"use strict";

module.exports = /******/function (modules) {
  // webpackBootstrap
  /******/ // install a JSONP callback for chunk loading
  /******/
  function webpackJsonpCallback(data) {
    /******/var chunkIds = data[0];
    /******/
    var moreModules = data[1];
    /******/
    /******/
    /******/ // add "moreModules" to the modules object,
    /******/ // then flag all "chunkIds" as loaded and fire callback
    /******/
    var moduleId,
      chunkId,
      i = 0,
      resolves = [];
    /******/
    for (; i < chunkIds.length; i++) {
      /******/chunkId = chunkIds[i];
      /******/
      if (Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
        /******/resolves.push(installedChunks[chunkId][0]);
        /******/
      }
      /******/
      installedChunks[chunkId] = 0;
      /******/
    }
    /******/
    for (moduleId in moreModules) {
      /******/if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
        /******/modules[moduleId] = moreModules[moduleId];
        /******/
      }
      /******/
    }
    /******/
    if (parentJsonpFunction) parentJsonpFunction(data);
    /******/
    /******/
    while (resolves.length) {
      /******/resolves.shift()();
      /******/
    }
    /******/
    /******/
  }
  ;
  /******/
  /******/
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // object to store loaded and loading chunks
  /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
  /******/ // Promise = chunk loading, 0 = chunk loaded
  /******/
  var installedChunks = {
    /******/1: 0
    /******/
  };
  /******/
  /******/
  /******/
  /******/ // script path function
  /******/
  function jsonpScriptSrc(chunkId) {
    /******/return __webpack_require__.p + "cargo-vue.common." + ({}[chunkId] || chunkId) + ".js";
    /******/
  }
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/ // This file contains only the entry chunk.
  /******/ // The chunk loading function for additional chunks
  /******/
  __webpack_require__.e = function requireEnsure(chunkId) {
    /******/var promises = [];
    /******/
    /******/
    /******/ // JSONP chunk loading for javascript
    /******/
    /******/
    var installedChunkData = installedChunks[chunkId];
    /******/
    if (installedChunkData !== 0) {
      // 0 means "already installed".
      /******/
      /******/ // a Promise means "currently loading".
      /******/
      if (installedChunkData) {
        /******/promises.push(installedChunkData[2]);
        /******/
      } else {
        /******/ // setup Promise in chunk cache
        /******/var promise = new Promise(function (resolve, reject) {
          /******/installedChunkData = installedChunks[chunkId] = [resolve, reject];
          /******/
        });
        /******/
        promises.push(installedChunkData[2] = promise);
        /******/
        /******/ // start chunk loading
        /******/
        var script = document.createElement('script');
        /******/
        var onScriptComplete;
        /******/
        /******/
        script.charset = 'utf-8';
        /******/
        script.timeout = 120;
        /******/
        if (__webpack_require__.nc) {
          /******/script.setAttribute("nonce", __webpack_require__.nc);
          /******/
        }
        /******/
        script.src = jsonpScriptSrc(chunkId);
        /******/
        /******/ // create error before stack unwound to get useful stacktrace later
        /******/
        var error = new Error();
        /******/
        onScriptComplete = function (event) {
          /******/ // avoid mem leaks in IE.
          /******/script.onerror = script.onload = null;
          /******/
          clearTimeout(timeout);
          /******/
          var chunk = installedChunks[chunkId];
          /******/
          if (chunk !== 0) {
            /******/if (chunk) {
              /******/var errorType = event && (event.type === 'load' ? 'missing' : event.type);
              /******/
              var realSrc = event && event.target && event.target.src;
              /******/
              error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
              /******/
              error.name = 'ChunkLoadError';
              /******/
              error.type = errorType;
              /******/
              error.request = realSrc;
              /******/
              chunk[1](error);
              /******/
            }
            /******/
            installedChunks[chunkId] = undefined;
            /******/
          }
          /******/
        };
        /******/
        var timeout = setTimeout(function () {
          /******/onScriptComplete({
            type: 'timeout',
            target: script
          });
          /******/
        }, 120000);
        /******/
        script.onerror = script.onload = onScriptComplete;
        /******/
        document.head.appendChild(script);
        /******/
      }
      /******/
    }
    /******/
    return Promise.all(promises);
    /******/
  };
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/
  __webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/
  __webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/
    if (mode & 8) return value;
    /******/
    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/
    var ns = Object.create(null);
    /******/
    __webpack_require__.r(ns);
    /******/
    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/
    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/
    return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ? /******/function getDefault() {
      return module['default'];
    } : /******/function getModuleExports() {
      return module;
    };
    /******/
    __webpack_require__.d(getter, 'a', getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/ // on error function for async loading
  /******/
  __webpack_require__.oe = function (err) {
    console.error(err);
    throw err;
  };
  /******/
  /******/
  var jsonpArray = (typeof self !== 'undefined' ? self : this)["webpackJsonpcargo_vue"] = (typeof self !== 'undefined' ? self : this)["webpackJsonpcargo_vue"] || [];
  /******/
  var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
  /******/
  jsonpArray.push = webpackJsonpCallback;
  /******/
  jsonpArray = jsonpArray.slice();
  /******/
  for (var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
  /******/
  var parentJsonpFunction = oldJsonpFunction;
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(__webpack_require__.s = "fb15");
  /******/
}
/************************************************************************/
/******/({
  /***/"00fd": /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("9e69");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;

    /***/
  },

  /***/"01f1": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsModal_vue_vue_type_style_index_0_id_6ae33730_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2e36");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsModal_vue_vue_type_style_index_0_id_6ae33730_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsModal_vue_vue_type_style_index_0_id_6ae33730_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"03dd": /***/function (module, exports, __webpack_require__) {
    var isPrototype = __webpack_require__("eac5"),
      nativeKeys = __webpack_require__("57a5");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeys;

    /***/
  },

  /***/"053d": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"07c7": /***/function (module, exports) {
    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }
    module.exports = stubFalse;

    /***/
  },

  /***/"087d": /***/function (module, exports) {
    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    module.exports = arrayPush;

    /***/
  },

  /***/"0b07": /***/function (module, exports, __webpack_require__) {
    var baseIsNative = __webpack_require__("34ac"),
      getValue = __webpack_require__("3698");

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }
    module.exports = getNative;

    /***/
  },

  /***/"0d24": /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module) {
      var root = __webpack_require__("2b3e"),
        stubFalse = __webpack_require__("07c7");

      /** Detect free variable `exports`. */
      var freeExports = true && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Built-in value references. */
      var Buffer = moduleExports ? root.Buffer : undefined;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

      /**
       * Checks if `value` is a buffer.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
       * @example
       *
       * _.isBuffer(new Buffer(2));
       * // => true
       *
       * _.isBuffer(new Uint8Array(2));
       * // => false
       */
      var isBuffer = nativeIsBuffer || stubFalse;
      module.exports = isBuffer;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("62e4")(module));

    /***/
  },

  /***/"100e": /***/function (module, exports, __webpack_require__) {
    var identity = __webpack_require__("cd9d"),
      overRest = __webpack_require__("2286"),
      setToString = __webpack_require__("c1c9");

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }
    module.exports = baseRest;

    /***/
  },

  /***/"1290": /***/function (module, exports) {
    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    module.exports = isKeyable;

    /***/
  },

  /***/"1310": /***/function (module, exports) {
    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }
    module.exports = isObjectLike;

    /***/
  },

  /***/"1368": /***/function (module, exports, __webpack_require__) {
    var coreJsData = __webpack_require__("da03");

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;

    /***/
  },

  /***/"155a": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsTooltip_vue_vue_type_style_index_0_id_2dcb0d4c_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b176");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsTooltip_vue_vue_type_style_index_0_id_2dcb0d4c_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsTooltip_vue_vue_type_style_index_0_id_2dcb0d4c_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"179f": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsPromotionSnippet_vue_vue_type_style_index_0_id_975b9b18_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7540");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsPromotionSnippet_vue_vue_type_style_index_0_id_975b9b18_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsPromotionSnippet_vue_vue_type_style_index_0_id_975b9b18_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"1a8c": /***/function (module, exports) {
    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }
    module.exports = isObject;

    /***/
  },

  /***/"1c3c": /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("9e69"),
      Uint8Array = __webpack_require__("2474"),
      eq = __webpack_require__("9638"),
      equalArrays = __webpack_require__("a2be"),
      mapToArray = __webpack_require__("edfa"),
      setToArray = __webpack_require__("ac41");

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /** `Object#toString` result references. */
    var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == other + '';
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    module.exports = equalByTag;

    /***/
  },

  /***/"1cec": /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__("0b07"),
      root = __webpack_require__("2b3e");

    /* Built-in method references that are verified to be native. */
    var Promise = getNative(root, 'Promise');
    module.exports = Promise;

    /***/
  },

  /***/"1efc": /***/function (module, exports) {
    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = hashDelete;

    /***/
  },

  /***/"1fc8": /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("4245");

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
        size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module.exports = mapCacheSet;

    /***/
  },

  /***/"2286": /***/function (module, exports, __webpack_require__) {
    var apply = __webpack_require__("85e3");

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeMax = Math.max;

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    module.exports = overRest;

    /***/
  },

  /***/"2474": /***/function (module, exports, __webpack_require__) {
    var root = __webpack_require__("2b3e");

    /** Built-in value references. */
    var Uint8Array = root.Uint8Array;
    module.exports = Uint8Array;

    /***/
  },

  /***/"2478": /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("4245");

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module.exports = mapCacheGet;

    /***/
  },

  /***/"2524": /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("6044");

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    }
    module.exports = hashSet;

    /***/
  },

  /***/"252c": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (global) {
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
        return __vue_component__;
      });
      /* unused harmony export install */
      function getInternetExplorerVersion() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
          // Edge (IE 12+) => return version number
          return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        } // other browser

        return -1;
      }

      //
      var isIE;
      function initCompat() {
        if (!initCompat.init) {
          initCompat.init = true;
          isIE = getInternetExplorerVersion() !== -1;
        }
      }
      var script = {
        name: 'ResizeObserver',
        props: {
          emitOnMount: {
            type: Boolean,
            default: false
          },
          ignoreWidth: {
            type: Boolean,
            default: false
          },
          ignoreHeight: {
            type: Boolean,
            default: false
          }
        },
        mounted: function mounted() {
          var _this = this;
          initCompat();
          this.$nextTick(function () {
            _this._w = _this.$el.offsetWidth;
            _this._h = _this.$el.offsetHeight;
            if (_this.emitOnMount) {
              _this.emitSize();
            }
          });
          var object = document.createElement('object');
          this._resizeObject = object;
          object.setAttribute('aria-hidden', 'true');
          object.setAttribute('tabindex', -1);
          object.onload = this.addResizeHandlers;
          object.type = 'text/html';
          if (isIE) {
            this.$el.appendChild(object);
          }
          object.data = 'about:blank';
          if (!isIE) {
            this.$el.appendChild(object);
          }
        },
        beforeDestroy: function beforeDestroy() {
          this.removeResizeHandlers();
        },
        methods: {
          compareAndNotify: function compareAndNotify() {
            if (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) {
              this._w = this.$el.offsetWidth;
              this._h = this.$el.offsetHeight;
              this.emitSize();
            }
          },
          emitSize: function emitSize() {
            this.$emit('notify', {
              width: this._w,
              height: this._h
            });
          },
          addResizeHandlers: function addResizeHandlers() {
            this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);
            this.compareAndNotify();
          },
          removeResizeHandlers: function removeResizeHandlers() {
            if (this._resizeObject && this._resizeObject.onload) {
              if (!isIE && this._resizeObject.contentDocument) {
                this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
              }
              this.$el.removeChild(this._resizeObject);
              this._resizeObject.onload = null;
              this._resizeObject = null;
            }
          }
        }
      };
      function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
      /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
        if (typeof shadowMode !== 'boolean') {
          createInjectorSSR = createInjector;
          createInjector = shadowMode;
          shadowMode = false;
        } // Vue.extend constructor export interop.

        var options = typeof script === 'function' ? script.options : script; // render functions

        if (template && template.render) {
          options.render = template.render;
          options.staticRenderFns = template.staticRenderFns;
          options._compiled = true; // functional template

          if (isFunctionalTemplate) {
            options.functional = true;
          }
        } // scopedId

        if (scopeId) {
          options._scopeId = scopeId;
        }
        var hook;
        if (moduleIdentifier) {
          // server build
          hook = function hook(context) {
            // 2.3 injection
            context = context ||
            // cached call
            this.$vnode && this.$vnode.ssrContext ||
            // stateful
            this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
            // 2.2 with runInNewContext: true

            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
              context = __VUE_SSR_CONTEXT__;
            } // inject component styles

            if (style) {
              style.call(this, createInjectorSSR(context));
            } // register component module identifier for async chunk inference

            if (context && context._registeredComponents) {
              context._registeredComponents.add(moduleIdentifier);
            }
          }; // used by ssr in case component is cached and beforeCreate
          // never gets called

          options._ssrRegister = hook;
        } else if (style) {
          hook = shadowMode ? function (context) {
            style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
          } : function (context) {
            style.call(this, createInjector(context));
          };
        }
        if (hook) {
          if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
              hook.call(context);
              return originalRender(h, context);
            };
          } else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }
        return script;
      }

      /* script */
      var __vue_script__ = script;
      /* template */

      var __vue_render__ = function __vue_render__() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("div", {
          staticClass: "resize-observer",
          attrs: {
            tabindex: "-1"
          }
        });
      };
      var __vue_staticRenderFns__ = [];
      __vue_render__._withStripped = true;
      /* style */

      var __vue_inject_styles__ = undefined;
      /* scoped */

      var __vue_scope_id__ = "data-v-8859cc6c";
      /* module identifier */

      var __vue_module_identifier__ = undefined;
      /* functional template */

      var __vue_is_functional_template__ = false;
      /* style inject */

      /* style inject SSR */

      /* style inject shadow dom */

      var __vue_component__ = /*#__PURE__*/normalizeComponent({
        render: __vue_render__,
        staticRenderFns: __vue_staticRenderFns__
      }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
      function install(Vue) {
        // eslint-disable-next-line vue/component-definition-name-casing
        Vue.component('resize-observer', __vue_component__);
        Vue.component('ResizeObserver', __vue_component__);
      }
      var plugin = {
        // eslint-disable-next-line no-undef
        version: "1.0.1",
        install: install
      };
      var GlobalVue = null;
      if (typeof window !== 'undefined') {
        GlobalVue = window.Vue;
      } else if (typeof global !== 'undefined') {
        GlobalVue = global.Vue;
      }
      if (GlobalVue) {
        GlobalVue.use(plugin);
      }

      /* unused harmony default export */
      var _unused_webpack_default_export = plugin;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("c8ba"));

    /***/
  },

  /***/"253c": /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("3729"),
      isObjectLike = __webpack_require__("1310");

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]';

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;

    /***/
  },

  /***/"28c9": /***/function (module, exports) {
    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module.exports = listCacheClear;

    /***/
  },

  /***/"29f3": /***/function (module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;

    /***/
  },

  /***/"2b3e": /***/function (module, exports, __webpack_require__) {
    var freeGlobal = __webpack_require__("585a");

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();
    module.exports = root;

    /***/
  },

  /***/"2d7c": /***/function (module, exports) {
    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    module.exports = arrayFilter;

    /***/
  },

  /***/"2dcb": /***/function (module, exports, __webpack_require__) {
    var overArg = __webpack_require__("91e9");

    /** Built-in value references. */
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    module.exports = getPrototype;

    /***/
  },

  /***/"2e36": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"2ec1": /***/function (module, exports, __webpack_require__) {
    var baseRest = __webpack_require__("100e"),
      isIterateeCall = __webpack_require__("9aff");

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function (object, sources) {
        var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }
    module.exports = createAssigner;

    /***/
  },

  /***/"2fcc": /***/function (module, exports) {
    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
        result = data['delete'](key);
      this.size = data.size;
      return result;
    }
    module.exports = stackDelete;

    /***/
  },

  /***/"2feb": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    // ESM COMPAT FLAG
    __webpack_require__.r(__webpack_exports__);

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, "tns", function () {
      return (/* binding */tns
      );
    });

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/raf.js
    var raf_win = window;
    var raf = raf_win.requestAnimationFrame || raf_win.webkitRequestAnimationFrame || raf_win.mozRequestAnimationFrame || raf_win.msRequestAnimationFrame || function (cb) {
      return setTimeout(cb, 16);
    };

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/caf.js
    var caf_win = window;
    var caf = caf_win.cancelAnimationFrame || caf_win.mozCancelAnimationFrame || function (id) {
      clearTimeout(id);
    };

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/extend.js
    function extend() {
      var obj,
        name,
        copy,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length;
      for (; i < length; i++) {
        if ((obj = arguments[i]) !== null) {
          for (name in obj) {
            copy = obj[name];
            if (target === copy) {
              continue;
            } else if (copy !== undefined) {
              target[name] = copy;
            }
          }
        }
      }
      return target;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/checkStorageValue.js
    function checkStorageValue(value) {
      return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/setLocalStorage.js
    function setLocalStorage(storage, key, value, access) {
      if (access) {
        try {
          storage.setItem(key, value);
        } catch (e) {}
      }
      return value;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/getSlideId.js
    function getSlideId() {
      var id = window.tnsId;
      window.tnsId = !id ? 1 : id + 1;
      return 'tns' + window.tnsId;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/getBody.js
    function getBody() {
      var doc = document,
        body = doc.body;
      if (!body) {
        body = doc.createElement('body');
        body.fake = true;
      }
      return body;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/docElement.js
    var docElement = document.documentElement;
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/setFakeBody.js

    function setFakeBody(body) {
      var docOverflow = '';
      if (body.fake) {
        docOverflow = docElement.style.overflow;
        //avoid crashing IE8, if background image is used
        body.style.background = '';
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = docElement.style.overflow = 'hidden';
        docElement.appendChild(body);
      }
      return docOverflow;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/resetFakeBody.js

    function resetFakeBody(body, docOverflow) {
      if (body.fake) {
        body.remove();
        docElement.style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        docElement.offsetHeight;
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/calc.js
    // get css-calc 
    // @return - false | calc | -webkit-calc | -moz-calc
    // @usage - var calc = getCalc(); 

    function calc() {
      var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        div = doc.createElement('div'),
        result = false;
      body.appendChild(div);
      try {
        var str = '(10px * 10)',
          vals = ['calc' + str, '-moz-calc' + str, '-webkit-calc' + str],
          val;
        for (var i = 0; i < 3; i++) {
          val = vals[i];
          div.style.width = val;
          if (div.offsetWidth === 100) {
            result = val.replace(str, '');
            break;
          }
        }
      } catch (e) {}
      body.fake ? resetFakeBody(body, docOverflow) : div.remove();
      return result;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/percentageLayout.js
    // get subpixel support value
    // @return - boolean

    function percentageLayout() {
      // check subpixel layout supporting
      var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        wrapper = doc.createElement('div'),
        outer = doc.createElement('div'),
        str = '',
        count = 70,
        perPage = 3,
        supported = false;
      wrapper.className = "tns-t-subp2";
      outer.className = "tns-t-ct";
      for (var i = 0; i < count; i++) {
        str += '<div></div>';
      }
      outer.innerHTML = str;
      wrapper.appendChild(outer);
      body.appendChild(wrapper);
      supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
      body.fake ? resetFakeBody(body, docOverflow) : wrapper.remove();
      return supported;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/mediaquerySupport.js

    function mediaquerySupport() {
      if (window.matchMedia || window.msMatchMedia) {
        return true;
      }
      var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        div = doc.createElement('div'),
        style = doc.createElement('style'),
        rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}',
        position;
      style.type = 'text/css';
      div.className = 'tns-mq-test';
      body.appendChild(style);
      body.appendChild(div);
      if (style.styleSheet) {
        style.styleSheet.cssText = rule;
      } else {
        style.appendChild(doc.createTextNode(rule));
      }
      position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];
      body.fake ? resetFakeBody(body, docOverflow) : div.remove();
      return position === "absolute";
    }

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/createStyleSheet.js
    // create and append style sheet
    function createStyleSheet(media, nonce) {
      // Create the <style> tag
      var style = document.createElement("style");
      // style.setAttribute("type", "text/css");

      // Add a media (and/or media query) here if you'd like!
      // style.setAttribute("media", "screen")
      // style.setAttribute("media", "only screen and (max-width : 1024px)")
      if (media) {
        style.setAttribute("media", media);
      }

      // Add nonce attribute for Content Security Policy
      if (nonce) {
        style.setAttribute("nonce", nonce);
      }

      // WebKit hack :(
      // style.appendChild(document.createTextNode(""));

      // Add the <style> element to the page
      document.querySelector('head').appendChild(style);
      return style.sheet ? style.sheet : style.styleSheet;
    }
    ;
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/addCSSRule.js
    // cross browsers addRule method

    function addCSSRule(sheet, selector, rules, index) {
      // return raf(function() {
      'insertRule' in sheet ? sheet.insertRule(selector + '{' + rules + '}', index) : sheet.addRule(selector, rules, index);
      // });
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/removeCSSRule.js
    // cross browsers addRule method

    function removeCSSRule(sheet, index) {
      // return raf(function() {
      'deleteRule' in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
      // });
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/getCssRulesLength.js
    function getCssRulesLength(sheet) {
      var rule = 'insertRule' in sheet ? sheet.cssRules : sheet.rules;
      return rule.length;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/toDegree.js
    function toDegree(y, x) {
      return Math.atan2(y, x) * (180 / Math.PI);
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/getTouchDirection.js
    function getTouchDirection(angle, range) {
      var direction = false,
        gap = Math.abs(90 - Math.abs(angle));
      if (gap >= 90 - range) {
        direction = 'horizontal';
      } else if (gap <= range) {
        direction = 'vertical';
      }
      return direction;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/forEach.js
    // https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
    function forEach(arr, callback, scope) {
      for (var i = 0, l = arr.length; i < l; i++) {
        callback.call(scope, arr[i], i);
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/classListSupport.js
    var classListSupport = ('classList' in document.createElement('_'));
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/hasClass.js

    var hasClass = classListSupport ? function (el, str) {
      return el.classList.contains(str);
    } : function (el, str) {
      return el.className.indexOf(str) >= 0;
    };

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/addClass.js

    var addClass = classListSupport ? function (el, str) {
      if (!hasClass(el, str)) {
        el.classList.add(str);
      }
    } : function (el, str) {
      if (!hasClass(el, str)) {
        el.className += ' ' + str;
      }
    };

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/removeClass.js

    var removeClass = classListSupport ? function (el, str) {
      if (hasClass(el, str)) {
        el.classList.remove(str);
      }
    } : function (el, str) {
      if (hasClass(el, str)) {
        el.className = el.className.replace(str, '');
      }
    };

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/hasAttr.js
    function hasAttr(el, attr) {
      return el.hasAttribute(attr);
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/getAttr.js
    function getAttr(el, attr) {
      return el.getAttribute(attr);
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/isNodeList.js
    function isNodeList(el) {
      // Only NodeList has the "item()" function
      return typeof el.item !== "undefined";
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/setAttrs.js

    function setAttrs(els, attrs) {
      els = isNodeList(els) || els instanceof Array ? els : [els];
      if (Object.prototype.toString.call(attrs) !== '[object Object]') {
        return;
      }
      for (var i = els.length; i--;) {
        for (var key in attrs) {
          els[i].setAttribute(key, attrs[key]);
        }
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/removeAttrs.js

    function removeAttrs(els, attrs) {
      els = isNodeList(els) || els instanceof Array ? els : [els];
      attrs = attrs instanceof Array ? attrs : [attrs];
      var attrLength = attrs.length;
      for (var i = els.length; i--;) {
        for (var j = attrLength; j--;) {
          els[i].removeAttribute(attrs[j]);
        }
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/arrayFromNodeList.js
    function arrayFromNodeList(nl) {
      var arr = [];
      for (var i = 0, l = nl.length; i < l; i++) {
        arr.push(nl[i]);
      }
      return arr;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/hideElement.js
    function hideElement(el, forceHide) {
      if (el.style.display !== 'none') {
        el.style.display = 'none';
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/showElement.js
    function showElement(el, forceHide) {
      if (el.style.display === 'none') {
        el.style.display = '';
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/isVisible.js
    function isVisible(el) {
      return window.getComputedStyle(el).display !== 'none';
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/whichProperty.js
    function whichProperty(props) {
      if (typeof props === 'string') {
        var arr = [props],
          Props = props.charAt(0).toUpperCase() + props.substr(1),
          prefixes = ['Webkit', 'Moz', 'ms', 'O'];
        prefixes.forEach(function (prefix) {
          if (prefix !== 'ms' || props === 'transform') {
            arr.push(prefix + Props);
          }
        });
        props = arr;
      }
      var el = document.createElement('fakeelement'),
        len = props.length;
      for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        if (el.style[prop] !== undefined) {
          return prop;
        }
      }
      return false; // explicit for ie9-
    }

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/has3DTransforms.js

    function has3DTransforms(tf) {
      if (!tf) {
        return false;
      }
      if (!window.getComputedStyle) {
        return false;
      }
      var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        el = doc.createElement('p'),
        has3d,
        cssTF = tf.length > 9 ? '-' + tf.slice(0, -9).toLowerCase() + '-' : '';
      cssTF += 'transform';

      // Add it to the body to get the computed style
      body.insertBefore(el, null);
      el.style[tf] = 'translate3d(1px,1px,1px)';
      has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
      body.fake ? resetFakeBody(body, docOverflow) : el.remove();
      return has3d !== undefined && has3d.length > 0 && has3d !== "none";
    }

    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/getEndProperty.js
    // get transitionend, animationend based on transitionDuration
    // @propin: string
    // @propOut: string, first-letter uppercase
    // Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
    function getEndProperty(propIn, propOut) {
      var endProp = false;
      if (/^Webkit/.test(propIn)) {
        endProp = 'webkit' + propOut + 'End';
      } else if (/^O/.test(propIn)) {
        endProp = 'o' + propOut + 'End';
      } else if (propIn) {
        endProp = propOut.toLowerCase() + 'end';
      }
      return endProp;
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/passiveOption.js
    // Test via a getter in the options object to see if the passive property is accessed
    var supportsPassive = false;
    try {
      var passiveOption_opts = Object.defineProperty({}, 'passive', {
        get: function () {
          supportsPassive = true;
        }
      });
      window.addEventListener("test", null, passiveOption_opts);
    } catch (e) {}
    var passiveOption = supportsPassive ? {
      passive: true
    } : false;
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/addEvents.js

    function addEvents(el, obj, preventScrolling) {
      for (var prop in obj) {
        var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 && !preventScrolling ? passiveOption : false;
        el.addEventListener(prop, obj[prop], option);
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/removeEvents.js

    function removeEvents(el, obj) {
      for (var prop in obj) {
        var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 ? passiveOption : false;
        el.removeEventListener(prop, obj[prop], option);
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/events.js
    function Events() {
      return {
        topics: {},
        on: function (eventName, fn) {
          this.topics[eventName] = this.topics[eventName] || [];
          this.topics[eventName].push(fn);
        },
        off: function (eventName, fn) {
          if (this.topics[eventName]) {
            for (var i = 0; i < this.topics[eventName].length; i++) {
              if (this.topics[eventName][i] === fn) {
                this.topics[eventName].splice(i, 1);
                break;
              }
            }
          }
        },
        emit: function (eventName, data) {
          data.type = eventName;
          if (this.topics[eventName]) {
            this.topics[eventName].forEach(function (fn) {
              fn(data, eventName);
            });
          }
        }
      };
    }
    ;
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/helpers/jsTransform.js
    function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
      var tick = Math.min(duration, 10),
        unit = to.indexOf('%') >= 0 ? '%' : 'px',
        to = to.replace(unit, ''),
        from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')),
        positionTick = (to - from) / duration * tick,
        running;
      setTimeout(moveElement, tick);
      function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) {
          setTimeout(moveElement, tick);
        } else {
          callback();
        }
      }
    }
    // CONCATENATED MODULE: ./node_modules/tiny-slider/src/tiny-slider.js
    // Object.keys
    if (!Object.keys) {
      Object.keys = function (object) {
        var keys = [];
        for (var name in object) {
          if (Object.prototype.hasOwnProperty.call(object, name)) {
            keys.push(name);
          }
        }
        return keys;
      };
    }

    // ChildNode.remove
    if (!("remove" in Element.prototype)) {
      Element.prototype.remove = function () {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      };
    }
    var tns = function (options) {
      options = extend({
        container: '.slider',
        mode: 'carousel',
        axis: 'horizontal',
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        autoWidth: false,
        viewportMax: false,
        slideBy: 1,
        center: false,
        controls: true,
        controlsPosition: 'top',
        controlsText: ['prev', 'next'],
        controlsContainer: false,
        prevButton: false,
        nextButton: false,
        nav: true,
        navPosition: 'top',
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayPosition: 'top',
        autoplayTimeout: 5000,
        autoplayDirection: 'forward',
        autoplayText: ['start', 'stop'],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        animateIn: 'tns-fadeIn',
        animateOut: 'tns-fadeOut',
        animateNormal: 'tns-normal',
        animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        lazyloadSelector: '.tns-lazy-img',
        touch: true,
        mouseDrag: false,
        swipeAngle: 15,
        nested: false,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        freezable: true,
        onInit: false,
        useLocalStorage: true,
        nonce: false
      }, options || {});
      var doc = document,
        win = window,
        KEYS = {
          ENTER: 13,
          SPACE: 32,
          LEFT: 37,
          RIGHT: 39
        },
        tnsStorage = {},
        localStorageAccess = options.useLocalStorage;
      if (localStorageAccess) {
        // check browser version and local storage access
        var browserInfo = navigator.userAgent;
        var uid = new Date();
        try {
          tnsStorage = win.localStorage;
          if (tnsStorage) {
            tnsStorage.setItem(uid, uid);
            localStorageAccess = tnsStorage.getItem(uid) == uid;
            tnsStorage.removeItem(uid);
          } else {
            localStorageAccess = false;
          }
          if (!localStorageAccess) {
            tnsStorage = {};
          }
        } catch (e) {
          localStorageAccess = false;
        }
        if (localStorageAccess) {
          // remove storage when browser version changes
          if (tnsStorage['tnsApp'] && tnsStorage['tnsApp'] !== browserInfo) {
            ['tC', 'tPL', 'tMQ', 'tTf', 't3D', 'tTDu', 'tTDe', 'tADu', 'tADe', 'tTE', 'tAE'].forEach(function (item) {
              tnsStorage.removeItem(item);
            });
          }
          // update browserInfo
          localStorage['tnsApp'] = browserInfo;
        }
      }
      var CALC = tnsStorage['tC'] ? checkStorageValue(tnsStorage['tC']) : setLocalStorage(tnsStorage, 'tC', calc(), localStorageAccess),
        PERCENTAGELAYOUT = tnsStorage['tPL'] ? checkStorageValue(tnsStorage['tPL']) : setLocalStorage(tnsStorage, 'tPL', percentageLayout(), localStorageAccess),
        CSSMQ = tnsStorage['tMQ'] ? checkStorageValue(tnsStorage['tMQ']) : setLocalStorage(tnsStorage, 'tMQ', mediaquerySupport(), localStorageAccess),
        TRANSFORM = tnsStorage['tTf'] ? checkStorageValue(tnsStorage['tTf']) : setLocalStorage(tnsStorage, 'tTf', whichProperty('transform'), localStorageAccess),
        HAS3DTRANSFORMS = tnsStorage['t3D'] ? checkStorageValue(tnsStorage['t3D']) : setLocalStorage(tnsStorage, 't3D', has3DTransforms(TRANSFORM), localStorageAccess),
        TRANSITIONDURATION = tnsStorage['tTDu'] ? checkStorageValue(tnsStorage['tTDu']) : setLocalStorage(tnsStorage, 'tTDu', whichProperty('transitionDuration'), localStorageAccess),
        TRANSITIONDELAY = tnsStorage['tTDe'] ? checkStorageValue(tnsStorage['tTDe']) : setLocalStorage(tnsStorage, 'tTDe', whichProperty('transitionDelay'), localStorageAccess),
        ANIMATIONDURATION = tnsStorage['tADu'] ? checkStorageValue(tnsStorage['tADu']) : setLocalStorage(tnsStorage, 'tADu', whichProperty('animationDuration'), localStorageAccess),
        ANIMATIONDELAY = tnsStorage['tADe'] ? checkStorageValue(tnsStorage['tADe']) : setLocalStorage(tnsStorage, 'tADe', whichProperty('animationDelay'), localStorageAccess),
        TRANSITIONEND = tnsStorage['tTE'] ? checkStorageValue(tnsStorage['tTE']) : setLocalStorage(tnsStorage, 'tTE', getEndProperty(TRANSITIONDURATION, 'Transition'), localStorageAccess),
        ANIMATIONEND = tnsStorage['tAE'] ? checkStorageValue(tnsStorage['tAE']) : setLocalStorage(tnsStorage, 'tAE', getEndProperty(ANIMATIONDURATION, 'Animation'), localStorageAccess);

      // get element nodes from selectors
      var supportConsoleWarn = win.console && typeof win.console.warn === "function",
        tnsList = ['container', 'controlsContainer', 'prevButton', 'nextButton', 'navContainer', 'autoplayButton'],
        optionsElements = {};
      tnsList.forEach(function (item) {
        if (typeof options[item] === 'string') {
          var str = options[item],
            el = doc.querySelector(str);
          optionsElements[item] = str;
          if (el && el.nodeName) {
            options[item] = el;
          } else {
            if (supportConsoleWarn) {
              console.warn('Can\'t find', options[item]);
            }
            return;
          }
        }
      });

      // make sure at least 1 slide
      if (options.container.children.length < 1) {
        if (supportConsoleWarn) {
          console.warn('No slides found in', options.container);
        }
        return;
      }

      // update options
      var responsive = options.responsive,
        nested = options.nested,
        carousel = options.mode === 'carousel' ? true : false;
      if (responsive) {
        // apply responsive[0] to options and remove it
        if (0 in responsive) {
          options = extend(options, responsive[0]);
          delete responsive[0];
        }
        var responsiveTem = {};
        for (var key in responsive) {
          var val = responsive[key];
          // update responsive
          // from: 300: 2
          // to:
          //   300: {
          //     items: 2
          //   }
          val = typeof val === 'number' ? {
            items: val
          } : val;
          responsiveTem[key] = val;
        }
        responsive = responsiveTem;
        responsiveTem = null;
      }

      // update options
      function updateOptions(obj) {
        for (var key in obj) {
          if (!carousel) {
            if (key === 'slideBy') {
              obj[key] = 'page';
            }
            if (key === 'edgePadding') {
              obj[key] = false;
            }
            if (key === 'autoHeight') {
              obj[key] = false;
            }
          }

          // update responsive options
          if (key === 'responsive') {
            updateOptions(obj[key]);
          }
        }
      }
      if (!carousel) {
        updateOptions(options);
      }

      // === define and set variables ===
      if (!carousel) {
        options.axis = 'horizontal';
        options.slideBy = 'page';
        options.edgePadding = false;
        var animateIn = options.animateIn,
          animateOut = options.animateOut,
          animateDelay = options.animateDelay,
          animateNormal = options.animateNormal;
      }
      var horizontal = options.axis === 'horizontal' ? true : false,
        outerWrapper = doc.createElement('div'),
        innerWrapper = doc.createElement('div'),
        middleWrapper,
        container = options.container,
        containerParent = container.parentNode,
        containerHTML = container.outerHTML,
        slideItems = container.children,
        slideCount = slideItems.length,
        breakpointZone,
        windowWidth = getWindowWidth(),
        isOn = false;
      if (responsive) {
        setBreakpointZone();
      }
      if (carousel) {
        container.className += ' tns-vpfix';
      }

      // fixedWidth: viewport > rightBoundary > indexMax
      var autoWidth = options.autoWidth,
        fixedWidth = getOption('fixedWidth'),
        edgePadding = getOption('edgePadding'),
        gutter = getOption('gutter'),
        viewport = getViewportWidth(),
        center = getOption('center'),
        items = !autoWidth ? Math.floor(getOption('items')) : 1,
        slideBy = getOption('slideBy'),
        viewportMax = options.viewportMax || options.fixedWidthViewportWidth,
        arrowKeys = getOption('arrowKeys'),
        speed = getOption('speed'),
        rewind = options.rewind,
        loop = rewind ? false : options.loop,
        autoHeight = getOption('autoHeight'),
        controls = getOption('controls'),
        controlsText = getOption('controlsText'),
        nav = getOption('nav'),
        touch = getOption('touch'),
        mouseDrag = getOption('mouseDrag'),
        autoplay = getOption('autoplay'),
        autoplayTimeout = getOption('autoplayTimeout'),
        autoplayText = getOption('autoplayText'),
        autoplayHoverPause = getOption('autoplayHoverPause'),
        autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'),
        sheet = createStyleSheet(null, getOption('nonce')),
        lazyload = options.lazyload,
        lazyloadSelector = options.lazyloadSelector,
        slidePositions,
        // collection of slide positions
        slideItemsOut = [],
        cloneCount = loop ? getCloneCountForLoop() : 0,
        slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2,
        hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false,
        rightBoundary = fixedWidth ? getRightBoundary() : null,
        updateIndexBeforeTransform = !carousel || !loop ? true : false,
        // transform
        transformAttr = horizontal ? 'left' : 'top',
        transformPrefix = '',
        transformPostfix = '',
        // index
        getIndexMax = function () {
          if (fixedWidth) {
            return function () {
              return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
            };
          } else if (autoWidth) {
            return function () {
              for (var i = 0; i < slideCountNew; i++) {
                if (slidePositions[i] >= -rightBoundary) {
                  return i;
                }
              }
            };
          } else {
            return function () {
              if (center && carousel && !loop) {
                return slideCount - 1;
              } else {
                return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
              }
            };
          }
        }(),
        index = getStartIndex(getOption('startIndex')),
        indexCached = index,
        displayIndex = getCurrentSlide(),
        indexMin = 0,
        indexMax = !autoWidth ? getIndexMax() : null,
        // resize
        resizeTimer,
        preventActionWhenRunning = options.preventActionWhenRunning,
        swipeAngle = options.swipeAngle,
        moveDirectionExpected = swipeAngle ? '?' : true,
        running = false,
        onInit = options.onInit,
        events = new Events(),
        // id, class
        newContainerClasses = ' tns-slider tns-' + options.mode,
        slideId = container.id || getSlideId(),
        disable = getOption('disable'),
        disabled = false,
        freezable = options.freezable,
        freeze = freezable && !autoWidth ? getFreeze() : false,
        frozen = false,
        controlsEvents = {
          'click': onControlsClick,
          'keydown': onControlsKeydown
        },
        navEvents = {
          'click': onNavClick,
          'keydown': onNavKeydown
        },
        hoverEvents = {
          'mouseover': mouseoverPause,
          'mouseout': mouseoutRestart
        },
        visibilityEvent = {
          'visibilitychange': onVisibilityChange
        },
        docmentKeydownEvent = {
          'keydown': onDocumentKeydown
        },
        touchEvents = {
          'touchstart': onPanStart,
          'touchmove': onPanMove,
          'touchend': onPanEnd,
          'touchcancel': onPanEnd
        },
        dragEvents = {
          'mousedown': onPanStart,
          'mousemove': onPanMove,
          'mouseup': onPanEnd,
          'mouseleave': onPanEnd
        },
        hasControls = hasOption('controls'),
        hasNav = hasOption('nav'),
        navAsThumbnails = autoWidth ? true : options.navAsThumbnails,
        hasAutoplay = hasOption('autoplay'),
        hasTouch = hasOption('touch'),
        hasMouseDrag = hasOption('mouseDrag'),
        slideActiveClass = 'tns-slide-active',
        slideClonedClass = 'tns-slide-cloned',
        imgCompleteClass = 'tns-complete',
        imgEvents = {
          'load': onImgLoaded,
          'error': onImgFailed
        },
        imgsComplete,
        liveregionCurrent,
        preventScroll = options.preventScrollOnTouch === 'force' ? true : false;

      // controls
      if (hasControls) {
        var controlsContainer = options.controlsContainer,
          controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : '',
          prevButton = options.prevButton,
          nextButton = options.nextButton,
          prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : '',
          nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : '',
          prevIsButton,
          nextIsButton;
      }

      // nav
      if (hasNav) {
        var navContainer = options.navContainer,
          navContainerHTML = options.navContainer ? options.navContainer.outerHTML : '',
          navItems,
          pages = autoWidth ? slideCount : getPages(),
          pagesCached = 0,
          navClicked = -1,
          navCurrentIndex = getCurrentNavIndex(),
          navCurrentIndexCached = navCurrentIndex,
          navActiveClass = 'tns-nav-active',
          navStr = 'Carousel Page ',
          navStrCurrent = ' (Current Slide)';
      }

      // autoplay
      if (hasAutoplay) {
        var autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1,
          autoplayButton = options.autoplayButton,
          autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : '',
          autoplayHtmlStrings = ['<span class=\'tns-visually-hidden\'>', ' animation</span>'],
          autoplayTimer,
          animating,
          autoplayHoverPaused,
          autoplayUserPaused,
          autoplayVisibilityPaused;
      }
      if (hasTouch || hasMouseDrag) {
        var initPosition = {},
          lastPosition = {},
          translateInit,
          disX,
          disY,
          panStart = false,
          rafIndex,
          getDist = horizontal ? function (a, b) {
            return a.x - b.x;
          } : function (a, b) {
            return a.y - b.y;
          };
      }

      // disable slider when slidecount <= items
      if (!autoWidth) {
        resetVariblesWhenDisable(disable || freeze);
      }
      if (TRANSFORM) {
        transformAttr = TRANSFORM;
        transformPrefix = 'translate';
        if (HAS3DTRANSFORMS) {
          transformPrefix += horizontal ? '3d(' : '3d(0px, ';
          transformPostfix = horizontal ? ', 0px, 0px)' : ', 0px)';
        } else {
          transformPrefix += horizontal ? 'X(' : 'Y(';
          transformPostfix = ')';
        }
      }
      if (carousel) {
        container.className = container.className.replace('tns-vpfix', '');
      }
      initStructure();
      initSheet();
      initSliderTransform();

      // === COMMON FUNCTIONS === //
      function resetVariblesWhenDisable(condition) {
        if (condition) {
          controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
        }
      }
      function getCurrentSlide() {
        var tem = carousel ? index - cloneCount : index;
        while (tem < 0) {
          tem += slideCount;
        }
        return tem % slideCount + 1;
      }
      function getStartIndex(ind) {
        ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
        return carousel ? ind + cloneCount : ind;
      }
      function getAbsIndex(i) {
        if (i == null) {
          i = index;
        }
        if (carousel) {
          i -= cloneCount;
        }
        while (i < 0) {
          i += slideCount;
        }
        return Math.floor(i % slideCount);
      }
      function getCurrentNavIndex() {
        var absIndex = getAbsIndex(),
          result;
        result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);

        // set active nav to the last one when reaches the right edge
        if (!loop && carousel && index === indexMax) {
          result = pages - 1;
        }
        return result;
      }
      function getItemsMax() {
        // fixedWidth or autoWidth while viewportMax is not available
        if (autoWidth || fixedWidth && !viewportMax) {
          return slideCount - 1;
          // most cases
        } else {
          var str = fixedWidth ? 'fixedWidth' : 'items',
            arr = [];
          if (fixedWidth || options[str] < slideCount) {
            arr.push(options[str]);
          }
          if (responsive) {
            for (var bp in responsive) {
              var tem = responsive[bp][str];
              if (tem && (fixedWidth || tem < slideCount)) {
                arr.push(tem);
              }
            }
          }
          if (!arr.length) {
            arr.push(0);
          }
          return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
        }
      }
      function getCloneCountForLoop() {
        var itemsMax = getItemsMax(),
          result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
        result = Math.max(itemsMax, result);
        return hasOption('edgePadding') ? result + 1 : result;
      }
      function getWindowWidth() {
        return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
      }
      function getInsertPosition(pos) {
        return pos === 'top' ? 'afterbegin' : 'beforeend';
      }
      function getClientWidth(el) {
        if (el == null) {
          return;
        }
        var div = doc.createElement('div'),
          rect,
          width;
        el.appendChild(div);
        rect = div.getBoundingClientRect();
        width = rect.right - rect.left;
        div.remove();
        return width || getClientWidth(el.parentNode);
      }
      function getViewportWidth() {
        var gap = edgePadding ? edgePadding * 2 - gutter : 0;
        return getClientWidth(containerParent) - gap;
      }
      function hasOption(item) {
        if (options[item]) {
          return true;
        } else {
          if (responsive) {
            for (var bp in responsive) {
              if (responsive[bp][item]) {
                return true;
              }
            }
          }
          return false;
        }
      }

      // get option:
      // fixed width: viewport, fixedWidth, gutter => items
      // others: window width => all variables
      // all: items => slideBy
      function getOption(item, ww) {
        if (ww == null) {
          ww = windowWidth;
        }
        if (item === 'items' && fixedWidth) {
          return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
        } else {
          var result = options[item];
          if (responsive) {
            for (var bp in responsive) {
              // bp: convert string to number
              if (ww >= parseInt(bp)) {
                if (item in responsive[bp]) {
                  result = responsive[bp][item];
                }
              }
            }
          }
          if (item === 'slideBy' && result === 'page') {
            result = getOption('items');
          }
          if (!carousel && (item === 'slideBy' || item === 'items')) {
            result = Math.floor(result);
          }
          return result;
        }
      }
      function getSlideMarginLeft(i) {
        return CALC ? CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' : i * 100 / slideCountNew + '%';
      }
      function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
        var str = '';
        if (edgePaddingTem !== undefined) {
          var gap = edgePaddingTem;
          if (gutterTem) {
            gap -= gutterTem;
          }
          str = horizontal ? 'margin: 0 ' + gap + 'px 0 ' + edgePaddingTem + 'px;' : 'margin: ' + edgePaddingTem + 'px 0 ' + gap + 'px 0;';
        } else if (gutterTem && !fixedWidthTem) {
          var gutterTemUnit = '-' + gutterTem + 'px',
            dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
          str = 'margin: 0 ' + dir + ';';
        }
        if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) {
          str += getTransitionDurationStyle(speedTem);
        }
        return str;
      }
      function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        if (fixedWidthTem) {
          return (fixedWidthTem + gutterTem) * slideCountNew + 'px';
        } else {
          return CALC ? CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' : slideCountNew * 100 / itemsTem + '%';
        }
      }
      function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var width;
        if (fixedWidthTem) {
          width = fixedWidthTem + gutterTem + 'px';
        } else {
          if (!carousel) {
            itemsTem = Math.floor(itemsTem);
          }
          var dividend = carousel ? slideCountNew : itemsTem;
          width = CALC ? CALC + '(100% / ' + dividend + ')' : 100 / dividend + '%';
        }
        width = 'width:' + width;

        // inner slider: overwrite outer slider styles
        return nested !== 'inner' ? width + ';' : width + ' !important;';
      }
      function getSlideGutterStyle(gutterTem) {
        var str = '';

        // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
          var prop = horizontal ? 'padding-' : 'margin-',
            dir = horizontal ? 'right' : 'bottom';
          str = prop + dir + ': ' + gutterTem + 'px;';
        }
        return str;
      }
      function getCSSPrefix(name, num) {
        var prefix = name.substring(0, name.length - num).toLowerCase();
        if (prefix) {
          prefix = '-' + prefix + '-';
        }
        return prefix;
      }
      function getTransitionDurationStyle(speed) {
        return getCSSPrefix(TRANSITIONDURATION, 18) + 'transition-duration:' + speed / 1000 + 's;';
      }
      function getAnimationDurationStyle(speed) {
        return getCSSPrefix(ANIMATIONDURATION, 17) + 'animation-duration:' + speed / 1000 + 's;';
      }
      function initStructure() {
        var classOuter = 'tns-outer',
          classInner = 'tns-inner',
          hasGutter = hasOption('gutter');
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        outerWrapper.id = slideId + '-ow';
        innerWrapper.id = slideId + '-iw';

        // set container properties
        if (container.id === '') {
          container.id = slideId;
        }
        newContainerClasses += PERCENTAGELAYOUT || autoWidth ? ' tns-subpixel' : ' tns-no-subpixel';
        newContainerClasses += CALC ? ' tns-calc' : ' tns-no-calc';
        if (autoWidth) {
          newContainerClasses += ' tns-autowidth';
        }
        newContainerClasses += ' tns-' + options.axis;
        container.className += newContainerClasses;

        // add constrain layer for carousel
        if (carousel) {
          middleWrapper = doc.createElement('div');
          middleWrapper.id = slideId + '-mw';
          middleWrapper.className = 'tns-ovh';
          outerWrapper.appendChild(middleWrapper);
          middleWrapper.appendChild(innerWrapper);
        } else {
          outerWrapper.appendChild(innerWrapper);
        }
        if (autoHeight) {
          var wp = middleWrapper ? middleWrapper : innerWrapper;
          wp.className += ' tns-ah';
        }
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container);

        // add id, class, aria attributes
        // before clone slides
        forEach(slideItems, function (item, i) {
          addClass(item, 'tns-item');
          if (!item.id) {
            item.id = slideId + '-item' + i;
          }
          if (!carousel && animateNormal) {
            addClass(item, animateNormal);
          }
          setAttrs(item, {
            'aria-hidden': 'true',
            'tabindex': '-1'
          });
        });

        // ## clone slides
        // carousel: n + slides + n
        // gallery:      slides + n
        if (cloneCount) {
          var fragmentBefore = doc.createDocumentFragment(),
            fragmentAfter = doc.createDocumentFragment();
          for (var j = cloneCount; j--;) {
            var num = j % slideCount,
              cloneFirst = slideItems[num].cloneNode(true);
            addClass(cloneFirst, slideClonedClass);
            removeAttrs(cloneFirst, 'id');
            fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
            if (carousel) {
              var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
              addClass(cloneLast, slideClonedClass);
              removeAttrs(cloneLast, 'id');
              fragmentBefore.appendChild(cloneLast);
            }
          }
          container.insertBefore(fragmentBefore, container.firstChild);
          container.appendChild(fragmentAfter);
          slideItems = container.children;
        }
      }
      function initSliderTransform() {
        // ## images loaded/failed
        if (hasOption('autoHeight') || autoWidth || !horizontal) {
          var imgs = container.querySelectorAll('img');

          // add img load event listener
          forEach(imgs, function (img) {
            var src = img.src;
            if (!lazyload) {
              // not data img
              if (src && src.indexOf('data:image') < 0) {
                img.src = '';
                addEvents(img, imgEvents);
                addClass(img, 'loading');
                img.src = src;
                // data img
              } else {
                imgLoaded(img);
              }
            }
          });

          // set imgsComplete
          raf(function () {
            imgsLoadedCheck(arrayFromNodeList(imgs), function () {
              imgsComplete = true;
            });
          });

          // reset imgs for auto height: check visible imgs only
          if (hasOption('autoHeight')) {
            imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
          }
          lazyload ? initSliderTransformStyleCheck() : raf(function () {
            imgsLoadedCheck(arrayFromNodeList(imgs), initSliderTransformStyleCheck);
          });
        } else {
          // set container transform property
          if (carousel) {
            doContainerTransformSilent();
          }

          // update slider tools and events
          initTools();
          initEvents();
        }
      }
      function initSliderTransformStyleCheck() {
        if (autoWidth && slideCount > 1) {
          // check styles application
          var num = loop ? index : slideCount - 1;
          (function stylesApplicationCheck() {
            var left = slideItems[num].getBoundingClientRect().left;
            var right = slideItems[num - 1].getBoundingClientRect().right;
            Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function () {
              stylesApplicationCheck();
            }, 16);
          })();
        } else {
          initSliderTransformCore();
        }
      }
      function initSliderTransformCore() {
        // run Fn()s which are rely on image loading
        if (!horizontal || autoWidth) {
          setSlidePositions();
          if (autoWidth) {
            rightBoundary = getRightBoundary();
            if (freezable) {
              freeze = getFreeze();
            }
            indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
            resetVariblesWhenDisable(disable || freeze);
          } else {
            updateContentWrapperHeight();
          }
        }

        // set container transform property
        if (carousel) {
          doContainerTransformSilent();
        }

        // update slider tools and events
        initTools();
        initEvents();
      }
      function initSheet() {
        // gallery:
        // set animation classes and left value for gallery slider
        if (!carousel) {
          for (var i = index, l = index + Math.min(slideCount, items); i < l; i++) {
            var item = slideItems[i];
            item.style.left = (i - index) * 100 / items + '%';
            addClass(item, animateIn);
            removeClass(item, animateNormal);
          }
        }

        // #### LAYOUT

        // ## INLINE-BLOCK VS FLOAT

        // ## PercentageLayout:
        // slides: inline-block
        // remove blank space between slides by set font-size: 0

        // ## Non PercentageLayout:
        // slides: float
        //         margin-right: -100%
        //         margin-left: ~

        // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
        if (horizontal) {
          if (PERCENTAGELAYOUT || autoWidth) {
            addCSSRule(sheet, '#' + slideId + ' > .tns-item', 'font-size:' + win.getComputedStyle(slideItems[0]).fontSize + ';', getCssRulesLength(sheet));
            addCSSRule(sheet, '#' + slideId, 'font-size:0;', getCssRulesLength(sheet));
          } else if (carousel) {
            forEach(slideItems, function (slide, i) {
              slide.style.marginLeft = getSlideMarginLeft(i);
            });
          }
        }

        // ## BASIC STYLES
        if (CSSMQ) {
          // middle wrapper style
          if (TRANSITIONDURATION) {
            var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : '';
            addCSSRule(sheet, '#' + slideId + '-mw', str, getCssRulesLength(sheet));
          }

          // inner wrapper styles
          str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
          addCSSRule(sheet, '#' + slideId + '-iw', str, getCssRulesLength(sheet));

          // container styles
          if (carousel) {
            str = horizontal && !autoWidth ? 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ';' : '';
            if (TRANSITIONDURATION) {
              str += getTransitionDurationStyle(speed);
            }
            addCSSRule(sheet, '#' + slideId, str, getCssRulesLength(sheet));
          }

          // slide styles
          str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : '';
          if (options.gutter) {
            str += getSlideGutterStyle(options.gutter);
          }
          // set gallery items transition-duration
          if (!carousel) {
            if (TRANSITIONDURATION) {
              str += getTransitionDurationStyle(speed);
            }
            if (ANIMATIONDURATION) {
              str += getAnimationDurationStyle(speed);
            }
          }
          if (str) {
            addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
          }

          // non CSS mediaqueries: IE8
          // ## update inner wrapper, container, slides if needed
          // set inline styles for inner wrapper & container
          // insert stylesheet (one line) for slides only (since slides are many)
        } else {
          // middle wrapper styles
          update_carousel_transition_duration();

          // inner wrapper styles
          innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);

          // container styles
          if (carousel && horizontal && !autoWidth) {
            container.style.width = getContainerWidth(fixedWidth, gutter, items);
          }

          // slide styles
          var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : '';
          if (gutter) {
            str += getSlideGutterStyle(gutter);
          }

          // append to the last line
          if (str) {
            addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
          }
        }

        // ## MEDIAQUERIES
        if (responsive && CSSMQ) {
          for (var bp in responsive) {
            // bp: convert string to number
            bp = parseInt(bp);
            var opts = responsive[bp],
              str = '',
              middleWrapperStr = '',
              innerWrapperStr = '',
              containerStr = '',
              slideStr = '',
              itemsBP = !autoWidth ? getOption('items', bp) : null,
              fixedWidthBP = getOption('fixedWidth', bp),
              speedBP = getOption('speed', bp),
              edgePaddingBP = getOption('edgePadding', bp),
              autoHeightBP = getOption('autoHeight', bp),
              gutterBP = getOption('gutter', bp);

            // middle wrapper string
            if (TRANSITIONDURATION && middleWrapper && getOption('autoHeight', bp) && 'speed' in opts) {
              middleWrapperStr = '#' + slideId + '-mw{' + getTransitionDurationStyle(speedBP) + '}';
            }

            // inner wrapper string
            if ('edgePadding' in opts || 'gutter' in opts) {
              innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + '}';
            }

            // container string
            if (carousel && horizontal && !autoWidth && ('fixedWidth' in opts || 'items' in opts || fixedWidth && 'gutter' in opts)) {
              containerStr = 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ';';
            }
            if (TRANSITIONDURATION && 'speed' in opts) {
              containerStr += getTransitionDurationStyle(speedBP);
            }
            if (containerStr) {
              containerStr = '#' + slideId + '{' + containerStr + '}';
            }

            // slide string
            if ('fixedWidth' in opts || fixedWidth && 'gutter' in opts || !carousel && 'items' in opts) {
              slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            }
            if ('gutter' in opts) {
              slideStr += getSlideGutterStyle(gutterBP);
            }
            // set gallery items transition-duration
            if (!carousel && 'speed' in opts) {
              if (TRANSITIONDURATION) {
                slideStr += getTransitionDurationStyle(speedBP);
              }
              if (ANIMATIONDURATION) {
                slideStr += getAnimationDurationStyle(speedBP);
              }
            }
            if (slideStr) {
              slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}';
            }

            // add up
            str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
            if (str) {
              sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
            }
          }
        }
      }
      function initTools() {
        // == slides ==
        updateSlideStatus();

        // == live region ==
        outerWrapper.insertAdjacentHTML('afterbegin', '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + '</span>  of ' + slideCount + '</div>');
        liveregionCurrent = outerWrapper.querySelector('.tns-liveregion .current');

        // == autoplayInit ==
        if (hasAutoplay) {
          var txt = autoplay ? 'stop' : 'start';
          if (autoplayButton) {
            setAttrs(autoplayButton, {
              'data-action': txt
            });
          } else if (options.autoplayButtonOutput) {
            outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
            autoplayButton = outerWrapper.querySelector('[data-action]');
          }

          // add event
          if (autoplayButton) {
            addEvents(autoplayButton, {
              'click': toggleAutoplay
            });
          }
          if (autoplay) {
            startAutoplay();
            if (autoplayHoverPause) {
              addEvents(container, hoverEvents);
            }
            if (autoplayResetOnVisibility) {
              addEvents(container, visibilityEvent);
            }
          }
        }

        // == navInit ==
        if (hasNav) {
          var initIndex = !carousel ? 0 : cloneCount;
          // customized nav
          // will not hide the navs in case they're thumbnails
          if (navContainer) {
            setAttrs(navContainer, {
              'aria-label': 'Carousel Pagination'
            });
            navItems = navContainer.children;
            forEach(navItems, function (item, i) {
              setAttrs(item, {
                'data-nav': i,
                'tabindex': '-1',
                'aria-label': navStr + (i + 1),
                'aria-controls': slideId
              });
            });

            // generated nav
          } else {
            var navHtml = '',
              hiddenStr = navAsThumbnails ? '' : 'style="display:none"';
            for (var i = 0; i < slideCount; i++) {
              // hide nav items by default
              navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
            }
            navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
            outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
            navContainer = outerWrapper.querySelector('.tns-nav');
            navItems = navContainer.children;
          }
          updateNavVisibility();

          // add transition
          if (TRANSITIONDURATION) {
            var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(),
              str = 'transition: all ' + speed / 1000 + 's';
            if (prefix) {
              str = '-' + prefix + '-' + str;
            }
            addCSSRule(sheet, '[aria-controls^=' + slideId + '-item]', str, getCssRulesLength(sheet));
          }
          setAttrs(navItems[navCurrentIndex], {
            'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
          });
          removeAttrs(navItems[navCurrentIndex], 'tabindex');
          addClass(navItems[navCurrentIndex], navActiveClass);

          // add events
          addEvents(navContainer, navEvents);
        }

        // == controlsInit ==
        if (hasControls) {
          if (!controlsContainer && (!prevButton || !nextButton)) {
            outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + '</button></div>');
            controlsContainer = outerWrapper.querySelector('.tns-controls');
          }
          if (!prevButton || !nextButton) {
            prevButton = controlsContainer.children[0];
            nextButton = controlsContainer.children[1];
          }
          if (options.controlsContainer) {
            setAttrs(controlsContainer, {
              'aria-label': 'Carousel Navigation',
              'tabindex': '0'
            });
          }
          if (options.controlsContainer || options.prevButton && options.nextButton) {
            setAttrs([prevButton, nextButton], {
              'aria-controls': slideId,
              'tabindex': '-1'
            });
          }
          if (options.controlsContainer || options.prevButton && options.nextButton) {
            setAttrs(prevButton, {
              'data-controls': 'prev'
            });
            setAttrs(nextButton, {
              'data-controls': 'next'
            });
          }
          prevIsButton = isButton(prevButton);
          nextIsButton = isButton(nextButton);
          updateControlsStatus();

          // add events
          if (controlsContainer) {
            addEvents(controlsContainer, controlsEvents);
          } else {
            addEvents(prevButton, controlsEvents);
            addEvents(nextButton, controlsEvents);
          }
        }

        // hide tools if needed
        disableUI();
      }
      function initEvents() {
        // add events
        if (carousel && TRANSITIONEND) {
          var eve = {};
          eve[TRANSITIONEND] = onTransitionEnd;
          addEvents(container, eve);
        }
        if (touch) {
          addEvents(container, touchEvents, options.preventScrollOnTouch);
        }
        if (mouseDrag) {
          addEvents(container, dragEvents);
        }
        if (arrowKeys) {
          addEvents(doc, docmentKeydownEvent);
        }
        if (nested === 'inner') {
          events.on('outerResized', function () {
            resizeTasks();
            events.emit('innerLoaded', info());
          });
        } else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) {
          addEvents(win, {
            'resize': onResize
          });
        }
        if (autoHeight) {
          if (nested === 'outer') {
            events.on('innerLoaded', doAutoHeight);
          } else if (!disable) {
            doAutoHeight();
          }
        }
        doLazyLoad();
        if (disable) {
          disableSlider();
        } else if (freeze) {
          freezeSlider();
        }
        events.on('indexChanged', additionalUpdates);
        if (nested === 'inner') {
          events.emit('innerLoaded', info());
        }
        if (typeof onInit === 'function') {
          onInit(info());
        }
        isOn = true;
      }
      function destroy() {
        // sheet
        sheet.disabled = true;
        if (sheet.ownerNode) {
          sheet.ownerNode.remove();
        }

        // remove win event listeners
        removeEvents(win, {
          'resize': onResize
        });

        // arrowKeys, controls, nav
        if (arrowKeys) {
          removeEvents(doc, docmentKeydownEvent);
        }
        if (controlsContainer) {
          removeEvents(controlsContainer, controlsEvents);
        }
        if (navContainer) {
          removeEvents(navContainer, navEvents);
        }

        // autoplay
        removeEvents(container, hoverEvents);
        removeEvents(container, visibilityEvent);
        if (autoplayButton) {
          removeEvents(autoplayButton, {
            'click': toggleAutoplay
          });
        }
        if (autoplay) {
          clearInterval(autoplayTimer);
        }

        // container
        if (carousel && TRANSITIONEND) {
          var eve = {};
          eve[TRANSITIONEND] = onTransitionEnd;
          removeEvents(container, eve);
        }
        if (touch) {
          removeEvents(container, touchEvents);
        }
        if (mouseDrag) {
          removeEvents(container, dragEvents);
        }

        // cache Object values in options && reset HTML
        var htmlList = [containerHTML, controlsContainerHTML, prevButtonHTML, nextButtonHTML, navContainerHTML, autoplayButtonHTML];
        tnsList.forEach(function (item, i) {
          var el = item === 'container' ? outerWrapper : options[item];
          if (typeof el === 'object' && el) {
            var prevEl = el.previousElementSibling ? el.previousElementSibling : false,
              parentEl = el.parentNode;
            el.outerHTML = htmlList[i];
            options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
          }
        });

        // reset variables
        tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
        // check variables
        // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });

        for (var a in this) {
          if (a !== 'rebuild') {
            this[a] = null;
          }
        }
        isOn = false;
      }

      // === ON RESIZE ===
      // responsive || fixedWidth || autoWidth || !horizontal
      function onResize(e) {
        raf(function () {
          resizeTasks(getEvent(e));
        });
      }
      function resizeTasks(e) {
        if (!isOn) {
          return;
        }
        if (nested === 'outer') {
          events.emit('outerResized', info(e));
        }
        windowWidth = getWindowWidth();
        var bpChanged,
          breakpointZoneTem = breakpointZone,
          needContainerTransform = false;
        if (responsive) {
          setBreakpointZone();
          bpChanged = breakpointZoneTem !== breakpointZone;
          // if (hasRightDeadZone) { needContainerTransform = true; } // *?
          if (bpChanged) {
            events.emit('newBreakpointStart', info(e));
          }
        }
        var indChanged,
          itemsChanged,
          itemsTem = items,
          disableTem = disable,
          freezeTem = freeze,
          arrowKeysTem = arrowKeys,
          controlsTem = controls,
          navTem = nav,
          touchTem = touch,
          mouseDragTem = mouseDrag,
          autoplayTem = autoplay,
          autoplayHoverPauseTem = autoplayHoverPause,
          autoplayResetOnVisibilityTem = autoplayResetOnVisibility,
          indexTem = index;
        if (bpChanged) {
          var fixedWidthTem = fixedWidth,
            autoHeightTem = autoHeight,
            controlsTextTem = controlsText,
            centerTem = center,
            autoplayTextTem = autoplayText;
          if (!CSSMQ) {
            var gutterTem = gutter,
              edgePaddingTem = edgePadding;
          }
        }

        // get option:
        // fixed width: viewport, fixedWidth, gutter => items
        // others: window width => all variables
        // all: items => slideBy
        arrowKeys = getOption('arrowKeys');
        controls = getOption('controls');
        nav = getOption('nav');
        touch = getOption('touch');
        center = getOption('center');
        mouseDrag = getOption('mouseDrag');
        autoplay = getOption('autoplay');
        autoplayHoverPause = getOption('autoplayHoverPause');
        autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');
        if (bpChanged) {
          disable = getOption('disable');
          fixedWidth = getOption('fixedWidth');
          speed = getOption('speed');
          autoHeight = getOption('autoHeight');
          controlsText = getOption('controlsText');
          autoplayText = getOption('autoplayText');
          autoplayTimeout = getOption('autoplayTimeout');
          if (!CSSMQ) {
            edgePadding = getOption('edgePadding');
            gutter = getOption('gutter');
          }
        }
        // update options
        resetVariblesWhenDisable(disable);
        viewport = getViewportWidth(); // <= edgePadding, gutter
        if ((!horizontal || autoWidth) && !disable) {
          setSlidePositions();
          if (!horizontal) {
            updateContentWrapperHeight(); // <= setSlidePositions
            needContainerTransform = true;
          }
        }
        if (fixedWidth || autoWidth) {
          rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
          // fixedWidth: <= viewport, fixedWidth, gutter
          indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
          // fixedWidth: <= rightBoundary, fixedWidth, gutter
        }

        if (bpChanged || fixedWidth) {
          items = getOption('items');
          slideBy = getOption('slideBy');
          itemsChanged = items !== itemsTem;
          if (itemsChanged) {
            if (!fixedWidth && !autoWidth) {
              indexMax = getIndexMax();
            } // <= items
            // check index before transform in case
            // slider reach the right edge then items become bigger
            updateIndex();
          }
        }
        if (bpChanged) {
          if (disable !== disableTem) {
            if (disable) {
              disableSlider();
            } else {
              enableSlider(); // <= slidePositions, rightBoundary, indexMax
            }
          }
        }

        if (freezable && (bpChanged || fixedWidth || autoWidth)) {
          freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
          // <= fixedWidth: fixedWidth, gutter, rightBoundary
          // <= others: items

          if (freeze !== freezeTem) {
            if (freeze) {
              doContainerTransform(getContainerTransformValue(getStartIndex(0)));
              freezeSlider();
            } else {
              unfreezeSlider();
              needContainerTransform = true;
            }
          }
        }
        resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
        if (!autoplay) {
          autoplayHoverPause = autoplayResetOnVisibility = false;
        }
        if (arrowKeys !== arrowKeysTem) {
          arrowKeys ? addEvents(doc, docmentKeydownEvent) : removeEvents(doc, docmentKeydownEvent);
        }
        if (controls !== controlsTem) {
          if (controls) {
            if (controlsContainer) {
              showElement(controlsContainer);
            } else {
              if (prevButton) {
                showElement(prevButton);
              }
              if (nextButton) {
                showElement(nextButton);
              }
            }
          } else {
            if (controlsContainer) {
              hideElement(controlsContainer);
            } else {
              if (prevButton) {
                hideElement(prevButton);
              }
              if (nextButton) {
                hideElement(nextButton);
              }
            }
          }
        }
        if (nav !== navTem) {
          if (nav) {
            showElement(navContainer);
            updateNavVisibility();
          } else {
            hideElement(navContainer);
          }
        }
        if (touch !== touchTem) {
          touch ? addEvents(container, touchEvents, options.preventScrollOnTouch) : removeEvents(container, touchEvents);
        }
        if (mouseDrag !== mouseDragTem) {
          mouseDrag ? addEvents(container, dragEvents) : removeEvents(container, dragEvents);
        }
        if (autoplay !== autoplayTem) {
          if (autoplay) {
            if (autoplayButton) {
              showElement(autoplayButton);
            }
            if (!animating && !autoplayUserPaused) {
              startAutoplay();
            }
          } else {
            if (autoplayButton) {
              hideElement(autoplayButton);
            }
            if (animating) {
              stopAutoplay();
            }
          }
        }
        if (autoplayHoverPause !== autoplayHoverPauseTem) {
          autoplayHoverPause ? addEvents(container, hoverEvents) : removeEvents(container, hoverEvents);
        }
        if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) {
          autoplayResetOnVisibility ? addEvents(doc, visibilityEvent) : removeEvents(doc, visibilityEvent);
        }
        if (bpChanged) {
          if (fixedWidth !== fixedWidthTem || center !== centerTem) {
            needContainerTransform = true;
          }
          if (autoHeight !== autoHeightTem) {
            if (!autoHeight) {
              innerWrapper.style.height = '';
            }
          }
          if (controls && controlsText !== controlsTextTem) {
            prevButton.innerHTML = controlsText[0];
            nextButton.innerHTML = controlsText[1];
          }
          if (autoplayButton && autoplayText !== autoplayTextTem) {
            var i = autoplay ? 1 : 0,
              html = autoplayButton.innerHTML,
              len = html.length - autoplayTextTem[i].length;
            if (html.substring(len) === autoplayTextTem[i]) {
              autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
            }
          }
        } else {
          if (center && (fixedWidth || autoWidth)) {
            needContainerTransform = true;
          }
        }
        if (itemsChanged || fixedWidth && !autoWidth) {
          pages = getPages();
          updateNavVisibility();
        }
        indChanged = index !== indexTem;
        if (indChanged) {
          events.emit('indexChanged', info());
          needContainerTransform = true;
        } else if (itemsChanged) {
          if (!indChanged) {
            additionalUpdates();
          }
        } else if (fixedWidth || autoWidth) {
          doLazyLoad();
          updateSlideStatus();
          updateLiveRegion();
        }
        if (itemsChanged && !carousel) {
          updateGallerySlidePositions();
        }
        if (!disable && !freeze) {
          // non-mediaqueries: IE8
          if (bpChanged && !CSSMQ) {
            // middle wrapper styles

            // inner wrapper styles
            if (edgePadding !== edgePaddingTem || gutter !== gutterTem) {
              innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
            }
            if (horizontal) {
              // container styles
              if (carousel) {
                container.style.width = getContainerWidth(fixedWidth, gutter, items);
              }

              // slide styles
              var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);

              // remove the last line and
              // add new styles
              removeCSSRule(sheet, getCssRulesLength(sheet) - 1);
              addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
            }
          }

          // auto height
          if (autoHeight) {
            doAutoHeight();
          }
          if (needContainerTransform) {
            doContainerTransformSilent();
            indexCached = index;
          }
        }
        if (bpChanged) {
          events.emit('newBreakpointEnd', info(e));
        }
      }

      // === INITIALIZATION FUNCTIONS === //
      function getFreeze() {
        if (!fixedWidth && !autoWidth) {
          var a = center ? items - (items - 1) / 2 : items;
          return slideCount <= a;
        }
        var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount],
          vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
        if (center) {
          vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
        }
        return width <= vp;
      }
      function setBreakpointZone() {
        breakpointZone = 0;
        for (var bp in responsive) {
          bp = parseInt(bp); // convert string to number
          if (windowWidth >= bp) {
            breakpointZone = bp;
          }
        }
      }

      // (slideBy, indexMin, indexMax) => index
      var updateIndex = function () {
        return loop ? carousel ?
        // loop + carousel
        function () {
          var leftEdge = indexMin,
            rightEdge = indexMax;
          leftEdge += slideBy;
          rightEdge -= slideBy;

          // adjust edges when has edge paddings
          // or fixed-width slider with extra space on the right side
          if (edgePadding) {
            leftEdge += 1;
            rightEdge -= 1;
          } else if (fixedWidth) {
            if ((viewport + gutter) % (fixedWidth + gutter)) {
              rightEdge -= 1;
            }
          }
          if (cloneCount) {
            if (index > rightEdge) {
              index -= slideCount;
            } else if (index < leftEdge) {
              index += slideCount;
            }
          }
        } :
        // loop + gallery
        function () {
          if (index > indexMax) {
            while (index >= indexMin + slideCount) {
              index -= slideCount;
            }
          } else if (index < indexMin) {
            while (index <= indexMax - slideCount) {
              index += slideCount;
            }
          }
        } :
        // non-loop
        function () {
          index = Math.max(indexMin, Math.min(indexMax, index));
        };
      }();
      function disableUI() {
        if (!autoplay && autoplayButton) {
          hideElement(autoplayButton);
        }
        if (!nav && navContainer) {
          hideElement(navContainer);
        }
        if (!controls) {
          if (controlsContainer) {
            hideElement(controlsContainer);
          } else {
            if (prevButton) {
              hideElement(prevButton);
            }
            if (nextButton) {
              hideElement(nextButton);
            }
          }
        }
      }
      function enableUI() {
        if (autoplay && autoplayButton) {
          showElement(autoplayButton);
        }
        if (nav && navContainer) {
          showElement(navContainer);
        }
        if (controls) {
          if (controlsContainer) {
            showElement(controlsContainer);
          } else {
            if (prevButton) {
              showElement(prevButton);
            }
            if (nextButton) {
              showElement(nextButton);
            }
          }
        }
      }
      function freezeSlider() {
        if (frozen) {
          return;
        }

        // remove edge padding from inner wrapper
        if (edgePadding) {
          innerWrapper.style.margin = '0px';
        }

        // add class tns-transparent to cloned slides
        if (cloneCount) {
          var str = 'tns-transparent';
          for (var i = cloneCount; i--;) {
            if (carousel) {
              addClass(slideItems[i], str);
            }
            addClass(slideItems[slideCountNew - i - 1], str);
          }
        }

        // update tools
        disableUI();
        frozen = true;
      }
      function unfreezeSlider() {
        if (!frozen) {
          return;
        }

        // restore edge padding for inner wrapper
        // for mordern browsers
        if (edgePadding && CSSMQ) {
          innerWrapper.style.margin = '';
        }

        // remove class tns-transparent to cloned slides
        if (cloneCount) {
          var str = 'tns-transparent';
          for (var i = cloneCount; i--;) {
            if (carousel) {
              removeClass(slideItems[i], str);
            }
            removeClass(slideItems[slideCountNew - i - 1], str);
          }
        }

        // update tools
        enableUI();
        frozen = false;
      }
      function disableSlider() {
        if (disabled) {
          return;
        }
        sheet.disabled = true;
        container.className = container.className.replace(newContainerClasses.substring(1), '');
        removeAttrs(container, ['style']);
        if (loop) {
          for (var j = cloneCount; j--;) {
            if (carousel) {
              hideElement(slideItems[j]);
            }
            hideElement(slideItems[slideCountNew - j - 1]);
          }
        }

        // vertical slider
        if (!horizontal || !carousel) {
          removeAttrs(innerWrapper, ['style']);
        }

        // gallery
        if (!carousel) {
          for (var i = index, l = index + slideCount; i < l; i++) {
            var item = slideItems[i];
            removeAttrs(item, ['style']);
            removeClass(item, animateIn);
            removeClass(item, animateNormal);
          }
        }

        // update tools
        disableUI();
        disabled = true;
      }
      function enableSlider() {
        if (!disabled) {
          return;
        }
        sheet.disabled = false;
        container.className += newContainerClasses;
        doContainerTransformSilent();
        if (loop) {
          for (var j = cloneCount; j--;) {
            if (carousel) {
              showElement(slideItems[j]);
            }
            showElement(slideItems[slideCountNew - j - 1]);
          }
        }

        // gallery
        if (!carousel) {
          for (var i = index, l = index + slideCount; i < l; i++) {
            var item = slideItems[i],
              classN = i < index + items ? animateIn : animateNormal;
            item.style.left = (i - index) * 100 / items + '%';
            addClass(item, classN);
          }
        }

        // update tools
        enableUI();
        disabled = false;
      }
      function updateLiveRegion() {
        var str = getLiveRegionStr();
        if (liveregionCurrent.innerHTML !== str) {
          liveregionCurrent.innerHTML = str;
        }
      }
      function getLiveRegionStr() {
        var arr = getVisibleSlideRange(),
          start = arr[0] + 1,
          end = arr[1] + 1;
        return start === end ? start + '' : start + ' to ' + end;
      }
      function getVisibleSlideRange(val) {
        if (val == null) {
          val = getContainerTransformValue();
        }
        var start = index,
          end,
          rangestart,
          rangeend;

        // get range start, range end for autoWidth and fixedWidth
        if (center || edgePadding) {
          if (autoWidth || fixedWidth) {
            rangestart = -(parseFloat(val) + edgePadding);
            rangeend = rangestart + viewport + edgePadding * 2;
          }
        } else {
          if (autoWidth) {
            rangestart = slidePositions[index];
            rangeend = rangestart + viewport;
          }
        }

        // get start, end
        // - check auto width
        if (autoWidth) {
          slidePositions.forEach(function (point, i) {
            if (i < slideCountNew) {
              if ((center || edgePadding) && point <= rangestart + 0.5) {
                start = i;
              }
              if (rangeend - point >= 0.5) {
                end = i;
              }
            }
          });

          // - check percentage width, fixed width
        } else {
          if (fixedWidth) {
            var cell = fixedWidth + gutter;
            if (center || edgePadding) {
              start = Math.floor(rangestart / cell);
              end = Math.ceil(rangeend / cell - 1);
            } else {
              end = start + Math.ceil(viewport / cell) - 1;
            }
          } else {
            if (center || edgePadding) {
              var a = items - 1;
              if (center) {
                start -= a / 2;
                end = index + a / 2;
              } else {
                end = index + a;
              }
              if (edgePadding) {
                var b = edgePadding * items / viewport;
                start -= b;
                end += b;
              }
              start = Math.floor(start);
              end = Math.ceil(end);
            } else {
              end = start + items - 1;
            }
          }
          start = Math.max(start, 0);
          end = Math.min(end, slideCountNew - 1);
        }
        return [start, end];
      }
      function doLazyLoad() {
        if (lazyload && !disable) {
          var arg = getVisibleSlideRange();
          arg.push(lazyloadSelector);
          getImageArray.apply(null, arg).forEach(function (img) {
            if (!hasClass(img, imgCompleteClass)) {
              // stop propagation transitionend event to container
              var eve = {};
              eve[TRANSITIONEND] = function (e) {
                e.stopPropagation();
              };
              addEvents(img, eve);
              addEvents(img, imgEvents);

              // update src
              img.src = getAttr(img, 'data-src');

              // update srcset
              var srcset = getAttr(img, 'data-srcset');
              if (srcset) {
                img.srcset = srcset;
              }
              addClass(img, 'loading');
            }
          });
        }
      }
      function onImgLoaded(e) {
        imgLoaded(getTarget(e));
      }
      function onImgFailed(e) {
        imgFailed(getTarget(e));
      }
      function imgLoaded(img) {
        addClass(img, 'loaded');
        imgCompleted(img);
      }
      function imgFailed(img) {
        addClass(img, 'failed');
        imgCompleted(img);
      }
      function imgCompleted(img) {
        addClass(img, imgCompleteClass);
        removeClass(img, 'loading');
        removeEvents(img, imgEvents);
      }
      function getImageArray(start, end, imgSelector) {
        var imgs = [];
        if (!imgSelector) {
          imgSelector = 'img';
        }
        while (start <= end) {
          forEach(slideItems[start].querySelectorAll(imgSelector), function (img) {
            imgs.push(img);
          });
          start++;
        }
        return imgs;
      }

      // check if all visible images are loaded
      // and update container height if it's done
      function doAutoHeight() {
        var imgs = getImageArray.apply(null, getVisibleSlideRange());
        raf(function () {
          imgsLoadedCheck(imgs, updateInnerWrapperHeight);
        });
      }
      function imgsLoadedCheck(imgs, cb) {
        // execute callback function if all images are complete
        if (imgsComplete) {
          return cb();
        }

        // check image classes
        imgs.forEach(function (img, index) {
          if (!lazyload && img.complete) {
            imgCompleted(img);
          } // Check image.complete
          if (hasClass(img, imgCompleteClass)) {
            imgs.splice(index, 1);
          }
        });

        // execute callback function if selected images are all complete
        if (!imgs.length) {
          return cb();
        }

        // otherwise execute this functiona again
        raf(function () {
          imgsLoadedCheck(imgs, cb);
        });
      }
      function additionalUpdates() {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
        updateControlsStatus();
        updateNavStatus();
      }
      function update_carousel_transition_duration() {
        if (carousel && autoHeight) {
          middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + 's';
        }
      }
      function getMaxSlideHeight(slideStart, slideRange) {
        var heights = [];
        for (var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) {
          heights.push(slideItems[i].offsetHeight);
        }
        return Math.max.apply(null, heights);
      }

      // update inner wrapper height
      // 1. get the max-height of the visible slides
      // 2. set transitionDuration to speed
      // 3. update inner wrapper height to max-height
      // 4. set transitionDuration to 0s after transition done
      function updateInnerWrapperHeight() {
        var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount),
          wp = middleWrapper ? middleWrapper : innerWrapper;
        if (wp.style.height !== maxHeight) {
          wp.style.height = maxHeight + 'px';
        }
      }

      // get the distance from the top edge of the first slide to each slide
      // (init) => slidePositions
      function setSlidePositions() {
        slidePositions = [0];
        var attr = horizontal ? 'left' : 'top',
          attr2 = horizontal ? 'right' : 'bottom',
          base = slideItems[0].getBoundingClientRect()[attr];
        forEach(slideItems, function (item, i) {
          // skip the first slide
          if (i) {
            slidePositions.push(item.getBoundingClientRect()[attr] - base);
          }
          // add the end edge
          if (i === slideCountNew - 1) {
            slidePositions.push(item.getBoundingClientRect()[attr2] - base);
          }
        });
      }

      // update slide
      function updateSlideStatus() {
        var range = getVisibleSlideRange(),
          start = range[0],
          end = range[1];
        forEach(slideItems, function (item, i) {
          // show slides
          if (i >= start && i <= end) {
            if (hasAttr(item, 'aria-hidden')) {
              removeAttrs(item, ['aria-hidden', 'tabindex']);
              addClass(item, slideActiveClass);
            }
            // hide slides
          } else {
            if (!hasAttr(item, 'aria-hidden')) {
              setAttrs(item, {
                'aria-hidden': 'true',
                'tabindex': '-1'
              });
              removeClass(item, slideActiveClass);
            }
          }
        });
      }

      // gallery: update slide position
      function updateGallerySlidePositions() {
        var l = index + Math.min(slideCount, items);
        for (var i = slideCountNew; i--;) {
          var item = slideItems[i];
          if (i >= index && i < l) {
            // add transitions to visible slides when adjusting their positions
            addClass(item, 'tns-moving');
            item.style.left = (i - index) * 100 / items + '%';
            addClass(item, animateIn);
            removeClass(item, animateNormal);
          } else if (item.style.left) {
            item.style.left = '';
            addClass(item, animateNormal);
            removeClass(item, animateIn);
          }

          // remove outlet animation
          removeClass(item, animateOut);
        }

        // removing '.tns-moving'
        setTimeout(function () {
          forEach(slideItems, function (el) {
            removeClass(el, 'tns-moving');
          });
        }, 300);
      }

      // set tabindex on Nav
      function updateNavStatus() {
        // get current nav
        if (nav) {
          navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
          navClicked = -1;
          if (navCurrentIndex !== navCurrentIndexCached) {
            var navPrev = navItems[navCurrentIndexCached],
              navCurrent = navItems[navCurrentIndex];
            setAttrs(navPrev, {
              'tabindex': '-1',
              'aria-label': navStr + (navCurrentIndexCached + 1)
            });
            removeClass(navPrev, navActiveClass);
            setAttrs(navCurrent, {
              'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
            });
            removeAttrs(navCurrent, 'tabindex');
            addClass(navCurrent, navActiveClass);
            navCurrentIndexCached = navCurrentIndex;
          }
        }
      }
      function getLowerCaseNodeName(el) {
        return el.nodeName.toLowerCase();
      }
      function isButton(el) {
        return getLowerCaseNodeName(el) === 'button';
      }
      function isAriaDisabled(el) {
        return el.getAttribute('aria-disabled') === 'true';
      }
      function disEnableElement(isButton, el, val) {
        if (isButton) {
          el.disabled = val;
        } else {
          el.setAttribute('aria-disabled', val.toString());
        }
      }

      // set 'disabled' to true on controls when reach the edges
      function updateControlsStatus() {
        if (!controls || rewind || loop) {
          return;
        }
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton),
          nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton),
          disablePrev = index <= indexMin ? true : false,
          disableNext = !rewind && index >= indexMax ? true : false;
        if (disablePrev && !prevDisabled) {
          disEnableElement(prevIsButton, prevButton, true);
        }
        if (!disablePrev && prevDisabled) {
          disEnableElement(prevIsButton, prevButton, false);
        }
        if (disableNext && !nextDisabled) {
          disEnableElement(nextIsButton, nextButton, true);
        }
        if (!disableNext && nextDisabled) {
          disEnableElement(nextIsButton, nextButton, false);
        }
      }

      // set duration
      function resetDuration(el, str) {
        if (TRANSITIONDURATION) {
          el.style[TRANSITIONDURATION] = str;
        }
      }
      function getSliderWidth() {
        return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
      }
      function getCenterGap(num) {
        if (num == null) {
          num = index;
        }
        var gap = edgePadding ? gutter : 0;
        return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
      }
      function getRightBoundary() {
        var gap = edgePadding ? gutter : 0,
          result = viewport + gap - getSliderWidth();
        if (center && !loop) {
          result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
        }
        if (result > 0) {
          result = 0;
        }
        return result;
      }
      function getContainerTransformValue(num) {
        if (num == null) {
          num = index;
        }
        var val;
        if (horizontal && !autoWidth) {
          if (fixedWidth) {
            val = -(fixedWidth + gutter) * num;
            if (center) {
              val += getCenterGap();
            }
          } else {
            var denominator = TRANSFORM ? slideCountNew : items;
            if (center) {
              num -= getCenterGap();
            }
            val = -num * 100 / denominator;
          }
        } else {
          val = -slidePositions[num];
          if (center && autoWidth) {
            val += getCenterGap();
          }
        }
        if (hasRightDeadZone) {
          val = Math.max(val, rightBoundary);
        }
        val += horizontal && !autoWidth && !fixedWidth ? '%' : 'px';
        return val;
      }
      function doContainerTransformSilent(val) {
        resetDuration(container, '0s');
        doContainerTransform(val);
      }
      function doContainerTransform(val) {
        if (val == null) {
          val = getContainerTransformValue();
        }
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
      }
      function animateSlide(number, classOut, classIn, isOut) {
        var l = number + items;
        if (!loop) {
          l = Math.min(l, slideCountNew);
        }
        for (var i = number; i < l; i++) {
          var item = slideItems[i];

          // set item positions
          if (!isOut) {
            item.style.left = (i - index) * 100 / items + '%';
          }
          if (animateDelay && TRANSITIONDELAY) {
            item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
          }
          removeClass(item, classOut);
          addClass(item, classIn);
          if (isOut) {
            slideItemsOut.push(item);
          }
        }
      }

      // make transfer after click/drag:
      // 1. change 'transform' property for mordern browsers
      // 2. change 'left' property for legacy browsers
      var transformCore = function () {
        return carousel ? function () {
          resetDuration(container, '');
          if (TRANSITIONDURATION || !speed) {
            // for morden browsers with non-zero duration or
            // zero duration for all browsers
            doContainerTransform();
            // run fallback function manually
            // when duration is 0 / container is hidden
            if (!speed || !isVisible(container)) {
              onTransitionEnd();
            }
          } else {
            // for old browser with non-zero duration
            jsTransform(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
          }
          if (!horizontal) {
            updateContentWrapperHeight();
          }
        } : function () {
          slideItemsOut = [];
          var eve = {};
          eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
          removeEvents(slideItems[indexCached], eve);
          addEvents(slideItems[index], eve);
          animateSlide(indexCached, animateIn, animateOut, true);
          animateSlide(index, animateNormal, animateIn);

          // run fallback function manually
          // when transition or animation not supported / duration is 0
          if (!TRANSITIONEND || !ANIMATIONEND || !speed || !isVisible(container)) {
            onTransitionEnd();
          }
        };
      }();
      function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) {
          updateIndex();
        }

        // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
          // events
          events.emit('indexChanged', info());
          events.emit('transitionStart', info());
          if (autoHeight) {
            doAutoHeight();
          }

          // pause autoplay when click or keydown from user
          if (animating && e && ['click', 'keydown'].indexOf(e.type) >= 0) {
            stopAutoplay();
          }
          running = true;
          transformCore();
        }
      }

      /*
       * Transfer prefixed properties to the same format
       * CSS: -Webkit-Transform => webkittransform
       * JS: WebkitTransform => webkittransform
       * @param {string} str - property
       *
       */
      function strTrans(str) {
        return str.toLowerCase().replace(/-/g, '');
      }

      // AFTER TRANSFORM
      // Things need to be done after a transfer:
      // 1. check index
      // 2. add classes to visible slide
      // 3. disable controls buttons when reach the first/last slide in non-loop slider
      // 4. update nav status
      // 5. lazyload images
      // 6. update container height
      function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
          events.emit('transitionEnd', info(event));
          if (!carousel && slideItemsOut.length > 0) {
            for (var i = 0; i < slideItemsOut.length; i++) {
              var item = slideItemsOut[i];
              // set item positions
              item.style.left = '';
              if (ANIMATIONDELAY && TRANSITIONDELAY) {
                item.style[ANIMATIONDELAY] = '';
                item.style[TRANSITIONDELAY] = '';
              }
              removeClass(item, animateOut);
              addClass(item, animateNormal);
            }
          }

          /* update slides, nav, controls after checking ...
           * => legacy browsers who don't support 'event'
           *    have to check event first, otherwise event.target will cause an error
           * => or 'gallery' mode:
           *   + event target is slide item
           * => or 'carousel' mode:
           *   + event target is container,
           *   + event.property is the same with transform attribute
           */
          if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
            if (!updateIndexBeforeTransform) {
              var indexTem = index;
              updateIndex();
              if (index !== indexTem) {
                events.emit('indexChanged', info());
                doContainerTransformSilent();
              }
            }
            if (nested === 'inner') {
              events.emit('innerLoaded', info());
            }
            running = false;
            indexCached = index;
          }
        }
      }

      // # ACTIONS
      function goTo(targetIndex, e) {
        if (freeze) {
          return;
        }

        // prev slideBy
        if (targetIndex === 'prev') {
          onControlsClick(e, -1);

          // next slideBy
        } else if (targetIndex === 'next') {
          onControlsClick(e, 1);

          // go to exact slide
        } else {
          if (running) {
            if (preventActionWhenRunning) {
              return;
            } else {
              onTransitionEnd();
            }
          }
          var absIndex = getAbsIndex(),
            indexGap = 0;
          if (targetIndex === 'first') {
            indexGap = -absIndex;
          } else if (targetIndex === 'last') {
            indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
          } else {
            if (typeof targetIndex !== 'number') {
              targetIndex = parseInt(targetIndex);
            }
            if (!isNaN(targetIndex)) {
              // from directly called goTo function
              if (!e) {
                targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
              }
              indexGap = targetIndex - absIndex;
            }
          }

          // gallery: make sure new page won't overlap with current page
          if (!carousel && indexGap && Math.abs(indexGap) < items) {
            var factor = indexGap > 0 ? 1 : -1;
            indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
          }
          index += indexGap;

          // make sure index is in range
          if (carousel && loop) {
            if (index < indexMin) {
              index += slideCount;
            }
            if (index > indexMax) {
              index -= slideCount;
            }
          }

          // if index is changed, start rendering
          if (getAbsIndex(index) !== getAbsIndex(indexCached)) {
            render(e);
          }
        }
      }

      // on controls click
      function onControlsClick(e, dir) {
        if (running) {
          if (preventActionWhenRunning) {
            return;
          } else {
            onTransitionEnd();
          }
        }
        var passEventObject;
        if (!dir) {
          e = getEvent(e);
          var target = getTarget(e);
          while (target !== controlsContainer && [prevButton, nextButton].indexOf(target) < 0) {
            target = target.parentNode;
          }
          var targetIn = [prevButton, nextButton].indexOf(target);
          if (targetIn >= 0) {
            passEventObject = true;
            dir = targetIn === 0 ? -1 : 1;
          }
        }
        if (rewind) {
          if (index === indexMin && dir === -1) {
            goTo('last', e);
            return;
          } else if (index === indexMax && dir === 1) {
            goTo('first', e);
            return;
          }
        }
        if (dir) {
          index += slideBy * dir;
          if (autoWidth) {
            index = Math.floor(index);
          }
          // pass e when click control buttons or keydown
          render(passEventObject || e && e.type === 'keydown' ? e : null);
        }
      }

      // on nav click
      function onNavClick(e) {
        if (running) {
          if (preventActionWhenRunning) {
            return;
          } else {
            onTransitionEnd();
          }
        }
        e = getEvent(e);
        var target = getTarget(e),
          navIndex;

        // find the clicked nav item
        while (target !== navContainer && !hasAttr(target, 'data-nav')) {
          target = target.parentNode;
        }
        if (hasAttr(target, 'data-nav')) {
          var navIndex = navClicked = Number(getAttr(target, 'data-nav')),
            targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items,
            targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
          goTo(targetIndex, e);
          if (navCurrentIndex === navIndex) {
            if (animating) {
              stopAutoplay();
            }
            navClicked = -1; // reset navClicked
          }
        }
      }

      // autoplay functions
      function setAutoplayTimer() {
        autoplayTimer = setInterval(function () {
          onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
      }
      function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
      }
      function updateAutoplayButton(action, txt) {
        setAttrs(autoplayButton, {
          'data-action': action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
      }
      function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) {
          updateAutoplayButton('stop', autoplayText[1]);
        }
      }
      function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) {
          updateAutoplayButton('start', autoplayText[0]);
        }
      }

      // programaitcally play/pause the slider
      function play() {
        if (autoplay && !animating) {
          startAutoplay();
          autoplayUserPaused = false;
        }
      }
      function pause() {
        if (animating) {
          stopAutoplay();
          autoplayUserPaused = true;
        }
      }
      function toggleAutoplay() {
        if (animating) {
          stopAutoplay();
          autoplayUserPaused = true;
        } else {
          startAutoplay();
          autoplayUserPaused = false;
        }
      }
      function onVisibilityChange() {
        if (doc.hidden) {
          if (animating) {
            stopAutoplayTimer();
            autoplayVisibilityPaused = true;
          }
        } else if (autoplayVisibilityPaused) {
          setAutoplayTimer();
          autoplayVisibilityPaused = false;
        }
      }
      function mouseoverPause() {
        if (animating) {
          stopAutoplayTimer();
          autoplayHoverPaused = true;
        }
      }
      function mouseoutRestart() {
        if (autoplayHoverPaused) {
          setAutoplayTimer();
          autoplayHoverPaused = false;
        }
      }

      // keydown events on document
      function onDocumentKeydown(e) {
        e = getEvent(e);
        var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);
        if (keyIndex >= 0) {
          onControlsClick(e, keyIndex === 0 ? -1 : 1);
        }
      }

      // on key control
      function onControlsKeydown(e) {
        e = getEvent(e);
        var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);
        if (keyIndex >= 0) {
          if (keyIndex === 0) {
            if (!prevButton.disabled) {
              onControlsClick(e, -1);
            }
          } else if (!nextButton.disabled) {
            onControlsClick(e, 1);
          }
        }
      }

      // set focus
      function setFocus(el) {
        el.focus();
      }

      // on key nav
      function onNavKeydown(e) {
        e = getEvent(e);
        var curElement = doc.activeElement;
        if (!hasAttr(curElement, 'data-nav')) {
          return;
        }

        // var code = e.keyCode,
        var keyIndex = [KEYS.LEFT, KEYS.RIGHT, KEYS.ENTER, KEYS.SPACE].indexOf(e.keyCode),
          navIndex = Number(getAttr(curElement, 'data-nav'));
        if (keyIndex >= 0) {
          if (keyIndex === 0) {
            if (navIndex > 0) {
              setFocus(navItems[navIndex - 1]);
            }
          } else if (keyIndex === 1) {
            if (navIndex < pages - 1) {
              setFocus(navItems[navIndex + 1]);
            }
          } else {
            navClicked = navIndex;
            goTo(navIndex, e);
          }
        }
      }
      function getEvent(e) {
        e = e || win.event;
        return isTouchEvent(e) ? e.changedTouches[0] : e;
      }
      function getTarget(e) {
        return e.target || win.event.srcElement;
      }
      function isTouchEvent(e) {
        return e.type.indexOf('touch') >= 0;
      }
      function preventDefaultBehavior(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
      }
      function getMoveDirectionExpected() {
        return getTouchDirection(toDegree(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
      }
      function onPanStart(e) {
        if (running) {
          if (preventActionWhenRunning) {
            return;
          } else {
            onTransitionEnd();
          }
        }
        if (autoplay && animating) {
          stopAutoplayTimer();
        }
        panStart = true;
        if (rafIndex) {
          caf(rafIndex);
          rafIndex = null;
        }
        var $ = getEvent(e);
        events.emit(isTouchEvent(e) ? 'touchStart' : 'dragStart', info(e));
        if (!isTouchEvent(e) && ['img', 'a'].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) {
          preventDefaultBehavior(e);
        }
        lastPosition.x = initPosition.x = $.clientX;
        lastPosition.y = initPosition.y = $.clientY;
        if (carousel) {
          translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ''));
          resetDuration(container, '0s');
        }
      }
      function onPanMove(e) {
        if (panStart) {
          var $ = getEvent(e);
          lastPosition.x = $.clientX;
          lastPosition.y = $.clientY;
          if (carousel) {
            if (!rafIndex) {
              rafIndex = raf(function () {
                panUpdate(e);
              });
            }
          } else {
            if (moveDirectionExpected === '?') {
              moveDirectionExpected = getMoveDirectionExpected();
            }
            if (moveDirectionExpected) {
              preventScroll = true;
            }
          }
          if ((typeof e.cancelable !== 'boolean' || e.cancelable) && preventScroll) {
            e.preventDefault();
          }
        }
      }
      function panUpdate(e) {
        if (!moveDirectionExpected) {
          panStart = false;
          return;
        }
        caf(rafIndex);
        if (panStart) {
          rafIndex = raf(function () {
            panUpdate(e);
          });
        }
        if (moveDirectionExpected === '?') {
          moveDirectionExpected = getMoveDirectionExpected();
        }
        if (moveDirectionExpected) {
          if (!preventScroll && isTouchEvent(e)) {
            preventScroll = true;
          }
          try {
            if (e.type) {
              events.emit(isTouchEvent(e) ? 'touchMove' : 'dragMove', info(e));
            }
          } catch (err) {}
          var x = translateInit,
            dist = getDist(lastPosition, initPosition);
          if (!horizontal || fixedWidth || autoWidth) {
            x += dist;
            x += 'px';
          } else {
            var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
            x += percentageX;
            x += '%';
          }
          container.style[transformAttr] = transformPrefix + x + transformPostfix;
        }
      }
      function onPanEnd(e) {
        if (panStart) {
          if (rafIndex) {
            caf(rafIndex);
            rafIndex = null;
          }
          if (carousel) {
            resetDuration(container, '');
          }
          panStart = false;
          var $ = getEvent(e);
          lastPosition.x = $.clientX;
          lastPosition.y = $.clientY;
          var dist = getDist(lastPosition, initPosition);
          if (Math.abs(dist)) {
            // drag vs click
            if (!isTouchEvent(e)) {
              // prevent "click"
              var target = getTarget(e);
              addEvents(target, {
                'click': function preventClick(e) {
                  preventDefaultBehavior(e);
                  removeEvents(target, {
                    'click': preventClick
                  });
                }
              });
            }
            if (carousel) {
              rafIndex = raf(function () {
                if (horizontal && !autoWidth) {
                  var indexMoved = -dist * items / (viewport + gutter);
                  indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                  index += indexMoved;
                } else {
                  var moved = -(translateInit + dist);
                  if (moved <= 0) {
                    index = indexMin;
                  } else if (moved >= slidePositions[slideCountNew - 1]) {
                    index = indexMax;
                  } else {
                    var i = 0;
                    while (i < slideCountNew && moved >= slidePositions[i]) {
                      index = i;
                      if (moved > slidePositions[i] && dist < 0) {
                        index += 1;
                      }
                      i++;
                    }
                  }
                }
                render(e, dist);
                events.emit(isTouchEvent(e) ? 'touchEnd' : 'dragEnd', info(e));
              });
            } else {
              if (moveDirectionExpected) {
                onControlsClick(e, dist > 0 ? -1 : 1);
              }
            }
          }
        }

        // reset
        if (options.preventScrollOnTouch === 'auto') {
          preventScroll = false;
        }
        if (swipeAngle) {
          moveDirectionExpected = '?';
        }
        if (autoplay && !animating) {
          setAutoplayTimer();
        }
      }

      // === RESIZE FUNCTIONS === //
      // (slidePositions, index, items) => vertical_conentWrapper.height
      function updateContentWrapperHeight() {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.style.height = slidePositions[index + items] - slidePositions[index] + 'px';
      }
      function getPages() {
        var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
        return Math.min(Math.ceil(rough), slideCount);
      }

      /*
       * 1. update visible nav items list
       * 2. add "hidden" attributes to previous visible nav items
       * 3. remove "hidden" attrubutes to new visible nav items
       */
      function updateNavVisibility() {
        if (!nav || navAsThumbnails) {
          return;
        }
        if (pages !== pagesCached) {
          var min = pagesCached,
            max = pages,
            fn = showElement;
          if (pagesCached > pages) {
            min = pages;
            max = pagesCached;
            fn = hideElement;
          }
          while (min < max) {
            fn(navItems[min]);
            min++;
          }

          // cache pages
          pagesCached = pages;
        }
      }
      function info(e) {
        return {
          container: container,
          slideItems: slideItems,
          navContainer: navContainer,
          navItems: navItems,
          controlsContainer: controlsContainer,
          hasControls: hasControls,
          prevButton: prevButton,
          nextButton: nextButton,
          items: items,
          slideBy: slideBy,
          cloneCount: cloneCount,
          slideCount: slideCount,
          slideCountNew: slideCountNew,
          index: index,
          indexCached: indexCached,
          displayIndex: getCurrentSlide(),
          navCurrentIndex: navCurrentIndex,
          navCurrentIndexCached: navCurrentIndexCached,
          pages: pages,
          pagesCached: pagesCached,
          sheet: sheet,
          isOn: isOn,
          event: e || {}
        };
      }
      return {
        version: '2.9.4',
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        isOn: isOn,
        updateSliderHeight: updateInnerWrapperHeight,
        refresh: initSliderTransform,
        destroy: destroy,
        rebuild: function () {
          return tns(extend(options, optionsElements));
        }
      };
    };

    /***/
  },

  /***/"30c9": /***/function (module, exports, __webpack_require__) {
    var isFunction = __webpack_require__("9520"),
      isLength = __webpack_require__("b218");

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module.exports = isArrayLike;

    /***/
  },

  /***/"32b3": /***/function (module, exports, __webpack_require__) {
    var baseAssignValue = __webpack_require__("872a"),
      eq = __webpack_require__("9638");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignValue;

    /***/
  },

  /***/"32f4": /***/function (module, exports, __webpack_require__) {
    var arrayFilter = __webpack_require__("2d7c"),
      stubArray = __webpack_require__("d327");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Built-in value references. */
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeGetSymbols = Object.getOwnPropertySymbols;

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    module.exports = getSymbols;

    /***/
  },

  /***/"34ac": /***/function (module, exports, __webpack_require__) {
    var isFunction = __webpack_require__("9520"),
      isMasked = __webpack_require__("1368"),
      isObject = __webpack_require__("1a8c"),
      toSource = __webpack_require__("dc57");

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used for built-in method references. */
    var funcProto = Function.prototype,
      objectProto = Object.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;

    /***/
  },

  /***/"3698": /***/function (module, exports) {
    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }
    module.exports = getValue;

    /***/
  },

  /***/"3729": /***/function (module, exports, __webpack_require__) {
    var Symbol = __webpack_require__("9e69"),
      getRawTag = __webpack_require__("00fd"),
      objectToString = __webpack_require__("29f3");

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;

    /***/
  },

  /***/"39ff": /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__("0b07"),
      root = __webpack_require__("2b3e");

    /* Built-in method references that are verified to be native. */
    var WeakMap = getNative(root, 'WeakMap');
    module.exports = WeakMap;

    /***/
  },

  /***/"3b4a": /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__("0b07");
    var defineProperty = function () {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }();
    module.exports = defineProperty;

    /***/
  },

  /***/"3e88": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"41c3": /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__("1a8c"),
      isPrototype = __webpack_require__("eac5"),
      nativeKeysIn = __webpack_require__("ec8c");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
        result = [];
      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeysIn;

    /***/
  },

  /***/"4245": /***/function (module, exports, __webpack_require__) {
    var isKeyable = __webpack_require__("1290");

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    module.exports = getMapData;

    /***/
  },

  /***/"42454": /***/function (module, exports, __webpack_require__) {
    var baseMerge = __webpack_require__("f909"),
      createAssigner = __webpack_require__("2ec1");

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function (object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });
    module.exports = merge;

    /***/
  },

  /***/"4284": /***/function (module, exports) {
    /**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    module.exports = arraySome;

    /***/
  },

  /***/"42a2": /***/function (module, exports, __webpack_require__) {
    var DataView = __webpack_require__("b5a7"),
      Map = __webpack_require__("79bc"),
      Promise = __webpack_require__("1cec"),
      Set = __webpack_require__("c869"),
      WeakMap = __webpack_require__("39ff"),
      baseGetTag = __webpack_require__("3729"),
      toSource = __webpack_require__("dc57");

    /** `Object#toString` result references. */
    var mapTag = '[object Map]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';
    var dataViewTag = '[object DataView]';

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function (value) {
        var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    module.exports = getTag;

    /***/
  },

  /***/"4359": /***/function (module, exports) {
    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
        length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    module.exports = copyArray;

    /***/
  },

  /***/"44ce": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"49f4": /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("6044");

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module.exports = hashClear;

    /***/
  },

  /***/"4af7": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"4f50": /***/function (module, exports, __webpack_require__) {
    var assignMergeValue = __webpack_require__("b760"),
      cloneBuffer = __webpack_require__("e538"),
      cloneTypedArray = __webpack_require__("c8fe"),
      copyArray = __webpack_require__("4359"),
      initCloneObject = __webpack_require__("fa21"),
      isArguments = __webpack_require__("d370"),
      isArray = __webpack_require__("6747"),
      isArrayLikeObject = __webpack_require__("dcbe"),
      isBuffer = __webpack_require__("0d24"),
      isFunction = __webpack_require__("9520"),
      isObject = __webpack_require__("1a8c"),
      isPlainObject = __webpack_require__("60ed"),
      isTypedArray = __webpack_require__("73ac"),
      safeGet = __webpack_require__("8adb"),
      toPlainObject = __webpack_require__("8de2");

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
      var isCommon = newValue === undefined;
      if (isCommon) {
        var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }
    module.exports = baseMergeDeep;

    /***/
  },

  /***/"50d8": /***/function (module, exports) {
    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    module.exports = baseTimes;

    /***/
  },

  /***/"52e8": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsQuickFacts_vue_vue_type_style_index_0_id_71b641c5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b4df");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsQuickFacts_vue_vue_type_style_index_0_id_71b641c5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsQuickFacts_vue_vue_type_style_index_0_id_71b641c5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"53ca": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return _typeof;
    });
    function _typeof(obj) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }

    /***/
  },

  /***/"55a3": /***/function (module, exports) {
    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }
    module.exports = stackHas;

    /***/
  },

  /***/"571d": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"57a5": /***/function (module, exports, __webpack_require__) {
    var overArg = __webpack_require__("91e9");

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeKeys = overArg(Object.keys, Object);
    module.exports = nativeKeys;

    /***/
  },

  /***/"585a": /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /** Detect free variable `global` from Node.js. */
      var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
      module.exports = freeGlobal;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("c8ba"));

    /***/
  },

  /***/"5bc3": /***/function (module, exports, __webpack_require__) {
    var toPropertyKey = __webpack_require__("a395");
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
      }
    }
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      Object.defineProperty(Constructor, "prototype", {
        writable: false
      });
      return Constructor;
    }
    module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

    /***/
  },

  /***/"5e2e": /***/function (module, exports, __webpack_require__) {
    var listCacheClear = __webpack_require__("28c9"),
      listCacheDelete = __webpack_require__("69d5"),
      listCacheGet = __webpack_require__("b4c0"),
      listCacheHas = __webpack_require__("fba5"),
      listCacheSet = __webpack_require__("67ca");

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module.exports = ListCache;

    /***/
  },

  /***/"6044": /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__("0b07");

    /* Built-in method references that are verified to be native. */
    var nativeCreate = getNative(Object, 'create');
    module.exports = nativeCreate;

    /***/
  },

  /***/"60c0": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"60ed": /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("3729"),
      getPrototype = __webpack_require__("2dcb"),
      isObjectLike = __webpack_require__("1310");

    /** `Object#toString` result references. */
    var objectTag = '[object Object]';

    /** Used for built-in method references. */
    var funcProto = Function.prototype,
      objectProto = Object.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    module.exports = isPlainObject;

    /***/
  },

  /***/"62e4": /***/function (module, exports) {
    module.exports = function (module) {
      if (!module.webpackPolyfill) {
        module.deprecate = function () {};
        module.paths = [];
        // module.parent = undefined by default
        if (!module.children) module.children = [];
        Object.defineProperty(module, "loaded", {
          enumerable: true,
          get: function () {
            return module.l;
          }
        });
        Object.defineProperty(module, "id", {
          enumerable: true,
          get: function () {
            return module.i;
          }
        });
        module.webpackPolyfill = 1;
      }
      return module;
    };

    /***/
  },

  /***/"63ea": /***/function (module, exports, __webpack_require__) {
    var baseIsEqual = __webpack_require__("c05f");

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }
    module.exports = isEqual;

    /***/
  },

  /***/"6747": /***/function (module, exports) {
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;
    module.exports = isArray;

    /***/
  },

  /***/"6790": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"67ca": /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("cb5a");

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module.exports = listCacheSet;

    /***/
  },

  /***/"69d5": /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("cb5a");

    /** Used for built-in method references. */
    var arrayProto = Array.prototype;

    /** Built-in value references. */
    var splice = arrayProto.splice;

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module.exports = listCacheDelete;

    /***/
  },

  /***/"6d92": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsCategoryList_vue_vue_type_style_index_0_id_6817f6b9_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("053d");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsCategoryList_vue_vue_type_style_index_0_id_6817f6b9_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsCategoryList_vue_vue_type_style_index_0_id_6817f6b9_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"6fcd": /***/function (module, exports, __webpack_require__) {
    var baseTimes = __webpack_require__("50d8"),
      isArguments = __webpack_require__("d370"),
      isArray = __webpack_require__("6747"),
      isBuffer = __webpack_require__("0d24"),
      isIndex = __webpack_require__("c098"),
      isTypedArray = __webpack_require__("73ac");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == 'length' ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == 'offset' || key == 'parent') ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
        // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = arrayLikeKeys;

    /***/
  },

  /***/"7037": /***/function (module, exports) {
    function _typeof(obj) {
      "@babel/helpers - typeof";

      return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
    }
    module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

    /***/
  },

  /***/"707d": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsDatePicker_vue_vue_type_style_index_0_id_55cd26a5_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a8ca");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsDatePicker_vue_vue_type_style_index_0_id_55cd26a5_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsDatePicker_vue_vue_type_style_index_0_id_55cd26a5_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"72af": /***/function (module, exports, __webpack_require__) {
    var createBaseFor = __webpack_require__("99cd");

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();
    module.exports = baseFor;

    /***/
  },

  /***/"72f0": /***/function (module, exports) {
    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function () {
        return value;
      };
    }
    module.exports = constant;

    /***/
  },

  /***/"73ac": /***/function (module, exports, __webpack_require__) {
    var baseIsTypedArray = __webpack_require__("743f"),
      baseUnary = __webpack_require__("b047"),
      nodeUtil = __webpack_require__("99d3");

    /* Node.js helper references. */
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module.exports = isTypedArray;

    /***/
  },

  /***/"73ce": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsListingCardBodyContent_vue_vue_type_style_index_0_id_6b24beac_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bf3e");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsListingCardBodyContent_vue_vue_type_style_index_0_id_6b24beac_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsListingCardBodyContent_vue_vue_type_style_index_0_id_6b24beac_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"743f": /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("3729"),
      isLength = __webpack_require__("b218"),
      isObjectLike = __webpack_require__("1310");

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    module.exports = baseIsTypedArray;

    /***/
  },

  /***/"7530": /***/function (module, exports, __webpack_require__) {
    var isObject = __webpack_require__("1a8c");

    /** Built-in value references. */
    var objectCreate = Object.create;

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = function () {
      function object() {}
      return function (proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = undefined;
        return result;
      };
    }();
    module.exports = baseCreate;

    /***/
  },

  /***/"7540": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"79bc": /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__("0b07"),
      root = __webpack_require__("2b3e");

    /* Built-in method references that are verified to be native. */
    var Map = getNative(root, 'Map');
    module.exports = Map;

    /***/
  },

  /***/"7a48": /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("6044");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    module.exports = hashHas;

    /***/
  },

  /***/"7a9c": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsFocusContainer_vue_vue_type_style_index_0_id_398e6866_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3e88");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsFocusContainer_vue_vue_type_style_index_0_id_398e6866_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsFocusContainer_vue_vue_type_style_index_0_id_398e6866_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"7b83": /***/function (module, exports, __webpack_require__) {
    var mapCacheClear = __webpack_require__("7c64"),
      mapCacheDelete = __webpack_require__("93ed"),
      mapCacheGet = __webpack_require__("2478"),
      mapCacheHas = __webpack_require__("a524"),
      mapCacheSet = __webpack_require__("1fc8");

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module.exports = MapCache;

    /***/
  },

  /***/"7b97": /***/function (module, exports, __webpack_require__) {
    var Stack = __webpack_require__("7e64"),
      equalArrays = __webpack_require__("a2be"),
      equalByTag = __webpack_require__("1c3c"),
      equalObjects = __webpack_require__("b1e5"),
      getTag = __webpack_require__("42a2"),
      isArray = __webpack_require__("6747"),
      isBuffer = __webpack_require__("0d24"),
      isTypedArray = __webpack_require__("73ac");

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1;

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      objectTag = '[object Object]';

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    module.exports = baseIsEqualDeep;

    /***/
  },

  /***/"7c64": /***/function (module, exports, __webpack_require__) {
    var Hash = __webpack_require__("e24b"),
      ListCache = __webpack_require__("5e2e"),
      Map = __webpack_require__("79bc");

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }
    module.exports = mapCacheClear;

    /***/
  },

  /***/"7d1f": /***/function (module, exports, __webpack_require__) {
    var arrayPush = __webpack_require__("087d"),
      isArray = __webpack_require__("6747");

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    module.exports = baseGetAllKeys;

    /***/
  },

  /***/"7e64": /***/function (module, exports, __webpack_require__) {
    var ListCache = __webpack_require__("5e2e"),
      stackClear = __webpack_require__("efb6"),
      stackDelete = __webpack_require__("2fcc"),
      stackGet = __webpack_require__("802a"),
      stackHas = __webpack_require__("55a3"),
      stackSet = __webpack_require__("d02c");

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module.exports = Stack;

    /***/
  },

  /***/"7ed2": /***/function (module, exports) {
    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    module.exports = setCacheAdd;

    /***/
  },

  /***/"802a": /***/function (module, exports) {
    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }
    module.exports = stackGet;

    /***/
  },

  /***/"8218": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"85e3": /***/function (module, exports) {
    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module.exports = apply;

    /***/
  },

  /***/"872a": /***/function (module, exports, __webpack_require__) {
    var defineProperty = __webpack_require__("3b4a");

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }
    module.exports = baseAssignValue;

    /***/
  },

  /***/"8adb": /***/function (module, exports) {
    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }
      if (key == '__proto__') {
        return;
      }
      return object[key];
    }
    module.exports = safeGet;

    /***/
  },

  /***/"8bbf": /***/function (module, exports) {
    module.exports = require("vue");

    /***/
  },

  /***/"8de2": /***/function (module, exports, __webpack_require__) {
    var copyObject = __webpack_require__("8eeb"),
      keysIn = __webpack_require__("9934");

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    module.exports = toPlainObject;

    /***/
  },

  /***/"8eeb": /***/function (module, exports, __webpack_require__) {
    var assignValue = __webpack_require__("32b3"),
      baseAssignValue = __webpack_require__("872a");

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1,
        length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    module.exports = copyObject;

    /***/
  },

  /***/"91e9": /***/function (module, exports) {
    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    module.exports = overArg;

    /***/
  },

  /***/"93ed": /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("4245");

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = mapCacheDelete;

    /***/
  },

  /***/"9520": /***/function (module, exports, __webpack_require__) {
    var baseGetTag = __webpack_require__("3729"),
      isObject = __webpack_require__("1a8c");

    /** `Object#toString` result references. */
    var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;

    /***/
  },

  /***/"9523": /***/function (module, exports, __webpack_require__) {
    var toPropertyKey = __webpack_require__("a395");
    function _defineProperty(obj, key, value) {
      key = toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

    /***/
  },

  /***/"9638": /***/function (module, exports) {
    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module.exports = eq;

    /***/
  },

  /***/"970b": /***/function (module, exports) {
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

    /***/
  },

  /***/"9934": /***/function (module, exports, __webpack_require__) {
    var arrayLikeKeys = __webpack_require__("6fcd"),
      baseKeysIn = __webpack_require__("41c3"),
      isArrayLike = __webpack_require__("30c9");

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    module.exports = keysIn;

    /***/
  },

  /***/"99cd": /***/function (module, exports) {
    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function (object, iteratee, keysFunc) {
        var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    module.exports = createBaseFor;

    /***/
  },

  /***/"99d3": /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module) {
      var freeGlobal = __webpack_require__("585a");

      /** Detect free variable `exports`. */
      var freeExports = true && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Detect free variable `process` from Node.js. */
      var freeProcess = moduleExports && freeGlobal.process;

      /** Used to access faster Node.js helpers. */
      var nodeUtil = function () {
        try {
          // Use `util.types` for Node.js 10+.
          var types = freeModule && freeModule.require && freeModule.require('util').types;
          if (types) {
            return types;
          }

          // Legacy `process.binding('util')` for Node.js < 10.
          return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
      }();
      module.exports = nodeUtil;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("62e4")(module));

    /***/
  },

  /***/"9aff": /***/function (module, exports, __webpack_require__) {
    var eq = __webpack_require__("9638"),
      isArrayLike = __webpack_require__("30c9"),
      isIndex = __webpack_require__("c098"),
      isObject = __webpack_require__("1a8c");

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
        return eq(object[index], value);
      }
      return false;
    }
    module.exports = isIterateeCall;

    /***/
  },

  /***/"9e69": /***/function (module, exports, __webpack_require__) {
    var root = __webpack_require__("2b3e");

    /** Built-in value references. */
    var Symbol = root.Symbol;
    module.exports = Symbol;

    /***/
  },

  /***/"a2be": /***/function (module, exports, __webpack_require__) {
    var SetCache = __webpack_require__("d612"),
      arraySome = __webpack_require__("4284"),
      cacheHas = __webpack_require__("c584");

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
          othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function (othValue, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }
    module.exports = equalArrays;

    /***/
  },

  /***/"a395": /***/function (module, exports, __webpack_require__) {
    var _typeof = __webpack_require__("7037")["default"];
    var toPrimitive = __webpack_require__("e50d");
    function _toPropertyKey(arg) {
      var key = toPrimitive(arg, "string");
      return _typeof(key) === "symbol" ? key : String(key);
    }
    module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

    /***/
  },

  /***/"a419": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsInfoCardLoading_vue_vue_type_style_index_0_id_24656ecd_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("60c0");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsInfoCardLoading_vue_vue_type_style_index_0_id_24656ecd_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsInfoCardLoading_vue_vue_type_style_index_0_id_24656ecd_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"a454": /***/function (module, exports, __webpack_require__) {
    var constant = __webpack_require__("72f0"),
      defineProperty = __webpack_require__("3b4a"),
      identity = __webpack_require__("cd9d");

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function (func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };
    module.exports = baseSetToString;

    /***/
  },

  /***/"a524": /***/function (module, exports, __webpack_require__) {
    var getMapData = __webpack_require__("4245");

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module.exports = mapCacheHas;

    /***/
  },

  /***/"a8ca": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"a994": /***/function (module, exports, __webpack_require__) {
    var baseGetAllKeys = __webpack_require__("7d1f"),
      getSymbols = __webpack_require__("32f4"),
      keys = __webpack_require__("ec69");

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    module.exports = getAllKeys;

    /***/
  },

  /***/"ab3b": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsSmartbuyCard_vue_vue_type_style_index_0_id_b04b6334_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8218");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsSmartbuyCard_vue_vue_type_style_index_0_id_b04b6334_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsSmartbuyCard_vue_vue_type_style_index_0_id_b04b6334_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"ac41": /***/function (module, exports) {
    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    module.exports = setToArray;

    /***/
  },

  /***/"b047": /***/function (module, exports) {
    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    module.exports = baseUnary;

    /***/
  },

  /***/"b176": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"b1e5": /***/function (module, exports, __webpack_require__) {
    var getAllKeys = __webpack_require__("a994");

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1;

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
          othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
          othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }
    module.exports = equalObjects;

    /***/
  },

  /***/"b218": /***/function (module, exports) {
    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;

    /***/
  },

  /***/"b4c0": /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("cb5a");

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }
    module.exports = listCacheGet;

    /***/
  },

  /***/"b4df": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"b5a7": /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__("0b07"),
      root = __webpack_require__("2b3e");

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(root, 'DataView');
    module.exports = DataView;

    /***/
  },

  /***/"b760": /***/function (module, exports, __webpack_require__) {
    var baseAssignValue = __webpack_require__("872a"),
      eq = __webpack_require__("9638");

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignMergeValue;

    /***/
  },

  /***/"bbc0": /***/function (module, exports, __webpack_require__) {
    var nativeCreate = __webpack_require__("6044");

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    module.exports = hashGet;

    /***/
  },

  /***/"bded": /***/function (module, exports, __webpack_require__) {
    !function (t, e) {
      true ? module.exports = e() : undefined;
    }(this, function () {
      return function (t) {
        function e(o) {
          if (i[o]) return i[o].exports;
          var s = i[o] = {
            exports: {},
            id: o,
            loaded: !1
          };
          return t[o].call(s.exports, s, s.exports, e), s.loaded = !0, s.exports;
        }
        var i = {};
        return e.m = t, e.c = i, e.p = "", e(0);
      }([function (t, e, i) {
        "use strict";

        var o = i(1),
          s = o.isInBrowser,
          n = i(2),
          r = new n(s ? document.body : null);
        r.setStateFromDOM(null), r.listenToDOM(), s && (window.scrollMonitor = r), t.exports = r;
      }, function (t, e) {
        "use strict";

        e.VISIBILITYCHANGE = "visibilityChange", e.ENTERVIEWPORT = "enterViewport", e.FULLYENTERVIEWPORT = "fullyEnterViewport", e.EXITVIEWPORT = "exitViewport", e.PARTIALLYEXITVIEWPORT = "partiallyExitViewport", e.LOCATIONCHANGE = "locationChange", e.STATECHANGE = "stateChange", e.eventTypes = [e.VISIBILITYCHANGE, e.ENTERVIEWPORT, e.FULLYENTERVIEWPORT, e.EXITVIEWPORT, e.PARTIALLYEXITVIEWPORT, e.LOCATIONCHANGE, e.STATECHANGE], e.isOnServer = "undefined" == typeof window, e.isInBrowser = !e.isOnServer, e.defaultOffsets = {
          top: 0,
          bottom: 0
        };
      }, function (t, e, i) {
        "use strict";

        function o(t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function s(t) {
          return c ? 0 : t === document.body ? window.innerHeight || document.documentElement.clientHeight : t.clientHeight;
        }
        function n(t) {
          return c ? 0 : t === document.body ? Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight) : t.scrollHeight;
        }
        function r(t) {
          return c ? 0 : t === document.body ? window.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body.scrollTop : t.scrollTop;
        }
        var h = i(1),
          c = h.isOnServer,
          a = h.isInBrowser,
          l = h.eventTypes,
          p = i(3),
          u = !1;
        if (a) try {
          var w = Object.defineProperty({}, "passive", {
            get: function () {
              u = !0;
            }
          });
          window.addEventListener("test", null, w);
        } catch (t) {}
        var d = !!u && {
            capture: !1,
            passive: !0
          },
          f = function () {
            function t(e, i) {
              function h() {
                if (a.viewportTop = r(e), a.viewportBottom = a.viewportTop + a.viewportHeight, a.documentHeight = n(e), a.documentHeight !== p) {
                  for (u = a.watchers.length; u--;) a.watchers[u].recalculateLocation();
                  p = a.documentHeight;
                }
              }
              function c() {
                for (w = a.watchers.length; w--;) a.watchers[w].update();
                for (w = a.watchers.length; w--;) a.watchers[w].triggerCallbacks();
              }
              o(this, t);
              var a = this;
              this.item = e, this.watchers = [], this.viewportTop = null, this.viewportBottom = null, this.documentHeight = n(e), this.viewportHeight = s(e), this.DOMListener = function () {
                t.prototype.DOMListener.apply(a, arguments);
              }, this.eventTypes = l, i && (this.containerWatcher = i.create(e));
              var p, u, w;
              this.update = function () {
                h(), c();
              }, this.recalculateLocations = function () {
                this.documentHeight = 0, this.update();
              };
            }
            return t.prototype.listenToDOM = function () {
              a && (window.addEventListener ? (this.item === document.body ? window.addEventListener("scroll", this.DOMListener, d) : this.item.addEventListener("scroll", this.DOMListener, d), window.addEventListener("resize", this.DOMListener)) : (this.item === document.body ? window.attachEvent("onscroll", this.DOMListener) : this.item.attachEvent("onscroll", this.DOMListener), window.attachEvent("onresize", this.DOMListener)), this.destroy = function () {
                window.addEventListener ? (this.item === document.body ? (window.removeEventListener("scroll", this.DOMListener, d), this.containerWatcher.destroy()) : this.item.removeEventListener("scroll", this.DOMListener, d), window.removeEventListener("resize", this.DOMListener)) : (this.item === document.body ? (window.detachEvent("onscroll", this.DOMListener), this.containerWatcher.destroy()) : this.item.detachEvent("onscroll", this.DOMListener), window.detachEvent("onresize", this.DOMListener));
              });
            }, t.prototype.destroy = function () {}, t.prototype.DOMListener = function (t) {
              this.setStateFromDOM(t);
            }, t.prototype.setStateFromDOM = function (t) {
              var e = r(this.item),
                i = s(this.item),
                o = n(this.item);
              this.setState(e, i, o, t);
            }, t.prototype.setState = function (t, e, i, o) {
              var s = e !== this.viewportHeight || i !== this.contentHeight;
              if (this.latestEvent = o, this.viewportTop = t, this.viewportHeight = e, this.viewportBottom = t + e, this.contentHeight = i, s) for (var n = this.watchers.length; n--;) this.watchers[n].recalculateLocation();
              this.updateAndTriggerWatchers(o);
            }, t.prototype.updateAndTriggerWatchers = function (t) {
              for (var e = this.watchers.length; e--;) this.watchers[e].update();
              for (e = this.watchers.length; e--;) this.watchers[e].triggerCallbacks(t);
            }, t.prototype.createCustomContainer = function () {
              return new t();
            }, t.prototype.createContainer = function (e) {
              "string" == typeof e ? e = document.querySelector(e) : e && e.length > 0 && (e = e[0]);
              var i = new t(e, this);
              return i.setStateFromDOM(), i.listenToDOM(), i;
            }, t.prototype.create = function (t, e) {
              "string" == typeof t ? t = document.querySelector(t) : t && t.length > 0 && (t = t[0]);
              var i = new p(this, t, e);
              return this.watchers.push(i), i;
            }, t.prototype.beget = function (t, e) {
              return this.create(t, e);
            }, t;
          }();
        t.exports = f;
      }, function (t, e, i) {
        "use strict";

        function o(t, e, i) {
          function o(t, e) {
            if (0 !== t.length) for (E = t.length; E--;) y = t[E], y.callback.call(s, e, s), y.isOne && t.splice(E, 1);
          }
          var s = this;
          this.watchItem = e, this.container = t, i ? i === +i ? this.offsets = {
            top: i,
            bottom: i
          } : this.offsets = {
            top: i.top || w.top,
            bottom: i.bottom || w.bottom
          } : this.offsets = w, this.callbacks = {};
          for (var d = 0, f = u.length; d < f; d++) s.callbacks[u[d]] = [];
          this.locked = !1;
          var m, v, b, I, E, y;
          this.triggerCallbacks = function (t) {
            switch (this.isInViewport && !m && o(this.callbacks[r], t), this.isFullyInViewport && !v && o(this.callbacks[h], t), this.isAboveViewport !== b && this.isBelowViewport !== I && (o(this.callbacks[n], t), v || this.isFullyInViewport || (o(this.callbacks[h], t), o(this.callbacks[a], t)), m || this.isInViewport || (o(this.callbacks[r], t), o(this.callbacks[c], t))), !this.isFullyInViewport && v && o(this.callbacks[a], t), !this.isInViewport && m && o(this.callbacks[c], t), this.isInViewport !== m && o(this.callbacks[n], t), !0) {
              case m !== this.isInViewport:
              case v !== this.isFullyInViewport:
              case b !== this.isAboveViewport:
              case I !== this.isBelowViewport:
                o(this.callbacks[p], t);
            }
            m = this.isInViewport, v = this.isFullyInViewport, b = this.isAboveViewport, I = this.isBelowViewport;
          }, this.recalculateLocation = function () {
            if (!this.locked) {
              var t = this.top,
                e = this.bottom;
              if (this.watchItem.nodeName) {
                var i = this.watchItem.style.display;
                "none" === i && (this.watchItem.style.display = "");
                for (var s = 0, n = this.container; n.containerWatcher;) s += n.containerWatcher.top - n.containerWatcher.container.viewportTop, n = n.containerWatcher.container;
                var r = this.watchItem.getBoundingClientRect();
                this.top = r.top + this.container.viewportTop - s, this.bottom = r.bottom + this.container.viewportTop - s, "none" === i && (this.watchItem.style.display = i);
              } else this.watchItem === +this.watchItem ? this.watchItem > 0 ? this.top = this.bottom = this.watchItem : this.top = this.bottom = this.container.documentHeight - this.watchItem : (this.top = this.watchItem.top, this.bottom = this.watchItem.bottom);
              this.top -= this.offsets.top, this.bottom += this.offsets.bottom, this.height = this.bottom - this.top, void 0 === t && void 0 === e || this.top === t && this.bottom === e || o(this.callbacks[l], null);
            }
          }, this.recalculateLocation(), this.update(), m = this.isInViewport, v = this.isFullyInViewport, b = this.isAboveViewport, I = this.isBelowViewport;
        }
        var s = i(1),
          n = s.VISIBILITYCHANGE,
          r = s.ENTERVIEWPORT,
          h = s.FULLYENTERVIEWPORT,
          c = s.EXITVIEWPORT,
          a = s.PARTIALLYEXITVIEWPORT,
          l = s.LOCATIONCHANGE,
          p = s.STATECHANGE,
          u = s.eventTypes,
          w = s.defaultOffsets;
        o.prototype = {
          on: function (t, e, i) {
            switch (!0) {
              case t === n && !this.isInViewport && this.isAboveViewport:
              case t === r && this.isInViewport:
              case t === h && this.isFullyInViewport:
              case t === c && this.isAboveViewport && !this.isInViewport:
              case t === a && this.isInViewport && this.isAboveViewport:
                if (e.call(this, this.container.latestEvent, this), i) return;
            }
            if (!this.callbacks[t]) throw new Error("Tried to add a scroll monitor listener of type " + t + ". Your options are: " + u.join(", "));
            this.callbacks[t].push({
              callback: e,
              isOne: i || !1
            });
          },
          off: function (t, e) {
            if (!this.callbacks[t]) throw new Error("Tried to remove a scroll monitor listener of type " + t + ". Your options are: " + u.join(", "));
            for (var i, o = 0; i = this.callbacks[t][o]; o++) if (i.callback === e) {
              this.callbacks[t].splice(o, 1);
              break;
            }
          },
          one: function (t, e) {
            this.on(t, e, !0);
          },
          recalculateSize: function () {
            this.height = this.watchItem.offsetHeight + this.offsets.top + this.offsets.bottom, this.bottom = this.top + this.height;
          },
          update: function () {
            this.isAboveViewport = this.top < this.container.viewportTop, this.isBelowViewport = this.bottom > this.container.viewportBottom, this.isInViewport = this.top < this.container.viewportBottom && this.bottom > this.container.viewportTop, this.isFullyInViewport = this.top >= this.container.viewportTop && this.bottom <= this.container.viewportBottom || this.isAboveViewport && this.isBelowViewport;
          },
          destroy: function () {
            var t = this.container.watchers.indexOf(this),
              e = this;
            this.container.watchers.splice(t, 1);
            for (var i = 0, o = u.length; i < o; i++) e.callbacks[u[i]].length = 0;
          },
          lock: function () {
            this.locked = !0;
          },
          unlock: function () {
            this.locked = !1;
          }
        };
        for (var d = function (t) {
            return function (e, i) {
              this.on.call(this, t, e, i);
            };
          }, f = 0, m = u.length; f < m; f++) {
          var v = u[f];
          o.prototype[v] = d(v);
        }
        t.exports = o;
      }]);
    });

    /***/
  },

  /***/"bf3e": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"c05f": /***/function (module, exports, __webpack_require__) {
    var baseIsEqualDeep = __webpack_require__("7b97"),
      isObjectLike = __webpack_require__("1310");

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    module.exports = baseIsEqual;

    /***/
  },

  /***/"c098": /***/function (module, exports) {
    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    module.exports = isIndex;

    /***/
  },

  /***/"c1c9": /***/function (module, exports, __webpack_require__) {
    var baseSetToString = __webpack_require__("a454"),
      shortOut = __webpack_require__("f3c1");

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);
    module.exports = setToString;

    /***/
  },

  /***/"c584": /***/function (module, exports) {
    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    module.exports = cacheHas;

    /***/
  },

  /***/"c792": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsMultiselect_vue_vue_type_style_index_0_id_a49b0a00_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d07c");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsMultiselect_vue_vue_type_style_index_0_id_a49b0a00_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsMultiselect_vue_vue_type_style_index_0_id_a49b0a00_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"c869": /***/function (module, exports, __webpack_require__) {
    var getNative = __webpack_require__("0b07"),
      root = __webpack_require__("2b3e");

    /* Built-in method references that are verified to be native. */
    var Set = getNative(root, 'Set');
    module.exports = Set;

    /***/
  },

  /***/"c8ba": /***/function (module, exports) {
    var g;

    // This works in non-strict mode
    g = function () {
      return this;
    }();
    try {
      // This works if eval is allowed (see CSP)
      g = g || new Function("return this")();
    } catch (e) {
      // This works if the window reference is available
      if (typeof window === "object") g = window;
    }

    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}

    module.exports = g;

    /***/
  },

  /***/"c8fe": /***/function (module, exports, __webpack_require__) {
    var cloneArrayBuffer = __webpack_require__("f8af");

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    module.exports = cloneTypedArray;

    /***/
  },

  /***/"cad3": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsLoader_vue_vue_type_style_index_0_id_77f4b1a1_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4af7");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsLoader_vue_vue_type_style_index_0_id_77f4b1a1_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsLoader_vue_vue_type_style_index_0_id_77f4b1a1_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"cb5a": /***/function (module, exports, __webpack_require__) {
    var eq = __webpack_require__("9638");

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module.exports = assocIndexOf;

    /***/
  },

  /***/"cd9d": /***/function (module, exports) {
    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }
    module.exports = identity;

    /***/
  },

  /***/"d007": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsHeaderDropdown_vue_vue_type_style_index_0_id_5a5a8940_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("571d");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsHeaderDropdown_vue_vue_type_style_index_0_id_5a5a8940_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsHeaderDropdown_vue_vue_type_style_index_0_id_5a5a8940_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"d02c": /***/function (module, exports, __webpack_require__) {
    var ListCache = __webpack_require__("5e2e"),
      Map = __webpack_require__("79bc"),
      MapCache = __webpack_require__("7b83");

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    module.exports = stackSet;

    /***/
  },

  /***/"d07c": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"d327": /***/function (module, exports) {
    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }
    module.exports = stubArray;

    /***/
  },

  /***/"d370": /***/function (module, exports, __webpack_require__) {
    var baseIsArguments = __webpack_require__("253c"),
      isObjectLike = __webpack_require__("1310");

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Built-in value references. */
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    };
    module.exports = isArguments;

    /***/
  },

  /***/"d612": /***/function (module, exports, __webpack_require__) {
    var MapCache = __webpack_require__("7b83"),
      setCacheAdd = __webpack_require__("7ed2"),
      setCacheHas = __webpack_require__("dc0f");

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
        length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    module.exports = SetCache;

    /***/
  },

  /***/"da03": /***/function (module, exports, __webpack_require__) {
    var root = __webpack_require__("2b3e");

    /** Used to detect overreaching core-js shims. */
    var coreJsData = root['__core-js_shared__'];
    module.exports = coreJsData;

    /***/
  },

  /***/"dc0f": /***/function (module, exports) {
    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    module.exports = setCacheHas;

    /***/
  },

  /***/"dc57": /***/function (module, exports) {
    /** Used for built-in method references. */
    var funcProto = Function.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + '';
        } catch (e) {}
      }
      return '';
    }
    module.exports = toSource;

    /***/
  },

  /***/"dcbe": /***/function (module, exports, __webpack_require__) {
    var isArrayLike = __webpack_require__("30c9"),
      isObjectLike = __webpack_require__("1310");

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    module.exports = isArrayLikeObject;

    /***/
  },

  /***/"e24b": /***/function (module, exports, __webpack_require__) {
    var hashClear = __webpack_require__("49f4"),
      hashDelete = __webpack_require__("1efc"),
      hashGet = __webpack_require__("bbc0"),
      hashHas = __webpack_require__("7a48"),
      hashSet = __webpack_require__("2524");

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module.exports = Hash;

    /***/
  },

  /***/"e37d": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (global) {
      /* unused harmony export VClosePopover */
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
        return VPopover;
      });
      /* unused harmony export VTooltip */
      /* unused harmony export createTooltip */
      /* unused harmony export destroyTooltip */
      /* unused harmony export install */
      /* harmony import */
      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7037");
      /* harmony import */
      var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9523");
      /* harmony import */
      var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("970b");
      /* harmony import */
      var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5bc3");
      /* harmony import */
      var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var popper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("f0bd");
      /* harmony import */
      var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("63ea");
      /* harmony import */
      var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */
      var vue_resize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("252c");
      /* harmony import */
      var lodash_merge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("42454");
      /* harmony import */
      var lodash_merge__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_7__);
      var SVGAnimatedString = function SVGAnimatedString() {};
      if (typeof window !== 'undefined') {
        SVGAnimatedString = window.SVGAnimatedString;
      }
      function convertToArray(value) {
        if (typeof value === 'string') {
          value = value.split(' ');
        }
        return value;
      }
      /**
       * Add classes to an element.
       * This method checks to ensure that the classes don't already exist before adding them.
       * It uses el.className rather than classList in order to be IE friendly.
       * @param {object} el - The element to add the classes to.
       * @param {classes} string - List of space separated classes to be added to the element.
       */

      function addClasses(el, classes) {
        var newClasses = convertToArray(classes);
        var classList;
        if (el.className instanceof SVGAnimatedString) {
          classList = convertToArray(el.className.baseVal);
        } else {
          classList = convertToArray(el.className);
        }
        newClasses.forEach(function (newClass) {
          if (classList.indexOf(newClass) === -1) {
            classList.push(newClass);
          }
        });
        if (el instanceof SVGElement) {
          el.setAttribute('class', classList.join(' '));
        } else {
          el.className = classList.join(' ');
        }
      }
      /**
       * Remove classes from an element.
       * It uses el.className rather than classList in order to be IE friendly.
       * @export
       * @param {any} el The element to remove the classes from.
       * @param {any} classes List of space separated classes to be removed from the element.
       */

      function removeClasses(el, classes) {
        var newClasses = convertToArray(classes);
        var classList;
        if (el.className instanceof SVGAnimatedString) {
          classList = convertToArray(el.className.baseVal);
        } else {
          classList = convertToArray(el.className);
        }
        newClasses.forEach(function (newClass) {
          var index = classList.indexOf(newClass);
          if (index !== -1) {
            classList.splice(index, 1);
          }
        });
        if (el instanceof SVGElement) {
          el.setAttribute('class', classList.join(' '));
        } else {
          el.className = classList.join(' ');
        }
      }
      var supportsPassive = false;
      if (typeof window !== 'undefined') {
        supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
              supportsPassive = true;
            }
          });
          window.addEventListener('test', null, opts);
        } catch (e) {}
      }
      function ownKeys$2(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread$2(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys$2(Object(source), true).forEach(function (key) {
              _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys$2(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      var DEFAULT_OPTIONS = {
        container: false,
        delay: 0,
        html: false,
        placement: 'top',
        title: '',
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        offset: 0
      };
      var openTooltips = [];
      var Tooltip = /*#__PURE__*/function () {
        /**
         * Create a new Tooltip.js instance
         * @class Tooltip
         * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
         * @param {Object} options
         * @param {String} options.placement=bottom
         *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
         *      left(-start, -end)`
         * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
         * @param {Number|Object} options.delay=0
         *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
         *      If a number is supplied, delay is applied to both hide/show.
         *      Object structure is: `{ show: 500, hide: 100 }`
         * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
         * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
         * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
         *      Base HTML to used when creating the tooltip.
         *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
         *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
         *      The outermost wrapper element should have the `.tooltip` class.
         * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
         * @param {String} [options.trigger='hover focus']
         *      How tooltip is triggered - click, hover, focus, manual.
         *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
         * @param {HTMLElement} options.boundariesElement
         *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
         *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
         * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
         *      [offset docs](https://popper.js.org/popper-documentation.html)
         * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
         *      [options docs](https://popper.js.org/popper-documentation.html)
         * @param {string} [options.ariaId] Id used for accessibility
         * @return {Object} instance - The generated tooltip instance
         */
        function Tooltip(_reference, _options) {
          var _this = this;
          _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Tooltip);
          _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(this, "_events", []);
          _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(this, "_setTooltipNodeEvent", function (evt, reference, delay, options) {
            var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;
            var callback = function callback(evt2) {
              var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget; // Remove event listener after call

              _this._tooltipNode.removeEventListener(evt.type, callback); // If the new reference is not the reference element

              if (!reference.contains(relatedreference2)) {
                // Schedule to hide tooltip
                _this._scheduleHide(reference, options.delay, options, evt2);
              }
            };
            if (_this._tooltipNode.contains(relatedreference)) {
              // listen to mouseleave on the tooltip element to be able to hide the tooltip
              _this._tooltipNode.addEventListener(evt.type, callback);
              return true;
            }
            return false;
          });

          // apply user options over default ones
          _options = _objectSpread$2(_objectSpread$2({}, DEFAULT_OPTIONS), _options);
          _reference.jquery && (_reference = _reference[0]);
          this.show = this.show.bind(this);
          this.hide = this.hide.bind(this); // cache reference and options

          this.reference = _reference;
          this.options = _options; // set initial state

          this._isOpen = false;
          this._init();
        } //
        // Public methods
        //

        /**
         * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
         * Tooltips with zero-length titles are never displayed.
         * @method Tooltip#show
         * @memberof Tooltip
         */

        _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Tooltip, [{
          key: "show",
          value: function show() {
            this._show(this.reference, this.options);
          }
          /**
           * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
           * @method Tooltip#hide
           * @memberof Tooltip
           */
        }, {
          key: "hide",
          value: function hide() {
            this._hide();
          }
          /**
           * Hides and destroys an element’s tooltip.
           * @method Tooltip#dispose
           * @memberof Tooltip
           */
        }, {
          key: "dispose",
          value: function dispose() {
            this._dispose();
          }
          /**
           * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
           * @method Tooltip#toggle
           * @memberof Tooltip
           */
        }, {
          key: "toggle",
          value: function toggle() {
            if (this._isOpen) {
              return this.hide();
            } else {
              return this.show();
            }
          }
        }, {
          key: "setClasses",
          value: function setClasses(classes) {
            this._classes = classes;
          }
        }, {
          key: "setContent",
          value: function setContent(content) {
            this.options.title = content;
            if (this._tooltipNode) {
              this._setContent(content, this.options);
            }
          }
        }, {
          key: "setOptions",
          value: function setOptions(options) {
            var classesUpdated = false;
            var classes = options && options.classes || directive.options.defaultClass;
            if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default()(this._classes, classes)) {
              this.setClasses(classes);
              classesUpdated = true;
            }
            options = getOptions(options);
            var needPopperUpdate = false;
            var needRestart = false;
            if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
              needPopperUpdate = true;
            }
            if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
              needRestart = true;
            }
            for (var key in options) {
              this.options[key] = options[key];
            }
            if (this._tooltipNode) {
              if (needRestart) {
                var isOpen = this._isOpen;
                this.dispose();
                this._init();
                if (isOpen) {
                  this.show();
                }
              } else if (needPopperUpdate) {
                this.popperInstance.update();
              }
            }
          } //
          // Private methods
          //
        }, {
          key: "_init",
          value: function _init() {
            // get events list
            var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ') : [];
            this._isDisposed = false;
            this._enableDocumentTouch = events.indexOf('manual') === -1;
            events = events.filter(function (trigger) {
              return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
            }); // set event listeners

            this._setEventListeners(this.reference, events, this.options); // title attribute

            this.$_originalTitle = this.reference.getAttribute('title');
            this.reference.removeAttribute('title');
            this.reference.setAttribute('data-original-title', this.$_originalTitle);
          }
          /**
           * Creates a new tooltip node
           * @memberof Tooltip
           * @private
           * @param {HTMLElement} reference
           * @param {String} template
           * @param {String|HTMLElement|TitleFunction} title
           * @param {Boolean} allowHtml
           * @return {HTMLelement} tooltipNode
           */
        }, {
          key: "_create",
          value: function _create(reference, template) {
            var _this2 = this;

            // create tooltip element
            var tooltipGenerator = window.document.createElement('div');
            tooltipGenerator.innerHTML = template.trim();
            var tooltipNode = tooltipGenerator.childNodes[0]; // add unique ID to our tooltip (needed for accessibility reasons)

            tooltipNode.id = this.options.ariaId || "tooltip_".concat(Math.random().toString(36).substr(2, 10)); // Initially hide the tooltip
            // The attribute will be switched in a next frame so
            // CSS transitions can play

            tooltipNode.setAttribute('aria-hidden', 'true');
            if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
              tooltipNode.addEventListener('mouseenter', function (evt) {
                return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
              });
              tooltipNode.addEventListener('click', function (evt) {
                return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
              });
            } // return the generated tooltip node

            return tooltipNode;
          }
        }, {
          key: "_setContent",
          value: function _setContent(content, options) {
            var _this3 = this;
            this.asyncContent = false;
            this._applyContent(content, options).then(function () {
              if (!_this3.popperInstance) return;
              _this3.popperInstance.update();
            });
          }
        }, {
          key: "_applyContent",
          value: function _applyContent(title, options) {
            var _this4 = this;
            return new Promise(function (resolve, reject) {
              var allowHtml = options.html;
              var rootNode = _this4._tooltipNode;
              if (!rootNode) return;
              var titleNode = rootNode.querySelector(_this4.options.innerSelector);
              if (title.nodeType === 1) {
                // if title is a node, append it only if allowHtml is true
                if (allowHtml) {
                  while (titleNode.firstChild) {
                    titleNode.removeChild(titleNode.firstChild);
                  }
                  titleNode.appendChild(title);
                }
              } else if (typeof title === 'function') {
                // if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
                var result = title();
                if (result && typeof result.then === 'function') {
                  _this4.asyncContent = true;
                  options.loadingClass && addClasses(rootNode, options.loadingClass);
                  if (options.loadingContent) {
                    _this4._applyContent(options.loadingContent, options);
                  }
                  result.then(function (asyncResult) {
                    options.loadingClass && removeClasses(rootNode, options.loadingClass);
                    return _this4._applyContent(asyncResult, options);
                  }).then(resolve).catch(reject);
                } else {
                  _this4._applyContent(result, options).then(resolve).catch(reject);
                }
                return;
              } else {
                // if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
                allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
              }
              resolve();
            });
          }
        }, {
          key: "_show",
          value: function _show(reference, options) {
            if (options && typeof options.container === 'string') {
              var container = document.querySelector(options.container);
              if (!container) return;
            }
            clearTimeout(this._disposeTimer);
            options = Object.assign({}, options);
            delete options.offset;
            var updateClasses = true;
            if (this._tooltipNode) {
              addClasses(this._tooltipNode, this._classes);
              updateClasses = false;
            }
            var result = this._ensureShown(reference, options);
            if (updateClasses && this._tooltipNode) {
              addClasses(this._tooltipNode, this._classes);
            }
            addClasses(reference, ['v-tooltip-open']);
            return result;
          }
        }, {
          key: "_ensureShown",
          value: function _ensureShown(reference, options) {
            var _this5 = this;

            // don't show if it's already visible
            if (this._isOpen) {
              return this;
            }
            this._isOpen = true;
            openTooltips.push(this); // if the tooltipNode already exists, just show it

            if (this._tooltipNode) {
              this._tooltipNode.style.display = '';
              this._tooltipNode.setAttribute('aria-hidden', 'false');
              this.popperInstance.enableEventListeners();
              this.popperInstance.update();
              if (this.asyncContent) {
                this._setContent(options.title, options);
              }
              return this;
            } // get title

            var title = reference.getAttribute('title') || options.title; // don't show tooltip if no title is defined

            if (!title) {
              return this;
            } // create tooltip node

            var tooltipNode = this._create(reference, options.template);
            this._tooltipNode = tooltipNode; // Add `aria-describedby` to our reference element for accessibility reasons

            reference.setAttribute('aria-describedby', tooltipNode.id); // append tooltip to container

            var container = this._findContainer(options.container, reference);
            this._append(tooltipNode, container);
            var popperOptions = _objectSpread$2(_objectSpread$2({}, options.popperOptions), {}, {
              placement: options.placement
            });
            popperOptions.modifiers = _objectSpread$2(_objectSpread$2({}, popperOptions.modifiers), {}, {
              arrow: {
                element: this.options.arrowSelector
              }
            });
            if (options.boundariesElement) {
              popperOptions.modifiers.preventOverflow = {
                boundariesElement: options.boundariesElement
              };
            }
            this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"](reference, tooltipNode, popperOptions);
            this._setContent(title, options); // Fix position

            requestAnimationFrame(function () {
              if (!_this5._isDisposed && _this5.popperInstance) {
                _this5.popperInstance.update(); // Show the tooltip

                requestAnimationFrame(function () {
                  if (!_this5._isDisposed) {
                    _this5._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
                  } else {
                    _this5.dispose();
                  }
                });
              } else {
                _this5.dispose();
              }
            });
            return this;
          }
        }, {
          key: "_noLongerOpen",
          value: function _noLongerOpen() {
            var index = openTooltips.indexOf(this);
            if (index !== -1) {
              openTooltips.splice(index, 1);
            }
          }
        }, {
          key: "_hide",
          value: function _hide() /* reference, options */
          {
            var _this6 = this;

            // don't hide if it's already hidden
            if (!this._isOpen) {
              return this;
            }
            this._isOpen = false;
            this._noLongerOpen(); // hide tooltipNode

            this._tooltipNode.style.display = 'none';
            this._tooltipNode.setAttribute('aria-hidden', 'true');
            if (this.popperInstance) {
              this.popperInstance.disableEventListeners();
            }
            clearTimeout(this._disposeTimer);
            var disposeTime = directive.options.disposeTimeout;
            if (disposeTime !== null) {
              this._disposeTimer = setTimeout(function () {
                if (_this6._tooltipNode) {
                  _this6._tooltipNode.removeEventListener('mouseenter', _this6.hide);
                  _this6._tooltipNode.removeEventListener('click', _this6.hide); // Don't remove popper instance, just the HTML element

                  _this6._removeTooltipNode();
                }
              }, disposeTime);
            }
            removeClasses(this.reference, ['v-tooltip-open']);
            return this;
          }
        }, {
          key: "_removeTooltipNode",
          value: function _removeTooltipNode() {
            if (!this._tooltipNode) return;
            var parentNode = this._tooltipNode.parentNode;
            if (parentNode) {
              parentNode.removeChild(this._tooltipNode);
              this.reference.removeAttribute('aria-describedby');
            }
            this._tooltipNode = null;
          }
        }, {
          key: "_dispose",
          value: function _dispose() {
            var _this7 = this;
            this._isDisposed = true;
            this.reference.removeAttribute('data-original-title');
            if (this.$_originalTitle) {
              this.reference.setAttribute('title', this.$_originalTitle);
            } // remove event listeners first to prevent any unexpected behaviour

            this._events.forEach(function (_ref) {
              var func = _ref.func,
                event = _ref.event;
              _this7.reference.removeEventListener(event, func);
            });
            this._events = [];
            if (this._tooltipNode) {
              this._hide();
              this._tooltipNode.removeEventListener('mouseenter', this.hide);
              this._tooltipNode.removeEventListener('click', this.hide); // destroy instance

              this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

              if (!this.popperInstance.options.removeOnDestroy) {
                this._removeTooltipNode();
              }
            } else {
              this._noLongerOpen();
            }
            return this;
          }
        }, {
          key: "_findContainer",
          value: function _findContainer(container, reference) {
            // if container is a query, get the relative element
            if (typeof container === 'string') {
              container = window.document.querySelector(container);
            } else if (container === false) {
              // if container is `false`, set it to reference parent
              container = reference.parentNode;
            }
            return container;
          }
          /**
           * Append tooltip to container
           * @memberof Tooltip
           * @private
           * @param {HTMLElement} tooltip
           * @param {HTMLElement|String|false} container
           */
        }, {
          key: "_append",
          value: function _append(tooltipNode, container) {
            container.appendChild(tooltipNode);
          }
        }, {
          key: "_setEventListeners",
          value: function _setEventListeners(reference, events, options) {
            var _this8 = this;
            var directEvents = [];
            var oppositeEvents = [];
            events.forEach(function (event) {
              switch (event) {
                case 'hover':
                  directEvents.push('mouseenter');
                  oppositeEvents.push('mouseleave');
                  if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
                  break;
                case 'focus':
                  directEvents.push('focus');
                  oppositeEvents.push('blur');
                  if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
                  break;
                case 'click':
                  directEvents.push('click');
                  oppositeEvents.push('click');
                  break;
              }
            }); // schedule show tooltip

            directEvents.forEach(function (event) {
              var func = function func(evt) {
                if (_this8._isOpen === true) {
                  return;
                }
                evt.usedByTooltip = true;
                _this8._scheduleShow(reference, options.delay, options, evt);
              };
              _this8._events.push({
                event: event,
                func: func
              });
              reference.addEventListener(event, func);
            }); // schedule hide tooltip

            oppositeEvents.forEach(function (event) {
              var func = function func(evt) {
                if (evt.usedByTooltip === true) {
                  return;
                }
                _this8._scheduleHide(reference, options.delay, options, evt);
              };
              _this8._events.push({
                event: event,
                func: func
              });
              reference.addEventListener(event, func);
            });
          }
        }, {
          key: "_onDocumentTouch",
          value: function _onDocumentTouch(event) {
            if (this._enableDocumentTouch) {
              this._scheduleHide(this.reference, this.options.delay, this.options, event);
            }
          }
        }, {
          key: "_scheduleShow",
          value: function _scheduleShow(reference, delay, options
          /*, evt */) {
            var _this9 = this;

            // defaults to 0
            var computedDelay = delay && delay.show || delay || 0;
            clearTimeout(this._scheduleTimer);
            this._scheduleTimer = window.setTimeout(function () {
              return _this9._show(reference, options);
            }, computedDelay);
          }
        }, {
          key: "_scheduleHide",
          value: function _scheduleHide(reference, delay, options, evt) {
            var _this10 = this;

            // defaults to 0
            var computedDelay = delay && delay.hide || delay || 0;
            clearTimeout(this._scheduleTimer);
            this._scheduleTimer = window.setTimeout(function () {
              if (_this10._isOpen === false) {
                return;
              }
              if (!_this10._tooltipNode.ownerDocument.body.contains(_this10._tooltipNode)) {
                return;
              } // if we are hiding because of a mouseleave, we must check that the new
              // reference isn't the tooltip, because in this case we don't want to hide it

              if (evt.type === 'mouseleave') {
                var isSet = _this10._setTooltipNodeEvent(evt, reference, delay, options); // if we set the new event, don't hide the tooltip yet
                // the new event will take care to hide it if necessary

                if (isSet) {
                  return;
                }
              }
              _this10._hide(reference, options);
            }, computedDelay);
          }
        }]);
        return Tooltip;
      }(); // Hide tooltips on touch devices

      if (typeof document !== 'undefined') {
        document.addEventListener('touchstart', function (event) {
          for (var i = 0; i < openTooltips.length; i++) {
            openTooltips[i]._onDocumentTouch(event);
          }
        }, supportsPassive ? {
          passive: true,
          capture: true
        } : true);
      }
      /**
       * Placement function, its context is the Tooltip instance.
       * @memberof Tooltip
       * @callback PlacementFunction
       * @param {HTMLElement} tooltip - tooltip DOM node.
       * @param {HTMLElement} reference - reference DOM node.
       * @return {String} placement - One of the allowed placement options.
       */

      /**
       * Title function, its context is the Tooltip instance.
       * @memberof Tooltip
       * @callback TitleFunction
       * @return {String} placement - The desired title.
       */

      function ownKeys$1(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread$1(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys$1(Object(source), true).forEach(function (key) {
              _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys$1(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      var state = {
        enabled: true
      };
      var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];
      var defaultOptions = {
        // Default tooltip placement relative to target element
        defaultPlacement: 'top',
        // Default CSS classes applied to the tooltip element
        defaultClass: 'vue-tooltip-theme',
        // Default CSS classes applied to the target element of the tooltip
        defaultTargetClass: 'has-tooltip',
        // Is the content HTML by default?
        defaultHtml: true,
        // Default HTML template of the tooltip element
        // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
        // Change if the classes conflict with other libraries (for example bootstrap)
        defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        // Selector used to get the arrow element in the tooltip template
        defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
        // Selector used to get the inner content element in the tooltip template
        defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
        // Delay (ms)
        defaultDelay: 0,
        // Default events that trigger the tooltip
        defaultTrigger: 'hover focus',
        // Default position offset (px)
        defaultOffset: 0,
        // Default container where the tooltip will be appended
        defaultContainer: 'body',
        defaultBoundariesElement: undefined,
        defaultPopperOptions: {},
        // Class added when content is loading
        defaultLoadingClass: 'tooltip-loading',
        // Displayed when tooltip content is loading
        defaultLoadingContent: '...',
        // Hide on mouseover tooltip
        autoHide: true,
        // Close tooltip on click on tooltip target?
        defaultHideOnTargetClick: true,
        // Auto destroy tooltip DOM nodes (ms)
        disposeTimeout: 5000,
        // Options for popover
        popover: {
          defaultPlacement: 'bottom',
          // Use the `popoverClass` prop for theming
          defaultClass: 'vue-popover-theme',
          // Base class (change if conflicts with other libraries)
          defaultBaseClass: 'tooltip popover',
          // Wrapper class (contains arrow and inner)
          defaultWrapperClass: 'wrapper',
          // Inner content class
          defaultInnerClass: 'tooltip-inner popover-inner',
          // Arrow class
          defaultArrowClass: 'tooltip-arrow popover-arrow',
          // Class added when popover is open
          defaultOpenClass: 'open',
          defaultDelay: 0,
          defaultTrigger: 'click',
          defaultOffset: 0,
          defaultContainer: 'body',
          defaultBoundariesElement: undefined,
          defaultPopperOptions: {},
          // Hides if clicked outside of popover
          defaultAutoHide: true,
          // Update popper on content resize
          defaultHandleResize: true
        }
      };
      function getOptions(options) {
        var result = {
          placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
          delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
          html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
          template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
          arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
          innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
          trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
          offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
          container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
          boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
          autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
          hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
          loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
          loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
          popperOptions: _objectSpread$1({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
        };
        if (result.offset) {
          var typeofOffset = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(result.offset);
          var offset = result.offset; // One value -> switch

          if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
            offset = "0, ".concat(offset);
          }
          if (!result.popperOptions.modifiers) {
            result.popperOptions.modifiers = {};
          }
          result.popperOptions.modifiers.offset = {
            offset: offset
          };
        }
        if (result.trigger && result.trigger.indexOf('click') !== -1) {
          result.hideOnTargetClick = false;
        }
        return result;
      }
      function getPlacement(value, modifiers) {
        var placement = value.placement;
        for (var i = 0; i < positions.length; i++) {
          var pos = positions[i];
          if (modifiers[pos]) {
            placement = pos;
          }
        }
        return placement;
      }
      function getContent(value) {
        var type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value);
        if (type === 'string') {
          return value;
        } else if (value && type === 'object') {
          return value.content;
        } else {
          return false;
        }
      }
      function createTooltip(el, value) {
        var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var content = getContent(value);
        var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;
        var opts = _objectSpread$1({
          title: content
        }, getOptions(_objectSpread$1(_objectSpread$1({}, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) === 'object' ? value : {}), {}, {
          placement: getPlacement(value, modifiers)
        })));
        var tooltip = el._tooltip = new Tooltip(el, opts);
        tooltip.setClasses(classes);
        tooltip._vueEl = el; // Class on target

        var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
        el._tooltipTargetClasses = targetClasses;
        addClasses(el, targetClasses);
        return tooltip;
      }
      function destroyTooltip(el) {
        if (el._tooltip) {
          el._tooltip.dispose();
          delete el._tooltip;
          delete el._tooltipOldShow;
        }
        if (el._tooltipTargetClasses) {
          removeClasses(el, el._tooltipTargetClasses);
          delete el._tooltipTargetClasses;
        }
      }
      function bind(el, _ref) {
        var value = _ref.value;
        _ref.oldValue;
        var modifiers = _ref.modifiers;
        var content = getContent(value);
        if (!content || !state.enabled) {
          destroyTooltip(el);
        } else {
          var tooltip;
          if (el._tooltip) {
            tooltip = el._tooltip; // Content

            tooltip.setContent(content); // Options

            tooltip.setOptions(_objectSpread$1(_objectSpread$1({}, value), {}, {
              placement: getPlacement(value, modifiers)
            }));
          } else {
            tooltip = createTooltip(el, value, modifiers);
          } // Manual show

          if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
            el._tooltipOldShow = value.show;
            value.show ? tooltip.show() : tooltip.hide();
          }
        }
      }
      var directive = {
        options: defaultOptions,
        bind: bind,
        update: bind,
        unbind: function unbind(el) {
          destroyTooltip(el);
        }
      };
      function addListeners(el) {
        el.addEventListener('click', onClick);
        el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
          passive: true
        } : false);
      }
      function removeListeners(el) {
        el.removeEventListener('click', onClick);
        el.removeEventListener('touchstart', onTouchStart);
        el.removeEventListener('touchend', onTouchEnd);
        el.removeEventListener('touchcancel', onTouchCancel);
      }
      function onClick(event) {
        var el = event.currentTarget;
        event.closePopover = !el.$_vclosepopover_touch;
        event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
      }
      function onTouchStart(event) {
        if (event.changedTouches.length === 1) {
          var el = event.currentTarget;
          el.$_vclosepopover_touch = true;
          var touch = event.changedTouches[0];
          el.$_vclosepopover_touchPoint = touch;
          el.addEventListener('touchend', onTouchEnd);
          el.addEventListener('touchcancel', onTouchCancel);
        }
      }
      function onTouchEnd(event) {
        var el = event.currentTarget;
        el.$_vclosepopover_touch = false;
        if (event.changedTouches.length === 1) {
          var touch = event.changedTouches[0];
          var firstTouch = el.$_vclosepopover_touchPoint;
          event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
          event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
        }
      }
      function onTouchCancel(event) {
        var el = event.currentTarget;
        el.$_vclosepopover_touch = false;
      }
      var vclosepopover = {
        bind: function bind(el, _ref) {
          var value = _ref.value,
            modifiers = _ref.modifiers;
          el.$_closePopoverModifiers = modifiers;
          if (typeof value === 'undefined' || value) {
            addListeners(el);
          }
        },
        update: function update(el, _ref2) {
          var value = _ref2.value,
            oldValue = _ref2.oldValue,
            modifiers = _ref2.modifiers;
          el.$_closePopoverModifiers = modifiers;
          if (value !== oldValue) {
            if (typeof value === 'undefined' || value) {
              addListeners(el);
            } else {
              removeListeners(el);
            }
          }
        },
        unbind: function unbind(el) {
          removeListeners(el);
        }
      };
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
              _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      function getDefault(key) {
        var value = directive.options.popover[key];
        if (typeof value === 'undefined') {
          return directive.options[key];
        }
        return value;
      }
      var isIOS = false;
      if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
        isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      }
      var openPopovers = [];
      var Element = function Element() {};
      if (typeof window !== 'undefined') {
        Element = window.Element;
      }
      var script = {
        name: 'VPopover',
        components: {
          ResizeObserver: vue_resize__WEBPACK_IMPORTED_MODULE_6__[/* ResizeObserver */"a"]
        },
        props: {
          open: {
            type: Boolean,
            default: false
          },
          disabled: {
            type: Boolean,
            default: false
          },
          placement: {
            type: String,
            default: function _default() {
              return getDefault('defaultPlacement');
            }
          },
          delay: {
            type: [String, Number, Object],
            default: function _default() {
              return getDefault('defaultDelay');
            }
          },
          offset: {
            type: [String, Number],
            default: function _default() {
              return getDefault('defaultOffset');
            }
          },
          trigger: {
            type: String,
            default: function _default() {
              return getDefault('defaultTrigger');
            }
          },
          container: {
            type: [String, Object, Element, Boolean],
            default: function _default() {
              return getDefault('defaultContainer');
            }
          },
          boundariesElement: {
            type: [String, Element],
            default: function _default() {
              return getDefault('defaultBoundariesElement');
            }
          },
          popperOptions: {
            type: Object,
            default: function _default() {
              return getDefault('defaultPopperOptions');
            }
          },
          popoverClass: {
            type: [String, Array],
            default: function _default() {
              return getDefault('defaultClass');
            }
          },
          popoverBaseClass: {
            type: [String, Array],
            default: function _default() {
              return directive.options.popover.defaultBaseClass;
            }
          },
          popoverInnerClass: {
            type: [String, Array],
            default: function _default() {
              return directive.options.popover.defaultInnerClass;
            }
          },
          popoverWrapperClass: {
            type: [String, Array],
            default: function _default() {
              return directive.options.popover.defaultWrapperClass;
            }
          },
          popoverArrowClass: {
            type: [String, Array],
            default: function _default() {
              return directive.options.popover.defaultArrowClass;
            }
          },
          autoHide: {
            type: Boolean,
            default: function _default() {
              return directive.options.popover.defaultAutoHide;
            }
          },
          handleResize: {
            type: Boolean,
            default: function _default() {
              return directive.options.popover.defaultHandleResize;
            }
          },
          openGroup: {
            type: String,
            default: null
          },
          openClass: {
            type: [String, Array],
            default: function _default() {
              return directive.options.popover.defaultOpenClass;
            }
          },
          ariaId: {
            default: null
          }
        },
        data: function data() {
          return {
            isOpen: false,
            id: Math.random().toString(36).substr(2, 10)
          };
        },
        computed: {
          cssClass: function cssClass() {
            return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, this.openClass, this.isOpen);
          },
          popoverId: function popoverId() {
            return "popover_".concat(this.ariaId != null ? this.ariaId : this.id);
          }
        },
        watch: {
          open: function open(val) {
            if (val) {
              this.show();
            } else {
              this.hide();
            }
          },
          disabled: function disabled(val, oldVal) {
            if (val !== oldVal) {
              if (val) {
                this.hide();
              } else if (this.open) {
                this.show();
              }
            }
          },
          container: function container(val) {
            if (this.isOpen && this.popperInstance) {
              var popoverNode = this.$refs.popover;
              var reference = this.$refs.trigger;
              var container = this.$_findContainer(this.container, reference);
              if (!container) {
                console.warn('No container for popover', this);
                return;
              }
              container.appendChild(popoverNode);
              this.popperInstance.scheduleUpdate();
            }
          },
          trigger: function trigger(val) {
            this.$_removeEventListeners();
            this.$_addEventListeners();
          },
          placement: function placement(val) {
            var _this = this;
            this.$_updatePopper(function () {
              _this.popperInstance.options.placement = val;
            });
          },
          offset: '$_restartPopper',
          boundariesElement: '$_restartPopper',
          popperOptions: {
            handler: '$_restartPopper',
            deep: true
          }
        },
        created: function created() {
          this.$_isDisposed = false;
          this.$_mounted = false;
          this.$_events = [];
          this.$_preventOpen = false;
        },
        mounted: function mounted() {
          var popoverNode = this.$refs.popover;
          popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
          this.$_init();
          if (this.open) {
            this.show();
          }
        },
        deactivated: function deactivated() {
          this.hide();
        },
        beforeDestroy: function beforeDestroy() {
          this.dispose();
        },
        methods: {
          show: function show() {
            var _this2 = this;
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              event = _ref2.event;
            _ref2.skipDelay;
            var _ref2$force = _ref2.force,
              force = _ref2$force === void 0 ? false : _ref2$force;
            if (force || !this.disabled) {
              this.$_scheduleShow(event);
              this.$emit('show');
            }
            this.$emit('update:open', true);
            this.$_beingShowed = true;
            requestAnimationFrame(function () {
              _this2.$_beingShowed = false;
            });
          },
          hide: function hide() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              event = _ref3.event;
            _ref3.skipDelay;
            this.$_scheduleHide(event);
            this.$emit('hide');
            this.$emit('update:open', false);
          },
          dispose: function dispose() {
            this.$_isDisposed = true;
            this.$_removeEventListeners();
            this.hide({
              skipDelay: true
            });
            if (this.popperInstance) {
              this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

              if (!this.popperInstance.options.removeOnDestroy) {
                var popoverNode = this.$refs.popover;
                popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
              }
            }
            this.$_mounted = false;
            this.popperInstance = null;
            this.isOpen = false;
            this.$emit('dispose');
          },
          $_init: function $_init() {
            if (this.trigger.indexOf('manual') === -1) {
              this.$_addEventListeners();
            }
          },
          $_show: function $_show() {
            var _this3 = this;
            var reference = this.$refs.trigger;
            var popoverNode = this.$refs.popover;
            clearTimeout(this.$_disposeTimer); // Already open

            if (this.isOpen) {
              return;
            } // Popper is already initialized

            if (this.popperInstance) {
              this.isOpen = true;
              this.popperInstance.enableEventListeners();
              this.popperInstance.scheduleUpdate();
            }
            if (!this.$_mounted) {
              var container = this.$_findContainer(this.container, reference);
              if (!container) {
                console.warn('No container for popover', this);
                return;
              }
              container.appendChild(popoverNode);
              this.$_mounted = true;
              this.isOpen = false;
              if (this.popperInstance) {
                requestAnimationFrame(function () {
                  if (!_this3.hidden) {
                    _this3.isOpen = true;
                  }
                });
              }
            }
            if (!this.popperInstance) {
              var popperOptions = _objectSpread(_objectSpread({}, this.popperOptions), {}, {
                placement: this.placement
              });
              popperOptions.modifiers = _objectSpread(_objectSpread({}, popperOptions.modifiers), {}, {
                arrow: _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.arrow), {}, {
                  element: this.$refs.arrow
                })
              });
              if (this.offset) {
                var offset = this.$_getOffset();
                popperOptions.modifiers.offset = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.offset), {}, {
                  offset: offset
                });
              }
              if (this.boundariesElement) {
                popperOptions.modifiers.preventOverflow = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow), {}, {
                  boundariesElement: this.boundariesElement
                });
              }
              this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"](reference, popoverNode, popperOptions); // Fix position

              requestAnimationFrame(function () {
                if (_this3.hidden) {
                  _this3.hidden = false;
                  _this3.$_hide();
                  return;
                }
                if (!_this3.$_isDisposed && _this3.popperInstance) {
                  _this3.popperInstance.scheduleUpdate(); // Show the tooltip

                  requestAnimationFrame(function () {
                    if (_this3.hidden) {
                      _this3.hidden = false;
                      _this3.$_hide();
                      return;
                    }
                    if (!_this3.$_isDisposed) {
                      _this3.isOpen = true;
                    } else {
                      _this3.dispose();
                    }
                  });
                } else {
                  _this3.dispose();
                }
              });
            }
            var openGroup = this.openGroup;
            if (openGroup) {
              var popover;
              for (var i = 0; i < openPopovers.length; i++) {
                popover = openPopovers[i];
                if (popover.openGroup !== openGroup) {
                  popover.hide();
                  popover.$emit('close-group');
                }
              }
            }
            openPopovers.push(this);
            this.$emit('apply-show');
          },
          $_hide: function $_hide() {
            var _this4 = this;

            // Already hidden
            if (!this.isOpen) {
              return;
            }
            var index = openPopovers.indexOf(this);
            if (index !== -1) {
              openPopovers.splice(index, 1);
            }
            this.isOpen = false;
            if (this.popperInstance) {
              this.popperInstance.disableEventListeners();
            }
            clearTimeout(this.$_disposeTimer);
            var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;
            if (disposeTime !== null) {
              this.$_disposeTimer = setTimeout(function () {
                var popoverNode = _this4.$refs.popover;
                if (popoverNode) {
                  // Don't remove popper instance, just the HTML element
                  popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
                  _this4.$_mounted = false;
                }
              }, disposeTime);
            }
            this.$emit('apply-hide');
          },
          $_findContainer: function $_findContainer(container, reference) {
            // if container is a query, get the relative element
            if (typeof container === 'string') {
              container = window.document.querySelector(container);
            } else if (container === false) {
              // if container is `false`, set it to reference parent
              container = reference.parentNode;
            }
            return container;
          },
          $_getOffset: function $_getOffset() {
            var typeofOffset = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(this.offset);
            var offset = this.offset; // One value -> switch

            if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
              offset = "0, ".concat(offset);
            }
            return offset;
          },
          $_addEventListeners: function $_addEventListeners() {
            var _this5 = this;
            var reference = this.$refs.trigger;
            var directEvents = [];
            var oppositeEvents = [];
            var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
              return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
            }) : [];
            events.forEach(function (event) {
              switch (event) {
                case 'hover':
                  directEvents.push('mouseenter');
                  oppositeEvents.push('mouseleave');
                  break;
                case 'focus':
                  directEvents.push('focus');
                  oppositeEvents.push('blur');
                  break;
                case 'click':
                  directEvents.push('click');
                  oppositeEvents.push('click');
                  break;
              }
            }); // schedule show tooltip

            directEvents.forEach(function (event) {
              var func = function func(event) {
                if (_this5.isOpen) {
                  return;
                }
                event.usedByTooltip = true;
                !_this5.$_preventOpen && _this5.show({
                  event: event
                });
                _this5.hidden = false;
              };
              _this5.$_events.push({
                event: event,
                func: func
              });
              reference.addEventListener(event, func);
            }); // schedule hide tooltip

            oppositeEvents.forEach(function (event) {
              var func = function func(event) {
                if (event.usedByTooltip) {
                  return;
                }
                _this5.hide({
                  event: event
                });
                _this5.hidden = true;
              };
              _this5.$_events.push({
                event: event,
                func: func
              });
              reference.addEventListener(event, func);
            });
          },
          $_scheduleShow: function $_scheduleShow() {
            var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            clearTimeout(this.$_scheduleTimer);
            if (skipDelay) {
              this.$_show();
            } else {
              // defaults to 0
              var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
              this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
            }
          },
          $_scheduleHide: function $_scheduleHide() {
            var _this6 = this;
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            clearTimeout(this.$_scheduleTimer);
            if (skipDelay) {
              this.$_hide();
            } else {
              // defaults to 0
              var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
              this.$_scheduleTimer = setTimeout(function () {
                if (!_this6.isOpen) {
                  return;
                } // if we are hiding because of a mouseleave, we must check that the new
                // reference isn't the tooltip, because in this case we don't want to hide it

                if (event && event.type === 'mouseleave') {
                  var isSet = _this6.$_setTooltipNodeEvent(event); // if we set the new event, don't hide the tooltip yet
                  // the new event will take care to hide it if necessary

                  if (isSet) {
                    return;
                  }
                }
                _this6.$_hide();
              }, computedDelay);
            }
          },
          $_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
            var _this7 = this;
            var reference = this.$refs.trigger;
            var popoverNode = this.$refs.popover;
            var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;
            var callback = function callback(event2) {
              var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget; // Remove event listener after call

              popoverNode.removeEventListener(event.type, callback); // If the new reference is not the reference element

              if (!reference.contains(relatedreference2)) {
                // Schedule to hide tooltip
                _this7.hide({
                  event: event2
                });
              }
            };
            if (popoverNode.contains(relatedreference)) {
              // listen to mouseleave on the tooltip element to be able to hide the tooltip
              popoverNode.addEventListener(event.type, callback);
              return true;
            }
            return false;
          },
          $_removeEventListeners: function $_removeEventListeners() {
            var reference = this.$refs.trigger;
            this.$_events.forEach(function (_ref4) {
              var func = _ref4.func,
                event = _ref4.event;
              reference.removeEventListener(event, func);
            });
            this.$_events = [];
          },
          $_updatePopper: function $_updatePopper(cb) {
            if (this.popperInstance) {
              cb();
              if (this.isOpen) this.popperInstance.scheduleUpdate();
            }
          },
          $_restartPopper: function $_restartPopper() {
            if (this.popperInstance) {
              var isOpen = this.isOpen;
              this.dispose();
              this.$_isDisposed = false;
              this.$_init();
              if (isOpen) {
                this.show({
                  skipDelay: true,
                  force: true
                });
              }
            }
          },
          $_handleGlobalClose: function $_handleGlobalClose(event) {
            var _this8 = this;
            var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (this.$_beingShowed) return;
            this.hide({
              event: event
            });
            if (event.closePopover) {
              this.$emit('close-directive');
            } else {
              this.$emit('auto-hide');
            }
            if (touch) {
              this.$_preventOpen = true;
              setTimeout(function () {
                _this8.$_preventOpen = false;
              }, 300);
            }
          },
          $_handleResize: function $_handleResize() {
            if (this.isOpen && this.popperInstance) {
              this.popperInstance.scheduleUpdate();
              this.$emit('resize');
            }
          }
        }
      };
      if (typeof document !== 'undefined' && typeof window !== 'undefined') {
        if (isIOS) {
          document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
            passive: true,
            capture: true
          } : true);
        } else {
          window.addEventListener('click', handleGlobalClick, true);
        }
      }
      function handleGlobalClick(event) {
        handleGlobalClose(event);
      }
      function handleGlobalTouchend(event) {
        handleGlobalClose(event, true);
      }
      function handleGlobalClose(event) {
        var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _loop = function _loop(i) {
          var popover = openPopovers[i];
          if (popover.$refs.popover) {
            var contains = popover.$refs.popover.contains(event.target);
            requestAnimationFrame(function () {
              if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
                popover.$_handleGlobalClose(event, touch);
              }
            });
          }
        };

        // Delay so that close directive has time to set values
        for (var i = 0; i < openPopovers.length; i++) {
          _loop(i);
        }
      }
      function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
        if (typeof shadowMode !== 'boolean') {
          createInjectorSSR = createInjector;
          createInjector = shadowMode;
          shadowMode = false;
        }
        // Vue.extend constructor export interop.
        const options = typeof script === 'function' ? script.options : script;
        // render functions
        if (template && template.render) {
          options.render = template.render;
          options.staticRenderFns = template.staticRenderFns;
          options._compiled = true;
          // functional template
          if (isFunctionalTemplate) {
            options.functional = true;
          }
        }
        // scopedId
        if (scopeId) {
          options._scopeId = scopeId;
        }
        let hook;
        if (moduleIdentifier) {
          // server build
          hook = function (context) {
            // 2.3 injection
            context = context ||
            // cached call
            this.$vnode && this.$vnode.ssrContext ||
            // stateful
            this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
              context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
              style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
              context._registeredComponents.add(moduleIdentifier);
            }
          };
          // used by ssr in case component is cached and beforeCreate
          // never gets called
          options._ssrRegister = hook;
        } else if (style) {
          hook = shadowMode ? function (context) {
            style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
          } : function (context) {
            style.call(this, createInjector(context));
          };
        }
        if (hook) {
          if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
              hook.call(context);
              return originalRender(h, context);
            };
          } else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
          }
        }
        return script;
      }

      /* script */
      var __vue_script__ = script;
      /* template */

      var __vue_render__ = function __vue_render__() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("div", {
          staticClass: "v-popover",
          class: _vm.cssClass
        }, [_c("div", {
          ref: "trigger",
          staticClass: "trigger",
          staticStyle: {
            display: "inline-block"
          },
          attrs: {
            "aria-describedby": _vm.isOpen ? _vm.popoverId : undefined,
            tabindex: _vm.trigger.indexOf("focus") !== -1 ? 0 : undefined
          }
        }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
          ref: "popover",
          class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass],
          style: {
            visibility: _vm.isOpen ? "visible" : "hidden"
          },
          attrs: {
            id: _vm.popoverId,
            "aria-hidden": _vm.isOpen ? "false" : "true",
            tabindex: _vm.autoHide ? 0 : undefined
          },
          on: {
            keyup: function keyup($event) {
              if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
                return null;
              }
              _vm.autoHide && _vm.hide();
            }
          }
        }, [_c("div", {
          class: _vm.popoverWrapperClass
        }, [_c("div", {
          ref: "inner",
          class: _vm.popoverInnerClass,
          staticStyle: {
            position: "relative"
          }
        }, [_c("div", [_vm._t("popover", null, {
          isOpen: _vm.isOpen
        })], 2), _vm._v(" "), _vm.handleResize ? _c("ResizeObserver", {
          on: {
            notify: _vm.$_handleResize
          }
        }) : _vm._e()], 1), _vm._v(" "), _c("div", {
          ref: "arrow",
          class: _vm.popoverArrowClass
        })])])]);
      };
      var __vue_staticRenderFns__ = [];
      __vue_render__._withStripped = true;
      /* style */

      var __vue_inject_styles__ = undefined;
      /* scoped */

      var __vue_scope_id__ = undefined;
      /* module identifier */

      var __vue_module_identifier__ = undefined;
      /* functional template */

      var __vue_is_functional_template__ = false;
      /* style inject */

      /* style inject SSR */

      /* style inject shadow dom */

      var __vue_component__ = /*#__PURE__*/normalizeComponent({
        render: __vue_render__,
        staticRenderFns: __vue_staticRenderFns__
      }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
      function styleInject(css, ref) {
        if (ref === void 0) ref = {};
        var insertAt = ref.insertAt;
        if (!css || typeof document === 'undefined') {
          return;
        }
        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        style.type = 'text/css';
        if (insertAt === 'top') {
          if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
          } else {
            head.appendChild(style);
          }
        } else {
          head.appendChild(style);
        }
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
      }
      var css_248z = ".resize-observer[data-v-8859cc6c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-8859cc6c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
      styleInject(css_248z);
      function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (install.installed) return;
        install.installed = true;
        var finalOptions = {};
        lodash_merge__WEBPACK_IMPORTED_MODULE_7___default()(finalOptions, defaultOptions, options);
        plugin.options = finalOptions;
        directive.options = finalOptions;
        Vue.directive('tooltip', directive);
        Vue.directive('close-popover', vclosepopover);
        Vue.component('VPopover', __vue_component__);
      }
      var VTooltip = directive;
      var VClosePopover = vclosepopover;
      var VPopover = __vue_component__;
      var plugin = {
        install: install,
        get enabled() {
          return state.enabled;
        },
        set enabled(value) {
          state.enabled = value;
        }
      }; // Auto-install

      var GlobalVue = null;
      if (typeof window !== 'undefined') {
        GlobalVue = window.Vue;
      } else if (typeof global !== 'undefined') {
        GlobalVue = global.Vue;
      }
      if (GlobalVue) {
        GlobalVue.use(plugin);
      }

      /* unused harmony default export */
      var _unused_webpack_default_export = plugin;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("c8ba"));

    /***/
  },

  /***/"e50d": /***/function (module, exports, __webpack_require__) {
    var _typeof = __webpack_require__("7037")["default"];
    function _toPrimitive(input, hint) {
      if (_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

    /***/
  },

  /***/"e538": /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (module) {
      var root = __webpack_require__("2b3e");

      /** Detect free variable `exports`. */
      var freeExports = true && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Built-in value references. */
      var Buffer = moduleExports ? root.Buffer : undefined,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

      /**
       * Creates a clone of  `buffer`.
       *
       * @private
       * @param {Buffer} buffer The buffer to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Buffer} Returns the cloned buffer.
       */
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
      }
      module.exports = cloneBuffer;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("62e4")(module));

    /***/
  },

  /***/"e607": /***/function (module, exports, __webpack_require__) {

    // extracted by mini-css-extract-plugin

    /***/},
  /***/"eac5": /***/function (module, exports) {
    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
      return value === proto;
    }
    module.exports = isPrototype;

    /***/
  },

  /***/"ec69": /***/function (module, exports, __webpack_require__) {
    var arrayLikeKeys = __webpack_require__("6fcd"),
      baseKeys = __webpack_require__("03dd"),
      isArrayLike = __webpack_require__("30c9");

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    module.exports = keys;

    /***/
  },

  /***/"ec8c": /***/function (module, exports) {
    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = nativeKeysIn;

    /***/
  },

  /***/"edfa": /***/function (module, exports) {
    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    module.exports = mapToArray;

    /***/
  },

  /***/"efb6": /***/function (module, exports, __webpack_require__) {
    var ListCache = __webpack_require__("5e2e");

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module.exports = stackClear;

    /***/
  },

  /***/"f0bd": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* WEBPACK VAR INJECTION */
    (function (global) {
      /**!
      * @fileOverview Kickass library to create and place poppers near their reference elements.
      * @version 1.16.1
      * @license
      * Copyright (c) 2016 Federico Zivolo and contributors
      *
      * Permission is hereby granted, free of charge, to any person obtaining a copy
      * of this software and associated documentation files (the "Software"), to deal
      * in the Software without restriction, including without limitation the rights
      * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      * copies of the Software, and to permit persons to whom the Software is
      * furnished to do so, subject to the following conditions:
      *
      * The above copyright notice and this permission notice shall be included in all
      * copies or substantial portions of the Software.
      *
      * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
      * SOFTWARE.
      */
      var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
      var timeoutDuration = function () {
        var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
        for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
          if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
            return 1;
          }
        }
        return 0;
      }();
      function microtaskDebounce(fn) {
        var called = false;
        return function () {
          if (called) {
            return;
          }
          called = true;
          window.Promise.resolve().then(function () {
            called = false;
            fn();
          });
        };
      }
      function taskDebounce(fn) {
        var scheduled = false;
        return function () {
          if (!scheduled) {
            scheduled = true;
            setTimeout(function () {
              scheduled = false;
              fn();
            }, timeoutDuration);
          }
        };
      }
      var supportsMicroTasks = isBrowser && window.Promise;

      /**
      * Create a debounced version of a method, that's asynchronously deferred
      * but called in the minimum time possible.
      *
      * @method
      * @memberof Popper.Utils
      * @argument {Function} fn
      * @returns {Function}
      */
      var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

      /**
       * Check if the given variable is a function
       * @method
       * @memberof Popper.Utils
       * @argument {Any} functionToCheck - variable to check
       * @returns {Boolean} answer to: is a function?
       */
      function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
      }

      /**
       * Get CSS computed property of the given element
       * @method
       * @memberof Popper.Utils
       * @argument {Eement} element
       * @argument {String} property
       */
      function getStyleComputedProperty(element, property) {
        if (element.nodeType !== 1) {
          return [];
        }
        // NOTE: 1 DOM access here
        var window = element.ownerDocument.defaultView;
        var css = window.getComputedStyle(element, null);
        return property ? css[property] : css;
      }

      /**
       * Returns the parentNode or the host of the element
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element
       * @returns {Element} parent
       */
      function getParentNode(element) {
        if (element.nodeName === 'HTML') {
          return element;
        }
        return element.parentNode || element.host;
      }

      /**
       * Returns the scrolling parent of the given element
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element
       * @returns {Element} scroll parent
       */
      function getScrollParent(element) {
        // Return body, `getScroll` will take care to get the correct `scrollTop` from it
        if (!element) {
          return document.body;
        }
        switch (element.nodeName) {
          case 'HTML':
          case 'BODY':
            return element.ownerDocument.body;
          case '#document':
            return element.body;
        }

        // Firefox want us to check `-x` and `-y` variations as well

        var _getStyleComputedProp = getStyleComputedProperty(element),
          overflow = _getStyleComputedProp.overflow,
          overflowX = _getStyleComputedProp.overflowX,
          overflowY = _getStyleComputedProp.overflowY;
        if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
          return element;
        }
        return getScrollParent(getParentNode(element));
      }

      /**
       * Returns the reference node of the reference object, or the reference object itself.
       * @method
       * @memberof Popper.Utils
       * @param {Element|Object} reference - the reference element (the popper will be relative to this)
       * @returns {Element} parent
       */
      function getReferenceNode(reference) {
        return reference && reference.referenceNode ? reference.referenceNode : reference;
      }
      var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
      var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

      /**
       * Determines if the browser is Internet Explorer
       * @method
       * @memberof Popper.Utils
       * @param {Number} version to check
       * @returns {Boolean} isIE
       */
      function isIE(version) {
        if (version === 11) {
          return isIE11;
        }
        if (version === 10) {
          return isIE10;
        }
        return isIE11 || isIE10;
      }

      /**
       * Returns the offset parent of the given element
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element
       * @returns {Element} offset parent
       */
      function getOffsetParent(element) {
        if (!element) {
          return document.documentElement;
        }
        var noOffsetParent = isIE(10) ? document.body : null;

        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent || null;
        // Skip hidden elements which don't have an offsetParent
        while (offsetParent === noOffsetParent && element.nextElementSibling) {
          offsetParent = (element = element.nextElementSibling).offsetParent;
        }
        var nodeName = offsetParent && offsetParent.nodeName;
        if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
          return element ? element.ownerDocument.documentElement : document.documentElement;
        }

        // .offsetParent will return the closest TH, TD or TABLE in case
        // no offsetParent is present, I hate this job...
        if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
          return getOffsetParent(offsetParent);
        }
        return offsetParent;
      }
      function isOffsetContainer(element) {
        var nodeName = element.nodeName;
        if (nodeName === 'BODY') {
          return false;
        }
        return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
      }

      /**
       * Finds the root node (document, shadowDOM root) of the given element
       * @method
       * @memberof Popper.Utils
       * @argument {Element} node
       * @returns {Element} root node
       */
      function getRoot(node) {
        if (node.parentNode !== null) {
          return getRoot(node.parentNode);
        }
        return node;
      }

      /**
       * Finds the offset parent common to the two provided nodes
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element1
       * @argument {Element} element2
       * @returns {Element} common offset parent
       */
      function findCommonOffsetParent(element1, element2) {
        // This check is needed to avoid errors in case one of the elements isn't defined for any reason
        if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
          return document.documentElement;
        }

        // Here we make sure to give as "start" the element that comes first in the DOM
        var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
        var start = order ? element1 : element2;
        var end = order ? element2 : element1;

        // Get common ancestor container
        var range = document.createRange();
        range.setStart(start, 0);
        range.setEnd(end, 0);
        var commonAncestorContainer = range.commonAncestorContainer;

        // Both nodes are inside #document

        if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
          if (isOffsetContainer(commonAncestorContainer)) {
            return commonAncestorContainer;
          }
          return getOffsetParent(commonAncestorContainer);
        }

        // one of the nodes is inside shadowDOM, find which one
        var element1root = getRoot(element1);
        if (element1root.host) {
          return findCommonOffsetParent(element1root.host, element2);
        } else {
          return findCommonOffsetParent(element1, getRoot(element2).host);
        }
      }

      /**
       * Gets the scroll value of the given element in the given side (top and left)
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element
       * @argument {String} side `top` or `left`
       * @returns {number} amount of scrolled pixels
       */
      function getScroll(element) {
        var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
        var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
        var nodeName = element.nodeName;
        if (nodeName === 'BODY' || nodeName === 'HTML') {
          var html = element.ownerDocument.documentElement;
          var scrollingElement = element.ownerDocument.scrollingElement || html;
          return scrollingElement[upperSide];
        }
        return element[upperSide];
      }

      /*
       * Sum or subtract the element scroll values (left and top) from a given rect object
       * @method
       * @memberof Popper.Utils
       * @param {Object} rect - Rect object you want to change
       * @param {HTMLElement} element - The element from the function reads the scroll values
       * @param {Boolean} subtract - set to true if you want to subtract the scroll values
       * @return {Object} rect - The modifier rect object
       */
      function includeScroll(rect, element) {
        var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var scrollTop = getScroll(element, 'top');
        var scrollLeft = getScroll(element, 'left');
        var modifier = subtract ? -1 : 1;
        rect.top += scrollTop * modifier;
        rect.bottom += scrollTop * modifier;
        rect.left += scrollLeft * modifier;
        rect.right += scrollLeft * modifier;
        return rect;
      }

      /*
       * Helper to detect borders of a given element
       * @method
       * @memberof Popper.Utils
       * @param {CSSStyleDeclaration} styles
       * Result of `getStyleComputedProperty` on the given element
       * @param {String} axis - `x` or `y`
       * @return {number} borders - The borders size of the given axis
       */

      function getBordersSize(styles, axis) {
        var sideA = axis === 'x' ? 'Left' : 'Top';
        var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
        return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
      }
      function getSize(axis, body, html, computedStyle) {
        return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
      }
      function getWindowSizes(document) {
        var body = document.body;
        var html = document.documentElement;
        var computedStyle = isIE(10) && getComputedStyle(html);
        return {
          height: getSize('Height', body, html, computedStyle),
          width: getSize('Width', body, html, computedStyle)
        };
      }
      var classCallCheck = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };
      var createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();
      var defineProperty = function (obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      };
      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };

      /**
       * Given element offsets, generate an output similar to getBoundingClientRect
       * @method
       * @memberof Popper.Utils
       * @argument {Object} offsets
       * @returns {Object} ClientRect like output
       */
      function getClientRect(offsets) {
        return _extends({}, offsets, {
          right: offsets.left + offsets.width,
          bottom: offsets.top + offsets.height
        });
      }

      /**
       * Get bounding client rect of given element
       * @method
       * @memberof Popper.Utils
       * @param {HTMLElement} element
       * @return {Object} client rect
       */
      function getBoundingClientRect(element) {
        var rect = {};

        // IE10 10 FIX: Please, don't ask, the element isn't
        // considered in DOM in some circumstances...
        // This isn't reproducible in IE10 compatibility mode of IE11
        try {
          if (isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = getScroll(element, 'top');
            var scrollLeft = getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
          } else {
            rect = element.getBoundingClientRect();
          }
        } catch (e) {}
        var result = {
          left: rect.left,
          top: rect.top,
          width: rect.right - rect.left,
          height: rect.bottom - rect.top
        };

        // subtract scrollbar size from sizes
        var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
        var width = sizes.width || element.clientWidth || result.width;
        var height = sizes.height || element.clientHeight || result.height;
        var horizScrollbar = element.offsetWidth - width;
        var vertScrollbar = element.offsetHeight - height;

        // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
        // we make this check conditional for performance reasons
        if (horizScrollbar || vertScrollbar) {
          var styles = getStyleComputedProperty(element);
          horizScrollbar -= getBordersSize(styles, 'x');
          vertScrollbar -= getBordersSize(styles, 'y');
          result.width -= horizScrollbar;
          result.height -= vertScrollbar;
        }
        return getClientRect(result);
      }
      function getOffsetRectRelativeToArbitraryNode(children, parent) {
        var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isIE10 = isIE(10);
        var isHTML = parent.nodeName === 'HTML';
        var childrenRect = getBoundingClientRect(children);
        var parentRect = getBoundingClientRect(parent);
        var scrollParent = getScrollParent(children);
        var styles = getStyleComputedProperty(parent);
        var borderTopWidth = parseFloat(styles.borderTopWidth);
        var borderLeftWidth = parseFloat(styles.borderLeftWidth);

        // In cases where the parent is fixed, we must ignore negative scroll in offset calc
        if (fixedPosition && isHTML) {
          parentRect.top = Math.max(parentRect.top, 0);
          parentRect.left = Math.max(parentRect.left, 0);
        }
        var offsets = getClientRect({
          top: childrenRect.top - parentRect.top - borderTopWidth,
          left: childrenRect.left - parentRect.left - borderLeftWidth,
          width: childrenRect.width,
          height: childrenRect.height
        });
        offsets.marginTop = 0;
        offsets.marginLeft = 0;

        // Subtract margins of documentElement in case it's being used as parent
        // we do this only on HTML because it's the only element that behaves
        // differently when margins are applied to it. The margins are included in
        // the box of the documentElement, in the other cases not.
        if (!isIE10 && isHTML) {
          var marginTop = parseFloat(styles.marginTop);
          var marginLeft = parseFloat(styles.marginLeft);
          offsets.top -= borderTopWidth - marginTop;
          offsets.bottom -= borderTopWidth - marginTop;
          offsets.left -= borderLeftWidth - marginLeft;
          offsets.right -= borderLeftWidth - marginLeft;

          // Attach marginTop and marginLeft because in some circumstances we may need them
          offsets.marginTop = marginTop;
          offsets.marginLeft = marginLeft;
        }
        if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
          offsets = includeScroll(offsets, parent);
        }
        return offsets;
      }
      function getViewportOffsetRectRelativeToArtbitraryNode(element) {
        var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var html = element.ownerDocument.documentElement;
        var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
        var width = Math.max(html.clientWidth, window.innerWidth || 0);
        var height = Math.max(html.clientHeight, window.innerHeight || 0);
        var scrollTop = !excludeScroll ? getScroll(html) : 0;
        var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
        var offset = {
          top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
          left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
          width: width,
          height: height
        };
        return getClientRect(offset);
      }

      /**
       * Check if the given element is fixed or is inside a fixed parent
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element
       * @argument {Element} customContainer
       * @returns {Boolean} answer to "isFixed?"
       */
      function isFixed(element) {
        var nodeName = element.nodeName;
        if (nodeName === 'BODY' || nodeName === 'HTML') {
          return false;
        }
        if (getStyleComputedProperty(element, 'position') === 'fixed') {
          return true;
        }
        var parentNode = getParentNode(element);
        if (!parentNode) {
          return false;
        }
        return isFixed(parentNode);
      }

      /**
       * Finds the first parent of an element that has a transformed property defined
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element
       * @returns {Element} first transformed parent or documentElement
       */

      function getFixedPositionOffsetParent(element) {
        // This check is needed to avoid errors in case one of the elements isn't defined for any reason
        if (!element || !element.parentElement || isIE()) {
          return document.documentElement;
        }
        var el = element.parentElement;
        while (el && getStyleComputedProperty(el, 'transform') === 'none') {
          el = el.parentElement;
        }
        return el || document.documentElement;
      }

      /**
       * Computed the boundaries limits and return them
       * @method
       * @memberof Popper.Utils
       * @param {HTMLElement} popper
       * @param {HTMLElement} reference
       * @param {number} padding
       * @param {HTMLElement} boundariesElement - Element used to define the boundaries
       * @param {Boolean} fixedPosition - Is in fixed position mode
       * @returns {Object} Coordinates of the boundaries
       */
      function getBoundaries(popper, reference, padding, boundariesElement) {
        var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        // NOTE: 1 DOM access here

        var boundaries = {
          top: 0,
          left: 0
        };
        var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

        // Handle viewport case
        if (boundariesElement === 'viewport') {
          boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
        } else {
          // Handle other cases based on DOM element used as boundaries
          var boundariesNode = void 0;
          if (boundariesElement === 'scrollParent') {
            boundariesNode = getScrollParent(getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') {
              boundariesNode = popper.ownerDocument.documentElement;
            }
          } else if (boundariesElement === 'window') {
            boundariesNode = popper.ownerDocument.documentElement;
          } else {
            boundariesNode = boundariesElement;
          }
          var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

          // In case of HTML, we need a different computation
          if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
            var _getWindowSizes = getWindowSizes(popper.ownerDocument),
              height = _getWindowSizes.height,
              width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
          } else {
            // for all the other DOM elements, this one is good
            boundaries = offsets;
          }
        }

        // Add paddings
        padding = padding || 0;
        var isPaddingNumber = typeof padding === 'number';
        boundaries.left += isPaddingNumber ? padding : padding.left || 0;
        boundaries.top += isPaddingNumber ? padding : padding.top || 0;
        boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
        boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
        return boundaries;
      }
      function getArea(_ref) {
        var width = _ref.width,
          height = _ref.height;
        return width * height;
      }

      /**
       * Utility used to transform the `auto` placement to the placement with more
       * available space.
       * @method
       * @memberof Popper.Utils
       * @argument {Object} data - The data object generated by update method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
        var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        if (placement.indexOf('auto') === -1) {
          return placement;
        }
        var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
        var rects = {
          top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
          },
          right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
          },
          bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
          },
          left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
          }
        };
        var sortedAreas = Object.keys(rects).map(function (key) {
          return _extends({
            key: key
          }, rects[key], {
            area: getArea(rects[key])
          });
        }).sort(function (a, b) {
          return b.area - a.area;
        });
        var filteredAreas = sortedAreas.filter(function (_ref2) {
          var width = _ref2.width,
            height = _ref2.height;
          return width >= popper.clientWidth && height >= popper.clientHeight;
        });
        var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
        var variation = placement.split('-')[1];
        return computedPlacement + (variation ? '-' + variation : '');
      }

      /**
       * Get offsets to the reference element
       * @method
       * @memberof Popper.Utils
       * @param {Object} state
       * @param {Element} popper - the popper element
       * @param {Element} reference - the reference element (the popper will be relative to this)
       * @param {Element} fixedPosition - is in fixed position mode
       * @returns {Object} An object containing the offsets which will be applied to the popper
       */
      function getReferenceOffsets(state, popper, reference) {
        var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
        return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
      }

      /**
       * Get the outer sizes of the given element (offset size + margins)
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element
       * @returns {Object} object containing width and height properties
       */
      function getOuterSizes(element) {
        var window = element.ownerDocument.defaultView;
        var styles = window.getComputedStyle(element);
        var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
        var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
        var result = {
          width: element.offsetWidth + y,
          height: element.offsetHeight + x
        };
        return result;
      }

      /**
       * Get the opposite placement of the given one
       * @method
       * @memberof Popper.Utils
       * @argument {String} placement
       * @returns {String} flipped placement
       */
      function getOppositePlacement(placement) {
        var hash = {
          left: 'right',
          right: 'left',
          bottom: 'top',
          top: 'bottom'
        };
        return placement.replace(/left|right|bottom|top/g, function (matched) {
          return hash[matched];
        });
      }

      /**
       * Get offsets to the popper
       * @method
       * @memberof Popper.Utils
       * @param {Object} position - CSS position the Popper will get applied
       * @param {HTMLElement} popper - the popper element
       * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
       * @param {String} placement - one of the valid placement options
       * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
       */
      function getPopperOffsets(popper, referenceOffsets, placement) {
        placement = placement.split('-')[0];

        // Get popper node sizes
        var popperRect = getOuterSizes(popper);

        // Add position, width and height to our offsets object
        var popperOffsets = {
          width: popperRect.width,
          height: popperRect.height
        };

        // depending by the popper placement we have to compute its offsets slightly differently
        var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
        var mainSide = isHoriz ? 'top' : 'left';
        var secondarySide = isHoriz ? 'left' : 'top';
        var measurement = isHoriz ? 'height' : 'width';
        var secondaryMeasurement = !isHoriz ? 'height' : 'width';
        popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
        if (placement === secondarySide) {
          popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
        } else {
          popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
        }
        return popperOffsets;
      }

      /**
       * Mimics the `find` method of Array
       * @method
       * @memberof Popper.Utils
       * @argument {Array} arr
       * @argument prop
       * @argument value
       * @returns index or -1
       */
      function find(arr, check) {
        // use native find if supported
        if (Array.prototype.find) {
          return arr.find(check);
        }

        // use `filter` to obtain the same behavior of `find`
        return arr.filter(check)[0];
      }

      /**
       * Return the index of the matching object
       * @method
       * @memberof Popper.Utils
       * @argument {Array} arr
       * @argument prop
       * @argument value
       * @returns index or -1
       */
      function findIndex(arr, prop, value) {
        // use native findIndex if supported
        if (Array.prototype.findIndex) {
          return arr.findIndex(function (cur) {
            return cur[prop] === value;
          });
        }

        // use `find` + `indexOf` if `findIndex` isn't supported
        var match = find(arr, function (obj) {
          return obj[prop] === value;
        });
        return arr.indexOf(match);
      }

      /**
       * Loop trough the list of modifiers and run them in order,
       * each of them will then edit the data object.
       * @method
       * @memberof Popper.Utils
       * @param {dataObject} data
       * @param {Array} modifiers
       * @param {String} ends - Optional modifier name used as stopper
       * @returns {dataObject}
       */
      function runModifiers(modifiers, data, ends) {
        var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
        modifiersToRun.forEach(function (modifier) {
          if (modifier['function']) {
            // eslint-disable-line dot-notation
            console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
          }
          var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
          if (modifier.enabled && isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = getClientRect(data.offsets.popper);
            data.offsets.reference = getClientRect(data.offsets.reference);
            data = fn(data, modifier);
          }
        });
        return data;
      }

      /**
       * Updates the position of the popper, computing the new offsets and applying
       * the new style.<br />
       * Prefer `scheduleUpdate` over `update` because of performance reasons.
       * @method
       * @memberof Popper
       */
      function update() {
        // if popper is destroyed, don't perform any further update
        if (this.state.isDestroyed) {
          return;
        }
        var data = {
          instance: this,
          styles: {},
          arrowStyles: {},
          attributes: {},
          flipped: false,
          offsets: {}
        };

        // compute reference element offsets
        data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

        // compute auto placement, store placement inside the data object,
        // modifiers will be able to edit `placement` if needed
        // and refer to originalPlacement to know the original value
        data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

        // store the computed placement inside `originalPlacement`
        data.originalPlacement = data.placement;
        data.positionFixed = this.options.positionFixed;

        // compute the popper offsets
        data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
        data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

        // run the modifiers
        data = runModifiers(this.modifiers, data);

        // the first `update` will call `onCreate` callback
        // the other ones will call `onUpdate` callback
        if (!this.state.isCreated) {
          this.state.isCreated = true;
          this.options.onCreate(data);
        } else {
          this.options.onUpdate(data);
        }
      }

      /**
       * Helper used to know if the given modifier is enabled.
       * @method
       * @memberof Popper.Utils
       * @returns {Boolean}
       */
      function isModifierEnabled(modifiers, modifierName) {
        return modifiers.some(function (_ref) {
          var name = _ref.name,
            enabled = _ref.enabled;
          return enabled && name === modifierName;
        });
      }

      /**
       * Get the prefixed supported property name
       * @method
       * @memberof Popper.Utils
       * @argument {String} property (camelCase)
       * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
       */
      function getSupportedPropertyName(property) {
        var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
        var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
        for (var i = 0; i < prefixes.length; i++) {
          var prefix = prefixes[i];
          var toCheck = prefix ? '' + prefix + upperProp : property;
          if (typeof document.body.style[toCheck] !== 'undefined') {
            return toCheck;
          }
        }
        return null;
      }

      /**
       * Destroys the popper.
       * @method
       * @memberof Popper
       */
      function destroy() {
        this.state.isDestroyed = true;

        // touch DOM only if `applyStyle` modifier is enabled
        if (isModifierEnabled(this.modifiers, 'applyStyle')) {
          this.popper.removeAttribute('x-placement');
          this.popper.style.position = '';
          this.popper.style.top = '';
          this.popper.style.left = '';
          this.popper.style.right = '';
          this.popper.style.bottom = '';
          this.popper.style.willChange = '';
          this.popper.style[getSupportedPropertyName('transform')] = '';
        }
        this.disableEventListeners();

        // remove the popper if user explicitly asked for the deletion on destroy
        // do not use `remove` because IE11 doesn't support it
        if (this.options.removeOnDestroy) {
          this.popper.parentNode.removeChild(this.popper);
        }
        return this;
      }

      /**
       * Get the window associated with the element
       * @argument {Element} element
       * @returns {Window}
       */
      function getWindow(element) {
        var ownerDocument = element.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView : window;
      }
      function attachToScrollParents(scrollParent, event, callback, scrollParents) {
        var isBody = scrollParent.nodeName === 'BODY';
        var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
        target.addEventListener(event, callback, {
          passive: true
        });
        if (!isBody) {
          attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
        }
        scrollParents.push(target);
      }

      /**
       * Setup needed event listeners used to update the popper position
       * @method
       * @memberof Popper.Utils
       * @private
       */
      function setupEventListeners(reference, options, state, updateBound) {
        // Resize event listener on window
        state.updateBound = updateBound;
        getWindow(reference).addEventListener('resize', state.updateBound, {
          passive: true
        });

        // Scroll event listener on scroll parents
        var scrollElement = getScrollParent(reference);
        attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
        state.scrollElement = scrollElement;
        state.eventsEnabled = true;
        return state;
      }

      /**
       * It will add resize/scroll events and start recalculating
       * position of the popper element when they are triggered.
       * @method
       * @memberof Popper
       */
      function enableEventListeners() {
        if (!this.state.eventsEnabled) {
          this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
        }
      }

      /**
       * Remove event listeners used to update the popper position
       * @method
       * @memberof Popper.Utils
       * @private
       */
      function removeEventListeners(reference, state) {
        // Remove resize event listener on window
        getWindow(reference).removeEventListener('resize', state.updateBound);

        // Remove scroll event listener on scroll parents
        state.scrollParents.forEach(function (target) {
          target.removeEventListener('scroll', state.updateBound);
        });

        // Reset state
        state.updateBound = null;
        state.scrollParents = [];
        state.scrollElement = null;
        state.eventsEnabled = false;
        return state;
      }

      /**
       * It will remove resize/scroll events and won't recalculate popper position
       * when they are triggered. It also won't trigger `onUpdate` callback anymore,
       * unless you call `update` method manually.
       * @method
       * @memberof Popper
       */
      function disableEventListeners() {
        if (this.state.eventsEnabled) {
          cancelAnimationFrame(this.scheduleUpdate);
          this.state = removeEventListeners(this.reference, this.state);
        }
      }

      /**
       * Tells if a given input is a number
       * @method
       * @memberof Popper.Utils
       * @param {*} input to check
       * @return {Boolean}
       */
      function isNumeric(n) {
        return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
      }

      /**
       * Set the style to the given popper
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element - Element to apply the style to
       * @argument {Object} styles
       * Object with a list of properties and values which will be applied to the element
       */
      function setStyles(element, styles) {
        Object.keys(styles).forEach(function (prop) {
          var unit = '';
          // add unit if the value is numeric and is one of the following
          if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
            unit = 'px';
          }
          element.style[prop] = styles[prop] + unit;
        });
      }

      /**
       * Set the attributes to the given popper
       * @method
       * @memberof Popper.Utils
       * @argument {Element} element - Element to apply the attributes to
       * @argument {Object} styles
       * Object with a list of properties and values which will be applied to the element
       */
      function setAttributes(element, attributes) {
        Object.keys(attributes).forEach(function (prop) {
          var value = attributes[prop];
          if (value !== false) {
            element.setAttribute(prop, attributes[prop]);
          } else {
            element.removeAttribute(prop);
          }
        });
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by `update` method
       * @argument {Object} data.styles - List of style properties - values to apply to popper element
       * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The same data object
       */
      function applyStyle(data) {
        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        setStyles(data.instance.popper, data.styles);

        // any property present in `data.attributes` will be applied to the popper,
        // they will be set as HTML attributes of the element
        setAttributes(data.instance.popper, data.attributes);

        // if arrowElement is defined and arrowStyles has some properties
        if (data.arrowElement && Object.keys(data.arrowStyles).length) {
          setStyles(data.arrowElement, data.arrowStyles);
        }
        return data;
      }

      /**
       * Set the x-placement attribute before everything else because it could be used
       * to add margins to the popper margins needs to be calculated to get the
       * correct popper offsets.
       * @method
       * @memberof Popper.modifiers
       * @param {HTMLElement} reference - The reference element used to position the popper
       * @param {HTMLElement} popper - The HTML element used as popper
       * @param {Object} options - Popper.js options
       */
      function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
        // compute reference element offsets
        var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

        // compute auto placement, store placement inside the data object,
        // modifiers will be able to edit `placement` if needed
        // and refer to originalPlacement to know the original value
        var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
        popper.setAttribute('x-placement', placement);

        // Apply `position` to popper before anything else because
        // without the position applied we can't guarantee correct computations
        setStyles(popper, {
          position: options.positionFixed ? 'fixed' : 'absolute'
        });
        return options;
      }

      /**
       * @function
       * @memberof Popper.Utils
       * @argument {Object} data - The data object generated by `update` method
       * @argument {Boolean} shouldRound - If the offsets should be rounded at all
       * @returns {Object} The popper's position offsets rounded
       *
       * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
       * good as it can be within reason.
       * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
       *
       * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
       * as well on High DPI screens).
       *
       * Firefox prefers no rounding for positioning and does not have blurriness on
       * high DPI screens.
       *
       * Only horizontal placement and left/right values need to be considered.
       */
      function getRoundedOffsets(data, shouldRound) {
        var _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
        var round = Math.round,
          floor = Math.floor;
        var noRound = function noRound(v) {
          return v;
        };
        var referenceWidth = round(reference.width);
        var popperWidth = round(popper.width);
        var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
        var isVariation = data.placement.indexOf('-') !== -1;
        var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
        var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
        var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
        var verticalToInteger = !shouldRound ? noRound : round;
        return {
          left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
          top: verticalToInteger(popper.top),
          bottom: verticalToInteger(popper.bottom),
          right: horizontalToInteger(popper.right)
        };
      }
      var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by `update` method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function computeStyle(data, options) {
        var x = options.x,
          y = options.y;
        var popper = data.offsets.popper;

        // Remove this legacy support in Popper.js v2

        var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
          return modifier.name === 'applyStyle';
        }).gpuAcceleration;
        if (legacyGpuAccelerationOption !== undefined) {
          console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
        }
        var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
        var offsetParent = getOffsetParent(data.instance.popper);
        var offsetParentRect = getBoundingClientRect(offsetParent);

        // Styles
        var styles = {
          position: popper.position
        };
        var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
        var sideA = x === 'bottom' ? 'top' : 'bottom';
        var sideB = y === 'right' ? 'left' : 'right';

        // if gpuAcceleration is set to `true` and transform is supported,
        //  we use `translate3d` to apply the position to the popper we
        // automatically use the supported prefixed version if needed
        var prefixedProperty = getSupportedPropertyName('transform');

        // now, let's make a step back and look at this code closely (wtf?)
        // If the content of the popper grows once it's been positioned, it
        // may happen that the popper gets misplaced because of the new content
        // overflowing its reference element
        // To avoid this problem, we provide two options (x and y), which allow
        // the consumer to define the offset origin.
        // If we position a popper on top of a reference element, we can set
        // `x` to `top` to make the popper grow towards its top instead of
        // its bottom.
        var left = void 0,
          top = void 0;
        if (sideA === 'bottom') {
          // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
          // and not the bottom of the html element
          if (offsetParent.nodeName === 'HTML') {
            top = -offsetParent.clientHeight + offsets.bottom;
          } else {
            top = -offsetParentRect.height + offsets.bottom;
          }
        } else {
          top = offsets.top;
        }
        if (sideB === 'right') {
          if (offsetParent.nodeName === 'HTML') {
            left = -offsetParent.clientWidth + offsets.right;
          } else {
            left = -offsetParentRect.width + offsets.right;
          }
        } else {
          left = offsets.left;
        }
        if (gpuAcceleration && prefixedProperty) {
          styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
          styles[sideA] = 0;
          styles[sideB] = 0;
          styles.willChange = 'transform';
        } else {
          // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
          var invertTop = sideA === 'bottom' ? -1 : 1;
          var invertLeft = sideB === 'right' ? -1 : 1;
          styles[sideA] = top * invertTop;
          styles[sideB] = left * invertLeft;
          styles.willChange = sideA + ', ' + sideB;
        }

        // Attributes
        var attributes = {
          'x-placement': data.placement
        };

        // Update `data` attributes, styles and arrowStyles
        data.attributes = _extends({}, attributes, data.attributes);
        data.styles = _extends({}, styles, data.styles);
        data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
        return data;
      }

      /**
       * Helper used to know if the given modifier depends from another one.<br />
       * It checks if the needed modifier is listed and enabled.
       * @method
       * @memberof Popper.Utils
       * @param {Array} modifiers - list of modifiers
       * @param {String} requestingName - name of requesting modifier
       * @param {String} requestedName - name of requested modifier
       * @returns {Boolean}
       */
      function isModifierRequired(modifiers, requestingName, requestedName) {
        var requesting = find(modifiers, function (_ref) {
          var name = _ref.name;
          return name === requestingName;
        });
        var isRequired = !!requesting && modifiers.some(function (modifier) {
          return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
        });
        if (!isRequired) {
          var _requesting = '`' + requestingName + '`';
          var requested = '`' + requestedName + '`';
          console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
        }
        return isRequired;
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by update method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function arrow(data, options) {
        var _data$offsets$arrow;

        // arrow depends on keepTogether in order to work
        if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
          return data;
        }
        var arrowElement = options.element;

        // if arrowElement is a string, suppose it's a CSS selector
        if (typeof arrowElement === 'string') {
          arrowElement = data.instance.popper.querySelector(arrowElement);

          // if arrowElement is not found, don't run the modifier
          if (!arrowElement) {
            return data;
          }
        } else {
          // if the arrowElement isn't a query selector we must check that the
          // provided DOM node is child of its popper node
          if (!data.instance.popper.contains(arrowElement)) {
            console.warn('WARNING: `arrow.element` must be child of its popper element!');
            return data;
          }
        }
        var placement = data.placement.split('-')[0];
        var _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
        var isVertical = ['left', 'right'].indexOf(placement) !== -1;
        var len = isVertical ? 'height' : 'width';
        var sideCapitalized = isVertical ? 'Top' : 'Left';
        var side = sideCapitalized.toLowerCase();
        var altSide = isVertical ? 'left' : 'top';
        var opSide = isVertical ? 'bottom' : 'right';
        var arrowElementSize = getOuterSizes(arrowElement)[len];

        //
        // extends keepTogether behavior making sure the popper and its
        // reference have enough pixels in conjunction
        //

        // top/left side
        if (reference[opSide] - arrowElementSize < popper[side]) {
          data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
        }
        // bottom/right side
        if (reference[side] + arrowElementSize > popper[opSide]) {
          data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
        }
        data.offsets.popper = getClientRect(data.offsets.popper);

        // compute center of the popper
        var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

        // Compute the sideValue using the updated popper offsets
        // take popper margin in account because we don't have this info available
        var css = getStyleComputedProperty(data.instance.popper);
        var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
        var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
        var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

        // prevent arrowElement from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
        data.arrowElement = arrowElement;
        data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
        return data;
      }

      /**
       * Get the opposite placement variation of the given one
       * @method
       * @memberof Popper.Utils
       * @argument {String} placement variation
       * @returns {String} flipped placement variation
       */
      function getOppositeVariation(variation) {
        if (variation === 'end') {
          return 'start';
        } else if (variation === 'start') {
          return 'end';
        }
        return variation;
      }

      /**
       * List of accepted placements to use as values of the `placement` option.<br />
       * Valid placements are:
       * - `auto`
       * - `top`
       * - `right`
       * - `bottom`
       * - `left`
       *
       * Each placement can have a variation from this list:
       * - `-start`
       * - `-end`
       *
       * Variations are interpreted easily if you think of them as the left to right
       * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
       * is right.<br />
       * Vertically (`left` and `right`), `start` is top and `end` is bottom.
       *
       * Some valid examples are:
       * - `top-end` (on top of reference, right aligned)
       * - `right-start` (on right of reference, top aligned)
       * - `bottom` (on bottom, centered)
       * - `auto-end` (on the side with more space available, alignment depends by placement)
       *
       * @static
       * @type {Array}
       * @enum {String}
       * @readonly
       * @method placements
       * @memberof Popper
       */
      var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

      // Get rid of `auto` `auto-start` and `auto-end`
      var validPlacements = placements.slice(3);

      /**
       * Given an initial placement, returns all the subsequent placements
       * clockwise (or counter-clockwise).
       *
       * @method
       * @memberof Popper.Utils
       * @argument {String} placement - A valid placement (it accepts variations)
       * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
       * @returns {Array} placements including their variations
       */
      function clockwise(placement) {
        var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var index = validPlacements.indexOf(placement);
        var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
        return counter ? arr.reverse() : arr;
      }
      var BEHAVIORS = {
        FLIP: 'flip',
        CLOCKWISE: 'clockwise',
        COUNTERCLOCKWISE: 'counterclockwise'
      };

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by update method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function flip(data, options) {
        // if `inner` modifier is enabled, we can't use the `flip` modifier
        if (isModifierEnabled(data.instance.modifiers, 'inner')) {
          return data;
        }
        if (data.flipped && data.placement === data.originalPlacement) {
          // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
          return data;
        }
        var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
        var placement = data.placement.split('-')[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split('-')[1] || '';
        var flipOrder = [];
        switch (options.behavior) {
          case BEHAVIORS.FLIP:
            flipOrder = [placement, placementOpposite];
            break;
          case BEHAVIORS.CLOCKWISE:
            flipOrder = clockwise(placement);
            break;
          case BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = clockwise(placement, true);
            break;
          default:
            flipOrder = options.behavior;
        }
        flipOrder.forEach(function (step, index) {
          if (placement !== step || flipOrder.length === index + 1) {
            return data;
          }
          placement = data.placement.split('-')[0];
          placementOpposite = getOppositePlacement(placement);
          var popperOffsets = data.offsets.popper;
          var refOffsets = data.offsets.reference;

          // using floor because the reference offsets may contain decimals we are not going to consider here
          var floor = Math.floor;
          var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
          var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
          var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
          var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
          var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
          var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

          // flip the variation if required
          var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

          // flips variation if reference element overflows boundaries
          var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

          // flips variation if popper content overflows boundaries
          var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
          var flippedVariation = flippedVariationByRef || flippedVariationByContent;
          if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) {
              placement = flipOrder[index + 1];
            }
            if (flippedVariation) {
              variation = getOppositeVariation(variation);
            }
            data.placement = placement + (variation ? '-' + variation : '');

            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = runModifiers(data.instance.modifiers, data, 'flip');
          }
        });
        return data;
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by update method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function keepTogether(data) {
        var _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
        var placement = data.placement.split('-')[0];
        var floor = Math.floor;
        var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
        var side = isVertical ? 'right' : 'bottom';
        var opSide = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        if (popper[side] < floor(reference[opSide])) {
          data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
        }
        if (popper[opSide] > floor(reference[side])) {
          data.offsets.popper[opSide] = floor(reference[side]);
        }
        return data;
      }

      /**
       * Converts a string containing value + unit into a px value number
       * @function
       * @memberof {modifiers~offset}
       * @private
       * @argument {String} str - Value + unit string
       * @argument {String} measurement - `height` or `width`
       * @argument {Object} popperOffsets
       * @argument {Object} referenceOffsets
       * @returns {Number|String}
       * Value in pixels, or original string if no values were extracted
       */
      function toValue(str, measurement, popperOffsets, referenceOffsets) {
        // separate value from unit
        var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
        var value = +split[1];
        var unit = split[2];

        // If it's not a number it's an operator, I guess
        if (!value) {
          return str;
        }
        if (unit.indexOf('%') === 0) {
          var element = void 0;
          switch (unit) {
            case '%p':
              element = popperOffsets;
              break;
            case '%':
            case '%r':
            default:
              element = referenceOffsets;
          }
          var rect = getClientRect(element);
          return rect[measurement] / 100 * value;
        } else if (unit === 'vh' || unit === 'vw') {
          // if is a vh or vw, we calculate the size based on the viewport
          var size = void 0;
          if (unit === 'vh') {
            size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
          } else {
            size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          }
          return size / 100 * value;
        } else {
          // if is an explicit pixel unit, we get rid of the unit and keep the value
          // if is an implicit unit, it's px, and we return just the value
          return value;
        }
      }

      /**
       * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
       * @function
       * @memberof {modifiers~offset}
       * @private
       * @argument {String} offset
       * @argument {Object} popperOffsets
       * @argument {Object} referenceOffsets
       * @argument {String} basePlacement
       * @returns {Array} a two cells array with x and y offsets in numbers
       */
      function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
        var offsets = [0, 0];

        // Use height if placement is left or right and index is 0 otherwise use width
        // in this way the first offset will use an axis and the second one
        // will use the other one
        var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

        // Split the offset string to obtain a list of values and operands
        // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
        var fragments = offset.split(/(\+|\-)/).map(function (frag) {
          return frag.trim();
        });

        // Detect if the offset string contains a pair of values or a single one
        // they could be separated by comma or space
        var divider = fragments.indexOf(find(fragments, function (frag) {
          return frag.search(/,|\s/) !== -1;
        }));
        if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
          console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
        }

        // If divider is found, we divide the list of values and operands to divide
        // them by ofset X and Y.
        var splitRegex = /\s*,\s*|\s+/;
        var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

        // Convert the values with units to absolute pixels to allow our computations
        ops = ops.map(function (op, index) {
          // Most of the units rely on the orientation of the popper
          var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
          var mergeWithPrevious = false;
          return op
          // This aggregates any `+` or `-` sign that aren't considered operators
          // e.g.: 10 + +5 => [10, +, +5]
          .reduce(function (a, b) {
            if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
              a[a.length - 1] = b;
              mergeWithPrevious = true;
              return a;
            } else if (mergeWithPrevious) {
              a[a.length - 1] += b;
              mergeWithPrevious = false;
              return a;
            } else {
              return a.concat(b);
            }
          }, [])
          // Here we convert the string values into number values (in px)
          .map(function (str) {
            return toValue(str, measurement, popperOffsets, referenceOffsets);
          });
        });

        // Loop trough the offsets arrays and execute the operations
        ops.forEach(function (op, index) {
          op.forEach(function (frag, index2) {
            if (isNumeric(frag)) {
              offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
            }
          });
        });
        return offsets;
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by update method
       * @argument {Object} options - Modifiers configuration and options
       * @argument {Number|String} options.offset=0
       * The offset value as described in the modifier description
       * @returns {Object} The data object, properly modified
       */
      function offset(data, _ref) {
        var offset = _ref.offset;
        var placement = data.placement,
          _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
        var basePlacement = placement.split('-')[0];
        var offsets = void 0;
        if (isNumeric(+offset)) {
          offsets = [+offset, 0];
        } else {
          offsets = parseOffset(offset, popper, reference, basePlacement);
        }
        if (basePlacement === 'left') {
          popper.top += offsets[0];
          popper.left -= offsets[1];
        } else if (basePlacement === 'right') {
          popper.top += offsets[0];
          popper.left += offsets[1];
        } else if (basePlacement === 'top') {
          popper.left += offsets[0];
          popper.top -= offsets[1];
        } else if (basePlacement === 'bottom') {
          popper.left += offsets[0];
          popper.top += offsets[1];
        }
        data.popper = popper;
        return data;
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by `update` method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function preventOverflow(data, options) {
        var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

        // If offsetParent is the reference element, we really want to
        // go one step up and use the next offsetParent as reference to
        // avoid to make this modifier completely useless and look like broken
        if (data.instance.reference === boundariesElement) {
          boundariesElement = getOffsetParent(boundariesElement);
        }

        // NOTE: DOM access here
        // resets the popper's position so that the document size can be calculated excluding
        // the size of the popper element itself
        var transformProp = getSupportedPropertyName('transform');
        var popperStyles = data.instance.popper.style; // assignment to help minification
        var top = popperStyles.top,
          left = popperStyles.left,
          transform = popperStyles[transformProp];
        popperStyles.top = '';
        popperStyles.left = '';
        popperStyles[transformProp] = '';
        var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

        // NOTE: DOM access here
        // restores the original style properties after the offsets have been computed
        popperStyles.top = top;
        popperStyles.left = left;
        popperStyles[transformProp] = transform;
        options.boundaries = boundaries;
        var order = options.priority;
        var popper = data.offsets.popper;
        var check = {
          primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
              value = Math.max(popper[placement], boundaries[placement]);
            }
            return defineProperty({}, placement, value);
          },
          secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
              value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            }
            return defineProperty({}, mainSide, value);
          }
        };
        order.forEach(function (placement) {
          var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
          popper = _extends({}, popper, check[side](placement));
        });
        data.offsets.popper = popper;
        return data;
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by `update` method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function shift(data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var shiftvariation = placement.split('-')[1];

        // if shift shiftvariation is specified, run the modifier
        if (shiftvariation) {
          var _data$offsets = data.offsets,
            reference = _data$offsets.reference,
            popper = _data$offsets.popper;
          var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
          var side = isVertical ? 'left' : 'top';
          var measurement = isVertical ? 'width' : 'height';
          var shiftOffsets = {
            start: defineProperty({}, side, reference[side]),
            end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
          };
          data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
        }
        return data;
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by update method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function hide(data) {
        if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
          return data;
        }
        var refRect = data.offsets.reference;
        var bound = find(data.instance.modifiers, function (modifier) {
          return modifier.name === 'preventOverflow';
        }).boundaries;
        if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
          // Avoid unnecessary DOM access if visibility hasn't changed
          if (data.hide === true) {
            return data;
          }
          data.hide = true;
          data.attributes['x-out-of-boundaries'] = '';
        } else {
          // Avoid unnecessary DOM access if visibility hasn't changed
          if (data.hide === false) {
            return data;
          }
          data.hide = false;
          data.attributes['x-out-of-boundaries'] = false;
        }
        return data;
      }

      /**
       * @function
       * @memberof Modifiers
       * @argument {Object} data - The data object generated by `update` method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {Object} The data object, properly modified
       */
      function inner(data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var _data$offsets = data.offsets,
          popper = _data$offsets.popper,
          reference = _data$offsets.reference;
        var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
        var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
        popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
        data.placement = getOppositePlacement(placement);
        data.offsets.popper = getClientRect(popper);
        return data;
      }

      /**
       * Modifier function, each modifier can have a function of this type assigned
       * to its `fn` property.<br />
       * These functions will be called on each update, this means that you must
       * make sure they are performant enough to avoid performance bottlenecks.
       *
       * @function ModifierFn
       * @argument {dataObject} data - The data object generated by `update` method
       * @argument {Object} options - Modifiers configuration and options
       * @returns {dataObject} The data object, properly modified
       */

      /**
       * Modifiers are plugins used to alter the behavior of your poppers.<br />
       * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
       * needed by the library.
       *
       * Usually you don't want to override the `order`, `fn` and `onLoad` props.
       * All the other properties are configurations that could be tweaked.
       * @namespace modifiers
       */
      var modifiers = {
        /**
         * Modifier used to shift the popper on the start or end of its reference
         * element.<br />
         * It will read the variation of the `placement` property.<br />
         * It can be one either `-end` or `-start`.
         * @memberof modifiers
         * @inner
         */
        shift: {
          /** @prop {number} order=100 - Index used to define the order of execution */
          order: 100,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: shift
        },
        /**
         * The `offset` modifier can shift your popper on both its axis.
         *
         * It accepts the following units:
         * - `px` or unit-less, interpreted as pixels
         * - `%` or `%r`, percentage relative to the length of the reference element
         * - `%p`, percentage relative to the length of the popper element
         * - `vw`, CSS viewport width unit
         * - `vh`, CSS viewport height unit
         *
         * For length is intended the main axis relative to the placement of the popper.<br />
         * This means that if the placement is `top` or `bottom`, the length will be the
         * `width`. In case of `left` or `right`, it will be the `height`.
         *
         * You can provide a single value (as `Number` or `String`), or a pair of values
         * as `String` divided by a comma or one (or more) white spaces.<br />
         * The latter is a deprecated method because it leads to confusion and will be
         * removed in v2.<br />
         * Additionally, it accepts additions and subtractions between different units.
         * Note that multiplications and divisions aren't supported.
         *
         * Valid examples are:
         * ```
         * 10
         * '10%'
         * '10, 10'
         * '10%, 10'
         * '10 + 10%'
         * '10 - 5vh + 3%'
         * '-10px + 5vh, 5px - 6%'
         * ```
         * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
         * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
         * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
         *
         * @memberof modifiers
         * @inner
         */
        offset: {
          /** @prop {number} order=200 - Index used to define the order of execution */
          order: 200,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: offset,
          /** @prop {Number|String} offset=0
           * The offset value as described in the modifier description
           */
          offset: 0
        },
        /**
         * Modifier used to prevent the popper from being positioned outside the boundary.
         *
         * A scenario exists where the reference itself is not within the boundaries.<br />
         * We can say it has "escaped the boundaries" — or just "escaped".<br />
         * In this case we need to decide whether the popper should either:
         *
         * - detach from the reference and remain "trapped" in the boundaries, or
         * - if it should ignore the boundary and "escape with its reference"
         *
         * When `escapeWithReference` is set to`true` and reference is completely
         * outside its boundaries, the popper will overflow (or completely leave)
         * the boundaries in order to remain attached to the edge of the reference.
         *
         * @memberof modifiers
         * @inner
         */
        preventOverflow: {
          /** @prop {number} order=300 - Index used to define the order of execution */
          order: 300,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: preventOverflow,
          /**
           * @prop {Array} [priority=['left','right','top','bottom']]
           * Popper will try to prevent overflow following these priorities by default,
           * then, it could overflow on the left and on top of the `boundariesElement`
           */
          priority: ['left', 'right', 'top', 'bottom'],
          /**
           * @prop {number} padding=5
           * Amount of pixel used to define a minimum distance between the boundaries
           * and the popper. This makes sure the popper always has a little padding
           * between the edges of its container
           */
          padding: 5,
          /**
           * @prop {String|HTMLElement} boundariesElement='scrollParent'
           * Boundaries used by the modifier. Can be `scrollParent`, `window`,
           * `viewport` or any DOM element.
           */
          boundariesElement: 'scrollParent'
        },
        /**
         * Modifier used to make sure the reference and its popper stay near each other
         * without leaving any gap between the two. Especially useful when the arrow is
         * enabled and you want to ensure that it points to its reference element.
         * It cares only about the first axis. You can still have poppers with margin
         * between the popper and its reference element.
         * @memberof modifiers
         * @inner
         */
        keepTogether: {
          /** @prop {number} order=400 - Index used to define the order of execution */
          order: 400,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: keepTogether
        },
        /**
         * This modifier is used to move the `arrowElement` of the popper to make
         * sure it is positioned between the reference element and its popper element.
         * It will read the outer size of the `arrowElement` node to detect how many
         * pixels of conjunction are needed.
         *
         * It has no effect if no `arrowElement` is provided.
         * @memberof modifiers
         * @inner
         */
        arrow: {
          /** @prop {number} order=500 - Index used to define the order of execution */
          order: 500,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: arrow,
          /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
          element: '[x-arrow]'
        },
        /**
         * Modifier used to flip the popper's placement when it starts to overlap its
         * reference element.
         *
         * Requires the `preventOverflow` modifier before it in order to work.
         *
         * **NOTE:** this modifier will interrupt the current update cycle and will
         * restart it if it detects the need to flip the placement.
         * @memberof modifiers
         * @inner
         */
        flip: {
          /** @prop {number} order=600 - Index used to define the order of execution */
          order: 600,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: flip,
          /**
           * @prop {String|Array} behavior='flip'
           * The behavior used to change the popper's placement. It can be one of
           * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
           * placements (with optional variations)
           */
          behavior: 'flip',
          /**
           * @prop {number} padding=5
           * The popper will flip if it hits the edges of the `boundariesElement`
           */
          padding: 5,
          /**
           * @prop {String|HTMLElement} boundariesElement='viewport'
           * The element which will define the boundaries of the popper position.
           * The popper will never be placed outside of the defined boundaries
           * (except if `keepTogether` is enabled)
           */
          boundariesElement: 'viewport',
          /**
           * @prop {Boolean} flipVariations=false
           * The popper will switch placement variation between `-start` and `-end` when
           * the reference element overlaps its boundaries.
           *
           * The original placement should have a set variation.
           */
          flipVariations: false,
          /**
           * @prop {Boolean} flipVariationsByContent=false
           * The popper will switch placement variation between `-start` and `-end` when
           * the popper element overlaps its reference boundaries.
           *
           * The original placement should have a set variation.
           */
          flipVariationsByContent: false
        },
        /**
         * Modifier used to make the popper flow toward the inner of the reference element.
         * By default, when this modifier is disabled, the popper will be placed outside
         * the reference element.
         * @memberof modifiers
         * @inner
         */
        inner: {
          /** @prop {number} order=700 - Index used to define the order of execution */
          order: 700,
          /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
          enabled: false,
          /** @prop {ModifierFn} */
          fn: inner
        },
        /**
         * Modifier used to hide the popper when its reference element is outside of the
         * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
         * be used to hide with a CSS selector the popper when its reference is
         * out of boundaries.
         *
         * Requires the `preventOverflow` modifier before it in order to work.
         * @memberof modifiers
         * @inner
         */
        hide: {
          /** @prop {number} order=800 - Index used to define the order of execution */
          order: 800,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: hide
        },
        /**
         * Computes the style that will be applied to the popper element to gets
         * properly positioned.
         *
         * Note that this modifier will not touch the DOM, it just prepares the styles
         * so that `applyStyle` modifier can apply it. This separation is useful
         * in case you need to replace `applyStyle` with a custom implementation.
         *
         * This modifier has `850` as `order` value to maintain backward compatibility
         * with previous versions of Popper.js. Expect the modifiers ordering method
         * to change in future major versions of the library.
         *
         * @memberof modifiers
         * @inner
         */
        computeStyle: {
          /** @prop {number} order=850 - Index used to define the order of execution */
          order: 850,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: computeStyle,
          /**
           * @prop {Boolean} gpuAcceleration=true
           * If true, it uses the CSS 3D transformation to position the popper.
           * Otherwise, it will use the `top` and `left` properties
           */
          gpuAcceleration: true,
          /**
           * @prop {string} [x='bottom']
           * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
           * Change this if your popper should grow in a direction different from `bottom`
           */
          x: 'bottom',
          /**
           * @prop {string} [x='left']
           * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
           * Change this if your popper should grow in a direction different from `right`
           */
          y: 'right'
        },
        /**
         * Applies the computed styles to the popper element.
         *
         * All the DOM manipulations are limited to this modifier. This is useful in case
         * you want to integrate Popper.js inside a framework or view library and you
         * want to delegate all the DOM manipulations to it.
         *
         * Note that if you disable this modifier, you must make sure the popper element
         * has its position set to `absolute` before Popper.js can do its work!
         *
         * Just disable this modifier and define your own to achieve the desired effect.
         *
         * @memberof modifiers
         * @inner
         */
        applyStyle: {
          /** @prop {number} order=900 - Index used to define the order of execution */
          order: 900,
          /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
          enabled: true,
          /** @prop {ModifierFn} */
          fn: applyStyle,
          /** @prop {Function} */
          onLoad: applyStyleOnLoad,
          /**
           * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
           * @prop {Boolean} gpuAcceleration=true
           * If true, it uses the CSS 3D transformation to position the popper.
           * Otherwise, it will use the `top` and `left` properties
           */
          gpuAcceleration: undefined
        }
      };

      /**
       * The `dataObject` is an object containing all the information used by Popper.js.
       * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
       * @name dataObject
       * @property {Object} data.instance The Popper.js instance
       * @property {String} data.placement Placement applied to popper
       * @property {String} data.originalPlacement Placement originally defined on init
       * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
       * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
       * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
       * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
       * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
       * @property {Object} data.boundaries Offsets of the popper boundaries
       * @property {Object} data.offsets The measurements of popper, reference and arrow elements
       * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
       * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
       * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
       */

      /**
       * Default options provided to Popper.js constructor.<br />
       * These can be overridden using the `options` argument of Popper.js.<br />
       * To override an option, simply pass an object with the same
       * structure of the `options` object, as the 3rd argument. For example:
       * ```
       * new Popper(ref, pop, {
       *   modifiers: {
       *     preventOverflow: { enabled: false }
       *   }
       * })
       * ```
       * @type {Object}
       * @static
       * @memberof Popper
       */
      var Defaults = {
        /**
         * Popper's placement.
         * @prop {Popper.placements} placement='bottom'
         */
        placement: 'bottom',
        /**
         * Set this to true if you want popper to position it self in 'fixed' mode
         * @prop {Boolean} positionFixed=false
         */
        positionFixed: false,
        /**
         * Whether events (resize, scroll) are initially enabled.
         * @prop {Boolean} eventsEnabled=true
         */
        eventsEnabled: true,
        /**
         * Set to true if you want to automatically remove the popper when
         * you call the `destroy` method.
         * @prop {Boolean} removeOnDestroy=false
         */
        removeOnDestroy: false,
        /**
         * Callback called when the popper is created.<br />
         * By default, it is set to no-op.<br />
         * Access Popper.js instance with `data.instance`.
         * @prop {onCreate}
         */
        onCreate: function onCreate() {},
        /**
         * Callback called when the popper is updated. This callback is not called
         * on the initialization/creation of the popper, but only on subsequent
         * updates.<br />
         * By default, it is set to no-op.<br />
         * Access Popper.js instance with `data.instance`.
         * @prop {onUpdate}
         */
        onUpdate: function onUpdate() {},
        /**
         * List of modifiers used to modify the offsets before they are applied to the popper.
         * They provide most of the functionalities of Popper.js.
         * @prop {modifiers}
         */
        modifiers: modifiers
      };

      /**
       * @callback onCreate
       * @param {dataObject} data
       */

      /**
       * @callback onUpdate
       * @param {dataObject} data
       */

      // Utils
      // Methods
      var Popper = function () {
        /**
         * Creates a new Popper.js instance.
         * @class Popper
         * @param {Element|referenceObject} reference - The reference element used to position the popper
         * @param {Element} popper - The HTML / XML element used as the popper
         * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
         * @return {Object} instance - The generated Popper.js instance
         */
        function Popper(reference, popper) {
          var _this = this;
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          classCallCheck(this, Popper);
          this.scheduleUpdate = function () {
            return requestAnimationFrame(_this.update);
          };

          // make update() debounced, so that it only runs at most once-per-tick
          this.update = debounce(this.update.bind(this));

          // with {} we create a new object with the options inside it
          this.options = _extends({}, Popper.Defaults, options);

          // init state
          this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
          };

          // get reference and popper elements (allow jQuery wrappers)
          this.reference = reference && reference.jquery ? reference[0] : reference;
          this.popper = popper && popper.jquery ? popper[0] : popper;

          // Deep merge modifiers options
          this.options.modifiers = {};
          Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
            _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
          });

          // Refactoring modifiers' list (Object => Array)
          this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
            return _extends({
              name: name
            }, _this.options.modifiers[name]);
          })
          // sort the modifiers by order
          .sort(function (a, b) {
            return a.order - b.order;
          });

          // modifiers have the ability to execute arbitrary code when Popper.js get inited
          // such code is executed in the same order of its modifier
          // they could add new properties to their options configuration
          // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
          this.modifiers.forEach(function (modifierOptions) {
            if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
              modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
            }
          });

          // fire the first update to position the popper in the right place
          this.update();
          var eventsEnabled = this.options.eventsEnabled;
          if (eventsEnabled) {
            // setup event listeners, they will take care of update the position in specific situations
            this.enableEventListeners();
          }
          this.state.eventsEnabled = eventsEnabled;
        }

        // We can't use class properties because they don't get listed in the
        // class prototype and break stuff like Sinon stubs

        createClass(Popper, [{
          key: 'update',
          value: function update$$1() {
            return update.call(this);
          }
        }, {
          key: 'destroy',
          value: function destroy$$1() {
            return destroy.call(this);
          }
        }, {
          key: 'enableEventListeners',
          value: function enableEventListeners$$1() {
            return enableEventListeners.call(this);
          }
        }, {
          key: 'disableEventListeners',
          value: function disableEventListeners$$1() {
            return disableEventListeners.call(this);
          }

          /**
           * Schedules an update. It will run on the next UI update available.
           * @method scheduleUpdate
           * @memberof Popper
           */

          /**
           * Collection of utilities useful when writing custom modifiers.
           * Starting from version 1.7, this method is available only if you
           * include `popper-utils.js` before `popper.js`.
           *
           * **DEPRECATION**: This way to access PopperUtils is deprecated
           * and will be removed in v2! Use the PopperUtils module directly instead.
           * Due to the high instability of the methods contained in Utils, we can't
           * guarantee them to follow semver. Use them at your own risk!
           * @static
           * @private
           * @type {Object}
           * @deprecated since version 1.8
           * @member Utils
           * @memberof Popper
           */
        }]);

        return Popper;
      }();

      /**
       * The `referenceObject` is an object that provides an interface compatible with Popper.js
       * and lets you use it as replacement of a real DOM node.<br />
       * You can use this method to position a popper relatively to a set of coordinates
       * in case you don't have a DOM node to use as reference.
       *
       * ```
       * new Popper(referenceObject, popperNode);
       * ```
       *
       * NB: This feature isn't supported in Internet Explorer 10.
       * @name referenceObject
       * @property {Function} data.getBoundingClientRect
       * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
       * @property {number} data.clientWidth
       * An ES6 getter that will return the width of the virtual reference element.
       * @property {number} data.clientHeight
       * An ES6 getter that will return the height of the virtual reference element.
       */

      Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
      Popper.placements = placements;
      Popper.Defaults = Defaults;

      /* harmony default export */
      __webpack_exports__["a"] = Popper;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("c8ba"));

    /***/
  },

  /***/"f3c1": /***/function (module, exports) {
    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800,
      HOT_SPAN = 16;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeNow = Date.now;

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
        lastCalled = 0;
      return function () {
        var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }
    module.exports = shortOut;

    /***/
  },

  /***/"f6fd": /***/function (module, exports) {
    // document.currentScript polyfill by Adam Miller

    // MIT license

    (function (document) {
      var currentScript = "currentScript",
        scripts = document.getElementsByTagName('script'); // Live NodeList collection

      // If browser needs currentScript polyfill, add get currentScript() to the document object
      if (!(currentScript in document)) {
        Object.defineProperty(document, currentScript, {
          get: function () {
            // IE 6-10 supports script readyState
            // IE 10+ support stack trace
            try {
              throw new Error();
            } catch (err) {
              // Find the second match for the "at" string to get file src url from stack.
              // Specifically works with the format of stack traces in IE.
              var i,
                res = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(err.stack) || [false])[1];

              // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
              for (i in scripts) {
                if (scripts[i].src == res || scripts[i].readyState == "interactive") {
                  return scripts[i];
                }
              }

              // If no match, return null
              return null;
            }
          }
        });
      }
    })(document);

    /***/
  },

  /***/"f7fe": /***/function (module, exports, __webpack_require__) {
    /* WEBPACK VAR INJECTION */(function (global) {
      /**
      * lodash (Custom Build) <https://lodash.com/>
      * Build: `lodash modularize exports="npm" -o ./`
      * Copyright jQuery Foundation and other contributors <https://jquery.org/>
      * Released under MIT license <https://lodash.com/license>
      * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
      * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
      */

      /** Used as the `TypeError` message for "Functions" methods. */
      var FUNC_ERROR_TEXT = 'Expected a function';

      /** Used as references for various `Number` constants. */
      var NAN = 0 / 0;

      /** `Object#toString` result references. */
      var symbolTag = '[object Symbol]';

      /** Used to match leading and trailing whitespace. */
      var reTrim = /^\s+|\s+$/g;

      /** Used to detect bad signed hexadecimal string values. */
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

      /** Used to detect binary string values. */
      var reIsBinary = /^0b[01]+$/i;

      /** Used to detect octal string values. */
      var reIsOctal = /^0o[0-7]+$/i;

      /** Built-in method references without a dependency on `root`. */
      var freeParseInt = parseInt;

      /** Detect free variable `global` from Node.js. */
      var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

      /** Detect free variable `self`. */
      var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

      /** Used as a reference to the global object. */
      var root = freeGlobal || freeSelf || Function('return this')();

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var objectToString = objectProto.toString;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeMax = Math.max,
        nativeMin = Math.min;

      /**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */
      var now = function () {
        return root.Date.now();
      };

      /**
       * Creates a debounced function that delays invoking `func` until after `wait`
       * milliseconds have elapsed since the last time the debounced function was
       * invoked. The debounced function comes with a `cancel` method to cancel
       * delayed `func` invocations and a `flush` method to immediately invoke them.
       * Provide `options` to indicate whether `func` should be invoked on the
       * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
       * with the last arguments provided to the debounced function. Subsequent
       * calls to the debounced function return the result of the last `func`
       * invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the debounced function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.debounce` and `_.throttle`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to debounce.
       * @param {number} [wait=0] The number of milliseconds to delay.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=false]
       *  Specify invoking on the leading edge of the timeout.
       * @param {number} [options.maxWait]
       *  The maximum time `func` is allowed to be delayed before it's invoked.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new debounced function.
       * @example
       *
       * // Avoid costly calculations while the window size is in flux.
       * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
       *
       * // Invoke `sendMail` when clicked, debouncing subsequent calls.
       * jQuery(element).on('click', _.debounce(sendMail, 300, {
       *   'leading': true,
       *   'trailing': false
       * }));
       *
       * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
       * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
       * var source = new EventSource('/stream');
       * jQuery(source).on('message', debounced);
       *
       * // Cancel the trailing debounced invocation.
       * jQuery(window).on('popstate', debounced.cancel);
       */
      function debounce(func, wait, options) {
        var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs,
            thisArg = lastThis;
          lastArgs = lastThis = undefined;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }
        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time;
          // Start the timer for the trailing edge.
          timerId = setTimeout(timerExpired, wait);
          // Invoke the leading edge.
          return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;
          return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

          // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.
          return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          // Restart the timer.
          timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined;

          // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined;
          return result;
        }
        function cancel() {
          if (timerId !== undefined) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
          return timerId === undefined ? result : trailingEdge(now());
        }
        function debounced() {
          var time = now(),
            isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              // Handle invocations in a tight loop.
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }

      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */
      function isObject(value) {
        var type = typeof value;
        return !!value && (type == 'object' || type == 'function');
      }

      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */
      function isObjectLike(value) {
        return !!value && typeof value == 'object';
      }

      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */
      function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
      }

      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */
      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }
        value = value.replace(reTrim, '');
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      module.exports = debounce;

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("c8ba"));

    /***/
  },

  /***/"f85e": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsCarousel_vue_vue_type_style_index_0_id_181f4f32_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("44ce");
    /* harmony import */
    var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsCarousel_vue_vue_type_style_index_0_id_181f4f32_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MsCarousel_vue_vue_type_style_index_0_id_181f4f32_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */

    /***/
  },

  /***/"f8af": /***/function (module, exports, __webpack_require__) {
    var Uint8Array = __webpack_require__("2474");

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }
    module.exports = cloneArrayBuffer;

    /***/
  },

  /***/"f909": /***/function (module, exports, __webpack_require__) {
    var Stack = __webpack_require__("7e64"),
      assignMergeValue = __webpack_require__("b760"),
      baseFor = __webpack_require__("72af"),
      baseMergeDeep = __webpack_require__("4f50"),
      isObject = __webpack_require__("1a8c"),
      keysIn = __webpack_require__("9934"),
      safeGet = __webpack_require__("8adb");

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function (srcValue, key) {
        stack || (stack = new Stack());
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    module.exports = baseMerge;

    /***/
  },

  /***/"fa21": /***/function (module, exports, __webpack_require__) {
    var baseCreate = __webpack_require__("7530"),
      getPrototype = __webpack_require__("2dcb"),
      isPrototype = __webpack_require__("eac5");

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    module.exports = initCloneObject;

    /***/
  },

  /***/"fb15": /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    // ESM COMPAT FLAG
    __webpack_require__.r(__webpack_exports__);

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, "MsAccordion", function () {
      return (/* reexport */components_MsAccordion
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsActionBlock", function () {
      return (/* reexport */components_MsActionBlock
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsActionButton", function () {
      return (/* reexport */components_MsActionButton
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsBadge", function () {
      return (/* reexport */components_MsBadge
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsBasicVerticalColumn", function () {
      return (/* reexport */components_MsBasicVerticalColumn
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsBreadcrumb", function () {
      return (/* reexport */components_MsBreadcrumb
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsButton", function () {
      return (/* reexport */components_MsButton
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsCardContainer", function () {
      return (/* reexport */components_MsCardContainer
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsCarousel", function () {
      return (/* reexport */components_MsCarousel
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsCategoryList", function () {
      return (/* reexport */components_MsCategoryList
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsCheckbox", function () {
      return (/* reexport */components_MsCheckbox
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsConvoDropdown", function () {
      return (/* reexport */components_MsConvoDropdown
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsConvoInputStepper", function () {
      return (/* reexport */components_MsConvoInputStepper
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsExtendedIntro", function () {
      return (/* reexport */components_MsExtendedIntro
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsDatePicker", function () {
      return (/* reexport */components_MsDatePicker
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsDropdown", function () {
      return (/* reexport */components_MsDropdown
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsError", function () {
      return (/* reexport */components_MsError
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsExpandableWrapper", function () {
      return (/* reexport */components_MsExpandableWrapper
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsFooter", function () {
      return (/* reexport */components_MsFooter
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsHeader", function () {
      return (/* reexport */components_MsHeader
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsHeading", function () {
      return (/* reexport */components_MsHeading
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsIcon", function () {
      return (/* reexport */components_MsIcon
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsImage", function () {
      return (/* reexport */components_MsImage
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsInfoCard", function () {
      return (/* reexport */components_MsInfoCard
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsInput", function () {
      return (/* reexport */components_MsInput
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsConvoInput", function () {
      return (/* reexport */components_MsConvoInput
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsInputPassword", function () {
      return (/* reexport */components_MsInputPassword
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsInputStepper", function () {
      return (/* reexport */components_MsInputStepper
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsIntro", function () {
      return (/* reexport */components_MsIntro
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsLink", function () {
      return (/* reexport */components_MsLink
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsListGroup", function () {
      return (/* reexport */components_MsListGroup
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsListingCard", function () {
      return (/* reexport */components_MsListingCard
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsListTable", function () {
      return (/* reexport */components_MsListTable
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsLoader", function () {
      return (/* reexport */components_MsLoader
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsMasthead", function () {
      return (/* reexport */components_MsMasthead
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsModal", function () {
      return (/* reexport */components_MsModal
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsMultiselect", function () {
      return (/* reexport */components_MsMultiselect
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsNotification", function () {
      return (/* reexport */components_MsNotification
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsPagination", function () {
      return (/* reexport */components_MsPagination
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsParagraph", function () {
      return (/* reexport */components_MsParagraph
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsPromotionSnippet", function () {
      return (/* reexport */components_MsPromotionSnippet
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsProgressBar", function () {
      return (/* reexport */components_MsProgressBar
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsQuickFacts", function () {
      return (/* reexport */components_MsQuickFacts
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsQuoteText", function () {
      return (/* reexport */components_MsQuoteText
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsRadioButton", function () {
      return (/* reexport */components_MsRadioButton
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsRating", function () {
      return (/* reexport */components_MsRating
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsSection", function () {
      return (/* reexport */components_MsSection
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsSectionHeader", function () {
      return (/* reexport */components_MsSectionHeader
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsSegmentedControl", function () {
      return (/* reexport */components_MsSegmentedControl
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsShare", function () {
      return (/* reexport */components_MsShare
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsSponsored", function () {
      return (/* reexport */components_MsSponsored
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsStepIndicator", function () {
      return (/* reexport */components_MsStepIndicator
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsSummaryCard", function () {
      return (/* reexport */components_MsSummaryCard
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsTooltip", function () {
      return (/* reexport */components_MsTooltip
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsProgressTimeline", function () {
      return (/* reexport */components_MsProgressTimeline
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsVisualContent", function () {
      return (/* reexport */components_MsVisualContent
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsTabs", function () {
      return (/* reexport */components_MsTabs
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsDisplayTimeline", function () {
      return (/* reexport */components_MsDisplayTimeline
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsQuotationParagraph", function () {
      return (/* reexport */components_MsQuotationParagraph
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsSmartbuyCard", function () {
      return (/* reexport */components_MsSmartbuyCard
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsSummaryLinks", function () {
      return (/* reexport */components_MsSummaryLinks
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsTable", function () {
      return (/* reexport */components_MsTable
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsCountdownTimer", function () {
      return (/* reexport */components_MsCountdownTimer
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsFaq", function () {
      return (/* reexport */components_MsFaq
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsProductCard", function () {
      return (/* reexport */components_MsProductCard
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsOneColumnContent", function () {
      return (/* reexport */components_MsOneColumnContent
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsTwoColumnContent", function () {
      return (/* reexport */components_MsTwoColumnContent
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsContentBox", function () {
      return (/* reexport */components_MsContentBox
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsHeroMasthead", function () {
      return (/* reexport */components_MsHeroMasthead
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsCallToAction", function () {
      return (/* reexport */components_MsCallToAction
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsFooterBanner", function () {
      return (/* reexport */components_MsFooterBanner
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsStepsColumn", function () {
      return (/* reexport */components_MsStepsColumn
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsVerticalColumn", function () {
      return (/* reexport */components_MsVerticalColumn
      );
    });
    __webpack_require__.d(__webpack_exports__, "MsQuickLinkMenu", function () {
      return (/* reexport */components_MsQuickLinkMenu
      );
    });

    // NAMESPACE OBJECT: ./src/components/index.js
    var components_namespaceObject = {};
    __webpack_require__.r(components_namespaceObject);
    __webpack_require__.d(components_namespaceObject, "MsAccordion", function () {
      return components_MsAccordion;
    });
    __webpack_require__.d(components_namespaceObject, "MsActionBlock", function () {
      return components_MsActionBlock;
    });
    __webpack_require__.d(components_namespaceObject, "MsActionButton", function () {
      return components_MsActionButton;
    });
    __webpack_require__.d(components_namespaceObject, "MsBadge", function () {
      return components_MsBadge;
    });
    __webpack_require__.d(components_namespaceObject, "MsBasicVerticalColumn", function () {
      return components_MsBasicVerticalColumn;
    });
    __webpack_require__.d(components_namespaceObject, "MsBreadcrumb", function () {
      return components_MsBreadcrumb;
    });
    __webpack_require__.d(components_namespaceObject, "MsButton", function () {
      return components_MsButton;
    });
    __webpack_require__.d(components_namespaceObject, "MsCardContainer", function () {
      return components_MsCardContainer;
    });
    __webpack_require__.d(components_namespaceObject, "MsCarousel", function () {
      return components_MsCarousel;
    });
    __webpack_require__.d(components_namespaceObject, "MsCategoryList", function () {
      return components_MsCategoryList;
    });
    __webpack_require__.d(components_namespaceObject, "MsCheckbox", function () {
      return components_MsCheckbox;
    });
    __webpack_require__.d(components_namespaceObject, "MsConvoDropdown", function () {
      return components_MsConvoDropdown;
    });
    __webpack_require__.d(components_namespaceObject, "MsConvoInputStepper", function () {
      return components_MsConvoInputStepper;
    });
    __webpack_require__.d(components_namespaceObject, "MsExtendedIntro", function () {
      return components_MsExtendedIntro;
    });
    __webpack_require__.d(components_namespaceObject, "MsDatePicker", function () {
      return components_MsDatePicker;
    });
    __webpack_require__.d(components_namespaceObject, "MsDropdown", function () {
      return components_MsDropdown;
    });
    __webpack_require__.d(components_namespaceObject, "MsError", function () {
      return components_MsError;
    });
    __webpack_require__.d(components_namespaceObject, "MsExpandableWrapper", function () {
      return components_MsExpandableWrapper;
    });
    __webpack_require__.d(components_namespaceObject, "MsFooter", function () {
      return components_MsFooter;
    });
    __webpack_require__.d(components_namespaceObject, "MsHeader", function () {
      return components_MsHeader;
    });
    __webpack_require__.d(components_namespaceObject, "MsHeading", function () {
      return components_MsHeading;
    });
    __webpack_require__.d(components_namespaceObject, "MsIcon", function () {
      return components_MsIcon;
    });
    __webpack_require__.d(components_namespaceObject, "MsImage", function () {
      return components_MsImage;
    });
    __webpack_require__.d(components_namespaceObject, "MsInfoCard", function () {
      return components_MsInfoCard;
    });
    __webpack_require__.d(components_namespaceObject, "MsInput", function () {
      return components_MsInput;
    });
    __webpack_require__.d(components_namespaceObject, "MsConvoInput", function () {
      return components_MsConvoInput;
    });
    __webpack_require__.d(components_namespaceObject, "MsInputPassword", function () {
      return components_MsInputPassword;
    });
    __webpack_require__.d(components_namespaceObject, "MsInputStepper", function () {
      return components_MsInputStepper;
    });
    __webpack_require__.d(components_namespaceObject, "MsIntro", function () {
      return components_MsIntro;
    });
    __webpack_require__.d(components_namespaceObject, "MsLink", function () {
      return components_MsLink;
    });
    __webpack_require__.d(components_namespaceObject, "MsListGroup", function () {
      return components_MsListGroup;
    });
    __webpack_require__.d(components_namespaceObject, "MsListingCard", function () {
      return components_MsListingCard;
    });
    __webpack_require__.d(components_namespaceObject, "MsListTable", function () {
      return components_MsListTable;
    });
    __webpack_require__.d(components_namespaceObject, "MsLoader", function () {
      return components_MsLoader;
    });
    __webpack_require__.d(components_namespaceObject, "MsMasthead", function () {
      return components_MsMasthead;
    });
    __webpack_require__.d(components_namespaceObject, "MsModal", function () {
      return components_MsModal;
    });
    __webpack_require__.d(components_namespaceObject, "MsMultiselect", function () {
      return components_MsMultiselect;
    });
    __webpack_require__.d(components_namespaceObject, "MsNotification", function () {
      return components_MsNotification;
    });
    __webpack_require__.d(components_namespaceObject, "MsPagination", function () {
      return components_MsPagination;
    });
    __webpack_require__.d(components_namespaceObject, "MsParagraph", function () {
      return components_MsParagraph;
    });
    __webpack_require__.d(components_namespaceObject, "MsPromotionSnippet", function () {
      return components_MsPromotionSnippet;
    });
    __webpack_require__.d(components_namespaceObject, "MsProgressBar", function () {
      return components_MsProgressBar;
    });
    __webpack_require__.d(components_namespaceObject, "MsQuickFacts", function () {
      return components_MsQuickFacts;
    });
    __webpack_require__.d(components_namespaceObject, "MsQuoteText", function () {
      return components_MsQuoteText;
    });
    __webpack_require__.d(components_namespaceObject, "MsRadioButton", function () {
      return components_MsRadioButton;
    });
    __webpack_require__.d(components_namespaceObject, "MsRating", function () {
      return components_MsRating;
    });
    __webpack_require__.d(components_namespaceObject, "MsSection", function () {
      return components_MsSection;
    });
    __webpack_require__.d(components_namespaceObject, "MsSectionHeader", function () {
      return components_MsSectionHeader;
    });
    __webpack_require__.d(components_namespaceObject, "MsSegmentedControl", function () {
      return components_MsSegmentedControl;
    });
    __webpack_require__.d(components_namespaceObject, "MsShare", function () {
      return components_MsShare;
    });
    __webpack_require__.d(components_namespaceObject, "MsSponsored", function () {
      return components_MsSponsored;
    });
    __webpack_require__.d(components_namespaceObject, "MsStepIndicator", function () {
      return components_MsStepIndicator;
    });
    __webpack_require__.d(components_namespaceObject, "MsSummaryCard", function () {
      return components_MsSummaryCard;
    });
    __webpack_require__.d(components_namespaceObject, "MsTooltip", function () {
      return components_MsTooltip;
    });
    __webpack_require__.d(components_namespaceObject, "MsProgressTimeline", function () {
      return components_MsProgressTimeline;
    });
    __webpack_require__.d(components_namespaceObject, "MsVisualContent", function () {
      return components_MsVisualContent;
    });
    __webpack_require__.d(components_namespaceObject, "MsTabs", function () {
      return components_MsTabs;
    });
    __webpack_require__.d(components_namespaceObject, "MsDisplayTimeline", function () {
      return components_MsDisplayTimeline;
    });
    __webpack_require__.d(components_namespaceObject, "MsQuotationParagraph", function () {
      return components_MsQuotationParagraph;
    });
    __webpack_require__.d(components_namespaceObject, "MsSmartbuyCard", function () {
      return components_MsSmartbuyCard;
    });
    __webpack_require__.d(components_namespaceObject, "MsSummaryLinks", function () {
      return components_MsSummaryLinks;
    });
    __webpack_require__.d(components_namespaceObject, "MsTable", function () {
      return components_MsTable;
    });
    __webpack_require__.d(components_namespaceObject, "MsCountdownTimer", function () {
      return components_MsCountdownTimer;
    });
    __webpack_require__.d(components_namespaceObject, "MsFaq", function () {
      return components_MsFaq;
    });
    __webpack_require__.d(components_namespaceObject, "MsProductCard", function () {
      return components_MsProductCard;
    });
    __webpack_require__.d(components_namespaceObject, "MsOneColumnContent", function () {
      return components_MsOneColumnContent;
    });
    __webpack_require__.d(components_namespaceObject, "MsTwoColumnContent", function () {
      return components_MsTwoColumnContent;
    });
    __webpack_require__.d(components_namespaceObject, "MsContentBox", function () {
      return components_MsContentBox;
    });
    __webpack_require__.d(components_namespaceObject, "MsHeroMasthead", function () {
      return components_MsHeroMasthead;
    });
    __webpack_require__.d(components_namespaceObject, "MsCallToAction", function () {
      return components_MsCallToAction;
    });
    __webpack_require__.d(components_namespaceObject, "MsFooterBanner", function () {
      return components_MsFooterBanner;
    });
    __webpack_require__.d(components_namespaceObject, "MsStepsColumn", function () {
      return components_MsStepsColumn;
    });
    __webpack_require__.d(components_namespaceObject, "MsVerticalColumn", function () {
      return components_MsVerticalColumn;
    });
    __webpack_require__.d(components_namespaceObject, "MsQuickLinkMenu", function () {
      return components_MsQuickLinkMenu;
    });

    // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
    // This file is imported into lib/wc client bundles.

    if (typeof window !== 'undefined') {
      if (true) {
        __webpack_require__("f6fd");
      }
      var setPublicPath_i;
      if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
        __webpack_require__.p = setPublicPath_i[1]; // eslint-disable-line
      }
    }

    // Indicate to webpack that this file can be concatenated
    /* harmony default export */
    var setPublicPath = null;

    // CONCATENATED MODULE: ./src/directives/click-outside.js
    /* harmony default export */
    var click_outside = {
      name: "ClickOutside",
      bind: function bind(el, binding, vNode) {
        var ele = el;
        if (typeof binding.value !== "function") {
          var componentName = vNode.context.name;
          var warn = "[vue-click-outside] provided expression '".concat(binding.expression, "' is not a function, but has to be");
          if (componentName) {
            warn += "Found in component '".concat(componentName, "'");
          }
          console.warn(warn);
        }
        var handler = function handler(event) {
          if (!ele.contains(event.target) && ele !== event.target) {
            binding.value(event);
          }
        };
        /* eslint-disable no-underscore-dangle */
        ele.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },
      unbind: function unbind(el) {
        var ele = el;
        document.removeEventListener("click", ele.__vueClickOutside__);
        ele.__vueClickOutside__ = null;
      }
    };
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordion.vue?vue&type=template&id=15772141&
    var MsAccordionvue_type_template_id_15772141_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('ul', {
        staticClass: "accordion",
        class: {
          'has-no-background': _vm.noBackground
        },
        attrs: {
          "role": "presentation"
        }
      }, [_vm._t("default")], 2);
    };
    var staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordion.vue?vue&type=template&id=15772141&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordion.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsAccordionvue_type_script_lang_js_ = {
      name: 'MsAccordion',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Accordion'
      },
      props: {
        /**
         * Allows user to enable no background for the accordion
        */
        noBackground: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordion.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsAccordion_MsAccordionvue_type_script_lang_js_ = MsAccordionvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier /* server only */, shadowMode /* vue-cli only */) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }
      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function (context) {
          // 2.3 injection
          context = context ||
          // cached call
          this.$vnode && this.$vnode.ssrContext ||
          // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
        } : injectStyles;
      }
      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functional component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
      return {
        exports: scriptExports,
        options: options
      };
    }

    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordion.vue

    /* normalize component */

    var component = normalizeComponent(MsAccordion_MsAccordionvue_type_script_lang_js_, MsAccordionvue_type_template_id_15772141_render, staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsAccordion = component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordionItem.vue?vue&type=template&id=7cdd12d1&
    var MsAccordionItemvue_type_template_id_7cdd12d1_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        staticClass: "accordion__item",
        class: [{
          'is-expanded': Boolean(_vm.MsAccordionItem.expanded)
        }],
        on: {
          "click": _vm.toggleExpand
        }
      }, [_vm._t("default")], 2);
    };
    var MsAccordionItemvue_type_template_id_7cdd12d1_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionItem.vue?vue&type=template&id=7cdd12d1&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordionItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsAccordionItemvue_type_script_lang_js_ = {
      name: 'MsAccordionItem',
      props: {
        rating: {
          type: Number,
          default: 0
        },
        expanded: {
          type: Boolean,
          default: false
        }
      },
      data: function data() {
        return {
          MsAccordionItem: {
            rating: this.rating,
            expanded: this.expanded
          }
        };
      },
      provide: function provide() {
        return {
          MsAccordionItem: this.MsAccordionItem
        };
      },
      methods: {
        toggleExpand: function toggleExpand() {
          this.MsAccordionItem.expanded = !this.MsAccordionItem.expanded;
          if (this.MsAccordionItem.expanded) {
            this.$emit('on-expanded');
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsAccordion_MsAccordionItemvue_type_script_lang_js_ = MsAccordionItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionItem.vue

    /* normalize component */

    var MsAccordionItem_component = normalizeComponent(MsAccordion_MsAccordionItemvue_type_script_lang_js_, MsAccordionItemvue_type_template_id_7cdd12d1_render, MsAccordionItemvue_type_template_id_7cdd12d1_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsAccordionItem = MsAccordionItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordionHeader.vue?vue&type=template&id=99ef3166&
    var MsAccordionHeadervue_type_template_id_99ef3166_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('ms-heading', {
        staticClass: "accordion__header",
        attrs: {
          "heading-tag": _vm.headingTag
        }
      }, [_c('button', {
        attrs: {
          "id": _vm.id,
          "type": "button",
          "aria-expanded": String(_vm.MsAccordionItem.expanded),
          "aria-controls": _vm.panelId
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('click');
          }
        }
      }, [_c('div', {
        staticClass: "accordion__header-title"
      }, [_vm._t("default"), _vm.showRating ? _c('ms-rating', {
        attrs: {
          "rating": _vm.MsAccordionItem.rating
        }
      }) : _vm._e()], 2), _c('div', {
        staticClass: "accordion__header-toggle"
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['fal', 'angle-down'],
          "size": "lg"
        }
      })], 1)])]);
    };
    var MsAccordionHeadervue_type_template_id_99ef3166_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionHeader.vue?vue&type=template&id=99ef3166&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeading/MsHeading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeadingvue_type_script_lang_js_ = {
      name: 'MsHeading',
      storybook: {
        path: 'Cargo Product Language/Patterns/Perceptual Pattern/Heading'
      },
      functional: true,
      props: {
        /**
         * Defines the heading tag
        */
        headingTag: {
          type: String,
          required: true,
          validator: function validator(value) {
            return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(value) !== -1;
          }
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          slots = _ref.slots;
        if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(props.headingTag) === -1) return null;
        return h(props.headingTag, data, slots().default);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeading/MsHeading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeading_MsHeadingvue_type_script_lang_js_ = MsHeadingvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeading/MsHeading.vue
    var MsHeading_render, MsHeading_staticRenderFns;

    /* normalize component */

    var MsHeading_component = normalizeComponent(MsHeading_MsHeadingvue_type_script_lang_js_, MsHeading_render, MsHeading_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeading = MsHeading_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsIcon/MsIcon.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsIconvue_type_script_lang_js_ = {
      name: 'MsIcon',
      storybook: {
        path: 'Cargo Product Language/Patterns/Perceptual Pattern/Icon'
      },
      functional: true,
      props: {
        /**
         * The size of the icon as defined by Font Awesome
         */
        size: {
          type: String,
          required: false
        }
      },
      render: function render(h, _ref) {
        var data = _ref.data;
        return h('fa', data);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsIcon/MsIcon.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsIcon_MsIconvue_type_script_lang_js_ = MsIconvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsIcon/MsIcon.vue
    var MsIcon_render, MsIcon_staticRenderFns;

    /* normalize component */

    var MsIcon_component = normalizeComponent(MsIcon_MsIconvue_type_script_lang_js_, MsIcon_render, MsIcon_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsIcon = MsIcon_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsRating/MsRating.vue?vue&type=template&id=10a3a652&
    var MsRatingvue_type_template_id_10a3a652_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('span', {
        class: ['star-rating', {
          'star-rating--vertical': _vm.isVertical
        }]
      }, [_c('div', {
        staticClass: "fa-wrap"
      }, [_vm._l(_vm.fullStars, function (value, index) {
        return _c('span', {
          key: "full-".concat(index),
          staticClass: "is-active"
        }, [_c('fa', {
          attrs: {
            "icon": ['fas', 'star']
          }
        })], 1);
      }), _vm._l(_vm.halfStars, function (value, index) {
        return _c('span', {
          key: "half-".concat(index),
          staticClass: "is-active"
        }, [_c('fa', {
          attrs: {
            "icon": ['fas', 'star-half-alt']
          }
        })], 1);
      }), _vm._l(_vm.emptyStars, function (value, index) {
        return _c('span', {
          key: "empty-".concat(index)
        }, [_c('fa', {
          attrs: {
            "icon": ['fas', 'star']
          }
        })], 1);
      })], 2), !_vm.hideLabel ? _c('span', {
        staticClass: "star-rating__label"
      }, [_vm._v(_vm._s(_vm.ratingLabel[_vm.roundRating]))]) : _vm._e()]);
    };
    var MsRatingvue_type_template_id_10a3a652_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsRating/MsRating.vue?vue&type=template&id=10a3a652&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsRating/MsRating.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsRatingvue_type_script_lang_js_ = {
      name: 'MsRating',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Rating'
      },
      props: {
        /**
         * Set minimum rating allowed
        */
        minRating: {
          type: Number,
          default: 0
        },
        /**
         * Set maximum rating allowed
        */
        maxRating: {
          type: Number,
          default: 5
        },
        /**
         * Set rating value
        */
        rating: {
          type: Number,
          default: 0
        },
        /**
         * Set array of rating labels
        */
        ratingLabel: {
          type: Array,
          default: function _default() {
            return ['OK', 'Average', 'Good', 'Very Good', 'Excellent'];
          }
        },
        /**
         * Set star rating ration
        */
        starRatio: {
          type: Number,
          default: 1
        },
        /**
         * Set rating orientation to vertical
        */
        isVertical: {
          type: Boolean,
          default: false
        },
        /**
         * Hide label on ratings
        */
        hideLabel: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        fullStars: function fullStars() {
          var rating = this.rating,
            starRatio = this.starRatio,
            maxRating = this.maxRating,
            minRating = this.minRating;
          if (rating > maxRating) return maxRating;
          if (rating < minRating) return minRating;
          return Math.floor(rating / starRatio);
        },
        halfStars: function halfStars() {
          var rating = this.rating,
            starRatio = this.starRatio,
            maxRating = this.maxRating,
            minRating = this.minRating;
          if (rating > maxRating) return 0;
          if (rating < minRating) return 1;
          var x = rating % starRatio;
          var i = 1 / 2 * starRatio;
          return x >= i ? 1 : 0;
        },
        emptyStars: function emptyStars() {
          return this.maxStars - this.fullStars - this.halfStars;
        },
        maxStars: function maxStars() {
          var maxRating = this.maxRating,
            starRatio = this.starRatio;
          return Math.ceil(maxRating / starRatio);
        },
        roundRating: function roundRating() {
          var rating = null;
          if (this.rating > this.ratingLabel.length) {
            rating = this.ratingLabel.length - 1;
          } else if (this.rating < 0) {
            rating = 0;
          } else {
            rating = Math.round(this.rating) - 1;
          }
          return rating;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsRating/MsRating.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsRating_MsRatingvue_type_script_lang_js_ = MsRatingvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsRating/MsRating.vue

    /* normalize component */

    var MsRating_component = normalizeComponent(MsRating_MsRatingvue_type_script_lang_js_, MsRatingvue_type_template_id_10a3a652_render, MsRatingvue_type_template_id_10a3a652_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsRating = MsRating_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordionHeader.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsAccordionHeadervue_type_script_lang_js_ = {
      name: 'MsAccordionHeader',
      components: {
        MsHeading: MsHeading,
        MsIcon: MsIcon,
        MsRating: MsRating
      },
      props: {
        id: {
          type: String,
          default: null,
          required: true
        },
        panelId: {
          type: String,
          default: null,
          required: true
        },
        icon: {
          type: Array,
          default: function _default() {
            return [];
          }
        },
        headingTag: {
          type: String,
          required: false,
          default: 'h2'
        }
      },
      inject: ['MsAccordionItem'],
      computed: {
        showRating: function showRating() {
          return this.MsAccordionItem.rating > 0;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsAccordion_MsAccordionHeadervue_type_script_lang_js_ = MsAccordionHeadervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionHeader.vue

    /* normalize component */

    var MsAccordionHeader_component = normalizeComponent(MsAccordion_MsAccordionHeadervue_type_script_lang_js_, MsAccordionHeadervue_type_template_id_99ef3166_render, MsAccordionHeadervue_type_template_id_99ef3166_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsAccordionHeader = MsAccordionHeader_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordionPanel.vue?vue&type=template&id=5f3cbf08&
    var MsAccordionPanelvue_type_template_id_5f3cbf08_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "accordion__panel",
        attrs: {
          "id": _vm.id,
          "aria-labelledby": _vm.headerId,
          "role": "region",
          "aria-hidden": String(!_vm.MsAccordionItem.expanded)
        }
      }, [_vm._t("default")], 2);
    };
    var MsAccordionPanelvue_type_template_id_5f3cbf08_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionPanel.vue?vue&type=template&id=5f3cbf08&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsAccordion/MsAccordionPanel.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsAccordionPanelvue_type_script_lang_js_ = {
      name: 'MsAccordionPanel',
      props: {
        id: {
          type: String,
          default: null,
          required: true
        },
        headerId: {
          type: String,
          default: null,
          required: true
        }
      },
      inject: ['MsAccordionItem']
    };
    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionPanel.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsAccordion_MsAccordionPanelvue_type_script_lang_js_ = MsAccordionPanelvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsAccordion/MsAccordionPanel.vue

    /* normalize component */

    var MsAccordionPanel_component = normalizeComponent(MsAccordion_MsAccordionPanelvue_type_script_lang_js_, MsAccordionPanelvue_type_template_id_5f3cbf08_render, MsAccordionPanelvue_type_template_id_5f3cbf08_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsAccordionPanel = MsAccordionPanel_component.exports;
    // CONCATENATED MODULE: ./src/components/MsAccordion/index.js

    var components = {
      MsAccordion: MsAccordion,
      MsAccordionItem: MsAccordionItem,
      MsAccordionHeader: MsAccordionHeader,
      MsIcon: MsIcon,
      MsRating: MsRating,
      MsAccordionPanel: MsAccordionPanel
    };
    MsAccordion.install = function (Vue) {
      Object.values(components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsAccordion = MsAccordion;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsActionBlock/MsActionBlock.vue?vue&type=template&id=32cad63e&
    var MsActionBlockvue_type_template_id_32cad63e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        ref: "action-block",
        staticClass: "action-block is-sticky-bottom is-border-t"
      }, [_c('div', {
        staticClass: "action-block__wrapper"
      }, [_c('div', {
        staticClass: "action-block__info"
      }, [_c('div', {
        staticClass: "action-block__label"
      }, [_vm._t("label")], 2), _c('div', {
        staticClass: "action-block__content"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.isButtonOnly,
          expression: "!isButtonOnly"
        }],
        staticClass: "unit-breakdown"
      }, [[_c('div', {
        staticClass: "unit-breakdown__group"
      }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
        staticClass: "unit-breakdown__price"
      }, [_vm.currency ? _c('sup', [_vm._v(_vm._s(_vm.currency))]) : _vm._e(), _vm._v(_vm._s(_vm.value) + "\n            ")]), _c('span', {
        staticClass: "unit-breakdown__discount-wrap"
      }, [_vm.discount || _vm.originalPrice ? _c('span', {
        staticClass: "unit-breakdown__original"
      }, [_c('span', {
        staticClass: "visually-hidden"
      }, [_vm._v("Original price")]), _c('s', [_vm._v(_vm._s(_vm.originalPrice))])]) : _vm._e(), _vm.discount || _vm.originalPrice ? _c('strong', {
        staticClass: "unit-breakdown__discount"
      }, [_vm._v(_vm._s(_vm.discount))]) : _vm._e()])]], 2), _c('div', {
        staticClass: "action-block-button__wrapper"
      }, [_vm._t("default")], 2)])])])]);
    };
    var MsActionBlockvue_type_template_id_32cad63e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsActionBlock/MsActionBlock.vue?vue&type=template&id=32cad63e&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsActionBlock/MsActionBlock.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsActionBlockvue_type_script_lang_js_ = {
      name: 'MsActionBlock',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/ActionBlock'
      },
      props: {
        /**
         * Set original price
         */
        originalPrice: {
          type: String
        },
        /**
         * Set discount value
         */
        discount: {
          type: String
        },
        /**
         * Set label
         */
        label: {
          type: String
        },
        /**
         * Set currency
         */
        currency: {
          type: String
        },
        /**
         * Set value
         */
        value: {
          type: String
        },
        /**
         * Only display CTA button on mobile
         */
        isButtonOnly: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsActionBlock/MsActionBlock.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsActionBlock_MsActionBlockvue_type_script_lang_js_ = MsActionBlockvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsActionBlock/MsActionBlock.vue

    /* normalize component */

    var MsActionBlock_component = normalizeComponent(MsActionBlock_MsActionBlockvue_type_script_lang_js_, MsActionBlockvue_type_template_id_32cad63e_render, MsActionBlockvue_type_template_id_32cad63e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsActionBlock = MsActionBlock_component.exports;
    // CONCATENATED MODULE: ./src/components/MsActionBlock/index.js

    var MsActionBlock_components = {
      MsActionBlock: MsActionBlock
    };
    MsActionBlock.install = function (Vue) {
      Object.values(MsActionBlock_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsActionBlock = MsActionBlock;
    // CONCATENATED MODULE: ./node_modules/vue-functional-data-merge/dist/lib.esm.js
    var lib_esm_e = function () {
        return (lib_esm_e = Object.assign || function (e) {
          for (var t, r = 1, s = arguments.length; r < s; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
          return e;
        }).apply(this, arguments);
      },
      lib_esm_t = {
        kebab: /-(\w)/g,
        styleProp: /:(.*)/,
        styleList: /;(?![^(]*\))/g
      };
    function r(e, t) {
      return t ? t.toUpperCase() : "";
    }
    function lib_esm_s(e) {
      for (var s, a = {}, c = 0, o = e.split(lib_esm_t.styleList); c < o.length; c++) {
        var n = o[c].split(lib_esm_t.styleProp),
          i = n[0],
          l = n[1];
        (i = i.trim()) && ("string" == typeof l && (l = l.trim()), a[(s = i, s.replace(lib_esm_t.kebab, r))] = l);
      }
      return a;
    }
    function a() {
      for (var t, r, a = {}, c = arguments.length; c--;) for (var o = 0, n = Object.keys(arguments[c]); o < n.length; o++) switch (t = n[o]) {
        case "class":
        case "style":
        case "directives":
          if (Array.isArray(a[t]) || (a[t] = []), "style" === t) {
            var i = void 0;
            i = Array.isArray(arguments[c].style) ? arguments[c].style : [arguments[c].style];
            for (var l = 0; l < i.length; l++) {
              var y = i[l];
              "string" == typeof y && (i[l] = lib_esm_s(y));
            }
            arguments[c].style = i;
          }
          a[t] = a[t].concat(arguments[c][t]);
          break;
        case "staticClass":
          if (!arguments[c][t]) break;
          void 0 === a[t] && (a[t] = ""), a[t] && (a[t] += " "), a[t] += arguments[c][t].trim();
          break;
        case "on":
        case "nativeOn":
          a[t] || (a[t] = {});
          for (var p = 0, f = Object.keys(arguments[c][t] || {}); p < f.length; p++) r = f[p], a[t][r] ? a[t][r] = [].concat(a[t][r], arguments[c][t][r]) : a[t][r] = arguments[c][t][r];
          break;
        case "attrs":
        case "props":
        case "domProps":
        case "scopedSlots":
        case "staticStyle":
        case "hook":
        case "transition":
          a[t] || (a[t] = {}), a[t] = lib_esm_e({}, arguments[c][t], a[t]);
          break;
        case "slot":
        case "key":
        case "ref":
        case "tag":
        case "show":
        case "keepAlive":
        default:
          a[t] || (a[t] = arguments[c][t]);
      }
      return a;
    }

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsActionButton/MsActionButton.vue?vue&type=script&lang=js&

    var MsActionButtonvue_type_script_lang_js_props = {
      checked: {
        type: Boolean,
        default: null
      },
      disabled: {
        type: Boolean,
        default: null
      },
      actionIcon: {
        type: Array,
        default: function _default() {
          return ['fal', 'sliders-h'];
        }
      },
      statusIcon: {
        type: Array,
        default: function _default() {
          return ['far', 'check'];
        }
      }
    };
    /* harmony default export */
    var MsActionButtonvue_type_script_lang_js_ = {
      name: 'MsActionButton',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Action Button'
      },
      functional: true,
      props: MsActionButtonvue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data;
        var actionIcon = [h(MsIcon, {
          props: {
            icon: props.actionIcon
          }
        })];
        var statusIcon = [h(MsIcon, {
          props: {
            icon: props.statusIcon
          }
        })];
        var checkLabel = h('div', {
          staticClass: 'action-btn__status'
        }, [statusIcon]);
        var innerBtn = h('button', {
          staticClass: 'btn action-btn__button',
          class: props.disabled ? 'btn--disabled' : null,
          attrs: {
            disabled: props.disabled
          }
        }, [actionIcon]);
        var actionBtn = h('div', a(data, {
          staticClass: 'action-btn'
        }), [innerBtn, props.checked ? checkLabel : null]);
        return actionBtn;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsActionButton/MsActionButton.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsActionButton_MsActionButtonvue_type_script_lang_js_ = MsActionButtonvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsActionButton/MsActionButton.vue
    var MsActionButton_render, MsActionButton_staticRenderFns;

    /* normalize component */

    var MsActionButton_component = normalizeComponent(MsActionButton_MsActionButtonvue_type_script_lang_js_, MsActionButton_render, MsActionButton_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsActionButton = MsActionButton_component.exports;
    // CONCATENATED MODULE: ./src/components/MsActionButton/index.js

    MsActionButton.install = function (Vue) {
      return Vue.component(MsActionButton.name, MsActionButton);
    };
    /* harmony default export */
    var components_MsActionButton = MsActionButton;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsBadge/MsBadge.vue?vue&type=template&id=ef94e288&
    function _typeof(obj) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
      key = _toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function _toPropertyKey(arg) {
      var key = _toPrimitive(arg, "string");
      return _typeof(key) === "symbol" ? key : String(key);
    }
    function _toPrimitive(input, hint) {
      if (_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsBadgevue_type_template_id_ef94e288_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "badge",
        class: _defineProperty({}, "badge--".concat(_vm.type), Boolean(_vm.type))
      }, [_c('div', {
        staticClass: "badge__label"
      }, [_vm._t("default")], 2)]);
    };
    var MsBadgevue_type_template_id_ef94e288_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsBadge/MsBadge.vue?vue&type=template&id=ef94e288&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsBadge/MsBadge.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsBadgevue_type_script_lang_js_ = {
      name: 'MsBadge',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Badge'
      },
      props: {
        type: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsBadge/MsBadge.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsBadge_MsBadgevue_type_script_lang_js_ = MsBadgevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsBadge/MsBadge.vue

    /* normalize component */

    var MsBadge_component = normalizeComponent(MsBadge_MsBadgevue_type_script_lang_js_, MsBadgevue_type_template_id_ef94e288_render, MsBadgevue_type_template_id_ef94e288_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsBadge = MsBadge_component.exports;
    // CONCATENATED MODULE: ./src/components/MsBadge/index.js

    MsBadge.install = function (Vue) {
      return Vue.component(MsBadge.name, MsBadge);
    };
    /* harmony default export */
    var components_MsBadge = MsBadge;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsBasicVerticalColumn/MsBasicVerticalColumn.vue?vue&type=template&id=23084b12&
    var MsBasicVerticalColumnvue_type_template_id_23084b12_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "basic-vertical-column",
        class: [_vm.$attrs.class, _vm.$attrs.staticClass]
      }, [_c('div', {
        staticClass: "basic-vertical-column__header"
      }, [_vm._t("section-header")], 2), _c('div', {
        staticClass: "basic-vertical-column__content"
      }, [_vm._t("default")], 2)]);
    };
    var MsBasicVerticalColumnvue_type_template_id_23084b12_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsBasicVerticalColumn/MsBasicVerticalColumn.vue?vue&type=template&id=23084b12&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsBasicVerticalColumn/MsBasicVerticalColumn.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsBasicVerticalColumnvue_type_script_lang_js_ = {
      name: 'MsBasicVerticalColumn',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Basic Vertical Column'
      }
    };
    // CONCATENATED MODULE: ./src/components/MsBasicVerticalColumn/MsBasicVerticalColumn.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsBasicVerticalColumn_MsBasicVerticalColumnvue_type_script_lang_js_ = MsBasicVerticalColumnvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsBasicVerticalColumn/MsBasicVerticalColumn.vue

    /* normalize component */

    var MsBasicVerticalColumn_component = normalizeComponent(MsBasicVerticalColumn_MsBasicVerticalColumnvue_type_script_lang_js_, MsBasicVerticalColumnvue_type_template_id_23084b12_render, MsBasicVerticalColumnvue_type_template_id_23084b12_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsBasicVerticalColumn = MsBasicVerticalColumn_component.exports;
    // CONCATENATED MODULE: ./src/components/MsBasicVerticalColumn/index.js

    MsBasicVerticalColumn.install = function (Vue) {
      return Vue.component(MsBasicVerticalColumn.name, MsBasicVerticalColumn);
    };
    /* harmony default export */
    var components_MsBasicVerticalColumn = MsBasicVerticalColumn;
    // CONCATENATED MODULE: ./src/utils/array.js
    // --- Static ---

    var from = Array.from;
    var isArray = Array.isArray;

    // --- Instance ---

    var arrayIncludes = function arrayIncludes(array, value) {
      return array.indexOf(value) !== -1;
    };
    var concat = function concat() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return Array.prototype.concat.apply([], args);
    };
    // CONCATENATED MODULE: ./src/utils/object.js
    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
          object_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function object_defineProperty(obj, key, value) {
      key = object_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function object_toPropertyKey(arg) {
      var key = object_toPrimitive(arg, "string");
      return object_typeof(key) === "symbol" ? key : String(key);
    }
    function object_toPrimitive(input, hint) {
      if (object_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (object_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    function object_typeof(obj) {
      "@babel/helpers - typeof";

      return object_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, object_typeof(obj);
    }

    // --- Static ---

    var object_assign = Object.assign;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var keys = Object.keys;
    var defineProperties = Object.defineProperties;
    var defineProperty = Object.defineProperty;
    var freeze = Object.freeze;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getPrototypeOf = Object.getPrototypeOf;
    var create = Object.create;
    var isFrozen = Object.isFrozen;
    var is = Object.is;

    // --- "Instance" ---

    var object_hasOwnProperty = function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };

    // --- Utilities ---

    /**
     * Quick object check - this is primarily used to tell
     * Objects from primitive values when we know the value
     * is a JSON-compliant type.
     * Note object could be a complex type like array, date, etc.
     */
    var isObject = function isObject(obj) {
      return obj !== null && object_typeof(obj) === 'object';
    };

    /**
     * Strict object type check. Only returns true
     * for plain JavaScript objects.
     */
    var isPlainObject = function isPlainObject(obj) {
      return Object.prototype.toString.call(obj) === '[object Object]';
    };

    // @link https://gist.github.com/bisubus/2da8af7e801ffd813fab7ac221aa7afc
    var omit = function omit(obj, props) {
      return keys(obj).filter(function (key) {
        return props.indexOf(key) === -1;
      }).reduce(function (result, key) {
        return _objectSpread(_objectSpread({}, result), {}, object_defineProperty({}, key, obj[key]));
      }, {});
    };
    var readonlyDescriptor = function readonlyDescriptor() {
      return {
        enumerable: true,
        configurable: false,
        writable: false
      };
    };

    /**
     * Deep-freezes and object, making it immutable / read-only.
     * Returns the same object passed-in, but frozen.
     * Freezes inner object/array/values first.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
     * Note: this method will not work for property values using Symbol() as a key
     */
    var object_deepFreeze = function deepFreeze(obj) {
      // Retrieve the property names defined on object/array
      // Note: `keys` will ignore properties that are keyed by a `Symbol()`
      var props = keys(obj);
      // Iterate over each prop and recursively freeze it
      props.forEach(function (prop) {
        var value = obj[prop];
        // If value is a plain object or array, we deepFreeze it
        // eslint-disable-next-line no-param-reassign
        obj[prop] = value && (isPlainObject(value) || isArray(value)) ? deepFreeze(value) : value;
      });
      return freeze(obj);
    };
    // CONCATENATED MODULE: ./src/utils/inspect.js
    function inspect_typeof(obj) {
      "@babel/helpers - typeof";

      return inspect_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, inspect_typeof(obj);
    }
    /**
     * Convenience inspection utilities
     */

    var toType = function toType(val) {
      return inspect_typeof(val);
    };
    var toRawType = function toRawType(val) {
      return Object.prototype.toString.call(val).slice(8, -1);
    };
    var toRawTypeLC = function toRawTypeLC(val) {
      return toRawType(val).toLowerCase();
    };
    var isUndefined = function isUndefined(val) {
      return val === undefined;
    };
    var isNull = function isNull(val) {
      return val === null;
    };
    var isFunction = function isFunction(val) {
      return toType(val) === 'function';
    };
    var isBoolean = function isBoolean(val) {
      return toType(val) === 'boolean';
    };
    var isString = function isString(val) {
      return toType(val) === 'string';
    };
    var isNumber = function isNumber(val) {
      return toType(val) === 'number';
    };
    var isPrimitive = function isPrimitive(val) {
      return isBoolean(val) || isString(val) || isNumber(val);
    };
    var isDate = function isDate(val) {
      return val instanceof Date;
    };
    var isRegExp = function isRegExp(val) {
      return toRawType(val) === 'RegExp';
    };
    var isPromise = function isPromise(val) {
      return !isUndefined(val) && !isNull(val) && isFunction(val.then) && isFunction(val.catch);
    };

    // Extra convenience named re-exports

    // CONCATENATED MODULE: ./src/utils/to-string.js

    /**
     * Convert a value to a string that can be rendered.
     */
    var to_string_toString = function toString(val) {
      var spaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      return isUndefined(val) || isNull(val) ? '' : isArray(val) || isPlainObject(val) && val.toString === Object.prototype.toString ? JSON.stringify(val, null, spaces) : String(val);
    };
    /* harmony default export */
    var to_string = to_string_toString;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsLink/MsLink.vue?vue&type=script&lang=js&
    function MsLinkvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsLinkvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsLinkvue_type_script_lang_js_typeof(obj);
    }
    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function MsLinkvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsLinkvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsLinkvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsLinkvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsLinkvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsLinkvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsLinkvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsLinkvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsLinkvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsLinkvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsLinkvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsLinkvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsLinkvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var ANCHOR_TAG = 'a';
    var linkPropsFactory = function linkPropsFactory() {
      return {
        href: {
          type: String,
          default: null
        },
        rel: {
          type: String,
          default: null
        },
        target: {
          type: String,
          default: '_self'
        },
        active: {
          type: Boolean,
          default: false
        },
        /**
         * Color of the button.
         */
        disabled: {
          type: Boolean,
          default: false
        },
        to: {
          type: [String, Object],
          default: null
        },
        redirect: {
          type: Boolean,
          default: null
        },
        append: {
          type: Boolean,
          default: false
        },
        replace: {
          type: Boolean,
          default: false
        },
        event: {
          type: [String, Array],
          default: 'click'
        },
        activeClass: {
          type: String
        },
        exact: {
          type: Boolean,
          default: false
        },
        exactActiveClass: {
          type: String
        },
        routerTag: {
          type: String,
          default: 'a'
        },
        noPrefetch: {
          type: Boolean,
          default: false
        }
      };
    };

    // Precompile RegExp
    var commaRE = /%2C/g;
    var encodeReserveRE = /[!'()*]/g;
    // Method to replace reserved chars
    var encodeReserveReplacer = function encodeReserveReplacer(c) {
      return "%".concat(c.charCodeAt(0).toString(16));
    };

    // Fixed encodeURIComponent which is more conformant to RFC3986:
    // - escapes [!'()*]
    // - preserve commas
    var MsLinkvue_type_script_lang_js_encode = function encode(str) {
      return encodeURIComponent(to_string(str)).replace(encodeReserveRE, encodeReserveReplacer).replace(commaRE, ',');
    };
    var MsLinkvue_type_script_lang_js_stringifyQueryObj = function stringifyQueryObj(obj) {
      if (!isPlainObject(obj)) {
        return '';
      }
      var query = keys(obj).map(function (key) {
        var val = obj[key];
        if (isUndefined(val)) {
          return '';
        }
        if (isNull(val)) {
          return MsLinkvue_type_script_lang_js_encode(key);
        }
        if (isArray(val)) {
          return val.reduce(function (results, val2) {
            if (isNull(val2)) {
              results.push(MsLinkvue_type_script_lang_js_encode(key));
            }
            if (!isUndefined(val2)) {
              // Faster than string interpolation
              results.push("".concat(MsLinkvue_type_script_lang_js_encode(key), "=").concat(MsLinkvue_type_script_lang_js_encode(val2)));
            }
            return results;
          }, []).join('&');
        }
        // Faster than string interpolation
        return "".concat(MsLinkvue_type_script_lang_js_encode(key), "=").concat(MsLinkvue_type_script_lang_js_encode(val));
      })
      /* must check for length, as we only want to filter empty strings, not things that look falsey! */.filter(function (x) {
        return x.length > 0;
      }).join('&');
      return query ? "?".concat(query) : '';
    };
    var _isRouterLink = function isRouterLink(tag) {
      return to_string(tag).toLowerCase() !== ANCHOR_TAG;
    };
    var MsLinkvue_type_script_lang_js_computeRel = function computeRel() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref.target,
        rel = _ref.rel;
      if (target === '_blank' && isNull(rel)) {
        return 'noopener';
      }
      return rel || null;
    };
    var computeTag = function computeTag() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        to = _ref2.to,
        disabled = _ref2.disabled,
        redirect = _ref2.redirect;
      var thisOrParent = arguments.length > 1 ? arguments[1] : undefined;
      return thisOrParent.$router && to && !disabled && !redirect ? thisOrParent.$nuxt ? 'nuxt-link' : 'router-link' : ANCHOR_TAG;
    };
    var MsLinkvue_type_script_lang_js_computeHref = function computeHref() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        href = _ref3.href,
        to = _ref3.to;
      var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ANCHOR_TAG;
      var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#';
      var toFallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
      // We've already checked the $router in computeTag(), so isRouterLink() indicates a live router.
      // When deferring to Vue Router's router-link, don't use the href attribute at all.
      // We return null, and then remove href from the attributes passed to router-link
      if (_isRouterLink(tag)) {
        return null;
      }

      // Return `href` when explicitly provided
      if (href) {
        return href;
      }

      // Reconstruct `href` when `to` used, but no router
      if (to) {
        // Fallback to `to` prop (if `to` is a string)
        if (isString(to)) {
          return to || toFallback;
        }
        // Fallback to `to.path + to.query + to.hash` prop (if `to` is an object)
        if (isPlainObject(to) && (to.path || to.query || to.hash)) {
          var path = to_string(to.path);
          var query = MsLinkvue_type_script_lang_js_stringifyQueryObj(to.query);
          var hash = to_string(to.hash);
          hash = !hash || hash.charAt(0) === '#' ? hash : "#".concat(hash);
          return "".concat(path).concat(query).concat(hash) || toFallback;
        }
      }

      // If nothing is provided return the fallback
      return fallback;
    };
    /* harmony default export */
    var MsLinkvue_type_script_lang_js_ = {
      name: 'MsLink',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Link'
      },
      inheritAttrs: false,
      props: linkPropsFactory(),
      computed: {
        computedTag: function computedTag() {
          // We don't pass `this` as the first arg as we need reactivity of the props
          return computeTag({
            to: this.to,
            disabled: this.disabled,
            redirect: this.redirect
          }, this);
        },
        isRouterLink: function isRouterLink() {
          return _isRouterLink(this.computedTag);
        },
        computedRel: function computedRel() {
          // We don't pass `this` as the first arg as we need reactivity of the props
          return MsLinkvue_type_script_lang_js_computeRel({
            target: this.target,
            rel: this.rel
          });
        },
        computedHref: function computedHref() {
          // We don't pass `this` as the first arg as we need reactivity of the props
          return MsLinkvue_type_script_lang_js_computeHref({
            to: this.to,
            href: this.href
          }, this.computedTag);
        },
        computedProps: function computedProps() {
          return this.isRouterLink ? MsLinkvue_type_script_lang_js_objectSpread(MsLinkvue_type_script_lang_js_objectSpread({}, this.$props), {}, {
            tag: this.routerTag
          }) : {};
        }
      },
      methods: {
        onClick: function onClick(evt) {
          var _arguments = arguments;
          var isEvent = evt instanceof Event;
          var isARouterLink = this.isRouterLink;
          var suppliedHandler = this.$listeners.click;
          if (isEvent && this.disabled) {
            // Stop event from bubbling up
            evt.stopPropagation();
            // Kill the event loop attached to this specific `EventTarget`
            // Needed to prevent `vue-router` for doing it's thing
            evt.stopImmediatePropagation();
          } else {
            /* eslint-disable no-underscore-dangle */
            /* istanbul ignore next: difficult to test, but we know it works */
            if (isARouterLink && evt.currentTarget__vue__) {
              // Router links do not emit instance `click` events, so we
              // add in an $emit('click', evt) on it's vue instance
              evt.currentTarget.__vue__.$emit('click', evt);
            }
            /* eslint-disable prefer-rest-params */
            // Call the suppliedHandler(s), if any provided
            concat(suppliedHandler).filter(function (h) {
              return isFunction(h);
            }).forEach(function (handler) {
              handler.apply(void 0, _toConsumableArray(_arguments));
            });
            // Emit the global $root click event
            this.$root.$emit('clicked::link', evt);
          }
          // Stop scroll-to-top behavior or navigation on
          // regular links when href is just '#'
          if (isEvent && (this.disabled || !_isRouterLink && this.computedHref === '#')) {
            evt.preventDefault();
          }
        },
        focus: function focus() {
          if (this.$el && this.$el.focus) {
            this.$el.focus();
          }
        },
        blur: function blur() {
          if (this.$el && this.$el.blur) {
            this.$el.blur();
          }
        }
      },
      render: function render(h) {
        var tag = this.computedTag;
        var rel = this.computedRel;
        var href = this.computedHref;
        var routerLink = this.isRouterLink;

        // We want to overwrite any click handler since our callback
        // will invoke the user supplied handler9s) if !props.disabled
        var handlers = MsLinkvue_type_script_lang_js_objectSpread(MsLinkvue_type_script_lang_js_objectSpread({}, this.$listeners), {}, {
          click: this.onClick
        });
        var componentData = {
          class: {
            active: this.active,
            disabled: this.disabled
          },
          attrs: MsLinkvue_type_script_lang_js_objectSpread(MsLinkvue_type_script_lang_js_objectSpread({}, this.$attrs), {}, {
            rel: rel,
            target: this.target,
            tabindex: this.disabled ? '-1' : isUndefined(this.$attrs.tabindex) ? null : this.$attrs.tabindex,
            'aria-disabled': this.disabled ? 'true' : null
          }),
          props: this.computedProps,
          on: routerLink ? {} : handlers
        };

        // If href attribute exists on <router-link> (even undefined or null) it fails working on
        // SSR, so we explicitly add it here if needed (i.e. if computedHref() is truthy)
        if (href) {
          componentData.attrs.href = href;
        } else {
          // Ensure the prop HREF does not exist for router links
          delete componentData.props.href;
        }
        return h(tag, componentData, this.$slots.default);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsLink/MsLink.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsLink_MsLinkvue_type_script_lang_js_ = MsLinkvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsLink/MsLink.vue
    var MsLink_render, MsLink_staticRenderFns;

    /* normalize component */

    var MsLink_component = normalizeComponent(MsLink_MsLinkvue_type_script_lang_js_, MsLink_render, MsLink_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsLink = MsLink_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsBreadcrumb/MsBreadcrumb.vue?vue&type=script&lang=js&
    function MsBreadcrumbvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsBreadcrumbvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsBreadcrumbvue_type_script_lang_js_typeof(obj);
    }
    function MsBreadcrumbvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsBreadcrumbvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsBreadcrumbvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsBreadcrumbvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsBreadcrumbvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsBreadcrumbvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsBreadcrumbvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsBreadcrumbvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsBreadcrumbvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsBreadcrumbvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsBreadcrumbvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsBreadcrumbvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsBreadcrumbvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    /* harmony default export */
    var MsBreadcrumbvue_type_script_lang_js_ = {
      name: 'MsBreadcrumb',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Breadcrumb'
      },
      functional: true,
      props: {
        /**
           * Display breadcrumb to be used on checkout flow
          */
        form: {
          type: Boolean,
          default: null
        },
        /**
           * Sets the visual mode of the component from light to dark
          */
        dark: {
          type: Boolean,
          default: null
        },
        /**
           * Sets mobile label for form breadcrumb
          */
        stepLabel: {
          type: String,
          default: 'Step'
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var mainClass = 'breadcrumbs';
        var $unorderedList = h('ol', slots().default);
        var mobileLabel = '';
        var items = slots().default.filter(function (item) {
          return item.tag === 'li';
        });
        var activeItemIndex = items.findIndex(function (item) {
          return item.data.staticClass.includes("breadcrumbs__item--active");
        });
        if (props.form) {
          mobileLabel = "".concat(props.stepLabel, " ").concat(activeItemIndex + 1, " of ").concat(items.length);
        }
        var $stepList = h('p', {
          staticClass: "".concat(mainClass, "__step-list")
        }, mobileLabel);
        var formClass = props.form ? " ".concat(mainClass, "--form") : '';
        var formAttributes = props.form ? {
          'tabindex': '0',
          'aria-label': mainClass
        } : {};
        var darkClass = props.dark ? " ".concat(mainClass, "--dark") : '';
        var navAttributes = {
          staticClass: mainClass,
          class: "".concat(formClass).concat(darkClass),
          attrs: MsBreadcrumbvue_type_script_lang_js_objectSpread({}, formAttributes)
        };
        var $nav = h('nav', navAttributes, [$unorderedList, $stepList]);
        return $nav;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsBreadcrumb/MsBreadcrumb.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsBreadcrumb_MsBreadcrumbvue_type_script_lang_js_ = MsBreadcrumbvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsBreadcrumb/MsBreadcrumb.vue
    var MsBreadcrumb_render, MsBreadcrumb_staticRenderFns;

    /* normalize component */

    var MsBreadcrumb_component = normalizeComponent(MsBreadcrumb_MsBreadcrumbvue_type_script_lang_js_, MsBreadcrumb_render, MsBreadcrumb_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsBreadcrumb = MsBreadcrumb_component.exports;
    // CONCATENATED MODULE: ./src/utils/identity.js
    var identity = function identity(x) {
      return x;
    };
    /* harmony default export */
    var utils_identity = identity;
    // CONCATENATED MODULE: ./src/utils/pluck-props.js

    /**
     * Given an array of properties or an object of property keys,
     * plucks all the values off the target object, returning a new object
     * that has props that reference the original prop values
     *
     * @param {{}|string[]} keysToPluck
     * @param {{}} objToPluck
     * @param {Function} transformFn
     * @return {{}}
     */
    var pluck_props_pluckProps = function pluckProps(keysToPluck, objToPluck) {
      var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : utils_identity;
      return (isArray(keysToPluck) ? keysToPluck.slice() : keys(keysToPluck)).reduce(function (memo, prop) {
        // eslint-disable-next-line no-param-reassign
        memo[transformFn(prop)] = objToPluck[prop];
        return memo;
      }, {});
    };
    /* harmony default export */
    var pluck_props = pluck_props_pluckProps;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsBreadcrumb/MsBreadcrumbItem.vue?vue&type=script&lang=js&
    function MsBreadcrumbItemvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsBreadcrumbItemvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsBreadcrumbItemvue_type_script_lang_js_typeof(obj);
    }
    function MsBreadcrumbItemvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsBreadcrumbItemvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsBreadcrumbItemvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsBreadcrumbItemvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsBreadcrumbItemvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsBreadcrumbItemvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsBreadcrumbItemvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsBreadcrumbItemvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsBreadcrumbItemvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsBreadcrumbItemvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsBreadcrumbItemvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsBreadcrumbItemvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsBreadcrumbItemvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var breadcrumbItemProps = {
      /**
       * When set to 'true', places the component in active state with active styling
      */
      active: {
        type: Boolean,
        default: null
      }
    };
    var linkProps = linkPropsFactory();
    delete linkProps.href.default;
    delete linkProps.to.default;
    var linkPropKeys = keys(linkProps);
    var MsBreadcrumbItemvue_type_script_lang_js_props = MsBreadcrumbItemvue_type_script_lang_js_objectSpread(MsBreadcrumbItemvue_type_script_lang_js_objectSpread({}, breadcrumbItemProps), linkProps);
    var isLink = function isLink(props) {
      return Boolean(props.href || props.to);
    };

    // Compute the link props to pass to ms-link (if required)
    var MsBreadcrumbItemvue_type_script_lang_js_computeLinkProps = function computeLinkProps(props) {
      return isLink(props) ? pluck_props(linkPropKeys, props) : null;
    };
    /* harmony default export */
    var MsBreadcrumbItemvue_type_script_lang_js_ = {
      name: 'MsBreadcrumbItem',
      functional: true,
      props: MsBreadcrumbItemvue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          slots = _ref.slots;
        var baseClass = 'breadcrumbs__item';
        var isActive = props.active;
        var link = isLink(props);
        var itemTag = link || !isActive ? MsLink : 'span';
        var componentData = {
          props: MsBreadcrumbItemvue_type_script_lang_js_computeLinkProps(props)
        };
        var $link = h(itemTag, a(data, componentData), slots().default);
        var $icon = h('fa', {
          staticClass: 'breadcrumbs__divider',
          attrs: {
            icon: ['fal', 'angle-right']
          }
        });
        var itemAttributes = {
          staticClass: baseClass
        };
        if (props.active) {
          itemAttributes = {
            staticClass: "".concat(baseClass, " ").concat(baseClass, "--active"),
            attrs: {
              'tabindex': '0',
              'aria-current': 'page'
            }
          };
        }
        var $nav = h('li', itemAttributes, [$link, $icon]);
        return $nav;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsBreadcrumb/MsBreadcrumbItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsBreadcrumb_MsBreadcrumbItemvue_type_script_lang_js_ = MsBreadcrumbItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsBreadcrumb/MsBreadcrumbItem.vue
    var MsBreadcrumbItem_render, MsBreadcrumbItem_staticRenderFns;

    /* normalize component */

    var MsBreadcrumbItem_component = normalizeComponent(MsBreadcrumb_MsBreadcrumbItemvue_type_script_lang_js_, MsBreadcrumbItem_render, MsBreadcrumbItem_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsBreadcrumbItem = MsBreadcrumbItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsBreadcrumb/index.js

    var MsBreadcrumb_components = {
      MsLink: MsLink,
      MsBreadcrumb: MsBreadcrumb,
      MsBreadcrumbItem: MsBreadcrumbItem
    };
    MsBreadcrumb.install = function (Vue) {
      Object.values(MsBreadcrumb_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsBreadcrumb = MsBreadcrumb;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsButton/MsButtonLabel.vue?vue&type=script&lang=js&

    var MsButtonLabelvue_type_script_lang_js_props = {
      label: {
        type: String,
        default: ''
      },
      labelTag: {
        type: String,
        default: 'span'
      }
    };
    /* harmony default export */
    var MsButtonLabelvue_type_script_lang_js_ = {
      name: 'MsButtonLabel',
      functional: true,
      props: MsButtonLabelvue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          children = _ref.children;
        return h(props.labelTag, a(data, {
          staticClass: 'btn__label'
        }), children || props.label);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsButton/MsButtonLabel.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsButton_MsButtonLabelvue_type_script_lang_js_ = MsButtonLabelvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsButton/MsButtonLabel.vue
    var MsButtonLabel_render, MsButtonLabel_staticRenderFns;

    /* normalize component */

    var MsButtonLabel_component = normalizeComponent(MsButton_MsButtonLabelvue_type_script_lang_js_, MsButtonLabel_render, MsButtonLabel_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsButtonLabel = MsButtonLabel_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsButton/MsButtonWrapper.vue?vue&type=script&lang=js&

    var MsButtonWrappervue_type_script_lang_js_props = {
      wrapperTag: {
        type: String,
        default: 'div'
      }
    };
    /* harmony default export */
    var MsButtonWrappervue_type_script_lang_js_ = {
      name: 'MsButtonWrapper',
      functional: true,
      props: MsButtonWrappervue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          children = _ref.children;
        return h(props.wrapperTag, a(data, {
          staticClass: 'btn__wrapper'
        }), children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsButton/MsButtonWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsButton_MsButtonWrappervue_type_script_lang_js_ = MsButtonWrappervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsButton/MsButtonWrapper.vue
    var MsButtonWrapper_render, MsButtonWrapper_staticRenderFns;

    /* normalize component */

    var MsButtonWrapper_component = normalizeComponent(MsButton_MsButtonWrappervue_type_script_lang_js_, MsButtonWrapper_render, MsButtonWrapper_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsButtonWrapper = MsButtonWrapper_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsButton/MsButton.vue?vue&type=script&lang=js&
    function MsButtonvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsButtonvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsButtonvue_type_script_lang_js_typeof(obj);
    }
    function MsButtonvue_type_script_lang_js_toConsumableArray(arr) {
      return MsButtonvue_type_script_lang_js_arrayWithoutHoles(arr) || MsButtonvue_type_script_lang_js_iterableToArray(arr) || MsButtonvue_type_script_lang_js_unsupportedIterableToArray(arr) || MsButtonvue_type_script_lang_js_nonIterableSpread();
    }
    function MsButtonvue_type_script_lang_js_nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function MsButtonvue_type_script_lang_js_unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return MsButtonvue_type_script_lang_js_arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MsButtonvue_type_script_lang_js_arrayLikeToArray(o, minLen);
    }
    function MsButtonvue_type_script_lang_js_iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function MsButtonvue_type_script_lang_js_arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return MsButtonvue_type_script_lang_js_arrayLikeToArray(arr);
    }
    function MsButtonvue_type_script_lang_js_arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function MsButtonvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsButtonvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsButtonvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsButtonvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsButtonvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsButtonvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsButtonvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsButtonvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsButtonvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsButtonvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsButtonvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsButtonvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsButtonvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }

    // Setup Props
    var btnProps = {
      /**
         * Set button active state
        */
      active: {
        type: Boolean,
        default: false
      },
      /**
         * Set button hover state
        */
      hovered: {
        type: Boolean,
        default: false
      },
      /**
         * Set button disabled state
        */
      disabled: {
        type: Boolean,
        default: false
      },
      /**
         * Renders a 100% width button (expands to the width of its parent container)
        */
      block: {
        type: Boolean,
        default: false
      },
      /**
         * Set the size of the button component
         * @values sm
        */
      size: {
        type: String,
        default: null
      },
      /**
         * Applies one of Cargo color variant to button
         * @values primary, secondary, ghost
        */
      use: {
        type: String,
        default: 'primary'
      },
      /**
         * Sets the rounded button variant
        */
      rounded: {
        type: Boolean,
        default: false
      },
      /**
         * Specify the HTML tag to render instead of the default tag
        */
      tag: {
        type: String,
        default: 'button'
      },
      /**
         * Set the value of the button's type attribute
         * @values button, submit, reset
        */
      type: {
        type: String,
        default: 'button'
      },
      /**
         * Set the position of the icon element in the button component
        */
      position: {
        type: String,
        default: 'start'
      },
      /**
         * Set the button component to have icon only
        */
      iconOnly: {
        type: Boolean,
        default: false
      },
      /**
         * Set the loading state of button component
        */
      isLoading: {
        type: Boolean,
        default: false
      }
    };
    var MsButtonvue_type_script_lang_js_linkProps = linkPropsFactory();
    delete MsButtonvue_type_script_lang_js_linkProps.href.default;
    delete MsButtonvue_type_script_lang_js_linkProps.to.default;
    var MsButtonvue_type_script_lang_js_linkPropKeys = keys(MsButtonvue_type_script_lang_js_linkProps);
    var MsButtonvue_type_script_lang_js_iconProps = {
      icon: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    };
    var iconPropKeys = keys(MsButtonvue_type_script_lang_js_iconProps);
    var MsButtonvue_type_script_lang_js_props = MsButtonvue_type_script_lang_js_objectSpread(MsButtonvue_type_script_lang_js_objectSpread(MsButtonvue_type_script_lang_js_objectSpread(MsButtonvue_type_script_lang_js_objectSpread({}, MsButtonvue_type_script_lang_js_linkProps), btnProps), MsButtonLabelvue_type_script_lang_js_props), MsButtonvue_type_script_lang_js_iconProps);

    // Does button has a label?
    var hasLabel = function hasLabel(props) {
      return Boolean(props.label);
    };

    // Does button has icon?
    var hasIcon = function hasIcon(props) {
      return props.icon.length > 0;
    };

    // Is the requested button a link?
    var MsButtonvue_type_script_lang_js_isLink = function isLink(props) {
      // If tag prop is set to `a`, we use a b-link to get proper disabled handling
      return Boolean(props.href || props.to || props.tag && String(props.tag).toLowerCase() === 'a');
    };

    // Is the button "really" a button?
    var isButton = function isButton(props) {
      if (MsButtonvue_type_script_lang_js_isLink(props)) {
        return false;
      }
      if (props.tag && String(props.tag).toLowerCase() !== 'button') {
        return false;
      }
      return true;
    };

    // Compute required classes (non static classes)
    var computeClass = function computeClass(props) {
      var _ref;
      return ["btn--".concat(props.use), (_ref = {}, MsButtonvue_type_script_lang_js_defineProperty(_ref, "btn--".concat(props.size), Boolean(props.size)), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--fluid', props.block), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--disabled', props.disabled), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--rounded', props.rounded), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--active', props.active), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--hover', props.hovered), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--icon-only', props.iconOnly), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--has-icon', props.icon.length > 0 && props.position === 'start'), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--has-icon-end', props.icon.length > 0 && props.position === 'end'), MsButtonvue_type_script_lang_js_defineProperty(_ref, 'btn--loading', props.isLoading), _ref)];
    };

    // Compute the link props to pass to ms-link (if required)
    var MsButtonvue_type_script_lang_js_computeLinkProps = function computeLinkProps(props) {
      return MsButtonvue_type_script_lang_js_isLink(props) ? pluck_props(MsButtonvue_type_script_lang_js_linkPropKeys, props) : null;
    };

    // Compute the icon props to pass to ms-icon (if required)
    var MsButtonvue_type_script_lang_js_computeIconProps = function computeIconProps(props) {
      return hasIcon(props) ? pluck_props(iconPropKeys, props) : null;
    };

    // Compute the attributes for a button
    var computeAttrs = function computeAttrs(props, data) {
      var button = isButton(props);
      var link = MsButtonvue_type_script_lang_js_isLink(props);
      var role = data.attrs && data.attrs.role ? data.attrs.role : null;
      var tabindex = data.attrs ? data.attrs.tabindex : null;
      return {
        // Type only used for "real" buttons
        type: button && !link ? props.type : null,
        // Disabled only set on "real" buttons
        disabled: button ? props.disabled : null,
        // We add a role of button when the tag is not a link or button for ARIA.
        // Don't bork any role provided in data.attrs when isLink or isButton
        role: link ? 'button' : role,
        // We set the aria-disabled state for link
        'aria-disabled': link ? String(props.disabled) : null,
        // Tab index is used when the component is not a button.
        // Links are tabbable, but don't allow disabled, while non buttons or links
        // are not tabbable, so we mimic that functionality by disabling tabbing
        // when disabled, and adding a tabindex of '0' to non buttons or non links.
        tabindex: props.disabled && !button ? '-1' : tabindex
      };
    };
    /* harmony default export */
    var MsButtonvue_type_script_lang_js_ = {
      name: 'MsButton',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Button'
      },
      functional: true,
      props: MsButtonvue_type_script_lang_js_props,
      render: function render(h, _ref2) {
        var props = _ref2.props,
          data = _ref2.data,
          children = _ref2.children;
        // placeholder for button, label, and icon
        var elButton = h(false);
        var elLabel = h(false);
        var elIconStart = h(false);
        var elIconEnd = h(false);
        var buttonContent = children || [h(false)];
        var loadingIcon = h(false);
        var link = MsButtonvue_type_script_lang_js_isLink(props);
        var label = hasLabel(props);
        var on = {
          click: function click(e) {
            // Prevent click event if disabled
            if (props.disabled && e instanceof Event) {
              e.stopPropagation();
              e.preventDefault();
            }
          }
        };
        var componentData = {
          staticClass: 'btn',
          class: computeClass(props),
          props: MsButtonvue_type_script_lang_js_computeLinkProps(props),
          attrs: computeAttrs(props, data),
          on: on
        };

        // Set the right element type for button
        var ButtonTag = link ? MsLink : props.tag;
        if (props.icon.length > 0) {
          var iconData = {
            // icon size in button needs to be 'sm'
            props: MsButtonvue_type_script_lang_js_objectSpread(MsButtonvue_type_script_lang_js_objectSpread({}, MsButtonvue_type_script_lang_js_computeIconProps(props)), {
              size: 'sm'
            })
          };
          var icon = h('span', {
            staticClass: props.position === 'start' ? 'btn__icon' : 'btn__icon btn__icon--end'
          }, [h(MsIcon, iconData)]);
          if (props.position === 'start') {
            elIconStart = icon;
          } else {
            elIconEnd = icon;
          }
        }

        // loading
        if (props.isLoading) {
          var loadingIconProps = {
            icon: ['far', 'spinner-third'],
            spin: true
          };
          loadingIcon = h('span', {
            staticClass: 'btn--loading__icon'
          }, [h(MsIcon, {
            props: loadingIconProps
          })]);
        }

        // Update button content
        buttonContent = [loadingIcon, elIconStart].concat(MsButtonvue_type_script_lang_js_toConsumableArray(buttonContent), [elIconEnd]);
        if (props.label) {
          elLabel = h(MsButtonLabel, {
            props: pluck_props(MsButtonLabelvue_type_script_lang_js_props, props)
          });
          elButton = h(ButtonTag, a(data, componentData), buttonContent);
        }
        return h(label ? MsButtonWrapper : ButtonTag, label ? {} : a(data, componentData), label ? [elButton, elLabel] : buttonContent);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsButton/MsButton.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsButton_MsButtonvue_type_script_lang_js_ = MsButtonvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsButton/MsButton.vue
    var MsButton_render, MsButton_staticRenderFns;

    /* normalize component */

    var MsButton_component = normalizeComponent(MsButton_MsButtonvue_type_script_lang_js_, MsButton_render, MsButton_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsButton = MsButton_component.exports;
    // CONCATENATED MODULE: ./src/components/MsButton/index.js

    MsButton.install = function (Vue) {
      return Vue.component(MsButton.name, MsButton);
    };
    /* harmony default export */
    var components_MsButton = MsButton;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCallToAction/MsCallToAction.vue?vue&type=template&id=4dd3dbf8&
    var MsCallToActionvue_type_template_id_4dd3dbf8_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "call-to-action"
      }, [_c('div', {
        staticClass: "call-to-action__content-wrapper"
      }, [_vm._t("section-header"), _vm._t("default")], 2), _c('div', {
        staticClass: "call-to-action__cta-wrapper"
      }, [_c('ms-button', {
        attrs: {
          "id": _vm.buttonId,
          "href": _vm.buttonUrl,
          "use": "secondary",
          "target": "_blank",
          "block": ""
        }
      }, [_vm._v("\n      " + _vm._s(_vm.buttonLabel) + "\n    ")])], 1)]);
    };
    var MsCallToActionvue_type_template_id_4dd3dbf8_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCallToAction/MsCallToAction.vue?vue&type=template&id=4dd3dbf8&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCallToAction/MsCallToAction.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCallToActionvue_type_script_lang_js_ = {
      name: 'MsCallToAction',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Call To Action'
      },
      props: {
        /**
         * Sets button text
         */
        buttonLabel: {
          type: String,
          required: true
        },
        /**
         * Sets button url
         */
        buttonUrl: {
          type: String,
          required: true
        },
        /**
         * Sets button id
         */
        buttonId: {
          type: String,
          required: true
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsCallToAction/MsCallToAction.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCallToAction_MsCallToActionvue_type_script_lang_js_ = MsCallToActionvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsCallToAction/MsCallToAction.vue

    /* normalize component */

    var MsCallToAction_component = normalizeComponent(MsCallToAction_MsCallToActionvue_type_script_lang_js_, MsCallToActionvue_type_template_id_4dd3dbf8_render, MsCallToActionvue_type_template_id_4dd3dbf8_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCallToAction = MsCallToAction_component.exports;
    // CONCATENATED MODULE: ./src/components/MsCallToAction/index.js

    var MsCallToAction_components = {
      MsCallToAction: MsCallToAction
    };
    MsCallToAction.install = function (Vue) {
      Object.values(MsCallToAction_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsCallToAction = MsCallToAction;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCardContainer/MsCardContainer.vue?vue&type=template&id=3ca1b102&
    function MsCardContainervue_type_template_id_3ca1b102_typeof(obj) {
      "@babel/helpers - typeof";

      return MsCardContainervue_type_template_id_3ca1b102_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsCardContainervue_type_template_id_3ca1b102_typeof(obj);
    }
    function MsCardContainervue_type_template_id_3ca1b102_defineProperty(obj, key, value) {
      key = MsCardContainervue_type_template_id_3ca1b102_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsCardContainervue_type_template_id_3ca1b102_toPropertyKey(arg) {
      var key = MsCardContainervue_type_template_id_3ca1b102_toPrimitive(arg, "string");
      return MsCardContainervue_type_template_id_3ca1b102_typeof(key) === "symbol" ? key : String(key);
    }
    function MsCardContainervue_type_template_id_3ca1b102_toPrimitive(input, hint) {
      if (MsCardContainervue_type_template_id_3ca1b102_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsCardContainervue_type_template_id_3ca1b102_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsCardContainervue_type_template_id_3ca1b102_render = function render() {
      var _class;
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "card-container",
        class: (_class = {}, MsCardContainervue_type_template_id_3ca1b102_defineProperty(_class, "card-container--grey", Boolean(_vm.greyBackground)), MsCardContainervue_type_template_id_3ca1b102_defineProperty(_class, "card-container--bordered", Boolean(_vm.bordered)), MsCardContainervue_type_template_id_3ca1b102_defineProperty(_class, "card-container--background-image", Boolean(_vm.backgroundImage)), MsCardContainervue_type_template_id_3ca1b102_defineProperty(_class, "card-container--underline", Boolean(_vm.underline)), MsCardContainervue_type_template_id_3ca1b102_defineProperty(_class, "card-container--negative", Boolean(_vm.negativeMargin)), _class)
      }, [_c('div', {
        staticClass: "card-container__image card-container__image--header"
      }, [_c('svg', {
        attrs: {
          "width": "113",
          "height": "35",
          "viewbox": "0 0 113 35",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M112.78 34H113V0H79V0.223213C79.1178 18.8257 94.176 33.8843 112.78 34Z",
          "fill": "#FFD100"
        }
      }), _c('circle', {
        attrs: {
          "cx": "2.07143",
          "cy": "8.07143",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "26.9284",
          "cy": "8.07143",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "51.7858",
          "cy": "8.07143",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "39.3571",
          "cy": "8.07143",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "64.214",
          "cy": "8.07143",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "14.5001",
          "cy": "8.07143",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "2.07143",
          "cy": "20.5",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "26.9284",
          "cy": "20.5",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "51.7858",
          "cy": "20.5",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "39.3571",
          "cy": "20.5",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "64.214",
          "cy": "20.5",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "14.5001",
          "cy": "20.5",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "2.07143",
          "cy": "32.9286",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "26.9284",
          "cy": "32.9286",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "51.7858",
          "cy": "32.9286",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "39.3571",
          "cy": "32.9286",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "64.214",
          "cy": "32.9286",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      }), _c('circle', {
        attrs: {
          "cx": "14.5001",
          "cy": "32.9286",
          "r": "2.07143",
          "fill": "#3DEDA4"
        }
      })])]), _c('div', {
        staticClass: "card-container__image card-container__image--footer"
      }, [_c('svg', {
        attrs: {
          "width": "31",
          "height": "27",
          "viewbox": "0 0 31 27",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M0.341064 28.3633L30.3388 27.9979L2.6514 0.333069L6.03171e-05 0.365361L0.341064 28.3633Z",
          "fill": "#D6F9EA"
        }
      })])]), _vm.title ? _c(_vm.titleTag, {
        tag: "component",
        staticClass: "card-container__title"
      }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _c('div', {
        staticClass: "card-container__content"
      }, [_vm._t("default")], 2), _vm.footerLinkText && _vm.footerLink ? _c('div', {
        staticClass: "card-container__footer-link"
      }, [_c('ms-link', {
        attrs: {
          "to": _vm.footerLink
        }
      }, [_vm._v("\n      " + _vm._s(_vm.footerLinkText) + "\n      "), _c('ms-icon', {
        staticClass: "icon",
        attrs: {
          "icon": ['far', 'arrow-right']
        }
      })], 1)], 1) : _vm._e()], 1);
    };
    var MsCardContainervue_type_template_id_3ca1b102_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCardContainer/MsCardContainer.vue?vue&type=template&id=3ca1b102&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCardContainer/MsCardContainer.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCardContainervue_type_script_lang_js_ = {
      name: 'MsCardContainer',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Card Container'
      },
      props: {
        /**
         * Sets title
        */
        title: {
          type: String,
          default: null
        },
        /**
         * Sets title tag
        */
        titleTag: {
          type: String,
          default: 'div'
        },
        /**
         * Sets the text in the bottom right link
        */
        footerLinkText: {
          type: String,
          default: null
        },
        /**
         * Sets the link in the bottom right link
        */
        footerLink: {
          type: String,
          default: null
        },
        /**
         * Sets if the card container has grey background
        */
        greyBackground: {
          type: Boolean,
          default: false
        },
        /**
         * Sets if the card container has borders
        */
        bordered: {
          type: Boolean,
          default: false
        },
        /**
         * Sets if the card container should display the decorated background
        */
        backgroundImage: {
          type: Boolean,
          default: false
        },
        /**
         * Sets the card container header will have a bottom underline
        */
        underline: {
          type: Boolean,
          default: false
        },
        /**
         * Adds negative margin on mobile to achieve full width look
        */
        negativeMargin: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsCardContainer/MsCardContainer.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCardContainer_MsCardContainervue_type_script_lang_js_ = MsCardContainervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsCardContainer/MsCardContainer.vue

    /* normalize component */

    var MsCardContainer_component = normalizeComponent(MsCardContainer_MsCardContainervue_type_script_lang_js_, MsCardContainervue_type_template_id_3ca1b102_render, MsCardContainervue_type_template_id_3ca1b102_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCardContainer = MsCardContainer_component.exports;
    // CONCATENATED MODULE: ./src/components/MsCardContainer/index.js

    var MsCardContainer_components = {
      MsCardContainer: MsCardContainer,
      MsLink: MsLink
    };
    MsCardContainer.install = function (Vue) {
      Object.values(MsCardContainer_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsCardContainer = MsCardContainer;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCarousel/MsCarousel.vue?vue&type=template&id=181f4f32&
    var MsCarouselvue_type_template_id_181f4f32_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "carousel",
        class: {
          'carousel--splash': _vm.splash,
          'carousel--sneak-peek': _vm.sneakPeek,
          'carousel--sneak-peek-last': _vm.sneakPeek && _vm.isLastItem,
          'carousel--center-control': _vm.centerControls
        }
      }, [_c('h3', {
        staticClass: "visually-hidden",
        attrs: {
          "id": _vm.id
        }
      }, [_vm._v(_vm._s(_vm.title))]), _c('ul', {
        staticClass: "carousel__slider",
        attrs: {
          "id": "carousel-".concat(_vm.id)
        }
      }, [_vm._t("default")], 2), _vm.showNav ? _c('div', {
        staticClass: "carousel__nav",
        attrs: {
          "id": "carousel-nav-".concat(_vm.id)
        }
      }, _vm._l(_vm.slideCount, function (index) {
        return _c('button', {
          key: index,
          on: {
            "click": function click($event) {
              return _vm.pillNavClick();
            }
          }
        }, [_c('div', {
          staticClass: "active-loader",
          style: "transition: width ".concat(_vm.controlClicked ? 0 : _vm.options.autoplayTimeout, "ms ease")
        })]);
      }), 0) : _vm._e(), _vm.showControls ? _c('div', {
        staticClass: "carousel__controls",
        class: "carousel__controls-".concat(_vm.id)
      }, [_c('div', {
        staticClass: "carousel__controls-prev",
        on: {
          "click": function click($event) {
            return _vm.arrowControlClick('previous');
          }
        }
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['fas', 'caret-left']
        }
      })], 1), _c('div', {
        staticClass: "carousel__controls-next",
        on: {
          "click": function click($event) {
            return _vm.arrowControlClick('next');
          }
        }
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['fas', 'caret-right']
        }
      })], 1)]) : _vm._e()]);
    };
    var MsCarouselvue_type_template_id_181f4f32_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCarousel/MsCarousel.vue?vue&type=template&id=181f4f32&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCarousel/MsCarousel.vue?vue&type=script&lang=js&
    function MsCarouselvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsCarouselvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsCarouselvue_type_script_lang_js_typeof(obj);
    }
    function MsCarouselvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsCarouselvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsCarouselvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsCarouselvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsCarouselvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsCarouselvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsCarouselvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsCarouselvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsCarouselvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsCarouselvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsCarouselvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsCarouselvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsCarouselvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    /* harmony default export */
    var MsCarouselvue_type_script_lang_js_ = {
      name: 'MsCarousel',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Carousel'
      },
      props: {
        /**
         * ID for the slider, so that the library is able to pick up which carousel it needs to render
         */
        id: {
          type: String,
          default: null,
          required: true
        },
        /**
         * Visually hidden title for screen readers
         */
        title: {
          type: String,
          default: null,
          required: true
        },
        /**
         * Enables controls for the carousel
         */
        showControls: {
          type: Boolean,
          default: false
        },
        /**
         * Enables navigation dots for the carousel
         */
        showNav: {
          type: Boolean,
          default: false
        },
        /**
         * Enables different control style for splash screens
         */
        splash: {
          type: Boolean,
          default: false
        },
        /**
         * Controls the number of items to slide the carousel by
         * @values 'page', 1
         */
        slideBy: {
          type: String,
          default: 'page'
        },
        /**
         * Controls the number of items to slide the carousel by
         * @values 'page', 1
         */
        sneakPeek: {
          type: Boolean,
          default: false
        },
        /**
         * Set the arrow control in the center
         */
        centerControls: {
          type: Boolean,
          default: false
        },
        /**
         * Accepts the options supported by Tiny Slider
         */
        options: {
          type: Object,
          default: function _default() {
            return {};
          }
        }
      },
      data: function data() {
        return {
          isMobile: false,
          fixedOptions: {
            container: "#carousel-".concat(this.id),
            navContainer: "#carousel-nav-".concat(this.id),
            controls: this.showControls,
            preventScrollOnTouch: 'auto',
            slideBy: this.slideBy,
            nav: this.showNav,
            navPosition: 'bottom'
          },
          slider: null,
          isLastItem: false,
          controlClicked: false
        };
      },
      computed: {
        hasControls: function hasControls() {
          if (this.showControls) {
            return ".carousel__controls-".concat(this.id);
          }
          return false;
        },
        slideCount: function slideCount() {
          if (!this.slider) return 99;
          return Math.ceil(this.slider.getInfo().slideCount / this.slider.getInfo().items);
        }
      },
      mounted: function mounted() {
        this.init();
      },
      beforeDestroy: function beforeDestroy() {
        if (this.slider) {
          this.slider.destroy();
        }
      },
      methods: {
        init: function init() {
          var _this = this;
          /* eslint-disable global-require */
          var tns = __webpack_require__("2feb").tns;
          this.slider = tns(MsCarouselvue_type_script_lang_js_objectSpread(MsCarouselvue_type_script_lang_js_objectSpread({
            controlsContainer: this.hasControls
          }, this.options), this.fixedOptions));
          this.$emit('carousel-load', this.slider.getInfo());
          this.slider.events.on('indexChanged', function (info) {
            var index = info.index,
              indexCached = info.indexCached,
              displayIndex = info.displayIndex,
              pages = info.pages;
            var event = index > indexCached ? 'next-click' : 'prev-click';
            _this.$emit(event, info);
            _this.isLastItem = displayIndex === pages;
          });
          this.slider.events.on('transitionEnd', function (info) {
            _this.$emit('carousel-changed', info);
          });
          this.slider.events.on('dragEnd', function (info) {
            var index = info.index,
              indexCached = info.indexCached;
            var direction = index > indexCached ? 'next' : 'previous';
            _this.$emit('carousel-drag', direction, info);
          });
          this.slider.events.on('touchStart', function () {
            _this.controlClicked = true;
            _this.slider.pause();
          });
          this.slider.events.on('touchEnd', function (info) {
            var index = info.index,
              indexCached = info.indexCached;
            var direction = index > indexCached ? 'next' : 'previous';
            _this.$emit('carousel-touch', direction, info);
            _this.controlClicked = true;
            _this.slider.pause();
          });
        },
        arrowControlClick: function arrowControlClick(direction) {
          this.$emit('arrow-click', direction);
          this.controlClicked = true;
        },
        pillNavClick: function pillNavClick() {
          this.$emit('pill-click');
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsCarousel/MsCarousel.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCarousel_MsCarouselvue_type_script_lang_js_ = MsCarouselvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsCarousel/MsCarousel.vue?vue&type=style&index=0&id=181f4f32&prod&lang=scss&
    var MsCarouselvue_type_style_index_0_id_181f4f32_prod_lang_scss_ = __webpack_require__("f85e");

    // CONCATENATED MODULE: ./src/components/MsCarousel/MsCarousel.vue

    /* normalize component */

    var MsCarousel_component = normalizeComponent(MsCarousel_MsCarouselvue_type_script_lang_js_, MsCarouselvue_type_template_id_181f4f32_render, MsCarouselvue_type_template_id_181f4f32_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCarousel = MsCarousel_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCarousel/MsCarouselItem.vue?vue&type=template&id=64d4e3d9&
    var MsCarouselItemvue_type_template_id_64d4e3d9_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        staticClass: "carousel__slider-item"
      }, [_vm._t("default")], 2);
    };
    var MsCarouselItemvue_type_template_id_64d4e3d9_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCarousel/MsCarouselItem.vue?vue&type=template&id=64d4e3d9&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCarousel/MsCarouselItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCarouselItemvue_type_script_lang_js_ = {
      name: 'MsCarouselItem'
    };
    // CONCATENATED MODULE: ./src/components/MsCarousel/MsCarouselItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCarousel_MsCarouselItemvue_type_script_lang_js_ = MsCarouselItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsCarousel/MsCarouselItem.vue

    /* normalize component */

    var MsCarouselItem_component = normalizeComponent(MsCarousel_MsCarouselItemvue_type_script_lang_js_, MsCarouselItemvue_type_template_id_64d4e3d9_render, MsCarouselItemvue_type_template_id_64d4e3d9_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCarouselItem = MsCarouselItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsCarousel/index.js

    var MsCarousel_components = {
      MsCarousel: MsCarousel,
      MsCarouselItem: MsCarouselItem,
      MsIcon: MsIcon
    };
    MsCarousel.install = function (Vue) {
      Object.values(MsCarousel_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsCarousel = MsCarousel;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCategoryList/MsCategoryList.vue?vue&type=template&id=6817f6b9&
    var MsCategoryListvue_type_template_id_6817f6b9_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "category-list"
      }, [_c('div', {
        ref: "categoryListContainer",
        staticClass: "category-list__container"
      }, [_c('ul', {
        staticClass: "category-list__slide"
      }, [_vm._t("prefixItems"), _vm._l(_vm.mutableList, function (item, index) {
        return _c('li', {
          key: index,
          class: {
            'category-list__slide--hidden': !item.visible,
            'li-variant-green': _vm.variant === 'green'
          },
          style: "order: ".concat(index + 1),
          attrs: {
            "id": "category-".concat(item.value)
          }
        }, [_c('ms-button', _vm._b({
          class: _vm.variant === 'green' ? 'variant-green' : 'variant-default',
          attrs: {
            "use": "ghost-secondary",
            "active": _vm.mutableValue === item.value
          },
          on: {
            "click": function click($event) {
              return _vm.inputButton($event, item.value, item.seoLink);
            }
          }
        }, 'ms-button', _vm.linkAttributes(item), false), [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])], 1);
      }), _c('li', {
        ref: "categoryListDropdown",
        style: "order: ".concat(_vm.position),
        attrs: {
          "id": "category-list--dropdown"
        }
      }, [_vm.moreOptions.length ? _c('ms-dropdown', {
        class: {
          'dropdown--active': _vm.isSelected,
          'dropdown-green': _vm.variant === 'green'
        },
        attrs: {
          "id": "dropdown",
          "options": _vm.moreOptions,
          "name": "dropdown",
          "placeholder": _vm.placeholder
        },
        model: {
          value: _vm.mutableValue,
          callback: function callback($$v) {
            _vm.mutableValue = $$v;
          },
          expression: "mutableValue"
        }
      }) : _vm._e()], 1)], 2)])]);
    };
    var MsCategoryListvue_type_template_id_6817f6b9_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCategoryList/MsCategoryList.vue?vue&type=template&id=6817f6b9&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCategoryList/MsCategoryList.vue?vue&type=script&lang=js&
    function MsCategoryListvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsCategoryListvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsCategoryListvue_type_script_lang_js_typeof(obj);
    }
    function MsCategoryListvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsCategoryListvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsCategoryListvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsCategoryListvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsCategoryListvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsCategoryListvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsCategoryListvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsCategoryListvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsCategoryListvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsCategoryListvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsCategoryListvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsCategoryListvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsCategoryListvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    /* harmony default export */
    var MsCategoryListvue_type_script_lang_js_ = {
      name: 'MsCategoryList',
      props: {
        value: {
          type: String
        },
        list: {
          type: Array,
          required: true
        },
        placeholder: {
          type: String,
          default: 'More'
        },
        variant: {
          type: String,
          default: 'primary'
        },
        autoScroll: {
          type: Boolean,
          default: true
        }
      },
      data: function data() {
        return {
          position: 0,
          mutableValue: this.value || '',
          mutableList: null,
          moreOptions: []
        };
      },
      computed: {
        isSelected: function isSelected() {
          var _this = this;
          return this.moreOptions.find(function (option) {
            return option.val === _this.mutableValue;
          });
        }
      },
      watch: {
        mutableValue: function mutableValue(newValue) {
          this.$emit('input', newValue);
        }
      },
      created: function created() {
        /* eslint-disable no-return-assign */
        /* eslint-disable no-param-reassign */
        this.mutableList = this.list.map(function (item) {
          return item = MsCategoryListvue_type_script_lang_js_objectSpread(MsCategoryListvue_type_script_lang_js_objectSpread({}, item), {}, {
            visible: true
          });
        });
      },
      mounted: function mounted() {
        var _this2 = this;
        this.checkInView();
        window.addEventListener('resize', this.checkInView);
        this.$nextTick(function () {
          _this2.checkInView();
        });
        this.updateScroll();
      },
      beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.checkInView);
      },
      methods: {
        updateScroll: function updateScroll() {
          var _this3 = this;
          if (!this.autoScroll) return;
          var categoryList = this.$el.querySelectorAll('.category-list__slide li');
          var categoryScroll = this.$el.querySelector('.category-list__slide').clientWidth / 2;
          [].forEach.call(categoryList, function (category) {
            var catLink = category.querySelector('.btn');
            if (catLink && catLink.classList.contains('active')) {
              var catLinkScroll = catLink.offsetLeft + catLink.clientWidth / 2;
              _this3.$el.querySelector('.category-list__slide').scrollLeft = catLinkScroll - categoryScroll;
            }
          });
        },
        linkAttributes: function linkAttributes(item) {
          var linkType = {
            href: "#"
          };
          if (item.href || item.seoLink) {
            linkType = {
              href: item.href || item.seoLink
            };
          } else if (item.to) {
            linkType = {
              to: item.to
            };
          }
          if (!item.visible) {
            linkType = MsCategoryListvue_type_script_lang_js_objectSpread(MsCategoryListvue_type_script_lang_js_objectSpread({}, linkType), {
              tabindex: '-1'
            });
          }
          return linkType;
        },
        inputButton: function inputButton(e, value, isSeo) {
          var _this4 = this;
          if (isSeo) {
            e.preventDefault();
          }
          this.mutableValue = value;
          this.$nextTick(function () {
            _this4.updateScroll();
          });
        },
        checkInView: function checkInView() {
          /* eslint-disable no-param-reassign */

          if (document.body.clientWidth < 1024) {
            this.mutableList.forEach(function (item) {
              item.visible = true;
            });
          } else {
            /* eslint-disable dot-notation */
            var dropdown = this.$refs['categoryListDropdown'];
            var container = this.$refs['categoryListContainer'];
            if (container) {
              var cLeft = container.scrollLeft;
              var cRight = cLeft + container.clientWidth;
              container.scrollLeft = 0;
              this.isDropdownInView(container, cLeft, cRight, dropdown);
              this.checkCategoriesInView(cLeft, cRight);
            }
            if (dropdown) {
              var firstHidden = this.mutableList.findIndex(function (option) {
                return !option.visible;
              });
              this.position = firstHidden;
              dropdown.style.order = firstHidden;
            }
          }
        },
        checkCategoriesInView: function checkCategoriesInView(cLeft, cRight) {
          var _this5 = this;
          this.mutableList.forEach(function (item) {
            var element = document.querySelector("#category-".concat(item.value));
            var eLeft = element.offsetLeft;
            var eRight = eLeft + element.clientWidth;
            var exist = _this5.moreOptions.find(function (option) {
              return option.val === item.value;
            });
            item.visible = eLeft >= cLeft && eRight <= cRight;
            if (!item.visible) {
              if (!exist) {
                _this5.moreOptions.push({
                  text: item.label,
                  val: item.value
                });
              }
            } else {
              var itemIndex = _this5.moreOptions.findIndex(function (option) {
                return item.value === option.val;
              });
              _this5.moreOptions.splice(itemIndex, 1);
            }
          });
        },
        isDropdownInView: function isDropdownInView(container, cLeft, cRight, dropdown) {
          var eLeft = dropdown.offsetLeft;
          var eRight = eLeft + dropdown.clientWidth;
          var isVisible = eLeft >= cLeft && eRight <= cRight;
          if (!isVisible) {
            this.position -= 1;
            dropdown.style.order = this.position;
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsCategoryList/MsCategoryList.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCategoryList_MsCategoryListvue_type_script_lang_js_ = MsCategoryListvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsCategoryList/MsCategoryList.vue?vue&type=style&index=0&id=6817f6b9&prod&lang=scss&
    var MsCategoryListvue_type_style_index_0_id_6817f6b9_prod_lang_scss_ = __webpack_require__("6d92");

    // CONCATENATED MODULE: ./src/components/MsCategoryList/MsCategoryList.vue

    /* normalize component */

    var MsCategoryList_component = normalizeComponent(MsCategoryList_MsCategoryListvue_type_script_lang_js_, MsCategoryListvue_type_template_id_6817f6b9_render, MsCategoryListvue_type_template_id_6817f6b9_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCategoryList = MsCategoryList_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDropdown/MsDropdown.vue?vue&type=template&id=722545e3&
    function MsDropdownvue_type_template_id_722545e3_typeof(obj) {
      "@babel/helpers - typeof";

      return MsDropdownvue_type_template_id_722545e3_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsDropdownvue_type_template_id_722545e3_typeof(obj);
    }
    function MsDropdownvue_type_template_id_722545e3_defineProperty(obj, key, value) {
      key = MsDropdownvue_type_template_id_722545e3_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsDropdownvue_type_template_id_722545e3_toPropertyKey(arg) {
      var key = MsDropdownvue_type_template_id_722545e3_toPrimitive(arg, "string");
      return MsDropdownvue_type_template_id_722545e3_typeof(key) === "symbol" ? key : String(key);
    }
    function MsDropdownvue_type_template_id_722545e3_toPrimitive(input, hint) {
      if (MsDropdownvue_type_template_id_722545e3_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsDropdownvue_type_template_id_722545e3_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsDropdownvue_type_template_id_722545e3_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "dropdown",
        class: MsDropdownvue_type_template_id_722545e3_defineProperty({
          'dropdown--filled': _vm.isValue,
          'dropdown--active': _vm.isActive,
          'dropdown--open': _vm.menuOpen,
          'disabled': _vm.isDisabled,
          'dropdown--error': _vm.isError,
          'dropdown--has-label': _vm.label
        }, "dropdown--".concat(_vm.use), _vm.use)
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.selectedValue,
          expression: "selectedValue"
        }],
        staticClass: "dropdown__select",
        attrs: {
          "id": "select_".concat(_vm.id),
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "aria-describedby": "help_text_".concat(_vm.id)
        },
        on: {
          "change": function change($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
              return o.selected;
            }).map(function (o) {
              var val = "_value" in o ? o._value : o.value;
              return val;
            });
            _vm.selectedValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
          }
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._l(_vm.options, function (item, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": item.val
          }
        }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]);
      })], 2), _c('div', {
        ref: "styledDropdown",
        staticClass: "dropdown__selection",
        attrs: {
          "id": "div_".concat(_vm.id),
          "name": _vm.name,
          "tabindex": _vm.isDisabled ? '-1' : '0',
          "aria-haspopup": "true",
          "aria-labelledby": "label_".concat(_vm.id),
          "aria-describedby": "help_text_".concat(_vm.id)
        },
        on: {
          "focus": function focus($event) {
            return _vm.openMenu();
          },
          "blur": function blur($event) {
            return _vm.closeMenu();
          }
        }
      }, [_vm.placeholder && !_vm.selectedOption ? _c('label', {
        staticClass: "dropdown__placeholder",
        attrs: {
          "id": "label_".concat(_vm.id),
          "for": "select_".concat(_vm.id)
        }
      }, [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]) : _vm._e(), _vm._v("\n\n    " + _vm._s(_vm.selectedOption) + "\n  ")]), _c('div', {
        staticClass: "dropdown__menu",
        attrs: {
          "aria-labelledby": "label_".concat(_vm.id),
          "aria-disabled": _vm.isDisabled,
          "role": "menu"
        }
      }, _vm._l(_vm.options, function (item, index) {
        return _c('div', {
          key: index,
          staticClass: "dropdown__option",
          class: {
            'dropdown__option--selected': item.val === _vm.value
          },
          attrs: {
            "value": item.val,
            "aria-disabled": _vm.isDisabled
          },
          on: {
            "mousedown": function mousedown($event) {
              return _vm.selectItem(item);
            }
          }
        }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]);
      }), 0), _c('div', {
        staticClass: "dropdown__arrow"
      }, [_c('fa', {
        attrs: {
          "icon": _vm.dropdownIcon
        }
      })], 1), _vm.label ? _c('label', {
        staticClass: "dropdown__label",
        attrs: {
          "id": "label_".concat(_vm.id),
          "for": "select_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm.helpText ? _c('span', {
        staticClass: "input-field__notice",
        class: {
          'input-field__notice--description': !_vm.isError,
          'input-field__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]) : _vm._e()]);
    };
    var MsDropdownvue_type_template_id_722545e3_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsDropdown/MsDropdown.vue?vue&type=template&id=722545e3&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDropdown/MsDropdown.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDropdownvue_type_script_lang_js_ = {
      name: 'MsDropdown',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Form Fields/Dropdown'
      },
      props: {
        /**
         * Unique id for the dropdown
        */
        id: {
          type: String,
          required: true
        },
        /**
         * Label for the dropdown
        */
        label: {
          type: String
        },
        /**
         * Placeholder for the dropdown
        */
        placeholder: {
          type: String
        },
        /**
         * Unique id for each datepicker input
        */
        modifier: {
          type: String
        },
        /**
         * Unique id for each datepicker input
        */
        name: {
          type: String,
          required: true
        },
        /**
         * Binds the dropdown value option to the model in the parent component.
         * The v-model value must be a valid val in the options array described above.
        */
        value: {
          type: String
        },
        /**
         * Forces active state on input. Normally, active state will only be on when the dropdown is focused.
        */
        isActive: {
          type: Boolean,
          default: false
        },
        /**
         * Sets state to error state
        */
        isError: {
          type: Boolean,
          default: false
        },
        /**
         * Sets state to disabled state
        */
        isDisabled: {
          type: Boolean,
          default: false
        },
        /**
         * Help text to be displayed (descriptions, error messages, etc).
        */
        helpText: {
          type: String
        },
        /**
         * List of options for dropdown eg. [ { val: '1', text: 'hello' } ]
        */
        options: {
          type: Array
        },
        /**
         * Adds a class to change the look. eg 'mini'
        */
        use: {
          type: String,
          validator: function validator(value) {
            return ['mini'].indexOf(value) !== -1;
          }
        }
      },
      data: function data() {
        return {
          selectedValue: this.value || null,
          menuOpen: false
        };
      },
      computed: {
        selectedOption: function selectedOption() {
          var _this = this;
          var selected = this.options.find(function (item) {
            return item.val === _this.value;
          });
          if (this.modifier === 'override-mobile') {
            return this.placeholder || selected.text;
          }
          if (selected) {
            return selected.text;
          }
          return '';
        },
        dropdownIcon: function dropdownIcon() {
          return this.use === 'mini' ? ['fal', 'angle-down'] : ['fas', 'caret-down'];
        },
        isValue: function isValue() {
          if (this.value === null || this.value === undefined) {
            return false;
          }
          return this.value !== '' && this.value.toString().length > 0;
        }
      },
      watch: {
        value: function value(val) {
          this.selectedValue = val;
        },
        selectedValue: function selectedValue(newValue) {
          /**
           * Emits the updated value on input event
          */
          this.$emit('input', newValue);
        }
      },
      methods: {
        selectItem: function selectItem(item) {
          this.selectedValue = item.val;
          this.closeMenu();
        },
        openMenu: function openMenu() {
          this.menuOpen = true;
        },
        closeMenu: function closeMenu() {
          this.menuOpen = false;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsDropdown/MsDropdown.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDropdown_MsDropdownvue_type_script_lang_js_ = MsDropdownvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsDropdown/MsDropdown.vue

    /* normalize component */

    var MsDropdown_component = normalizeComponent(MsDropdown_MsDropdownvue_type_script_lang_js_, MsDropdownvue_type_template_id_722545e3_render, MsDropdownvue_type_template_id_722545e3_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsDropdown = MsDropdown_component.exports;
    // CONCATENATED MODULE: ./src/components/MsCategoryList/index.js

    var MsCategoryList_components = {
      MsCategoryList: MsCategoryList,
      MsButton: MsButton,
      MsDropdown: MsDropdown
    };
    MsCategoryList.install = function (Vue) {
      Object.values(MsCategoryList_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsCategoryList = MsCategoryList;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCheckbox/MsCheckbox.vue?vue&type=template&id=632d937d&
    function MsCheckboxvue_type_template_id_632d937d_typeof(obj) {
      "@babel/helpers - typeof";

      return MsCheckboxvue_type_template_id_632d937d_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsCheckboxvue_type_template_id_632d937d_typeof(obj);
    }
    function MsCheckboxvue_type_template_id_632d937d_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsCheckboxvue_type_template_id_632d937d_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsCheckboxvue_type_template_id_632d937d_ownKeys(Object(source), !0).forEach(function (key) {
          MsCheckboxvue_type_template_id_632d937d_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsCheckboxvue_type_template_id_632d937d_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsCheckboxvue_type_template_id_632d937d_defineProperty(obj, key, value) {
      key = MsCheckboxvue_type_template_id_632d937d_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsCheckboxvue_type_template_id_632d937d_toPropertyKey(arg) {
      var key = MsCheckboxvue_type_template_id_632d937d_toPrimitive(arg, "string");
      return MsCheckboxvue_type_template_id_632d937d_typeof(key) === "symbol" ? key : String(key);
    }
    function MsCheckboxvue_type_template_id_632d937d_toPrimitive(input, hint) {
      if (MsCheckboxvue_type_template_id_632d937d_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsCheckboxvue_type_template_id_632d937d_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsCheckboxvue_type_template_id_632d937d_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('fieldset', {
        staticClass: "input-group",
        class: {
          'input-group--emphasis': _vm.emphasis,
          'input-field--error': _vm.isError
        },
        attrs: {
          "aria-describedby": "help_text_".concat(_vm.id),
          "aria-required": _vm.isRequired ? 'true' : false
        }
      }, [_vm.label ? _c('legend', {
        staticClass: "input-group__legend",
        class: {
          'is-conversational': _vm.isConversational
        }
      }, [_vm._v("\n    " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
        staticClass: "required-field"
      }, [_vm._v("*")]) : _vm._e(), _vm._t("tooltip")], 2) : _vm._e(), _vm.isConversational && _vm.helpText ? _c('span', {
        staticClass: "convo-input__notice",
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]) : _vm._e(), _c('div', {
        staticClass: "input-group__items",
        class: MsCheckboxvue_type_template_id_632d937d_objectSpread(MsCheckboxvue_type_template_id_632d937d_objectSpread({
          'is-reverse': Boolean(_vm.reverse),
          'has-no-border': Boolean(_vm.hideBorder),
          'is-disabled': Boolean(_vm.isDisabled)
        }, _vm.fontSizeClass), _vm.themeClass)
      }, [_vm._t("default")], 2), !_vm.isConversational && _vm.helpText ? _c('span', {
        staticClass: "input-field__notice",
        class: {
          'input-field__notice--description': !_vm.isError,
          'input-field__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v(_vm._s(_vm.helpText))]) : _vm._e(), _vm.isConversational && _vm.isError && _vm.errorText ? _c('span', {
        staticClass: "convo-input__notice convo-input__notice--error-text"
      }, [_vm._v("\n    " + _vm._s(_vm.errorText) + "\n  ")]) : _vm._e()]);
    };
    var MsCheckboxvue_type_template_id_632d937d_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCheckbox/MsCheckbox.vue?vue&type=template&id=632d937d&

    // CONCATENATED MODULE: ./src/mixins/FormRadioCheckbox.js
    var FormRadioCheckbox = {
      props: {
        /**
         * Id for the component and is also used for linking accessibity labels
        */
        id: {
          type: String,
          required: true
        },
        /**
         * Label for checkbox/radio/segmented control button group
        */
        label: {
          type: String,
          default: ''
        },
        /**
         * Hide border for checkbox/radio/segmented control button group
        */
        hideBorder: {
          type: Boolean,
          default: null
        },
        /**
         * Reverse label position
        */
        reverse: {
          type: Boolean,
          default: null
        },
        /**
         * Help text for segmented control group
        */
        helpText: {
          type: String,
          default: ''
        },
        /**
         * Error text if you are using it in conversational mode
         */
        errorText: {
          type: String,
          default: ''
        },
        /**
         * Sets an error class for checkbox/radio/segmented control button group
        */
        isError: {
          type: Boolean,
          default: false
        },
        /**
         * Specifies if checkbox/radio/segmented control button group is disabled
        */
        isDisabled: {
          type: Boolean,
          default: false
        },
        /**
         * Whether or not the conversational style should be applied to the legend
        */
        isConversational: {
          type: Boolean,
          default: false
        },
        /**
         * Set ARIA attribute and show * star in label
        */
        isRequired: {
          type: Boolean,
          default: false
        }
      }
    };
    var FormRadioCheckboxItem = {
      model: {
        prop: 'modelValue'
      },
      props: {
        /**
         * The checkbox/radio button value
        */
        value: {
          type: String,
          required: true
        }
      }
    };

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCheckbox/MsCheckbox.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsCheckboxvue_type_script_lang_js_ = {
      name: 'MsCheckbox',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Form Fields/Checkbox'
      },
      mixins: [FormRadioCheckbox],
      inheritAttrs: false,
      props: {
        /**
         * For different font sizes.
         * (Options: 'small', 'default')
         */
        fontSize: {
          type: String,
          default: 'default',
          validator: function validator(size) {
            var fontSizeOptions = ['small', 'default'];
            return fontSizeOptions.includes(size);
          }
        },
        /**
         * For different font colors
         * (Options: 'light', 'default')
         */
        theme: {
          type: String,
          default: 'default',
          validator: function validator(theme) {
            var themeOptions = ['light', 'default'];
            return themeOptions.includes(theme);
          }
        },
        /**
         * Whether or not the conversational style should be applied to the legend
        */
        emphasis: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        fontSizeClass: function fontSizeClass() {
          switch (this.fontSize) {
            case 'small':
              return {
                'label-sm': true
              };
            default:
              return {};
          }
        },
        themeClass: function themeClass() {
          switch (this.theme) {
            case 'light':
              return {
                'color-light': true
              };
            default:
              return {};
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsCheckbox/MsCheckbox.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCheckbox_MsCheckboxvue_type_script_lang_js_ = MsCheckboxvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsCheckbox/MsCheckbox.vue

    /* normalize component */

    var MsCheckbox_component = normalizeComponent(MsCheckbox_MsCheckboxvue_type_script_lang_js_, MsCheckboxvue_type_template_id_632d937d_render, MsCheckboxvue_type_template_id_632d937d_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCheckbox = MsCheckbox_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCheckbox/MsCheckboxItem.vue?vue&type=template&id=3753779c&
    var MsCheckboxItemvue_type_template_id_3753779c_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "input-group__item checkbox"
      }, [_c('label', {
        attrs: {
          "for": _vm.id
        },
        domProps: {
          "innerHTML": _vm._s(_vm.label)
        }
      }), _c('div', {
        staticClass: "input-group__item-container"
      }, [_c('div', {
        staticClass: "input-group__item-wrap"
      }, [_c('input', {
        attrs: {
          "id": _vm.id,
          "type": "checkbox",
          "name": _vm.name,
          "disabled": Boolean(_vm.isDisabled)
        },
        domProps: {
          "value": _vm.value,
          "checked": _vm.modelValue.includes(_vm.value) ? 'checked' : ''
        },
        on: {
          "change": function change($event) {
            _vm.$emit('input', _vm.onChange($event, _vm.modelValue));
          }
        }
      }), _c('div', {
        staticClass: "input-group__item-marker"
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'check']
        }
      })], 1)])])]);
    };
    var MsCheckboxItemvue_type_template_id_3753779c_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCheckbox/MsCheckboxItem.vue?vue&type=template&id=3753779c&

    // CONCATENATED MODULE: ./src/mixins/FormFields.js
    var FormFields = {
      props: {
        /**
         * Unique ID for each item
        */
        id: {
          type: String,
          required: true
        },
        /**
         * Label for each item
        */
        label: {
          type: String,
          required: true
        },
        /**
         * Specifies the grouping of the fields. Use the same name for fields in the same group
        */
        name: {
          type: String,
          required: true
        },
        /**
         * The checkbox/radio/segmented control button value
        */
        value: {
          type: [String, Number]
        }
      }
    };

    // eslint-disable-next-line

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCheckbox/MsCheckboxItem.vue?vue&type=script&lang=js&
    function MsCheckboxItemvue_type_script_lang_js_toConsumableArray(arr) {
      return MsCheckboxItemvue_type_script_lang_js_arrayWithoutHoles(arr) || MsCheckboxItemvue_type_script_lang_js_iterableToArray(arr) || MsCheckboxItemvue_type_script_lang_js_unsupportedIterableToArray(arr) || MsCheckboxItemvue_type_script_lang_js_nonIterableSpread();
    }
    function MsCheckboxItemvue_type_script_lang_js_nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function MsCheckboxItemvue_type_script_lang_js_unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return MsCheckboxItemvue_type_script_lang_js_arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MsCheckboxItemvue_type_script_lang_js_arrayLikeToArray(o, minLen);
    }
    function MsCheckboxItemvue_type_script_lang_js_iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function MsCheckboxItemvue_type_script_lang_js_arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return MsCheckboxItemvue_type_script_lang_js_arrayLikeToArray(arr);
    }
    function MsCheckboxItemvue_type_script_lang_js_arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }

    /* harmony default export */
    var MsCheckboxItemvue_type_script_lang_js_ = {
      name: 'MsCheckboxItem',
      mixins: [FormFields, FormRadioCheckboxItem],
      inheritAttrs: false,
      props: {
        modelValue: {
          type: Array,
          required: true
        },
        isDisabled: {
          type: Boolean,
          default: false
        }
      },
      methods: {
        onChange: function onChange(event, checkboxValues) {
          var isChecked = event.target.checked;
          var values = checkboxValues;
          if (isChecked) {
            values = [].concat(MsCheckboxItemvue_type_script_lang_js_toConsumableArray(values), [event.target.value]);
          } else {
            values = values.filter(function (value) {
              return value !== event.target.value;
            });
          }
          return values;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsCheckbox/MsCheckboxItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCheckbox_MsCheckboxItemvue_type_script_lang_js_ = MsCheckboxItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsCheckbox/MsCheckboxItem.vue

    /* normalize component */

    var MsCheckboxItem_component = normalizeComponent(MsCheckbox_MsCheckboxItemvue_type_script_lang_js_, MsCheckboxItemvue_type_template_id_3753779c_render, MsCheckboxItemvue_type_template_id_3753779c_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCheckboxItem = MsCheckboxItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsCheckbox/index.js

    var MsCheckbox_components = {
      MsCheckbox: MsCheckbox,
      MsCheckboxItem: MsCheckboxItem
    };
    MsCheckbox.install = function (Vue) {
      Object.values(MsCheckbox_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsCheckbox = MsCheckbox;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsConvoDropdown/MsConvoDropdown.vue?vue&type=template&id=37d249a8&
    var MsConvoDropdownvue_type_template_id_37d249a8_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "convo-dropdown",
        class: {
          'convo-dropdown--active': _vm.isActive,
          'convo-dropdown--open': _vm.menuOpen,
          'disabled': _vm.isDisabled,
          'convo-dropdown--error': _vm.isError,
          'convo-dropdown--has-label': _vm.label
        }
      }, [_c('div', {
        staticClass: "label_wrapper"
      }, [_vm.label ? _c('label', {
        staticClass: "convo-dropdown__label",
        attrs: {
          "id": "label_".concat(_vm.id),
          "for": "select_".concat(_vm.id)
        }
      }, [_vm._v("\n      " + _vm._s(_vm.label)), _vm.isRequired ? _c('span', {
        staticClass: "required-field"
      }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._t("tooltip")], 2), _vm.helpText ? _c('p', {
        staticClass: "convo-input__notice",
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]) : _vm._e(), _c('div', {
        staticClass: "convo-dropdown__select"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.selectedValue,
          expression: "selectedValue"
        }],
        staticClass: "convo-dropdown__select",
        attrs: {
          "id": "select_".concat(_vm.id),
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "aria-describedby": "help_text_".concat(_vm.id)
        },
        on: {
          "change": function change($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
              return o.selected;
            }).map(function (o) {
              var val = "_value" in o ? o._value : o.value;
              return val;
            });
            _vm.selectedValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
          }
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._l(_vm.options, function (item, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": item.val
          }
        }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
      })], 2)]), _c('div', {
        ref: "styledDropdown",
        staticClass: "convo-dropdown__selection",
        attrs: {
          "id": "div_".concat(_vm.id),
          "name": _vm.name,
          "tabindex": _vm.isDisabled ? '-1' : '0',
          "aria-haspopup": "true",
          "aria-labelledby": "label_".concat(_vm.id),
          "aria-describedby": "help_text_".concat(_vm.id)
        },
        on: {
          "focus": function focus($event) {
            return _vm.openMenu();
          },
          "blur": function blur($event) {
            return _vm.closeMenu();
          }
        }
      }, [_vm.placeholder && !_vm.selectedOption ? _c('label', {
        staticClass: "convo-dropdown__placeholder",
        attrs: {
          "id": "label_".concat(_vm.id),
          "for": "select_".concat(_vm.id)
        }
      }, [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]) : _vm._e(), _vm._v("\n\n    " + _vm._s(_vm.selectedOption) + "\n\n    "), _c('div', {
        staticClass: "convo-dropdown__arrow"
      }, [_c('fa', {
        attrs: {
          "icon": ['fas', 'caret-down']
        }
      })], 1)]), _c('div', {
        staticClass: "convo-dropdown__menu",
        attrs: {
          "aria-labelledby": "label_".concat(_vm.id),
          "aria-disabled": _vm.isDisabled,
          "role": "menu"
        }
      }, _vm._l(_vm.options, function (item, index) {
        return _c('div', {
          key: index,
          staticClass: "convo-dropdown__option",
          class: {
            'convo-dropdown__option--selected': item.val === _vm.value
          },
          attrs: {
            "value": item.val,
            "aria-disabled": _vm.isDisabled
          },
          on: {
            "mousedown": function mousedown($event) {
              return _vm.selectItem(item);
            }
          }
        }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]);
      }), 0), _vm.isError && _vm.errorText ? _c('span', {
        staticClass: "convo-input__notice convo-input__notice--error-text",
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.errorText) + "\n  ")]) : _vm._e()]);
    };
    var MsConvoDropdownvue_type_template_id_37d249a8_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsConvoDropdown/MsConvoDropdown.vue?vue&type=template&id=37d249a8&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsConvoDropdown/MsConvoDropdown.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsConvoDropdownvue_type_script_lang_js_ = {
      name: 'MsConvoDropdown',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Conversational Fields/Dropdown'
      },
      props: {
        /**
         * Unique id for the dropdown
        */
        id: {
          type: String,
          required: true
        },
        /**
         * Label for the dropdown
        */
        label: {
          type: String
        },
        /**
         * Placeholder for the dropdown
        */
        placeholder: {
          type: String
        },
        /**
         * Unique id for each datepicker input
        */
        modifier: {
          type: String
        },
        /**
         * Unique id for each datepicker input
        */
        name: {
          type: String,
          required: true
        },
        /**
         * Binds the dropdown value option to the model in the parent component.
         * The v-model value must be a valid val in the options array described above.
        */
        value: {
          type: String
        },
        /**
         * Help text to be displayed (descriptions, etc).
        */
        helpText: {
          type: String
        },
        /**
         * Error text to be displayed
        */
        errorText: {
          type: String
        },
        /**
         * Forces active state on input. Normally, active state will only be on when the dropdown is focused.
        */
        isActive: {
          type: Boolean,
          default: false
        },
        /**
         * Sets state to error state
        */
        isError: {
          type: Boolean,
          default: false
        },
        /**
         * Sets state to disabled state
        */
        isDisabled: {
          type: Boolean,
          default: false
        },
        /**
         * Makes the dropdown required
        */
        isRequired: {
          type: Boolean,
          default: false
        },
        /**
         * List of options for dropdown eg. [ { val: '1', text: 'hello' } ]
        */
        options: {
          type: Array
        }
      },
      data: function data() {
        return {
          selectedValue: this.value || null,
          menuOpen: false
        };
      },
      computed: {
        selectedOption: function selectedOption() {
          var _this = this;
          var selected = this.options.find(function (item) {
            return item.val === _this.value;
          });
          if (this.modifier === 'override-mobile') {
            return this.placeholder || selected.text;
          }
          if (selected) {
            return selected.text;
          }
          return '';
        }
      },
      watch: {
        value: function value(val) {
          this.selectedValue = val;
        },
        selectedValue: function selectedValue(newValue) {
          /**
           * Emits the updated value on input event
          */
          this.$emit('input', newValue);
        }
      },
      methods: {
        selectItem: function selectItem(item) {
          this.selectedValue = item.val;
          this.closeMenu();
        },
        openMenu: function openMenu() {
          this.menuOpen = true;
        },
        closeMenu: function closeMenu() {
          this.menuOpen = false;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsConvoDropdown/MsConvoDropdown.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsConvoDropdown_MsConvoDropdownvue_type_script_lang_js_ = MsConvoDropdownvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsConvoDropdown/MsConvoDropdown.vue

    /* normalize component */

    var MsConvoDropdown_component = normalizeComponent(MsConvoDropdown_MsConvoDropdownvue_type_script_lang_js_, MsConvoDropdownvue_type_template_id_37d249a8_render, MsConvoDropdownvue_type_template_id_37d249a8_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsConvoDropdown = MsConvoDropdown_component.exports;
    // CONCATENATED MODULE: ./src/components/MsConvoDropdown/index.js

    var MsConvoDropdown_components = {
      MsConvoDropdown: MsConvoDropdown
    };
    MsConvoDropdown.install = function (Vue) {
      Object.values(MsConvoDropdown_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsConvoDropdown = MsConvoDropdown;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsConvoInputStepper/MsConvoInputStepper.vue?vue&type=template&id=dfb9b77e&
    var MsConvoInputSteppervue_type_template_id_dfb9b77e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "convo-input convo-input--stepper",
        class: {
          'convo-input--filled': _vm.value !== undefined,
          'convo-input--active': _vm.isActive,
          'convo-input--error': _vm.isError,
          'convo-input--prefix': _vm.hasPrefix,
          'convo-input--suffix': _vm.hasSuffix,
          'convo-input--mask': _vm.mask
        }
      }, [_c('div', {
        staticClass: "label_wrapper"
      }, [_c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
        staticClass: "required-field"
      }, [_vm._v("*")]) : _vm._e()]), _vm._t("tooltip")], 2), _vm.helpText ? _c('p', {
        staticClass: "convo-input__notice",
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]) : _vm._e(), _c('div', {
        staticClass: "convo-input__wrapper"
      }, [_vm.mask || _vm.hasSuffix ? [_c('Cleave', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": "text",
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "options": _vm.maskOptions,
          "aria-describedby": "help_text_".concat(_vm.id),
          "raw": !_vm.maskOptions.date
        },
        model: {
          value: _vm.maskedValue,
          callback: function callback($$v) {
            _vm.maskedValue = $$v;
          },
          expression: "maskedValue"
        }
      }, 'Cleave', _vm.$attrs, false))] : [_c('input', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": "number",
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "aria-describedby": "help_text_".concat(_vm.id)
        },
        domProps: {
          "value": _vm.value
        },
        on: {
          "input": _vm.changeInput,
          "change": _vm.changeInput
        }
      }, 'input', _vm.$attrs, false))], _vm.hasPrefix ? _c('span', {
        staticClass: "convo-input__prefix"
      }, [_vm._v(_vm._s(_vm.prefix))]) : _vm._e(), _c('div', {
        staticClass: "convo-input--stepper__nav"
      }, [_c('button', {
        staticClass: "convo-input--stepper__nav__down",
        class: {
          'convo-input--stepper__nav--disabled': !_vm.decrement.active
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.toggle(_vm.decrement);
          }
        }
      }, [_c('fa', {
        staticClass: "text-body-m1",
        attrs: {
          "icon": ['fal', 'minus']
        }
      })], 1), _c('button', {
        staticClass: "convo-input--stepper__nav__up",
        class: {
          'convo-input--stepper__nav--disabled': !_vm.increment.active
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.toggle(_vm.increment);
          }
        }
      }, [_c('fa', {
        staticClass: "text-body-m1",
        attrs: {
          "icon": ['fal', 'plus']
        }
      })], 1)]), _c('div', {
        staticClass: "convo-input__border"
      })], 2), _vm.isError && _vm.errorText ? _c('span', {
        staticClass: "convo-input__notice",
        class: {
          'convo-input__notice--description': !_vm.isError,
          'convo-input__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.errorText) + "\n  ")]) : _vm._e()]);
    };
    var MsConvoInputSteppervue_type_template_id_dfb9b77e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsConvoInputStepper/MsConvoInputStepper.vue?vue&type=template&id=dfb9b77e&

    // CONCATENATED MODULE: ./src/mixins/FormInput.js
    var FormInput = {
      props: {
        /**
         * Sets the type of the form field
        */
        type: {
          type: String,
          default: 'text'
        },
        /**
         * Sets an active class to the form field
        */
        isActive: {
          type: Boolean,
          default: false
        },
        /**
         * Sets an error class to the form field
        */
        isError: {
          type: Boolean,
          default: false
        },
        /**
         * Disables the form field
        */
        isDisabled: {
          type: Boolean,
          default: false
        },
        /**
         * Sets help text label above the form field for convo inputs
         * Sets help text label below the form field for normal inputs
        */
        helpText: {
          type: String
        },
        /**
         * Sets error text label below the form field
        */
        errorText: {
          type: String
        }
      }
    };

    // eslint-disable-next-line

    // CONCATENATED MODULE: ./src/mixins/StepperButton.js
    var StepperButton = {
      data: function data() {
        var maskedValue = this.value || 0;
        return {
          maskedValue: maskedValue
        };
      },
      watch: {
        // For v-model support of Cleave component
        value: function value(val) {
          this.maskedValue = val;
        },
        maskedValue: function maskedValue(newValue) {
          this.$emit('input', newValue);
        }
      },
      methods: {
        changeInput: function changeInput(event) {
          this.$emit('input', parseInt(event.target.value, 10));
        },
        toggle: function toggle(data) {
          var active = data.active,
            value = data.value;
          if (active) {
            this.$emit('input', value);
          }
        }
      },
      computed: {
        changingStep: function changingStep() {
          return this.step || 1;
        },
        increment: function increment() {
          var value;
          var active;
          if (this.mask || this.hasSuffix) {
            value = parseInt(this.value, 10) + parseInt(this.changingStep, 10);
            active = !this.maxValue || value <= this.maxValue;
          } else {
            value = this.value + this.changingStep;
            active = !this.maxValue || value <= this.maxValue;
          }
          return {
            value: value,
            active: active
          };
        },
        decrement: function decrement() {
          var value;
          var active;
          if (this.mask || this.hasSuffix) {
            value = parseInt(this.value, 10) - parseInt(this.changingStep, 10);
            active = value >= this.minValue;
          } else {
            value = this.value - this.changingStep;
            active = value >= this.minValue;
          }
          return {
            value: value,
            active: active
          };
        },
        maskOptions: function maskOptions() {
          return {
            numeral: true,
            tailPrefix: this.hasSuffix,
            prefix: this.hasSuffix ? this.suffix : ''
          };
        },
        hasPrefix: function hasPrefix() {
          return this.prefix !== null && this.prefix !== '';
        },
        hasSuffix: function hasSuffix() {
          return this.suffix !== null && this.suffix !== '';
        }
      }
    };
    /* harmony default export */
    var mixins_StepperButton = StepperButton;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsConvoInputStepper/MsConvoInputStepper.vue?vue&type=script&lang=js&
    function MsConvoInputSteppervue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsConvoInputSteppervue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsConvoInputSteppervue_type_script_lang_js_typeof(obj);
    }
    function MsConvoInputSteppervue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsConvoInputSteppervue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsConvoInputSteppervue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsConvoInputSteppervue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsConvoInputSteppervue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsConvoInputSteppervue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsConvoInputSteppervue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsConvoInputSteppervue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsConvoInputSteppervue_type_script_lang_js_toPrimitive(arg, "string");
      return MsConvoInputSteppervue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsConvoInputSteppervue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsConvoInputSteppervue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsConvoInputSteppervue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var propOptions = {
      type: Number,
      required: false
    };
    /* harmony default export */
    var MsConvoInputSteppervue_type_script_lang_js_ = {
      name: 'MsConvoInputStepper',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Conversational Fields/Input Stepper'
      },
      components: {
        Cleave: function Cleave() {
          return __webpack_require__.e( /* import() */0).then(__webpack_require__.t.bind(null, "2083", 7));
        }
      },
      mixins: [FormFields, FormInput, mixins_StepperButton],
      inheritAttrs: false,
      props: {
        /**
         * The input stepper value
        */
        value: {
          type: [Number, String],
          required: false
        },
        /**
         * Sets minimum value
        */
        minValue: MsConvoInputSteppervue_type_script_lang_js_objectSpread(MsConvoInputSteppervue_type_script_lang_js_objectSpread({}, propOptions), {}, {
          default: 0
        }),
        /**
         * Sets maximum value
        */
        maxValue: propOptions,
        /**
         * Sets the interval amount
        */
        step: propOptions,
        /**
         * Set ARIA attribute and show * star in label
        */
        isRequired: {
          type: Boolean,
          default: false
        },
        /**
         * Sets the prefix
        */
        prefix: {
          type: String,
          default: null
        },
        /**
         * Sets the suffix
        */
        suffix: {
          type: String,
          default: null
        },
        /**
         * Sets masking of input
        */
        mask: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsConvoInputStepper/MsConvoInputStepper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsConvoInputStepper_MsConvoInputSteppervue_type_script_lang_js_ = MsConvoInputSteppervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsConvoInputStepper/MsConvoInputStepper.vue

    /* normalize component */

    var MsConvoInputStepper_component = normalizeComponent(MsConvoInputStepper_MsConvoInputSteppervue_type_script_lang_js_, MsConvoInputSteppervue_type_template_id_dfb9b77e_render, MsConvoInputSteppervue_type_template_id_dfb9b77e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsConvoInputStepper = MsConvoInputStepper_component.exports;
    // CONCATENATED MODULE: ./src/components/MsConvoInputStepper/index.js

    MsConvoInputStepper.install = function (Vue) {
      return Vue.component(MsConvoInputStepper.name, MsConvoInputStepper);
    };
    /* harmony default export */
    var components_MsConvoInputStepper = MsConvoInputStepper;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCountdownTimer/MsCountdownTimer.vue?vue&type=template&id=92072c4a&
    var MsCountdownTimervue_type_template_id_92072c4a_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _vm.shouldCalculateAndRender ? _c('div', {
        staticClass: "countdown-timer",
        class: {
          'is-last-day': _vm.enableHighlight
        }
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['far', 'stopwatch']
        }
      }), _c('span', {
        staticClass: "countdown-timer__label"
      }, [_vm._v(_vm._s(_vm.label))]), _c('span', {
        staticClass: "countdown-timer__time"
      }, [_vm._v(_vm._s(_vm.countdownStr))])], 1) : _vm._e();
    };
    var MsCountdownTimervue_type_template_id_92072c4a_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsCountdownTimer/MsCountdownTimer.vue?vue&type=template&id=92072c4a&

    // CONCATENATED MODULE: ./node_modules/date-fns/esm/constants/index.js
    /**
     * Days in 1 week.
     *
     * @name daysInWeek
     * @constant
     * @type {number}
     * @default
     */
    var daysInWeek = 7;

    /**
     * Days in 1 year
     * One years equals 365.2425 days according to the formula:
     *
     * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
     * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
     *
     * @name daysInYear
     * @constant
     * @type {number}
     * @default
     */
    var daysInYear = 365.2425;

    /**
     * Maximum allowed time.
     *
     * @name maxTime
     * @constant
     * @type {number}
     * @default
     */
    var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

    /**
     * Milliseconds in 1 minute
     *
     * @name millisecondsInMinute
     * @constant
     * @type {number}
     * @default
     */
    var millisecondsInMinute = 60000;

    /**
     * Milliseconds in 1 hour
     *
     * @name millisecondsInHour
     * @constant
     * @type {number}
     * @default
     */
    var millisecondsInHour = 3600000;

    /**
     * Milliseconds in 1 second
     *
     * @name millisecondsInSecond
     * @constant
     * @type {number}
     * @default
     */
    var millisecondsInSecond = 1000;

    /**
     * Minimum allowed time.
     *
     * @name minTime
     * @constant
     * @type {number}
     * @default
     */
    var minTime = -maxTime;

    /**
     * Minutes in 1 hour
     *
     * @name minutesInHour
     * @constant
     * @type {number}
     * @default
     */
    var minutesInHour = 60;

    /**
     * Months in 1 quarter
     *
     * @name monthsInQuarter
     * @constant
     * @type {number}
     * @default
     */
    var monthsInQuarter = 3;

    /**
     * Months in 1 year
     *
     * @name monthsInYear
     * @constant
     * @type {number}
     * @default
     */
    var monthsInYear = 12;

    /**
     * Quarters in 1 year
     *
     * @name quartersInYear
     * @constant
     * @type {number}
     * @default
     */
    var quartersInYear = 4;

    /**
     * Seconds in 1 hour
     *
     * @name secondsInHour
     * @constant
     * @type {number}
     * @default
     */
    var secondsInHour = 3600;

    /**
     * Seconds in 1 minute
     *
     * @name secondsInMinute
     * @constant
     * @type {number}
     * @default
     */
    var secondsInMinute = 60;

    /**
     * Seconds in 1 day
     *
     * @name secondsInDay
     * @constant
     * @type {number}
     * @default
     */
    var secondsInDay = secondsInHour * 24;

    /**
     * Seconds in 1 week
     *
     * @name secondsInWeek
     * @constant
     * @type {number}
     * @default
     */
    var secondsInWeek = secondsInDay * 7;

    /**
     * Seconds in 1 year
     *
     * @name secondsInYear
     * @constant
     * @type {number}
     * @default
     */
    var secondsInYear = secondsInDay * daysInYear;

    /**
     * Seconds in 1 month
     *
     * @name secondsInMonth
     * @constant
     * @type {number}
     * @default
     */
    var secondsInMonth = secondsInYear / 12;

    /**
     * Seconds in 1 quarter
     *
     * @name secondsInQuarter
     * @constant
     * @type {number}
     * @default
     */
    var secondsInQuarter = secondsInMonth * 3;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
    function requiredArgs(required, args) {
      if (args.length < required) {
        throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
      }
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
    function toInteger(dirtyNumber) {
      if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
        return NaN;
      }
      var number = Number(dirtyNumber);
      if (isNaN(number)) {
        return number;
      }
      return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/parseISO/index.js

    /**
     * @name parseISO
     * @category Common Helpers
     * @summary Parse ISO string
     *
     * @description
     * Parse the given string in ISO 8601 format and return an instance of Date.
     *
     * Function accepts complete ISO 8601 formats as well as partial implementations.
     * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
     *
     * If the argument isn't a string, the function cannot parse the string or
     * the values are invalid, it returns Invalid Date.
     *
     * @param {String} argument - the value to convert
     * @param {Object} [options] - an object with options.
     * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
     * @returns {Date} the parsed date in the local time zone
     * @throws {TypeError} 1 argument required
     * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
     *
     * @example
     * // Convert string '2014-02-11T11:30:30' to date:
     * const result = parseISO('2014-02-11T11:30:30')
     * //=> Tue Feb 11 2014 11:30:30
     *
     * @example
     * // Convert string '+02014101' to date,
     * // if the additional number of digits in the extended year format is 1:
     * const result = parseISO('+02014101', { additionalDigits: 1 })
     * //=> Fri Apr 11 2014 00:00:00
     */
    function parseISO(argument, options) {
      var _options$additionalDi;
      requiredArgs(1, arguments);
      var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
      if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
        throw new RangeError('additionalDigits must be 0, 1 or 2');
      }
      if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
        return new Date(NaN);
      }
      var dateStrings = splitDateString(argument);
      var date;
      if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
      }
      if (!date || isNaN(date.getTime())) {
        return new Date(NaN);
      }
      var timestamp = date.getTime();
      var time = 0;
      var offset;
      if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) {
          return new Date(NaN);
        }
      }
      if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) {
          return new Date(NaN);
        }
      } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
      }
      return new Date(timestamp + time + offset);
    }
    var patterns = {
      dateTimeDelimiter: /[T ]/,
      timeZoneDelimiter: /[Z ]/i,
      timezone: /([Z+-].*)$/
    };
    var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
    var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
    var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
    function splitDateString(dateString) {
      var dateStrings = {};
      var array = dateString.split(patterns.dateTimeDelimiter);
      var timeString;

      // The regex match should only return at maximum two array elements.
      // [date], [time], or [date, time].
      if (array.length > 2) {
        return dateStrings;
      }
      if (/:/.test(array[0])) {
        timeString = array[0];
      } else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
          dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
          timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
      }
      if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
          dateStrings.time = timeString.replace(token[1], '');
          dateStrings.timezone = token[1];
        } else {
          dateStrings.time = timeString;
        }
      }
      return dateStrings;
    }
    function parseYear(dateString, additionalDigits) {
      var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
      var captures = dateString.match(regex);
      // Invalid ISO-formatted year
      if (!captures) return {
        year: NaN,
        restDateString: ''
      };
      var year = captures[1] ? parseInt(captures[1]) : null;
      var century = captures[2] ? parseInt(captures[2]) : null;

      // either year or century is null, not both
      return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
      };
    }
    function parseDate(dateString, year) {
      // Invalid ISO-formatted year
      if (year === null) return new Date(NaN);
      var captures = dateString.match(dateRegex);
      // Invalid ISO-formatted string
      if (!captures) return new Date(NaN);
      var isWeekDate = !!captures[4];
      var dayOfYear = parseDateUnit(captures[1]);
      var month = parseDateUnit(captures[2]) - 1;
      var day = parseDateUnit(captures[3]);
      var week = parseDateUnit(captures[4]);
      var dayOfWeek = parseDateUnit(captures[5]) - 1;
      if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) {
          return new Date(NaN);
        }
        return dayOfISOWeekYear(year, week, dayOfWeek);
      } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
          return new Date(NaN);
        }
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
      }
    }
    function parseDateUnit(value) {
      return value ? parseInt(value) : 1;
    }
    function parseTime(timeString) {
      var captures = timeString.match(timeRegex);
      if (!captures) return NaN; // Invalid ISO-formatted time

      var hours = parseTimeUnit(captures[1]);
      var minutes = parseTimeUnit(captures[2]);
      var seconds = parseTimeUnit(captures[3]);
      if (!validateTime(hours, minutes, seconds)) {
        return NaN;
      }
      return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
    }
    function parseTimeUnit(value) {
      return value && parseFloat(value.replace(',', '.')) || 0;
    }
    function parseTimezone(timezoneString) {
      if (timezoneString === 'Z') return 0;
      var captures = timezoneString.match(timezoneRegex);
      if (!captures) return 0;
      var sign = captures[1] === '+' ? -1 : 1;
      var hours = parseInt(captures[2]);
      var minutes = captures[3] && parseInt(captures[3]) || 0;
      if (!validateTimezone(hours, minutes)) {
        return NaN;
      }
      return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
    }
    function dayOfISOWeekYear(isoWeekYear, week, day) {
      var date = new Date(0);
      date.setUTCFullYear(isoWeekYear, 0, 4);
      var fourthOfJanuaryDay = date.getUTCDay() || 7;
      var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
      date.setUTCDate(date.getUTCDate() + diff);
      return date;
    }

    // Validation functions

    // February is null to handle the leap year (using ||)
    var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    function isLeapYearIndex(year) {
      return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function validateDate(year, month, date) {
      return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
    }
    function validateDayOfYearDate(year, dayOfYear) {
      return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
    }
    function validateWeekDate(_year, week, day) {
      return week >= 1 && week <= 53 && day >= 0 && day <= 6;
    }
    function validateTime(hours, minutes, seconds) {
      if (hours === 24) {
        return minutes === 0 && seconds === 0;
      }
      return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
    }
    function validateTimezone(_hours, minutes) {
      return minutes >= 0 && minutes <= 59;
    }
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
    var esm_typeof = __webpack_require__("53ca");

    // CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js

    /**
     * @name isDate
     * @category Common Helpers
     * @summary Is the given value a date?
     *
     * @description
     * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
     *
     * @param {*} value - the value to check
     * @returns {boolean} true if the given value is a date
     * @throws {TypeError} 1 arguments required
     *
     * @example
     * // For a valid date:
     * const result = isDate(new Date())
     * //=> true
     *
     * @example
     * // For an invalid date:
     * const result = isDate(new Date(NaN))
     * //=> true
     *
     * @example
     * // For some value:
     * const result = isDate('2014-02-31')
     * //=> false
     *
     * @example
     * // For an object:
     * const result = isDate({})
     * //=> false
     */
    function isDate_isDate(value) {
      requiredArgs(1, arguments);
      return value instanceof Date || Object(esm_typeof["a" /* default */])(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/toDate/index.js

    /**
     * @name toDate
     * @category Common Helpers
     * @summary Convert the given argument to an instance of Date.
     *
     * @description
     * Convert the given argument to an instance of Date.
     *
     * If the argument is an instance of Date, the function returns its clone.
     *
     * If the argument is a number, it is treated as a timestamp.
     *
     * If the argument is none of the above, the function returns Invalid Date.
     *
     * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
     *
     * @param {Date|Number} argument - the value to convert
     * @returns {Date} the parsed date in the local time zone
     * @throws {TypeError} 1 argument required
     *
     * @example
     * // Clone the date:
     * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
     * //=> Tue Feb 11 2014 11:30:30
     *
     * @example
     * // Convert the timestamp to date:
     * const result = toDate(1392098430000)
     * //=> Tue Feb 11 2014 11:30:30
     */
    function toDate(argument) {
      requiredArgs(1, arguments);
      var argStr = Object.prototype.toString.call(argument);

      // Clone the date
      if (argument instanceof Date || Object(esm_typeof["a" /* default */])(argument) === 'object' && argStr === '[object Date]') {
        // Prevent the date to lose the milliseconds when passed to new Date() in IE10
        return new Date(argument.getTime());
      } else if (typeof argument === 'number' || argStr === '[object Number]') {
        return new Date(argument);
      } else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
          // eslint-disable-next-line no-console
          console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
          // eslint-disable-next-line no-console
          console.warn(new Error().stack);
        }
        return new Date(NaN);
      }
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js

    /**
     * @name isValid
     * @category Common Helpers
     * @summary Is the given date valid?
     *
     * @description
     * Returns false if argument is Invalid Date and true otherwise.
     * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
     * Invalid Date is a Date, whose time value is NaN.
     *
     * Time value of Date: http://es5.github.io/#x15.9.1.1
     *
     * @param {*} date - the date to check
     * @returns {Boolean} the date is valid
     * @throws {TypeError} 1 argument required
     *
     * @example
     * // For the valid date:
     * const result = isValid(new Date(2014, 1, 31))
     * //=> true
     *
     * @example
     * // For the value, convertable into a date:
     * const result = isValid(1393804800000)
     * //=> true
     *
     * @example
     * // For the invalid date:
     * const result = isValid(new Date(''))
     * //=> false
     */
    function isValid(dirtyDate) {
      requiredArgs(1, arguments);
      if (!isDate_isDate(dirtyDate) && typeof dirtyDate !== 'number') {
        return false;
      }
      var date = toDate(dirtyDate);
      return !isNaN(Number(date));
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/compareAsc/index.js

    /**
     * @name compareAsc
     * @category Common Helpers
     * @summary Compare the two dates and return -1, 0 or 1.
     *
     * @description
     * Compare the two dates and return 1 if the first date is after the second,
     * -1 if the first date is before the second or 0 if dates are equal.
     *
     * @param {Date|Number} dateLeft - the first date to compare
     * @param {Date|Number} dateRight - the second date to compare
     * @returns {Number} the result of the comparison
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // Compare 11 February 1987 and 10 July 1989:
     * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
     * //=> -1
     *
     * @example
     * // Sort the array of dates:
     * const result = [
     *   new Date(1995, 6, 2),
     *   new Date(1987, 1, 11),
     *   new Date(1989, 6, 10)
     * ].sort(compareAsc)
     * //=> [
     * //   Wed Feb 11 1987 00:00:00,
     * //   Mon Jul 10 1989 00:00:00,
     * //   Sun Jul 02 1995 00:00:00
     * // ]
     */
    function compareAsc(dirtyDateLeft, dirtyDateRight) {
      requiredArgs(2, arguments);
      var dateLeft = toDate(dirtyDateLeft);
      var dateRight = toDate(dirtyDateRight);
      var diff = dateLeft.getTime() - dateRight.getTime();
      if (diff < 0) {
        return -1;
      } else if (diff > 0) {
        return 1;
        // Return 0 if diff is 0; return NaN if diff is NaN
      } else {
        return diff;
      }
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js

    /**
     * @name differenceInMilliseconds
     * @category Millisecond Helpers
     * @summary Get the number of milliseconds between the given dates.
     *
     * @description
     * Get the number of milliseconds between the given dates.
     *
     * @param {Date|Number} dateLeft - the later date
     * @param {Date|Number} dateRight - the earlier date
     * @returns {Number} the number of milliseconds
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // How many milliseconds are between
     * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
     * const result = differenceInMilliseconds(
     *   new Date(2014, 6, 2, 12, 30, 21, 700),
     *   new Date(2014, 6, 2, 12, 30, 20, 600)
     * )
     * //=> 1100
     */
    function differenceInMilliseconds(dateLeft, dateRight) {
      requiredArgs(2, arguments);
      return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/roundingMethods/index.js
    var roundingMap = {
      ceil: Math.ceil,
      round: Math.round,
      floor: Math.floor,
      trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
      } // Math.trunc is not supported by IE
    };

    var defaultRoundingMethod = 'trunc';
    function getRoundingMethod(method) {
      return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMinutes/index.js

    /**
     * @name differenceInMinutes
     * @category Minute Helpers
     * @summary Get the number of minutes between the given dates.
     *
     * @description
     * Get the signed number of full (rounded towards 0) minutes between the given dates.
     *
     * @param {Date|Number} dateLeft - the later date
     * @param {Date|Number} dateRight - the earlier date
     * @param {Object} [options] - an object with options.
     * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
     * @returns {Number} the number of minutes
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
     * const result = differenceInMinutes(
     *   new Date(2014, 6, 2, 12, 20, 0),
     *   new Date(2014, 6, 2, 12, 7, 59)
     * )
     * //=> 12
     *
     * @example
     * // How many minutes are between 10:01:59 and 10:00:00
     * const result = differenceInMinutes(
     *   new Date(2000, 0, 1, 10, 0, 0),
     *   new Date(2000, 0, 1, 10, 1, 59)
     * )
     * //=> -1
     */
    function differenceInMinutes(dateLeft, dateRight, options) {
      requiredArgs(2, arguments);
      var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
      return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js

    /**
     * @name differenceInSeconds
     * @category Second Helpers
     * @summary Get the number of seconds between the given dates.
     *
     * @description
     * Get the number of seconds between the given dates.
     *
     * @param {Date|Number} dateLeft - the later date
     * @param {Date|Number} dateRight - the earlier date
     * @param {Object} [options] - an object with options.
     * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
     * @returns {Number} the number of seconds
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // How many seconds are between
     * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
     * const result = differenceInSeconds(
     *   new Date(2014, 6, 2, 12, 30, 20, 0),
     *   new Date(2014, 6, 2, 12, 30, 7, 999)
     * )
     * //=> 12
     */
    function differenceInSeconds(dateLeft, dateRight, options) {
      requiredArgs(2, arguments);
      var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
      return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
    }
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsCountdownTimer/MsCountdownTimer.vue?vue&type=script&lang=js&

    var COUNTDOWN_INTERVAL = 60 * 1000; // 1 minute

    /* harmony default export */
    var MsCountdownTimervue_type_script_lang_js_ = {
      name: 'MsCountdownTimer',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Countdown Timer'
      },
      components: {
        MsIcon: MsIcon
      },
      props: {
        /**
         * Sets label
         */
        label: {
          type: String,
          default: 'Promo ends in '
        },
        /**
         * Sets the different labels for time (specifically day, hours and minutes).
         */
        timeLabels: {
          type: Object,
          default: function _default() {
            return {
              days: 'days',
              hours: 'h',
              minutes: 'm',
              seconds: ''
            };
          }
        },
        /**
         * Sets end date to compare against
         */
        endDate: {
          type: String,
          default: null
        },
        /**
         * Sets hours before showing detailed countdown
         */
        hoursBeforeDetailedCountdown: {
          type: Number,
          default: 24
        }
      },
      data: function data() {
        return {
          enableHighlight: false,
          countdownStr: null,
          intervalTracker: false
        };
      },
      computed: {
        shouldCalculateAndRender: function shouldCalculateAndRender() {
          var endDateObj = parseISO(this.endDate);
          var isValidEndDate = isValid(endDateObj);

          // If valid date and endDate has not passed
          return isValidEndDate && compareAsc(new Date(), endDateObj) === -1;
        },
        showSeconds: function showSeconds() {
          return this.timeLabels.seconds && this.timeLabels.seconds !== '';
        }
      },
      watch: {
        endDate: function endDate(newEndDateValue) {
          // To restart the loop when prop is updated
          this.formatRemainingTime(newEndDateValue);
        }
      },
      mounted: function mounted() {
        // Start render loop on mount
        this.formatRemainingTime(this.endDate);
      },
      methods: {
        getRemaining: function getRemaining(endDate) {
          var difference = differenceInMinutes(parseISO(endDate), new Date());
          var hours = Math.floor(difference / 60);
          var minutes = difference % 60;
          if (this.showSeconds) {
            var remainingTime = {};
            var seconds = differenceInSeconds(parseISO(endDate), new Date()) % 60;
            remainingTime.seconds = seconds;
            if (this.timeLabels.hours && this.timeLabels.hours !== '') remainingTime.hours = hours;
            if (this.timeLabels.minutes && this.timeLabels.minutes !== '') remainingTime.minutes = minutes;
            if (remainingTime.minutes === 0 && remainingTime.seconds === 0) clearInterval(this.intervalTracker);
            return remainingTime;
          }
          return {
            hours: hours,
            minutes: minutes
          };
        },
        formatRemainingTime: function formatRemainingTime(endDate) {
          var _this = this;
          // if no endDate or if endDate has passed
          if (!this.shouldCalculateAndRender) {
            this.countdownStr = null;
            return;
          }
          var timerInterval = this.showSeconds ? 1000 : COUNTDOWN_INTERVAL;
          var remainingTime = this.getRemaining(endDate);
          if (remainingTime.hours < this.hoursBeforeDetailedCountdown) {
            // Prevent another loop if there is exising loop
            if (!this.intervalTracker) {
              // Start recurrsive loop to do countdown
              this.intervalTracker = setInterval(function () {
                _this.formatRemainingTime(endDate);
              }, timerInterval);
            }
            if (this.showSeconds) {
              this.countdownStr = remainingTime.minutes === 0 ? "".concat(remainingTime.seconds).concat(this.timeLabels.seconds) : "".concat(remainingTime.minutes).concat(this.timeLabels.minutes, " ").concat(remainingTime.seconds).concat(this.timeLabels.seconds);
            } else {
              this.countdownStr = "".concat(remainingTime.hours).concat(this.timeLabels.hours, ":").concat(remainingTime.minutes).concat(this.timeLabels.minutes);
            }
            this.enableHighlight = true;
            return;
          }

          // if more than a day
          var endDateObj = parseISO(endDate);
          var differenceSeconds = differenceInSeconds(endDateObj, new Date());
          var daysLeft = Math.ceil(differenceSeconds / 24 / 60 / 60);
          this.countdownStr = "".concat(daysLeft, " ").concat(this.timeLabels.days);
          this.enableHighlight = false;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsCountdownTimer/MsCountdownTimer.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsCountdownTimer_MsCountdownTimervue_type_script_lang_js_ = MsCountdownTimervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsCountdownTimer/MsCountdownTimer.vue

    /* normalize component */

    var MsCountdownTimer_component = normalizeComponent(MsCountdownTimer_MsCountdownTimervue_type_script_lang_js_, MsCountdownTimervue_type_template_id_92072c4a_render, MsCountdownTimervue_type_template_id_92072c4a_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsCountdownTimer = MsCountdownTimer_component.exports;
    // CONCATENATED MODULE: ./src/components/MsCountdownTimer/index.js

    MsCountdownTimer.install = function (Vue) {
      return Vue.component(MsCountdownTimer.name, MsCountdownTimer);
    };
    /* harmony default export */
    var components_MsCountdownTimer = MsCountdownTimer;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDatePicker/MsDatePicker.vue?vue&type=template&id=55cd26a5&
    var MsDatePickervue_type_template_id_55cd26a5_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "date-picker",
        class: {
          'date-picker--filled': _vm.focused || _vm.filled
        }
      }, [_c('date-picker', _vm._b({
        attrs: {
          "color": "blue",
          "locale": _vm.locale
        },
        scopedSlots: _vm._u([_vm.mode === 'range' || _vm.mode === 'auto' ? {
          key: "default",
          fn: function fn(_ref) {
            var inputEvents = _ref.inputEvents;
            return [_c('input', _vm._g(_vm._b({}, 'input', _vm.inputProperties, false), _vm.events(inputEvents)))];
          }
        } : null], null, true),
        model: {
          value: _vm.selectedDate,
          callback: function callback($$v) {
            _vm.selectedDate = $$v;
          },
          expression: "selectedDate"
        }
      }, 'date-picker', _vm.pickerProperties, false)), _c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v(_vm._s(_vm.placeholder))])], 1);
    };
    var MsDatePickervue_type_template_id_55cd26a5_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsDatePicker/MsDatePicker.vue?vue&type=template&id=55cd26a5&

    // CONCATENATED MODULE: ./node_modules/date-fns/esm/addDays/index.js

    /**
     * @name addDays
     * @category Day Helpers
     * @summary Add the specified number of days to the given date.
     *
     * @description
     * Add the specified number of days to the given date.
     *
     * @param {Date|Number} date - the date to be changed
     * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
     * @returns {Date} - the new date with the days added
     * @throws {TypeError} - 2 arguments required
     *
     * @example
     * // Add 10 days to 1 September 2014:
     * const result = addDays(new Date(2014, 8, 1), 10)
     * //=> Thu Sep 11 2014 00:00:00
     */
    function addDays(dirtyDate, dirtyAmount) {
      requiredArgs(2, arguments);
      var date = toDate(dirtyDate);
      var amount = toInteger(dirtyAmount);
      if (isNaN(amount)) {
        return new Date(NaN);
      }
      if (!amount) {
        // If 0 days, no-op to avoid changing times in the hour before end of DST
        return date;
      }
      date.setDate(date.getDate() + amount);
      return date;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js

    /**
     * @name addMilliseconds
     * @category Millisecond Helpers
     * @summary Add the specified number of milliseconds to the given date.
     *
     * @description
     * Add the specified number of milliseconds to the given date.
     *
     * @param {Date|Number} date - the date to be changed
     * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
     * @returns {Date} the new date with the milliseconds added
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
     * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
     * //=> Thu Jul 10 2014 12:45:30.750
     */
    function addMilliseconds(dirtyDate, dirtyAmount) {
      requiredArgs(2, arguments);
      var timestamp = toDate(dirtyDate).getTime();
      var amount = toInteger(dirtyAmount);
      return new Date(timestamp + amount);
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js

    /**
     * @name subMilliseconds
     * @category Millisecond Helpers
     * @summary Subtract the specified number of milliseconds from the given date.
     *
     * @description
     * Subtract the specified number of milliseconds from the given date.
     *
     * @param {Date|Number} date - the date to be changed
     * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
     * @returns {Date} the new date with the milliseconds subtracted
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
     * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
     * //=> Thu Jul 10 2014 12:45:29.250
     */
    function subMilliseconds(dirtyDate, dirtyAmount) {
      requiredArgs(2, arguments);
      var amount = toInteger(dirtyAmount);
      return addMilliseconds(dirtyDate, -amount);
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js

    var MILLISECONDS_IN_DAY = 86400000;
    function getUTCDayOfYear(dirtyDate) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var timestamp = date.getTime();
      date.setUTCMonth(0, 1);
      date.setUTCHours(0, 0, 0, 0);
      var startOfYearTimestamp = date.getTime();
      var difference = timestamp - startOfYearTimestamp;
      return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js

    function startOfUTCISOWeek(dirtyDate) {
      requiredArgs(1, arguments);
      var weekStartsOn = 1;
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js

    function getUTCISOWeekYear(dirtyDate) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var year = date.getUTCFullYear();
      var fourthOfJanuaryOfNextYear = new Date(0);
      fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
      fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
      var fourthOfJanuaryOfThisYear = new Date(0);
      fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
      fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js

    function startOfUTCISOWeekYear(dirtyDate) {
      requiredArgs(1, arguments);
      var year = getUTCISOWeekYear(dirtyDate);
      var fourthOfJanuary = new Date(0);
      fourthOfJanuary.setUTCFullYear(year, 0, 4);
      fourthOfJanuary.setUTCHours(0, 0, 0, 0);
      var date = startOfUTCISOWeek(fourthOfJanuary);
      return date;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js

    var MILLISECONDS_IN_WEEK = 604800000;
    function getUTCISOWeek(dirtyDate) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

      // Round the number of days to the nearest integer
      // because the number of milliseconds in a week is not constant
      // (e.g. it's different in the week of the daylight saving time clock shift)
      return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
    var defaultOptions_defaultOptions = {};
    function getDefaultOptions() {
      return defaultOptions_defaultOptions;
    }
    function setDefaultOptions(newOptions) {
      defaultOptions_defaultOptions = newOptions;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js

    function startOfUTCWeek(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      requiredArgs(1, arguments);
      var defaultOptions = getDefaultOptions();
      var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

      // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
      }
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js

    function getUTCWeekYear(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var year = date.getUTCFullYear();
      var defaultOptions = getDefaultOptions();
      var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

      // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
      }
      var firstWeekOfNextYear = new Date(0);
      firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
      firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
      var firstWeekOfThisYear = new Date(0);
      firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js

    function startOfUTCWeekYear(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      requiredArgs(1, arguments);
      var defaultOptions = getDefaultOptions();
      var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
      var year = getUTCWeekYear(dirtyDate, options);
      var firstWeek = new Date(0);
      firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeek.setUTCHours(0, 0, 0, 0);
      var date = startOfUTCWeek(firstWeek, options);
      return date;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js

    var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
    function getUTCWeek(dirtyDate, options) {
      requiredArgs(1, arguments);
      var date = toDate(dirtyDate);
      var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

      // Round the number of days to the nearest integer
      // because the number of milliseconds in a week is not constant
      // (e.g. it's different in the week of the daylight saving time clock shift)
      return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
    function addLeadingZeros(number, targetLength) {
      var sign = number < 0 ? '-' : '';
      var output = Math.abs(number).toString();
      while (output.length < targetLength) {
        output = '0' + output;
      }
      return sign + output;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* |                                |
     * |  d  | Day of month                   |  D  |                                |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  m  | Minute                         |  M  | Month                          |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  y  | Year (abs)                     |  Y  |                                |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     */
    var formatters = {
      // Year
      y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
      },
      // Month
      M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
      },
      // Day of the month
      d: function d(date, token) {
        return addLeadingZeros(date.getUTCDate(), token.length);
      },
      // AM or PM
      a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch (token) {
          case 'a':
          case 'aa':
            return dayPeriodEnumValue.toUpperCase();
          case 'aaa':
            return dayPeriodEnumValue;
          case 'aaaaa':
            return dayPeriodEnumValue[0];
          case 'aaaa':
          default:
            return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
      },
      // Hour [1-12]
      h: function h(date, token) {
        return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
      },
      // Hour [0-23]
      H: function H(date, token) {
        return addLeadingZeros(date.getUTCHours(), token.length);
      },
      // Minute
      m: function m(date, token) {
        return addLeadingZeros(date.getUTCMinutes(), token.length);
      },
      // Second
      s: function s(date, token) {
        return addLeadingZeros(date.getUTCSeconds(), token.length);
      },
      // Fraction of second
      S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return addLeadingZeros(fractionalSeconds, token.length);
      }
    };
    /* harmony default export */
    var lightFormatters = formatters;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js

    var dayPeriodEnum = {
      am: 'am',
      pm: 'pm',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    };
    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* | Milliseconds in day            |
     * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
     * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
     * |  d  | Day of month                   |  D  | Day of year                    |
     * |  e  | Local day of week              |  E  | Day of week                    |
     * |  f  |                                |  F* | Day of week in month           |
     * |  g* | Modified Julian day            |  G  | Era                            |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  i! | ISO day of week                |  I! | ISO week of year               |
     * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
     * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
     * |  l* | (deprecated)                   |  L  | Stand-alone month              |
     * |  m  | Minute                         |  M  | Month                          |
     * |  n  |                                |  N  |                                |
     * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
     * |  p! | Long localized time            |  P! | Long localized date            |
     * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
     * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
     * |  u  | Extended year                  |  U* | Cyclic year                    |
     * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
     * |  w  | Local week of year             |  W* | Week of month                  |
     * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
     * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
     * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     *
     * Letters marked by ! are non-standard, but implemented by date-fns:
     * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
     * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
     *   i.e. 7 for Sunday, 1 for Monday, etc.
     * - `I` is ISO week of year, as opposed to `w` which is local week of year.
     * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
     *   `R` is supposed to be used in conjunction with `I` and `i`
     *   for universal ISO week-numbering date, whereas
     *   `Y` is supposed to be used in conjunction with `w` and `e`
     *   for week-numbering date specific to the locale.
     * - `P` is long localized date format
     * - `p` is long localized time format
     */

    var formatters_formatters = {
      // Era
      G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch (token) {
          // AD, BC
          case 'G':
          case 'GG':
          case 'GGG':
            return localize.era(era, {
              width: 'abbreviated'
            });
          // A, B
          case 'GGGGG':
            return localize.era(era, {
              width: 'narrow'
            });
          // Anno Domini, Before Christ
          case 'GGGG':
          default:
            return localize.era(era, {
              width: 'wide'
            });
        }
      },
      // Year
      y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
          var signedYear = date.getUTCFullYear();
          // Returns 1 for 1 BC (which is year 0 in JavaScript)
          var year = signedYear > 0 ? signedYear : 1 - signedYear;
          return localize.ordinalNumber(year, {
            unit: 'year'
          });
        }
        return lightFormatters.y(date, token);
      },
      // Local week-numbering year
      Y: function Y(date, token, localize, options) {
        var signedWeekYear = getUTCWeekYear(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

        // Two digit year
        if (token === 'YY') {
          var twoDigitYear = weekYear % 100;
          return addLeadingZeros(twoDigitYear, 2);
        }

        // Ordinal number
        if (token === 'Yo') {
          return localize.ordinalNumber(weekYear, {
            unit: 'year'
          });
        }

        // Padding
        return addLeadingZeros(weekYear, token.length);
      },
      // ISO week-numbering year
      R: function R(date, token) {
        var isoWeekYear = getUTCISOWeekYear(date);

        // Padding
        return addLeadingZeros(isoWeekYear, token.length);
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function u(date, token) {
        var year = date.getUTCFullYear();
        return addLeadingZeros(year, token.length);
      },
      // Quarter
      Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case 'Q':
            return String(quarter);
          // 01, 02, 03, 04
          case 'QQ':
            return addLeadingZeros(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case 'Qo':
            return localize.ordinalNumber(quarter, {
              unit: 'quarter'
            });
          // Q1, Q2, Q3, Q4
          case 'QQQ':
            return localize.quarter(quarter, {
              width: 'abbreviated',
              context: 'formatting'
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case 'QQQQQ':
            return localize.quarter(quarter, {
              width: 'narrow',
              context: 'formatting'
            });
          // 1st quarter, 2nd quarter, ...
          case 'QQQQ':
          default:
            return localize.quarter(quarter, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // Stand-alone quarter
      q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case 'q':
            return String(quarter);
          // 01, 02, 03, 04
          case 'qq':
            return addLeadingZeros(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case 'qo':
            return localize.ordinalNumber(quarter, {
              unit: 'quarter'
            });
          // Q1, Q2, Q3, Q4
          case 'qqq':
            return localize.quarter(quarter, {
              width: 'abbreviated',
              context: 'standalone'
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case 'qqqqq':
            return localize.quarter(quarter, {
              width: 'narrow',
              context: 'standalone'
            });
          // 1st quarter, 2nd quarter, ...
          case 'qqqq':
          default:
            return localize.quarter(quarter, {
              width: 'wide',
              context: 'standalone'
            });
        }
      },
      // Month
      M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch (token) {
          case 'M':
          case 'MM':
            return lightFormatters.M(date, token);
          // 1st, 2nd, ..., 12th
          case 'Mo':
            return localize.ordinalNumber(month + 1, {
              unit: 'month'
            });
          // Jan, Feb, ..., Dec
          case 'MMM':
            return localize.month(month, {
              width: 'abbreviated',
              context: 'formatting'
            });
          // J, F, ..., D
          case 'MMMMM':
            return localize.month(month, {
              width: 'narrow',
              context: 'formatting'
            });
          // January, February, ..., December
          case 'MMMM':
          default:
            return localize.month(month, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // Stand-alone month
      L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch (token) {
          // 1, 2, ..., 12
          case 'L':
            return String(month + 1);
          // 01, 02, ..., 12
          case 'LL':
            return addLeadingZeros(month + 1, 2);
          // 1st, 2nd, ..., 12th
          case 'Lo':
            return localize.ordinalNumber(month + 1, {
              unit: 'month'
            });
          // Jan, Feb, ..., Dec
          case 'LLL':
            return localize.month(month, {
              width: 'abbreviated',
              context: 'standalone'
            });
          // J, F, ..., D
          case 'LLLLL':
            return localize.month(month, {
              width: 'narrow',
              context: 'standalone'
            });
          // January, February, ..., December
          case 'LLLL':
          default:
            return localize.month(month, {
              width: 'wide',
              context: 'standalone'
            });
        }
      },
      // Local week of year
      w: function w(date, token, localize, options) {
        var week = getUTCWeek(date, options);
        if (token === 'wo') {
          return localize.ordinalNumber(week, {
            unit: 'week'
          });
        }
        return addLeadingZeros(week, token.length);
      },
      // ISO week of year
      I: function I(date, token, localize) {
        var isoWeek = getUTCISOWeek(date);
        if (token === 'Io') {
          return localize.ordinalNumber(isoWeek, {
            unit: 'week'
          });
        }
        return addLeadingZeros(isoWeek, token.length);
      },
      // Day of the month
      d: function d(date, token, localize) {
        if (token === 'do') {
          return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
          });
        }
        return lightFormatters.d(date, token);
      },
      // Day of year
      D: function D(date, token, localize) {
        var dayOfYear = getUTCDayOfYear(date);
        if (token === 'Do') {
          return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
          });
        }
        return addLeadingZeros(dayOfYear, token.length);
      },
      // Day of week
      E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch (token) {
          // Tue
          case 'E':
          case 'EE':
          case 'EEE':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting'
            });
          // T
          case 'EEEEE':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tu
          case 'EEEEEE':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting'
            });
          // Tuesday
          case 'EEEE':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // Local day of week
      e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case 'e':
            return String(localDayOfWeek);
          // Padded numerical value
          case 'ee':
            return addLeadingZeros(localDayOfWeek, 2);
          // 1st, 2nd, ..., 7th
          case 'eo':
            return localize.ordinalNumber(localDayOfWeek, {
              unit: 'day'
            });
          case 'eee':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting'
            });
          // T
          case 'eeeee':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tu
          case 'eeeeee':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting'
            });
          // Tuesday
          case 'eeee':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // Stand-alone local day of week
      c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (same as in `e`)
          case 'c':
            return String(localDayOfWeek);
          // Padded numerical value
          case 'cc':
            return addLeadingZeros(localDayOfWeek, token.length);
          // 1st, 2nd, ..., 7th
          case 'co':
            return localize.ordinalNumber(localDayOfWeek, {
              unit: 'day'
            });
          case 'ccc':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'standalone'
            });
          // T
          case 'ccccc':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'standalone'
            });
          // Tu
          case 'cccccc':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'standalone'
            });
          // Tuesday
          case 'cccc':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'standalone'
            });
        }
      },
      // ISO day of week
      i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch (token) {
          // 2
          case 'i':
            return String(isoDayOfWeek);
          // 02
          case 'ii':
            return addLeadingZeros(isoDayOfWeek, token.length);
          // 2nd
          case 'io':
            return localize.ordinalNumber(isoDayOfWeek, {
              unit: 'day'
            });
          // Tue
          case 'iii':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting'
            });
          // T
          case 'iiiii':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tu
          case 'iiiiii':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting'
            });
          // Tuesday
          case 'iiii':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // AM or PM
      a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch (token) {
          case 'a':
          case 'aa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            });
          case 'aaa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            }).toLowerCase();
          case 'aaaaa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'aaaa':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // AM, PM, midnight, noon
      b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) {
          dayPeriodEnumValue = dayPeriodEnum.noon;
        } else if (hours === 0) {
          dayPeriodEnumValue = dayPeriodEnum.midnight;
        } else {
          dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        }
        switch (token) {
          case 'b':
          case 'bb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            });
          case 'bbb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            }).toLowerCase();
          case 'bbbbb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'bbbb':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // in the morning, in the afternoon, in the evening, at night
      B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) {
          dayPeriodEnumValue = dayPeriodEnum.evening;
        } else if (hours >= 12) {
          dayPeriodEnumValue = dayPeriodEnum.afternoon;
        } else if (hours >= 4) {
          dayPeriodEnumValue = dayPeriodEnum.morning;
        } else {
          dayPeriodEnumValue = dayPeriodEnum.night;
        }
        switch (token) {
          case 'B':
          case 'BB':
          case 'BBB':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            });
          case 'BBBBB':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'BBBB':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting'
            });
        }
      },
      // Hour [1-12]
      h: function h(date, token, localize) {
        if (token === 'ho') {
          var hours = date.getUTCHours() % 12;
          if (hours === 0) hours = 12;
          return localize.ordinalNumber(hours, {
            unit: 'hour'
          });
        }
        return lightFormatters.h(date, token);
      },
      // Hour [0-23]
      H: function H(date, token, localize) {
        if (token === 'Ho') {
          return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
          });
        }
        return lightFormatters.H(date, token);
      },
      // Hour [0-11]
      K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') {
          return localize.ordinalNumber(hours, {
            unit: 'hour'
          });
        }
        return addLeadingZeros(hours, token.length);
      },
      // Hour [1-24]
      k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') {
          return localize.ordinalNumber(hours, {
            unit: 'hour'
          });
        }
        return addLeadingZeros(hours, token.length);
      },
      // Minute
      m: function m(date, token, localize) {
        if (token === 'mo') {
          return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
          });
        }
        return lightFormatters.m(date, token);
      },
      // Second
      s: function s(date, token, localize) {
        if (token === 'so') {
          return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
          });
        }
        return lightFormatters.s(date, token);
      },
      // Fraction of second
      S: function S(date, token) {
        return lightFormatters.S(date, token);
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) {
          return 'Z';
        }
        switch (token) {
          // Hours and optional minutes
          case 'X':
            return formatTimezoneWithOptionalMinutes(timezoneOffset);

          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case 'XXXX':
          case 'XX':
            // Hours and minutes without `:` delimiter
            return formatTimezone(timezoneOffset);

          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case 'XXXXX':
          case 'XXX': // Hours and minutes with `:` delimiter
          default:
            return formatTimezone(timezoneOffset, ':');
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Hours and optional minutes
          case 'x':
            return formatTimezoneWithOptionalMinutes(timezoneOffset);

          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case 'xxxx':
          case 'xx':
            // Hours and minutes without `:` delimiter
            return formatTimezone(timezoneOffset);

          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case 'xxxxx':
          case 'xxx': // Hours and minutes with `:` delimiter
          default:
            return formatTimezone(timezoneOffset, ':');
        }
      },
      // Timezone (GMT)
      O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case 'O':
          case 'OO':
          case 'OOO':
            return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
          // Long
          case 'OOOO':
          default:
            return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
      },
      // Timezone (specific non-location)
      z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case 'z':
          case 'zz':
          case 'zzz':
            return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
          // Long
          case 'zzzz':
          default:
            return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
      },
      // Seconds timestamp
      t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return addLeadingZeros(timestamp, token.length);
      },
      // Milliseconds timestamp
      T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return addLeadingZeros(timestamp, token.length);
      }
    };
    function formatTimezoneShort(offset, dirtyDelimiter) {
      var sign = offset > 0 ? '-' : '+';
      var absOffset = Math.abs(offset);
      var hours = Math.floor(absOffset / 60);
      var minutes = absOffset % 60;
      if (minutes === 0) {
        return sign + String(hours);
      }
      var delimiter = dirtyDelimiter || '';
      return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
    }
    function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
      if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
      }
      return formatTimezone(offset, dirtyDelimiter);
    }
    function formatTimezone(offset, dirtyDelimiter) {
      var delimiter = dirtyDelimiter || '';
      var sign = offset > 0 ? '-' : '+';
      var absOffset = Math.abs(offset);
      var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
      var minutes = addLeadingZeros(absOffset % 60, 2);
      return sign + hours + delimiter + minutes;
    }
    /* harmony default export */
    var format_formatters = formatters_formatters;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
    var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
      switch (pattern) {
        case 'P':
          return formatLong.date({
            width: 'short'
          });
        case 'PP':
          return formatLong.date({
            width: 'medium'
          });
        case 'PPP':
          return formatLong.date({
            width: 'long'
          });
        case 'PPPP':
        default:
          return formatLong.date({
            width: 'full'
          });
      }
    };
    var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
      switch (pattern) {
        case 'p':
          return formatLong.time({
            width: 'short'
          });
        case 'pp':
          return formatLong.time({
            width: 'medium'
          });
        case 'ppp':
          return formatLong.time({
            width: 'long'
          });
        case 'pppp':
        default:
          return formatLong.time({
            width: 'full'
          });
      }
    };
    var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
      var matchResult = pattern.match(/(P+)(p+)?/) || [];
      var datePattern = matchResult[1];
      var timePattern = matchResult[2];
      if (!timePattern) {
        return dateLongFormatter(pattern, formatLong);
      }
      var dateTimeFormat;
      switch (datePattern) {
        case 'P':
          dateTimeFormat = formatLong.dateTime({
            width: 'short'
          });
          break;
        case 'PP':
          dateTimeFormat = formatLong.dateTime({
            width: 'medium'
          });
          break;
        case 'PPP':
          dateTimeFormat = formatLong.dateTime({
            width: 'long'
          });
          break;
        case 'PPPP':
        default:
          dateTimeFormat = formatLong.dateTime({
            width: 'full'
          });
          break;
      }
      return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
    };
    var longFormatters = {
      p: timeLongFormatter,
      P: dateTimeLongFormatter
    };
    /* harmony default export */
    var format_longFormatters = longFormatters;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
    /**
     * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
     * They usually appear for dates that denote time before the timezones were introduced
     * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
     * and GMT+01:00:00 after that date)
     *
     * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
     * which would lead to incorrect calculations.
     *
     * This function returns the timezone offset in milliseconds that takes seconds in account.
     */
    function getTimezoneOffsetInMilliseconds(date) {
      var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
      utcDate.setUTCFullYear(date.getFullYear());
      return date.getTime() - utcDate.getTime();
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
    var protectedDayOfYearTokens = ['D', 'DD'];
    var protectedWeekYearTokens = ['YY', 'YYYY'];
    function isProtectedDayOfYearToken(token) {
      return protectedDayOfYearTokens.indexOf(token) !== -1;
    }
    function isProtectedWeekYearToken(token) {
      return protectedWeekYearTokens.indexOf(token) !== -1;
    }
    function throwProtectedError(token, format, input) {
      if (token === 'YYYY') {
        throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === 'YY') {
        throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === 'D') {
        throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === 'DD') {
        throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      }
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
    var formatDistanceLocale = {
      lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
      },
      xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
      },
      halfAMinute: 'half a minute',
      lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
      },
      xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
      },
      aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
      },
      xHours: {
        one: '1 hour',
        other: '{{count}} hours'
      },
      xDays: {
        one: '1 day',
        other: '{{count}} days'
      },
      aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
      },
      xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
      },
      aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
      },
      xMonths: {
        one: '1 month',
        other: '{{count}} months'
      },
      aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
      },
      xYears: {
        one: '1 year',
        other: '{{count}} years'
      },
      overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
      },
      almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
      }
    };
    var formatDistance = function formatDistance(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale[token];
      if (typeof tokenValue === 'string') {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace('{{count}}', count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return 'in ' + result;
        } else {
          return result + ' ago';
        }
      }
      return result;
    };
    /* harmony default export */
    var _lib_formatDistance = formatDistance;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
    function buildFormatLongFn(args) {
      return function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
      };
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

    var dateFormats = {
      full: 'EEEE, MMMM do, y',
      long: 'MMMM do, y',
      medium: 'MMM d, y',
      short: 'MM/dd/yyyy'
    };
    var timeFormats = {
      full: 'h:mm:ss a zzzz',
      long: 'h:mm:ss a z',
      medium: 'h:mm:ss a',
      short: 'h:mm a'
    };
    var dateTimeFormats = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: '{{date}}, {{time}}',
      short: '{{date}}, {{time}}'
    };
    var formatLong = {
      date: buildFormatLongFn({
        formats: dateFormats,
        defaultWidth: 'full'
      }),
      time: buildFormatLongFn({
        formats: timeFormats,
        defaultWidth: 'full'
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats,
        defaultWidth: 'full'
      })
    };
    /* harmony default export */
    var _lib_formatLong = formatLong;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
    var formatRelativeLocale = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: 'P'
    };
    var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
      return formatRelativeLocale[token];
    };
    /* harmony default export */
    var _lib_formatRelative = formatRelative;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
    function buildLocalizeFn(args) {
      return function (dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
          var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
          var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
          valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
          var _defaultWidth = args.defaultWidth;
          var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
          valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
      };
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

    var eraValues = {
      narrow: ['B', 'A'],
      abbreviated: ['BC', 'AD'],
      wide: ['Before Christ', 'Anno Domini']
    };
    var quarterValues = {
      narrow: ['1', '2', '3', '4'],
      abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
      wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
    };

    // Note: in English, the names of days of the week and months are capitalized.
    // If you are making a new locale based on this one, check if the same is true for the language you're working on.
    // Generally, formatted dates should look like they are in the middle of a sentence,
    // e.g. in Spanish language the weekdays and months should be in the lowercase.
    var monthValues = {
      narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
      abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };
    var dayValues = {
      narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    };
    var dayPeriodValues = {
      narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
      },
      abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
      },
      wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
      }
    };
    var formattingDayPeriodValues = {
      narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
      },
      abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
      },
      wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
      }
    };
    var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
      var number = Number(dirtyNumber);

      // If ordinal numbers depend on context, for example,
      // if they are different for different grammatical genders,
      // use `options.unit`.
      //
      // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
      // 'day', 'hour', 'minute', 'second'.

      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + 'st';
          case 2:
            return number + 'nd';
          case 3:
            return number + 'rd';
        }
      }
      return number + 'th';
    };
    var localize_localize = {
      ordinalNumber: ordinalNumber,
      era: buildLocalizeFn({
        values: eraValues,
        defaultWidth: 'wide'
      }),
      quarter: buildLocalizeFn({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues,
        defaultWidth: 'wide'
      }),
      day: buildLocalizeFn({
        values: dayValues,
        defaultWidth: 'wide'
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
      })
    };
    /* harmony default export */
    var _lib_localize = localize_localize;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
    function buildMatchFn(args) {
      return function (string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) {
          return null;
        }
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
          return pattern.test(matchedString);
        }) : findKey(parsePatterns, function (pattern) {
          return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value: value,
          rest: rest
        };
      };
    }
    function findKey(object, predicate) {
      for (var key in object) {
        if (object.hasOwnProperty(key) && predicate(object[key])) {
          return key;
        }
      }
      return undefined;
    }
    function findIndex(array, predicate) {
      for (var key = 0; key < array.length; key++) {
        if (predicate(array[key])) {
          return key;
        }
      }
      return undefined;
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
    function buildMatchPatternFn(args) {
      return function (string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value: value,
          rest: rest
        };
      };
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js

    var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    var parseOrdinalNumberPattern = /\d+/i;
    var matchEraPatterns = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var parseEraPatterns = {
      any: [/^b/i, /^(a|c)/i]
    };
    var matchQuarterPatterns = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var parseQuarterPatterns = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    var matchMonthPatterns = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var parseMonthPatterns = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    var matchDayPatterns = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var parseDayPatterns = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    };
    var matchDayPeriodPatterns = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var parseDayPeriodPatterns = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    };
    var match = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
      })
    };
    /* harmony default export */
    var _lib_match = match;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js

    /**
     * @type {Locale}
     * @category Locales
     * @summary English locale (United States).
     * @language English
     * @iso-639-2 eng
     * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
     * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
     */
    var en_US_locale = {
      code: 'en-US',
      formatDistance: _lib_formatDistance,
      formatLong: _lib_formatLong,
      formatRelative: _lib_formatRelative,
      localize: _lib_localize,
      match: _lib_match,
      options: {
        weekStartsOn: 0 /* Sunday */,
        firstWeekContainsDate: 1
      }
    };
    /* harmony default export */
    var en_US = en_US_locale;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

    /* harmony default export */
    var defaultLocale = en_US;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js

    // This RegExp consists of three parts separated by `|`:
    // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
    //   (one of the certain letters followed by `o`)
    // - (\w)\1* matches any sequences of the same letter
    // - '' matches two quote characters in a row
    // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
    //   except a single quote symbol, which ends the sequence.
    //   Two quote characters do not end the sequence.
    //   If there is no matching single quote
    //   then the sequence will continue until the end of the string.
    // - . matches any single character unmatched by previous parts of the RegExps
    var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

    // This RegExp catches symbols escaped by quotes, and also
    // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
    var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var escapedStringRegExp = /^'([^]*?)'?$/;
    var doubleQuoteRegExp = /''/g;
    var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

    /**
     * @name format
     * @category Common Helpers
     * @summary Format the date.
     *
     * @description
     * Return the formatted date string in the given format. The result may vary by locale.
     *
     * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
     * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     *
     * The characters wrapped between two single quotes characters (') are escaped.
     * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
     * (see the last example)
     *
     * Format of the string is based on Unicode Technical Standard #35:
     * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
     * with a few additions (see note 7 below the table).
     *
     * Accepted patterns:
     * | Unit                            | Pattern | Result examples                   | Notes |
     * |---------------------------------|---------|-----------------------------------|-------|
     * | Era                             | G..GGG  | AD, BC                            |       |
     * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
     * |                                 | GGGGG   | A, B                              |       |
     * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
     * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
     * |                                 | yy      | 44, 01, 00, 17                    | 5     |
     * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
     * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
     * |                                 | yyyyy   | ...                               | 3,5   |
     * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
     * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
     * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
     * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
     * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
     * |                                 | YYYYY   | ...                               | 3,5   |
     * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
     * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
     * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
     * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
     * |                                 | RRRRR   | ...                               | 3,5,7 |
     * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
     * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
     * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
     * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
     * |                                 | uuuuu   | ...                               | 3,5   |
     * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
     * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
     * |                                 | QQ      | 01, 02, 03, 04                    |       |
     * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
     * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
     * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
     * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
     * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
     * |                                 | qq      | 01, 02, 03, 04                    |       |
     * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
     * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
     * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
     * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
     * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
     * |                                 | MM      | 01, 02, ..., 12                   |       |
     * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
     * |                                 | MMMM    | January, February, ..., December  | 2     |
     * |                                 | MMMMM   | J, F, ..., D                      |       |
     * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
     * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
     * |                                 | LL      | 01, 02, ..., 12                   |       |
     * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
     * |                                 | LLLL    | January, February, ..., December  | 2     |
     * |                                 | LLLLL   | J, F, ..., D                      |       |
     * | Local week of year              | w       | 1, 2, ..., 53                     |       |
     * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
     * |                                 | ww      | 01, 02, ..., 53                   |       |
     * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
     * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
     * |                                 | II      | 01, 02, ..., 53                   | 7     |
     * | Day of month                    | d       | 1, 2, ..., 31                     |       |
     * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
     * |                                 | dd      | 01, 02, ..., 31                   |       |
     * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
     * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
     * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
     * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
     * |                                 | DDDD    | ...                               | 3     |
     * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
     * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
     * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
     * |                                 | ii      | 01, 02, ..., 07                   | 7     |
     * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
     * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
     * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
     * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
     * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
     * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
     * |                                 | ee      | 02, 03, ..., 01                   |       |
     * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
     * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
     * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
     * |                                 | cc      | 02, 03, ..., 01                   |       |
     * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
     * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | AM, PM                          | a..aa   | AM, PM                            |       |
     * |                                 | aaa     | am, pm                            |       |
     * |                                 | aaaa    | a.m., p.m.                        | 2     |
     * |                                 | aaaaa   | a, p                              |       |
     * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
     * |                                 | bbb     | am, pm, noon, midnight            |       |
     * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
     * |                                 | bbbbb   | a, p, n, mi                       |       |
     * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
     * |                                 | BBBB    | at night, in the morning, ...     | 2     |
     * |                                 | BBBBB   | at night, in the morning, ...     |       |
     * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
     * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
     * |                                 | hh      | 01, 02, ..., 11, 12               |       |
     * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
     * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
     * |                                 | HH      | 00, 01, 02, ..., 23               |       |
     * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
     * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
     * |                                 | KK      | 01, 02, ..., 11, 00               |       |
     * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
     * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
     * |                                 | kk      | 24, 01, 02, ..., 23               |       |
     * | Minute                          | m       | 0, 1, ..., 59                     |       |
     * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
     * |                                 | mm      | 00, 01, ..., 59                   |       |
     * | Second                          | s       | 0, 1, ..., 59                     |       |
     * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
     * |                                 | ss      | 00, 01, ..., 59                   |       |
     * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
     * |                                 | SS      | 00, 01, ..., 99                   |       |
     * |                                 | SSS     | 000, 001, ..., 999                |       |
     * |                                 | SSSS    | ...                               | 3     |
     * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
     * |                                 | XX      | -0800, +0530, Z                   |       |
     * |                                 | XXX     | -08:00, +05:30, Z                 |       |
     * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
     * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
     * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
     * |                                 | xx      | -0800, +0530, +0000               |       |
     * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
     * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
     * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
     * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
     * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
     * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
     * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
     * | Seconds timestamp               | t       | 512969520                         | 7     |
     * |                                 | tt      | ...                               | 3,7   |
     * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
     * |                                 | TT      | ...                               | 3,7   |
     * | Long localized date             | P       | 04/29/1453                        | 7     |
     * |                                 | PP      | Apr 29, 1453                      | 7     |
     * |                                 | PPP     | April 29th, 1453                  | 7     |
     * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
     * | Long localized time             | p       | 12:00 AM                          | 7     |
     * |                                 | pp      | 12:00:00 AM                       | 7     |
     * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
     * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
     * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
     * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
     * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
     * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
     * Notes:
     * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
     *    are the same as "stand-alone" units, but are different in some languages.
     *    "Formatting" units are declined according to the rules of the language
     *    in the context of a date. "Stand-alone" units are always nominative singular:
     *
     *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
     *
     *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
     *
     * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
     *    the single quote characters (see below).
     *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
     *    the output will be the same as default pattern for this unit, usually
     *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
     *    are marked with "2" in the last column of the table.
     *
     *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
     *
     * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
     *    The output will be padded with zeros to match the length of the pattern.
     *
     *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
     *
     * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
     *    These tokens represent the shortest form of the quarter.
     *
     * 5. The main difference between `y` and `u` patterns are B.C. years:
     *
     *    | Year | `y` | `u` |
     *    |------|-----|-----|
     *    | AC 1 |   1 |   1 |
     *    | BC 1 |   1 |   0 |
     *    | BC 2 |   2 |  -1 |
     *
     *    Also `yy` always returns the last two digits of a year,
     *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
     *
     *    | Year | `yy` | `uu` |
     *    |------|------|------|
     *    | 1    |   01 |   01 |
     *    | 14   |   14 |   14 |
     *    | 376  |   76 |  376 |
     *    | 1453 |   53 | 1453 |
     *
     *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
     *    except local week-numbering years are dependent on `options.weekStartsOn`
     *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
     *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
     *
     * 6. Specific non-location timezones are currently unavailable in `date-fns`,
     *    so right now these tokens fall back to GMT timezones.
     *
     * 7. These patterns are not in the Unicode Technical Standard #35:
     *    - `i`: ISO day of week
     *    - `I`: ISO week of year
     *    - `R`: ISO week-numbering year
     *    - `t`: seconds timestamp
     *    - `T`: milliseconds timestamp
     *    - `o`: ordinal number modifier
     *    - `P`: long localized date
     *    - `p`: long localized time
     *
     * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
     *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     *
     * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
     *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     *
     * @param {Date|Number} date - the original date
     * @param {String} format - the string of tokens
     * @param {Object} [options] - an object with options.
     * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
     * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
     * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
     * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
     *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
     *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @returns {String} the formatted date string
     * @throws {TypeError} 2 arguments required
     * @throws {RangeError} `date` must not be Invalid Date
     * @throws {RangeError} `options.locale` must contain `localize` property
     * @throws {RangeError} `options.locale` must contain `formatLong` property
     * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
     * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
     * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
     * @throws {RangeError} format string contains an unescaped latin alphabet character
     *
     * @example
     * // Represent 11 February 2014 in middle-endian format:
     * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
     * //=> '02/11/2014'
     *
     * @example
     * // Represent 2 July 2014 in Esperanto:
     * import { eoLocale } from 'date-fns/locale/eo'
     * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
     *   locale: eoLocale
     * })
     * //=> '2-a de julio 2014'
     *
     * @example
     * // Escape string by single quote characters:
     * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
     * //=> "3 o'clock"
     */

    function format(dirtyDate, dirtyFormatStr, options) {
      var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
      requiredArgs(2, arguments);
      var formatStr = String(dirtyFormatStr);
      var defaultOptions = getDefaultOptions();
      var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
      var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

      // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
      }
      var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

      // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
      }
      if (!locale.localize) {
        throw new RangeError('locale must contain localize property');
      }
      if (!locale.formatLong) {
        throw new RangeError('locale must contain formatLong property');
      }
      var originalDate = toDate(dirtyDate);
      if (!isValid(originalDate)) {
        throw new RangeError('Invalid time value');
      }

      // Convert the date in system timezone to the same date in UTC+00:00 timezone.
      // This ensures that when UTC functions will be implemented, locales will be compatible with them.
      // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
      var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
      var utcDate = subMilliseconds(originalDate, timezoneOffset);
      var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
      };
      var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
          var longFormatter = format_longFormatters[firstCharacter];
          return longFormatter(substring, locale.formatLong);
        }
        return substring;
      }).join('').match(formattingTokensRegExp).map(function (substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") {
          return "'";
        }
        var firstCharacter = substring[0];
        if (firstCharacter === "'") {
          return cleanEscapedString(substring);
        }
        var formatter = format_formatters[firstCharacter];
        if (formatter) {
          if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
            throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
          }
          if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
            throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
          }
          return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }
        return substring;
      }).join('');
      return result;
    }
    function cleanEscapedString(input) {
      var matched = input.match(escapedStringRegExp);
      if (!matched) {
        return input;
      }
      return matched[1].replace(doubleQuoteRegExp, "'");
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatDistance/index.js
    var formatDistance_formatDistanceLocale = {
      lessThanXSeconds: {
        one: '不到 1 秒',
        other: '不到 {{count}} 秒'
      },
      xSeconds: {
        one: '1 秒',
        other: '{{count}} 秒'
      },
      halfAMinute: '半分钟',
      lessThanXMinutes: {
        one: '不到 1 分钟',
        other: '不到 {{count}} 分钟'
      },
      xMinutes: {
        one: '1 分钟',
        other: '{{count}} 分钟'
      },
      xHours: {
        one: '1 小时',
        other: '{{count}} 小时'
      },
      aboutXHours: {
        one: '大约 1 小时',
        other: '大约 {{count}} 小时'
      },
      xDays: {
        one: '1 天',
        other: '{{count}} 天'
      },
      aboutXWeeks: {
        one: '大约 1 个星期',
        other: '大约 {{count}} 个星期'
      },
      xWeeks: {
        one: '1 个星期',
        other: '{{count}} 个星期'
      },
      aboutXMonths: {
        one: '大约 1 个月',
        other: '大约 {{count}} 个月'
      },
      xMonths: {
        one: '1 个月',
        other: '{{count}} 个月'
      },
      aboutXYears: {
        one: '大约 1 年',
        other: '大约 {{count}} 年'
      },
      xYears: {
        one: '1 年',
        other: '{{count}} 年'
      },
      overXYears: {
        one: '超过 1 年',
        other: '超过 {{count}} 年'
      },
      almostXYears: {
        one: '将近 1 年',
        other: '将近 {{count}} 年'
      }
    };
    var formatDistance_formatDistance = function formatDistance(token, count, options) {
      var result;
      var tokenValue = formatDistance_formatDistanceLocale[token];
      if (typeof tokenValue === 'string') {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace('{{count}}', String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + '内';
        } else {
          return result + '前';
        }
      }
      return result;
    };
    /* harmony default export */
    var zh_CN_lib_formatDistance = formatDistance_formatDistance;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatLong/index.js

    var formatLong_dateFormats = {
      full: "y'年'M'月'd'日' EEEE",
      long: "y'年'M'月'd'日'",
      medium: 'yyyy-MM-dd',
      short: 'yy-MM-dd'
    };
    var formatLong_timeFormats = {
      full: 'zzzz a h:mm:ss',
      long: 'z a h:mm:ss',
      medium: 'a h:mm:ss',
      short: 'a h:mm'
    };
    var formatLong_dateTimeFormats = {
      full: '{{date}} {{time}}',
      long: '{{date}} {{time}}',
      medium: '{{date}} {{time}}',
      short: '{{date}} {{time}}'
    };
    var formatLong_formatLong = {
      date: buildFormatLongFn({
        formats: formatLong_dateFormats,
        defaultWidth: 'full'
      }),
      time: buildFormatLongFn({
        formats: formatLong_timeFormats,
        defaultWidth: 'full'
      }),
      dateTime: buildFormatLongFn({
        formats: formatLong_dateTimeFormats,
        defaultWidth: 'full'
      })
    };
    /* harmony default export */
    var zh_CN_lib_formatLong = formatLong_formatLong;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js

    function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
      requiredArgs(2, arguments);
      var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
      var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
      return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
    }
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/formatRelative/index.js

    function checkWeek(date, baseDate, options) {
      var baseFormat = 'eeee p';
      if (isSameUTCWeek(date, baseDate, options)) {
        return baseFormat; // in same week
      } else if (date.getTime() > baseDate.getTime()) {
        return "'下个'" + baseFormat; // in next week
      }

      return "'上个'" + baseFormat; // in last week
    }

    var formatRelative_formatRelativeLocale = {
      lastWeek: checkWeek,
      // days before yesterday, maybe in this week or last week
      yesterday: "'昨天' p",
      today: "'今天' p",
      tomorrow: "'明天' p",
      nextWeek: checkWeek,
      // days after tomorrow, maybe in this week or next week
      other: 'PP p'
    };
    var formatRelative_formatRelative = function formatRelative(token, date, baseDate, options) {
      var format = formatRelative_formatRelativeLocale[token];
      if (typeof format === 'function') {
        return format(date, baseDate, options);
      }
      return format;
    };
    /* harmony default export */
    var zh_CN_lib_formatRelative = formatRelative_formatRelative;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/localize/index.js

    var localize_eraValues = {
      narrow: ['前', '公元'],
      abbreviated: ['前', '公元'],
      wide: ['公元前', '公元']
    };
    var localize_quarterValues = {
      narrow: ['1', '2', '3', '4'],
      abbreviated: ['第一季', '第二季', '第三季', '第四季'],
      wide: ['第一季度', '第二季度', '第三季度', '第四季度']
    };
    var localize_monthValues = {
      narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
      abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
    };
    var localize_dayValues = {
      narrow: ['日', '一', '二', '三', '四', '五', '六'],
      short: ['日', '一', '二', '三', '四', '五', '六'],
      abbreviated: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    };
    var localize_dayPeriodValues = {
      narrow: {
        am: '上',
        pm: '下',
        midnight: '凌晨',
        noon: '午',
        morning: '早',
        afternoon: '下午',
        evening: '晚',
        night: '夜'
      },
      abbreviated: {
        am: '上午',
        pm: '下午',
        midnight: '凌晨',
        noon: '中午',
        morning: '早晨',
        afternoon: '中午',
        evening: '晚上',
        night: '夜间'
      },
      wide: {
        am: '上午',
        pm: '下午',
        midnight: '凌晨',
        noon: '中午',
        morning: '早晨',
        afternoon: '中午',
        evening: '晚上',
        night: '夜间'
      }
    };
    var localize_formattingDayPeriodValues = {
      narrow: {
        am: '上',
        pm: '下',
        midnight: '凌晨',
        noon: '午',
        morning: '早',
        afternoon: '下午',
        evening: '晚',
        night: '夜'
      },
      abbreviated: {
        am: '上午',
        pm: '下午',
        midnight: '凌晨',
        noon: '中午',
        morning: '早晨',
        afternoon: '中午',
        evening: '晚上',
        night: '夜间'
      },
      wide: {
        am: '上午',
        pm: '下午',
        midnight: '凌晨',
        noon: '中午',
        morning: '早晨',
        afternoon: '中午',
        evening: '晚上',
        night: '夜间'
      }
    };
    var localize_ordinalNumber = function ordinalNumber(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      switch (options === null || options === void 0 ? void 0 : options.unit) {
        case 'date':
          return number.toString() + '日';
        case 'hour':
          return number.toString() + '时';
        case 'minute':
          return number.toString() + '分';
        case 'second':
          return number.toString() + '秒';
        default:
          return '第 ' + number.toString();
      }
    };
    var _lib_localize_localize = {
      ordinalNumber: localize_ordinalNumber,
      era: buildLocalizeFn({
        values: localize_eraValues,
        defaultWidth: 'wide'
      }),
      quarter: buildLocalizeFn({
        values: localize_quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: localize_monthValues,
        defaultWidth: 'wide'
      }),
      day: buildLocalizeFn({
        values: localize_dayValues,
        defaultWidth: 'wide'
      }),
      dayPeriod: buildLocalizeFn({
        values: localize_dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: localize_formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
      })
    };
    /* harmony default export */
    var zh_CN_lib_localize = _lib_localize_localize;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/_lib/match/index.js

    var match_matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
    var match_parseOrdinalNumberPattern = /\d+/i;
    var match_matchEraPatterns = {
      narrow: /^(前)/i,
      abbreviated: /^(前)/i,
      wide: /^(公元前|公元)/i
    };
    var match_parseEraPatterns = {
      any: [/^(前)/i, /^(公元)/i]
    };
    var match_matchQuarterPatterns = {
      narrow: /^[1234]/i,
      abbreviated: /^第[一二三四]刻/i,
      wide: /^第[一二三四]刻钟/i
    };
    var match_parseQuarterPatterns = {
      any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
    };
    var match_matchMonthPatterns = {
      narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
      abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
      wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
    };
    var match_parseMonthPatterns = {
      narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
      any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
    };
    var match_matchDayPatterns = {
      narrow: /^[一二三四五六日]/i,
      short: /^[一二三四五六日]/i,
      abbreviated: /^周[一二三四五六日]/i,
      wide: /^星期[一二三四五六日]/i
    };
    var match_parseDayPatterns = {
      any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
    };
    var match_matchDayPeriodPatterns = {
      any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
    };
    var match_parseDayPeriodPatterns = {
      any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
      }
    };
    var match_match = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: match_matchOrdinalNumberPattern,
        parsePattern: match_parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: match_matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: match_parseEraPatterns,
        defaultParseWidth: 'any'
      }),
      quarter: buildMatchFn({
        matchPatterns: match_matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: match_parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: match_matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: match_parseMonthPatterns,
        defaultParseWidth: 'any'
      }),
      day: buildMatchFn({
        matchPatterns: match_matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: match_parseDayPatterns,
        defaultParseWidth: 'any'
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: match_matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: match_parseDayPeriodPatterns,
        defaultParseWidth: 'any'
      })
    };
    /* harmony default export */
    var zh_CN_lib_match = match_match;
    // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/zh-CN/index.js

    /**
     * @type {Locale}
     * @category Locales
     * @summary Chinese Simplified locale.
     * @language Chinese Simplified
     * @iso-639-2 zho
     * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
     * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
     * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
     * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
     * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
     */
    var zh_CN_locale = {
      code: 'zh-CN',
      formatDistance: zh_CN_lib_formatDistance,
      formatLong: zh_CN_lib_formatLong,
      formatRelative: zh_CN_lib_formatRelative,
      localize: zh_CN_lib_localize,
      match: zh_CN_lib_match,
      options: {
        weekStartsOn: 1 /* Monday */,
        firstWeekContainsDate: 4
      }
    };
    /* harmony default export */
    var zh_CN = zh_CN_locale;
    // CONCATENATED MODULE: ./src/assets/scripts/constants.js
    var breakpoints = {
      phablet: 576,
      tablet: 768,
      tablethd: 1024,
      desktop: 1200,
      desktophd: 1440
    };

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDatePicker/MsDatePicker.vue?vue&type=script&lang=js&
    function MsDatePickervue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsDatePickervue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsDatePickervue_type_script_lang_js_typeof(obj);
    }
    function MsDatePickervue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsDatePickervue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsDatePickervue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsDatePickervue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsDatePickervue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsDatePickervue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsDatePickervue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsDatePickervue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsDatePickervue_type_script_lang_js_toPrimitive(arg, "string");
      return MsDatePickervue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsDatePickervue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsDatePickervue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsDatePickervue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }

    /* harmony default export */
    var MsDatePickervue_type_script_lang_js_ = {
      name: 'MsDatePicker',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/DatePicker'
      },
      components: {
        DatePicker: function DatePicker() {
          return __webpack_require__.e( /* import() */2).then(__webpack_require__.t.bind(null, "404b", 7));
        }
      },
      props: {
        /**
         * Unique id for each datepicker input
        */
        id: {
          type: String,
          default: '',
          required: true
        },
        /**
         * Binds the input model in the parent component.
        */
        value: {
          type: [Date, Object]
        },
        /**
         * Sets the mode to use for the datepicker
        */
        mode: {
          type: String,
          default: 'range'
        },
        /**
         * Placeholder for the input
        */
        placeholder: {
          type: String,
          default: ''
        },
        /**
         * Sets the date format. We will need to use and follow https://date-fns.org/ for the date format.
        */
        format: {
          type: String,
          default: 'dd MMM yyyy'
        },
        /**
         * Sets the minimum date.
        */
        min: {
          type: [String, Date],
          default: null
        },
        /**
         * Sets the maximum date.
        */
        max: {
          type: [String, Date],
          default: null
        },
        /**
         * Enables weekdays only. This is only applicable for single mode.
        */
        weekdays: {
          type: Boolean,
          default: false
        },
        /**
         * Sets the input to readonly.
        */
        readOnly: {
          type: Boolean,
          default: false
        },
        /**
         * This range value will be used to calculate the total number of days from the selected date for auto mode datepickers. This is only applicable for auto mode.
        */
        range: {
          type: Number,
          default: null
        },
        /**
         * Sets the local of the calendar and the selected values
        */
        locale: {
          type: [String, Object],
          default: 'en'
        }
      },
      data: function data() {
        return {
          columns: this.mode === 'single' ? 1 : 2,
          inputDebounce: 250,
          timeout: false,
          focused: false,
          attributes: [{
            key: 'today',
            highlight: 'green',
            dates: new Date()
          }],
          dateFnsLocales: {
            en: en_US,
            'zh-hk': zh_CN
          }
        };
      },
      computed: {
        selectedDate: {
          get: function get() {
            if (this.auto) {
              this.updateRangeSpan(this.value.start);
            }
            return this.value;
          },
          set: function set(val) {
            if (!val) return;
            if (this.auto) {
              var startDate = new Date(val.start || val);

              /**
               * Emits the updated value on input event
              */
              this.$emit('input', {
                start: startDate,
                end: addDays(startDate, this.range)
              });
            } else {
              this.$emit('input', val);
            }
          }
        },
        auto: function auto() {
          return this.mode === 'auto';
        },
        pickerProperties: function pickerProperties() {
          var mode = this.auto ? 'single' : this.mode;
          return MsDatePickervue_type_script_lang_js_objectSpread(MsDatePickervue_type_script_lang_js_objectSpread({}, this.minMax), {
            mode: mode,
            columns: this.columns,
            disabledDates: this.disabledDates,
            attributes: this.attributes,
            inputProps: {
              id: "picker-input-".concat(this.id),
              readonly: this.readOnly
            },
            popover: {
              visibility: 'focus'
            },
            inputDebounce: this.inputDebounce,
            masks: {
              input: this.format.toUpperCase()
            }
          });
        },
        disabledDates: function disabledDates() {
          if (this.mode === 'single' && this.weekdays) {
            return {
              weekdays: [1, 7]
            };
          }
          return null;
        },
        minMax: function minMax() {
          var minMax = {};
          if (this.min) {
            minMax = MsDatePickervue_type_script_lang_js_objectSpread(MsDatePickervue_type_script_lang_js_objectSpread({}, minMax), {
              'min-date': new Date(this.min)
            });
          }
          if (this.max) {
            minMax = MsDatePickervue_type_script_lang_js_objectSpread(MsDatePickervue_type_script_lang_js_objectSpread({}, minMax), {
              'max-date': new Date(this.max)
            });
          }
          return minMax;
        },
        filled: function filled() {
          if (this.selectedDate && this.selectedDate.start === null) {
            return false;
          }
          return this.selectedDate;
        },
        inputProperties: function inputProperties() {
          var inputProps = {
            id: "picker-input-".concat(this.id),
            readonly: this.readOnly,
            type: "input"
          };
          if (this.mode === 'auto' || this.mode === 'range') {
            var _this$value = this.value,
              start = _this$value.start,
              end = _this$value.end;
            return MsDatePickervue_type_script_lang_js_objectSpread(MsDatePickervue_type_script_lang_js_objectSpread({}, inputProps), {
              value: start !== null ? "".concat(this.formatDate(start), " - ").concat(this.formatDate(end)) : ''
            });
          }
          return MsDatePickervue_type_script_lang_js_objectSpread(MsDatePickervue_type_script_lang_js_objectSpread({}, inputProps), {}, {
            value: this.value ? this.formatDate(this.value) : this.value
          });
        }
      },
      mounted: function mounted() {
        window.addEventListener('load', this.onResize);
        window.addEventListener('resize', this.onResize);
      },
      beforeDestroy: function beforeDestroy() {
        window.removeEventListener('load', this.onResize);
        window.removeEventListener('resize', this.onResize);
      },
      methods: {
        focus: function focus() {
          this.focused = true;
        },
        blur: function blur(e) {
          var _this = this;
          setTimeout(function () {
            if (e.target.value === '') {
              _this.focused = false;
            }
          }, this.inputDebounce);
        },
        events: function events(inputEvents) {
          return MsDatePickervue_type_script_lang_js_objectSpread(MsDatePickervue_type_script_lang_js_objectSpread({}, inputEvents), {
            blur: this.blur,
            focus: this.focus
          });
        },
        updateRangeSpan: function updateRangeSpan(startDate) {
          this.attributes[0] = MsDatePickervue_type_script_lang_js_objectSpread(MsDatePickervue_type_script_lang_js_objectSpread({}, this.attributes[0]), {
            key: 'today',
            highlight: 'blue',
            dates: {
              start: new Date(startDate),
              span: this.range + 1
            }
          });
        },
        formatDate: function formatDate(date) {
          return format(date, this.format, {
            locale: this.dateFnsLocales[this.locale]
          });
        },
        onResize: function onResize() {
          var _this2 = this;
          if (this.timeout) {
            window.cancelAnimationFrame(this.timeout);
          }
          this.timeout = window.requestAnimationFrame(function () {
            if (_this2.mode !== 'single') {
              _this2.columns = document.body.clientWidth < breakpoints.tablet ? 1 : 2;
            }
          });
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsDatePicker/MsDatePicker.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDatePicker_MsDatePickervue_type_script_lang_js_ = MsDatePickervue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsDatePicker/MsDatePicker.vue?vue&type=style&index=0&id=55cd26a5&prod&lang=scss&
    var MsDatePickervue_type_style_index_0_id_55cd26a5_prod_lang_scss_ = __webpack_require__("707d");

    // CONCATENATED MODULE: ./src/components/MsDatePicker/MsDatePicker.vue

    /* normalize component */

    var MsDatePicker_component = normalizeComponent(MsDatePicker_MsDatePickervue_type_script_lang_js_, MsDatePickervue_type_template_id_55cd26a5_render, MsDatePickervue_type_template_id_55cd26a5_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsDatePicker = MsDatePicker_component.exports;
    // CONCATENATED MODULE: ./src/components/MsDatePicker/index.js

    MsDatePicker.install = function (Vue) {
      return Vue.component(MsDatePicker.name, MsDatePicker);
    };
    /* harmony default export */
    var components_MsDatePicker = MsDatePicker;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimeline.vue?vue&type=template&id=c48ee2ac&
    var MsDisplayTimelinevue_type_template_id_c48ee2ac_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', [_c('ol', {
        staticClass: "display-timeline",
        class: {
          'display-timeline--center': _vm.position === 'center',
          'display-timeline--left': _vm.position === 'left'
        }
      }, [_vm._t("default")], 2), _c('div', {
        staticClass: "display-timeline__line"
      })]);
    };
    var MsDisplayTimelinevue_type_template_id_c48ee2ac_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimeline.vue?vue&type=template&id=c48ee2ac&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimeline.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimelinevue_type_script_lang_js_ = {
      name: 'MsDisplayTimeline',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Display Timeline'
      },
      props: {
        /**
         * Sets position of the children
         * @values null, left, center
         */
        position: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimeline.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimeline_MsDisplayTimelinevue_type_script_lang_js_ = MsDisplayTimelinevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimeline.vue

    /* normalize component */

    var MsDisplayTimeline_component = normalizeComponent(MsDisplayTimeline_MsDisplayTimelinevue_type_script_lang_js_, MsDisplayTimelinevue_type_template_id_c48ee2ac_render, MsDisplayTimelinevue_type_template_id_c48ee2ac_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsDisplayTimeline = MsDisplayTimeline_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimelineItem.vue?vue&type=template&id=85ee5cc4&
    var MsDisplayTimelineItemvue_type_template_id_85ee5cc4_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        staticClass: "display-timeline__item"
      }, [_c('div', {
        staticClass: "display-timeline__item-content"
      }, [_vm._t("default")], 2)]);
    };
    var MsDisplayTimelineItemvue_type_template_id_85ee5cc4_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineItem.vue?vue&type=template&id=85ee5cc4&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimelineItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimelineItemvue_type_script_lang_js_ = {
      name: 'MsDisplayTimelineItem'
    };
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimeline_MsDisplayTimelineItemvue_type_script_lang_js_ = MsDisplayTimelineItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineItem.vue

    /* normalize component */

    var MsDisplayTimelineItem_component = normalizeComponent(MsDisplayTimeline_MsDisplayTimelineItemvue_type_script_lang_js_, MsDisplayTimelineItemvue_type_template_id_85ee5cc4_render, MsDisplayTimelineItemvue_type_template_id_85ee5cc4_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsDisplayTimelineItem = MsDisplayTimelineItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimelineIcon.vue?vue&type=template&id=f908a0ca&
    var MsDisplayTimelineIconvue_type_template_id_f908a0ca_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "display-timeline__icon"
      }, [_vm._t("default")], 2);
    };
    var MsDisplayTimelineIconvue_type_template_id_f908a0ca_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineIcon.vue?vue&type=template&id=f908a0ca&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimelineIcon.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimelineIconvue_type_script_lang_js_ = {
      name: 'MsDisplayTimelineIcon'
    };
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineIcon.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimeline_MsDisplayTimelineIconvue_type_script_lang_js_ = MsDisplayTimelineIconvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineIcon.vue

    /* normalize component */

    var MsDisplayTimelineIcon_component = normalizeComponent(MsDisplayTimeline_MsDisplayTimelineIconvue_type_script_lang_js_, MsDisplayTimelineIconvue_type_template_id_f908a0ca_render, MsDisplayTimelineIconvue_type_template_id_f908a0ca_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsDisplayTimelineIcon = MsDisplayTimelineIcon_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimelineText.vue?vue&type=template&id=5e54fb4e&
    var MsDisplayTimelineTextvue_type_template_id_5e54fb4e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "display-timeline__text-wrapper"
      }, [_c('p', {
        staticClass: "display-timeline__item-description"
      }, [_vm._t("default")], 2)]);
    };
    var MsDisplayTimelineTextvue_type_template_id_5e54fb4e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineText.vue?vue&type=template&id=5e54fb4e&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsDisplayTimeline/MsDisplayTimelineText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimelineTextvue_type_script_lang_js_ = {
      name: 'MsDisplayTimelineText'
    };
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsDisplayTimeline_MsDisplayTimelineTextvue_type_script_lang_js_ = MsDisplayTimelineTextvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/MsDisplayTimelineText.vue

    /* normalize component */

    var MsDisplayTimelineText_component = normalizeComponent(MsDisplayTimeline_MsDisplayTimelineTextvue_type_script_lang_js_, MsDisplayTimelineTextvue_type_template_id_5e54fb4e_render, MsDisplayTimelineTextvue_type_template_id_5e54fb4e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsDisplayTimelineText = MsDisplayTimelineText_component.exports;
    // CONCATENATED MODULE: ./src/components/MsDisplayTimeline/index.js

    var MsDisplayTimeline_components = {
      MsDisplayTimeline: MsDisplayTimeline,
      MsDisplayTimelineItem: MsDisplayTimelineItem,
      MsDisplayTimelineIcon: MsDisplayTimelineIcon,
      MsDisplayTimelineText: MsDisplayTimelineText
    };
    MsDisplayTimeline.install = function (Vue) {
      Object.values(MsDisplayTimeline_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsDisplayTimeline = MsDisplayTimeline;
    // CONCATENATED MODULE: ./src/components/MsDropdown/index.js

    var MsDropdown_components = {
      MsDropdown: MsDropdown
    };
    MsDropdown.install = function (Vue) {
      Object.values(MsDropdown_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsDropdown = MsDropdown;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsError/MsError.vue?vue&type=template&id=22dcd46e&
    var MsErrorvue_type_template_id_22dcd46e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "error"
      }, [_c('h1', {
        staticClass: "error__header"
      }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
        staticClass: "error__sub-header",
        domProps: {
          "innerHTML": _vm._s(_vm.subHeader)
        }
      }), _c('ms-image', {
        staticClass: "error__image",
        attrs: {
          "src": _vm.imageUrl,
          "alt": _vm.imageAlt
        }
      }), _c('div', {
        staticClass: "error__links"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.linksTitle)
        }
      }), _c('ul', [_c('li', [_c('ms-link', {
        attrs: {
          "href": _vm.shopLink.url
        }
      }, [_c('ms-image', {
        attrs: {
          "src": _vm.shopLink.imageUrl ? _vm.shopLink.imageUrl : _vm.errorLinkImage.shop,
          "alt": _vm.shopLink.imageAlt
        }
      }), _vm._v("\n          " + _vm._s(_vm.shopLink.label) + "\n        ")], 1)], 1), _c('li', [_c('ms-link', {
        attrs: {
          "href": _vm.blogLink.url
        }
      }, [_c('ms-image', {
        attrs: {
          "src": _vm.blogLink.imageUrl ? _vm.blogLink.imageUrl : _vm.errorLinkImage.blog,
          "alt": _vm.blogLink.imageAlt
        }
      }), _vm._v("\n          " + _vm._s(_vm.blogLink.label) + "\n        ")], 1)], 1), _c('li', [_c('ms-link', {
        attrs: {
          "href": _vm.contactUsLink.url
        }
      }, [_c('ms-image', {
        attrs: {
          "src": _vm.contactUsLink.imageUrl ? _vm.contactUsLink.imageUrl : _vm.errorLinkImage.contactUs,
          "alt": _vm.contactUsLink.imageAlt
        }
      }), _vm._v("\n          " + _vm._s(_vm.contactUsLink.label) + "\n        ")], 1)], 1)])])], 1);
    };
    var MsErrorvue_type_template_id_22dcd46e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsError/MsError.vue?vue&type=template&id=22dcd46e&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsError/MsError.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsErrorvue_type_script_lang_js_ = {
      name: 'MsError',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Error'
      },
      props: {
        /**
         * Text for error title
         */
        title: {
          type: String,
          default: 'We are sorry. But the page you are looking for cannot be found.'
        },
        /**
         * Sets the HTML text for error sub header
         */
        subHeader: {
          type: String,
          default: '<p>Please check your website URL, or return to the <a href="https://www.moneysmart.sg/">MoneySmart Homepage</a> instead.</p>'
        },
        /**
         * Sets the display image for the error component
         */
        imageUrl: {
          type: String,
          default: 'https://assets.cdn-moneysmart.com/assets/cargo/images/error-page/jcbrd2joxwfbiuluxjrz.png'
        },
        /**
         * Sets the alt text for the image display
         */
        imageAlt: {
          type: String,
          default: 'Error 404'
        },
        /**
         * Sets the HTML text for error link title
         */
        linksTitle: {
          type: String,
          default: 'Alternatively, try one of these links to get back on track.'
        },
        /**
         * Set properties for shop link
         */
        shopLink: {
          type: Object,
          default: function _default() {
            return {
              label: 'shop',
              imageAlt: 'shop',
              url: 'https://www.moneysmart.sg/'
            };
          }
        },
        /**
         * Set properties for blog link
         */
        blogLink: {
          type: Object,
          default: function _default() {
            return {
              label: 'blog',
              imageAlt: 'blog',
              url: 'https://blog.moneysmart.sg/'
            };
          }
        },
        /**
         * Set properties for contact us link
         */
        contactUsLink: {
          type: Object,
          default: function _default() {
            return {
              label: 'contact us',
              imageAlt: 'contact us',
              url: 'https://www.moneysmart.sg/contact-us'
            };
          }
        }
      },
      data: function data() {
        return {
          errorLinkImage: {
            shop: 'https://assets.cdn-moneysmart.com/assets/cargo/images/error-page/oirjh0a5qjoepincavue.png',
            blog: 'https://assets.cdn-moneysmart.com/assets/cargo/images/error-page/txttj9apasglvyk4rhvb.png',
            contactUs: 'https://assets.cdn-moneysmart.com/assets/cargo/images/error-page/m3rckxxyy6rsyp5brmet.png'
          }
        };
      }
    };
    // CONCATENATED MODULE: ./src/components/MsError/MsError.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsError_MsErrorvue_type_script_lang_js_ = MsErrorvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsError/MsError.vue

    /* normalize component */

    var MsError_component = normalizeComponent(MsError_MsErrorvue_type_script_lang_js_, MsErrorvue_type_template_id_22dcd46e_render, MsErrorvue_type_template_id_22dcd46e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsError = MsError_component.exports;
    // CONCATENATED MODULE: ./src/components/MsError/index.js

    MsError.install = function (Vue) {
      return Vue.component(MsError.name, MsError);
    };
    /* harmony default export */
    var components_MsError = MsError;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExpandableWrapper/MsExpandableWrapper.vue?vue&type=template&id=239e58ef&
    var MsExpandableWrappervue_type_template_id_239e58ef_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "expandable-wrapper",
        class: {
          'is-expanded': !_vm.arrowDown
        }
      }, [_vm._t("default"), _c('div', {
        staticClass: "expandable-wrapper__content"
      }, [_vm._t("expandableContent")], 2), _c('div', {
        staticClass: "expandable-wrapper__button",
        on: {
          "click": _vm.toggleArrow
        }
      }, [_c('ms-icon', {
        staticClass: "expandable-wrapper__icon",
        attrs: {
          "icon": ['far', 'chevron-down']
        }
      })], 1)], 2);
    };
    var MsExpandableWrappervue_type_template_id_239e58ef_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExpandableWrapper/MsExpandableWrapper.vue?vue&type=template&id=239e58ef&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExpandableWrapper/MsExpandableWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExpandableWrappervue_type_script_lang_js_ = {
      name: 'MsExpandableWrapper',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Expandable Wrapper'
      },
      data: function data() {
        return {
          arrowDown: true
        };
      },
      methods: {
        toggleArrow: function toggleArrow() {
          this.arrowDown = !this.arrowDown;
          this.$emit(this.arrowDown ? 'on-closed' : 'on-expanded');
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsExpandableWrapper/MsExpandableWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExpandableWrapper_MsExpandableWrappervue_type_script_lang_js_ = MsExpandableWrappervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExpandableWrapper/MsExpandableWrapper.vue

    /* normalize component */

    var MsExpandableWrapper_component = normalizeComponent(MsExpandableWrapper_MsExpandableWrappervue_type_script_lang_js_, MsExpandableWrappervue_type_template_id_239e58ef_render, MsExpandableWrappervue_type_template_id_239e58ef_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExpandableWrapper = MsExpandableWrapper_component.exports;
    // CONCATENATED MODULE: ./src/components/MsExpandableWrapper/index.js

    MsExpandableWrapper.install = function (Vue) {
      return Vue.component(MsExpandableWrapper.name, MsExpandableWrapper);
    };
    /* harmony default export */
    var components_MsExpandableWrapper = MsExpandableWrapper;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntro.vue?vue&type=template&id=5af4e8b8&
    function MsExtendedIntrovue_type_template_id_5af4e8b8_typeof(obj) {
      "@babel/helpers - typeof";

      return MsExtendedIntrovue_type_template_id_5af4e8b8_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsExtendedIntrovue_type_template_id_5af4e8b8_typeof(obj);
    }
    function MsExtendedIntrovue_type_template_id_5af4e8b8_defineProperty(obj, key, value) {
      key = MsExtendedIntrovue_type_template_id_5af4e8b8_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsExtendedIntrovue_type_template_id_5af4e8b8_toPropertyKey(arg) {
      var key = MsExtendedIntrovue_type_template_id_5af4e8b8_toPrimitive(arg, "string");
      return MsExtendedIntrovue_type_template_id_5af4e8b8_typeof(key) === "symbol" ? key : String(key);
    }
    function MsExtendedIntrovue_type_template_id_5af4e8b8_toPrimitive(input, hint) {
      if (MsExtendedIntrovue_type_template_id_5af4e8b8_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsExtendedIntrovue_type_template_id_5af4e8b8_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsExtendedIntrovue_type_template_id_5af4e8b8_render = function render() {
      var _class;
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "extended-intro",
        class: (_class = {}, MsExtendedIntrovue_type_template_id_5af4e8b8_defineProperty(_class, "extended-intro--".concat(_vm.position), Boolean(_vm.position)), MsExtendedIntrovue_type_template_id_5af4e8b8_defineProperty(_class, "extended-intro--".concat(_vm.theme), Boolean(_vm.theme)), MsExtendedIntrovue_type_template_id_5af4e8b8_defineProperty(_class, 'extended-intro--negative', _vm.negativeMargin), _class)
      }, [_vm._t("default")], 2);
    };
    var MsExtendedIntrovue_type_template_id_5af4e8b8_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntro.vue?vue&type=template&id=5af4e8b8&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntro.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntrovue_type_script_lang_js_ = {
      name: 'MsExtendedIntro',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Extended Intro'
      },
      props: {
        theme: {
          type: String,
          default: null
        },
        position: {
          type: String,
          default: null
        },
        negativeMargin: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntro.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntro_MsExtendedIntrovue_type_script_lang_js_ = MsExtendedIntrovue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntro.vue

    /* normalize component */

    var MsExtendedIntro_component = normalizeComponent(MsExtendedIntro_MsExtendedIntrovue_type_script_lang_js_, MsExtendedIntrovue_type_template_id_5af4e8b8_render, MsExtendedIntrovue_type_template_id_5af4e8b8_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExtendedIntro = MsExtendedIntro_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroBody.vue?vue&type=template&id=6baeeb76&
    var MsExtendedIntroBodyvue_type_template_id_6baeeb76_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "extended-intro__body"
      }, [_vm._t("default")], 2);
    };
    var MsExtendedIntroBodyvue_type_template_id_6baeeb76_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroBody.vue?vue&type=template&id=6baeeb76&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroBody.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntroBodyvue_type_script_lang_js_ = {
      name: 'MsExtendedIntroBody'
    };
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroBody.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntro_MsExtendedIntroBodyvue_type_script_lang_js_ = MsExtendedIntroBodyvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroBody.vue

    /* normalize component */

    var MsExtendedIntroBody_component = normalizeComponent(MsExtendedIntro_MsExtendedIntroBodyvue_type_script_lang_js_, MsExtendedIntroBodyvue_type_template_id_6baeeb76_render, MsExtendedIntroBodyvue_type_template_id_6baeeb76_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExtendedIntroBody = MsExtendedIntroBody_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroCta.vue?vue&type=template&id=9417ed74&
    var MsExtendedIntroCtavue_type_template_id_9417ed74_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "extended-intro__cta"
      }, [_vm._t("default")], 2);
    };
    var MsExtendedIntroCtavue_type_template_id_9417ed74_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroCta.vue?vue&type=template&id=9417ed74&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntroCtavue_type_script_lang_js_ = {
      name: 'MsExtendedIntroCta'
    };
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntro_MsExtendedIntroCtavue_type_script_lang_js_ = MsExtendedIntroCtavue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroCta.vue

    /* normalize component */

    var MsExtendedIntroCta_component = normalizeComponent(MsExtendedIntro_MsExtendedIntroCtavue_type_script_lang_js_, MsExtendedIntroCtavue_type_template_id_9417ed74_render, MsExtendedIntroCtavue_type_template_id_9417ed74_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExtendedIntroCta = MsExtendedIntroCta_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroHeader.vue?vue&type=template&id=71b127ea&
    var MsExtendedIntroHeadervue_type_template_id_71b127ea_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "extended-intro__header"
      }, [_vm._t("default")], 2);
    };
    var MsExtendedIntroHeadervue_type_template_id_71b127ea_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroHeader.vue?vue&type=template&id=71b127ea&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntroHeadervue_type_script_lang_js_ = {
      name: 'MsExtendedIntroHeader'
    };
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntro_MsExtendedIntroHeadervue_type_script_lang_js_ = MsExtendedIntroHeadervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroHeader.vue

    /* normalize component */

    var MsExtendedIntroHeader_component = normalizeComponent(MsExtendedIntro_MsExtendedIntroHeadervue_type_script_lang_js_, MsExtendedIntroHeadervue_type_template_id_71b127ea_render, MsExtendedIntroHeadervue_type_template_id_71b127ea_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExtendedIntroHeader = MsExtendedIntroHeader_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroImage.vue?vue&type=template&id=19bdd2b0&
    var MsExtendedIntroImagevue_type_template_id_19bdd2b0_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "extended-intro__image",
        class: {
          'hide-on-mobile': _vm.hideOnMobile
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.url
        }
      })]);
    };
    var MsExtendedIntroImagevue_type_template_id_19bdd2b0_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroImage.vue?vue&type=template&id=19bdd2b0&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroImage.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntroImagevue_type_script_lang_js_ = {
      name: 'MsExtendedIntroImage',
      props: {
        url: {
          type: String,
          required: true,
          default: null
        },
        hideOnMobile: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroImage.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntro_MsExtendedIntroImagevue_type_script_lang_js_ = MsExtendedIntroImagevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroImage.vue

    /* normalize component */

    var MsExtendedIntroImage_component = normalizeComponent(MsExtendedIntro_MsExtendedIntroImagevue_type_script_lang_js_, MsExtendedIntroImagevue_type_template_id_19bdd2b0_render, MsExtendedIntroImagevue_type_template_id_19bdd2b0_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExtendedIntroImage = MsExtendedIntroImage_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroSubText.vue?vue&type=template&id=62ca3750&
    var MsExtendedIntroSubTextvue_type_template_id_62ca3750_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "extended-intro__sub-text"
      }, [_vm._t("default")], 2);
    };
    var MsExtendedIntroSubTextvue_type_template_id_62ca3750_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroSubText.vue?vue&type=template&id=62ca3750&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroSubText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntroSubTextvue_type_script_lang_js_ = {
      name: 'MsExtendedIntroSubText'
    };
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroSubText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntro_MsExtendedIntroSubTextvue_type_script_lang_js_ = MsExtendedIntroSubTextvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroSubText.vue

    /* normalize component */

    var MsExtendedIntroSubText_component = normalizeComponent(MsExtendedIntro_MsExtendedIntroSubTextvue_type_script_lang_js_, MsExtendedIntroSubTextvue_type_template_id_62ca3750_render, MsExtendedIntroSubTextvue_type_template_id_62ca3750_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExtendedIntroSubText = MsExtendedIntroSubText_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroTagLine.vue?vue&type=template&id=b1b5d6f2&
    var MsExtendedIntroTagLinevue_type_template_id_b1b5d6f2_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "extended-intro__tag-line"
      }, [_vm._t("default")], 2);
    };
    var MsExtendedIntroTagLinevue_type_template_id_b1b5d6f2_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroTagLine.vue?vue&type=template&id=b1b5d6f2&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsExtendedIntro/MsExtendedIntroTagLine.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntroTagLinevue_type_script_lang_js_ = {
      name: 'MsExtendedIntroTagLine'
    };
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroTagLine.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsExtendedIntro_MsExtendedIntroTagLinevue_type_script_lang_js_ = MsExtendedIntroTagLinevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/MsExtendedIntroTagLine.vue

    /* normalize component */

    var MsExtendedIntroTagLine_component = normalizeComponent(MsExtendedIntro_MsExtendedIntroTagLinevue_type_script_lang_js_, MsExtendedIntroTagLinevue_type_template_id_b1b5d6f2_render, MsExtendedIntroTagLinevue_type_template_id_b1b5d6f2_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsExtendedIntroTagLine = MsExtendedIntroTagLine_component.exports;
    // CONCATENATED MODULE: ./src/components/MsExtendedIntro/index.js

    var MsExtendedIntro_components = {
      MsExtendedIntro: MsExtendedIntro,
      MsExtendedIntroBody: MsExtendedIntroBody,
      MsExtendedIntroCta: MsExtendedIntroCta,
      MsExtendedIntroHeader: MsExtendedIntroHeader,
      MsExtendedIntroImage: MsExtendedIntroImage,
      MsExtendedIntroSubText: MsExtendedIntroSubText,
      MsExtendedIntroTagLine: MsExtendedIntroTagLine
    };
    MsExtendedIntro.install = function (Vue) {
      Object.values(MsExtendedIntro_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsExtendedIntro = MsExtendedIntro;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooter.vue?vue&type=template&id=afc23cac&
    var MsFootervue_type_template_id_afc23cac_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('footer', {
        staticClass: "footer"
      }, [_c('div', {
        staticClass: "footer__main"
      }, [_c('div', {
        staticClass: "container"
      }, [_vm._t("default")], 2)]), _c('div', {
        staticClass: "footer__copyright"
      }, [_c('div', {
        staticClass: "container"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "footer__col--12-10-12"
      }, [_c('div', {
        staticClass: "footer__copyright-text",
        domProps: {
          "innerHTML": _vm._s(_vm.copyrightText)
        }
      })])])])])]);
    };
    var MsFootervue_type_template_id_afc23cac_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooter.vue?vue&type=template&id=afc23cac&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooter.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFootervue_type_script_lang_js_ = {
      name: 'MsFooter',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Footer'
      },
      props: {
        /**
         * Copyright has a attribute called 'text' that renders as a string of HTML
         */
        copyright: {
          type: Object,
          required: true
        },
        /**
         * To display regulated/unregulated view
         */
        isRegulated: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        copyrightText: function copyrightText() {
          var currentYear = new Date().getFullYear();
          var copyrightText = this.isRegulated && 'ms_financial' in this.copyright ? this.copyright.ms_financial : this.copyright.text;
          return copyrightText.replace('<current_year>', currentYear);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooter.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooter_MsFootervue_type_script_lang_js_ = MsFootervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooter.vue

    /* normalize component */

    var MsFooter_component = normalizeComponent(MsFooter_MsFootervue_type_script_lang_js_, MsFootervue_type_template_id_afc23cac_render, MsFootervue_type_template_id_afc23cac_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFooter = MsFooter_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooterHeader.vue?vue&type=template&id=9fabff40&
    var MsFooterHeadervue_type_template_id_9fabff40_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "row footer__header"
      }, [_c('div', {
        staticClass: "footer__header__logo footer__col--6-10-12"
      }, [_c('ms-image', {
        attrs: {
          "alt": _vm.headerLogo.alt,
          "height": "20",
          "src": _vm.headerLogo.src,
          "width": "187"
        }
      })], 1), _c('div', {
        staticClass: "footer__col--6-10-12"
      }, [_c('ul', {
        staticClass: "footer__header__nav"
      }, _vm._l(_vm.header.navigation_items, function (item, index) {
        return _c('li', {
          key: index,
          staticClass: "footer__header__nav-item"
        }, [_c('ms-link', {
          staticClass: "footer__header__nav-link",
          attrs: {
            "href": item.link
          },
          on: {
            "click": function click($event) {
              return _vm.listeners['link-clicked'](item);
            }
          }
        }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])], 1);
      }), 0)])]);
    };
    var MsFooterHeadervue_type_template_id_9fabff40_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterHeader.vue?vue&type=template&id=9fabff40&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooterHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooterHeadervue_type_script_lang_js_ = {
      name: 'MsFooterHeader',
      props: {
        /**
         * Object contains data for the logo, and top level navigations items as an array
         */
        header: {
          type: Object,
          required: true
        },
        /**
         * To display regulated/unregulated view
         */
        isRegulated: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        headerLogo: function headerLogo() {
          return this.isRegulated && 'ms_financial_logo' in this.header ? this.header.ms_financial_logo : this.header.logo;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooter_MsFooterHeadervue_type_script_lang_js_ = MsFooterHeadervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterHeader.vue

    /* normalize component */

    var MsFooterHeader_component = normalizeComponent(MsFooter_MsFooterHeadervue_type_script_lang_js_, MsFooterHeadervue_type_template_id_9fabff40_render, MsFooterHeadervue_type_template_id_9fabff40_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFooterHeader = MsFooterHeader_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooterContent.vue?vue&type=template&id=ff6b54d4&
    var MsFooterContentvue_type_template_id_ff6b54d4_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "row footer__content"
      }, [_c('div', {
        staticClass: "footer__content__nav-container"
      }, [_c('ul', {
        staticClass: "footer__content__nav"
      }, _vm._l(_vm.content.nav_items.primary, function (item, index) {
        return _c('li', {
          key: index,
          staticClass: "footer__content__nav-item"
        }, [_c('ms-link', {
          staticClass: "footer__content__nav-link",
          attrs: {
            "href": item.url
          },
          on: {
            "click": function click($event) {
              return _vm.listeners['link-clicked'](item);
            }
          }
        }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])], 1);
      }), 0)]), _c('div', {
        staticClass: "footer__content__nav-container"
      }, [_c('div', {
        staticClass: "footer__content__nav"
      }, _vm._l(_vm.content.nav_items.secondary, function (item, index) {
        return _c('li', {
          key: index,
          staticClass: "footer__content__nav-item"
        }, [_c('ms-link', {
          staticClass: "footer__content__nav-link",
          attrs: {
            "href": item.url
          },
          on: {
            "click": function click($event) {
              return _vm.listeners['link-clicked'](item);
            }
          }
        }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])], 1);
      }), 0)]), _c('div', {
        staticClass: "footer__content__disclaimer footer__col--6-10-12"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.contentDisclaimerText)
        }
      })])]);
    };
    var MsFooterContentvue_type_template_id_ff6b54d4_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterContent.vue?vue&type=template&id=ff6b54d4&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooterContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooterContentvue_type_script_lang_js_ = {
      name: 'MsFooterContent',
      props: {
        /**
         * Content is an object nav_links and disclaimer text. Nav_links contains arrays of links for the first and second levels in the footer
         */
        content: {
          type: Object,
          required: true
        },
        /**
         * To display regulated/unregulated view
         */
        isRegulated: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        contentDisclaimerText: function contentDisclaimerText() {
          return this.isRegulated && 'ms_financial' in this.content.disclaimer ? this.content.disclaimer.ms_financial : this.content.disclaimer.text;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooter_MsFooterContentvue_type_script_lang_js_ = MsFooterContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterContent.vue

    /* normalize component */

    var MsFooterContent_component = normalizeComponent(MsFooter_MsFooterContentvue_type_script_lang_js_, MsFooterContentvue_type_template_id_ff6b54d4_render, MsFooterContentvue_type_template_id_ff6b54d4_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFooterContent = MsFooterContent_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooterMeta.vue?vue&type=template&id=4c40b808&
    var MsFooterMetavue_type_template_id_4c40b808_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "row footer__meta"
      }, [_c('div', {
        staticClass: "footer__social footer__col--6-10-12"
      }, [_c('span', {
        staticClass: "footer__social-title"
      }, [_vm._v(_vm._s(_vm.meta.social.label))]), _c('ul', {
        staticClass: "footer__social-icons"
      }, _vm._l(_vm.meta.social.social_body, function (item, index) {
        return _c('li', {
          key: index,
          staticClass: "footer__social-icon"
        }, [_c('ms-link', {
          staticClass: "footer__social-link",
          attrs: {
            "href": item.link,
            "aria-label": item.label,
            "target": item.target
          },
          on: {
            "click": function click($event) {
              return _vm.listeners['link-clicked'](item);
            }
          }
        }, [_c('fa', {
          attrs: {
            "icon": item.icon
          }
        })], 1)], 1);
      }), 0)]), _c('div', {
        staticClass: "footer__col--6-10-12"
      }, [_c('ul', {
        staticClass: "footer__countries"
      }, _vm._l(_vm.meta.countries, function (item, index) {
        return _c('li', {
          key: index,
          staticClass: "footer__country"
        }, [_c('ms-link', {
          staticClass: "footer__country-link",
          attrs: {
            "href": item.link,
            "target": item.target,
            "aria-label": item.image_alt
          },
          on: {
            "click": function click($event) {
              return _vm.listeners['link-clicked'](item);
            }
          }
        }, [_c('ms-image', {
          attrs: {
            "src": item.image_src,
            "alt": item.image_alt,
            "width": "36",
            "height": "24"
          }
        })], 1)], 1);
      }), 0)])]);
    };
    var MsFooterMetavue_type_template_id_4c40b808_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterMeta.vue?vue&type=template&id=4c40b808&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooter/MsFooterMeta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooterMetavue_type_script_lang_js_ = {
      name: 'MsFooterMeta',
      props: {
        /**
         * Meta contains information about social links, as well as the countries visible in the footer
         */
        meta: {
          type: Object,
          required: true
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterMeta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooter_MsFooterMetavue_type_script_lang_js_ = MsFooterMetavue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsFooter/MsFooterMeta.vue

    /* normalize component */

    var MsFooterMeta_component = normalizeComponent(MsFooter_MsFooterMetavue_type_script_lang_js_, MsFooterMetavue_type_template_id_4c40b808_render, MsFooterMetavue_type_template_id_4c40b808_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFooterMeta = MsFooterMeta_component.exports;
    // CONCATENATED MODULE: ./src/assets/scripts/helpers.js
    /* eslint-disable operator-assignment */
    var spaceToSnakeCase = function spaceToSnakeCase(string) {
      return string.replace(/ /g, "_").toLowerCase();
    };
    var getDimension = function getDimension(dimension) {
      return parseInt(dimension, 10) || null;
    };

    // Simple and fast method to create a hash from a string
    // https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    var simpleHash = function simpleHash(s) {
      var hash = 0;
      var strlen = s.length;
      var c;
      if (strlen === 0) {
        return hash;
      }

      // eslint-disable-next-line no-plusplus
      for (var i = 0; i < strlen; i++) {
        c = s.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + c;
        // eslint-disable-next-line no-bitwise
        hash = hash & hash; // Convert to 32bit integer
      }

      return hash;
    };

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsImage/MsImage.vue?vue&type=script&lang=js&

    var MsImagevue_type_script_lang_js_props = {
      src: {
        type: String,
        default: null
      },
      alt: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      width: {
        type: [Number, String],
        default: null
      },
      height: {
        type: [Number, String],
        default: null
      }
    };
    /* harmony default export */
    var MsImagevue_type_script_lang_js_ = {
      name: 'MsImage',
      functional: true,
      props: MsImagevue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data;
        var src = props.src,
          alt = props.alt,
          title = props.title;
        var width = getDimension(props.width);
        var height = getDimension(props.height);
        var renderImage = h('img', a(data, {
          attrs: {
            src: src,
            alt: alt,
            title: title,
            width: width ? String(width) : null,
            height: height ? String(height) : null,
            loading: "lazy",
            decoding: "async"
          },
          class: {}
        }));
        if (title) {
          return h('div', {
            attrs: {
              title: title,
              tabIndex: 0
            },
            class: 'image-tooltip'
          }, [renderImage]);
        }
        return renderImage;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsImage/MsImage.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsImage_MsImagevue_type_script_lang_js_ = MsImagevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsImage/MsImage.vue
    var MsImage_render, MsImage_staticRenderFns;

    /* normalize component */

    var MsImage_component = normalizeComponent(MsImage_MsImagevue_type_script_lang_js_, MsImage_render, MsImage_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsImage = MsImage_component.exports;
    // CONCATENATED MODULE: ./src/components/MsFooter/index.js

    var MsFooter_components = {
      MsFooter: MsFooter,
      MsFooterHeader: MsFooterHeader,
      MsFooterContent: MsFooterContent,
      MsFooterMeta: MsFooterMeta,
      MsImage: MsImage,
      MsLink: MsLink
    };
    MsFooter.install = function (Vue) {
      Object.values(MsFooter_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsFooter = MsFooter;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeader.vue?vue&type=template&id=1585c901&
    var MsHeadervue_type_template_id_1585c901_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "header"
      }, [_vm._t("default")], 2);
    };
    var MsHeadervue_type_template_id_1585c901_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeader.vue?vue&type=template&id=1585c901&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeadervue_type_script_lang_js_ = {
      name: 'MsHeader',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Header'
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeadervue_type_script_lang_js_ = MsHeadervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeader.vue

    /* normalize component */

    var MsHeader_component = normalizeComponent(MsHeader_MsHeadervue_type_script_lang_js_, MsHeadervue_type_template_id_1585c901_render, MsHeadervue_type_template_id_1585c901_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeader = MsHeader_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderLanguageBar.vue?vue&type=template&id=8e712a28&
    var MsHeaderLanguageBarvue_type_template_id_8e712a28_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "header__language-bar",
        attrs: {
          "aria-label": "language navigation"
        }
      }, [_c('div', {
        staticClass: "container"
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'globe']
        }
      }), _vm._t("default")], 2)]);
    };
    var MsHeaderLanguageBarvue_type_template_id_8e712a28_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderLanguageBar.vue?vue&type=template&id=8e712a28&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderLanguageBar.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeaderLanguageBarvue_type_script_lang_js_ = {
      name: 'MsHeaderLanguageBar'
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderLanguageBar.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderLanguageBarvue_type_script_lang_js_ = MsHeaderLanguageBarvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderLanguageBar.vue

    /* normalize component */

    var MsHeaderLanguageBar_component = normalizeComponent(MsHeader_MsHeaderLanguageBarvue_type_script_lang_js_, MsHeaderLanguageBarvue_type_template_id_8e712a28_render, MsHeaderLanguageBarvue_type_template_id_8e712a28_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeaderLanguageBar = MsHeaderLanguageBar_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderNav.vue?vue&type=template&id=c954e62c&
    var MsHeaderNavvue_type_template_id_c954e62c_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "header__nav-wrapper"
      }, [_c('nav', {
        staticClass: "header__main-navigation",
        attrs: {
          "aria-label": _vm.aria.desktop
        }
      }, [_c('div', {
        staticClass: "container"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "header__logo-container"
      }, [_c('ms-link', {
        attrs: {
          "href": _vm.headerLogo.link
        },
        on: {
          "click": _vm.linkClicked
        }
      }, [_c('ms-image', {
        staticClass: "header__logo",
        attrs: {
          "src": _vm.headerLogo.src,
          "alt": _vm.headerLogo.alt,
          "width": "180",
          "height": "19"
        }
      })], 1)], 1), _c('div', {
        staticClass: "header__navbar-container"
      }, [_c('ul', {
        staticClass: "header__navbar",
        attrs: {
          "role": "menubar"
        }
      }, [_vm._l(_vm.headerData.navigation_items, function (mainNav, index) {
        return [_c('ms-header-nav-link', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.isWizard,
            expression: "!isWizard"
          }],
          key: "navigation-".concat(index),
          attrs: {
            "header-links": mainNav
          },
          on: {
            "link-clicked": _vm.linkClicked
          }
        })];
      }), _vm.hasMainNavSlot ? _c('li', {
        staticClass: "header__nav-item"
      }, [_vm._t("mainNav")], 2) : _vm._e(), _vm.authEnabled ? _c('ms-header-nav-auth', {
        attrs: {
          "hide-dashboard-link": _vm.hideDashboardLink,
          "auth-data": _vm.authData,
          "reward-data": _vm.rewardData,
          "variant": _vm.variant
        },
        on: {
          "track-auth-link": function trackAuthLink($event) {
            return _vm.$emit('track-auth-link', $event);
          },
          "auth-logout": function authLogout($event) {
            return _vm.$emit('auth-logout', $event);
          }
        }
      }) : _vm._e()], 2), _vm.variant === 'green' ? _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.isWizard,
          expression: "!isWizard"
        }],
        staticClass: "header__navbar-mobile variant-green",
        attrs: {
          "aria-pressed": _vm.isSidebarOpen ? 'true' : 'false',
          "aria-label": _vm.aria.mobile,
          "aria-expanded": _vm.isSidebarOpen ? 'true' : 'false',
          "on": "tap:sidebar.open"
        },
        on: {
          "click": function click($event) {
            return _vm.toggleSidebar(true);
          }
        }
      }, [_vm.hasSession ? [_c('div', {
        staticClass: "header__avatar header__avatar--mobile",
        class: "".concat(_vm.headerAvatarClassName, " variant-green")
      }, [_vm._v("\n                " + _vm._s(_vm.nameInitial) + "\n              ")]), _vm.rewardData && _vm.rewardData.availablePoints ? _c('div', {
        staticClass: "header__reward-point-mobile"
      }, [_c('div', {
        staticClass: "point"
      }, [_vm._v(_vm._s(_vm.rewardData.availablePoints))]), _c('div', {
        staticClass: "label"
      }, [_vm._v(_vm._s(_vm.rewardData.label))])]) : _vm._e()] : _vm._e(), _c('fa', {
        attrs: {
          "icon": ['fal', 'bars']
        }
      })], 2) : [_vm.hasSession && !_vm.isWizard ? _c('div', {
        staticClass: "header__avatar header__avatar--mobile",
        class: "".concat(_vm.headerAvatarClassName, " variant-default")
      }, [_vm._v("\n              " + _vm._s(_vm.nameInitial) + "\n            ")]) : _vm._e(), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.isWizard,
          expression: "!isWizard"
        }],
        staticClass: "header__navbar-mobile",
        attrs: {
          "aria-pressed": _vm.isSidebarOpen ? 'true' : 'false',
          "aria-label": _vm.aria.mobile,
          "aria-expanded": _vm.isSidebarOpen ? 'true' : 'false',
          "on": "tap:sidebar.open"
        },
        on: {
          "click": function click($event) {
            return _vm.toggleSidebar(true);
          }
        }
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'bars']
        }
      })], 1)]], 2)])])]), _vm.entityInfo ? _c('div', {
        staticClass: "header__sub-info"
      }, [_c('div', {
        staticClass: "container"
      }, [_c('p', [_vm._v(_vm._s(_vm.entityInfo))])])]) : _vm._e(), _c('slide-x-right-transition', [_c('ms-header-sidebar', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isSidebarOpen,
          expression: "isSidebarOpen"
        }],
        attrs: {
          "hide-dashboard-link": _vm.hideDashboardLink,
          "sidebar-data": _vm.mobileNavLink,
          "sidebar-social": _vm.sidebarSocial,
          "logo": _vm.headerLogo,
          "auth-data": _vm.authData,
          "variant": _vm.variant,
          "always-open": _vm.alwaysOpen
        },
        on: {
          "sidebar-link-clicked": function sidebarLinkClicked($event) {
            return _vm.$emit('sidebar-link-clicked', $event);
          },
          "track-auth-link": function trackAuthLink($event) {
            return _vm.$emit('track-auth-link', $event);
          },
          "auth-logout": function authLogout($event) {
            return _vm.$emit('auth-logout', $event);
          },
          "close": _vm.toggleSidebar
        }
      }, [_c('template', {
        slot: "sideNavInternal"
      }, [_vm._t("sideNav")], 2), _c('template', {
        slot: "sideNavLangInternal"
      }, [_vm._t("sideNavLang")], 2)], 2)], 1), _c('fade-transition', [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isSidebarOpen,
          expression: "isSidebarOpen"
        }],
        staticClass: "header__overlay",
        on: {
          "click": function click($event) {
            _vm.isSidebarOpen = false;
          }
        }
      })])], 1);
    };
    var MsHeaderNavvue_type_template_id_c954e62c_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNav.vue?vue&type=template&id=c954e62c&

    // CONCATENATED MODULE: ./node_modules/vue2-transitions/dist/vue2-transitions.m.js
    /*!
     * vue2-transitions v0.3.0
     * (c) 2019-present cristij <joracristi@gmail.com>
     * Released under the MIT License.
     */
    var baseTransition = {
      inheritAttrs: false,
      props: {
        /**
         * Transition duration. Number for specifying the same duration for enter/leave transitions
         * Object style {enter: 300, leave: 300} for specifying explicit durations for enter/leave
         */
        duration: {
          type: [Number, Object],
          default: 300
        },
        /**
         * Transition delay. Number for specifying the same delay for enter/leave transitions
         * Object style {enter: 300, leave: 300} for specifying explicit durations for enter/leave
         */
        delay: {
          type: [Number, Object],
          default: 0
        },
        /**
         * Whether the component should be a `transition-group` component.
         */
        group: Boolean,
        /**
         * Transition tag, in case the component is a `transition-group`
         */
        tag: {
          type: String,
          default: 'span'
        },
        /**
         *  Transform origin property https://tympanus.net/codrops/css_reference/transform-origin/.
         *  Can be specified with styles as well but it's shorter with this prop
         */
        origin: {
          type: String,
          default: ''
        },
        /**
         * Element styles that are applied during transition. These styles are applied on @beforeEnter and @beforeLeave hooks
         */
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'ease-out'
            };
          }
        }
      },
      computed: {
        componentType: function componentType() {
          return this.group ? 'transition-group' : 'transition';
        },
        hooks: function hooks() {
          return Object.assign({
            beforeEnter: this.beforeEnter,
            afterEnter: this.cleanUpStyles,
            beforeLeave: this.beforeLeave,
            leave: this.leave,
            afterLeave: this.cleanUpStyles
          }, this.$listeners);
        }
      },
      methods: {
        beforeEnter: function beforeEnter(el) {
          var enterDuration = this.duration.enter ? this.duration.enter : this.duration;
          el.style.animationDuration = enterDuration + "ms";
          var enterDelay = this.delay.enter ? this.delay.enter : this.delay;
          el.style.animationDelay = enterDelay + "ms";
          this.setStyles(el);
        },
        cleanUpStyles: function cleanUpStyles(el) {
          var this$1 = this;
          Object.keys(this.styles).forEach(function (key) {
            var styleValue = this$1.styles[key];
            if (styleValue) {
              el.style[key] = '';
            }
          });
          el.style.animationDuration = '';
          el.style.animationDelay = '';
        },
        beforeLeave: function beforeLeave(el) {
          var leaveDuration = this.duration.leave ? this.duration.leave : this.duration;
          el.style.animationDuration = leaveDuration + "ms";
          var leaveDelay = this.delay.leave ? this.delay.leave : this.delay;
          el.style.animationDelay = leaveDelay + "ms";
          this.setStyles(el);
        },
        leave: function leave(el) {
          this.setAbsolutePosition(el);
        },
        setStyles: function setStyles(el) {
          var this$1 = this;
          this.setTransformOrigin(el);
          Object.keys(this.styles).forEach(function (key) {
            var styleValue = this$1.styles[key];
            if (styleValue) {
              el.style[key] = styleValue;
            }
          });
        },
        setAbsolutePosition: function setAbsolutePosition(el) {
          if (this.group) {
            el.style.position = 'absolute';
          }
          return this;
        },
        setTransformOrigin: function setTransformOrigin(el) {
          if (this.origin) {
            el.style.transformOrigin = this.origin;
          }
          return this;
        }
      }
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = " @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } } .fadeIn { animation-name: fadeIn; } @keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } } .fadeOut { animation-name: fadeOut; } .fade-move { transition: transform .3s ease-out; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var FadeTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "fadeIn",
            "move-class": "fade-move",
            "leave-active-class": "fadeOut"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'fade-transition',
      mixins: [baseTransition]
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = ".zoom-move { transition: transform .3s ease-out; } @keyframes zoomIn { from { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); } 50% { opacity: 1; } } .zoomIn { animation-name: zoomIn; } @keyframes zoomOut { from { opacity: 1; } 50% { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); } to { opacity: 0; } } .zoomOut { animation-name: zoomOut; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var ZoomCenterTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "zoomIn",
            "move-class": "zoom-move",
            "leave-active-class": "zoomOut"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'zoom-center-transition',
      mixins: [baseTransition]
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = ".zoom-move { transition: transform .3s ease-out; } @keyframes zoomInX { from { opacity: 0; transform: scaleX(0); } 50% { opacity: 1; } } .zoomInX { animation-name: zoomInX; } @keyframes zoomOutX { from { opacity: 1; } 50% { opacity: 0; transform: scaleX(0); } to { opacity: 0; } } .zoomOutX { animation-name: zoomOutX; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var ZoomXTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "zoomInX",
            "move-class": "zoom-move",
            "leave-active-class": "zoomOutX"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'zoom-x-transition',
      props: {
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(.55,0,.1,1)'
            };
          }
        }
      },
      mixins: [baseTransition]
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = ".zoom-move { transition: transform .3s ease-out; } @keyframes zoomInY { from { opacity: 0; transform: scaleY(0); } 50% { opacity: 1; tranform: scaleY(1); } } .zoomInY { animation-name: zoomInY; } @keyframes zoomOutY { from { opacity: 1; } 50% { opacity: 0; transform: scaleY(0); } to { opacity: 0; } } .zoomOutY { animation-name: zoomOutY; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var ZoomYTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "zoomInY",
            "move-class": "zoom-move",
            "leave-active-class": "zoomOutY"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'zoom-y-transition',
      mixins: [baseTransition],
      props: {
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(.55,0,.1,1)'
            };
          }
        }
      }
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = " .collapse-move { transition: transform .3s ease-in-out; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var CollapseTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "move-class": "collapse-move"
          },
          on: {
            "before-enter": _vm.beforeEnter,
            "after-enter": _vm.afterEnter,
            "enter": _vm.enter,
            "before-leave": _vm.beforeLeave,
            "leave": _vm.leave,
            "after-leave": _vm.afterLeave
          }
        }, 'component', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'collapse-transition',
      mixins: [baseTransition],
      methods: {
        transitionStyle: function transitionStyle(duration) {
          if (duration === void 0) duration = 300;
          var durationInSeconds = duration / 1000;
          var style = durationInSeconds + "s height ease-in-out, " + durationInSeconds + "s padding-top ease-in-out, " + durationInSeconds + "s padding-bottom ease-in-out";
          return style;
        },
        beforeEnter: function beforeEnter(el) {
          var enterDuration = this.duration.enter ? this.duration.enter : this.duration;
          el.style.transition = this.transitionStyle(enterDuration);
          if (!el.dataset) {
            el.dataset = {};
          }
          el.dataset.oldPaddingTop = el.style.paddingTop;
          el.dataset.oldPaddingBottom = el.style.paddingBottom;
          el.style.height = '0';
          el.style.paddingTop = 0;
          el.style.paddingBottom = 0;
          this.setStyles(el);
        },
        enter: function enter(el) {
          el.dataset.oldOverflow = el.style.overflow;
          if (el.scrollHeight !== 0) {
            el.style.height = el.scrollHeight + 'px';
            el.style.paddingTop = el.dataset.oldPaddingTop;
            el.style.paddingBottom = el.dataset.oldPaddingBottom;
          } else {
            el.style.height = '';
            el.style.paddingTop = el.dataset.oldPaddingTop;
            el.style.paddingBottom = el.dataset.oldPaddingBottom;
          }
          el.style.overflow = 'hidden';
        },
        afterEnter: function afterEnter(el) {
          // for safari: remove class then reset height is necessary
          el.style.transition = '';
          el.style.height = '';
          el.style.overflow = el.dataset.oldOverflow;
        },
        beforeLeave: function beforeLeave(el) {
          if (!el.dataset) {
            el.dataset = {};
          }
          el.dataset.oldPaddingTop = el.style.paddingTop;
          el.dataset.oldPaddingBottom = el.style.paddingBottom;
          el.dataset.oldOverflow = el.style.overflow;
          el.style.height = el.scrollHeight + 'px';
          el.style.overflow = 'hidden';
          this.setStyles(el);
        },
        leave: function leave(el) {
          var leaveDuration = this.duration.leave ? this.duration.leave : this.duration;
          if (el.scrollHeight !== 0) {
            // for safari: add class after set height, or it will jump to zero height suddenly, weired
            el.style.transition = this.transitionStyle(leaveDuration);
            el.style.height = 0;
            el.style.paddingTop = 0;
            el.style.paddingBottom = 0;
          }
          // necessary for transition-group
          this.setAbsolutePosition(el);
        },
        afterLeave: function afterLeave(el) {
          el.style.transition = '';
          el.style.height = '';
          el.style.overflow = el.dataset.oldOverflow;
          el.style.paddingTop = el.dataset.oldPaddingTop;
          el.style.paddingBottom = el.dataset.oldPaddingBottom;
        }
      }
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = " @keyframes scaleIn { from { opacity: 0; transform: scale(0) } to { opacity: 1; } } .scaleIn { animation-name: scaleIn; } @keyframes scaleOut { from { opacity: 1; } to { opacity: 0; transform: scale(0); } } .scaleOut { animation-name: scaleOut; } .scale-move { transition: transform .3s cubic-bezier(.25, .8, .50, 1); } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var ScaleTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "scaleIn",
            "move-class": "scale-move",
            "leave-active-class": "scaleOut"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'scale-transition',
      mixins: [baseTransition],
      props: {
        origin: {
          type: String,
          default: 'top left'
        },
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(.25,.8,.50,1)'
            };
          }
        }
      }
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = ".slide-move { transition: transform .3s; } @keyframes slideYIn { from { opacity: 0; transform: translateY(-15px); } to { opacity: 1; } } .slideYIn { animation-name: slideYIn; } @keyframes slideYOut { from { opacity: 1; } to { opacity: 0; transform: translateY(-15px); } } .slideYOut { animation-name: slideYOut; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var SlideYUpTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "type": "animation",
            "enter-active-class": "slideYIn",
            "move-class": "slide-move",
            "leave-active-class": "slideYOut"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'slide-y-up-transition',
      mixins: [baseTransition],
      props: {
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(.25,.8,.50,1)'
            };
          }
        }
      }
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = ".slide-move { transition: transform .3s; } @keyframes slideYDownIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; } } .slideYDownIn { animation-name: slideYDownIn; } @keyframes slideYDownOut { from { opacity: 1; } to { opacity: 0; transform: translateY(15px); } } .slideYDownOut { animation-name: slideYDownOut; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var SlideYDownTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "slideYDownIn",
            "leave-active-class": "slideYDownOut"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'slide-y-down-transition',
      mixins: [baseTransition],
      props: {
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(.25,.8,.50,1)'
            };
          }
        }
      }
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = ".slide-move { transition: transform .3s; } @keyframes slideXLeftIn { from { opacity: 0; transform: translateX(-15px); } to { opacity: 1; } } .slideXLeftIn { animation-name: slideXLeftIn; } @keyframes slideXLeftOut { from { opacity: 1; } to { opacity: 0; transform: translateX(-15px); } } .slideXLeftOut { animation-name: slideXLeftOut; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var SlideXLeftTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "slideXLeftIn",
            "move-class": "slide-move",
            "leave-active-class": "slideXLeftOut"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'slide-x-left-transition',
      mixins: [baseTransition],
      props: {
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(.25,.8,.50,1)'
            };
          }
        }
      }
    };
    (function () {
      if (typeof document !== 'undefined') {
        var head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style'),
          css = ".slide-move { transition: transform .3s; } @keyframes slideXRightIn { from { opacity: 0; transform: translateX(15px); } to { opacity: 1; } } .slideXRightIn { animation-name: slideXRightIn; } @keyframes slideXRightOut { from { opacity: 1; } to { opacity: 0; transform: translateX(15px); } } .slideXRightOut { animation-name: slideXRightOut; } ";
        style.type = 'text/css';
        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
      }
    })();
    var SlideXRightTransition = {
      render: function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(_vm.componentType, _vm._g(_vm._b({
          tag: "component",
          attrs: {
            "tag": _vm.tag,
            "enter-active-class": "slideXRightIn",
            "move-class": "slide-move",
            "leave-active-class": "slideXRightOut"
          }
        }, 'component', _vm.$attrs, false), _vm.hooks), [_vm._t("default")], 2);
      },
      staticRenderFns: [],
      name: 'slide-x-right-transition',
      mixins: [baseTransition],
      props: {
        styles: {
          type: Object,
          default: function () {
            return {
              animationFillMode: 'both',
              animationTimingFunction: 'cubic-bezier(.25,.8,.50,1)'
            };
          }
        }
      }
    };
    var vue2_transitions_m_components = {};
    vue2_transitions_m_components[FadeTransition.name] = FadeTransition;
    vue2_transitions_m_components[ZoomCenterTransition.name] = ZoomCenterTransition;
    vue2_transitions_m_components[ZoomXTransition.name] = ZoomXTransition;
    vue2_transitions_m_components[ZoomYTransition.name] = ZoomYTransition;
    vue2_transitions_m_components[CollapseTransition.name] = CollapseTransition;
    vue2_transitions_m_components[ScaleTransition.name] = ScaleTransition;
    vue2_transitions_m_components[SlideYUpTransition.name] = SlideYUpTransition;
    vue2_transitions_m_components[SlideYDownTransition.name] = SlideYDownTransition;
    vue2_transitions_m_components[SlideXLeftTransition.name] = SlideXLeftTransition;
    vue2_transitions_m_components[SlideXRightTransition.name] = SlideXRightTransition;
    function vue2_transitions_m_install(Vue, options) {
      if (options && options.components) {
        options.components.forEach(function (c) {
          return Vue.component(c.name, vue2_transitions_m_components[c.name]);
        });
      } else {
        Object.keys(vue2_transitions_m_components).forEach(function (key) {
          Vue.component(key, vue2_transitions_m_components[key]);
        });
      }
    }

    // Automatic installation if Vue has been added to the global scope.
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use({
        install: vue2_transitions_m_install
      });
    }
    var index = {
      install: vue2_transitions_m_install
    };

    /* harmony default export */
    var vue2_transitions_m = index;

    // CONCATENATED MODULE: ./src/mixins/Auth.js
    /* harmony default export */
    var Auth = {
      computed: {
        authEnabled: function authEnabled() {
          return this.authData && this.authData.user !== null && this.authData.user !== undefined;
        },
        hasSession: function hasSession() {
          return this.authEnabled && this.authData.hasSession;
        },
        nameInitial: function nameInitial() {
          var user = this.authData.user;
          return user.charAt(0);
        },
        dashboardLink: function dashboardLink() {
          return this.authData.profileLinks.dashboard;
        },
        authenticationLink: function authenticationLink() {
          var _this$authData = this.authData,
            login = _this$authData.login,
            profileLinks = _this$authData.profileLinks;
          return this.hasSession ? profileLinks.logout : login;
        }
      },
      methods: {
        authLinkClick: function authLinkClick(link) {
          if (link.id === 'logout') this.$emit('auth-logout', link);
          this.$emit('track-auth-link', link);
        }
      }
    };
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderNav.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsHeaderNavvue_type_script_lang_js_ = {
      name: 'MsHeaderNav',
      components: {
        SlideXRightTransition: SlideXRightTransition,
        FadeTransition: FadeTransition
      },
      mixins: [Auth],
      props: {
        /**
         * When true, the menu will be always open
         */
        alwaysOpen: {
          type: Boolean,
          default: false
        },
        /**
         * Data returned from the Commons API
         */
        headerData: {
          type: Object
        },
        /**
         * When true, the menu links will be hidden from the user
         */
        isWizard: {
          type: Boolean,
          default: false
        },
        authData: {
          type: Object,
          required: false,
          default: function _default() {}
        },
        sidebarData: {
          type: Array,
          required: false,
          default: function _default() {
            return [];
          }
        },
        sidebarSocial: {
          type: Object,
          required: false,
          default: function _default() {}
        },
        rewardData: {
          type: Object,
          required: false,
          default: function _default() {}
        },
        variant: {
          type: String,
          default: 'default'
        },
        hideDashboardLink: {
          type: Boolean,
          default: false
        },
        /**
         * To display regulated/unregulated view
         */
        isRegulated: {
          type: Boolean,
          default: false
        }
      },
      data: function data() {
        return {
          isSidebarOpen: false,
          aria: {
            desktop: 'main navigation',
            mobile: 'mobile menu'
          }
        };
      },
      computed: {
        hasMainNavSlot: function hasMainNavSlot() {
          return !!this.$slots.mainNav;
        },
        mobileNavLink: function mobileNavLink() {
          return this.sidebarData.concat(this.headerData.navigation_items);
        },
        headerAvatarClassName: function headerAvatarClassName() {
          return "header__avatar--".concat(this.nameInitial.toLowerCase());
        },
        headerLogo: function headerLogo() {
          return this.isRegulated && 'ms_financial_logo' in this.headerData ? this.headerData.ms_financial_logo : this.headerData.logo;
        },
        entityInfo: function entityInfo() {
          return this.isRegulated && 'entity_information' in this.headerData ? this.headerData.entity_information : '';
        },
        isMember: function isMember() {
          return this.authData && this.authData.isMember;
        }
      },
      methods: {
        toggleSidebar: function toggleSidebar(value) {
          this.isSidebarOpen = value;
        },
        linkClicked: function linkClicked(data) {
          this.$emit('link-clicked', data);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNav.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderNavvue_type_script_lang_js_ = MsHeaderNavvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNav.vue

    /* normalize component */

    var MsHeaderNav_component = normalizeComponent(MsHeader_MsHeaderNavvue_type_script_lang_js_, MsHeaderNavvue_type_template_id_c954e62c_render, MsHeaderNavvue_type_template_id_c954e62c_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeaderNav = MsHeaderNav_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderNavLink.vue?vue&type=template&id=578e5782&
    var MsHeaderNavLinkvue_type_template_id_578e5782_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        class: ['header__nav-item', {
          'header__dropdown-wide-column': _vm.headerLinks.class === 'wide-column'
        }, {
          'header__dropdown-single-column': _vm.headerLinks.class === 'single-column'
        }],
        attrs: {
          "role": "menuitem",
          "aria-haspopup": _vm.headerLinks.dropdown_items ? true : false,
          "aria-expanded": _vm.isHoverDropdown && _vm.headerLinks.dropdown_items ? 'true' : 'false'
        },
        on: {
          "mouseover": function mouseover($event) {
            _vm.isHoverDropdown = true;
          },
          "mouseleave": function mouseleave($event) {
            _vm.isHoverDropdown = false;
          }
        }
      }, [_vm.isDropdownData ? [_c('ms-link', {
        staticClass: "header__nav-link",
        attrs: {
          "href": _vm.headerLinks.link
        },
        on: {
          "click": function click($event) {
            return _vm.linkClicked(_vm.headerLinks);
          },
          "dropdown-link-clicked": function dropdownLinkClicked($event) {
            $event.preventDefault();
            return _vm.linkClicked.apply(null, arguments);
          }
        }
      }, [_vm._v("\n      " + _vm._s(_vm.headerLinks.title) + "\n    ")])] : [_c('ms-link', {
        staticClass: "header__nav-link",
        attrs: {
          "href": _vm.headerLinks.link
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('link-clicked', _vm.headerLinks);
          }
        }
      }, [_vm._v("\n      " + _vm._s(_vm.headerLinks.title) + "\n    ")])], _vm.headerLinks.dropdown_items ? _c('ms-header-dropdown', {
        attrs: {
          "dropdown-data": _vm.headerLinks,
          "is-focus": _vm.isHoverDropdown
        },
        on: {
          "dropdown-link-clicked": _vm.linkClicked
        }
      }) : _vm._e()], 2);
    };
    var MsHeaderNavLinkvue_type_template_id_578e5782_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNavLink.vue?vue&type=template&id=578e5782&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderNavLink.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeaderNavLinkvue_type_script_lang_js_ = {
      name: 'MsHeaderNavLink',
      props: {
        headerLinks: Object
      },
      data: function data() {
        return {
          isHoverDropdown: false
        };
      },
      computed: {
        isDropdownData: function isDropdownData() {
          if (!this.headerLinks.dropdown_items || this.headerLinks && this.headerLinks.dropdown_items.length === 0) {
            return false;
          }
          return true;
        }
      },
      methods: {
        linkClicked: function linkClicked(data) {
          this.$emit('link-clicked', data);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNavLink.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderNavLinkvue_type_script_lang_js_ = MsHeaderNavLinkvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNavLink.vue

    /* normalize component */

    var MsHeaderNavLink_component = normalizeComponent(MsHeader_MsHeaderNavLinkvue_type_script_lang_js_, MsHeaderNavLinkvue_type_template_id_578e5782_render, MsHeaderNavLinkvue_type_template_id_578e5782_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeaderNavLink = MsHeaderNavLink_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderNavAuth.vue?vue&type=template&id=14c39d94&
    var MsHeaderNavAuthvue_type_template_id_14c39d94_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        staticClass: "header__nav-item header__nav-item--auth"
      }, [_vm.hasSession ? _c('v-popover', {
        attrs: {
          "trigger": "click",
          "popover-class": "auth-tooltip",
          "placement": "bottom"
        }
      }, [_c('button', {
        staticClass: "tooltip-target"
      }, [_c('div', {
        staticClass: "header__avatar",
        class: "".concat(_vm.headerAvatarClassName, " ").concat(_vm.variant === 'green' ? 'variant-green' : 'variant-default')
      }, [_vm._v("\n        " + _vm._s(_vm.nameInitial) + "\n      ")]), _vm.rewardData && _vm.rewardData.availablePoints ? _c('div', {
        staticClass: "header__reward-point-desktop"
      }, [_c('div', {
        staticClass: "point"
      }, [_vm._v(_vm._s(_vm.rewardData.availablePoints))]), _c('div', {
        staticClass: "label"
      }, [_vm._v(_vm._s(_vm.rewardData.label))])]) : _c('fa', {
        attrs: {
          "icon": ['fal', 'angle-down']
        }
      })], 1), _c('template', {
        slot: "popover"
      }, [_c('ul', {
        staticClass: "auth-tooltip__nav",
        class: {
          'auth-tooltip--hidden-dashboard-link': _vm.hideDashboardLink
        }
      }, [_c('li', {
        staticClass: "auth-tooltip__info"
      }, [_c('span', [_vm._v(_vm._s(_vm.authData.user))]), _c('span', [_vm._v(_vm._s(_vm.authData.email))])]), _vm._l(_vm.authData.profileLinks, function (link, key, index) {
        return _c('li', {
          key: index,
          class: {
            'logout-option': key === 'logout' && _vm.profileLinksCount > 2,
            'profile-links': key !== 'logout' && key !== 'dashboard'
          }
        }, [_c('ms-link', {
          class: link.id,
          attrs: {
            "href": link.url,
            "target": link.target
          },
          on: {
            "click": function click($event) {
              return _vm.authLinkClick(link);
            }
          }
        }, [_c('span', [_vm._v(_vm._s(link.label))]), link.badgeLabel ? _c('span', {
          staticClass: "link-badge"
        }, [_vm._v(_vm._s(link.badgeLabel))]) : _vm._e()])], 1);
      })], 2)])], 2) : _c('ms-link', {
        staticClass: "header__nav-link",
        attrs: {
          "href": _vm.authenticationLink.url
        }
      }, [_c('fa', {
        attrs: {
          "icon": ['fas', 'user-circle']
        }
      }), _vm._v("\n    " + _vm._s(_vm.authenticationLink.label) + "\n  ")], 1)], 1);
    };
    var MsHeaderNavAuthvue_type_template_id_14c39d94_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNavAuth.vue?vue&type=template&id=14c39d94&

    // EXTERNAL MODULE: ./node_modules/v-tooltip/dist/v-tooltip.esm.js
    var v_tooltip_esm = __webpack_require__("e37d");

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderNavAuth.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsHeaderNavAuthvue_type_script_lang_js_ = {
      name: 'MsHeaderNavAuth',
      components: {
        VPopover: v_tooltip_esm["a" /* VPopover */]
      },

      mixins: [Auth],
      props: {
        authData: Object,
        rewardData: {
          type: Object,
          required: false,
          default: function _default() {}
        },
        variant: {
          type: String,
          default: 'default'
        },
        hideDashboardLink: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        headerAvatarClassName: function headerAvatarClassName() {
          return "header__avatar--".concat(this.nameInitial.toLowerCase());
        },
        isMember: function isMember() {
          return this.authData && this.authData.isMember;
        },
        profileLinksCount: function profileLinksCount() {
          return Object.keys(this.authData.profileLinks).length;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNavAuth.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderNavAuthvue_type_script_lang_js_ = MsHeaderNavAuthvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderNavAuth.vue

    /* normalize component */

    var MsHeaderNavAuth_component = normalizeComponent(MsHeader_MsHeaderNavAuthvue_type_script_lang_js_, MsHeaderNavAuthvue_type_template_id_14c39d94_render, MsHeaderNavAuthvue_type_template_id_14c39d94_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeaderNavAuth = MsHeaderNavAuth_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderDropdown.vue?vue&type=template&id=5a5a8940&scoped=true&
    var MsHeaderDropdownvue_type_template_id_5a5a8940_scoped_true_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "header__dropdown",
        attrs: {
          "aria-hidden": _vm.isFocus ? 'false' : 'true'
        }
      }, [_c('div', {
        staticClass: "container"
      }, [_c('div', {
        staticClass: "header__dropdown-row"
      }, [_c('div', {
        staticClass: "header__dropdown-col"
      }, [_vm.dropdownData.subHeader ? _c('h3', {
        staticClass: "header__dropdown-title"
      }, [_vm._v("\n          " + _vm._s(_vm.dropdownData.subHeader) + "\n        ")]) : [_vm.dropdownData.dropdown_items[0] ? [_c('h4', {
        staticClass: "header__dropdown-secondary-title"
      }, [_vm.dropdownData.dropdown_items[0].titleLink ? _c('a', {
        attrs: {
          "href": _vm.dropdownData.dropdown_items[0].titleLink
        },
        on: {
          "click": function click() {
            return _vm.linkClicked(_vm.dropdownData.dropdown_items[0]);
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.dropdownData.dropdown_items[0].title) + "\n              ")]) : [_vm._v(_vm._s(_vm.dropdownData.dropdown_items[0].title))]], 2)] : _vm._e(), _c('div', {
        staticClass: "header__dropdown-links-wrap"
      }, _vm._l(_vm.dropdownData.dropdown_items[0].data, function (links, index) {
        return _c('ms-link', {
          key: "dropdown-links-".concat(index),
          staticClass: "header__dropdown-links",
          attrs: {
            "href": links.link,
            "tabindex": _vm.isFocus ? '0' : '-1'
          },
          on: {
            "click": function click() {
              return _vm.linkClicked(links);
            }
          }
        }, [_vm._v("\n              " + _vm._s(links.label) + "\n              "), links.icon ? _c('fa', {
          attrs: {
            "icon": links.icon
          }
        }) : _vm._e()], 1);
      }), 1), _vm.dropdownData.dropdown_items[0].groupedData ? _vm._l(_vm.dropdownData.dropdown_items[0].groupedData, function (item, index) {
        return _c('div', {
          key: "dropdown-".concat(index),
          staticClass: "header__dropdown-links-wrap"
        }, [item.title ? [_c('h4', {
          staticClass: "header__dropdown-secondary-title"
        }, [item.titleLink ? _c('a', {
          attrs: {
            "href": item.titleLink
          },
          on: {
            "click": function click() {
              return _vm.linkClicked(item);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")]) : [_vm._v(_vm._s(item.title))]], 2)] : _vm._e(), _vm._l(item.data, function (links, index) {
          return _c('ms-link', {
            key: "dropdown-links-".concat(index),
            staticClass: "header__dropdown-links",
            attrs: {
              "href": links.link,
              "tabindex": _vm.isFocus ? '0' : '-1'
            },
            on: {
              "click": function click() {
                return _vm.linkClicked(links);
              }
            }
          }, [_vm._v("\n                " + _vm._s(links.label) + "\n                "), links.icon ? _c('fa', {
            attrs: {
              "icon": links.icon
            }
          }) : _vm._e()], 1);
        })], 2);
      }) : _vm._e()]], 2), _vm.dropdownData.subHeader ? [_c('div', {
        staticClass: "header__dropdown-col"
      }, [_vm.dropdownData.dropdown_items[0] ? [_c('h4', {
        staticClass: "header__dropdown-secondary-title"
      }, [_vm.dropdownData.dropdown_items[0].titleLink ? _c('a', {
        attrs: {
          "href": _vm.dropdownData.dropdown_items[0].titleLink
        },
        on: {
          "click": function click() {
            return _vm.linkClicked(_vm.dropdownData.dropdown_items[0]);
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.dropdownData.dropdown_items[0].title) + "\n              ")]) : [_vm._v(_vm._s(_vm.dropdownData.dropdown_items[0].title))]], 2)] : _vm._e(), _c('div', {
        staticClass: "header__dropdown-links-wrap"
      }, _vm._l(_vm.dropdownData.dropdown_items[0].data, function (links, index) {
        return _c('ms-link', {
          key: "dropdown-links-".concat(index),
          staticClass: "header__dropdown-links",
          attrs: {
            "href": links.link,
            "tabindex": _vm.isFocus ? '0' : '-1'
          },
          on: {
            "click": function click() {
              return _vm.linkClicked(links);
            }
          }
        }, [_vm._v("\n              " + _vm._s(links.label) + "\n              "), links.icon ? _c('fa', {
          attrs: {
            "icon": links.icon
          }
        }) : _vm._e()], 1);
      }), 1), _vm.dropdownData.dropdown_items[0].groupedData ? _vm._l(_vm.dropdownData.dropdown_items[0].groupedData, function (item, index) {
        return _c('div', {
          key: "dropdown-".concat(index),
          staticClass: "header__dropdown-links-wrap"
        }, [item.title ? [_c('h4', {
          staticClass: "header__dropdown-secondary-title"
        }, [item.titleLink ? _c('a', {
          attrs: {
            "href": item.titleLink
          },
          on: {
            "click": function click() {
              return _vm.linkClicked(item);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")]) : [_vm._v(_vm._s(item.title))]], 2)] : _vm._e(), _vm._l(item.data, function (links, index) {
          return _c('ms-link', {
            key: "dropdown-links-".concat(index),
            staticClass: "header__dropdown-links",
            attrs: {
              "href": links.link,
              "tabindex": _vm.isFocus ? '0' : '-1'
            },
            on: {
              "click": function click() {
                return _vm.linkClicked(links);
              }
            }
          }, [_vm._v("\n                " + _vm._s(links.label) + "\n                "), links.icon ? _c('fa', {
            attrs: {
              "icon": links.icon
            }
          }) : _vm._e()], 1);
        })], 2);
      }) : _vm._e()], 2)] : _vm._e(), _vm._l(_vm.dropdownData.dropdown_items.slice(1), function (dropdown, index) {
        return [_c('div', {
          key: "dropdown-".concat(index),
          staticClass: "header__dropdown-col"
        }, [_c('h4', {
          staticClass: "header__dropdown-secondary-title"
        }, [dropdown.titleLink ? _c('a', {
          attrs: {
            "href": dropdown.titleLink
          },
          on: {
            "click": function click() {
              return _vm.linkClicked(dropdown);
            }
          }
        }, [_vm._v("\n              " + _vm._s(dropdown.title) + "\n            ")]) : [_vm._v(_vm._s(dropdown.title))]], 2), _c('div', {
          staticClass: "header__dropdown-links-wrap"
        }, _vm._l(dropdown.data, function (links, index) {
          return _c('ms-link', {
            key: "dropdown-links-".concat(index),
            staticClass: "header__dropdown-links",
            attrs: {
              "href": links.link,
              "tabindex": _vm.isFocus ? '0' : '-1'
            },
            on: {
              "click": function click() {
                return _vm.linkClicked(links);
              }
            }
          }, [_vm._v("\n              " + _vm._s(links.label) + "\n              "), links.icon ? _c('fa', {
            attrs: {
              "icon": links.icon
            }
          }) : _vm._e()], 1);
        }), 1), dropdown.groupedData ? _vm._l(dropdown.groupedData, function (item, index) {
          return _c('div', {
            key: "dropdown-".concat(index),
            staticClass: "header__dropdown-links-wrap"
          }, [item.title ? [_c('h4', {
            staticClass: "header__dropdown-secondary-title"
          }, [item.titleLink ? _c('a', {
            attrs: {
              "href": item.titleLink
            },
            on: {
              "click": function click() {
                return _vm.linkClicked(item);
              }
            }
          }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")]) : [_vm._v(_vm._s(item.title))]], 2)] : _vm._e(), _vm._l(item.data, function (links, index) {
            return _c('ms-link', {
              key: "dropdown-links-".concat(index),
              staticClass: "header__dropdown-links",
              attrs: {
                "href": links.link,
                "tabindex": _vm.isFocus ? '0' : '-1'
              },
              on: {
                "click": function click() {
                  return _vm.linkClicked(links);
                }
              }
            }, [_vm._v("\n                " + _vm._s(links.label) + "\n                "), links.icon ? _c('fa', {
              attrs: {
                "icon": links.icon
              }
            }) : _vm._e()], 1);
          })], 2);
        }) : _vm._e()], 2)];
      }), _vm.dropdownData.dropdown_items.length < 4 ? [_vm.dropdownData.dropdown_items.length < 3 ? _c('div', {
        staticClass: "header__dropdown-col"
      }) : _vm._e(), !_vm.dropdownData.subHeader ? _c('div', {
        staticClass: "header__dropdown-col"
      }) : _vm._e()] : _vm._e()], 2)])]);
    };
    var MsHeaderDropdownvue_type_template_id_5a5a8940_scoped_true_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderDropdown.vue?vue&type=template&id=5a5a8940&scoped=true&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderDropdown.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeaderDropdownvue_type_script_lang_js_ = {
      name: 'MsHeaderDropdown',
      props: {
        /**
         * Data object for custom dropdown
         */
        dropdownData: {
          type: Object
        },
        /**
         * Set the aria state, and tabability of links
         */
        isFocus: {
          type: Boolean
        }
      },
      methods: {
        linkClicked: function linkClicked(data) {
          this.$emit('dropdown-link-clicked', data);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderDropdown.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderDropdownvue_type_script_lang_js_ = MsHeaderDropdownvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsHeader/MsHeaderDropdown.vue?vue&type=style&index=0&id=5a5a8940&prod&lang=scss&scoped=true&
    var MsHeaderDropdownvue_type_style_index_0_id_5a5a8940_prod_lang_scss_scoped_true_ = __webpack_require__("d007");

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderDropdown.vue

    /* normalize component */

    var MsHeaderDropdown_component = normalizeComponent(MsHeader_MsHeaderDropdownvue_type_script_lang_js_, MsHeaderDropdownvue_type_template_id_5a5a8940_scoped_true_render, MsHeaderDropdownvue_type_template_id_5a5a8940_scoped_true_staticRenderFns, false, null, "5a5a8940", null);

    /* harmony default export */
    var MsHeaderDropdown = MsHeaderDropdown_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderSidebar.vue?vue&type=template&id=fae620a0&
    var MsHeaderSidebarvue_type_template_id_fae620a0_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('nav', {
        staticClass: "header-sidebar",
        attrs: {
          "aria-label": "sidebar navigation",
          "aria-hidden": "true"
        }
      }, [_c('div', {
        staticClass: "header-sidebar__logo-container"
      }, [_c('ms-link', {
        staticClass: "header__logo-wrap",
        attrs: {
          "href": _vm.logo.link
        }
      }, [_c('ms-image', {
        staticClass: "header__logo",
        attrs: {
          "src": _vm.logo.src,
          "alt": _vm.logo.alt,
          "width": "180",
          "height": "19"
        }
      })], 1), _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.closeSidebar.apply(null, arguments);
          }
        }
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'times']
        }
      })], 1)], 1), _vm.toggleInternalLinks ? _c('ms-link', {
        staticClass: "header-sidebar__back-container",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.closeSubMenu.apply(null, arguments);
          }
        }
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'angle-left']
        }
      }), _c('span', [_vm._v("Back")])], 1) : _vm._e(), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.toggleInternalLinks,
          expression: "!toggleInternalLinks"
        }],
        staticClass: "header-sidebar__links-wrapper"
      }, [_c('ul', {
        staticClass: "header-sidebar__links-container",
        attrs: {
          "role": "menu"
        }
      }, [_vm.hasSession ? _c('li', {
        staticClass: "header-sidebar__links header-sidebar__links--auth",
        class: {
          'top-profile-section': _vm.alwaysOpen
        }
      }, [_vm.variant === 'default' ? _c('div', {
        staticClass: "header__avatar",
        class: [_vm.headerAvatarClassName]
      }, [_vm._v("\n          " + _vm._s(_vm.nameInitial) + "\n        ")]) : _vm._e(), _vm.authData.user ? _c('span', [_vm._v(_vm._s(_vm.authData.user))]) : _vm._e(), _vm.authData.email ? _c('span', [_vm._v(_vm._s(_vm.authData.email))]) : _vm._e()]) : _vm._e(), _vm.hasSession && !_vm.hideDashboardLink ? _c('li', {
        staticClass: "header-sidebar__links",
        class: {
          'always-open': _vm.alwaysOpen
        }
      }, [_c('ms-link', {
        attrs: {
          "href": _vm.dashboardLink.url,
          "target": _vm.dashboardLink.target
        },
        on: {
          "click": function click($event) {
            return _vm.authLinkClick(_vm.dashboardLink);
          }
        }
      }, [_vm._v("\n          " + _vm._s(_vm.dashboardLink.label) + "\n        ")])], 1) : _vm._e(), _vm.authEnabled && !_vm.hasSession ? _c('li', {
        staticClass: "header-sidebar__links header-sidebar__links--login",
        class: "".concat(_vm.alwaysOpen ? 'always-open' : '', " ").concat(_vm.variant === 'green' ? 'variant-green' : 'variant-default')
      }, [_vm.variant === 'green' ? _c('ms-link', {
        staticClass: "always-open",
        class: _vm.authenticationLink.id,
        attrs: {
          "href": _vm.authenticationLink.url
        },
        on: {
          "click": function click($event) {
            return _vm.authLinkClick(_vm.authenticationLink);
          }
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.authenticationLink.label))]), _c('fa', {
        attrs: {
          "icon": ['fas', 'user-circle']
        }
      })], 1) : _c('ms-link', {
        class: _vm.authenticationLink.id,
        attrs: {
          "href": _vm.authenticationLink.url
        },
        on: {
          "click": function click($event) {
            return _vm.authLinkClick(_vm.authenticationLink);
          }
        }
      }, [_c('fa', {
        attrs: {
          "icon": ['fas', 'user-circle']
        }
      }), _vm._v("\n          " + _vm._s(_vm.authenticationLink.label) + "\n          "), _c('fa', {
        attrs: {
          "icon": ['fal', 'angle-right']
        }
      })], 1)], 1) : _vm._e(), _vm.hasSession ? _vm._l(_vm.profileLinks, function (authLink, index) {
        return _c('li', {
          key: "auth-link".concat(index),
          staticClass: "header-sidebar__links profile-links"
        }, [_c('ms-link', {
          class: authLink.id,
          attrs: {
            "href": authLink.url
          },
          on: {
            "click": function click($event) {
              return _vm.authLinkClick(authLink);
            }
          }
        }, [_c('span', [_vm._v(_vm._s(authLink.label))]), authLink.badgeLabel ? _c('span', {
          staticClass: "link-badge"
        }, [_vm._v(_vm._s(authLink.badgeLabel))]) : _vm._e()])], 1);
      }) : _vm._e(), _vm._m(0), _vm._l(_vm.sidebarData, function (sidebar, index) {
        return [_c('ms-header-sidebar-link', {
          key: "sidebar-".concat(index),
          attrs: {
            "sidebar-data": sidebar,
            "always-open": _vm.alwaysOpen
          },
          on: {
            "internalLinks": _vm.getInternalLinks,
            "closeSidebar": _vm.closeSidebar,
            "sidebar-link-clicked": function sidebarLinkClicked($event) {
              return _vm.$emit('sidebar-link-clicked', $event);
            }
          }
        })];
      }), _vm.hasSession ? _c('li', {
        staticClass: "header-sidebar__links header-sidebar__links--logout",
        class: {
          'always-open': _vm.alwaysOpen
        }
      }, [_c('ms-link', {
        class: _vm.authenticationLink.id,
        attrs: {
          "href": _vm.authenticationLink.url
        },
        on: {
          "click": function click($event) {
            return _vm.authLinkClick(_vm.authenticationLink);
          }
        }
      }, [_vm._v("\n          " + _vm._s(_vm.authenticationLink.label) + "\n        ")])], 1) : _vm._e(), _c('li', {
        staticClass: "header-sidebar__links"
      }, [_vm._t("sideNavInternal")], 2)], 2), _c('ul', {
        staticClass: "header-sidebar__links-container",
        attrs: {
          "role": "menu"
        }
      }, [_vm.navLangHasContent ? _c('li', {
        staticClass: "header-sidebar__links--language"
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'globe']
        }
      }), _vm._t("sideNavLangInternal")], 2) : _vm._e(), _vm.sidebarSocial ? _c('li', {
        staticClass: "header-sidebar__links--social",
        class: {
          'always-open': _vm.alwaysOpen
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.sidebarSocial.label))]), _vm._l(_vm.sidebarSocial.social_sites, function (social, index) {
        return _c('ms-link', {
          key: index,
          attrs: {
            "href": social.link,
            "target": social.target,
            "alt": social.label
          }
        }, [_c('fa', {
          attrs: {
            "icon": social.icon
          }
        })], 1);
      })], 2) : _vm._e()])]), _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.toggleInternalLinks,
          expression: "toggleInternalLinks"
        }],
        staticClass: "header-sidebar__links-container",
        attrs: {
          "role": "menu"
        }
      }, [_vm._l(_vm.internalLinks, function (sidebar, index) {
        return _c('li', {
          key: "".concat(index),
          staticClass: "header-sidebar__links--internal",
          attrs: {
            "role": "menuitem"
          }
        }, [_c('ms-link', {
          attrs: {
            "href": sidebar.link
          },
          on: {
            "click": function click($event) {
              return _vm.$emit('sidebar-link-clicked', sidebar);
            }
          }
        }, [_c('ms-header-sidebar-link-label', {
          attrs: {
            "label": sidebar.label,
            "badge-label": sidebar.badgeLabel,
            "is-new": sidebar.new
          }
        }), sidebar.icon ? _c('fa', {
          attrs: {
            "icon": sidebar.icon
          }
        }) : _vm._e()], 1)], 1);
      }), _vm._l(_vm.internalGroupedLinks, function (sidebar, index) {
        return _c('li', {
          key: "group-".concat(index),
          staticClass: "header-sidebar__links--internal",
          attrs: {
            "role": "menuitem"
          }
        }, _vm._l(sidebar.data, function (link, index) {
          return _c('ms-link', {
            key: "group-link-".concat(index),
            attrs: {
              "href": link.link
            }
          }, [_vm._v("\n        " + _vm._s(link.label) + "\n        "), link.icon ? _c('fa', {
            attrs: {
              "icon": link.icon
            }
          }) : _vm._e()], 1);
        }), 1);
      }), _vm.navLangHasContent ? _c('li', {
        staticClass: "header-sidebar__links--language"
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'globe']
        }
      }), _vm._t("sideNavLangInternal")], 2) : _vm._e()], 2)], 1);
    };
    var MsHeaderSidebarvue_type_template_id_fae620a0_staticRenderFns = [function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', [_c('div', {
        staticClass: "link-separator"
      })]);
    }];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebar.vue?vue&type=template&id=fae620a0&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderSidebar.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsHeaderSidebarvue_type_script_lang_js_ = {
      name: 'MsHeaderSidebar',
      mixins: [Auth],
      props: {
        sidebarData: {
          type: Array,
          required: true
        },
        /**
         * ms-link and image source
         */
        logo: {
          type: Object,
          required: true
        },
        authData: {
          type: Object
        },
        sidebarSocial: {
          type: Object
        },
        variant: {
          type: String,
          default: 'default'
        },
        hideDashboardLink: {
          type: Boolean,
          default: false
        },
        alwaysOpen: {
          type: Boolean,
          default: false
        }
      },
      data: function data() {
        return {
          internalGroupedLinks: {},
          internalLinks: {},
          toggleInternalLinks: false,
          profileLinks: []
        };
      },
      computed: {
        navLangHasContent: function navLangHasContent() {
          return !!this.$slots.sideNavLangInternal;
        },
        headerAvatarClassName: function headerAvatarClassName() {
          return "header__avatar--".concat(this.nameInitial.toLowerCase());
        },
        isMember: function isMember() {
          return this.authData && this.authData.isMember;
        }
      },
      created: function created() {
        if (!this.authData || this.authData && !this.authData.profileLinks) return;
        var profileLinks = Object.entries(this.authData.profileLinks).filter(function (profileLink) {
          return !['dashboard', 'logout'].includes(profileLink[0]);
        });
        this.profileLinks = profileLinks.map(function (el) {
          return el[1];
        });
      },
      methods: {
        closeSidebar: function closeSidebar() {
          /**
           * Close the sidebar
           *
           * @event close
           * @property {boolean} false close the sidebar
           */
          this.$emit('close', false);
          this.toggleInternalLinks = false;
        },
        closeSubMenu: function closeSubMenu() {
          this.internalGroupedLinks = {};
          this.toggleInternalLinks = false;
        },
        getInternalLinks: function getInternalLinks(value) {
          this.toggleInternalLinks = true;
          this.internalLinks = value.default;
          if (value.groups) {
            this.internalGroupedLinks = value.groups;
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebar.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderSidebarvue_type_script_lang_js_ = MsHeaderSidebarvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebar.vue

    /* normalize component */

    var MsHeaderSidebar_component = normalizeComponent(MsHeader_MsHeaderSidebarvue_type_script_lang_js_, MsHeaderSidebarvue_type_template_id_fae620a0_render, MsHeaderSidebarvue_type_template_id_fae620a0_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeaderSidebar = MsHeaderSidebar_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderSidebarLink.vue?vue&type=template&id=6b27c01e&
    var MsHeaderSidebarLinkvue_type_template_id_6b27c01e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        staticClass: "header-sidebar__links link-divider",
        class: {
          'always-open': _vm.alwaysOpen
        },
        attrs: {
          "role": "menuitem",
          "aria-haspopup": _vm.sidebarData.dropdown_items || _vm.sidebarData.child ? true : false,
          "aria-expanded": _vm.isCollapsed && (_vm.sidebarData.dropdown_items || _vm.sidebarData.child) ? 'true' : 'false'
        }
      }, [_vm.isSidebarData ? [_c('ms-link', {
        class: {
          'is-active': _vm.toggleLinks
        },
        attrs: {
          "href": _vm.sidebarData.link,
          "to": _vm.sidebarData.to,
          "target": _vm.sidebarData.target
        },
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.toggleIfData($event, _vm.sidebarData);
          }
        }
      }, [_c('ms-header-sidebar-link-label', {
        attrs: {
          "label": _vm.sidebarData.title,
          "badge-label": _vm.sidebarData.badgeLabel,
          "toggle": _vm.toggleLinks,
          "is-new": _vm.sidebarData.new
        }
      }), _c('fa', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.sidebarData.dropdown_items,
          expression: "sidebarData.dropdown_items"
        }],
        class: {
          'icon-rotate-up': _vm.isCollapsed
        },
        attrs: {
          "icon": ['fal', 'angle-down']
        }
      })], 1)] : _vm.alwaysOpen ? [_vm.sidebarData.child ? _c('div', {
        staticClass: "open-menu"
      }, [_c('ms-header-sidebar-link-label', {
        attrs: {
          "label": _vm.sidebarData.title,
          "badge-label": _vm.sidebarData.badgeLabel,
          "toggle": _vm.toggleLinks,
          "is-new": _vm.sidebarData.new
        }
      })], 1) : _c('ms-link', {
        attrs: {
          "href": _vm.sidebarData.link,
          "to": _vm.sidebarData.to,
          "target": _vm.sidebarData.target,
          "exact-active-class": "is-active"
        },
        nativeOn: {
          "click": function click($event) {
            return _vm.closeSidebar($event, _vm.sidebarData);
          }
        }
      }, [_c('ms-header-sidebar-link-label', {
        attrs: {
          "label": _vm.sidebarData.title,
          "badge-label": _vm.sidebarData.badgeLabel,
          "toggle": _vm.toggleLinks,
          "is-new": _vm.sidebarData.new
        }
      })], 1)] : _vm.isChildData ? [_c('ms-link', {
        class: {
          'is-active': _vm.toggleLinks
        },
        attrs: {
          "href": _vm.sidebarData.link,
          "to": _vm.sidebarData.to,
          "target": _vm.sidebarData.target
        },
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.toggleIfData($event, _vm.sidebarData);
          }
        }
      }, [_c('ms-header-sidebar-link-label', {
        attrs: {
          "label": _vm.sidebarData.title,
          "badge-label": _vm.sidebarData.badgeLabel,
          "toggle": _vm.toggleLinks,
          "is-new": _vm.sidebarData.new
        }
      }), _c('fa', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.sidebarData.child,
          expression: "sidebarData.child"
        }],
        class: {
          'icon-rotate-up': _vm.isCollapsed
        },
        attrs: {
          "icon": ['fal', 'angle-down']
        }
      })], 1)] : [_c('ms-link', {
        attrs: {
          "href": _vm.sidebarData.link,
          "to": _vm.sidebarData.to,
          "target": _vm.sidebarData.target,
          "exact-active-class": "is-active"
        },
        nativeOn: {
          "click": function click($event) {
            return _vm.closeSidebar($event, _vm.sidebarData);
          }
        }
      }, [_c('ms-header-sidebar-link-label', {
        attrs: {
          "label": _vm.sidebarData.title,
          "badge-label": _vm.sidebarData.badgeLabel,
          "toggle": _vm.toggleLinks,
          "is-new": _vm.sidebarData.new
        }
      }), _c('fa', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.sidebarData.dropdown_items,
          expression: "sidebarData.dropdown_items"
        }],
        class: {
          'icon-rotate-up': _vm.toggleLinks
        },
        attrs: {
          "icon": ['fal', 'angle-down']
        }
      })], 1)], _c('collapse-transition', [_vm.sidebarData.dropdown_items ? [_c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isCollapsed,
          expression: "isCollapsed"
        }],
        staticClass: "header-sidebar--internal-links",
        attrs: {
          "role": "menu",
          "aria-label": _vm.sidebarData.title
        }
      }, _vm._l(_vm.flattenedDropdownItems, function (sidebarLink, index) {
        return _c('li', {
          key: "sidebar-collapse-link-".concat(index),
          attrs: {
            "role": "menuitem"
          }
        }, [_c('ms-link', {
          attrs: {
            "href": "#",
            "exact-active-class": "is-active"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              _vm.emitInternalLinks(sidebarLink, _vm.compileInternalLinks(sidebarLink));
            }
          }
        }, [_c('ms-header-sidebar-link-label', {
          attrs: {
            "label": sidebarLink.title,
            "badge-label": sidebarLink.badgeLabel,
            "is-new": sidebarLink.new
          }
        }), _c('fa', {
          attrs: {
            "icon": ['fal', 'angle-right']
          }
        })], 1)], 1);
      }), 0)] : _vm._e()], 2), _c('collapse-transition', [_vm.sidebarData.child ? [_c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isCollapsed || _vm.alwaysOpen,
          expression: "isCollapsed || alwaysOpen"
        }],
        staticClass: "header-sidebar--internal-links",
        class: {
          'always-open-menu': _vm.alwaysOpen
        },
        attrs: {
          "role": "menu",
          "aria-label": _vm.sidebarData.title
        }
      }, _vm._l(_vm.sidebarData.child, function (sidebarLink, index) {
        return _c('li', {
          key: "sidebar-collapse-link-".concat(index),
          attrs: {
            "role": "menuitem"
          }
        }, [_c('ms-link', {
          attrs: {
            "href": sidebarLink.href,
            "to": sidebarLink.to,
            "target": sidebarLink.target,
            "exact-active-class": "is-active"
          },
          nativeOn: {
            "click": function click($event) {
              return _vm.closeSidebar($event);
            }
          }
        }, [_c('ms-header-sidebar-link-label', {
          attrs: {
            "label": sidebarLink.title,
            "badge-label": sidebarLink.badgeLabel,
            "is-new": sidebarLink.new
          }
        }, [sidebarLink.icon && sidebarLink.icon.name ? _c('ms-icon', {
          staticClass: "alert-icon",
          class: "variant-".concat(sidebarLink.icon.variant || 'default'),
          attrs: {
            "icon": ['fas', sidebarLink.icon.name]
          }
        }) : _vm._e()], 1)], 1)], 1);
      }), 0)] : _vm._e()], 2)], 2);
    };
    var MsHeaderSidebarLinkvue_type_template_id_6b27c01e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebarLink.vue?vue&type=template&id=6b27c01e&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderSidebarLink.vue?vue&type=script&lang=js&
    var _excluded = ["groupedData"];
    function _objectWithoutProperties(source, excluded) {
      if (source == null) return {};
      var target = _objectWithoutPropertiesLoose(source, excluded);
      var key, i;
      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
          target[key] = source[key];
        }
      }
      return target;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;
      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }
      return target;
    }

    /* harmony default export */
    var MsHeaderSidebarLinkvue_type_script_lang_js_ = {
      name: 'MsHeaderSidebarLink',
      components: {
        CollapseTransition: CollapseTransition
      },
      props: {
        sidebarData: {
          type: Object,
          required: true
        },
        alwaysOpen: {
          type: Boolean,
          default: false
        }
      },
      data: function data() {
        return {
          toggleLinks: false,
          isCollapsed: this.sidebarData.isCollapsed
        };
      },
      computed: {
        isSidebarData: function isSidebarData() {
          if (!this.sidebarData.dropdown_items || this.sidebarData && this.sidebarData.dropdown_items.length === 0) {
            return false;
          }
          return true;
        },
        isChildData: function isChildData() {
          if (this.sidebarData.child) {
            return true;
          }
          return false;
        },
        flattenedDropdownItems: function flattenedDropdownItems() {
          // Process the dropdown lists to move 'groupedData' that has a title to a top level item
          if (this.isSidebarData) {
            var flattenedArray = [];
            this.sidebarData.dropdown_items.forEach(function (list) {
              if (!list.groupedData) {
                flattenedArray.push(list);
              } else {
                var groupedData = list.groupedData,
                  items = _objectWithoutProperties(list, _excluded);
                var curPos = flattenedArray.length;
                // Push item without any groupedData into list
                flattenedArray.push(items);
                groupedData.forEach(function (groupList) {
                  // If no title, add to the latest item to the base array, then keep repeating on the remaining sets
                  if (!groupList.title) {
                    flattenedArray[curPos].groupedData = flattenedArray[curPos].groupedData || [];
                    flattenedArray[curPos].groupedData.push(groupList);
                  } else {
                    // Start a new group, and update the index for the items that do not have a title to end up in the new group on the next pass
                    flattenedArray.push(groupList);
                    curPos += 1;
                  }
                });
              }
            });
            return flattenedArray;
          }
          return this.sidebarData.dropdown_items;
        }
      },
      methods: {
        toggleIfData: function toggleIfData(e, value) {
          e.sidebarData = value;
          this.isCollapsed = !this.isCollapsed;
          this.$emit('sidebar-link-clicked', e);
        },
        emitInternalLinks: function emitInternalLinks(e, value) {
          this.$emit('internalLinks', value);
          this.$emit('sidebar-link-clicked', e);
        },
        closeSidebar: function closeSidebar(e, value) {
          e.sidebarData = value;
          this.$emit('closeSidebar');
          this.$emit('sidebar-link-clicked', e);
        },
        compileInternalLinks: function compileInternalLinks(value) {
          return {
            "default": value.data,
            "groups": value.groupedData || null
          };
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebarLink.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderSidebarLinkvue_type_script_lang_js_ = MsHeaderSidebarLinkvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebarLink.vue

    /* normalize component */

    var MsHeaderSidebarLink_component = normalizeComponent(MsHeader_MsHeaderSidebarLinkvue_type_script_lang_js_, MsHeaderSidebarLinkvue_type_template_id_6b27c01e_render, MsHeaderSidebarLinkvue_type_template_id_6b27c01e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeaderSidebarLink = MsHeaderSidebarLink_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderSidebarLinkLabel.vue?vue&type=template&id=2ec38d3e&
    var MsHeaderSidebarLinkLabelvue_type_template_id_2ec38d3e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "header-sidebar__label"
      }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _vm._t("default"), _vm.badgeLabel && !_vm.toggle && !_vm.isNew ? _c('ms-badge', [_vm._v("\n    " + _vm._s(_vm.badgeLabel) + "\n  ")]) : _vm._e(), _vm.isNew ? _c('div', {
        staticClass: "link-badge"
      }, [_vm._v(_vm._s(_vm.badgeLabel))]) : _vm._e()], 2);
    };
    var MsHeaderSidebarLinkLabelvue_type_template_id_2ec38d3e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebarLinkLabel.vue?vue&type=template&id=2ec38d3e&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeader/MsHeaderSidebarLinkLabel.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeaderSidebarLinkLabelvue_type_script_lang_js_ = {
      name: 'MsHeaderSidebarLinkLabel',
      props: {
        label: {
          type: String,
          default: null,
          required: true
        },
        badgeLabel: {
          type: String,
          default: null
        },
        toggle: {
          type: Boolean,
          default: false
        },
        isNew: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebarLinkLabel.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeader_MsHeaderSidebarLinkLabelvue_type_script_lang_js_ = MsHeaderSidebarLinkLabelvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeader/MsHeaderSidebarLinkLabel.vue

    /* normalize component */

    var MsHeaderSidebarLinkLabel_component = normalizeComponent(MsHeader_MsHeaderSidebarLinkLabelvue_type_script_lang_js_, MsHeaderSidebarLinkLabelvue_type_template_id_2ec38d3e_render, MsHeaderSidebarLinkLabelvue_type_template_id_2ec38d3e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeaderSidebarLinkLabel = MsHeaderSidebarLinkLabel_component.exports;
    // CONCATENATED MODULE: ./src/components/MsHeader/index.js

    var MsHeader_components = {
      MsHeader: MsHeader,
      MsHeaderLanguageBar: MsHeaderLanguageBar,
      MsHeaderNav: MsHeaderNav,
      MsHeaderNavLink: MsHeaderNavLink,
      MsHeaderNavAuth: MsHeaderNavAuth,
      MsHeaderDropdown: MsHeaderDropdown,
      MsHeaderSidebar: MsHeaderSidebar,
      MsHeaderSidebarLink: MsHeaderSidebarLink,
      MsHeaderSidebarLinkLabel: MsHeaderSidebarLinkLabel,
      MsLink: MsLink
    };
    MsHeader.install = function (Vue) {
      Object.values(MsHeader_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsHeader = MsHeader;
    // CONCATENATED MODULE: ./src/components/MsHeading/index.js

    MsHeading.install = function (Vue) {
      return Vue.component(MsHeading.name, MsHeading);
    };
    /* harmony default export */
    var components_MsHeading = MsHeading;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeroMasthead/MsHeroMasthead.vue?vue&type=template&id=657a2a08&
    var MsHeroMastheadvue_type_template_id_657a2a08_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "hero-masthead"
      }, [_c('div', {
        staticClass: "hero-masthead__content-wrapper"
      }, [_vm._t("section-header"), _vm._t("default")], 2), _c('div', {
        staticClass: "hero-masthead__image-wrapper"
      }, [_c('ms-image', {
        staticClass: "hero-masthead__image",
        attrs: {
          "src": _vm.imageUrl,
          "alt": _vm.imageAlt,
          "width": "447",
          "height": "284"
        }
      })], 1)]);
    };
    var MsHeroMastheadvue_type_template_id_657a2a08_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsHeroMasthead/MsHeroMasthead.vue?vue&type=template&id=657a2a08&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsHeroMasthead/MsHeroMasthead.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeroMastheadvue_type_script_lang_js_ = {
      name: 'MsHeroMasthead',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Hero Masthead'
      },
      props: {
        /**
         * Sets image url
         */
        imageUrl: {
          type: String,
          default: 'https://assets.cdn-moneysmart.com/assets/cargo/images/d4lv2bx9czxqsfaurrh8.png'
        },
        /**
         * Sets image alt
         */
        imageAlt: {
          type: String,
          default: 'background image'
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsHeroMasthead/MsHeroMasthead.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsHeroMasthead_MsHeroMastheadvue_type_script_lang_js_ = MsHeroMastheadvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsHeroMasthead/MsHeroMasthead.vue

    /* normalize component */

    var MsHeroMasthead_component = normalizeComponent(MsHeroMasthead_MsHeroMastheadvue_type_script_lang_js_, MsHeroMastheadvue_type_template_id_657a2a08_render, MsHeroMastheadvue_type_template_id_657a2a08_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsHeroMasthead = MsHeroMasthead_component.exports;
    // CONCATENATED MODULE: ./src/components/MsHeroMasthead/index.js

    var MsHeroMasthead_components = {
      MsHeroMasthead: MsHeroMasthead
    };
    MsHeroMasthead.install = function (Vue) {
      Object.values(MsHeroMasthead_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsHeroMasthead = MsHeroMasthead;
    // CONCATENATED MODULE: ./src/components/MsIcon/index.js

    MsIcon.install = function (Vue) {
      return Vue.component(MsIcon.name, MsIcon);
    };
    /* harmony default export */
    var components_MsIcon = MsIcon;
    // CONCATENATED MODULE: ./src/components/MsImage/index.js

    MsImage.install = function (Vue) {
      return Vue.component(MsImage.name, MsImage);
    };
    /* harmony default export */
    var components_MsImage = MsImage;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCard.vue?vue&type=template&id=e4adbbf2&
    var MsInfoCardvue_type_template_id_e4adbbf2_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        ref: "infoCard",
        staticClass: "info-card",
        class: {
          'info-card--expandable': Boolean(_vm.expandable),
          'info-card--progress-bar': Boolean(_vm.progressBar),
          'info-card--inactive': Boolean(_vm.inactive),
          'is-loading': Boolean(_vm.isLoading)
        }
      }, [_vm.isLoading ? _c('ms-info-card-loading', {
        attrs: {
          "progress-bar": _vm.progressBar
        }
      }) : _vm._t("default")], 2);
    };
    var MsInfoCardvue_type_template_id_e4adbbf2_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCard.vue?vue&type=template&id=e4adbbf2&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardLoading.vue?vue&type=template&id=24656ecd&
    var MsInfoCardLoadingvue_type_template_id_24656ecd_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__wrapper"
      }, [_c('div', {
        staticClass: "info-card__content"
      }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm.progressBar ? _c('div', {
        staticClass: "info-card__progress-bar"
      }, [_vm._m(3)]) : _vm._e()]), _vm._m(4), _vm._m(5)]);
    };
    var MsInfoCardLoadingvue_type_template_id_24656ecd_staticRenderFns = [function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__title"
      }, [_c('div', {
        staticClass: "placeholder"
      })]);
    }, function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__description"
      }, [_c('div', {
        staticClass: "placeholder"
      })]);
    }, function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__list"
      }, [_c('div', {
        staticClass: "info-card__list-item"
      }, [_c('div', {
        staticClass: "placeholder"
      })]), _c('div', {
        staticClass: "info-card__list-item"
      }, [_c('div', {
        staticClass: "placeholder"
      })])]);
    }, function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "progress-bar"
      }, [_c('div', {
        staticClass: "progress-bar__indicator"
      }, [_c('div', {
        staticClass: "placeholder"
      })]), _c('div', {
        staticClass: "progress-bar__sub-text"
      }, [_c('div', {
        staticClass: "placeholder"
      })])]);
    }, function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__image"
      }, [_c('div', {
        staticClass: "placeholder"
      })]);
    }, function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__cta"
      }, [_c('div', {
        staticClass: "placeholder"
      })]);
    }];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardLoading.vue?vue&type=template&id=24656ecd&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardLoading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardLoadingvue_type_script_lang_js_ = {
      name: 'MsInfoCardLoading',
      props: {
        /**
         * If info card has progress bar
         */
        progressBar: {
          type: Boolean,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardLoading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardLoadingvue_type_script_lang_js_ = MsInfoCardLoadingvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsInfoCard/MsInfoCardLoading.vue?vue&type=style&index=0&id=24656ecd&prod&lang=scss&
    var MsInfoCardLoadingvue_type_style_index_0_id_24656ecd_prod_lang_scss_ = __webpack_require__("a419");

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardLoading.vue

    /* normalize component */

    var MsInfoCardLoading_component = normalizeComponent(MsInfoCard_MsInfoCardLoadingvue_type_script_lang_js_, MsInfoCardLoadingvue_type_template_id_24656ecd_render, MsInfoCardLoadingvue_type_template_id_24656ecd_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardLoading = MsInfoCardLoading_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCard.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsInfoCardvue_type_script_lang_js_ = {
      name: 'MsInfoCard',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Info Card'
      },
      components: {
        MsInfoCardLoading: MsInfoCardLoading
      },
      props: {
        /**
         * If info card is expandable
         */
        expandable: {
          type: Boolean,
          default: null
        },
        /**
         * Set expanded state for info card
         */
        expanded: {
          type: Boolean,
          default: null
        },
        /**
         * If info card has progress bar
         */
        progressBar: {
          type: Boolean,
          default: null
        },
        /**
         * If info card is inactive
         */
        inactive: {
          type: Boolean,
          default: null
        },
        /**
         * If info card is loading
         */
        isLoading: {
          type: Boolean,
          default: null
        }
      },
      mounted: function mounted() {
        var infoCard = this.$refs.infoCard;
        if (this.progressBar) {
          var progressBar = infoCard.querySelector('.info-card__progress-bar');
          if (progressBar) {
            this.$refs.infoCard.style.paddingBottom = "".concat(progressBar.clientHeight + 16, "px");
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardvue_type_script_lang_js_ = MsInfoCardvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCard.vue

    /* normalize component */

    var MsInfoCard_component = normalizeComponent(MsInfoCard_MsInfoCardvue_type_script_lang_js_, MsInfoCardvue_type_template_id_e4adbbf2_render, MsInfoCardvue_type_template_id_e4adbbf2_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCard = MsInfoCard_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardContent.vue?vue&type=template&id=63c9a542&
    var MsInfoCardContentvue_type_template_id_63c9a542_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__content"
      }, [_vm._t("default")], 2);
    };
    var MsInfoCardContentvue_type_template_id_63c9a542_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardContent.vue?vue&type=template&id=63c9a542&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardContentvue_type_script_lang_js_ = {
      name: 'MsInfoCardContent'
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardContentvue_type_script_lang_js_ = MsInfoCardContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardContent.vue

    /* normalize component */

    var MsInfoCardContent_component = normalizeComponent(MsInfoCard_MsInfoCardContentvue_type_script_lang_js_, MsInfoCardContentvue_type_template_id_63c9a542_render, MsInfoCardContentvue_type_template_id_63c9a542_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardContent = MsInfoCardContent_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardCta.vue?vue&type=template&id=6573dba4&
    var MsInfoCardCtavue_type_template_id_6573dba4_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__cta",
        class: {
          'is-expanded': _vm.showDetails
        }
      }, [_vm._t("default"), _vm.expandable ? _c('ms-button', {
        staticClass: "info-card__toggle",
        attrs: {
          "icon": ['far', _vm.showDetailsBtn.icon],
          "use": "secondary",
          "position": "end"
        },
        on: {
          "click": _vm.toggleMoreDetails
        }
      }, [_vm._v("\n    " + _vm._s(_vm.showDetails ? _vm.toggleHideLabel : _vm.toggleShowLabel) + "\n  ")]) : _vm._e()], 2);
    };
    var MsInfoCardCtavue_type_template_id_6573dba4_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardCta.vue?vue&type=template&id=6573dba4&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardCtavue_type_script_lang_js_ = {
      name: 'MsInfoCardCta',
      props: {
        toggleShowLabel: {
          type: String,
          required: false,
          default: 'More Details'
        },
        toggleHideLabel: {
          type: String,
          required: false,
          default: 'Less Details'
        },
        expandable: {
          type: Boolean,
          default: false
        }
      },
      data: function data() {
        return {
          showDetails: false,
          showDetailsBtn: {
            icon: 'chevron-right'
          }
        };
      },
      mounted: function mounted() {
        if (this.$parent.expandable && this.$parent.expanded) {
          this.toggleMoreDetails();
        }
      },
      methods: {
        toggleMoreDetails: function toggleMoreDetails() {
          this.showDetails = !this.showDetails;
          this.showDetailsBtn = {
            icon: this.showDetails ? 'chevron-up' : 'chevron-right'
          };
          if (this.showDetails) {
            this.$emit('expanded');
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardCtavue_type_script_lang_js_ = MsInfoCardCtavue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardCta.vue

    /* normalize component */

    var MsInfoCardCta_component = normalizeComponent(MsInfoCard_MsInfoCardCtavue_type_script_lang_js_, MsInfoCardCtavue_type_template_id_6573dba4_render, MsInfoCardCtavue_type_template_id_6573dba4_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardCta = MsInfoCardCta_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardDescription.vue?vue&type=template&id=79f07e1c&
    var MsInfoCardDescriptionvue_type_template_id_79f07e1c_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__description"
      }, [_vm._t("default")], 2);
    };
    var MsInfoCardDescriptionvue_type_template_id_79f07e1c_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardDescription.vue?vue&type=template&id=79f07e1c&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardDescription.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardDescriptionvue_type_script_lang_js_ = {
      name: 'MsInfoCardDescription'
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardDescription.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardDescriptionvue_type_script_lang_js_ = MsInfoCardDescriptionvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardDescription.vue

    /* normalize component */

    var MsInfoCardDescription_component = normalizeComponent(MsInfoCard_MsInfoCardDescriptionvue_type_script_lang_js_, MsInfoCardDescriptionvue_type_template_id_79f07e1c_render, MsInfoCardDescriptionvue_type_template_id_79f07e1c_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardDescription = MsInfoCardDescription_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardExpandableContent.vue?vue&type=template&id=8cb085ec&
    var MsInfoCardExpandableContentvue_type_template_id_8cb085ec_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__expandable-content"
      }, [_vm._t("default")], 2);
    };
    var MsInfoCardExpandableContentvue_type_template_id_8cb085ec_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardExpandableContent.vue?vue&type=template&id=8cb085ec&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardExpandableContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardExpandableContentvue_type_script_lang_js_ = {
      name: 'MsInfoCardExpandableContent'
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardExpandableContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardExpandableContentvue_type_script_lang_js_ = MsInfoCardExpandableContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardExpandableContent.vue

    /* normalize component */

    var MsInfoCardExpandableContent_component = normalizeComponent(MsInfoCard_MsInfoCardExpandableContentvue_type_script_lang_js_, MsInfoCardExpandableContentvue_type_template_id_8cb085ec_render, MsInfoCardExpandableContentvue_type_template_id_8cb085ec_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardExpandableContent = MsInfoCardExpandableContent_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardImage.vue?vue&type=template&id=27632da7&
    var MsInfoCardImagevue_type_template_id_27632da7_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__image"
      }, [_c('img', {
        attrs: {
          "src": _vm.url,
          "alt": _vm.altText
        }
      })]);
    };
    var MsInfoCardImagevue_type_template_id_27632da7_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardImage.vue?vue&type=template&id=27632da7&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardImage.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardImagevue_type_script_lang_js_ = {
      name: 'MsInfoCardImage',
      props: {
        url: {
          type: String,
          required: true,
          default: null
        },
        altText: {
          type: String,
          required: false,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardImage.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardImagevue_type_script_lang_js_ = MsInfoCardImagevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardImage.vue

    /* normalize component */

    var MsInfoCardImage_component = normalizeComponent(MsInfoCard_MsInfoCardImagevue_type_script_lang_js_, MsInfoCardImagevue_type_template_id_27632da7_render, MsInfoCardImagevue_type_template_id_27632da7_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardImage = MsInfoCardImage_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardList.vue?vue&type=template&id=8469d354&
    var MsInfoCardListvue_type_template_id_8469d354_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('dl', {
        staticClass: "info-card__list"
      }, [_vm._t("default")], 2);
    };
    var MsInfoCardListvue_type_template_id_8469d354_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardList.vue?vue&type=template&id=8469d354&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardList.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardListvue_type_script_lang_js_ = {
      name: 'MsInfoCardList'
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardList.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardListvue_type_script_lang_js_ = MsInfoCardListvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardList.vue

    /* normalize component */

    var MsInfoCardList_component = normalizeComponent(MsInfoCard_MsInfoCardListvue_type_script_lang_js_, MsInfoCardListvue_type_template_id_8469d354_render, MsInfoCardListvue_type_template_id_8469d354_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardList = MsInfoCardList_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardListItem.vue?vue&type=template&id=7ba0f68d&
    function MsInfoCardListItemvue_type_template_id_7ba0f68d_typeof(obj) {
      "@babel/helpers - typeof";

      return MsInfoCardListItemvue_type_template_id_7ba0f68d_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsInfoCardListItemvue_type_template_id_7ba0f68d_typeof(obj);
    }
    function MsInfoCardListItemvue_type_template_id_7ba0f68d_defineProperty(obj, key, value) {
      key = MsInfoCardListItemvue_type_template_id_7ba0f68d_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsInfoCardListItemvue_type_template_id_7ba0f68d_toPropertyKey(arg) {
      var key = MsInfoCardListItemvue_type_template_id_7ba0f68d_toPrimitive(arg, "string");
      return MsInfoCardListItemvue_type_template_id_7ba0f68d_typeof(key) === "symbol" ? key : String(key);
    }
    function MsInfoCardListItemvue_type_template_id_7ba0f68d_toPrimitive(input, hint) {
      if (MsInfoCardListItemvue_type_template_id_7ba0f68d_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsInfoCardListItemvue_type_template_id_7ba0f68d_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsInfoCardListItemvue_type_template_id_7ba0f68d_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('dt', {
        staticClass: "info-card__list-item"
      }, [!!_vm.label ? _c('div', {
        staticClass: "info-card__list-item-label"
      }, [_vm._v(_vm._s(_vm.label) + ":")]) : _vm._e(), _c('div', {
        staticClass: "info-card__list-item-text",
        class: MsInfoCardListItemvue_type_template_id_7ba0f68d_defineProperty({}, 'info-card__list-item--red', _vm.red)
      }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])]);
    };
    var MsInfoCardListItemvue_type_template_id_7ba0f68d_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardListItem.vue?vue&type=template&id=7ba0f68d&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardListItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardListItemvue_type_script_lang_js_ = {
      name: 'MsInfoCardListItem',
      props: {
        red: {
          type: Boolean,
          default: false
        },
        label: {
          type: String,
          required: false
        },
        text: {
          type: String,
          required: true
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardListItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardListItemvue_type_script_lang_js_ = MsInfoCardListItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardListItem.vue

    /* normalize component */

    var MsInfoCardListItem_component = normalizeComponent(MsInfoCard_MsInfoCardListItemvue_type_script_lang_js_, MsInfoCardListItemvue_type_template_id_7ba0f68d_render, MsInfoCardListItemvue_type_template_id_7ba0f68d_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardListItem = MsInfoCardListItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardProgressBar.vue?vue&type=template&id=5ec11c17&
    var MsInfoCardProgressBarvue_type_template_id_5ec11c17_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__progress-bar"
      }, [_c('ms-progress-bar', {
        attrs: {
          "theme": _vm.theme,
          "progress": _vm.progress,
          "max-value": _vm.maxValue
        }
      }, [_vm._t("default")], 2)], 1);
    };
    var MsInfoCardProgressBarvue_type_template_id_5ec11c17_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardProgressBar.vue?vue&type=template&id=5ec11c17&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProgressBar/MsProgressBar.vue?vue&type=template&id=7bbe8afd&
    var MsProgressBarvue_type_template_id_7bbe8afd_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "progress-bar",
        class: {
          'progress-bar--bordered': _vm.bordered,
          'progress-bar--red': _vm.theme === 'red',
          'progress-bar--negative': _vm.negativeMargin
        }
      }, [_vm.label ? _c('p', {
        staticClass: "progress-bar__label"
      }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _c('progress', {
        staticClass: "progress-bar__indicator",
        attrs: {
          "max": _vm.maxValue
        },
        domProps: {
          "value": _vm.progress
        }
      }), _c('p', {
        staticClass: "progress-bar__sub-text"
      }, [_vm._t("default")], 2)]);
    };
    var MsProgressBarvue_type_template_id_7bbe8afd_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProgressBar/MsProgressBar.vue?vue&type=template&id=7bbe8afd&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProgressBar/MsProgressBar.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProgressBarvue_type_script_lang_js_ = {
      name: 'MsProgressBar',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Progress Bar'
      },
      props: {
        /**
         * Applies variants
         * @values red
        */
        theme: {
          type: String,
          required: false
        },
        /**
         * Applies border
        */
        bordered: {
          type: Boolean,
          default: false
        },
        /**
         * Adds negative margin on mobile to achieve full width look
        */
        negativeMargin: {
          type: Boolean,
          default: false
        },
        /**
         * Progress bar label
        */
        label: {
          type: String,
          required: false
        },
        /**
         * Set max of the progress indicator
        */
        maxValue: {
          type: Number,
          default: 100
        },
        /**
         * Progress indicator (preferably percentage number)
        */
        progress: {
          type: Number,
          default: 0
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsProgressBar/MsProgressBar.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProgressBar_MsProgressBarvue_type_script_lang_js_ = MsProgressBarvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProgressBar/MsProgressBar.vue

    /* normalize component */

    var MsProgressBar_component = normalizeComponent(MsProgressBar_MsProgressBarvue_type_script_lang_js_, MsProgressBarvue_type_template_id_7bbe8afd_render, MsProgressBarvue_type_template_id_7bbe8afd_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProgressBar = MsProgressBar_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardProgressBar.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsInfoCardProgressBarvue_type_script_lang_js_ = {
      name: 'MsInfoCardProgressBar',
      components: {
        MsProgressBar: MsProgressBar
      },
      props: {
        theme: {
          type: String,
          required: false
        },
        progress: {
          type: Number,
          default: 0
        },
        maxValue: {
          type: Number,
          default: 100
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardProgressBar.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardProgressBarvue_type_script_lang_js_ = MsInfoCardProgressBarvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardProgressBar.vue

    /* normalize component */

    var MsInfoCardProgressBar_component = normalizeComponent(MsInfoCard_MsInfoCardProgressBarvue_type_script_lang_js_, MsInfoCardProgressBarvue_type_template_id_5ec11c17_render, MsInfoCardProgressBarvue_type_template_id_5ec11c17_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardProgressBar = MsInfoCardProgressBar_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardText.vue?vue&type=template&id=63002ef1&
    var MsInfoCardTextvue_type_template_id_63002ef1_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__text"
      }, [_vm._t("default")], 2);
    };
    var MsInfoCardTextvue_type_template_id_63002ef1_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardText.vue?vue&type=template&id=63002ef1&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardTextvue_type_script_lang_js_ = {
      name: 'MsInfoCardText'
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardTextvue_type_script_lang_js_ = MsInfoCardTextvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardText.vue

    /* normalize component */

    var MsInfoCardText_component = normalizeComponent(MsInfoCard_MsInfoCardTextvue_type_script_lang_js_, MsInfoCardTextvue_type_template_id_63002ef1_render, MsInfoCardTextvue_type_template_id_63002ef1_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardText = MsInfoCardText_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardTitle.vue?vue&type=template&id=23210e40&
    var MsInfoCardTitlevue_type_template_id_23210e40_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "info-card__title"
      }, [_vm._t("default")], 2);
    };
    var MsInfoCardTitlevue_type_template_id_23210e40_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardTitle.vue?vue&type=template&id=23210e40&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInfoCard/MsInfoCardTitle.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCardTitlevue_type_script_lang_js_ = {
      name: 'MsInfoCardTitle'
    };
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardTitle.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInfoCard_MsInfoCardTitlevue_type_script_lang_js_ = MsInfoCardTitlevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/MsInfoCardTitle.vue

    /* normalize component */

    var MsInfoCardTitle_component = normalizeComponent(MsInfoCard_MsInfoCardTitlevue_type_script_lang_js_, MsInfoCardTitlevue_type_template_id_23210e40_render, MsInfoCardTitlevue_type_template_id_23210e40_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInfoCardTitle = MsInfoCardTitle_component.exports;
    // CONCATENATED MODULE: ./src/components/MsInfoCard/index.js

    var MsInfoCard_components = {
      MsInfoCard: MsInfoCard,
      MsInfoCardContent: MsInfoCardContent,
      MsInfoCardCta: MsInfoCardCta,
      MsInfoCardDescription: MsInfoCardDescription,
      MsInfoCardExpandableContent: MsInfoCardExpandableContent,
      MsInfoCardImage: MsInfoCardImage,
      MsInfoCardList: MsInfoCardList,
      MsInfoCardListItem: MsInfoCardListItem,
      MsInfoCardLoading: MsInfoCardLoading,
      MsInfoCardProgressBar: MsInfoCardProgressBar,
      MsInfoCardText: MsInfoCardText,
      MsInfoCardTitle: MsInfoCardTitle
    };
    MsInfoCard.install = function (Vue) {
      Object.values(MsInfoCard_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsInfoCard = MsInfoCard;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInput/MsInput.vue?vue&type=template&id=f4da7a46&
    var MsInputvue_type_template_id_f4da7a46_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "input-field",
        class: {
          'input-field--filled': _vm.isValue,
          'input-field--active': _vm.isActive,
          'input-field--error': _vm.isError,
          'input-field--loading': _vm.isLoading,
          'input-field--icon': _vm.icon !== null,
          'input-field--prefix': _vm.prefix !== null,
          'input-field--mask': _vm.mask
        }
      }, [_c('div', {
        staticClass: "input-field__align"
      }, [_vm.mask ? [_c('Cleave', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": _vm.type,
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "options": _vm.maskOptions,
          "aria-describedby": "help_text_".concat(_vm.id),
          "raw": !_vm.maskOptions.date
        },
        model: {
          value: _vm.maskedValue,
          callback: function callback($$v) {
            _vm.maskedValue = $$v;
          },
          expression: "maskedValue"
        }
      }, 'Cleave', _vm.$attrs, false))] : [_c('input', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": _vm.type,
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "aria-describedby": "help_text_".concat(_vm.id)
        },
        domProps: {
          "value": _vm.value
        },
        on: {
          "input": function input($event) {
            return _vm.$emit('input', $event.target.value);
          }
        }
      }, 'input', _vm.$attrs, false))], _c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v(_vm._s(_vm.label))]), _vm.icon ? _c('fa', {
        staticClass: "input-field__icon",
        attrs: {
          "icon": _vm.icon
        }
      }) : _vm._e(), _vm.prefix ? _c('span', {
        ref: "prefixLabel",
        staticClass: "input-field__prefix"
      }, [_vm._v(_vm._s(_vm.prefix))]) : _vm._e(), _vm.isLoading ? _c('fa', {
        staticClass: "loading-spinner",
        attrs: {
          "icon": ['fal', 'spinner-third'],
          "spin": ""
        }
      }) : _vm._e(), _c('div', {
        staticClass: "input-field__border"
      })], 2), _vm.helpText ? _c('span', {
        staticClass: "input-field__notice",
        class: {
          'input-field__notice--description': !_vm.isError,
          'input-field__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v(_vm._s(_vm.helpText))]) : _vm._e()]);
    };
    var MsInputvue_type_template_id_f4da7a46_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInput/MsInput.vue?vue&type=template&id=f4da7a46&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInput/MsInput.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsInputvue_type_script_lang_js_ = {
      name: 'MsInput',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Form Fields/Input'
      },
      components: {
        Cleave: function Cleave() {
          return __webpack_require__.e( /* import() */0).then(__webpack_require__.t.bind(null, "2083", 7));
        }
      },
      mixins: [FormFields, FormInput],
      inheritAttrs: false,
      props: {
        /**
         * Check if component is still loading
        */
        isLoading: {
          type: Boolean,
          default: false
        },
        /**
         * Input icon
        */
        icon: {
          type: Array,
          default: null
        },
        /**
         * Prefix of input, if any
        */
        prefix: {
          type: String,
          default: null
        },
        /**
         * Sets masking of input
        */
        mask: {
          type: Boolean,
          default: false
        },
        /**
         * Sets type of masking added
        */
        maskOptions: {
          type: Object,
          default: function _default() {
            return {
              numeral: true
            };
          }
        }
      },
      data: function data() {
        var maskedValue = this.value || null;
        return {
          maskedValue: maskedValue
        };
      },
      computed: {
        isValue: function isValue() {
          if (this.value === null || this.value === undefined) {
            return false;
          }
          return this.value !== '' && this.value.toString().length > 0;
        }
      },
      watch: {
        // For v-model support of Cleave component
        value: function value(val) {
          this.maskedValue = val;
        },
        maskedValue: function maskedValue(newValue) {
          this.$emit('input', newValue);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInput/MsInput.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInput_MsInputvue_type_script_lang_js_ = MsInputvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInput/MsInput.vue

    /* normalize component */

    var MsInput_component = normalizeComponent(MsInput_MsInputvue_type_script_lang_js_, MsInputvue_type_template_id_f4da7a46_render, MsInputvue_type_template_id_f4da7a46_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInput = MsInput_component.exports;
    // CONCATENATED MODULE: ./src/components/MsInput/index.js

    MsInput.install = function (Vue) {
      return Vue.component(MsInput.name, MsInput);
    };
    /* harmony default export */
    var components_MsInput = MsInput;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsConvoInput/MsConvoInput.vue?vue&type=template&id=321fdf59&
    var MsConvoInputvue_type_template_id_321fdf59_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "convo-input",
        class: {
          'convo-input--active': _vm.isActive,
          'convo-input--error': _vm.isError,
          'convo-input--loading': _vm.isLoading,
          'convo-input--icon': _vm.icon !== null,
          'convo-input--prefix': _vm.prefix !== null,
          'convo-input--mask': _vm.mask
        }
      }, [_c('div', {
        staticClass: "label_wrapper"
      }, [_c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
        staticClass: "required-field"
      }, [_vm._v("*")]) : _vm._e()]), _vm._t("tooltip")], 2), _vm.helpText ? _c('p', {
        staticClass: "convo-input__notice",
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]) : _vm._e(), _c('div', {
        staticClass: "convo-input__align"
      }, [_vm.mask ? _c('Cleave', _vm._b({
        attrs: {
          "options": _vm.maskOptions,
          "raw": !_vm.maskOptions.date
        },
        model: {
          value: _vm.maskedValue,
          callback: function callback($$v) {
            _vm.maskedValue = $$v;
          },
          expression: "maskedValue"
        }
      }, 'Cleave', _vm.inputAttributes, false)) : _c('input', _vm._b({
        domProps: {
          "value": _vm.value
        },
        on: {
          "input": function input($event) {
            return _vm.$emit('input', $event.target.value);
          }
        }
      }, 'input', _vm.inputAttributes, false)), _vm.icon ? _c('fa', {
        staticClass: "convo-input__icon",
        attrs: {
          "icon": _vm.icon
        }
      }) : _vm._e(), _vm.prefix ? _c('span', {
        ref: "prefixLabel",
        staticClass: "convo-input__prefix"
      }, [_vm._v(_vm._s(_vm.prefix))]) : _vm._e(), _vm.isLoading ? _c('fa', {
        staticClass: "loading-spinner",
        attrs: {
          "icon": ['fal', 'spinner-third'],
          "spin": ""
        }
      }) : _vm._e(), _c('div', {
        staticClass: "convo-input__border"
      })], 1), _vm.isError && _vm.errorText ? _c('span', {
        staticClass: "convo-input__notice convo-input__notice--error-text",
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.errorText) + "\n  ")]) : _vm._e()]);
    };
    var MsConvoInputvue_type_template_id_321fdf59_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsConvoInput/MsConvoInput.vue?vue&type=template&id=321fdf59&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsConvoInput/MsConvoInput.vue?vue&type=script&lang=js&
    function MsConvoInputvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsConvoInputvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsConvoInputvue_type_script_lang_js_typeof(obj);
    }
    function MsConvoInputvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsConvoInputvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsConvoInputvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsConvoInputvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsConvoInputvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsConvoInputvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsConvoInputvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsConvoInputvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsConvoInputvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsConvoInputvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsConvoInputvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsConvoInputvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsConvoInputvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }

    /* harmony default export */
    var MsConvoInputvue_type_script_lang_js_ = {
      name: 'MsConvoInput',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Conversational Fields/Input'
      },
      components: {
        Cleave: function Cleave() {
          return __webpack_require__.e( /* import() */0).then(__webpack_require__.t.bind(null, "2083", 7));
        }
      },
      mixins: [FormFields, FormInput],
      inheritAttrs: false,
      props: {
        /**
         * Check if component is still loading
        */
        isLoading: {
          type: Boolean,
          default: false
        },
        /**
         * Input icon
        */
        icon: {
          type: Array,
          default: null
        },
        /**
         * Prefix of input, if any
        */
        prefix: {
          type: String,
          default: null
        },
        /**
         * Sets masking of input
        */
        mask: {
          type: Boolean,
          default: false
        },
        /**
         * Sets type of masking added
        */
        maskOptions: {
          type: Object,
          default: function _default() {
            return {
              numeral: true
            };
          }
        },
        /**
         * Set ARIA attribute and show * star in label
        */
        isRequired: {
          type: Boolean,
          default: false
        },
        /**
         * Placeholder for the input
        */
        placeholder: {
          type: String,
          default: null
        }
      },
      data: function data() {
        var maskedValue = this.value || null;
        return {
          maskedValue: maskedValue
        };
      },
      computed: {
        inputAttributes: function inputAttributes() {
          return MsConvoInputvue_type_script_lang_js_objectSpread(MsConvoInputvue_type_script_lang_js_objectSpread({}, this.$attrs), {}, {
            id: this.id,
            type: this.type,
            name: this.name,
            placeholder: this.placeholder,
            disabled: this.isDisabled,
            'aria-describedby': "help_text_".concat(this.id),
            'aria-required': this.isRequired ? 'true' : false
          });
        }
      },
      watch: {
        // For v-model support of Cleave component
        value: function value(val) {
          this.maskedValue = val;
        },
        maskedValue: function maskedValue(newValue) {
          this.$emit('input', newValue);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsConvoInput/MsConvoInput.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsConvoInput_MsConvoInputvue_type_script_lang_js_ = MsConvoInputvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsConvoInput/MsConvoInput.vue

    /* normalize component */

    var MsConvoInput_component = normalizeComponent(MsConvoInput_MsConvoInputvue_type_script_lang_js_, MsConvoInputvue_type_template_id_321fdf59_render, MsConvoInputvue_type_template_id_321fdf59_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsConvoInput = MsConvoInput_component.exports;
    // CONCATENATED MODULE: ./src/components/MsConvoInput/index.js

    MsConvoInput.install = function (Vue) {
      return Vue.component(MsConvoInput.name, MsConvoInput);
    };
    /* harmony default export */
    var components_MsConvoInput = MsConvoInput;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInputPassword/MsInputPassword.vue?vue&type=template&id=6505974b&
    var MsInputPasswordvue_type_template_id_6505974b_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "input-field input-field--password",
        class: {
          'input-field--filled': _vm.value && _vm.value.length > 0,
          'input-field--active': _vm.isActive,
          'input-field--error': _vm.isError
        },
        attrs: {
          "aria-describedby": "help_text_".concat(_vm.id)
        }
      }, [_c('div', {
        staticClass: "input-field__align"
      }, [_c('input', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": _vm.isRevealed ? 'text' : 'password',
          "name": _vm.name,
          "disabled": _vm.isDisabled
        },
        domProps: {
          "value": _vm.value
        },
        on: {
          "input": _vm.updateValue
        }
      }, 'input', _vm.$attrs, false)), _c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v(_vm._s(_vm.label))]), _vm.isRevealed ? _c('fa', {
        staticClass: "input-field__icon",
        attrs: {
          "icon": ['far', 'eye-slash']
        },
        on: {
          "click": _vm.updateState
        }
      }) : _c('fa', {
        staticClass: "input-field__icon",
        attrs: {
          "icon": ['far', 'eye']
        },
        on: {
          "click": _vm.updateState
        }
      }), _c('div', {
        staticClass: "input-field__border"
      })], 1), _vm.helpText ? _c('span', {
        staticClass: "input-field__notice",
        class: {
          'input-field__notice--description': !_vm.isError,
          'input-field__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]) : _vm._e()]);
    };
    var MsInputPasswordvue_type_template_id_6505974b_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInputPassword/MsInputPassword.vue?vue&type=template&id=6505974b&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInputPassword/MsInputPassword.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsInputPasswordvue_type_script_lang_js_ = {
      name: 'MsInputPassword',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Form Fields/Input Password'
      },
      mixins: [FormFields, FormInput],
      inheritAttrs: false,
      data: function data() {
        return {
          isRevealed: false
        };
      },
      methods: {
        updateState: function updateState() {
          this.isRevealed = !this.isRevealed;
        },
        updateValue: function updateValue(event) {
          /**
           * Emits the updated value on input event
          */
          this.$emit('input', event.target.value);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInputPassword/MsInputPassword.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInputPassword_MsInputPasswordvue_type_script_lang_js_ = MsInputPasswordvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInputPassword/MsInputPassword.vue

    /* normalize component */

    var MsInputPassword_component = normalizeComponent(MsInputPassword_MsInputPasswordvue_type_script_lang_js_, MsInputPasswordvue_type_template_id_6505974b_render, MsInputPasswordvue_type_template_id_6505974b_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInputPassword = MsInputPassword_component.exports;
    // CONCATENATED MODULE: ./src/components/MsInputPassword/index.js

    MsInputPassword.install = function (Vue) {
      return Vue.component(MsInputPassword.name, MsInputPassword);
    };
    /* harmony default export */
    var components_MsInputPassword = MsInputPassword;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInputStepper/MsInputStepper.vue?vue&type=template&id=8574befc&
    var MsInputSteppervue_type_template_id_8574befc_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "input-field input-field--stepper",
        class: {
          'input-field--filled': _vm.value !== undefined,
          'input-field--active': _vm.isActive,
          'input-field--error': _vm.isError,
          'input-field--prefix': _vm.hasPrefix,
          'input-field--suffix': _vm.hasSuffix,
          'input-field--mask': _vm.mask
        }
      }, [_c('div', {
        staticClass: "input-field__wrapper"
      }, [_vm.mask || _vm.hasSuffix ? [_c('Cleave', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": "text",
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "options": _vm.maskOptions,
          "aria-describedby": "help_text_".concat(_vm.id),
          "raw": !_vm.maskOptions.date
        },
        model: {
          value: _vm.maskedValue,
          callback: function callback($$v) {
            _vm.maskedValue = $$v;
          },
          expression: "maskedValue"
        }
      }, 'Cleave', _vm.$attrs, false))] : [_c('input', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": "number",
          "name": _vm.name,
          "disabled": _vm.isDisabled,
          "aria-describedby": "help_text_".concat(_vm.id)
        },
        domProps: {
          "value": _vm.value
        },
        on: {
          "input": _vm.changeInput,
          "change": _vm.changeInput
        }
      }, 'input', _vm.$attrs, false))], _c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v(_vm._s(_vm.label))]), _vm.hasPrefix ? _c('span', {
        staticClass: "input-field__prefix"
      }, [_vm._v(_vm._s(_vm.prefix))]) : _vm._e(), _c('div', {
        staticClass: "input-field--stepper__nav"
      }, [_c('button', {
        staticClass: "input-field--stepper__nav__down",
        class: {
          'input-field--stepper__nav--disabled': !_vm.decrement.active
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.toggle(_vm.decrement);
          }
        }
      }, [_c('fa', {
        staticClass: "text-body-m1",
        attrs: {
          "icon": ['fal', 'minus']
        }
      })], 1), _c('button', {
        staticClass: "input-field--stepper__nav__up",
        class: {
          'input-field--stepper__nav--disabled': !_vm.increment.active
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.toggle(_vm.increment);
          }
        }
      }, [_c('fa', {
        staticClass: "text-body-m1",
        attrs: {
          "icon": ['fal', 'plus']
        }
      })], 1)]), _c('div', {
        staticClass: "input-field__border"
      })], 2), _vm.helpText ? _c('span', {
        staticClass: "input-field__notice",
        class: {
          'input-field__notice--description': !_vm.isError,
          'input-field__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]) : _vm._e()]);
    };
    var MsInputSteppervue_type_template_id_8574befc_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsInputStepper/MsInputStepper.vue?vue&type=template&id=8574befc&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsInputStepper/MsInputStepper.vue?vue&type=script&lang=js&
    function MsInputSteppervue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsInputSteppervue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsInputSteppervue_type_script_lang_js_typeof(obj);
    }
    function MsInputSteppervue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsInputSteppervue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsInputSteppervue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsInputSteppervue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsInputSteppervue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsInputSteppervue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsInputSteppervue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsInputSteppervue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsInputSteppervue_type_script_lang_js_toPrimitive(arg, "string");
      return MsInputSteppervue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsInputSteppervue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsInputSteppervue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsInputSteppervue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsInputSteppervue_type_script_lang_js_propOptions = {
      type: Number,
      required: false
    };
    /* harmony default export */
    var MsInputSteppervue_type_script_lang_js_ = {
      name: 'MsInputStepper',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Form Fields/Input Stepper'
      },
      components: {
        Cleave: function Cleave() {
          return __webpack_require__.e( /* import() */0).then(__webpack_require__.t.bind(null, "2083", 7));
        }
      },
      mixins: [FormFields, FormInput, mixins_StepperButton],
      inheritAttrs: false,
      props: {
        /**
         * The input stepper value
        */
        value: {
          type: [Number, String],
          required: false
        },
        /**
         * Sets minimum value
        */
        minValue: MsInputSteppervue_type_script_lang_js_objectSpread(MsInputSteppervue_type_script_lang_js_objectSpread({}, MsInputSteppervue_type_script_lang_js_propOptions), {}, {
          default: 0
        }),
        /**
         * Sets maximum value
        */
        maxValue: MsInputSteppervue_type_script_lang_js_propOptions,
        /**
         * Sets the interval amount
        */
        step: MsInputSteppervue_type_script_lang_js_propOptions,
        /**
         * Sets the prefix
        */
        prefix: {
          type: String,
          default: null
        },
        /**
         * Sets the suffix
        */
        suffix: {
          type: String,
          default: null
        },
        /**
         * Sets masking of input
        */
        mask: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsInputStepper/MsInputStepper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsInputStepper_MsInputSteppervue_type_script_lang_js_ = MsInputSteppervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsInputStepper/MsInputStepper.vue

    /* normalize component */

    var MsInputStepper_component = normalizeComponent(MsInputStepper_MsInputSteppervue_type_script_lang_js_, MsInputSteppervue_type_template_id_8574befc_render, MsInputSteppervue_type_template_id_8574befc_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsInputStepper = MsInputStepper_component.exports;
    // CONCATENATED MODULE: ./src/components/MsInputStepper/index.js

    MsInputStepper.install = function (Vue) {
      return Vue.component(MsInputStepper.name, MsInputStepper);
    };
    /* harmony default export */
    var components_MsInputStepper = MsInputStepper;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsIntro/MsIntro.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsIntrovue_type_script_lang_js_ = {
      name: 'MsIntro',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Intro'
      },
      functional: true,
      props: {
        /**
         * Sets title
        */
        title: {
          type: String,
          default: null
        },
        /**
         * Sets title tag
        */
        titleTag: {
          type: String,
          default: 'span'
        },
        /**
         * Sets image
        */
        image: {
          type: String,
          default: null
        },
        /**
         * Sets the alt text for the image
        */
        altText: {
          type: String,
          default: null
        },
        /**
         * Sets grey background color
        */
        frosty: {
          type: Boolean,
          default: false
        },
        /**
         * Adds negative margin on mobile to achieve full width look
        */
        negativeMargin: {
          type: Boolean,
          default: false
        },
        /**
         * Applies border
        */
        bordered: {
          type: Boolean,
          default: false
        },
        /**
         * Displays image on the right
        */
        reversed: {
          type: Boolean,
          default: false
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          slots = _ref.slots;
        var title = h(false);
        var titleTag = h(false);
        var description = h(false);
        var content = h(false);
        var image = h(false);
        var imageWrapper = h(false);

        // intro title
        if (props.title) {
          titleTag = h(props.titleTag, [props.title]);
          title = h('div', {
            staticClass: 'intro__title'
          }, [titleTag]);
        }

        // intro image
        if (props.image) {
          image = h(MsImage, a(data, {
            props: {
              src: props.image,
              alt: props.altText
            }
          }));
          imageWrapper = h('div', {
            staticClass: 'intro__image'
          }, [image]);
        }

        // intro description
        if (slots().default) {
          description = h('div', {
            staticClass: 'intro__content'
          }, slots().default);
        }
        if (props.image || slots().default) {
          content = h('div', {
            staticClass: 'intro__wrapper'
          }, [imageWrapper, description]);
        }
        return h('div', {
          staticClass: 'intro',
          class: [{
            'intro--frosty': props.frosty,
            'intro--negative': props.negativeMargin,
            'intro--bordered': props.bordered,
            'intro--reversed': props.reversed
          }]
        }, [title, content]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsIntro/MsIntro.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsIntro_MsIntrovue_type_script_lang_js_ = MsIntrovue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsIntro/MsIntro.vue
    var MsIntro_render, MsIntro_staticRenderFns;

    /* normalize component */

    var MsIntro_component = normalizeComponent(MsIntro_MsIntrovue_type_script_lang_js_, MsIntro_render, MsIntro_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsIntro = MsIntro_component.exports;
    // CONCATENATED MODULE: ./src/components/MsIntro/index.js

    MsIntro.install = function (Vue) {
      return Vue.component(MsIntro.name, MsIntro);
    };
    /* harmony default export */
    var components_MsIntro = MsIntro;
    // CONCATENATED MODULE: ./src/components/MsLink/index.js

    MsLink.install = function (Vue) {
      return Vue.component(MsLink.name, MsLink);
    };
    /* harmony default export */
    var components_MsLink = MsLink;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListGroup/MsListGroup.vue?vue&type=script&lang=js&
    var mainClass = 'list-group';
    /* harmony default export */
    var MsListGroupvue_type_script_lang_js_ = {
      name: 'MsListGroup',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/ListGroup'
      },
      functional: true,
      props: {
        /**
         * List header icon
        */
        icon: {
          type: Array,
          required: false
        },
        /**
         * Sets the visual mode of the component from dark to light
        */
        mode: {
          type: String,
          default: ''
        },
        /**
         * List group component size
        */
        size: {
          type: String,
          default: ''
        },
        /**
         * List header title
        */
        title: {
          type: String,
          required: false
        },
        /**
         * List header type
        */
        type: {
          type: String,
          default: 'unordered'
        },
        /**
         * Sets the heading element for the list, by default it will use h4
        */
        headingTag: {
          type: String,
          default: 'h4'
        },
        /**
         * Sets the background colour of the list style
         * @values epic-yellow, dark-line-grey, trusty-peach, fresh-cyan
        */
        color: {
          validator: function validator(value) {
            // The value must match one of these strings
            return ['dark-line-grey', 'epic-yellow', 'trusty-peach', 'fresh-cyan'].indexOf(value) !== -1;
          }
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var $titleContainer = h('div', {
          domProps: {
            innerHTML: props.title
          }
        });
        var headerElements = [$titleContainer];
        if (props.icon && props.icon.length !== 0) {
          var $icon = h('fa', {
            attrs: {
              icon: props.icon
            }
          });
          var $iconContainer = h('span', {
            staticClass: 'icon'
          }, [$icon]);
          headerElements.unshift($iconContainer);
        }
        var $headerContainer = h(props.headingTag, {
          staticClass: "".concat(mainClass, "__title")
        }, headerElements);
        var listType = props.type === 'ordered' ? 'ol' : 'ul';
        var $listContainer = h(listType, {
          staticClass: "".concat(mainClass, "__").concat(props.type),
          class: {
            'list-group--epic-yellow': props.color === 'epic-yellow',
            'list-group--trusty-peach': props.color === 'trusty-peach',
            'list-group--fresh-cyan': props.color === 'fresh-cyan',
            'list-group--dark-line-grey': props.color === 'dark-line-grey'
          }
        }, slots().default);
        var listGroupElements = [$listContainer];
        if (props.title) {
          listGroupElements.unshift($headerContainer);
        }
        return h('div', {
          staticClass: "".concat(mainClass, " ").concat(props.size, " ").concat(props.mode).trim()
        }, listGroupElements);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListGroup/MsListGroup.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListGroup_MsListGroupvue_type_script_lang_js_ = MsListGroupvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListGroup/MsListGroup.vue
    var MsListGroup_render, MsListGroup_staticRenderFns;

    /* normalize component */

    var MsListGroup_component = normalizeComponent(MsListGroup_MsListGroupvue_type_script_lang_js_, MsListGroup_render, MsListGroup_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListGroup = MsListGroup_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListGroup/MsListGroupItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListGroupItemvue_type_script_lang_js_ = {
      name: 'MsListGroupItem',
      functional: true,
      props: {
        /**
         * Icon bullets for list group item
        */
        icon: {
          type: Array
        },
        /**
         * Sets the element tag for the list item, by default it will use p
        */
        elementTag: {
          type: String,
          default: 'p'
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var labelClass = props.icon ? 'list-label' : 'list-content';
        var $labelContainer = h(props.elementTag, {
          staticClass: labelClass
        }, [slots().default]);
        var listElements = [$labelContainer];
        if (props.icon) {
          var $icon = h('fa', {
            staticClass: 'fa-sm',
            attrs: {
              icon: props.icon
            }
          });
          var $iconContainer = h('span', {
            staticClass: 'list-icon'
          }, [$icon]);
          listElements.unshift($iconContainer);
        }
        return h('li', [listElements]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListGroup/MsListGroupItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListGroup_MsListGroupItemvue_type_script_lang_js_ = MsListGroupItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListGroup/MsListGroupItem.vue
    var MsListGroupItem_render, MsListGroupItem_staticRenderFns;

    /* normalize component */

    var MsListGroupItem_component = normalizeComponent(MsListGroup_MsListGroupItemvue_type_script_lang_js_, MsListGroupItem_render, MsListGroupItem_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListGroupItem = MsListGroupItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsListGroup/index.js

    var MsListGroup_components = {
      MsListGroup: MsListGroup,
      MsListGroupItem: MsListGroupItem
    };
    MsListGroup.install = function (Vue) {
      Object.values(MsListGroup_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsListGroup = MsListGroup;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCard.vue?vue&type=template&id=0a095e5a&
    var MsListingCardvue_type_template_id_0a095e5a_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "listing-card",
        class: ["listing-card--".concat(_vm.cardType), {
          'listing-card--exclusive': Boolean(_vm.exclusive),
          'listing-card--badge': Boolean(_vm.badge),
          'listing-card--sponsored': Boolean(_vm.disclosure),
          'is-loading': Boolean(_vm.isLoading),
          'listing-card--share': Boolean(_vm.hasShareSlot)
        }]
      }, [_c('div', {
        staticClass: "listing-card__right-corner"
      }, [_vm.disclosure ? [_c('ms-listing-card-disclosure', [_vm._v(_vm._s(_vm.disclosure))])] : _vm._e(), _vm._t("share")], 2), _vm.isLoading ? [_c('ms-listing-card-loading')] : [_vm._t("default")]], 2);
    };
    var MsListingCardvue_type_template_id_0a095e5a_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCard.vue?vue&type=template&id=0a095e5a&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardDisclosure.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCardDisclosurevue_type_script_lang_js_ = {
      name: 'MsListingCardDisclosure',
      functional: true,
      render: function render(h, _ref) {
        var children = _ref.children;
        return h('div', {
          staticClass: 'listing-card__disclosure'
        }, children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardDisclosure.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardDisclosurevue_type_script_lang_js_ = MsListingCardDisclosurevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardDisclosure.vue
    var MsListingCardDisclosure_render, MsListingCardDisclosure_staticRenderFns;

    /* normalize component */

    var MsListingCardDisclosure_component = normalizeComponent(MsListingCard_MsListingCardDisclosurevue_type_script_lang_js_, MsListingCardDisclosure_render, MsListingCardDisclosure_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardDisclosure = MsListingCardDisclosure_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardLoading.vue?vue&type=template&id=712c9705&
    var MsListingCardLoadingvue_type_template_id_712c9705_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _vm._m(0);
    };
    var MsListingCardLoadingvue_type_template_id_712c9705_staticRenderFns = [function () {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', [_c('div', {
        staticClass: "listing-card__head"
      }, [_c('div', {
        staticClass: "listing-card__highlights"
      }, [_c('div', {
        staticClass: "listing-card__image"
      }, [_c('div', {
        staticClass: "placeholder"
      })])]), _c('div', {
        staticClass: "listing-card__summary"
      }, [_c('div', {
        staticClass: "listing-card__title-wrapper"
      }, [_c('div', {
        staticClass: "placeholder"
      })]), _c('div', {
        staticClass: "listing-card__content"
      }, [_c('div', {
        staticClass: "listing-card__usp"
      }, [_c('div', {
        staticClass: "listing-card__usp-group"
      }, [_c('div', {
        staticClass: "placeholder"
      }), _c('div', {
        staticClass: "placeholder"
      })]), _c('div', {
        staticClass: "listing-card__usp-group"
      }, [_c('div', {
        staticClass: "placeholder"
      }), _c('div', {
        staticClass: "placeholder"
      })]), _c('div', {
        staticClass: "listing-card__usp-group"
      }, [_c('div', {
        staticClass: "placeholder"
      }), _c('div', {
        staticClass: "placeholder"
      })])])])])]), _c('div', {
        staticClass: "listing-card__body"
      }, [_c('div', {
        staticClass: "listing-card__trigger"
      }, [_c('div', {
        staticClass: "placeholder-wrapper"
      }, [_c('div', {
        staticClass: "placeholder"
      })])])])]);
    }];

    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardLoading.vue?vue&type=template&id=712c9705&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardLoading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCardLoadingvue_type_script_lang_js_ = {
      name: 'MsListingCardLoading'
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardLoading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardLoadingvue_type_script_lang_js_ = MsListingCardLoadingvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardLoading.vue

    /* normalize component */

    var MsListingCardLoading_component = normalizeComponent(MsListingCard_MsListingCardLoadingvue_type_script_lang_js_, MsListingCardLoadingvue_type_template_id_712c9705_render, MsListingCardLoadingvue_type_template_id_712c9705_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardLoading = MsListingCardLoading_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCard.vue?vue&type=script&lang=js&

    var MsListingCardvue_type_script_lang_js_props = {
      /**
       * If listing card is exlusive
       */
      exclusive: {
        type: Boolean,
        default: null
      },
      /**
       * If listing card has badge
       */
      badge: {
        type: Boolean,
        default: null
      },
      /**
       * Content of the sponsorship disclosure for the display card
       */
      disclosure: {
        type: String,
        default: null
      },
      /**
       * Type of the listing card
       * @values product, provider
       */
      cardType: {
        type: String,
        default: 'product'
      },
      /**
       * Set loading state of the listing card
       */
      isLoading: {
        type: Boolean,
        default: null
      }
    };
    /* harmony default export */
    var MsListingCardvue_type_script_lang_js_ = {
      name: 'MsListingCard',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/ListingCard'
      },
      components: {
        MsListingCardDisclosure: MsListingCardDisclosure,
        MsListingCardLoading: MsListingCardLoading
      },
      props: MsListingCardvue_type_script_lang_js_props,
      data: function data() {
        return {
          MsListingCard: {
            expanded: false
          }
        };
      },
      computed: {
        hasShareSlot: function hasShareSlot() {
          return !!this.$slots.share;
        }
      },
      provide: function provide() {
        return {
          MsListingCard: this.MsListingCard
        };
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardvue_type_script_lang_js_ = MsListingCardvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCard.vue

    /* normalize component */

    var MsListingCard_component = normalizeComponent(MsListingCard_MsListingCardvue_type_script_lang_js_, MsListingCardvue_type_template_id_0a095e5a_render, MsListingCardvue_type_template_id_0a095e5a_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCard = MsListingCard_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardTitle.vue?vue&type=script&lang=js&
    function MsListingCardTitlevue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsListingCardTitlevue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsListingCardTitlevue_type_script_lang_js_typeof(obj);
    }
    function MsListingCardTitlevue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsListingCardTitlevue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsListingCardTitlevue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsListingCardTitlevue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsListingCardTitlevue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsListingCardTitlevue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsListingCardTitlevue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsListingCardTitlevue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsListingCardTitlevue_type_script_lang_js_toPrimitive(arg, "string");
      return MsListingCardTitlevue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsListingCardTitlevue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsListingCardTitlevue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsListingCardTitlevue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsListingCardTitlevue_type_script_lang_js_linkProps = linkPropsFactory();
    delete MsListingCardTitlevue_type_script_lang_js_linkProps.href.default;
    delete MsListingCardTitlevue_type_script_lang_js_linkProps.to.default;
    var MsListingCardTitlevue_type_script_lang_js_props = MsListingCardTitlevue_type_script_lang_js_objectSpread({
      title: {
        type: String,
        default: null,
        required: true
      },
      titleTag: {
        type: String,
        default: 'h2'
      }
    }, MsListingCardTitlevue_type_script_lang_js_linkProps);
    /* harmony default export */
    var MsListingCardTitlevue_type_script_lang_js_ = {
      name: 'MsListingCardTitle',
      functional: true,
      props: MsListingCardTitlevue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data;
        var titleLink = h(false);
        var title = h(false);
        var titleProps = pluck_props(MsListingCardTitlevue_type_script_lang_js_linkProps, props);
        title = h(props.titleTag, {
          staticClass: 'listing-card__title'
        }, props.title);
        titleLink = h(MsLink, a(data, {
          props: titleProps,
          staticClass: 'listing-card__title-link'
        }), [title]);
        return h('div', {
          staticClass: 'listing-card__title-wrapper'
        }, [titleLink]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardTitle.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardTitlevue_type_script_lang_js_ = MsListingCardTitlevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardTitle.vue
    var MsListingCardTitle_render, MsListingCardTitle_staticRenderFns;

    /* normalize component */

    var MsListingCardTitle_component = normalizeComponent(MsListingCard_MsListingCardTitlevue_type_script_lang_js_, MsListingCardTitle_render, MsListingCardTitle_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardTitle = MsListingCardTitle_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardBadges.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCardBadgesvue_type_script_lang_js_ = {
      name: 'MsListingCardBadges',
      functional: true,
      render: function render(h, _ref) {
        var children = _ref.children;
        return h('div', {
          staticClass: 'badges'
        }, children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBadges.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardBadgesvue_type_script_lang_js_ = MsListingCardBadgesvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBadges.vue
    var MsListingCardBadges_render, MsListingCardBadges_staticRenderFns;

    /* normalize component */

    var MsListingCardBadges_component = normalizeComponent(MsListingCard_MsListingCardBadgesvue_type_script_lang_js_, MsListingCardBadges_render, MsListingCardBadges_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardBadges = MsListingCardBadges_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardBody.vue?vue&type=template&id=92e251ea&
    var MsListingCardBodyvue_type_template_id_92e251ea_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "listing-card__body"
      }, [_vm._t("default")], 2);
    };
    var MsListingCardBodyvue_type_template_id_92e251ea_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBody.vue?vue&type=template&id=92e251ea&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardBody.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCardBodyvue_type_script_lang_js_ = {
      name: 'MsListingCardBody',
      inject: ['MsListingCard']
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBody.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardBodyvue_type_script_lang_js_ = MsListingCardBodyvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBody.vue

    /* normalize component */

    var MsListingCardBody_component = normalizeComponent(MsListingCard_MsListingCardBodyvue_type_script_lang_js_, MsListingCardBodyvue_type_template_id_92e251ea_render, MsListingCardBodyvue_type_template_id_92e251ea_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardBody = MsListingCardBody_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardBodyContent.vue?vue&type=template&id=6b24beac&
    var MsListingCardBodyContentvue_type_template_id_6b24beac_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('collapse-transition', [_vm.MsListingCard.expanded ? _c('div', {
        staticClass: "listing-card__body-container"
      }, [_vm._t("default")], 2) : _vm._e()]);
    };
    var MsListingCardBodyContentvue_type_template_id_6b24beac_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBodyContent.vue?vue&type=template&id=6b24beac&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardBodyContent.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsListingCardBodyContentvue_type_script_lang_js_ = {
      name: 'MsListingCardBodyContent',
      components: {
        CollapseTransition: CollapseTransition
      },
      inject: ['MsListingCard']
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBodyContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardBodyContentvue_type_script_lang_js_ = MsListingCardBodyContentvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsListingCard/MsListingCardBodyContent.vue?vue&type=style&index=0&id=6b24beac&prod&lang=scss&
    var MsListingCardBodyContentvue_type_style_index_0_id_6b24beac_prod_lang_scss_ = __webpack_require__("73ce");

    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBodyContent.vue

    /* normalize component */

    var MsListingCardBodyContent_component = normalizeComponent(MsListingCard_MsListingCardBodyContentvue_type_script_lang_js_, MsListingCardBodyContentvue_type_template_id_6b24beac_render, MsListingCardBodyContentvue_type_template_id_6b24beac_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardBodyContent = MsListingCardBodyContent_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardBodyTrigger.vue?vue&type=script&lang=js&

    var MsListingCardBodyTriggervue_type_script_lang_js_props = {
      labelExpand: {
        type: String,
        default: null
      },
      labelCollapse: {
        type: String,
        default: null
      }
    };
    /* harmony default export */
    var MsListingCardBodyTriggervue_type_script_lang_js_ = {
      name: 'MsListingCardBodyTrigger',
      components: {
        MsIcon: MsIcon
      },
      props: MsListingCardBodyTriggervue_type_script_lang_js_props,
      inject: ['MsListingCard'],
      render: function render(h) {
        var _this = this;
        // element placeholders
        var toggleLabel = h(false);
        var toggleLink = h(false);
        var toggleIcon = h(false);
        var iconClass = this.MsListingCard.expanded ? 'angle-up' : 'angle-down';
        var iconProps = {
          icon: ['fal', iconClass]
        };
        var labelText = this.MsListingCard.expanded ? this.labelCollapse : this.labelExpand;
        var on = {
          click: function click() {
            _this.MsListingCard.expanded = !_this.MsListingCard.expanded;
            _this.$emit('bodyToggle', _this.MsListingCard.expanded);
          }
        };
        var componentData = {
          staticClass: 'listing-card__trigger',
          on: on
        };
        toggleIcon = h('span', [h(MsIcon, {
          props: iconProps
        })]);
        toggleLabel = h('span', labelText);
        toggleLink = h('a', {
          class: 'link-toggle'
        }, [toggleLabel, toggleIcon]);
        return h('div', componentData, [toggleLink]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBodyTrigger.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardBodyTriggervue_type_script_lang_js_ = MsListingCardBodyTriggervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardBodyTrigger.vue
    var MsListingCardBodyTrigger_render, MsListingCardBodyTrigger_staticRenderFns;

    /* normalize component */

    var MsListingCardBodyTrigger_component = normalizeComponent(MsListingCard_MsListingCardBodyTriggervue_type_script_lang_js_, MsListingCardBodyTrigger_render, MsListingCardBodyTrigger_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardBodyTrigger = MsListingCardBodyTrigger_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCardCtavue_type_script_lang_js_ = {
      name: 'MsListingCardCta',
      functional: true,
      render: function render(h, _ref) {
        var children = _ref.children;
        return h('div', {
          staticClass: 'listing-card__cta'
        }, children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardCtavue_type_script_lang_js_ = MsListingCardCtavue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardCta.vue
    var MsListingCardCta_render, MsListingCardCta_staticRenderFns;

    /* normalize component */

    var MsListingCardCta_component = normalizeComponent(MsListingCard_MsListingCardCtavue_type_script_lang_js_, MsListingCardCta_render, MsListingCardCta_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardCta = MsListingCardCta_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardContentWrapper.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsListingCardContentWrappervue_type_script_lang_js_ = {
      name: 'MsListingCardContentWrapper',
      functional: true,
      render: function render(h, _ref) {
        var data = _ref.data,
          slots = _ref.slots;
        return h('div', a(data, {
          staticClass: 'listing-card__content-wrapper'
        }), slots().default);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardContentWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardContentWrappervue_type_script_lang_js_ = MsListingCardContentWrappervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardContentWrapper.vue
    var MsListingCardContentWrapper_render, MsListingCardContentWrapper_staticRenderFns;

    /* normalize component */

    var MsListingCardContentWrapper_component = normalizeComponent(MsListingCard_MsListingCardContentWrappervue_type_script_lang_js_, MsListingCardContentWrapper_render, MsListingCardContentWrapper_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardContentWrapper = MsListingCardContentWrapper_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardExclusive.vue?vue&type=template&id=09818217&
    var MsListingCardExclusivevue_type_template_id_09818217_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "listing-card__exclusive"
      }, [_c('ms-promotion-snippet', {
        attrs: {
          "title": _vm.title,
          "terms": _vm.terms,
          "use": _vm.use,
          "image": _vm.image
        },
        on: {
          "click": _vm.triggerDrawer
        },
        scopedSlots: _vm._u([{
          key: "countdown",
          fn: function fn() {
            return [_vm.hasCountdown ? _c('ms-countdown-timer', {
              attrs: {
                "label": _vm.countdownLabel,
                "time-labels": _vm.countdownTimeLabels,
                "end-date": _vm.countdownEndDate,
                "hours-before-detailed-countdown": _vm.hoursBeforeDetailedCountdown
              }
            }) : _vm._e()];
          },
          proxy: true
        }])
      }, [_vm._t("default")], 2)], 1);
    };
    var MsListingCardExclusivevue_type_template_id_09818217_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardExclusive.vue?vue&type=template&id=09818217&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardExclusive.vue?vue&type=script&lang=js&

    var MsListingCardExclusivevue_type_script_lang_js_props = {
      title: {
        type: String,
        default: null
      },
      terms: {
        type: String,
        default: null
      },
      use: {
        type: String,
        default: null
      },
      image: {
        type: String,
        default: null
      },
      countdownLabel: {
        type: String
      },
      countdownEndDate: {
        type: String
      },
      countdownTimeLabels: {
        type: Object,
        default: function _default() {
          return {
            days: 'days',
            hours: 'h',
            minutes: 'm'
          };
        }
      },
      hasCountdown: {
        type: Boolean,
        default: false
      },
      hoursBeforeDetailedCountdown: {
        type: Number,
        default: 24
      }
    };
    /* harmony default export */
    var MsListingCardExclusivevue_type_script_lang_js_ = {
      name: 'MsListingCardExclusive',
      props: MsListingCardExclusivevue_type_script_lang_js_props,
      inject: ['MsListingCard'],
      methods: {
        triggerDrawer: function triggerDrawer() {
          this.MsListingCard.expanded = true;
          if (window.innerWidth < breakpoints.tablet) {
            this.scrollToPromotions();
          }
        },
        scrollToPromotions: function scrollToPromotions() {
          var listingCard = this.$parent.$el;
          var listingCardBody = listingCard.querySelector('.listing-card__body');
          this.$scrollTo(listingCardBody, {
            offset: -80
          });
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardExclusive.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardExclusivevue_type_script_lang_js_ = MsListingCardExclusivevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardExclusive.vue

    /* normalize component */

    var MsListingCardExclusive_component = normalizeComponent(MsListingCard_MsListingCardExclusivevue_type_script_lang_js_, MsListingCardExclusivevue_type_template_id_09818217_render, MsListingCardExclusivevue_type_template_id_09818217_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardExclusive = MsListingCardExclusive_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardHead.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCardHeadvue_type_script_lang_js_ = {
      name: 'MsListingCardHead',
      functional: true,
      render: function render(h, _ref) {
        var children = _ref.children;
        return h('div', {
          staticClass: 'listing-card__head'
        }, children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardHead.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardHeadvue_type_script_lang_js_ = MsListingCardHeadvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardHead.vue
    var MsListingCardHead_render, MsListingCardHead_staticRenderFns;

    /* normalize component */

    var MsListingCardHead_component = normalizeComponent(MsListingCard_MsListingCardHeadvue_type_script_lang_js_, MsListingCardHead_render, MsListingCardHead_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardHead = MsListingCardHead_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardHighlights.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsListingCardHighlightsvue_type_script_lang_js_ = {
      name: 'MsListingCardHighlights',
      functional: true,
      render: function render(h, _ref) {
        var data = _ref.data,
          children = _ref.children;
        return h('div', a(data, {
          staticClass: 'listing-card__highlights'
        }), children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardHighlights.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardHighlightsvue_type_script_lang_js_ = MsListingCardHighlightsvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardHighlights.vue
    var MsListingCardHighlights_render, MsListingCardHighlights_staticRenderFns;

    /* normalize component */

    var MsListingCardHighlights_component = normalizeComponent(MsListingCard_MsListingCardHighlightsvue_type_script_lang_js_, MsListingCardHighlights_render, MsListingCardHighlights_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardHighlights = MsListingCardHighlights_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardImage.vue?vue&type=script&lang=js&
    function MsListingCardImagevue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsListingCardImagevue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsListingCardImagevue_type_script_lang_js_typeof(obj);
    }
    function MsListingCardImagevue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsListingCardImagevue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsListingCardImagevue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsListingCardImagevue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsListingCardImagevue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsListingCardImagevue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsListingCardImagevue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsListingCardImagevue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsListingCardImagevue_type_script_lang_js_toPrimitive(arg, "string");
      return MsListingCardImagevue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsListingCardImagevue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsListingCardImagevue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsListingCardImagevue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsListingCardImagevue_type_script_lang_js_linkProps = linkPropsFactory();
    delete MsListingCardImagevue_type_script_lang_js_linkProps.href.default;
    delete MsListingCardImagevue_type_script_lang_js_linkProps.to.default;
    var MsListingCardImagevue_type_script_lang_js_props = MsListingCardImagevue_type_script_lang_js_objectSpread({
      src: {
        type: String,
        default: null
      },
      alt: {
        type: String,
        default: null
      }
    }, MsListingCardImagevue_type_script_lang_js_linkProps);
    /* harmony default export */
    var MsListingCardImagevue_type_script_lang_js_ = {
      name: 'MsListingCardImage',
      functional: true,
      props: MsListingCardImagevue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data;
        var img = h(false);
        var imgLink = h(false);
        var imgLinkProps = pluck_props(MsListingCardImagevue_type_script_lang_js_linkProps, props);
        img = h(MsImage, a(data, {
          props: {
            src: props.src,
            alt: props.alt,
            width: '120',
            height: '75'
          }
        }));
        imgLink = h(MsLink, {
          props: imgLinkProps
        }, [img]);
        return h('div', {
          staticClass: 'listing-card__image'
        }, [imgLink]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardImage.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardImagevue_type_script_lang_js_ = MsListingCardImagevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardImage.vue
    var MsListingCardImage_render, MsListingCardImage_staticRenderFns;

    /* normalize component */

    var MsListingCardImage_component = normalizeComponent(MsListingCard_MsListingCardImagevue_type_script_lang_js_, MsListingCardImage_render, MsListingCardImage_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardImage = MsListingCardImage_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardRate.vue?vue&type=script&lang=js&

    var MsListingCardRatevue_type_script_lang_js_props = {
      horizontal: {
        type: Boolean,
        default: null
      },
      label: {
        type: String,
        default: null,
        required: true
      },
      helperLabel: {
        type: String,
        default: null,
        required: true
      },
      original: {
        type: String,
        default: null,
        required: true
      },
      discount: {
        type: String,
        default: null
      },
      currency: {
        type: String,
        default: null,
        required: false
      },
      value: {
        type: String,
        default: null,
        required: true
      },
      valueTag: {
        type: String,
        default: 'h4'
      }
    };
    /* harmony default export */
    var MsListingCardRatevue_type_script_lang_js_ = {
      name: 'MsListingCardRate',
      functional: true,
      props: MsListingCardRatevue_type_script_lang_js_props,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data;
        var label = h(false);
        var helperLabel = h(false);
        var original = h(false);
        var discount = h(false);
        var value = h(false);
        var currency = h(false);
        var originalWrapper = h(false);
        var wrapper = h(false);
        var notes = h(false);
        var componentData = {
          staticClass: 'listing-card__rate'
        };
        if (props.original) {
          original = h('s', props.original);
        }
        if (props.helperLabel) {
          helperLabel = h('span', {
            staticClass: 'visually-hidden'
          }, props.helperLabel);
        }
        if (props.label) {
          label = h('p', {
            staticClass: 'listing-card__rate__label'
          }, props.label);
        }
        if (props.discount) {
          discount = h('span', {
            staticClass: 'listing-card__rate__discount'
          }, props.discount);
        }
        if (props.value) {
          if (props.currency) {
            currency = h('sup', props.currency);
          }
          value = h(props.valueTag, {
            staticClass: 'listing-card__rate__final'
          }, props.currency ? [currency, props.value] : [props.value]);
        }
        originalWrapper = h('span', {
          staticClass: 'listing-card__rate__original'
        }, [helperLabel, original]);
        notes = h('div', {
          staticClass: 'listing-card__rate__notes'
        }, [discount, originalWrapper]);
        if (props.horizontal) {
          wrapper = h('div', {
            staticClass: 'listing-card__rate__wrapper'
          }, [value, notes]);
        }
        return h('div', a(data, componentData), props.horizontal ? [label, wrapper] : [originalWrapper, discount]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardRate.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardRatevue_type_script_lang_js_ = MsListingCardRatevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardRate.vue
    var MsListingCardRate_render, MsListingCardRate_staticRenderFns;

    /* normalize component */

    var MsListingCardRate_component = normalizeComponent(MsListingCard_MsListingCardRatevue_type_script_lang_js_, MsListingCardRate_render, MsListingCardRate_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardRate = MsListingCardRate_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardSummary.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsListingCardSummaryvue_type_script_lang_js_ = {
      name: 'MsListingCardSummary',
      functional: true,
      render: function render(h, _ref) {
        var data = _ref.data,
          slots = _ref.slots;
        return h('div', a(data, {
          staticClass: 'listing-card__summary'
        }), slots().default);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardSummary.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardSummaryvue_type_script_lang_js_ = MsListingCardSummaryvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardSummary.vue
    var MsListingCardSummary_render, MsListingCardSummary_staticRenderFns;

    /* normalize component */

    var MsListingCardSummary_component = normalizeComponent(MsListingCard_MsListingCardSummaryvue_type_script_lang_js_, MsListingCardSummary_render, MsListingCardSummary_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardSummary = MsListingCardSummary_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardUspList.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCardUspListvue_type_script_lang_js_ = {
      name: 'MsListingCardUspList',
      functional: true,
      render: function render(h, _ref) {
        var children = _ref.children;
        var content = h(false);
        content = h('dl', {
          staticClass: 'listing-card__usp'
        }, children);
        return h('div', {
          staticClass: 'listing-card__content'
        }, [content]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardUspList.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardUspListvue_type_script_lang_js_ = MsListingCardUspListvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardUspList.vue
    var MsListingCardUspList_render, MsListingCardUspList_staticRenderFns;

    /* normalize component */

    var MsListingCardUspList_component = normalizeComponent(MsListingCard_MsListingCardUspListvue_type_script_lang_js_, MsListingCardUspList_render, MsListingCardUspList_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardUspList = MsListingCardUspList_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListingCard/MsListingCardUspListItem.vue?vue&type=script&lang=js&
    function MsListingCardUspListItemvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsListingCardUspListItemvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsListingCardUspListItemvue_type_script_lang_js_typeof(obj);
    }
    function MsListingCardUspListItemvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsListingCardUspListItemvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsListingCardUspListItemvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsListingCardUspListItemvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsListingCardUspListItemvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsListingCardUspListItemvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsListingCardUspListItemvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsListingCardUspListItemvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsListingCardUspListItemvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsListingCardUspListItemvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsListingCardUspListItemvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsListingCardUspListItemvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsListingCardUspListItemvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    MsListingCardRatevue_type_script_lang_js_props.label.required = false;
    MsListingCardRatevue_type_script_lang_js_props.helperLabel.required = false;
    MsListingCardRatevue_type_script_lang_js_props.original.required = false;
    MsListingCardRatevue_type_script_lang_js_props.value.required = false;
    var defaultProps = MsListingCardUspListItemvue_type_script_lang_js_objectSpread({
      type: {
        type: String,
        default: null
      }
    }, MsListingCardRatevue_type_script_lang_js_props);
    var isRate = function isRate(props) {
      return props.type === 'rate';
    };
    /* harmony default export */
    var MsListingCardUspListItemvue_type_script_lang_js_ = {
      name: 'MsListingCardUspListItem',
      functional: true,
      props: defaultProps,
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var dt = h(false);
        var dd = h(false);
        var rate = h(false);
        var currency = h(false);
        var additionalInfo = slots().default || h(false);
        var hasRate = isRate(props);
        if (hasRate) {
          rate = h(MsListingCardRate, {
            props: pluck_props(MsListingCardRatevue_type_script_lang_js_props, props)
          });
        }
        dt = h('dt', [props.label, rate, additionalInfo]);
        if (props.currency) {
          currency = h('sup', props.currency);
          dd = h('dd', [currency, props.value]);
        } else {
          dd = h('dd', props.value);
        }
        return h('div', {
          staticClass: 'listing-card__usp-group'
        }, [dt, dd]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardUspListItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListingCard_MsListingCardUspListItemvue_type_script_lang_js_ = MsListingCardUspListItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListingCard/MsListingCardUspListItem.vue
    var MsListingCardUspListItem_render, MsListingCardUspListItem_staticRenderFns;

    /* normalize component */

    var MsListingCardUspListItem_component = normalizeComponent(MsListingCard_MsListingCardUspListItemvue_type_script_lang_js_, MsListingCardUspListItem_render, MsListingCardUspListItem_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListingCardUspListItem = MsListingCardUspListItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsPromotionSnippet/MsPromotionSnippet.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsPromotionSnippetvue_type_script_lang_js_ = {
      name: 'MsPromotionSnippet',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/PromotionSnippet'
      },
      functional: true,
      props: {
        /**
         * Sets title label
        */
        title: {
          type: String,
          default: null
        },
        /**
         * Sets terms label
        */
        terms: {
          type: String,
          default: null
        },
        /**
         * Sets the use case for Moneysmart Exclusive
         * @values epic-yellow, trusty-peach, fresh-cyan, smart-green
        */
        use: {
          type: String,
          validator: function validator(value) {
            // The value must match one of these strings
            return ['epic-yellow', 'trusty-peach', 'fresh-cyan', 'smart-green'].indexOf(value) !== -1;
          }
        },
        /**
         * Sets the image for IMC
        */
        image: {
          type: String,
          required: false
        },
        /**
         * Sets the alt text for the image for IMC
        */
        alt: {
          type: String,
          required: false
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          listeners = _ref.listeners,
          slots = _ref.slots;
        var title = h(false);
        var terms = h(false);
        var content = h(false);
        var image = h(false);
        var imageWrapper = h(false);
        var contentClass = 'promotion-snippet__content';
        var on = {
          click: listeners.click || function () {}
        };
        if (props.title) {
          title = h('strong', [props.title, ': ']);
        }
        if (props.terms) {
          terms = h('span', {
            staticClass: 'promotion-snippet__terms'
          }, [props.terms]);
        }
        if (slots().badges || props.title || slots().default || props.terms || slots().countdown) {
          content = h('div', {
            staticClass: contentClass
          }, [slots().badges, title, slots().default, terms, slots().countdown]);
        }
        if (props.image) {
          image = h(MsImage, a(data, {
            props: {
              src: props.image,
              alt: props.alt,
              width: '67',
              height: '67'
            }
          }));
          imageWrapper = h('div', {
            staticClass: 'promotion-snippet__image'
          }, [image]);
        }
        return h('div', {
          staticClass: 'promotion-snippet',
          class: [{
            'promotion-snippet--epic-yellow': props.use === 'epic-yellow',
            'promotion-snippet--trusty-peach': props.use === 'trusty-peach',
            'promotion-snippet--fresh-cyan': props.use === 'fresh-cyan',
            'promotion-snippet--smart-green': props.use === 'smart-green'
          }],
          on: on
        }, [content, imageWrapper]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsPromotionSnippet/MsPromotionSnippet.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsPromotionSnippet_MsPromotionSnippetvue_type_script_lang_js_ = MsPromotionSnippetvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsPromotionSnippet/MsPromotionSnippet.vue?vue&type=style&index=0&id=975b9b18&prod&lang=scss&
    var MsPromotionSnippetvue_type_style_index_0_id_975b9b18_prod_lang_scss_ = __webpack_require__("179f");

    // CONCATENATED MODULE: ./src/components/MsPromotionSnippet/MsPromotionSnippet.vue
    var MsPromotionSnippet_render, MsPromotionSnippet_staticRenderFns;

    /* normalize component */

    var MsPromotionSnippet_component = normalizeComponent(MsPromotionSnippet_MsPromotionSnippetvue_type_script_lang_js_, MsPromotionSnippet_render, MsPromotionSnippet_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsPromotionSnippet = MsPromotionSnippet_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSponsored/MsSponsored.vue?vue&type=script&lang=js&
    function MsSponsoredvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsSponsoredvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsSponsoredvue_type_script_lang_js_typeof(obj);
    }
    function MsSponsoredvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsSponsoredvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsSponsoredvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsSponsoredvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsSponsoredvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsSponsoredvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsSponsoredvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsSponsoredvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsSponsoredvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsSponsoredvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsSponsoredvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsSponsoredvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsSponsoredvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsSponsoredvue_type_script_lang_js_linkProps = linkPropsFactory();
    delete MsSponsoredvue_type_script_lang_js_linkProps.href.default;
    delete MsSponsoredvue_type_script_lang_js_linkProps.to.default;
    /* harmony default export */
    var MsSponsoredvue_type_script_lang_js_ = {
      name: 'MsSponsored',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Sponsored'
      },
      functional: true,
      props: MsSponsoredvue_type_script_lang_js_objectSpread({
        /**
         * Set the image display style
         */
        use: {
          type: String,
          default: null
        },
        /**
         * Set mobile image
         */
        imgMobile: {
          type: String,
          default: null
        },
        /**
         * Set desktop image
         */
        imgDesktop: {
          type: String,
          default: null
        },
        /**
         * Set alt-text for the image
         */
        imgAltText: {
          type: String,
          default: null
        }
      }, MsSponsoredvue_type_script_lang_js_linkProps),
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          slots = _ref.slots;
        var img = h(false);
        var imgMobile = h(false);
        var imgDesktop = h(false);
        var hasLink = props.href || props.to;
        if (props.imgMobile) {
          imgMobile = h('div', a(data, {
            staticClass: 'ms-sponsored-block__image--mobile'
          }), [h(MsImage, {
            props: {
              src: props.imgMobile,
              alt: props.imgAltText,
              height: '88',
              width: '404'
            }
          })]);
        }
        if (props.imgDesktop) {
          imgDesktop = h('div', a(data, {
            staticClass: 'ms-sponsored-block__image--desktop'
          }), [h(MsImage, {
            props: {
              src: props.imgDesktop,
              alt: props.imgAltText,
              height: '94',
              width: '838'
            }
          })]);
        }
        if (hasLink) {
          img = h(MsLink, a(data, {
            props: props,
            staticClass: 'ms-sponsored-block__image'
          }), [imgMobile, imgDesktop]);
        } else {
          img = h('div', a(data, {
            staticClass: 'ms-sponsored-block__image'
          }), [imgMobile, imgDesktop]);
        }
        return h('div', a(data, {
          staticClass: 'ms-sponsored-block',
          class: props.use ? "ms-sponsored-block--".concat(props.use) : ''
        }), [slots().default, img]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSponsored/MsSponsored.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSponsored_MsSponsoredvue_type_script_lang_js_ = MsSponsoredvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSponsored/MsSponsored.vue
    var MsSponsored_render, MsSponsored_staticRenderFns;

    /* normalize component */

    var MsSponsored_component = normalizeComponent(MsSponsored_MsSponsoredvue_type_script_lang_js_, MsSponsored_render, MsSponsored_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSponsored = MsSponsored_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSponsored/MsSponsoredLink.vue?vue&type=script&lang=js&
    function MsSponsoredLinkvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsSponsoredLinkvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsSponsoredLinkvue_type_script_lang_js_typeof(obj);
    }
    function MsSponsoredLinkvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsSponsoredLinkvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsSponsoredLinkvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsSponsoredLinkvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsSponsoredLinkvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsSponsoredLinkvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsSponsoredLinkvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsSponsoredLinkvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsSponsoredLinkvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsSponsoredLinkvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsSponsoredLinkvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsSponsoredLinkvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsSponsoredLinkvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsSponsoredLinkvue_type_script_lang_js_linkProps = linkPropsFactory();
    delete MsSponsoredLinkvue_type_script_lang_js_linkProps.href.default;
    delete MsSponsoredLinkvue_type_script_lang_js_linkProps.to.default;
    var MsSponsoredLinkvue_type_script_lang_js_props = MsSponsoredLinkvue_type_script_lang_js_objectSpread({}, MsSponsoredLinkvue_type_script_lang_js_linkProps);
    /* harmony default export */
    var MsSponsoredLinkvue_type_script_lang_js_ = {
      name: 'MsSponsoredLink',
      functional: true,
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data,
          children = _ref.children;
        return h(MsLink, a(data, {
          props: props,
          staticClass: 'ms-sponsored-block__hopoff'
        }), children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSponsored/MsSponsoredLink.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSponsored_MsSponsoredLinkvue_type_script_lang_js_ = MsSponsoredLinkvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSponsored/MsSponsoredLink.vue
    var MsSponsoredLink_render, MsSponsoredLink_staticRenderFns;

    /* normalize component */

    var MsSponsoredLink_component = normalizeComponent(MsSponsored_MsSponsoredLinkvue_type_script_lang_js_, MsSponsoredLink_render, MsSponsoredLink_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSponsoredLink = MsSponsoredLink_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSponsored/MsSponsoredText.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsSponsoredTextvue_type_script_lang_js_ = {
      name: 'MsSponsoredText',
      functional: true,
      render: function render(h, _ref) {
        var data = _ref.data,
          children = _ref.children;
        return h('div', a(data, {
          staticClass: 'ms-sponsored-block__title'
        }), children);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSponsored/MsSponsoredText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSponsored_MsSponsoredTextvue_type_script_lang_js_ = MsSponsoredTextvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSponsored/MsSponsoredText.vue
    var MsSponsoredText_render, MsSponsoredText_staticRenderFns;

    /* normalize component */

    var MsSponsoredText_component = normalizeComponent(MsSponsored_MsSponsoredTextvue_type_script_lang_js_, MsSponsoredText_render, MsSponsoredText_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSponsoredText = MsSponsoredText_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShare.vue?vue&type=template&id=ec103610&
    var MsSharevue_type_template_id_ec103610_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        directives: [{
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close"
        }],
        staticClass: "share__container",
        class: [{
          'is-open': _vm.isMenuOpen
        }]
      }, [_c('ms-share-button', {
        attrs: {
          "button-text": _vm.buttonText,
          "close-button-text": _vm.closeButtonText,
          "has-border": _vm.hasBorder
        },
        on: {
          "click": _vm.toggleMenu
        }
      }), _c('div', {
        staticClass: "menu__container py-2",
        class: [{
          'is-open': _vm.isMenuOpen
        }, _vm.align === 'right' ? 'is-align-right' : 'is-align-left', _vm.valign === 'bottom' ? 'is-valign-bottom' : 'is-valign-top']
      }, [_vm._t("default")], 2)], 1);
    };
    var MsSharevue_type_template_id_ec103610_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsShare/MsShare.vue?vue&type=template&id=ec103610&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShareButton.vue?vue&type=template&id=77e8e4b5&
    var MsShareButtonvue_type_template_id_77e8e4b5_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('button', {
        staticClass: "btn__share",
        class: [{
          'has-text': _vm.hasText
        }, {
          'has-border': _vm.hasBorder
        }],
        on: {
          "click": function click($event) {
            return _vm.$emit('click');
          }
        }
      }, [_c('svg', {
        staticClass: "close-icon",
        attrs: {
          "id": "close",
          "width": "100%",
          "height": "100%",
          "viewBox": "0 0 16 17",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M9.61133 8.625L14.6406 3.64453L15.666 2.61914C15.8125 2.47266 15.8125 2.22852 15.666 2.0332L14.5918 0.958984C14.3965 0.8125 14.1523 0.8125 14.0059 0.958984L8 7.01367L1.94531 0.958984C1.79883 0.8125 1.55469 0.8125 1.35938 0.958984L0.285156 2.0332C0.138672 2.22852 0.138672 2.47266 0.285156 2.61914L6.33984 8.625L0.285156 14.6797C0.138672 14.8262 0.138672 15.0703 0.285156 15.2656L1.35938 16.3398C1.55469 16.4863 1.79883 16.4863 1.94531 16.3398L8 10.2852L12.9805 15.3145L14.0059 16.3398C14.1523 16.4863 14.3965 16.4863 14.5918 16.3398L15.666 15.2656C15.8125 15.0703 15.8125 14.8262 15.666 14.6797L9.61133 8.625Z",
          "fill": "#333333"
        }
      })]), _c('span', {
        staticClass: "close-btn__text"
      }, [_vm._v("\n    " + _vm._s(_vm.closeButtonText) + "\n  ")]), _c('svg', {
        staticClass: "share-icon",
        attrs: {
          "id": "share",
          "width": "100%",
          "height": "100%",
          "viewBox": "0 0 13 16",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M6.72967 0.445551C6.80044 0.474831 6.86674 0.518234 6.92426 0.57576L6.92442 0.575919L9.67426 3.32576C9.90858 3.56007 9.90858 3.93997 9.67426 4.17429C9.43995 4.4086 9.06005 4.4086 8.82574 4.17429L7.1 2.44855V9.93752C7.1 10.2689 6.83137 10.5375 6.5 10.5375C6.16863 10.5375 5.9 10.2689 5.9 9.93752V2.44855L4.17426 4.17429C3.93995 4.4086 3.56005 4.4086 3.32574 4.17429C3.09142 3.93997 3.09142 3.56007 3.32574 3.32576L6.07558 0.575919L6.07574 0.57576C6.19339 0.458109 6.34774 0.399532 6.50194 0.400028C6.57945 0.400277 6.65692 0.415451 6.72967 0.445551ZM6.50194 0.400028C6.58259 0.400283 6.65949 0.416449 6.72967 0.445551ZM1 7.27502C1.33137 7.27502 1.6 7.54365 1.6 7.87502V13.375C1.6 13.5806 1.68165 13.7777 1.82699 13.923C1.97233 14.0684 2.16946 14.15 2.375 14.15H10.625C10.8305 14.15 11.0277 14.0684 11.173 13.923C11.3183 13.7777 11.4 13.5806 11.4 13.375V7.87502C11.4 7.54365 11.6686 7.27502 12 7.27502C12.3314 7.27502 12.6 7.54365 12.6 7.87502V13.375C12.6 13.8988 12.3919 14.4012 12.0215 14.7716C11.6512 15.1419 11.1488 15.35 10.625 15.35H2.375C1.8512 15.35 1.34885 15.1419 0.978464 14.7716C0.60808 14.4012 0.4 13.8988 0.4 13.375V7.87502C0.4 7.54365 0.668629 7.27502 1 7.27502Z",
          "fill": "#808080"
        }
      })]), _c('span', {
        staticClass: "btn__text",
        class: [{
          'visually-hidden': !_vm.hasText
        }]
      }, [_vm._v("\n    " + _vm._s(_vm.hasText ? _vm.buttonText : 'Share') + "\n  ")])]);
    };
    var MsShareButtonvue_type_template_id_77e8e4b5_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsShare/MsShareButton.vue?vue&type=template&id=77e8e4b5&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShareButton.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsShareButtonvue_type_script_lang_js_ = {
      name: 'MsShareButton',
      props: {
        /**
         * Set button label
        */
        buttonText: {
          type: String,
          default: ''
        },
        /**
         * Set close button label
        */
        closeButtonText: {
          type: String,
          default: 'Close'
        },
        /**
         * Set border for share button
        */
        hasBorder: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        hasText: function hasText() {
          return this.buttonText !== '';
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsShare/MsShareButton.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsShare_MsShareButtonvue_type_script_lang_js_ = MsShareButtonvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsShare/MsShareButton.vue

    /* normalize component */

    var MsShareButton_component = normalizeComponent(MsShare_MsShareButtonvue_type_script_lang_js_, MsShareButtonvue_type_template_id_77e8e4b5_render, MsShareButtonvue_type_template_id_77e8e4b5_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsShareButton = MsShareButton_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShare.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsSharevue_type_script_lang_js_ = {
      name: 'MsShare',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/MsShare'
      },
      components: {
        MsShareButton: MsShareButton
      },
      directives: {
        'click-outside': click_outside
      },
      props: {
        /**
         * Set button label
        */
        buttonText: {
          type: String,
          default: ''
        },
        /**
         * Set close button label
        */
        closeButtonText: {
          type: String,
          default: 'Close'
        },
        /**
         * Set dropdown menu orientation to horizontal [right, left]
        */
        align: {
          type: String,
          default: 'right',
          validator: function validator(value) {
            return ['right', 'left'].indexOf(value) !== -1;
          }
        },
        /**
         * Set dropdown menu orientation to vertical [top, bottom]
        */
        valign: {
          type: String,
          default: 'bottom',
          validator: function validator(value) {
            return ['bottom', 'top'].indexOf(value) !== -1;
          }
        },
        /**
         * Set border for share button
        */
        hasBorder: {
          type: Boolean,
          default: false
        }
      },
      data: function data() {
        return {
          isMenuOpen: false
        };
      },
      methods: {
        toggleMenu: function toggleMenu() {
          this.isMenuOpen = !this.isMenuOpen;
        },
        close: function close() {
          this.isMenuOpen = false;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsShare/MsShare.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsShare_MsSharevue_type_script_lang_js_ = MsSharevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsShare/MsShare.vue

    /* normalize component */

    var MsShare_component = normalizeComponent(MsShare_MsSharevue_type_script_lang_js_, MsSharevue_type_template_id_ec103610_render, MsSharevue_type_template_id_ec103610_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsShare = MsShare_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShareCopyClipboard.vue?vue&type=template&id=dd05bafa&
    var MsShareCopyClipboardvue_type_template_id_dd05bafa_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "menu__item"
      }, [_c('ms-link', {
        staticClass: "btn__copy",
        class: [{
          'is-active': _vm.isActive
        }],
        attrs: {
          "href": "#"
        },
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.copyClipboard.apply(null, arguments);
          }
        }
      }, [_c('ms-icon', {
        staticClass: "ml-0 mr-5",
        attrs: {
          "icon": _vm.isActive ? ['fas', 'check-circle'] : ['far', 'link']
        }
      }), _c('span', [_vm._v(_vm._s(_vm.isActive ? _vm.activeLabel : _vm.label))])], 1)], 1);
    };
    var MsShareCopyClipboardvue_type_template_id_dd05bafa_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsShare/MsShareCopyClipboard.vue?vue&type=template&id=dd05bafa&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShareCopyClipboard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsShareCopyClipboardvue_type_script_lang_js_ = {
      name: 'MsShareCopyClipboard',
      props: {
        /**
         * Set label for copy clipboard link
        */
        label: {
          type: String,
          default: ''
        },
        /**
         * Set link to copy
        */
        link: {
          type: String,
          required: true
        },
        /**
         * Set label for copy clipboard when link clicked.
        */
        activeLabel: {
          type: String,
          default: 'Link Copied!'
        }
      },
      data: function data() {
        return {
          isActive: false
        };
      },
      methods: {
        copyClipboard: function copyClipboard() {
          this.isActive = true;
          var el = document.createElement('textArea');
          el.readOnly = true;
          el.contentEditable = true;
          el.value = this.link;
          document.body.appendChild(el);
          if (this.isiOS()) {
            var range = document.createRange();
            range.selectNodeContents(el);
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            el.setSelectionRange(0, 999999);
          } else {
            el.select();
          }
          document.execCommand('copy');
          document.body.removeChild(el);
        },
        isiOS: function isiOS() {
          return navigator.userAgent.match(/ipad|iphone/i);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsShare/MsShareCopyClipboard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsShare_MsShareCopyClipboardvue_type_script_lang_js_ = MsShareCopyClipboardvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsShare/MsShareCopyClipboard.vue

    /* normalize component */

    var MsShareCopyClipboard_component = normalizeComponent(MsShare_MsShareCopyClipboardvue_type_script_lang_js_, MsShareCopyClipboardvue_type_template_id_dd05bafa_render, MsShareCopyClipboardvue_type_template_id_dd05bafa_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsShareCopyClipboard = MsShareCopyClipboard_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShareItem.vue?vue&type=template&id=780dad1a&
    var MsShareItemvue_type_template_id_780dad1a_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "menu__item"
      }, [_c('ms-link', {
        attrs: {
          "href": _vm.href,
          "target": _vm.target
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('click');
          }
        }
      }, [_c('ms-icon', {
        staticClass: "ml-0 mr-5",
        attrs: {
          "icon": _vm.icon
        }
      }), _c('span', [_vm._v(_vm._s(_vm.label))])], 1)], 1);
    };
    var MsShareItemvue_type_template_id_780dad1a_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsShare/MsShareItem.vue?vue&type=template&id=780dad1a&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsShare/MsShareItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsShareItemvue_type_script_lang_js_ = {
      name: 'MsShareItem',
      props: {
        /**
         * Set link for share item
        */
        href: {
          type: String,
          required: true
        },
        /**
         * Set link target for share item
        */
        target: {
          type: String,
          default: '_blank'
        },
        /**
         * Set icon for share item
        */
        icon: {
          type: Array,
          required: true
        },
        /**
         * Set label for share item
        */
        label: {
          type: String,
          default: ''
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsShare/MsShareItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsShare_MsShareItemvue_type_script_lang_js_ = MsShareItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsShare/MsShareItem.vue

    /* normalize component */

    var MsShareItem_component = normalizeComponent(MsShare_MsShareItemvue_type_script_lang_js_, MsShareItemvue_type_template_id_780dad1a_render, MsShareItemvue_type_template_id_780dad1a_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsShareItem = MsShareItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTabs/MsTabs.vue?vue&type=template&id=a814aeda&
    var MsTabsvue_type_template_id_a814aeda_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "tabs"
      }, [_c('div', {
        staticClass: "tabs__arrows"
      }, [_c('button', {
        staticClass: "tabs__arrows--previous",
        on: {
          "click": function click($event) {
            return _vm.arrowScroll('previous');
          }
        }
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['far', 'chevron-left']
        }
      })], 1), _c('button', {
        staticClass: "tabs__arrows--next",
        on: {
          "click": function click($event) {
            return _vm.arrowScroll('next');
          }
        }
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['far', 'chevron-right']
        }
      })], 1)]), _c('div', {
        ref: "tabMenu",
        staticClass: "tabs__menu"
      }, [_c('ul', {
        attrs: {
          "role": "tablist"
        }
      }, [_vm._t("menu", null, {
        "activeMenuId": _vm.definedActiveMenuId || _vm.activeMenuId,
        "onMenuClick": _vm.onMenuClick
      })], 2), _c('span', {
        staticClass: "tabs__menu__highlighter"
      })]), _c('div', {
        staticClass: "tabs__content"
      }, [_c('ul', [_vm._t("content", null, {
        "activeMenuId": _vm.definedActiveMenuId || _vm.activeMenuId
      })], 2)])]);
    };
    var MsTabsvue_type_template_id_a814aeda_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTabs/MsTabs.vue?vue&type=template&id=a814aeda&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTabs/MsTabs.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTabsvue_type_script_lang_js_ = {
      name: 'MsTabs',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Tabs'
      },
      props: {
        activeMenuId: {
          type: String,
          default: null
        }
      },
      data: function data() {
        return {
          definedActiveMenuId: null
        };
      },
      watch: {
        definedActiveMenuId: function definedActiveMenuId(newValue) {
          this.$emit('set-active-tab', newValue);
        }
      },
      mounted: function mounted() {
        this.positionHighlighter(this.$el.querySelector('.tabs__menu > ul > li:nth-child(1)'));
        this.showHideArrow();
        this.onContentScroll();
        this.onMenuScroll();
        this.onResize();
      },
      methods: {
        onMenuClick: function onMenuClick(e, id) {
          this.definedActiveMenuId = id;
          this.positionHighlighter(e.target);
          this.positionToContent();
        },
        arrowScroll: function arrowScroll(direction) {
          var tabMenu = this.$refs.tabMenu;
          var activeMenu = this.$refs.tabMenu.querySelector('.is-active');
          tabMenu.scroll({
            left: direction === 'previous' ? tabMenu.scrollLeft - activeMenu.clientWidth : tabMenu.scrollLeft + activeMenu.clientWidth,
            behavior: 'smooth'
          });
        },
        onContentScroll: function onContentScroll() {
          var _this = this;
          var container = this.$el.querySelector('.tabs__content > ul');
          var containerMenu = this.$el.querySelector('.tabs__menu');
          container.addEventListener('scroll', function () {
            var selectedOnScroll = containerMenu.querySelector("li:nth-child(".concat(Math.round(container.scrollLeft / container.clientWidth + 1), ")"));
            _this.definedActiveMenuId = selectedOnScroll.getAttribute('data-id');
            _this.positionHighlighter(selectedOnScroll);
          });
        },
        onMenuScroll: function onMenuScroll() {
          var _this2 = this;
          var container = this.$el.querySelector('.tabs__menu');
          container.addEventListener('scroll', function () {
            return _this2.showHideArrow();
          });
        },
        onResize: function onResize() {
          var _this3 = this;
          window.addEventListener('resize', function () {
            return _this3.showHideArrow();
          });
        },
        showHideArrow: function showHideArrow() {
          var container = this.$el.querySelector('.tabs__menu');
          var arrows = this.$el.querySelector('.tabs__arrows');
          var arrowLeft = this.$el.querySelector('.tabs__arrows .tabs__arrows--previous');
          var arrowRight = this.$el.querySelector('.tabs__arrows .tabs__arrows--next');
          arrows.style.display = container.scrollWidth === this.$el.clientWidth ? 'none' : 'flex';
          arrowLeft.style.display = container.scrollLeft === 0 ? 'none' : 'block';
          arrowRight.style.display = container.scrollLeft + container.clientWidth === container.scrollWidth ? 'none' : 'block';
        },
        positionToContent: function positionToContent() {
          var container = this.$el.querySelector('.tabs__content > ul');
          var contentContainers = container.querySelectorAll('.tabs__content > ul > li');
          var scrollLeft = 0;

          // eslint-disable-next-line no-plusplus
          for (var i = 0; i < contentContainers.length; i++) {
            if (contentContainers[i].getAttribute('data-id') === this.definedActiveMenuId) {
              container.scroll({
                left: scrollLeft,
                behavior: 'smooth'
              });
            } else {
              scrollLeft += contentContainers[i].offsetWidth;
            }
          }
        },
        positionHighlighter: function positionHighlighter(el) {
          var menusContainer = this.$el.querySelector('.tabs__menu');
          var highlighter = menusContainer.querySelector('.tabs__menu__highlighter');
          var childWidth = el ? el.offsetWidth : 0;
          var menus = el ? el.parentElement.querySelectorAll('li') : null;
          var highlightPosition = 0;
          var scrollLeft = -10;
          if (menus) {
            // eslint-disable-next-line no-plusplus
            for (var i = 0; i < menus.length; i++) {
              if (menus[i] === el) {
                highlighter.style.width = "".concat(childWidth, "px");
                highlighter.style.transform = "translate(".concat(highlightPosition, "px)");
                menusContainer.scroll({
                  left: scrollLeft,
                  behavior: 'smooth'
                });
              } else {
                highlightPosition += menus[i].offsetWidth;
                scrollLeft += menus[i].offsetWidth;
              }
            }
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTabs/MsTabs.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTabs_MsTabsvue_type_script_lang_js_ = MsTabsvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTabs/MsTabs.vue

    /* normalize component */

    var MsTabs_component = normalizeComponent(MsTabs_MsTabsvue_type_script_lang_js_, MsTabsvue_type_template_id_a814aeda_render, MsTabsvue_type_template_id_a814aeda_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTabs = MsTabs_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTabs/MsTabMenu.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTabMenuvue_type_script_lang_js_ = {
      name: 'MsTabMenu',
      functional: true,
      props: {
        active: {
          type: Boolean,
          default: false
        },
        onMenuClick: {
          type: Function,
          required: true
        },
        menuId: {
          type: String,
          required: true
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var onClick = function onClick(e, props) {
          props.onMenuClick(e, props.menuId);
        };
        return h('li', {
          class: props.active ? 'is-active' : '',
          attrs: {
            'data-id': props.menuId,
            'aria-controls': props.menuId,
            'aria-selected': props.active ? 'true' : 'false',
            href: "#".concat(props.menuId),
            id: "tab-".concat(props.menuId),
            role: 'tab'
          },
          'on': {
            'click': function click(e) {
              onClick(e, props);
            }
          }
        }, slots().default);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTabs/MsTabMenu.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTabs_MsTabMenuvue_type_script_lang_js_ = MsTabMenuvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTabs/MsTabMenu.vue
    var MsTabMenu_render, MsTabMenu_staticRenderFns;

    /* normalize component */

    var MsTabMenu_component = normalizeComponent(MsTabs_MsTabMenuvue_type_script_lang_js_, MsTabMenu_render, MsTabMenu_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTabMenu = MsTabMenu_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTabs/MsTabContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTabContentvue_type_script_lang_js_ = {
      name: 'MsTabContent',
      functional: true,
      props: {
        menuId: {
          type: String,
          required: true
        },
        active: {
          type: Boolean,
          default: false
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        return h('li', {
          staticClass: 'tab-list',
          class: props.active ? 'is-active' : '',
          attrs: {
            'data-id': props.menuId,
            'aria-labelledby': "tab-".concat(props.menuId),
            role: 'tabpanel'
          }
        }, slots().default);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTabs/MsTabContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTabs_MsTabContentvue_type_script_lang_js_ = MsTabContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTabs/MsTabContent.vue
    var MsTabContent_render, MsTabContent_staticRenderFns;

    /* normalize component */

    var MsTabContent_component = normalizeComponent(MsTabs_MsTabContentvue_type_script_lang_js_, MsTabContent_render, MsTabContent_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTabContent = MsTabContent_component.exports;
    // CONCATENATED MODULE: ./src/components/MsListingCard/index.js

    var MsListingCard_components = {
      MsListingCard: MsListingCard,
      MsListingCardTitle: MsListingCardTitle,
      MsListingCardBadges: MsListingCardBadges,
      MsListingCardBody: MsListingCardBody,
      MsListingCardBodyContent: MsListingCardBodyContent,
      MsListingCardBodyTrigger: MsListingCardBodyTrigger,
      MsListingCardCta: MsListingCardCta,
      MsListingCardContentWrapper: MsListingCardContentWrapper,
      MsListingCardDisclosure: MsListingCardDisclosure,
      MsListingCardExclusive: MsListingCardExclusive,
      MsListingCardHead: MsListingCardHead,
      MsListingCardHighlights: MsListingCardHighlights,
      MsListingCardImage: MsListingCardImage,
      MsListingCardLoading: MsListingCardLoading,
      MsListingCardRate: MsListingCardRate,
      MsListingCardSummary: MsListingCardSummary,
      MsListingCardUspList: MsListingCardUspList,
      MsListingCardUspListItem: MsListingCardUspListItem,
      MsButton: MsButton,
      MsIcon: MsIcon,
      MsImage: MsImage,
      MsLink: MsLink,
      MsPromotionSnippet: MsPromotionSnippet,
      MsSponsored: MsSponsored,
      MsSponsoredLink: MsSponsoredLink,
      MsSponsoredText: MsSponsoredText,
      MsShare: MsShare,
      MsShareButton: MsShareButton,
      MsShareCopyClipboard: MsShareCopyClipboard,
      MsShareItem: MsShareItem,
      MsTabs: MsTabs,
      MsTabMenu: MsTabMenu,
      MsTabContent: MsTabContent,
      MsCountdownTimer: MsCountdownTimer
    };
    MsListingCard.install = function (Vue) {
      Object.values(MsListingCard_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsListingCard = MsListingCard;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListTable/MsListTable.vue?vue&type=script&lang=js&
    var MsListTablevue_type_script_lang_js_mainClass = 'list-group';
    /* harmony default export */
    var MsListTablevue_type_script_lang_js_ = {
      name: 'MsListTable',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/ListTable'
      },
      functional: true,
      props: {
        /**
         * Sets the visual mode of the component from dark to light
        */
        mode: {
          type: String,
          default: ''
        },
        /**
         * List group component size
        */
        size: {
          type: String,
          default: ''
        },
        /**
         * List header title
        */
        title: {
          type: String
        },
        /**
         * Sets the heading element for the list, by default it will use h4
        */
        headingTag: {
          type: String,
          default: 'h4'
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var $headerContainer = h(props.headingTag, {
          staticClass: "".concat(MsListTablevue_type_script_lang_js_mainClass, "__title")
        }, [props.title]);
        var $bodyContainer = h('tbody', slots().default);
        var $tableContainer = h('table', {
          staticClass: "".concat(MsListTablevue_type_script_lang_js_mainClass, "__table")
        }, [$bodyContainer]);
        var listTableElements = [$tableContainer];
        if (props.title) {
          listTableElements.unshift($headerContainer);
        }
        return h('div', {
          staticClass: "".concat(MsListTablevue_type_script_lang_js_mainClass, " ").concat(props.size, " ").concat(props.mode).trim()
        }, listTableElements);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListTable/MsListTable.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListTable_MsListTablevue_type_script_lang_js_ = MsListTablevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListTable/MsListTable.vue
    var MsListTable_render, MsListTable_staticRenderFns;

    /* normalize component */

    var MsListTable_component = normalizeComponent(MsListTable_MsListTablevue_type_script_lang_js_, MsListTable_render, MsListTable_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListTable = MsListTable_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListTable/MsListTableItem.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsListTableItemvue_type_script_lang_js_ = {
      name: 'MsListTableItem',
      functional: true,
      props: {
        /**
         * Table head label
        */
        label: {
          type: String,
          required: true
        },
        /**
         * 	This unique key can be provided when the label is repeated on the page
         *  in another table to guarantee a unique string to enable the cell association to the correct heading
        */
        uniqueKey: {
          type: String,
          required: false,
          default: ''
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var relationshipIdentifier = "".concat(spaceToSnakeCase(props.label), "_").concat(simpleHash(props.label + props.uniqueKey));
        var $headContainer = h('th', {
          attrs: {
            id: relationshipIdentifier,
            scope: 'row'
          }
        }, props.label);
        var $cellContainer = h('td', {
          attrs: {
            headers: relationshipIdentifier
          }
        }, slots().default);
        return h('tr', [$headContainer, $cellContainer]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListTable/MsListTableItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListTable_MsListTableItemvue_type_script_lang_js_ = MsListTableItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListTable/MsListTableItem.vue
    var MsListTableItem_render, MsListTableItem_staticRenderFns;

    /* normalize component */

    var MsListTableItem_component = normalizeComponent(MsListTable_MsListTableItemvue_type_script_lang_js_, MsListTableItem_render, MsListTableItem_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListTableItem = MsListTableItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsListTable/MsListTableSubItem.vue?vue&type=script&lang=js&

    var MsListTableSubItemvue_type_script_lang_js_mainClass = 'list-group';
    /* harmony default export */
    var MsListTableSubItemvue_type_script_lang_js_ = {
      name: 'MsListTableSubItem',
      functional: true,
      props: {
        /**
         * Table head label
        */
        label: {
          type: String,
          required: true
        },
        /**
         * The parent label is required to correctly link the sub-rows to the parent row for SEO and
         * accessibility purposes. This must exactly match the parent row's label
        */
        parentLabel: {
          type: String,
          required: true
        },
        /**
         * This unique key can be provided when the label information is repeated on the page
         * to guarantee a unique string to enable the cell association to the correct heading.
         * This must exactly match the parent row's uniqueKey
        */
        parentUniqueKey: {
          type: String,
          required: false,
          default: ''
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots;
        var relationshipIdentifier = "".concat(spaceToSnakeCase(props.label), "_").concat(simpleHash(props.label + props.parentUniqueKey));
        var parentRelationshipIdentifier = "".concat(spaceToSnakeCase(props.parentLabel), "_").concat(simpleHash(props.parentLabel + props.parentUniqueKey));
        var $headContainer = h('th', {
          attrs: {
            id: relationshipIdentifier,
            scope: 'row'
          }
        }, props.label);
        var $cellContainer = h('td', {
          attrs: {
            headers: "".concat(parentRelationshipIdentifier, " ").concat(relationshipIdentifier)
          }
        }, slots().default);
        return h('tr', {
          staticClass: "".concat(MsListTableSubItemvue_type_script_lang_js_mainClass, "__sub-value")
        }, [$headContainer, $cellContainer]);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsListTable/MsListTableSubItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsListTable_MsListTableSubItemvue_type_script_lang_js_ = MsListTableSubItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsListTable/MsListTableSubItem.vue
    var MsListTableSubItem_render, MsListTableSubItem_staticRenderFns;

    /* normalize component */

    var MsListTableSubItem_component = normalizeComponent(MsListTable_MsListTableSubItemvue_type_script_lang_js_, MsListTableSubItem_render, MsListTableSubItem_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsListTableSubItem = MsListTableSubItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsListTable/index.js

    var MsListTable_components = {
      MsListTable: MsListTable,
      MsListTableItem: MsListTableItem,
      MsListTableSubItem: MsListTableSubItem
    };
    MsListTable.install = function (Vue) {
      Object.values(MsListTable_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsListTable = MsListTable;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsLoader/MsLoader.vue?vue&type=template&id=77f4b1a1&
    var MsLoadervue_type_template_id_77f4b1a1_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "sk-three-bounce",
        class: {
          'inline-loader': _vm.inline
        },
        style: _vm.style
      }, _vm._l(_vm.dots, function (dot, index) {
        return _c('div', {
          key: index,
          staticClass: "sk-child",
          class: ["sk-bounce".concat(index + 1), "bg-".concat(_vm.color)]
        });
      }), 0);
    };
    var MsLoadervue_type_template_id_77f4b1a1_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsLoader/MsLoader.vue?vue&type=template&id=77f4b1a1&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsLoader/MsLoader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsLoadervue_type_script_lang_js_ = {
      name: 'MsLoader',
      storybook: {
        path: 'Cargo Product Language/Motion/Animations/Loader'
      },
      props: {
        /**
         * Sets loader display Inline or Block
        */
        inline: {
          type: Boolean,
          default: false
        },
        /**
         * Sets the color of the loader
        */
        color: {
          type: String,
          default: 'smart-green'
        },
        /**
         * Sets the size of the loader
        */
        size: {
          type: Number,
          default: 15
        }
      },
      data: function data() {
        return {
          dots: 4
        };
      },
      computed: {
        style: function style() {
          return {
            '--spinner-size': "".concat(this.size, "px")
          };
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsLoader/MsLoader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsLoader_MsLoadervue_type_script_lang_js_ = MsLoadervue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsLoader/MsLoader.vue?vue&type=style&index=0&id=77f4b1a1&prod&lang=scss&
    var MsLoadervue_type_style_index_0_id_77f4b1a1_prod_lang_scss_ = __webpack_require__("cad3");

    // CONCATENATED MODULE: ./src/components/MsLoader/MsLoader.vue

    /* normalize component */

    var MsLoader_component = normalizeComponent(MsLoader_MsLoadervue_type_script_lang_js_, MsLoadervue_type_template_id_77f4b1a1_render, MsLoadervue_type_template_id_77f4b1a1_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsLoader = MsLoader_component.exports;
    // CONCATENATED MODULE: ./src/components/MsLoader/index.js

    MsLoader.install = function (Vue) {
      return Vue.component(MsLoader.name, MsLoader);
    };
    /* harmony default export */
    var components_MsLoader = MsLoader;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMasthead.vue?vue&type=template&id=15947dd6&
    function MsMastheadvue_type_template_id_15947dd6_typeof(obj) {
      "@babel/helpers - typeof";

      return MsMastheadvue_type_template_id_15947dd6_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsMastheadvue_type_template_id_15947dd6_typeof(obj);
    }
    function MsMastheadvue_type_template_id_15947dd6_defineProperty(obj, key, value) {
      key = MsMastheadvue_type_template_id_15947dd6_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsMastheadvue_type_template_id_15947dd6_toPropertyKey(arg) {
      var key = MsMastheadvue_type_template_id_15947dd6_toPrimitive(arg, "string");
      return MsMastheadvue_type_template_id_15947dd6_typeof(key) === "symbol" ? key : String(key);
    }
    function MsMastheadvue_type_template_id_15947dd6_toPrimitive(input, hint) {
      if (MsMastheadvue_type_template_id_15947dd6_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsMastheadvue_type_template_id_15947dd6_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsMastheadvue_type_template_id_15947dd6_render = function render() {
      var _ref;
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        ref: "masthead",
        staticClass: "masthead",
        class: [(_ref = {}, MsMastheadvue_type_template_id_15947dd6_defineProperty(_ref, "masthead--".concat(_vm.use), Boolean(_vm.use)), MsMastheadvue_type_template_id_15947dd6_defineProperty(_ref, 'masthead--form', _vm.contentType === 'form'), _ref)],
        style: _vm.customProperty
      }, [_c('div', {
        staticClass: "container"
      }, [_vm.title ? _c('h1', {
        ref: "mastheadTitle",
        staticClass: "masthead__title"
      }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._t("default")], 2)]);
    };
    var MsMastheadvue_type_template_id_15947dd6_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMasthead.vue?vue&type=template&id=15947dd6&

    // EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
    var lodash_debounce = __webpack_require__("f7fe");
    var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMasthead.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsMastheadvue_type_script_lang_js_ = {
      name: 'MsMasthead',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Masthead'
      },
      props: {
        /**
         * Set masthead type
         * @values filter, form
        */
        use: {
          type: String,
          default: null
        },
        /**
         * Set masthead content type
         * @values filter, form
        */
        contentType: {
          type: String,
          default: null
        },
        /**
         * Display title of the masthead
        */
        title: {
          type: String,
          default: null
        }
      },
      data: function data() {
        return {
          height: {
            title: 0,
            description: 0
          },
          isContentForm: false,
          stickyClass: 'is-sticky',
          isSticky: false
        };
      },
      computed: {
        customProperty: function customProperty() {
          var _this$height = this.height,
            title = _this$height.title,
            description = _this$height.description;
          var totalHeight = title + description;
          return "--scroll-position: -".concat(totalHeight, "px");
        }
      },
      mounted: function mounted() {
        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('scroll', this.stickyObserver);
        this.updateChildHeights();
      },
      destroyed: function destroyed() {
        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('scroll', this.stickyObserver);
      },
      methods: {
        stickyObserver: function stickyObserver() {
          var $masthead = this.$refs.masthead;
          if (window.pageYOffset > $masthead.offsetTop) {
            $masthead.classList.add(this.stickyClass);
          } else {
            $masthead.classList.remove(this.stickyClass);
          }
        },
        updateChildHeights: function updateChildHeights() {
          var mastheadTitle = this.$refs.mastheadTitle;
          var readMore = this.$children.find(function (child) {
            return child.$options.name === 'MsMastheadReadmore';
          });
          if (this.title && mastheadTitle) {
            this.height.title = mastheadTitle.offsetHeight;
          }
          if (readMore) {
            this.height.description = readMore.$el.offsetHeight;
          }
        },
        onWindowResize: lodash_debounce_default()(function resizeWindow() {
          this.updateChildHeights();
        }, 150)
      }
    };
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMasthead.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsMasthead_MsMastheadvue_type_script_lang_js_ = MsMastheadvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMasthead.vue

    /* normalize component */

    var MsMasthead_component = normalizeComponent(MsMasthead_MsMastheadvue_type_script_lang_js_, MsMastheadvue_type_template_id_15947dd6_render, MsMastheadvue_type_template_id_15947dd6_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsMasthead = MsMasthead_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMastheadReadmore.vue?vue&type=template&id=411cafc2&
    var MsMastheadReadmorevue_type_template_id_411cafc2_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        ref: "mastheadDescription",
        staticClass: "masthead__description",
        class: {
          'is-expanded': _vm.expanded
        }
      }, [_vm.description ? _c('span', {
        staticClass: "blurb"
      }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm.hasSlot ? _c('ms-link', {
        staticClass: "masthead__toggle",
        attrs: {
          "id": _vm.id,
          "aria-expanded": _vm.expanded,
          "aria-controls": _vm.panelId,
          "role": "button"
        },
        nativeOn: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.toggleReadMorePanel.apply(null, arguments);
          }
        }
      }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n\n    "), _c('span', [_c('ms-icon', {
        attrs: {
          "icon": ['fal', 'angle-down']
        }
      })], 1)]) : _vm._e(), _c('p', {
        staticClass: "masthead__readmore-content",
        attrs: {
          "id": _vm.panelId,
          "aria-labelledby": _vm.id,
          "aria-hidden": !_vm.expanded,
          "role": "region"
        }
      }, [_vm._t("default")], 2)], 1);
    };
    var MsMastheadReadmorevue_type_template_id_411cafc2_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadReadmore.vue?vue&type=template&id=411cafc2&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMastheadReadmore.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsMastheadReadmorevue_type_script_lang_js_ = {
      name: 'MsMastheadReadmore',
      props: {
        /**
           * Set the component unique id
          */
        id: {
          type: String,
          required: true
        },
        /**
           * Set target id for the content
          */
        panelId: {
          type: String,
          required: true
        },
        /**
           * Set trigger element's label
          */
        label: {
          type: String,
          default: 'Read More'
        },
        /**
           * Set the description to be displayed when toggled
          */
        description: {
          type: String,
          default: null
        }
      },
      data: function data() {
        return {
          delay: 350,
          expanded: false
        };
      },
      computed: {
        hasSlot: function hasSlot() {
          return !!this.$slots.default[0].text.length;
        }
      },
      methods: {
        toggleReadMorePanel: function toggleReadMorePanel() {
          var _this = this;
          this.expanded = !this.expanded;

          // wait for the transition
          setTimeout(function () {
            _this.$parent.height.description = _this.$refs.mastheadDescription.offsetHeight;
          }, this.delay);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadReadmore.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsMasthead_MsMastheadReadmorevue_type_script_lang_js_ = MsMastheadReadmorevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadReadmore.vue

    /* normalize component */

    var MsMastheadReadmore_component = normalizeComponent(MsMasthead_MsMastheadReadmorevue_type_script_lang_js_, MsMastheadReadmorevue_type_template_id_411cafc2_render, MsMastheadReadmorevue_type_template_id_411cafc2_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsMastheadReadmore = MsMastheadReadmore_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMastheadContent.vue?vue&type=template&id=4aaf8d66&
    function MsMastheadContentvue_type_template_id_4aaf8d66_typeof(obj) {
      "@babel/helpers - typeof";

      return MsMastheadContentvue_type_template_id_4aaf8d66_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsMastheadContentvue_type_template_id_4aaf8d66_typeof(obj);
    }
    function MsMastheadContentvue_type_template_id_4aaf8d66_defineProperty(obj, key, value) {
      key = MsMastheadContentvue_type_template_id_4aaf8d66_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsMastheadContentvue_type_template_id_4aaf8d66_toPropertyKey(arg) {
      var key = MsMastheadContentvue_type_template_id_4aaf8d66_toPrimitive(arg, "string");
      return MsMastheadContentvue_type_template_id_4aaf8d66_typeof(key) === "symbol" ? key : String(key);
    }
    function MsMastheadContentvue_type_template_id_4aaf8d66_toPrimitive(input, hint) {
      if (MsMastheadContentvue_type_template_id_4aaf8d66_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsMastheadContentvue_type_template_id_4aaf8d66_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsMastheadContentvue_type_template_id_4aaf8d66_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "masthead__wrapper",
        class: [MsMastheadContentvue_type_template_id_4aaf8d66_defineProperty({}, "masthead__wrapper--".concat(_vm.use), Boolean(_vm.use))]
      }, [_vm.use && _vm.use === 'form' ? _c('ms-masthead-sticker', {
        attrs: {
          "use": _vm.use,
          "is-fixed": _vm.isStickerFixed
        },
        scopedSlots: _vm._u([{
          key: "info",
          fn: function fn() {
            return [_vm.stickerTitle ? _c('strong', {
              staticClass: "title"
            }, [_vm._v(_vm._s(_vm.stickerTitle))]) : _vm._e(), _vm.stickerSubtitle ? _c('span', {
              staticClass: "subtitle"
            }, [_vm._v(_vm._s(_vm.stickerSubtitle))]) : _vm._e()];
          },
          proxy: true
        }, {
          key: "action",
          fn: function fn() {
            return [_c('ms-link', {
              on: {
                "click": function click($event) {
                  $event.preventDefault();
                  return _vm.onClick.apply(null, arguments);
                }
              }
            }, [_c('ms-icon', {
              attrs: {
                "icon": ['fas', 'pencil']
              }
            }), _c('span', [_vm._v(_vm._s(_vm.stickerLabel))])], 1)];
          },
          proxy: true
        }], null, false, 2393112045)
      }) : _vm._e(), _c('div', {
        ref: "msatheadContent",
        staticClass: "masthead__content"
      }, [_vm._t("default")], 2)], 1);
    };
    var MsMastheadContentvue_type_template_id_4aaf8d66_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadContent.vue?vue&type=template&id=4aaf8d66&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMastheadSticker.vue?vue&type=template&id=3fd6e5d1&
    var MsMastheadStickervue_type_template_id_3fd6e5d1_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "masthead__sticker-wrapper"
      }, [_c('div', {
        staticClass: "masthead__sticker",
        class: {
          'is-fixed': _vm.use === 'form' && _vm.isFixed
        }
      }, [_c('div', {
        staticClass: "container"
      }, [_c('div', {
        staticClass: "masthead__sticker-header"
      }, [_c('div', {
        staticClass: "masthead__sticker-header--info"
      }, [_vm._t("info")], 2), _c('div', {
        staticClass: "masthead__sticker-header--action"
      }, [_vm._t("action")], 2)])])])]);
    };
    var MsMastheadStickervue_type_template_id_3fd6e5d1_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadSticker.vue?vue&type=template&id=3fd6e5d1&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMastheadSticker.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsMastheadStickervue_type_script_lang_js_ = {
      name: 'MsMastheadSticker',
      props: {
        /**
           * Set masthead type
           * @values filter, form
          */
        use: {
          type: String,
          default: null
        },
        /**
           * If set to true, this component will stick to the top on scroll
          */
        isFixed: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadSticker.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsMasthead_MsMastheadStickervue_type_script_lang_js_ = MsMastheadStickervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadSticker.vue

    /* normalize component */

    var MsMastheadSticker_component = normalizeComponent(MsMasthead_MsMastheadStickervue_type_script_lang_js_, MsMastheadStickervue_type_template_id_3fd6e5d1_render, MsMastheadStickervue_type_template_id_3fd6e5d1_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsMastheadSticker = MsMastheadSticker_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMasthead/MsMastheadContent.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsMastheadContentvue_type_script_lang_js_ = {
      name: 'MsMastheadContent',
      components: {
        MsMastheadSticker: MsMastheadSticker
      },
      props: {
        /**
         * Set masthead type
         * @values filter, form
        */
        use: {
          type: String,
          default: null
        },
        /**
         * Set the title of the sticker component
        */
        stickerTitle: {
          type: String,
          default: null
        },
        /**
         * Set the subtitle of the sticker component
        */
        stickerSubtitle: {
          type: String,
          default: null
        },
        /**
         * Set the label of the sticker component
        */
        stickerLabel: {
          type: String,
          default: 'Edit'
        }
      },
      data: function data() {
        return {
          isStickerFixed: false
        };
      },
      mounted: function mounted() {
        this.initWatcher();
      },
      methods: {
        initWatcher: function initWatcher() {
          var _this = this;
          /* eslint-disable global-require */
          this.scrollMonitor = __webpack_require__("bded");
          this.mastheadContentWatcher = this.scrollMonitor.create(this.$refs.msatheadContent);
          this.mastheadContentWatcher.exitViewport(function () {
            _this.isStickerFixed = true;
          });
          this.mastheadContentWatcher.enterViewport(function () {
            _this.isStickerFixed = false;
          });
        },
        onClick: function onClick() {
          this.$emit('click');
          this.scrollToTop();
        },
        scrollToTop: function scrollToTop() {
          if (document.body.scrollTop !== 0 || document.documentElement.scrollTop !== 0) {
            window.scrollBy(0, -50);
            requestAnimationFrame(this.scrollToTop);
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsMasthead_MsMastheadContentvue_type_script_lang_js_ = MsMastheadContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsMasthead/MsMastheadContent.vue

    /* normalize component */

    var MsMastheadContent_component = normalizeComponent(MsMasthead_MsMastheadContentvue_type_script_lang_js_, MsMastheadContentvue_type_template_id_4aaf8d66_render, MsMastheadContentvue_type_template_id_4aaf8d66_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsMastheadContent = MsMastheadContent_component.exports;
    // CONCATENATED MODULE: ./src/components/MsMasthead/index.js

    var MsMasthead_components = {
      MsMasthead: MsMasthead,
      MsMastheadReadmore: MsMastheadReadmore,
      MsMastheadContent: MsMastheadContent,
      MsMastheadSticker: MsMastheadSticker,
      MsIcon: MsIcon
    };
    MsMasthead.install = function (Vue) {
      Object.values(MsMasthead_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsMasthead = MsMasthead;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsModal/MsModal.vue?vue&type=template&id=6ae33730&
    var MsModalvue_type_template_id_6ae33730_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('transition', {
        attrs: {
          "name": _vm.toggleTransition
        },
        on: {
          "after-enter": _vm.onEnter,
          "after-leave": _vm.onLeave
        }
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isOpen,
          expression: "isOpen"
        }],
        staticClass: "modal modal__mask",
        class: _vm.classes,
        attrs: {
          "role": _vm.role
        },
        on: {
          "click": function click($event) {
            if ($event.target !== $event.currentTarget) return null;
            return _vm.onBackdropClick.apply(null, arguments);
          }
        }
      }, [_c('div', {
        staticClass: "modal__wrapper",
        class: {
          'has-dummy-scrollbar': _vm.preventShift
        },
        style: _vm.alignTopStyle,
        on: {
          "click": function click($event) {
            if ($event.target !== $event.currentTarget) return null;
            return _vm.onBackdropClick.apply(null, arguments);
          }
        }
      }, [_c('ms-focus-container', {
        ref: "focusContainer",
        staticClass: "modal__container",
        attrs: {
          "tabindex": "-1"
        },
        nativeOn: {
          "keydown": function keydown($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
            $event.stopPropagation();
            return _vm.onEsc.apply(null, arguments);
          }
        }
      }, [_vm._t("header", function () {
        return [!_vm.removeHeader ? _c('div', {
          staticClass: "modal__header"
        }, [_c('h2', {
          staticClass: "modal__header-text"
        }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e()];
      }), _c('div', {
        staticClass: "modal__close-button"
      }, [_vm.dismissOnCloseButton && !_vm.removeCloseButton && _vm.dismissible ? _c('button', {
        on: {
          "click": _vm.close
        }
      }, [_c('fa', {
        attrs: {
          "icon": ['fal', 'times']
        }
      })], 1) : _vm._e()]), _c('div', {
        staticClass: "modal__body"
      }, [_vm._t("default")], 2), _vm.hasFooter ? _c('div', {
        staticClass: "modal__footer"
      }, [_vm._t("footer")], 2) : _vm._e()], 2)], 1)])]);
    };
    var MsModalvue_type_template_id_6ae33730_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsModal/MsModal.vue?vue&type=template&id=6ae33730&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsModal/MsFocusContainer.vue?vue&type=template&id=398e6866&
    var MsFocusContainervue_type_template_id_398e6866_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c(_vm.tag, {
        tag: "component",
        staticClass: "ms-focus-container"
      }, [_vm.renderRedirector ? _c('span', {
        staticClass: "ms-focus-container__focus-redirector",
        attrs: {
          "tabindex": "0"
        },
        on: {
          "focus": function focus($event) {
            return _vm.redirectFocus($event, {
              isTabbingForward: false
            });
          }
        }
      }) : _vm._e(), _c('div', {
        ref: "content",
        staticClass: "ms-focus-container__content",
        attrs: {
          "tabindex": "-1"
        }
      }, [_vm._t("default")], 2), !_vm.disabled && _vm.containFocus ? _c('span', {
        ref: "lastFocusable",
        staticClass: "ms-focus-container__last-focusable",
        attrs: {
          "tabindex": "-1"
        }
      }) : _vm._e(), _vm.renderRedirector ? _c('span', {
        staticClass: "ms-focus-container__focus-redirector",
        attrs: {
          "tabindex": "0"
        },
        on: {
          "focus": function focus($event) {
            return _vm.redirectFocus($event, {
              isTabbingForward: true
            });
          }
        }
      }) : _vm._e()]);
    };
    var MsFocusContainervue_type_template_id_398e6866_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsModal/MsFocusContainer.vue?vue&type=template&id=398e6866&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsModal/MsFocusContainer.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFocusContainervue_type_script_lang_js_ = {
      name: 'MsFocusContainer',
      props: {
        containFocus: {
          type: Boolean,
          default: true
        },
        focusRedirector: Function,
        disabled: {
          type: Boolean,
          default: false
        },
        tag: {
          type: String,
          default: 'div'
        },
        lazy: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        renderRedirector: function renderRedirector() {
          if (this.disabled) {
            return false;
          }
          return this.lazy ? this.containFocus : true;
        }
      },
      methods: {
        focus: function focus() {
          this.$refs.content.focus();
        },
        redirectFocus: function redirectFocus(e, options) {
          if (!this.containFocus) {
            this.$emit('focus-overflow', e, options);
            return;
          }
          e.stopPropagation();
          if (this.focusRedirector) {
            this.focusRedirector(e, options);
            return;
          }
          if (options.isTabbingForward) {
            this.$refs.content.focus();
          } else {
            this.$refs.lastFocusable.focus();
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsModal/MsFocusContainer.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsModal_MsFocusContainervue_type_script_lang_js_ = MsFocusContainervue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsModal/MsFocusContainer.vue?vue&type=style&index=0&id=398e6866&prod&lang=scss&
    var MsFocusContainervue_type_style_index_0_id_398e6866_prod_lang_scss_ = __webpack_require__("7a9c");

    // CONCATENATED MODULE: ./src/components/MsModal/MsFocusContainer.vue

    /* normalize component */

    var MsFocusContainer_component = normalizeComponent(MsModal_MsFocusContainervue_type_script_lang_js_, MsFocusContainervue_type_template_id_398e6866_render, MsFocusContainervue_type_template_id_398e6866_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFocusContainer = MsFocusContainer_component.exports;
    // CONCATENATED MODULE: ./src/utils/classlist.js
    function classlist_toConsumableArray(arr) {
      return classlist_arrayWithoutHoles(arr) || classlist_iterableToArray(arr) || classlist_unsupportedIterableToArray(arr) || classlist_nonIterableSpread();
    }
    function classlist_nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function classlist_unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return classlist_arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return classlist_arrayLikeToArray(o, minLen);
    }
    function classlist_iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function classlist_arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return classlist_arrayLikeToArray(arr);
    }
    function classlist_arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function classlist_typeof(obj) {
      "@babel/helpers - typeof";

      return classlist_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, classlist_typeof(obj);
    }
    /**
     * Shamlessly adapted from dominus v6.0.1 :)
     * https://github.com/bevacqua/dominus/blob/master/src/classes.js
     */

    var trim = /^\s+|\s+$/g;
    var whitespace = /\s+/g;
    function isElementObject(o) {
      return o && classlist_typeof(o) === 'object' && typeof o.nodeName === 'string' && o.nodeType === 1;
    }
    function isElement(o) {
      var elementObjects = (typeof HTMLElement === "undefined" ? "undefined" : classlist_typeof(HTMLElement)) === 'object';
      return elementObjects ? o instanceof HTMLElement : isElementObject(o);
    }
    function classes(el) {
      if (isElement(el)) {
        return (el.getAttribute('class') || '').replace(trim, '').split(whitespace);
      }
      return [];
    }
    function interpret(input) {
      return typeof input === 'string' ? input.replace(trim, '').split(whitespace) : input;
    }
    function classlist_set(el, input) {
      if (isElement(el)) {
        el.setAttribute('class', interpret(input).join(' '));
      }
    }
    function remove(el, input) {
      var current = classes(el);
      var values = interpret(input);
      values.forEach(function (value) {
        var i = current.indexOf(value);
        if (i !== -1) {
          current.splice(i, 1);
        }
      });
      classlist_set(el, current);
      return current;
    }
    function add(el, input) {
      var current = remove(el, input);
      var values = interpret(input);
      current.push.apply(current, classlist_toConsumableArray(values));
      classlist_set(el, current);
      return current;
    }
    function contains(el, input) {
      var current = classes(el);
      var values = interpret(input);
      return values.every(function (value) {
        return current.indexOf(value) !== -1;
      });
    }
    /* harmony default export */
    var classlist = {
      add: add,
      remove: remove,
      contains: contains,
      has: contains,
      set: classlist_set,
      get: classes
    };
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsModal/MsModal.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsModalvue_type_script_lang_js_ = {
      name: 'MsModal',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Modal'
      },
      components: {
        MsFocusContainer: MsFocusContainer
      },
      props: {
        title: {
          type: String,
          default: 'Ms Modal title'
        },
        alignTop: {
          type: Boolean,
          default: false
        },
        alignTopMargin: {
          type: Number,
          default: 60
        },
        size: {
          type: String,
          default: 'm' // 's', 'm', 'l', 'fullscreen', or 'auto'
        },

        role: {
          type: String,
          default: 'dialog' // 'dialog' or 'alertdialog'
        },

        transition: {
          type: String,
          default: 'slide-up' // 'slide-down', or 'fade'
        },

        removeHeader: {
          type: Boolean,
          default: false
        },
        removeCloseButton: {
          type: Boolean,
          default: false
        },
        preventShift: {
          type: Boolean,
          default: false
        },
        dismissible: {
          type: Boolean,
          default: true
        },
        dismissOn: {
          type: String,
          default: 'backdrop esc close-button'
        },
        backdropBlur: {
          type: Boolean,
          default: false
        }
      },
      data: function data() {
        return {
          isOpen: false,
          lastFocusedElement: null
        };
      },
      computed: {
        // dynamic classes
        classes: function classes() {
          return ["modal--size-".concat(this.size), {
            'has-footer': this.hasFooter
          }, {
            'is-open': this.isOpen
          }, {
            'is-aligned-top': this.alignTop
          }, {
            'is-backdrop-blur': this.backdropBlur
          }];
        },
        alignTopStyle: function alignTopStyle() {
          if (this.alignTop) {
            return {
              'padding-top': "".concat(this.alignTopMargin, "px")
            };
          }
          return null;
        },
        toggleTransition: function toggleTransition() {
          return "modal--transition-".concat(this.transition);
        },
        hasFooter: function hasFooter() {
          return Boolean(this.$slots.footer);
        },
        dismissOnBackdrop: function dismissOnBackdrop() {
          return this.dismissOn.indexOf('backdrop') > -1;
        },
        dismissOnCloseButton: function dismissOnCloseButton() {
          return this.dismissOn.indexOf('close-button') > -1;
        },
        dismissOnEsc: function dismissOnEsc() {
          return this.dismissOn.indexOf('esc') > -1;
        }
      },
      watch: {
        isOpen: function isOpen() {
          var _this = this;
          this.$nextTick(function () {
            _this[_this.isOpen ? 'onOpen' : 'onClose']();
          });
        }
      },
      beforeDestroy: function beforeDestroy() {
        if (this.isOpen) {
          this.returnFocus();
        }
      },
      methods: {
        open: function open() {
          this.isOpen = true;
        },
        close: function close() {
          if (!this.dismissible) {
            return;
          }
          this.isOpen = false;
        },
        // Accessabiliy try
        redirectFocus: function redirectFocus() {
          this.$refs.focusContainer.focus();
        },
        returnFocus: function returnFocus() {
          if (this.lastFocusedElement) {
            this.lastFocusedElement.focus();
          }
        },
        // Dismiss modal on backdrop click
        onBackdropClick: function onBackdropClick() {
          if (this.dismissOnBackdrop) {
            this.close();
          } else {
            this.redirectFocus();
          }
        },
        // Dismiss modal on esc key
        onEsc: function onEsc() {
          if (this.dismissOnEsc) {
            this.close();
          }
        },
        onOpen: function onOpen() {
          this.lastFocusedElement = document.activeElement;
          this.$refs.focusContainer.focus();

          // Add modal open class on body tag (good for future cases if modications are required)
          classlist.add(document.body, 'modal--is-open');
          this.incrementOpenModalCount();
          this.$emit('open');
        },
        // will be emitted when modal starts to close
        onClose: function onClose() {
          this.returnFocus();
          this.$emit('close');
        },
        // will be emitted after transition is done and opened
        onEnter: function onEnter() {
          this.$emit('reveal');
        },
        // will be emitted after transition is done and closes
        onLeave: function onLeave() {
          this.$emit('hide');
          var newCount = this.decrementOpenModalCount();

          // Remove modal open class on body tag
          if (newCount === 0) {
            classlist.remove(document.body, 'modal--is-open');
          }
        },
        getOpenModalCount: function getOpenModalCount() {
          var count = document.body.getAttribute('data-open-modals');
          return count === undefined ? 0 : Number(count);
        },
        // Set no. of modals open data attribute
        setOpenModalCount: function setOpenModalCount(count) {
          var normalizedCount = Math.max(0, count);
          if (normalizedCount === 0) {
            document.body.removeAttribute('data-open-modals');
          } else {
            document.body.setAttribute('data-open-modals', normalizedCount);
          }
          return normalizedCount;
        },
        // Used if nested modals get activated
        incrementOpenModalCount: function incrementOpenModalCount() {
          return this.setOpenModalCount(this.getOpenModalCount() + 1);
        },
        decrementOpenModalCount: function decrementOpenModalCount() {
          return this.setOpenModalCount(this.getOpenModalCount() - 1);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsModal/MsModal.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsModal_MsModalvue_type_script_lang_js_ = MsModalvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsModal/MsModal.vue?vue&type=style&index=0&id=6ae33730&prod&lang=scss&
    var MsModalvue_type_style_index_0_id_6ae33730_prod_lang_scss_ = __webpack_require__("01f1");

    // CONCATENATED MODULE: ./src/components/MsModal/MsModal.vue

    /* normalize component */

    var MsModal_component = normalizeComponent(MsModal_MsModalvue_type_script_lang_js_, MsModalvue_type_template_id_6ae33730_render, MsModalvue_type_template_id_6ae33730_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsModal = MsModal_component.exports;
    // CONCATENATED MODULE: ./src/components/MsModal/index.js

    MsModal.install = function (Vue) {
      return Vue.component(MsModal.name, MsModal);
    };
    /* harmony default export */
    var components_MsModal = MsModal;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMultiselect/MsMultiselect.vue?vue&type=template&id=a49b0a00&
    var MsMultiselectvue_type_template_id_a49b0a00_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "ms-multiselect",
        class: {
          'ms-multiselect--single': !_vm.mergedConfig.multiple
        }
      }, [_c('multiselect', _vm._b({
        ref: "multiselect",
        attrs: {
          "options": _vm.options
        },
        on: {
          "input": function input($event) {
            return _vm.$emit('input', _vm.mutableValue);
          },
          "search-change": function searchChange($event) {
            return _vm.$emit('search-change', $event);
          }
        },
        scopedSlots: _vm._u([{
          key: "singleLabel",
          fn: function fn(props) {
            return [_c('span', {
              staticClass: "multiselect__single-select"
            }, [_c('label', {
              staticClass: "multiselect__single-select__label"
            }, [_vm._v(_vm._s(_vm.mergedConfig.placeholder))]), _c('span', {
              staticClass: "multiselect__single-select__selected"
            }, [_vm._v(_vm._s(props.option[_vm.mergedConfig.label]))])])];
          }
        }, {
          key: "tag",
          fn: function fn(_ref) {
            var option = _ref.option,
              remove = _ref.remove;
            return [_c('span', {
              staticClass: "multiselect__tag"
            }, [_c('span', [_vm._v(_vm._s(option[_vm.mergedConfig.selectedCustomLabel]))]), _c('fa', {
              staticClass: "multiselect__tag-icon multiselect__tag-custom-icon",
              attrs: {
                "icon": ['fal', 'times'],
                "aria-hidden": "true",
                "tabindex": "1"
              },
              on: {
                "click": function click($event) {
                  return remove(option);
                }
              }
            })], 1)];
          }
        }, {
          key: "option",
          fn: function fn(_ref2) {
            var option = _ref2.option;
            return [_c('span', [_vm._v(_vm._s(option[_vm.mergedConfig.selectedCustomLabel]))]), _vm.mergedConfig.multiple && _vm.selectedValues.includes(option.value) ? _c('fa', {
              staticClass: "multiselect__tag-icon multiselect__option--selected__tag-custom-icon",
              attrs: {
                "icon": ['fal', 'times'],
                "aria-hidden": "true",
                "tabindex": "1"
              }
            }) : _vm._e()];
          }
        }]),
        model: {
          value: _vm.mutableValue,
          callback: function callback($$v) {
            _vm.mutableValue = $$v;
          },
          expression: "mutableValue"
        }
      }, 'multiselect', _vm.mergedConfig, false), [_c('template', {
        slot: "noResult"
      }, [_vm._v(_vm._s(_vm.mergedConfig.emptyMessage))]), _c('template', {
        slot: "noOptions"
      }, [_vm._v(_vm._s(_vm.mergedConfig.emptyOptionsMessage))])], 2)], 1);
    };
    var MsMultiselectvue_type_template_id_a49b0a00_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsMultiselect/MsMultiselect.vue?vue&type=template&id=a49b0a00&

    // EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.css
    var vue_multiselect_min = __webpack_require__("e607");

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsMultiselect/MsMultiselect.vue?vue&type=script&lang=js&
    function MsMultiselectvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsMultiselectvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsMultiselectvue_type_script_lang_js_typeof(obj);
    }
    function MsMultiselectvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsMultiselectvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsMultiselectvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsMultiselectvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsMultiselectvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsMultiselectvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsMultiselectvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsMultiselectvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsMultiselectvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsMultiselectvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsMultiselectvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsMultiselectvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsMultiselectvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }

    /* harmony default export */
    var MsMultiselectvue_type_script_lang_js_ = {
      name: 'MsMultiselect',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Multiselect'
      },
      components: {
        Multiselect: function Multiselect() {
          return __webpack_require__.e( /* import() */3).then(__webpack_require__.t.bind(null, "8e5f", 7));
        }
      },
      props: {
        /**
         * Binds the input model in the parent component.
        */
        value: {
          type: [Array, Object]
        },
        /**
         * Option list for the dropdown
        */
        options: {
          type: Array,
          required: true
        },
        /**
         * Holds all vue-multiselect options, please visit https://vue-multiselect.js.org/#sub-props for more details
        */
        config: {
          type: Object
        }
      },
      data: function data() {
        return {
          defaultConfig: {
            multiple: true,
            closeOnSelect: true,
            preserveSearch: true,
            label: 'name',
            trackBy: 'name',
            selectedCustomLabel: 'name',
            selectLabel: '',
            selectedLabel: '',
            deselectLabel: '',
            emptyMessage: "No matches found! Please try another search."
          },
          mutableValue: JSON.parse(JSON.stringify(this.value))
        };
      },
      computed: {
        selectedValues: function selectedValues() {
          if (this.mergedConfig.multiple) {
            return this.mutableValue ? this.mutableValue.map(function (item) {
              return item.value;
            }) : [];
          }
          return this.mutableValue;
        },
        mergedConfig: function mergedConfig() {
          return MsMultiselectvue_type_script_lang_js_objectSpread(MsMultiselectvue_type_script_lang_js_objectSpread({}, this.defaultConfig), this.config);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsMultiselect/MsMultiselect.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsMultiselect_MsMultiselectvue_type_script_lang_js_ = MsMultiselectvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsMultiselect/MsMultiselect.vue?vue&type=style&index=0&id=a49b0a00&prod&lang=scss&
    var MsMultiselectvue_type_style_index_0_id_a49b0a00_prod_lang_scss_ = __webpack_require__("c792");

    // CONCATENATED MODULE: ./src/components/MsMultiselect/MsMultiselect.vue

    /* normalize component */

    var MsMultiselect_component = normalizeComponent(MsMultiselect_MsMultiselectvue_type_script_lang_js_, MsMultiselectvue_type_template_id_a49b0a00_render, MsMultiselectvue_type_template_id_a49b0a00_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsMultiselect = MsMultiselect_component.exports;
    // CONCATENATED MODULE: ./src/components/MsMultiselect/index.js

    MsMultiselect.install = function (Vue) {
      return Vue.component(MsMultiselect.name, MsMultiselect);
    };
    /* harmony default export */
    var components_MsMultiselect = MsMultiselect;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotification.vue?vue&type=template&id=354aa250&
    function MsNotificationvue_type_template_id_354aa250_typeof(obj) {
      "@babel/helpers - typeof";

      return MsNotificationvue_type_template_id_354aa250_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsNotificationvue_type_template_id_354aa250_typeof(obj);
    }
    function MsNotificationvue_type_template_id_354aa250_defineProperty(obj, key, value) {
      key = MsNotificationvue_type_template_id_354aa250_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsNotificationvue_type_template_id_354aa250_toPropertyKey(arg) {
      var key = MsNotificationvue_type_template_id_354aa250_toPrimitive(arg, "string");
      return MsNotificationvue_type_template_id_354aa250_typeof(key) === "symbol" ? key : String(key);
    }
    function MsNotificationvue_type_template_id_354aa250_toPrimitive(input, hint) {
      if (MsNotificationvue_type_template_id_354aa250_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsNotificationvue_type_template_id_354aa250_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsNotificationvue_type_template_id_354aa250_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _vm.showNotification ? _c('div', {
        staticClass: "notification",
        class: MsNotificationvue_type_template_id_354aa250_defineProperty({
          'notification--inline': _vm.inline,
          'notification--small': _vm.small,
          'notification--dim-background': _vm.dimBackground
        }, "notification--".concat(_vm.type), Boolean(_vm.type))
      }, [_c('div', {
        staticClass: "notification__inner",
        class: {
          'container': !_vm.fullWidth
        }
      }, [_c('div', {
        staticClass: "notification__container container"
      }, [!_vm.hideClose ? _c('div', {
        staticClass: "notification__close"
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['fal', 'times']
        },
        on: {
          "click": _vm.close
        }
      })], 1) : _vm._e(), _c('div', {
        staticClass: "notification__icon"
      }, [_c('ms-icon', {
        attrs: {
          "icon": _vm.notificationIcon
        }
      })], 1), _c('div', {
        staticClass: "notification__content"
      }, [_vm._t("default")], 2)])])]) : _vm._e();
    };
    var MsNotificationvue_type_template_id_354aa250_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotification.vue?vue&type=template&id=354aa250&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotification.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsNotificationvue_type_script_lang_js_ = {
      name: 'MsNotification',
      components: {
        MsIcon: MsIcon
      },
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Notification'
      },
      props: {
        fullWidth: {
          type: Boolean,
          default: false
        },
        inline: {
          type: Boolean,
          default: false
        },
        small: {
          type: Boolean,
          default: false
        },
        hideClose: {
          type: Boolean,
          default: false
        },
        dimBackground: {
          type: Boolean,
          default: true
        },
        type: {
          type: String,
          required: false
        },
        icon: {
          type: Array,
          required: false
        }
      },
      data: function data() {
        return {
          showNotification: this.inline
        };
      },
      computed: {
        notificationIcon: function notificationIcon() {
          if (this.icon) {
            return this.icon;
          }
          if (this.type === 'success') {
            return ['fas', 'check-circle'];
          }
          if (this.type === 'error') {
            return ['fas', 'exclamation-circle'];
          }
          return ['fas', 'info-circle'];
        }
      },
      watch: {
        showNotification: function showNotification(newValue) {
          var bodyOverflow = newValue ? 'hidden' : 'auto';
          this.setNotificationBody(bodyOverflow);
        }
      },
      beforeDestroy: function beforeDestroy() {
        this.setNotificationBody('auto');
      },
      methods: {
        open: function open() {
          this.showNotification = true;
        },
        close: function close() {
          this.showNotification = false;
          this.$emit('close');
        },
        setNotificationBody: function setNotificationBody(bodyOverflow) {
          if (document.body) {
            document.body.style.overflow = bodyOverflow;
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotification.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotification_MsNotificationvue_type_script_lang_js_ = MsNotificationvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotification.vue

    /* normalize component */

    var MsNotification_component = normalizeComponent(MsNotification_MsNotificationvue_type_script_lang_js_, MsNotificationvue_type_template_id_354aa250_render, MsNotificationvue_type_template_id_354aa250_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsNotification = MsNotification_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationBody.vue?vue&type=template&id=6dcd2ca5&
    var MsNotificationBodyvue_type_template_id_6dcd2ca5_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "notification__body"
      }, [_vm._t("default")], 2);
    };
    var MsNotificationBodyvue_type_template_id_6dcd2ca5_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationBody.vue?vue&type=template&id=6dcd2ca5&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationBody.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotificationBodyvue_type_script_lang_js_ = {
      name: 'MsNotificationBody'
    };
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationBody.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotification_MsNotificationBodyvue_type_script_lang_js_ = MsNotificationBodyvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationBody.vue

    /* normalize component */

    var MsNotificationBody_component = normalizeComponent(MsNotification_MsNotificationBodyvue_type_script_lang_js_, MsNotificationBodyvue_type_template_id_6dcd2ca5_render, MsNotificationBodyvue_type_template_id_6dcd2ca5_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsNotificationBody = MsNotificationBody_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationLink.vue?vue&type=template&id=8cdfa0a6&
    var MsNotificationLinkvue_type_template_id_8cdfa0a6_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "notification__link"
      }, [_vm._t("default")], 2);
    };
    var MsNotificationLinkvue_type_template_id_8cdfa0a6_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationLink.vue?vue&type=template&id=8cdfa0a6&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationLink.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotificationLinkvue_type_script_lang_js_ = {
      name: 'MsNotificationLink'
    };
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationLink.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotification_MsNotificationLinkvue_type_script_lang_js_ = MsNotificationLinkvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationLink.vue

    /* normalize component */

    var MsNotificationLink_component = normalizeComponent(MsNotification_MsNotificationLinkvue_type_script_lang_js_, MsNotificationLinkvue_type_template_id_8cdfa0a6_render, MsNotificationLinkvue_type_template_id_8cdfa0a6_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsNotificationLink = MsNotificationLink_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationMeta.vue?vue&type=template&id=277315ce&
    var MsNotificationMetavue_type_template_id_277315ce_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "notification__meta"
      }, [_vm._t("default")], 2);
    };
    var MsNotificationMetavue_type_template_id_277315ce_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationMeta.vue?vue&type=template&id=277315ce&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationMeta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotificationMetavue_type_script_lang_js_ = {
      name: 'MsNotificationMeta'
    };
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationMeta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotification_MsNotificationMetavue_type_script_lang_js_ = MsNotificationMetavue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationMeta.vue

    /* normalize component */

    var MsNotificationMeta_component = normalizeComponent(MsNotification_MsNotificationMetavue_type_script_lang_js_, MsNotificationMetavue_type_template_id_277315ce_render, MsNotificationMetavue_type_template_id_277315ce_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsNotificationMeta = MsNotificationMeta_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationTitle.vue?vue&type=template&id=701cc975&
    var MsNotificationTitlevue_type_template_id_701cc975_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "notification__title"
      }, [_vm._t("default")], 2);
    };
    var MsNotificationTitlevue_type_template_id_701cc975_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationTitle.vue?vue&type=template&id=701cc975&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsNotification/MsNotificationTitle.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotificationTitlevue_type_script_lang_js_ = {
      name: 'MsNotificationTitle'
    };
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationTitle.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsNotification_MsNotificationTitlevue_type_script_lang_js_ = MsNotificationTitlevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsNotification/MsNotificationTitle.vue

    /* normalize component */

    var MsNotificationTitle_component = normalizeComponent(MsNotification_MsNotificationTitlevue_type_script_lang_js_, MsNotificationTitlevue_type_template_id_701cc975_render, MsNotificationTitlevue_type_template_id_701cc975_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsNotificationTitle = MsNotificationTitle_component.exports;
    // CONCATENATED MODULE: ./src/components/MsNotification/index.js

    var MsNotification_components = {
      MsNotification: MsNotification,
      MsNotificationBody: MsNotificationBody,
      MsNotificationLink: MsNotificationLink,
      MsNotificationMeta: MsNotificationMeta,
      MsNotificationTitle: MsNotificationTitle
    };
    MsNotification.install = function (Vue) {
      Object.values(MsNotification_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsNotification = MsNotification;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsOneColumnContent/MsOneColumnContent.vue?vue&type=template&id=e3d01f42&
    var MsOneColumnContentvue_type_template_id_e3d01f42_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "one-column-content"
      }, [_c('div', {
        staticClass: "one-column-content__content-wrapper"
      }, [_vm._t("section-header"), _c('div', {
        staticClass: "one-column-content__row-wrapper"
      }, [_c('div', {
        staticClass: "one-column-content__column-wrapper"
      }, [_vm._t("default")], 2)])], 2), _c('div', {
        staticClass: "one-column-content__image-wrapper"
      }, [_c('ms-image', {
        staticClass: "one-column-content__image",
        attrs: {
          "src": _vm.imageUrl,
          "alt": _vm.imageAlt,
          "width": "410",
          "height": "392"
        }
      })], 1)]);
    };
    var MsOneColumnContentvue_type_template_id_e3d01f42_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsOneColumnContent/MsOneColumnContent.vue?vue&type=template&id=e3d01f42&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsOneColumnContent/MsOneColumnContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsOneColumnContentvue_type_script_lang_js_ = {
      name: 'MsOneColumnContent',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/One Column Content'
      },
      props: {
        /**
         * Sets image url
         */
        imageUrl: {
          type: String,
          default: 'https://assets.cdn-moneysmart.com/assets/cargo/images/mirfrekv623o0ze8flxl.png'
        },
        /**
         * Sets image alt
         */
        imageAlt: {
          type: String,
          default: 'background image'
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsOneColumnContent/MsOneColumnContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsOneColumnContent_MsOneColumnContentvue_type_script_lang_js_ = MsOneColumnContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsOneColumnContent/MsOneColumnContent.vue

    /* normalize component */

    var MsOneColumnContent_component = normalizeComponent(MsOneColumnContent_MsOneColumnContentvue_type_script_lang_js_, MsOneColumnContentvue_type_template_id_e3d01f42_render, MsOneColumnContentvue_type_template_id_e3d01f42_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsOneColumnContent = MsOneColumnContent_component.exports;
    // CONCATENATED MODULE: ./src/components/MsOneColumnContent/index.js

    var MsOneColumnContent_components = {
      MsOneColumnContent: MsOneColumnContent
    };
    MsOneColumnContent.install = function (Vue) {
      Object.values(MsOneColumnContent_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsOneColumnContent = MsOneColumnContent;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsPagination/MsPagination.vue?vue&type=template&id=33866245&
    var MsPaginationvue_type_template_id_33866245_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "pagination"
      }, [_c('div', {
        staticClass: "pagination__label"
      }, [_vm._v("\n    " + _vm._s(_vm.pageResultLabel) + "\n  ")]), _c('nav', {
        staticClass: "pagination__navigation",
        attrs: {
          "role": "navigation",
          "aria-label": "Page Navigation"
        }
      }, [_c('ul', [_vm.showArrow ? _c('li', [_c('ms-link', {
        class: {
          'is-disabled': _vm.isFirstPage
        },
        attrs: {
          "href": "#",
          "aria-label": "Go to previous page"
        },
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.clickPrev.apply(null, arguments);
          }
        }
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['fal', 'angle-left']
        }
      })], 1)], 1) : _vm._e(), _vm._l(_vm.pageRange, function (page, index) {
        return _c('li', {
          key: index
        }, [_c('ms-link', {
          class: {
            'is-active': _vm.isPageActive(page)
          },
          attrs: {
            "href": "#",
            "aria-label": "Go to page ".concat(page),
            "aria-current": _vm.isPageActive(page) ? 'true' : false
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.clickPage(page);
            }
          }
        }, [_vm._v("\n          " + _vm._s(page) + "\n        ")])], 1);
      }), _vm.showArrow ? _c('li', [_c('ms-link', {
        class: {
          'is-disabled': _vm.isLastPage
        },
        attrs: {
          "href": "#",
          "aria-label": "Go to next page"
        },
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.clickNext.apply(null, arguments);
          }
        }
      }, [_c('ms-icon', {
        attrs: {
          "icon": ['fal', 'angle-right']
        }
      })], 1)], 1) : _vm._e()], 2)])]);
    };
    var MsPaginationvue_type_template_id_33866245_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsPagination/MsPagination.vue?vue&type=template&id=33866245&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsPagination/MsPagination.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsPaginationvue_type_script_lang_js_ = {
      name: 'MsPagination',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Pagination'
      },
      props: {
        total: {
          type: Number,
          required: true
        },
        limit: {
          type: Number,
          required: false,
          default: 10
        },
        currentPage: {
          type: Number,
          required: true
        },
        pageSize: {
          type: Number,
          required: false,
          default: 5
        },
        pageLabel: {
          type: String,
          required: false
        }
      },
      computed: {
        totalPages: function totalPages() {
          return Math.ceil(this.total / this.limit);
        },
        rangeStart: function rangeStart() {
          if (this.currentPage === this.totalPages && this.totalPages > this.pageSize) {
            return this.currentPage - (this.pageSize - 1);
          }
          if (this.currentPage >= this.pageSize && this.totalPages > this.pageSize) {
            return this.currentPage - (this.pageSize - 2);
          }
          return 1;
        },
        rangeEnd: function rangeEnd() {
          return Math.min(this.rangeStart + this.pageSize - 1, this.totalPages);
        },
        pageRange: function pageRange() {
          var range = [];
          for (var i = this.rangeStart; i <= this.rangeEnd; i += 1) {
            range.push(i);
          }
          return range;
        },
        isFirstPage: function isFirstPage() {
          return this.currentPage === 1;
        },
        isLastPage: function isLastPage() {
          return this.currentPage === this.totalPages;
        },
        showArrow: function showArrow() {
          return this.totalPages > this.pageSize;
        },
        pageResultLabel: function pageResultLabel() {
          var startOf = (this.currentPage - 1) * this.limit + 1;
          var endOf = this.isLastPage ? this.total : this.currentPage * this.limit;
          return this.pageLabel ? this.pageLabel : "Showing ".concat(startOf, " to ").concat(endOf, " of ").concat(this.total, " results");
        }
      },
      methods: {
        clickPrev: function clickPrev() {
          this.$emit('pageChanged', this.currentPage - 1, 'click-previous');
        },
        clickNext: function clickNext() {
          this.$emit('pageChanged', this.currentPage + 1, 'click-next');
        },
        clickPage: function clickPage(page) {
          this.$emit('pageChanged', page, 'click-page-number');
        },
        isPageActive: function isPageActive(page) {
          return this.currentPage === page;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsPagination/MsPagination.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsPagination_MsPaginationvue_type_script_lang_js_ = MsPaginationvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsPagination/MsPagination.vue

    /* normalize component */

    var MsPagination_component = normalizeComponent(MsPagination_MsPaginationvue_type_script_lang_js_, MsPaginationvue_type_template_id_33866245_render, MsPaginationvue_type_template_id_33866245_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsPagination = MsPagination_component.exports;
    // CONCATENATED MODULE: ./src/components/MsPagination/index.js

    MsPagination.install = function (Vue) {
      return Vue.component(MsPagination.name, MsPagination);
    };
    /* harmony default export */
    var components_MsPagination = MsPagination;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsParagraph/MsParagraph.vue?vue&type=template&id=e2319b24&
    var MsParagraphvue_type_template_id_e2319b24_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _vm.disableHtml ? _c('p', {
        class: _vm.$attrs.staticClass || ''
      }, [_vm._v(_vm._s(_vm.content))]) : _c('p', {
        class: _vm.$attrs.staticClass || '',
        domProps: {
          "innerHTML": _vm._s(_vm.content)
        }
      });
    };
    var MsParagraphvue_type_template_id_e2319b24_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsParagraph/MsParagraph.vue?vue&type=template&id=e2319b24&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsParagraph/MsParagraph.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsParagraphvue_type_script_lang_js_ = {
      name: 'MsParagraph',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Paragraph'
      },
      props: {
        disableHtml: {
          type: Boolean,
          default: false
        },
        content: {
          type: String,
          default: ''
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsParagraph/MsParagraph.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsParagraph_MsParagraphvue_type_script_lang_js_ = MsParagraphvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsParagraph/MsParagraph.vue

    /* normalize component */

    var MsParagraph_component = normalizeComponent(MsParagraph_MsParagraphvue_type_script_lang_js_, MsParagraphvue_type_template_id_e2319b24_render, MsParagraphvue_type_template_id_e2319b24_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsParagraph = MsParagraph_component.exports;
    // CONCATENATED MODULE: ./src/components/MsParagraph/index.js

    MsParagraph.install = function (Vue) {
      return Vue.component(MsParagraph.name, MsParagraph);
    };
    /* harmony default export */
    var components_MsParagraph = MsParagraph;
    // CONCATENATED MODULE: ./src/components/MsPromotionSnippet/index.js

    MsPromotionSnippet.install = function (Vue) {
      return Vue.component(MsPromotionSnippet.name, MsPromotionSnippet);
    };
    /* harmony default export */
    var components_MsPromotionSnippet = MsPromotionSnippet;
    // CONCATENATED MODULE: ./src/components/MsProgressBar/index.js

    var MsProgressBar_components = {
      MsProgressBar: MsProgressBar
    };
    MsProgressBar.install = function (Vue) {
      Object.values(MsProgressBar_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsProgressBar = MsProgressBar;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickFacts/MsQuickFacts.vue?vue&type=template&id=71b641c5&scoped=true&
    var MsQuickFactsvue_type_template_id_71b641c5_scoped_true_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "quick-facts"
      }, [_vm.title ? _c('h2', {
        staticClass: "quick-facts__title"
      }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm.items.length ? _c('div', {
        staticClass: "quick-facts__items",
        class: {
          'quick-facts__items--has-top-border': _vm.use === 'expandable'
        }
      }, [_vm._l(_vm.items, function (item, index) {
        return [_c('ms-quick-facts-item', {
          key: index,
          attrs: {
            "in-last-row": _vm.checkIfItemIsInLastRow(_vm.items.length, index, _vm.columns),
            "label": item.label,
            "description": item.description,
            "icon": item.icon
          }
        })];
      })], 2) : _vm._e()]);
    };
    var MsQuickFactsvue_type_template_id_71b641c5_scoped_true_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsQuickFacts/MsQuickFacts.vue?vue&type=template&id=71b641c5&scoped=true&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickFacts/MsQuickFactsItem.vue?vue&type=template&id=6a532b16&
    var MsQuickFactsItemvue_type_template_id_6a532b16_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "quick-facts__item",
        class: {
          'quick-facts__item--no-bottom-border': _vm.inLastRow
        }
      }, [_c('ms-icon', {
        staticClass: "quick-facts__icon",
        attrs: {
          "icon": _vm.icon
        }
      }), _c('div', {
        staticClass: "quick-facts__content"
      }, [_c('h3', {
        staticClass: "quick-facts__label"
      }, [_vm._v(_vm._s(_vm.label))]), _c('p', {
        staticClass: "quick-facts__description"
      }, [_vm._v(_vm._s(_vm.description))])])], 1);
    };
    var MsQuickFactsItemvue_type_template_id_6a532b16_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsQuickFacts/MsQuickFactsItem.vue?vue&type=template&id=6a532b16&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickFacts/MsQuickFactsItem.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsQuickFactsItemvue_type_script_lang_js_ = {
      name: 'MsQuickFactsItem',
      components: {
        MsIcon: MsIcon
      },
      props: {
        /**
         * Quick Fact Item Label
        */
        label: {
          type: String,
          required: true
        },
        /**
         * Quick Fact Item Description
        */
        description: {
          type: String,
          required: true
        },
        /**
         * Quick Fact Item Icon
         * Default is check
        */
        icon: {
          type: Array,
          default: function _default() {
            return ['far', 'check'];
          }
        },
        /**
         * Checks if item is in last row
        */
        inLastRow: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsQuickFacts/MsQuickFactsItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuickFacts_MsQuickFactsItemvue_type_script_lang_js_ = MsQuickFactsItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsQuickFacts/MsQuickFactsItem.vue

    /* normalize component */

    var MsQuickFactsItem_component = normalizeComponent(MsQuickFacts_MsQuickFactsItemvue_type_script_lang_js_, MsQuickFactsItemvue_type_template_id_6a532b16_render, MsQuickFactsItemvue_type_template_id_6a532b16_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsQuickFactsItem = MsQuickFactsItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickFacts/MsQuickFacts.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsQuickFactsvue_type_script_lang_js_ = {
      name: 'MsQuickFacts',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/QuickFacts'
      },
      components: {
        MsQuickFactsItem: MsQuickFactsItem
      },
      props: {
        /**
         * Applies variants
         * @values expandable
        */
        use: {
          type: String,
          required: false
        },
        /**
         * Quick facts title
        */
        title: {
          type: String,
          required: false
        },
        /**
         * Fact items array
        */
        items: {
          type: Array,
          required: true
        },
        /**
         * Number of columns (for future variants)
        */
        columns: {
          type: Number,
          default: 2
        }
      },
      methods: {
        checkIfItemIsInLastRow: function checkIfItemIsInLastRow(arrayLength, index, columns) {
          return index === arrayLength - columns && arrayLength % 2 === 0;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsQuickFacts/MsQuickFacts.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuickFacts_MsQuickFactsvue_type_script_lang_js_ = MsQuickFactsvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsQuickFacts/MsQuickFacts.vue?vue&type=style&index=0&id=71b641c5&prod&lang=scss&scoped=true&
    var MsQuickFactsvue_type_style_index_0_id_71b641c5_prod_lang_scss_scoped_true_ = __webpack_require__("52e8");

    // CONCATENATED MODULE: ./src/components/MsQuickFacts/MsQuickFacts.vue

    /* normalize component */

    var MsQuickFacts_component = normalizeComponent(MsQuickFacts_MsQuickFactsvue_type_script_lang_js_, MsQuickFactsvue_type_template_id_71b641c5_scoped_true_render, MsQuickFactsvue_type_template_id_71b641c5_scoped_true_staticRenderFns, false, null, "71b641c5", null);

    /* harmony default export */
    var MsQuickFacts = MsQuickFacts_component.exports;
    // CONCATENATED MODULE: ./src/components/MsQuickFacts/index.js

    var MsQuickFacts_components = {
      MsQuickFacts: MsQuickFacts,
      MsQuickFactsItem: MsQuickFactsItem
    };
    MsQuickFacts.install = function (Vue) {
      Object.values(MsQuickFacts_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsQuickFacts = MsQuickFacts;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuotationParagraph/MsQuotationParagraph.vue?vue&type=template&id=81ec4d1c&
    var MsQuotationParagraphvue_type_template_id_81ec4d1c_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "quotation-paragraph"
      }, [_c('ms-heading', {
        staticClass: "quotation-paragraph__title",
        attrs: {
          "heading-tag": "h2"
        }
      }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
        staticClass: "quotation-paragraph__content"
      }, [_vm.youtubeId && _vm.isVideoAtTop ? _c('div', {
        staticClass: "quotation-paragraph__video-wrapper"
      }, [_c('iframe', {
        attrs: {
          "width": "100%",
          "height": "100%",
          "src": 'https://www.youtube.com/embed/' + _vm.youtubeId,
          "frameborder": "0",
          "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          "allowfullscreen": ""
        }
      })]) : _vm._e(), _c(_vm.dynamicBlurb, {
        tag: "component"
      }), _vm.youtubeId && _vm.isVideoAtBottom ? _c('div', {
        staticClass: "quotation-paragraph__video-wrapper"
      }, [_c('iframe', {
        attrs: {
          "width": "100%",
          "height": "100%",
          "src": 'https://www.youtube.com/embed/' + _vm.youtubeId,
          "frameborder": "0",
          "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          "allowfullscreen": ""
        }
      })]) : _vm._e()], 1)], 1);
    };
    var MsQuotationParagraphvue_type_template_id_81ec4d1c_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsQuotationParagraph/MsQuotationParagraph.vue?vue&type=template&id=81ec4d1c&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuotationParagraph/MsQuotationParagraph.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsQuotationParagraphvue_type_script_lang_js_ = {
      name: 'MsQuotationParagraph',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Quotation Paragraph'
      },
      components: {
        MsHeading: MsHeading
      },
      props: {
        /**
         * Sets title
        */
        title: {
          type: String,
          default: ''
        },
        /**
         * Sets content text
        */
        content: {
          type: String,
          required: false
        },
        /**
         * Sets the YouTube video to be embedded
        */
        youtubeLink: {
          type: String,
          default: ''
        },
        /**
         * Sets embedded video's position to be above or below the text
        */
        videoPosition: {
          type: String,
          default: null
        }
      },
      computed: {
        isVideoAtTop: function isVideoAtTop() {
          return this.videoPosition === 'above';
        },
        isVideoAtBottom: function isVideoAtBottom() {
          return this.videoPosition === 'below';
        },
        youtubeId: function youtubeId() {
          // Grab video ID from different types of URLs
          if (this.youtubeLink === '') return null;
          var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          var match = this.youtubeLink.match(regExp);
          return match && match[2].length === 11 ? match[2] : null;
        },
        dynamicBlurb: function dynamicBlurb() {
          return {
            // Dynamically compilation of the blurb so we can use MSQuoteText cargo component
            template: "<div>".concat(this.content.replace(/<blockquote>(.+?)<\/blockquote>/gi, "<ms-quote-text color='blue'>$1</ms-quote-text>"), "</div>")
          };
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsQuotationParagraph/MsQuotationParagraph.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuotationParagraph_MsQuotationParagraphvue_type_script_lang_js_ = MsQuotationParagraphvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsQuotationParagraph/MsQuotationParagraph.vue

    /* normalize component */

    var MsQuotationParagraph_component = normalizeComponent(MsQuotationParagraph_MsQuotationParagraphvue_type_script_lang_js_, MsQuotationParagraphvue_type_template_id_81ec4d1c_render, MsQuotationParagraphvue_type_template_id_81ec4d1c_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsQuotationParagraph = MsQuotationParagraph_component.exports;
    // CONCATENATED MODULE: ./src/components/MsQuotationParagraph/index.js

    MsQuotationParagraph.install = function (Vue) {
      return Vue.component(MsQuotationParagraph.name, MsQuotationParagraph);
    };
    /* harmony default export */
    var components_MsQuotationParagraph = MsQuotationParagraph;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuoteText/MsQuoteText.vue?vue&type=template&id=df10e31e&
    function MsQuoteTextvue_type_template_id_df10e31e_typeof(obj) {
      "@babel/helpers - typeof";

      return MsQuoteTextvue_type_template_id_df10e31e_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsQuoteTextvue_type_template_id_df10e31e_typeof(obj);
    }
    function MsQuoteTextvue_type_template_id_df10e31e_defineProperty(obj, key, value) {
      key = MsQuoteTextvue_type_template_id_df10e31e_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsQuoteTextvue_type_template_id_df10e31e_toPropertyKey(arg) {
      var key = MsQuoteTextvue_type_template_id_df10e31e_toPrimitive(arg, "string");
      return MsQuoteTextvue_type_template_id_df10e31e_typeof(key) === "symbol" ? key : String(key);
    }
    function MsQuoteTextvue_type_template_id_df10e31e_toPrimitive(input, hint) {
      if (MsQuoteTextvue_type_template_id_df10e31e_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsQuoteTextvue_type_template_id_df10e31e_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    var MsQuoteTextvue_type_template_id_df10e31e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "quote-text",
        class: MsQuoteTextvue_type_template_id_df10e31e_defineProperty({
          'quote-text--bold': Boolean(_vm.bold)
        }, "quote-text--".concat(_vm.color), Boolean(_vm.color))
      }, [_c('svg', {
        attrs: {
          "id": "quote",
          "width": "23",
          "height": "18",
          "viewBox": "0 0 23 18",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M0 11.6163C0 9.76744 0.627366 7.80523 1.8821 5.72965C3.15402 3.63663 5.44003 1.72674 8.74015 0L9.35892 1.17733C7.70886 2.36337 6.48851 3.35756 5.69785 4.15988C4.30562 5.60756 3.6095 6.99419 3.6095 8.31977C3.6095 8.77326 3.73841 9.06977 3.99623 9.2093C4.25405 9.36628 4.4775 9.44477 4.66657 9.44477C5.31972 9.35756 5.74942 9.31395 5.95568 9.31395C7.05571 9.31395 7.95809 9.72384 8.6628 10.5436C9.36751 11.3459 9.71987 12.3227 9.71987 13.4738C9.71987 14.7645 9.33314 15.8459 8.55967 16.718C7.78621 17.5727 6.72055 18 5.36269 18C3.76419 18 2.46649 17.4244 1.46958 16.2733C0.489861 15.1047 0 13.5523 0 11.6163ZM12.7801 11.6163C12.7801 9.66279 13.4505 7.64826 14.7911 5.57267C16.1318 3.49709 18.3749 1.63953 21.5203 0L22.139 1.17733C20.5921 2.27616 19.4061 3.24419 18.5811 4.0814C17.1201 5.56395 16.3896 6.94186 16.3896 8.21512C16.3896 8.5814 16.4842 8.87791 16.6732 9.10465C16.8623 9.3314 17.1201 9.44477 17.4467 9.44477C18.0998 9.35756 18.5296 9.31395 18.7358 9.31395C19.8187 9.31395 20.7124 9.71512 21.4172 10.5174C22.139 11.3198 22.5 12.3052 22.5 13.4738C22.5 14.8343 22.1047 15.9331 21.314 16.7703C20.5234 17.5901 19.4491 18 18.0913 18C16.5443 18 15.2724 17.4244 14.2755 16.2733C13.2786 15.1047 12.7801 13.5523 12.7801 11.6163Z"
        }
      })]), _vm._t("default")], 2);
    };
    var MsQuoteTextvue_type_template_id_df10e31e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsQuoteText/MsQuoteText.vue?vue&type=template&id=df10e31e&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuoteText/MsQuoteText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuoteTextvue_type_script_lang_js_ = {
      name: 'MsQuoteText',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Quote Text'
      },
      props: {
        bold: {
          type: Boolean,
          default: null
        },
        color: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsQuoteText/MsQuoteText.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuoteText_MsQuoteTextvue_type_script_lang_js_ = MsQuoteTextvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsQuoteText/MsQuoteText.vue

    /* normalize component */

    var MsQuoteText_component = normalizeComponent(MsQuoteText_MsQuoteTextvue_type_script_lang_js_, MsQuoteTextvue_type_template_id_df10e31e_render, MsQuoteTextvue_type_template_id_df10e31e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsQuoteText = MsQuoteText_component.exports;
    // CONCATENATED MODULE: ./src/components/MsQuoteText/index.js

    MsQuoteText.install = function (Vue) {
      return Vue.component(MsQuoteText.name, MsQuoteText);
    };
    /* harmony default export */
    var components_MsQuoteText = MsQuoteText;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsRadioButton/MsRadioButton.vue?vue&type=template&id=3bca898c&
    var MsRadioButtonvue_type_template_id_3bca898c_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('fieldset', {
        staticClass: "input-group",
        class: {
          'input-field--error': _vm.isError
        },
        attrs: {
          "aria-describedby": "help_text_".concat(_vm.id),
          "aria-required": _vm.isRequired ? 'true' : false
        }
      }, [_c('div', [_c('legend', {
        staticClass: "input-group__legend",
        class: {
          'is-conversational': _vm.isConversational
        }
      }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
        staticClass: "required-field"
      }, [_vm._v("*")]) : _vm._e(), _vm._t("tooltip")], 2), _vm.isConversational && _vm.helpText ? _c('span', {
        staticClass: "convo-input__notice",
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v("\n      " + _vm._s(_vm.helpText) + "\n    ")]) : _vm._e()]), _c('div', {
        staticClass: "input-group__items",
        class: {
          'is-reverse': Boolean(_vm.reverse),
          'has-no-border': Boolean(_vm.hideBorder),
          'is-disabled': Boolean(_vm.isDisabled)
        }
      }, [_vm._t("default")], 2), !_vm.isConversational && _vm.helpText ? _c('span', {
        staticClass: "input-field__notice",
        class: {
          'input-field__notice--description': !_vm.isError,
          'input-field__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v(_vm._s(_vm.helpText))]) : _vm._e(), _vm.isConversational && _vm.isError && _vm.errorText ? _c('span', {
        staticClass: "convo-input__notice convo-input__notice--error-text"
      }, [_vm._v("\n    " + _vm._s(_vm.errorText) + "\n  ")]) : _vm._e()]);
    };
    var MsRadioButtonvue_type_template_id_3bca898c_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsRadioButton/MsRadioButton.vue?vue&type=template&id=3bca898c&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsRadioButton/MsRadioButton.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsRadioButtonvue_type_script_lang_js_ = {
      name: 'MsRadioButton',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Form Fields/Radio'
      },
      mixins: [FormRadioCheckbox],
      inheritAttrs: false
    };
    // CONCATENATED MODULE: ./src/components/MsRadioButton/MsRadioButton.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsRadioButton_MsRadioButtonvue_type_script_lang_js_ = MsRadioButtonvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsRadioButton/MsRadioButton.vue

    /* normalize component */

    var MsRadioButton_component = normalizeComponent(MsRadioButton_MsRadioButtonvue_type_script_lang_js_, MsRadioButtonvue_type_template_id_3bca898c_render, MsRadioButtonvue_type_template_id_3bca898c_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsRadioButton = MsRadioButton_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsRadioButton/MsRadioButtonItem.vue?vue&type=template&id=3c97376a&
    var MsRadioButtonItemvue_type_template_id_3c97376a_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "input-group__item radio"
      }, [_c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
        staticClass: "input-group__item-container"
      }, [_c('div', {
        staticClass: "input-group__item-wrap"
      }, [_c('input', {
        attrs: {
          "id": _vm.id,
          "type": "radio",
          "name": _vm.name,
          "disabled": Boolean(_vm.isDisabled)
        },
        domProps: {
          "value": _vm.value,
          "checked": _vm.value === _vm.modelValue ? 'checked' : ''
        },
        on: {
          "change": function change($event) {
            return _vm.$emit('input', $event.target.value);
          }
        }
      })])])]);
    };
    var MsRadioButtonItemvue_type_template_id_3c97376a_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsRadioButton/MsRadioButtonItem.vue?vue&type=template&id=3c97376a&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsRadioButton/MsRadioButtonItem.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsRadioButtonItemvue_type_script_lang_js_ = {
      name: 'MsRadioButtonItem',
      mixins: [FormFields, FormRadioCheckboxItem],
      inheritAttrs: false,
      props: {
        modelValue: {
          type: [Array, String],
          required: true
        },
        /**
         * Specifies if checkbox/radio button item is disabled
        */
        isDisabled: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsRadioButton/MsRadioButtonItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsRadioButton_MsRadioButtonItemvue_type_script_lang_js_ = MsRadioButtonItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsRadioButton/MsRadioButtonItem.vue

    /* normalize component */

    var MsRadioButtonItem_component = normalizeComponent(MsRadioButton_MsRadioButtonItemvue_type_script_lang_js_, MsRadioButtonItemvue_type_template_id_3c97376a_render, MsRadioButtonItemvue_type_template_id_3c97376a_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsRadioButtonItem = MsRadioButtonItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsRadioButton/index.js

    var MsRadioButton_components = {
      MsRadioButton: MsRadioButton,
      MsRadioButtonItem: MsRadioButtonItem
    };
    MsRadioButton.install = function (Vue) {
      Object.values(MsRadioButton_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsRadioButton = MsRadioButton;
    // CONCATENATED MODULE: ./src/components/MsRating/index.js

    MsRating.install = function (Vue) {
      return Vue.component(MsRating.name, MsRating);
    };
    /* harmony default export */
    var components_MsRating = MsRating;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSection/MsSection.vue?vue&type=template&id=4ff7f959&
    var MsSectionvue_type_template_id_4ff7f959_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('section', {
        class: ['section', _vm.bgColorClass],
        style: _vm.sectionStyling,
        attrs: {
          "id": _vm.id
        }
      }, [!_vm.fullWidth ? [_c('div', {
        staticClass: "container"
      }, [_vm._t("header"), _vm._t("default")], 2)] : [_vm._t("header"), _vm._t("default")]], 2);
    };
    var MsSectionvue_type_template_id_4ff7f959_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsSection/MsSection.vue?vue&type=template&id=4ff7f959&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSection/MsSection.vue?vue&type=script&lang=js&
    function MsSectionvue_type_script_lang_js_typeof(obj) {
      "@babel/helpers - typeof";

      return MsSectionvue_type_script_lang_js_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, MsSectionvue_type_script_lang_js_typeof(obj);
    }
    function MsSectionvue_type_script_lang_js_ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function MsSectionvue_type_script_lang_js_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? MsSectionvue_type_script_lang_js_ownKeys(Object(source), !0).forEach(function (key) {
          MsSectionvue_type_script_lang_js_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MsSectionvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function MsSectionvue_type_script_lang_js_defineProperty(obj, key, value) {
      key = MsSectionvue_type_script_lang_js_toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function MsSectionvue_type_script_lang_js_toPropertyKey(arg) {
      var key = MsSectionvue_type_script_lang_js_toPrimitive(arg, "string");
      return MsSectionvue_type_script_lang_js_typeof(key) === "symbol" ? key : String(key);
    }
    function MsSectionvue_type_script_lang_js_toPrimitive(input, hint) {
      if (MsSectionvue_type_script_lang_js_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (MsSectionvue_type_script_lang_js_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    /* harmony default export */
    var MsSectionvue_type_script_lang_js_ = {
      name: 'MsSection',
      storybook: {
        path: 'Cargo Product Language/Patterns/Perceptual Pattern/Section'
      },
      props: {
        /**
         * Sets full with or container width
        */
        fullWidth: {
          type: Boolean,
          default: false
        },
        /**
         * Sets background color using cargo color variable or Hex code
        */
        bgColor: {
          type: String,
          // List defined predefiend color names here:
          // https://github.com/moneysmartco/cargo/blob/f191fdb9d31a13e5d7338abc402a33b21f14f955/src/styles/utilities/_common.scss#L29-L64
          // e.g. true-blue
          default: 'white'
        },
        /**
         * Sets text color using hex code
        */
        textColor: {
          type: String,
          default: '#333'
        },
        /**
         * Adds id for anchor tags
        */
        id: {
          type: String,
          required: false
        }
      },
      computed: {
        bgColorClass: function bgColorClass() {
          var isHexCode = this.bgColor.startsWith('#');
          return !isHexCode ? "bg-".concat(this.bgColor) : '';
        },
        sectionStyling: function sectionStyling() {
          var isHexCode = this.bgColor.startsWith('#');
          return MsSectionvue_type_script_lang_js_objectSpread(MsSectionvue_type_script_lang_js_objectSpread({}, isHexCode ? {
            backgroundColor: this.bgColor
          } : {}), {}, {
            color: this.textColor
          });
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSection/MsSection.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSection_MsSectionvue_type_script_lang_js_ = MsSectionvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSection/MsSection.vue

    /* normalize component */

    var MsSection_component = normalizeComponent(MsSection_MsSectionvue_type_script_lang_js_, MsSectionvue_type_template_id_4ff7f959_render, MsSectionvue_type_template_id_4ff7f959_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSection = MsSection_component.exports;
    // CONCATENATED MODULE: ./src/components/MsSection/index.js

    MsSection.install = function (Vue) {
      return Vue.component(MsSection.name, MsSection);
    };
    /* harmony default export */
    var components_MsSection = MsSection;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSectionHeader/MsSectionHeader.vue?vue&type=template&id=e0aac190&
    var MsSectionHeadervue_type_template_id_e0aac190_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "section-header",
        class: {
          'has-width-constraint': _vm.customWidth
        }
      }, [_vm._t("default")], 2);
    };
    var MsSectionHeadervue_type_template_id_e0aac190_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsSectionHeader/MsSectionHeader.vue?vue&type=template&id=e0aac190&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSectionHeader/MsSectionHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSectionHeadervue_type_script_lang_js_ = {
      name: 'MsSectionHeader',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Section Header'
      },
      props: {
        /**
         * Sets custom width of the container
         */
        customWidth: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSectionHeader/MsSectionHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSectionHeader_MsSectionHeadervue_type_script_lang_js_ = MsSectionHeadervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSectionHeader/MsSectionHeader.vue

    /* normalize component */

    var MsSectionHeader_component = normalizeComponent(MsSectionHeader_MsSectionHeadervue_type_script_lang_js_, MsSectionHeadervue_type_template_id_e0aac190_render, MsSectionHeadervue_type_template_id_e0aac190_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSectionHeader = MsSectionHeader_component.exports;
    // CONCATENATED MODULE: ./src/components/MsSectionHeader/index.js

    MsSectionHeader.install = function (Vue) {
      return Vue.component(MsSectionHeader.name, MsSectionHeader);
    };
    /* harmony default export */
    var components_MsSectionHeader = MsSectionHeader;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSegmentedControl/MsSegmentedControl.vue?vue&type=template&id=e6ec477e&
    var MsSegmentedControlvue_type_template_id_e6ec477e_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('fieldset', {
        staticClass: "segmented-control-group",
        class: {
          'input-field--error': _vm.isError
        },
        attrs: {
          "aria-describedby": "help_text_".concat(_vm.id)
        }
      }, [_c('legend', {
        staticClass: "segmented-control-group__legend"
      }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
        staticClass: "segmented-control-group__items",
        class: {
          'segmented-control-group--dual': _vm.$slots.default && _vm.$slots.default.length <= 2,
          'segmented-control-group--disabled': _vm.isDisabled
        }
      }, [_vm._t("default")], 2), _vm.helpText ? _c('span', {
        staticClass: "input-field__notice",
        class: {
          'input-field__notice--description': !_vm.isError,
          'input-field--error': _vm.isError,
          'input-field__notice--error-text': _vm.isError
        },
        attrs: {
          "id": "help_text_".concat(_vm.id)
        }
      }, [_vm._v(_vm._s(_vm.helpText))]) : _vm._e()]);
    };
    var MsSegmentedControlvue_type_template_id_e6ec477e_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsSegmentedControl/MsSegmentedControl.vue?vue&type=template&id=e6ec477e&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSegmentedControl/MsSegmentedControl.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsSegmentedControlvue_type_script_lang_js_ = {
      name: 'MsSegmentedControl',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Form Fields/Segmented Controls'
      },
      mixins: [FormRadioCheckbox],
      inheritAttrs: false
    };
    // CONCATENATED MODULE: ./src/components/MsSegmentedControl/MsSegmentedControl.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSegmentedControl_MsSegmentedControlvue_type_script_lang_js_ = MsSegmentedControlvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSegmentedControl/MsSegmentedControl.vue

    /* normalize component */

    var MsSegmentedControl_component = normalizeComponent(MsSegmentedControl_MsSegmentedControlvue_type_script_lang_js_, MsSegmentedControlvue_type_template_id_e6ec477e_render, MsSegmentedControlvue_type_template_id_e6ec477e_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSegmentedControl = MsSegmentedControl_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSegmentedControl/MsSegmentedControlItem.vue?vue&type=template&id=538ab54a&
    var MsSegmentedControlItemvue_type_template_id_538ab54a_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "segmented-control-group__item"
      }, [_c('input', _vm._b({
        attrs: {
          "id": _vm.id,
          "type": "radio",
          "name": _vm.name,
          "disabled": Boolean(_vm.isDisabled)
        },
        domProps: {
          "value": _vm.value,
          "checked": _vm.value === _vm.modelValue ? 'checked' : ''
        },
        on: {
          "change": function change($event) {
            return _vm.$emit('input', $event.target.value);
          }
        }
      }, 'input', _vm.$attrs, false)), _c('label', {
        attrs: {
          "for": _vm.id
        }
      }, [_vm._v(_vm._s(_vm.parsedText))])]);
    };
    var MsSegmentedControlItemvue_type_template_id_538ab54a_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsSegmentedControl/MsSegmentedControlItem.vue?vue&type=template&id=538ab54a&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSegmentedControl/MsSegmentedControlItem.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsSegmentedControlItemvue_type_script_lang_js_ = {
      name: 'MsSegmentedControlItem',
      mixins: [FormFields, FormRadioCheckboxItem],
      inheritAttrs: false,
      props: {
        modelValue: {
          type: String,
          required: true
        },
        /**
         * Maximum length of the item label
        */
        maxLength: {
          type: Number,
          default: 16
        },
        /**
         * Specifies if segmented control item is disabled
        */
        isDisabled: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        parsedText: function parsedText() {
          if (this.label.length > this.maxLength) {
            return "".concat(this.label.substring(0, this.maxLength - 1), "...");
          }
          return this.label;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSegmentedControl/MsSegmentedControlItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSegmentedControl_MsSegmentedControlItemvue_type_script_lang_js_ = MsSegmentedControlItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSegmentedControl/MsSegmentedControlItem.vue

    /* normalize component */

    var MsSegmentedControlItem_component = normalizeComponent(MsSegmentedControl_MsSegmentedControlItemvue_type_script_lang_js_, MsSegmentedControlItemvue_type_template_id_538ab54a_render, MsSegmentedControlItemvue_type_template_id_538ab54a_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSegmentedControlItem = MsSegmentedControlItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsSegmentedControl/index.js

    var MsSegmentedControl_components = {
      MsSegmentedControl: MsSegmentedControl,
      MsSegmentedControlItem: MsSegmentedControlItem
    };
    MsSegmentedControl.install = function (Vue) {
      Object.values(MsSegmentedControl_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsSegmentedControl = MsSegmentedControl;
    // CONCATENATED MODULE: ./src/components/MsShare/index.js

    var MsShare_components = {
      MsShare: MsShare,
      MsShareButton: MsShareButton,
      MsShareCopyClipboard: MsShareCopyClipboard,
      MsShareItem: MsShareItem
    };
    MsShare.install = function (Vue) {
      Object.values(MsShare_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsShare = MsShare;
    // CONCATENATED MODULE: ./src/components/MsSponsored/index.js

    var MsSponsored_components = {
      MsSponsored: MsSponsored,
      MsSponsoredText: MsSponsoredText,
      MsSponsoredLink: MsSponsoredLink
    };
    MsSponsored.install = function (Vue) {
      Object.values(MsSponsored_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsSponsored = MsSponsored;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsStepsColumn/MsStepsColumn.vue?vue&type=template&id=cf9ee136&
    var MsStepsColumnvue_type_template_id_cf9ee136_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "steps-column",
        class: [_vm.$attrs.class, _vm.$attrs.staticClass]
      }, [_c('div', {
        staticClass: "steps-column__header"
      }, [_vm._t("section-header")], 2), _c('div', {
        staticClass: "steps-column__content"
      }, [_vm._t("default")], 2)]);
    };
    var MsStepsColumnvue_type_template_id_cf9ee136_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsStepsColumn/MsStepsColumn.vue?vue&type=template&id=cf9ee136&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsStepsColumn/MsStepsColumn.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsStepsColumnvue_type_script_lang_js_ = {
      name: 'MsStepsColumn',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Steps Column'
      }
    };
    // CONCATENATED MODULE: ./src/components/MsStepsColumn/MsStepsColumn.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsStepsColumn_MsStepsColumnvue_type_script_lang_js_ = MsStepsColumnvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsStepsColumn/MsStepsColumn.vue

    /* normalize component */

    var MsStepsColumn_component = normalizeComponent(MsStepsColumn_MsStepsColumnvue_type_script_lang_js_, MsStepsColumnvue_type_template_id_cf9ee136_render, MsStepsColumnvue_type_template_id_cf9ee136_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsStepsColumn = MsStepsColumn_component.exports;
    // CONCATENATED MODULE: ./src/components/MsStepsColumn/index.js

    var MsStepsColumn_components = {
      MsStepsColumn: MsStepsColumn
    };
    MsStepsColumn.install = function (Vue) {
      Object.values(MsStepsColumn_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsStepsColumn = MsStepsColumn;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsStepIndicator/MsStepIndicator.vue?vue&type=template&id=35978232&
    var MsStepIndicatorvue_type_template_id_35978232_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('nav', {
        staticClass: "step-indicator"
      }, [_c('ol', {
        staticClass: "step-indicator__list",
        attrs: {
          "tabindex": "0",
          "role": "progressbar",
          "aria-valuemin": "1",
          "aria-valuemax": _vm.numSteps,
          "aria-valuenow": _vm.activeStepIndex,
          "aria-valuetext": _vm.activeStepText
        }
      }, [_vm._t("default")], 2)]);
    };
    var MsStepIndicatorvue_type_template_id_35978232_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsStepIndicator/MsStepIndicator.vue?vue&type=template&id=35978232&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsStepIndicator/MsStepIndicator.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsStepIndicatorvue_type_script_lang_js_ = {
      name: 'MsStepIndicator',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Step Indicator'
      },
      props: {
        /**
         * i18n option to pass in translation for 'completed' step
         */
        completedText: {
          type: String,
          required: false,
          default: 'Completed'
        },
        /**
         * i18n option to pass in translation for 'not completed' step
         */
        notCompletedText: {
          type: String,
          required: false,
          default: 'Not Completed'
        }
      },
      data: function data() {
        return {
          numSteps: 0,
          activeStepIndex: null,
          activeStepText: null
        };
      },
      created: function created() {
        var _this = this;
        this.$on('child-changed', function () {
          _this.numSteps = _this.$children.length;
          _this.activeStepIndex = _this.getActiveStepIndex();
          _this.activeStepText = _this.getActiveStepText();
          _this.setStatusText();
        });
      },
      methods: {
        getActiveStepIndex: function getActiveStepIndex() {
          return this.$children.findIndex(function (child) {
            return child.active === true;
          });
        },
        getActiveStepText: function getActiveStepText() {
          if (this.activeStepIndex && this.activeStepIndex !== -1) {
            return this.$children[this.activeStepIndex].$slots.default[0].text;
          }
          return null;
        },
        setStatusText: function setStatusText() {
          var _this2 = this;
          this.$children.forEach(function (child, index) {
            if (index < _this2.activeStepIndex) {
              child.isComplete();
            } else {
              child.isNotComplete();
            }
          });
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsStepIndicator/MsStepIndicator.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsStepIndicator_MsStepIndicatorvue_type_script_lang_js_ = MsStepIndicatorvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsStepIndicator/MsStepIndicator.vue

    /* normalize component */

    var MsStepIndicator_component = normalizeComponent(MsStepIndicator_MsStepIndicatorvue_type_script_lang_js_, MsStepIndicatorvue_type_template_id_35978232_render, MsStepIndicatorvue_type_template_id_35978232_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsStepIndicator = MsStepIndicator_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsStepIndicator/MsStepIndicatorItem.vue?vue&type=template&id=d05bbdf8&
    var MsStepIndicatorItemvue_type_template_id_d05bbdf8_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        staticClass: "step-indicator__item",
        class: {
          'step-indicator--active': _vm.active
        },
        attrs: {
          "aria-hidden": "true"
        }
      }, [_c(_vm.href ? 'a' : 'span', {
        tag: "component",
        staticClass: "step-indicator__title",
        attrs: {
          "href": _vm.href || false
        }
      }, [_c('span', {
        staticClass: "step-indicator__icon"
      }, [!_vm.useFontAwesome ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.icon)
        }
      }) : _c('fa', {
        staticClass: "fa-2x",
        attrs: {
          "icon": _vm.icon
        }
      })], 1), _c('span', {
        staticClass: "step-indicator__label"
      }, [_vm._t("default")], 2), _c('span', {
        staticClass: "visually-hidden"
      }, [_vm._v(_vm._s(_vm.statusText))])])], 1);
    };
    var MsStepIndicatorItemvue_type_template_id_d05bbdf8_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsStepIndicator/MsStepIndicatorItem.vue?vue&type=template&id=d05bbdf8&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsStepIndicator/MsStepIndicatorItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsStepIndicatorItemvue_type_script_lang_js_ = {
      name: 'MsStepIndicatorItem',
      props: {
        /**
         * Link location if clickable
        */
        href: {
          type: String,
          required: false,
          default: null
        },
        /**
         * Icon as a string of SVG, or an array if using font awesome
        */
        icon: {
          type: [String, Array],
          required: false,
          default: null
        },
        /**
         * Set true for the active step
        */
        active: {
          type: Boolean,
          required: false,
          default: null
        },
        /**
         * Option to select if supplying a SVG source or using font-awesome array
         */
        useFontAwesome: {
          type: Boolean,
          required: false,
          default: false
        }
      },
      data: function data() {
        return {
          statusText: ''
        };
      },
      watch: {
        active: function active() {
          this.$parent.$emit('child-changed');
        }
      },
      mounted: function mounted() {
        this.$parent.$emit('child-changed');
      },
      methods: {
        isComplete: function isComplete() {
          this.statusText = this.$parent.completedText;
        },
        isNotComplete: function isNotComplete() {
          this.statusText = this.$parent.notCompletedText;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsStepIndicator/MsStepIndicatorItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsStepIndicator_MsStepIndicatorItemvue_type_script_lang_js_ = MsStepIndicatorItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsStepIndicator/MsStepIndicatorItem.vue

    /* normalize component */

    var MsStepIndicatorItem_component = normalizeComponent(MsStepIndicator_MsStepIndicatorItemvue_type_script_lang_js_, MsStepIndicatorItemvue_type_template_id_d05bbdf8_render, MsStepIndicatorItemvue_type_template_id_d05bbdf8_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsStepIndicatorItem = MsStepIndicatorItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsStepIndicator/index.js

    var MsStepIndicator_components = {
      MsStepIndicator: MsStepIndicator,
      MsStepIndicatorItem: MsStepIndicatorItem
    };
    MsStepIndicator.install = function (Vue) {
      Object.values(MsStepIndicator_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsStepIndicator = MsStepIndicator;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSummaryCard/MsSummaryCard.vue?vue&type=template&id=0beef3d4&
    var MsSummaryCardvue_type_template_id_0beef3d4_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "summary-card",
        class: {
          'summary-card--bordered': _vm.bordered,
          'summary-card--promotion': _vm.promotion,
          'summary-card--fresh-cyan': _vm.theme === 'cyan',
          'summary-card--true-blue': _vm.theme === 'blue',
          'summary-card--smart-green': _vm.theme === 'green',
          'summary-card--epic-yellow': _vm.theme === 'yellow'
        }
      }, [_vm.theme ? _c('div', {
        staticClass: "summary-card__line"
      }) : _vm._e(), _c('div', {
        staticClass: "summary-card__meta"
      }, [_vm.badgeLabel ? _c('ms-badge', {
        attrs: {
          "type": _vm.badgeType
        }
      }, [_vm._v("\n      " + _vm._s(_vm.badgeLabel) + "\n    ")]) : _vm._e(), _vm.hasImage ? _c('div', {
        staticClass: "summary-card__image"
      }, [_vm._t("default")], 2) : _vm._e()], 1), _c('div', {
        staticClass: "summary-card__content",
        class: {
          'summary-card__content--full-width': !_vm.hasImage
        }
      }, [_c('ms-link', {
        attrs: {
          "href": _vm.ctaUrl,
          "target": _vm.ctaTarget
        },
        on: {
          "click": _vm.onLinkCtaClick
        }
      }, [_c('p', {
        staticClass: "summary-card__title",
        style: _vm.titleLinesStyle,
        domProps: {
          "innerHTML": _vm._s(_vm.title)
        }
      })]), _c('p', {
        staticClass: "summary-card__description",
        style: _vm.descLinesStyle
      }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]), _vm.ctaLabel ? _c('ms-button', {
        attrs: {
          "use": "ghost--secondary",
          "size": "sm",
          "rounded": "",
          "href": _vm.ctaUrl,
          "target": _vm.ctaTarget
        },
        on: {
          "click": _vm.onButtonCtaClick
        }
      }, [_vm._v("\n      " + _vm._s(_vm.ctaLabel) + "\n    ")]) : _vm._e()], 1)]);
    };
    var MsSummaryCardvue_type_template_id_0beef3d4_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsSummaryCard/MsSummaryCard.vue?vue&type=template&id=0beef3d4&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSummaryCard/MsSummaryCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSummaryCardvue_type_script_lang_js_ = {
      name: 'MsSummaryCard',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Summary Card'
      },
      props: {
        /**
         * Enables border for the card
         */
        bordered: {
          type: Boolean,
          default: false
        },
        /**
         * Enables promotion variant
         */
        promotion: {
          type: Boolean,
          default: false
        },
        /**
         * Sets theme of the left border
         * @values cyan, blue, green, yellow
         */
        theme: {
          type: String,
          default: null
        },
        /**
         * Text for the CTA button
         */
        ctaLabel: {
          type: String,
          required: true
        },
        /**
         * Url for the CTA and the title
         */
        ctaUrl: {
          type: String,
          required: true
        },
        /**
         * Sets the CTA/title to open in current tab or others
         */
        ctaTarget: {
          type: String,
          default: '_self'
        },
        /**
         * Title of the card
         */
        title: {
          type: String,
          default: null
        },
        /**
         * Description of the card
         */
        description: {
          type: String,
          default: null
        },
        /**
         * Type of badge
         * @values 'plain', 'exclusive', 'primary', ''
         */
        badgeType: {
          type: String,
          default: 'plain'
        },
        /**
         * Label of badge
         */
        badgeLabel: {
          type: String,
          default: null
        },
        /**
         * Number of lines to show before truncating for title
         */
        titleLines: {
          type: Number,
          default: null
        },
        /**
         * Number of lines to show before truncating for description
         */
        descLines: {
          type: Number,
          default: null
        }
      },
      computed: {
        titleLinesStyle: function titleLinesStyle() {
          return "-webkit-line-clamp: ".concat(this.titleLines);
        },
        descLinesStyle: function descLinesStyle() {
          return "-webkit-line-clamp: ".concat(this.descLines);
        },
        hasImage: function hasImage() {
          return !!this.$slots.default;
        }
      },
      methods: {
        onLinkCtaClick: function onLinkCtaClick() {
          this.$emit('link-cta-click');
        },
        onButtonCtaClick: function onButtonCtaClick() {
          this.$emit('button-cta-click');
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSummaryCard/MsSummaryCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSummaryCard_MsSummaryCardvue_type_script_lang_js_ = MsSummaryCardvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSummaryCard/MsSummaryCard.vue

    /* normalize component */

    var MsSummaryCard_component = normalizeComponent(MsSummaryCard_MsSummaryCardvue_type_script_lang_js_, MsSummaryCardvue_type_template_id_0beef3d4_render, MsSummaryCardvue_type_template_id_0beef3d4_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSummaryCard = MsSummaryCard_component.exports;
    // CONCATENATED MODULE: ./src/components/MsSummaryCard/index.js

    var MsSummaryCard_components = {
      MsSummaryCard: MsSummaryCard,
      MsBadge: MsBadge
    };
    MsSummaryCard.install = function (Vue) {
      Object.values(MsSummaryCard_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsSummaryCard = MsSummaryCard;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTooltip/MsTooltip.vue?vue&type=template&id=2dcb0d4c&
    var MsTooltipvue_type_template_id_2dcb0d4c_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "tooltip",
        class: {
          'has-click-trigger': _vm.trigger === 'click' || _vm.trigger === 'manual'
        }
      }, [_c('v-popover', {
        attrs: {
          "trigger": _vm.trigger,
          "placement": _vm.position,
          "popover-class": "tooltip--".concat(_vm.use),
          "popper-options": _vm.popperOptions,
          "boundaries-element": _vm.boundary
        },
        on: {
          "show": function show($event) {
            return _vm.$emit('show');
          }
        }
      }, [_c('ms-icon', {
        class: "tooltip__icon--".concat(_vm.icon),
        attrs: {
          "icon": _vm.parseIcon
        }
      }), _c('template', {
        slot: "popover"
      }, [_vm.title ? _c('div', {
        staticClass: "tooltip__header"
      }, [_c('ms-icon', {
        attrs: {
          "icon": _vm.parseIcon
        }
      }), _vm.title ? _c('span', {
        staticClass: "tooltip__title"
      }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _c('div', {
        staticClass: "tooltip__content"
      }, [_vm._t("default")], 2), _vm.hasFooter ? _c('div', {
        staticClass: "tooltip__footer"
      }, [_vm._t("footer")], 2) : _vm._e()])], 2)], 1);
    };
    var MsTooltipvue_type_template_id_2dcb0d4c_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTooltip/MsTooltip.vue?vue&type=template&id=2dcb0d4c&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTooltip/MsTooltip.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsTooltipvue_type_script_lang_js_ = {
      name: 'MsTooltip',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Tooltip'
      },
      components: {
        MsIcon: MsIcon,
        VPopover: v_tooltip_esm["a" /* VPopover */]
      },

      props: {
        /**
         * Title for tooltip
        */
        title: {
          type: String,
          required: false
        },
        /**
         * Applies one of Cargo color variant to button
         * @values blue, navy, grey, white
        */
        use: {
          type: String,
          default: 'blue'
        },
        /**
         * Changes the position of the tooltip popup
         * @values auto, top, right, bottom, left
        */
        position: {
          type: String,
          default: 'auto'
        },
        /**
         * Changes trigger mode of the tooltip, can be separated with spaces
         * @values 'hover', 'click', 'focus' or 'manual' ('manual' can't be combined with any other event).
        */
        trigger: {
          type: String,
          default: 'hover focus'
        },
        /**
         * Icon for both the trigger and title in the header
         * @values 'info', 'extensive'.
         * 'info' - shortcut for quick information
         * 'extensive' - more extensive documentation/context is more intense and complicated
        */
        signifier: {
          type: String,
          default: 'info'
        },
        /**
         * Boundaries used by the popper.js
         * @values 'scrollParent', 'window', 'viewport', or any DOM element
         */
        boundariesElement: {
          type: String,
          default: '.container'
        },
        /**
         * Option to change icon color
         * @values 'blue (default)', 'grey'
         */
        icon: {
          type: String,
          default: 'blue'
        }
      },
      data: function data() {
        return {
          boundary: null,
          popperOptions: {
            modifiers: {
              preventOverflow: {
                enabled: true,
                padding: 0
              }
            }
          }
        };
      },
      computed: {
        hasFooter: function hasFooter() {
          return !!this.$slots.footer;
        },
        parseIcon: function parseIcon() {
          return this.signifier === 'extensive' ? ['fas', 'question-circle'] : ['fas', 'info-circle'];
        }
      },
      mounted: function mounted() {
        this.boundary = document.querySelector(this.boundariesElement);
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTooltip/MsTooltip.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTooltip_MsTooltipvue_type_script_lang_js_ = MsTooltipvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsTooltip/MsTooltip.vue?vue&type=style&index=0&id=2dcb0d4c&prod&lang=scss&
    var MsTooltipvue_type_style_index_0_id_2dcb0d4c_prod_lang_scss_ = __webpack_require__("155a");

    // CONCATENATED MODULE: ./src/components/MsTooltip/MsTooltip.vue

    /* normalize component */

    var MsTooltip_component = normalizeComponent(MsTooltip_MsTooltipvue_type_script_lang_js_, MsTooltipvue_type_template_id_2dcb0d4c_render, MsTooltipvue_type_template_id_2dcb0d4c_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTooltip = MsTooltip_component.exports;
    // CONCATENATED MODULE: ./src/components/MsTooltip/index.js

    MsTooltip.install = function (Vue) {
      return Vue.component(MsTooltip.name, MsTooltip);
    };
    /* harmony default export */
    var components_MsTooltip = MsTooltip;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProgressTimeline/MsProgressTimeline.vue?vue&type=template&id=5fee69aa&
    var MsProgressTimelinevue_type_template_id_5fee69aa_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('nav', {
        staticClass: "progress-timeline"
      }, [_c('ol', {
        staticClass: "progress-timeline__list",
        attrs: {
          "tabindex": "0",
          "role": "progressbar",
          "aria-valuemin": "1",
          "aria-valuemax": _vm.numSteps,
          "aria-valuenow": _vm.activeStepIndex,
          "aria-valuetext": _vm.activeStepText
        }
      }, [_vm._t("default")], 2)]);
    };
    var MsProgressTimelinevue_type_template_id_5fee69aa_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProgressTimeline/MsProgressTimeline.vue?vue&type=template&id=5fee69aa&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProgressTimeline/MsProgressTimeline.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProgressTimelinevue_type_script_lang_js_ = {
      name: 'MsProgressTimeline',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Progress Timeline'
      },
      props: {
        /**
         * i18n option to pass in translation for 'current' step
         */
        currentStepText: {
          type: String,
          required: false,
          default: 'Current Step'
        }
      },
      data: function data() {
        return {
          numSteps: 0,
          activeStepIndex: null,
          activeStepText: null
        };
      },
      created: function created() {
        var _this = this;
        this.$on('child-changed', function () {
          _this.numSteps = _this.$children.length;
          _this.activeStepIndex = _this.getActiveStepIndex();
          _this.activeStepText = _this.getActiveStepText();
          _this.setStatusText();
        });
      },
      methods: {
        getActiveStepIndex: function getActiveStepIndex() {
          return this.$children.findIndex(function (child) {
            return child.active === true;
          });
        },
        getActiveStepText: function getActiveStepText() {
          if (this.activeStepIndex && this.activeStepIndex !== -1) {
            return this.$children[this.activeStepIndex].title;
          }
          return null;
        },
        setStatusText: function setStatusText() {
          var _this2 = this;
          this.$children.forEach(function (child, index) {
            if (index === _this2.activeStepIndex) {
              child.isCurrent();
            }
          });
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsProgressTimeline/MsProgressTimeline.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProgressTimeline_MsProgressTimelinevue_type_script_lang_js_ = MsProgressTimelinevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProgressTimeline/MsProgressTimeline.vue

    /* normalize component */

    var MsProgressTimeline_component = normalizeComponent(MsProgressTimeline_MsProgressTimelinevue_type_script_lang_js_, MsProgressTimelinevue_type_template_id_5fee69aa_render, MsProgressTimelinevue_type_template_id_5fee69aa_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProgressTimeline = MsProgressTimeline_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProgressTimeline/MsProgressTimelineItem.vue?vue&type=template&id=d7a326f8&
    var MsProgressTimelineItemvue_type_template_id_d7a326f8_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('li', {
        staticClass: "progress-timeline__item",
        class: {
          'progress-timeline__item--active': _vm.active
        }
      }, [_vm.statusText ? _c('span', {
        staticClass: "visually-hidden"
      }, [_vm._v("\n    " + _vm._s(_vm.statusText) + "\n  ")]) : _vm._e(), _c('div', {
        staticClass: "progress-timeline__content"
      }, [_c('p', {
        staticClass: "progress-timeline__title"
      }, [_vm._v(_vm._s(_vm.title))]), _vm.date ? _c('p', {
        staticClass: "progress-timeline__date"
      }, [_vm._v(_vm._s(_vm.date))]) : _vm._e(), _vm.description ? _c('p', {
        staticClass: "progress-timeline__description"
      }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()])]);
    };
    var MsProgressTimelineItemvue_type_template_id_d7a326f8_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProgressTimeline/MsProgressTimelineItem.vue?vue&type=template&id=d7a326f8&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProgressTimeline/MsProgressTimelineItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProgressTimelineItemvue_type_script_lang_js_ = {
      name: 'MsProgressTimelineItem',
      props: {
        /**
         * Sets this item to be the current step
         */
        active: {
          type: Boolean,
          default: false
        },
        /**
         * Sets title of the step
         */
        title: {
          type: String,
          required: true
        },
        /**
         * Sets date of the step
         */
        date: {
          type: String,
          required: false
        },
        /**
         * Sets description of the step
         */
        description: {
          type: String,
          required: false
        }
      },
      data: function data() {
        return {
          statusText: ''
        };
      },
      watch: {
        active: function active() {
          this.$parent.$emit('child-changed');
        }
      },
      mounted: function mounted() {
        this.$parent.$emit('child-changed');
      },
      methods: {
        isCurrent: function isCurrent() {
          this.statusText = this.$parent.currentStepText;
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsProgressTimeline/MsProgressTimelineItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProgressTimeline_MsProgressTimelineItemvue_type_script_lang_js_ = MsProgressTimelineItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProgressTimeline/MsProgressTimelineItem.vue

    /* normalize component */

    var MsProgressTimelineItem_component = normalizeComponent(MsProgressTimeline_MsProgressTimelineItemvue_type_script_lang_js_, MsProgressTimelineItemvue_type_template_id_d7a326f8_render, MsProgressTimelineItemvue_type_template_id_d7a326f8_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProgressTimelineItem = MsProgressTimelineItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsProgressTimeline/index.js

    var MsProgressTimeline_components = {
      MsProgressTimeline: MsProgressTimeline,
      MsProgressTimelineItem: MsProgressTimelineItem
    };
    MsProgressTimeline.install = function (Vue) {
      Object.values(MsProgressTimeline_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsProgressTimeline = MsProgressTimeline;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsVisualContent/MsVisualContent.vue?vue&type=template&id=773cadfe&
    var MsVisualContentvue_type_template_id_773cadfe_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "visual-content",
        class: {
          'visual-content--reverse': _vm.reverse,
          'visual-content--centered': _vm.center,
          'visual-content--full-width': _vm.fullWidth
        }
      }, [_vm.fullWidth ? _c('div', {
        staticClass: "visual-content__mask"
      }, [_vm.fullWidth && _vm.center ? [_c('svg', {
        staticClass: "visual-content__mask--tablet",
        attrs: {
          "width": "687",
          "height": "420",
          "viewBox": "0 0 687 420",
          "preserveAspectRatio": "none",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M171.65 0H512.159V420H0C6.42645 415.748 12.5816 411.076 18.4072 405.957C126.676 310.805 167.988 130.617 171.65 0Z",
          "fill": _vm.maskColor
        }
      }), _c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M515.35 0H174.841V420H687C680.574 415.748 674.418 411.076 668.593 405.957C560.324 310.805 519.012 130.617 515.35 0Z",
          "fill": _vm.maskColor
        }
      })]), _c('svg', {
        staticClass: "visual-content__mask--desktop",
        attrs: {
          "width": "1020",
          "height": "456",
          "viewBox": "0 0 1020 456",
          "preserveAspectRatio": "none",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M258 0H256C250.56 141.812 189.187 337.445 28.3442 440.753C19.6899 446.312 10.5458 451.383 0.998779 456H258H762H1019C1009.45 451.383 1000.31 446.312 991.656 440.753C830.813 337.445 769.44 141.812 764 0H762H258Z",
          "fill": _vm.maskColor
        }
      })])] : _vm.fullWidth ? _c('svg', {
        attrs: {
          "viewBox": "0 0 295 456",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          "d": "M 0 456 H 295 C 241 435 228 424 209 408 C 99 305 44.7604 130.617 40.6133 0 H 0 V 456 Z",
          "fill": _vm.maskColor
        }
      })]) : _vm._e()], 2) : _vm._e(), _c('div', {
        staticClass: "visual-content__content",
        style: "background-color: ".concat(_vm.maskColor, "; color: ").concat(_vm.textColor)
      }, [_vm._t("default")], 2), _c('div', {
        staticClass: "visual-content__media"
      }, [_vm.desktopImage ? _c('img', {
        staticClass: "visual-content__media--desktop",
        attrs: {
          "src": _vm.desktopImage,
          "alt": _vm.altText
        }
      }) : _vm._e(), _vm.mobileImage ? _c('img', {
        staticClass: "visual-content__media--mobile",
        attrs: {
          "src": _vm.mobileImage,
          "alt": _vm.altText
        }
      }) : _vm._e()])]);
    };
    var MsVisualContentvue_type_template_id_773cadfe_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsVisualContent/MsVisualContent.vue?vue&type=template&id=773cadfe&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsVisualContent/MsVisualContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsVisualContentvue_type_script_lang_js_ = {
      name: 'MsVisualContent',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Visual Content'
      },
      props: {
        /**
         * Reverse the content
        */
        reverse: {
          type: Boolean,
          default: false
        },
        /**
         * Centers the content, to be used with fullWidth
        */
        center: {
          type: Boolean,
          default: false
        },
        /**
         * Toggles full width for the background image
        */
        fullWidth: {
          type: Boolean,
          default: false
        },
        /**
         * Mobile Image URL
        */
        mobileImage: {
          type: String,
          required: true
        },
        /**
         * Desktop Image URL
        */
        desktopImage: {
          type: String,
          required: true
        },
        /**
         * Desktop Image Alt Text
        */
        altText: {
          type: String,
          default: 'Visual Content Image'
        },
        /**
         * Changes the mask background colour
        */
        maskColor: {
          type: String,
          default: '#fff'
        },
        /**
         * Changes the text  colour
        */
        textColor: {
          type: String,
          default: '#333'
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsVisualContent/MsVisualContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsVisualContent_MsVisualContentvue_type_script_lang_js_ = MsVisualContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsVisualContent/MsVisualContent.vue

    /* normalize component */

    var MsVisualContent_component = normalizeComponent(MsVisualContent_MsVisualContentvue_type_script_lang_js_, MsVisualContentvue_type_template_id_773cadfe_render, MsVisualContentvue_type_template_id_773cadfe_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsVisualContent = MsVisualContent_component.exports;
    // CONCATENATED MODULE: ./src/components/MsVisualContent/index.js

    MsVisualContent.install = function (Vue) {
      return Vue.component(MsVisualContent.name, MsVisualContent);
    };
    /* harmony default export */
    var components_MsVisualContent = MsVisualContent;
    // CONCATENATED MODULE: ./src/components/MsTabs/index.js

    var MsTabs_components = {
      MsTabs: MsTabs,
      MsTabMenu: MsTabMenu,
      MsTabContent: MsTabContent
    };
    MsTabs.install = function (Vue) {
      Object.values(MsTabs_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsTabs = MsTabs;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSmartbuyCard/MsSmartbuyCard.vue?vue&type=template&id=b04b6334&
    var MsSmartbuyCardvue_type_template_id_b04b6334_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "smartbuy-card"
      }, [_c('a', {
        attrs: {
          "href": _vm.redirectUrl || 'javascript:;'
        }
      }, [_vm.showPointCard ? _c('div', {
        staticClass: "smartbuy-reward"
      }, [_vm.badgeInfo.label ? _c('ms-badge', {
        staticClass: "smartbuy-reward__badge",
        attrs: {
          "type": _vm.badgeInfo.type || ''
        }
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.badgeInfo.label)
        }
      })]) : _vm._e(), _c('div', {
        staticClass: "smartbuy-reward__prod-price-wrapper"
      }, [_c('div', {
        staticClass: "smartbuy-reward__point-value"
      }, [_vm._v(_vm._s(_vm.productPoints))]), _c('div', {
        staticClass: "smartbuy-reward__prod-price"
      }, [_vm._v(_vm._s(_vm.price))])]), _c('div', [_c('div', {
        staticClass: "smartbuy-reward__prod-img"
      }, [_c('img', {
        attrs: {
          "src": _vm.imageUrl
        }
      })]), _c('div', {
        staticClass: "smartbuy-reward__content"
      }, [_c('div', {
        staticClass: "smartbuy-reward__prod-name truncate-text",
        attrs: {
          "title": _vm.name
        }
      }, [_vm._v("\n            " + _vm._s(_vm.name) + "\n          ")]), _c('div', {
        staticClass: "smartbuy-reward__prod-description truncate-text"
      }, [_vm._v("\n            " + _vm._s(_vm.description) + "\n          ")])])])], 1) : _c('div', {
        staticClass: "smartbuy-card__inner"
      }, [_c('div', [_c('div', {
        staticClass: "smartbuy-card__prod-img"
      }, [_c('img', {
        attrs: {
          "src": _vm.imageUrl
        }
      })]), _c('div', {
        staticClass: "smartbuy-card__prod-name truncate-text",
        attrs: {
          "title": _vm.name
        }
      }, [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")])]), _c('div', {
        staticClass: "smartbuy-card__prod-price-wrapper"
      }, [_c('div', {
        staticClass: "smartbuy-card__prod-price"
      }, [_vm._v(_vm._s(_vm.price))]), _c('div', {
        staticClass: "smartbuy-card__cashback-info"
      }, [_c('ms-badge', {
        attrs: {
          "type": "pending"
        }
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.cashbackInfo)
        }
      })])], 1)])])])]);
    };
    var MsSmartbuyCardvue_type_template_id_b04b6334_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsSmartbuyCard/MsSmartbuyCard.vue?vue&type=template&id=b04b6334&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSmartbuyCard/MsSmartbuyCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSmartbuyCardvue_type_script_lang_js_ = {
      name: 'MsSmartbuyCard',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Smartbuy Card'
      },
      props: {
        imageUrl: {
          type: String,
          required: true,
          default: ''
        },
        name: {
          type: String,
          required: true,
          default: ''
        },
        price: {
          type: String,
          required: true,
          default: ''
        },
        cashbackInfo: {
          type: String,
          default: ''
        },
        redirectUrl: {
          type: String,
          default: ''
        },
        showPointCard: {
          type: Boolean,
          default: false
        },
        pointInfo: {
          type: Object,
          default: function _default() {
            return {};
          }
        },
        description: {
          type: String,
          default: ''
        },
        badgeInfo: {
          type: Object,
          default: function _default() {
            return {};
          }
        }
      },
      computed: {
        productPoints: function productPoints() {
          var _this$pointInfo = this.pointInfo,
            value = _this$pointInfo.value,
            label = _this$pointInfo.label;
          var strValue = value.toLocaleString('en-US');
          return "".concat(strValue, " ").concat(label);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSmartbuyCard/MsSmartbuyCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSmartbuyCard_MsSmartbuyCardvue_type_script_lang_js_ = MsSmartbuyCardvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/MsSmartbuyCard/MsSmartbuyCard.vue?vue&type=style&index=0&id=b04b6334&prod&lang=scss&
    var MsSmartbuyCardvue_type_style_index_0_id_b04b6334_prod_lang_scss_ = __webpack_require__("ab3b");

    // CONCATENATED MODULE: ./src/components/MsSmartbuyCard/MsSmartbuyCard.vue

    /* normalize component */

    var MsSmartbuyCard_component = normalizeComponent(MsSmartbuyCard_MsSmartbuyCardvue_type_script_lang_js_, MsSmartbuyCardvue_type_template_id_b04b6334_render, MsSmartbuyCardvue_type_template_id_b04b6334_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSmartbuyCard = MsSmartbuyCard_component.exports;
    // CONCATENATED MODULE: ./src/components/MsSmartbuyCard/index.js

    var MsSmartbuyCard_components = {
      MsSmartbuyCard: MsSmartbuyCard
    };
    MsSmartbuyCard.install = function (Vue) {
      Object.values(MsSmartbuyCard_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsSmartbuyCard = MsSmartbuyCard;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSummaryLinks/MsSummaryLinks.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSummaryLinksvue_type_script_lang_js_ = {
      name: 'MsSummaryLinks',
      functional: true,
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Summary Links'
      },
      props: {
        /**
         * Title of MsSummaryLinks
         */
        title: {
          type: String,
          default: ''
        },
        /**
         * HTML tag to use for the title
         */
        titleTag: {
          type: String,
          default: 'h3'
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          slots = _ref.slots,
          data = _ref.data;
        var $defaultSlot = slots().default;
        var $title = props.title && props.title !== '' ? h(props.titleTag, {
          staticClass: 'summary-links__title'
        }, [props.title]) : null;
        var $links = slots().default ? h('ul', {
          staticClass: 'summary-links__links'
        }, [$defaultSlot]) : null;
        var $summaryLinks = h('div', {
          staticClass: 'summary-links',
          class: data.staticClass || '',
          attrs: data.attrs
        }, [$title, $links]);
        return $summaryLinks;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSummaryLinks/MsSummaryLinks.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSummaryLinks_MsSummaryLinksvue_type_script_lang_js_ = MsSummaryLinksvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSummaryLinks/MsSummaryLinks.vue
    var MsSummaryLinks_render, MsSummaryLinks_staticRenderFns;

    /* normalize component */

    var MsSummaryLinks_component = normalizeComponent(MsSummaryLinks_MsSummaryLinksvue_type_script_lang_js_, MsSummaryLinks_render, MsSummaryLinks_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSummaryLinks = MsSummaryLinks_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsSummaryLinks/MsSummaryLinksItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSummaryLinksItemvue_type_script_lang_js_ = {
      name: 'MsSummaryLinksItem',
      functional: true,
      props: {
        /**
         * URL/Path to use for the link
         */
        link: {
          type: String,
          required: true
        },
        /**
         * Title of MsSummaryLinksItem
         */
        title: {
          type: String,
          required: true
        },
        /**
         * HTML tag to use for the title
         */
        titleTag: {
          type: String,
          default: 'h4'
        },
        /**
         * Text of MsSummaryLinksItem
         */
        text: {
          type: String,
          default: ''
        },
        /**
         * HTML tag to use for the text
         */
        textTag: {
          type: String,
          default: 'p'
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data;
        var $title = h(props.titleTag, {
          staticClass: 'summary-links__link-header'
        }, [props.title]);
        var $text = props.text ? h(props.textTag, {
          staticClass: 'summary-links__link-text'
        }, [props.text]) : null;
        var $link = h('a', {
          attrs: {
            href: props.link
          }
        }, [$title, $text]);
        var $item = h('li', {
          staticClass: 'summary-links__link',
          class: data.staticClass || '',
          attrs: data.attrs
        }, [$link]);
        return $item;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsSummaryLinks/MsSummaryLinksItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsSummaryLinks_MsSummaryLinksItemvue_type_script_lang_js_ = MsSummaryLinksItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsSummaryLinks/MsSummaryLinksItem.vue
    var MsSummaryLinksItem_render, MsSummaryLinksItem_staticRenderFns;

    /* normalize component */

    var MsSummaryLinksItem_component = normalizeComponent(MsSummaryLinks_MsSummaryLinksItemvue_type_script_lang_js_, MsSummaryLinksItem_render, MsSummaryLinksItem_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsSummaryLinksItem = MsSummaryLinksItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsSummaryLinks/index.js

    var MsSummaryLinks_components = {
      MsSummaryLinks: MsSummaryLinks,
      MsSummaryLinksItem: MsSummaryLinksItem
    };
    MsSummaryLinks.install = function (Vue) {
      Object.values(MsSummaryLinks_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsSummaryLinks = MsSummaryLinks;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTable.vue?vue&type=template&id=d8e44b3c&
    var MsTablevue_type_template_id_d8e44b3c_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('table', {
        staticClass: "vertical-table",
        class: [_vm.$attrs.class, _vm.$attrs.staticClass]
      }, [_vm._t("default")], 2);
    };
    var MsTablevue_type_template_id_d8e44b3c_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTable/MsTable.vue?vue&type=template&id=d8e44b3c&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTable.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTablevue_type_script_lang_js_ = {
      name: 'MsTable',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Table'
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTable/MsTable.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTable_MsTablevue_type_script_lang_js_ = MsTablevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTable/MsTable.vue

    /* normalize component */

    var MsTable_component = normalizeComponent(MsTable_MsTablevue_type_script_lang_js_, MsTablevue_type_template_id_d8e44b3c_render, MsTablevue_type_template_id_d8e44b3c_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTable = MsTable_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTableSection.vue?vue&type=template&id=21e05ab5&
    var MsTableSectionvue_type_template_id_21e05ab5_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _vm.type == 'thead' ? _c('thead', [_vm._t("default")], 2) : _c('tbody', [_vm._t("default")], 2);
    };
    var MsTableSectionvue_type_template_id_21e05ab5_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTable/MsTableSection.vue?vue&type=template&id=21e05ab5&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTableSection.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTableSectionvue_type_script_lang_js_ = {
      name: 'MsTableSection',
      props: {
        /**
         * Set table section type <br/>
         * (Options: 'tbody', 'thead') <br/>
         * Set 'tbody' as default value
        */
        type: {
          type: String,
          default: 'tbody'
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTable/MsTableSection.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTable_MsTableSectionvue_type_script_lang_js_ = MsTableSectionvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTable/MsTableSection.vue

    /* normalize component */

    var MsTableSection_component = normalizeComponent(MsTable_MsTableSectionvue_type_script_lang_js_, MsTableSectionvue_type_template_id_21e05ab5_render, MsTableSectionvue_type_template_id_21e05ab5_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTableSection = MsTableSection_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTableRow.vue?vue&type=template&id=364a933a&
    var MsTableRowvue_type_template_id_364a933a_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('tr', {
        class: {
          'is-disabled': _vm.isDisabled
        }
      }, [_vm._t("default")], 2);
    };
    var MsTableRowvue_type_template_id_364a933a_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTable/MsTableRow.vue?vue&type=template&id=364a933a&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTableRow.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTableRowvue_type_script_lang_js_ = {
      name: 'MsTableRow',
      props: {
        /**
         * Set row disabled <br/>
         * If row is disable won't show mouse hover effect. <br/>
         * Default will be false
        */
        isDisabled: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTable/MsTableRow.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTable_MsTableRowvue_type_script_lang_js_ = MsTableRowvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTable/MsTableRow.vue

    /* normalize component */

    var MsTableRow_component = normalizeComponent(MsTable_MsTableRowvue_type_script_lang_js_, MsTableRowvue_type_template_id_364a933a_render, MsTableRowvue_type_template_id_364a933a_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTableRow = MsTableRow_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTableCell.vue?vue&type=template&id=a10e1446&
    var MsTableCellvue_type_template_id_a10e1446_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _vm.type == 'td' ? _c('td', {
        attrs: {
          "scope": _vm.scope,
          "data-th": _vm.cellHeading
        },
        domProps: {
          "innerHTML": _vm._s(_vm.content)
        }
      }) : _c('th', {
        attrs: {
          "scope": _vm.scope,
          "data-th": _vm.cellHeading
        },
        domProps: {
          "innerHTML": _vm._s(_vm.content)
        }
      });
    };
    var MsTableCellvue_type_template_id_a10e1446_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTable/MsTableCell.vue?vue&type=template&id=a10e1446&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTable/MsTableCell.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTableCellvue_type_script_lang_js_ = {
      name: 'MsTableCell',
      props: {
        /**
         * Set cell type, to render th or td tag <br/>
         * (Options: 'td', 'th'). <br/>
         * Set 'td' as default.
        */
        type: {
          type: String,
          default: 'td'
        },
        /**
         * Set cell scope attribute <br/>
         * (Options: col, row, colgroup, rowgroup)
        */
        scope: {
          type: String,
          default: ''
        },
        /**
         * Set data attribute 'data-th' for cell heading <br/>
         * This will be use to display as cell heading on mobile mode.
        */
        cellHeading: {
          type: String,
          default: ''
        },
        /**
         * Pass string to content, for render as html in table cell
        */
        content: {
          type: String,
          default: ''
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTable/MsTableCell.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTable_MsTableCellvue_type_script_lang_js_ = MsTableCellvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTable/MsTableCell.vue

    /* normalize component */

    var MsTableCell_component = normalizeComponent(MsTable_MsTableCellvue_type_script_lang_js_, MsTableCellvue_type_template_id_a10e1446_render, MsTableCellvue_type_template_id_a10e1446_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTableCell = MsTableCell_component.exports;
    // CONCATENATED MODULE: ./src/components/MsTable/index.js

    var MsTable_components = {
      MsTable: MsTable,
      MsTableSection: MsTableSection,
      MsTableRow: MsTableRow,
      MsTableCell: MsTableCell
    };
    MsTable.install = function (Vue) {
      Object.values(MsTable_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsTable = MsTable;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFaq/MsFaq.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFaqvue_type_script_lang_js_ = {
      name: 'MsFaq',
      functional: true,
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/FAQ'
      },
      render: function render(h, _ref) {
        var slots = _ref.slots;
        var $faq = h('dl', {
          staticClass: 'faq'
        }, [slots().default]);
        return $faq;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsFaq/MsFaq.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFaq_MsFaqvue_type_script_lang_js_ = MsFaqvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsFaq/MsFaq.vue
    var MsFaq_render, MsFaq_staticRenderFns;

    /* normalize component */

    var MsFaq_component = normalizeComponent(MsFaq_MsFaqvue_type_script_lang_js_, MsFaq_render, MsFaq_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFaq = MsFaq_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFaq/MsFaqItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFaqItemvue_type_script_lang_js_ = {
      name: 'MsFaqItem',
      functional: true,
      props: {
        /**
         * Title of FAQ Item
         */
        title: {
          type: String,
          required: true
        },
        /**
         * HTML tag to use for the FAQ Item Title
         */
        titleTag: {
          type: String,
          default: 'h3'
        },
        /**
         * FAQ Item Content (Accepts HTML)
         */
        content: {
          type: String,
          required: true
        }
      },
      render: function render(h, _ref) {
        var props = _ref.props,
          data = _ref.data;
        var $title = h(props.titleTag, {
          staticClass: 'text-header-p2'
        }, [props.title]);
        var $titleWrapper = h('dt', {
          staticClass: 'faq__item__title'
        }, [$title]);
        var $content = h('dd', {
          staticClass: 'faq__item__description text-body-0',
          domProps: {
            innerHTML: props.content
          } // v-html
        }, []);
        var $faqItem = h('div', {
          staticClass: 'faq__item',
          class: data.staticClass || '',
          attrs: data.attrs
        }, [$titleWrapper, $content]);
        return $faqItem;
      }
    };
    // CONCATENATED MODULE: ./src/components/MsFaq/MsFaqItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFaq_MsFaqItemvue_type_script_lang_js_ = MsFaqItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsFaq/MsFaqItem.vue
    var MsFaqItem_render, MsFaqItem_staticRenderFns;

    /* normalize component */

    var MsFaqItem_component = normalizeComponent(MsFaq_MsFaqItemvue_type_script_lang_js_, MsFaqItem_render, MsFaqItem_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFaqItem = MsFaqItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsFaq/index.js

    var MsFaq_components = {
      MsFaq: MsFaq,
      MsFaqItem: MsFaqItem
    };
    MsFaq.install = function (Vue) {
      Object.values(MsFaq_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsFaq = MsFaq;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCard.vue?vue&type=template&id=6298fddb&
    var MsProductCardvue_type_template_id_6298fddb_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card",
        attrs: {
          "id": _vm.slug
        }
      }, [_vm._t("default")], 2);
    };
    var MsProductCardvue_type_template_id_6298fddb_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCard.vue?vue&type=template&id=6298fddb&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardvue_type_script_lang_js_ = {
      name: 'MsProductCard',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/ProductCard'
      },
      props: {
        /**
        * Set Id with product slug
        */
        slug: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCard.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardvue_type_script_lang_js_ = MsProductCardvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCard.vue

    /* normalize component */

    var MsProductCard_component = normalizeComponent(MsProductCard_MsProductCardvue_type_script_lang_js_, MsProductCardvue_type_template_id_6298fddb_render, MsProductCardvue_type_template_id_6298fddb_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCard = MsProductCard_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardBrand.vue?vue&type=template&id=62973eb3&
    var MsProductCardBrandvue_type_template_id_62973eb3_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__brand"
      }, [_vm._t("default")], 2);
    };
    var MsProductCardBrandvue_type_template_id_62973eb3_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardBrand.vue?vue&type=template&id=62973eb3&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardBrand.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardBrandvue_type_script_lang_js_ = {
      name: 'MsProductCardBrand'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardBrand.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardBrandvue_type_script_lang_js_ = MsProductCardBrandvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardBrand.vue

    /* normalize component */

    var MsProductCardBrand_component = normalizeComponent(MsProductCard_MsProductCardBrandvue_type_script_lang_js_, MsProductCardBrandvue_type_template_id_62973eb3_render, MsProductCardBrandvue_type_template_id_62973eb3_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardBrand = MsProductCardBrand_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardBadge.vue?vue&type=template&id=4fd23615&
    var MsProductCardBadgevue_type_template_id_4fd23615_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "badge-wrapper"
      }, [_vm._t("default")], 2);
    };
    var MsProductCardBadgevue_type_template_id_4fd23615_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardBadge.vue?vue&type=template&id=4fd23615&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardBadge.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardBadgevue_type_script_lang_js_ = {
      name: 'MsProductCardBadge'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardBadge.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardBadgevue_type_script_lang_js_ = MsProductCardBadgevue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardBadge.vue

    /* normalize component */

    var MsProductCardBadge_component = normalizeComponent(MsProductCard_MsProductCardBadgevue_type_script_lang_js_, MsProductCardBadgevue_type_template_id_4fd23615_render, MsProductCardBadgevue_type_template_id_4fd23615_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardBadge = MsProductCardBadge_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardDetails.vue?vue&type=template&id=3ec0a71f&
    var MsProductCardDetailsvue_type_template_id_3ec0a71f_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__details"
      }, [_vm._t("default")], 2);
    };
    var MsProductCardDetailsvue_type_template_id_3ec0a71f_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardDetails.vue?vue&type=template&id=3ec0a71f&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardDetails.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardDetailsvue_type_script_lang_js_ = {
      name: 'MsProductCardDetails'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardDetails.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardDetailsvue_type_script_lang_js_ = MsProductCardDetailsvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardDetails.vue

    /* normalize component */

    var MsProductCardDetails_component = normalizeComponent(MsProductCard_MsProductCardDetailsvue_type_script_lang_js_, MsProductCardDetailsvue_type_template_id_3ec0a71f_render, MsProductCardDetailsvue_type_template_id_3ec0a71f_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardDetails = MsProductCardDetails_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardHeader.vue?vue&type=template&id=82d3c5aa&
    var MsProductCardHeadervue_type_template_id_82d3c5aa_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__header mb-2"
      }, [_vm._t("default")], 2);
    };
    var MsProductCardHeadervue_type_template_id_82d3c5aa_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHeader.vue?vue&type=template&id=82d3c5aa&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardHeadervue_type_script_lang_js_ = {
      name: 'MsProductCardHeader'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHeader.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardHeadervue_type_script_lang_js_ = MsProductCardHeadervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHeader.vue

    /* normalize component */

    var MsProductCardHeader_component = normalizeComponent(MsProductCard_MsProductCardHeadervue_type_script_lang_js_, MsProductCardHeadervue_type_template_id_82d3c5aa_render, MsProductCardHeadervue_type_template_id_82d3c5aa_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardHeader = MsProductCardHeader_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardHighlights.vue?vue&type=template&id=22178938&
    var MsProductCardHighlightsvue_type_template_id_22178938_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__highlights"
      }, [_c('dl', [_vm._t("default")], 2)]);
    };
    var MsProductCardHighlightsvue_type_template_id_22178938_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHighlights.vue?vue&type=template&id=22178938&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardHighlights.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardHighlightsvue_type_script_lang_js_ = {
      name: 'MsProductCardHighlights'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHighlights.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardHighlightsvue_type_script_lang_js_ = MsProductCardHighlightsvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHighlights.vue

    /* normalize component */

    var MsProductCardHighlights_component = normalizeComponent(MsProductCard_MsProductCardHighlightsvue_type_script_lang_js_, MsProductCardHighlightsvue_type_template_id_22178938_render, MsProductCardHighlightsvue_type_template_id_22178938_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardHighlights = MsProductCardHighlights_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardHighlightItem.vue?vue&type=template&id=536316db&
    var MsProductCardHighlightItemvue_type_template_id_536316db_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card-highlight"
      }, [_c('dt', {
        staticClass: "product-card-highlight__subtitle"
      }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _c('dd', {
        staticClass: "product-card-highlight__title"
      }, [_vm.currency ? _c('sup', [_vm._v(_vm._s(_vm.currency))]) : _vm._e(), _vm._v(_vm._s(_vm.value) + "\n  ")])]);
    };
    var MsProductCardHighlightItemvue_type_template_id_536316db_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHighlightItem.vue?vue&type=template&id=536316db&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardHighlightItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardHighlightItemvue_type_script_lang_js_ = {
      name: 'MsProductCardHighlightItem',
      props: {
        /**
        * Set highlight label
        */
        label: {
          type: String,
          default: null
        },
        /**
        * Set highlight value
        */
        value: {
          type: String,
          default: null
        },
        /**
        * Set currency value
        */
        currency: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHighlightItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardHighlightItemvue_type_script_lang_js_ = MsProductCardHighlightItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardHighlightItem.vue

    /* normalize component */

    var MsProductCardHighlightItem_component = normalizeComponent(MsProductCard_MsProductCardHighlightItemvue_type_script_lang_js_, MsProductCardHighlightItemvue_type_template_id_536316db_render, MsProductCardHighlightItemvue_type_template_id_536316db_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardHighlightItem = MsProductCardHighlightItem_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardCampaign.vue?vue&type=template&id=d6736ad0&
    var MsProductCardCampaignvue_type_template_id_d6736ad0_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__campaign"
      }, [_vm._t("default")], 2);
    };
    var MsProductCardCampaignvue_type_template_id_d6736ad0_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardCampaign.vue?vue&type=template&id=d6736ad0&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardCampaign.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardCampaignvue_type_script_lang_js_ = {
      name: 'MsProductCardCampaign'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardCampaign.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardCampaignvue_type_script_lang_js_ = MsProductCardCampaignvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardCampaign.vue

    /* normalize component */

    var MsProductCardCampaign_component = normalizeComponent(MsProductCard_MsProductCardCampaignvue_type_script_lang_js_, MsProductCardCampaignvue_type_template_id_d6736ad0_render, MsProductCardCampaignvue_type_template_id_d6736ad0_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardCampaign = MsProductCardCampaign_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardPromotion.vue?vue&type=template&id=5a7e727b&
    var MsProductCardPromotionvue_type_template_id_5a7e727b_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__promotion"
      }, [_vm._t("default")], 2);
    };
    var MsProductCardPromotionvue_type_template_id_5a7e727b_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardPromotion.vue?vue&type=template&id=5a7e727b&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardPromotion.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardPromotionvue_type_script_lang_js_ = {
      name: 'MsProductCardPromotion'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardPromotion.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardPromotionvue_type_script_lang_js_ = MsProductCardPromotionvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardPromotion.vue

    /* normalize component */

    var MsProductCardPromotion_component = normalizeComponent(MsProductCard_MsProductCardPromotionvue_type_script_lang_js_, MsProductCardPromotionvue_type_template_id_5a7e727b_render, MsProductCardPromotionvue_type_template_id_5a7e727b_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardPromotion = MsProductCardPromotion_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardContent.vue?vue&type=template&id=58e50e37&
    var MsProductCardContentvue_type_template_id_58e50e37_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__details-content"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.content)
        }
      })]);
    };
    var MsProductCardContentvue_type_template_id_58e50e37_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardContent.vue?vue&type=template&id=58e50e37&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardContentvue_type_script_lang_js_ = {
      name: 'MsProductCardContent',
      props: {
        /**
        * Set display content
        */
        content: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardContentvue_type_script_lang_js_ = MsProductCardContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardContent.vue

    /* normalize component */

    var MsProductCardContent_component = normalizeComponent(MsProductCard_MsProductCardContentvue_type_script_lang_js_, MsProductCardContentvue_type_template_id_58e50e37_render, MsProductCardContentvue_type_template_id_58e50e37_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardContent = MsProductCardContent_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardCta.vue?vue&type=template&id=2cf456d0&
    var MsProductCardCtavue_type_template_id_2cf456d0_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__cta",
        class: [_vm.$attrs.class, _vm.$attrs.staticClass]
      }, [_vm._t("default"), _vm.label || _vm.value ? _c('p', {
        staticClass: "product-card__supplementary"
      }, [_vm.label ? _c('span', {
        staticClass: "product-card__supplementary-label"
      }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm.value ? _c('span', {
        staticClass: "product-card__supplementary-value"
      }, [_vm._v(_vm._s(_vm.value))]) : _vm._e()]) : _vm._e(), _vm._t("secondaryButton")], 2);
    };
    var MsProductCardCtavue_type_template_id_2cf456d0_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardCta.vue?vue&type=template&id=2cf456d0&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardCtavue_type_script_lang_js_ = {
      name: 'MsProductCardCta',
      props: {
        /**
        * Set supplementary label
        */
        label: {
          type: String,
          default: null
        },
        /**
        * Set supplementary value
        */
        value: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardCta.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardCtavue_type_script_lang_js_ = MsProductCardCtavue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardCta.vue

    /* normalize component */

    var MsProductCardCta_component = normalizeComponent(MsProductCard_MsProductCardCtavue_type_script_lang_js_, MsProductCardCtavue_type_template_id_2cf456d0_render, MsProductCardCtavue_type_template_id_2cf456d0_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardCta = MsProductCardCta_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardPromotionWrapper.vue?vue&type=template&id=2d3268d5&
    var MsProductCardPromotionWrappervue_type_template_id_2d3268d5_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__promotion-wrapper"
      }, [_vm._t("default")], 2);
    };
    var MsProductCardPromotionWrappervue_type_template_id_2d3268d5_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardPromotionWrapper.vue?vue&type=template&id=2d3268d5&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardPromotionWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardPromotionWrappervue_type_script_lang_js_ = {
      name: 'MsProductCardPromotionWrapper'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardPromotionWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardPromotionWrappervue_type_script_lang_js_ = MsProductCardPromotionWrappervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardPromotionWrapper.vue

    /* normalize component */

    var MsProductCardPromotionWrapper_component = normalizeComponent(MsProductCard_MsProductCardPromotionWrappervue_type_script_lang_js_, MsProductCardPromotionWrappervue_type_template_id_2d3268d5_render, MsProductCardPromotionWrappervue_type_template_id_2d3268d5_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardPromotionWrapper = MsProductCardPromotionWrapper_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardContentWrapper.vue?vue&type=template&id=400f173d&
    var MsProductCardContentWrappervue_type_template_id_400f173d_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "product-card__content-wrapper"
      }, [_c('div', {
        staticClass: "product-card__content"
      }, [_vm._t("default")], 2), _vm._t("cta")], 2);
    };
    var MsProductCardContentWrappervue_type_template_id_400f173d_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardContentWrapper.vue?vue&type=template&id=400f173d&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsProductCard/MsProductCardContentWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCardContentWrappervue_type_script_lang_js_ = {
      name: 'MsProductCardContentWrapper'
    };
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardContentWrapper.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsProductCard_MsProductCardContentWrappervue_type_script_lang_js_ = MsProductCardContentWrappervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsProductCard/MsProductCardContentWrapper.vue

    /* normalize component */

    var MsProductCardContentWrapper_component = normalizeComponent(MsProductCard_MsProductCardContentWrappervue_type_script_lang_js_, MsProductCardContentWrappervue_type_template_id_400f173d_render, MsProductCardContentWrappervue_type_template_id_400f173d_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsProductCardContentWrapper = MsProductCardContentWrapper_component.exports;
    // CONCATENATED MODULE: ./src/components/MsProductCard/index.js

    var MsProductCard_components = {
      MsProductCard: MsProductCard,
      MsProductCardBrand: MsProductCardBrand,
      MsProductCardBadge: MsProductCardBadge,
      MsProductCardDetails: MsProductCardDetails,
      MsProductCardHeader: MsProductCardHeader,
      MsProductCardHighlights: MsProductCardHighlights,
      MsProductCardHighlightItem: MsProductCardHighlightItem,
      MsProductCardCampaign: MsProductCardCampaign,
      MsProductCardPromotion: MsProductCardPromotion,
      MsProductCardContent: MsProductCardContent,
      MsProductCardCta: MsProductCardCta,
      MsProductCardPromotionWrapper: MsProductCardPromotionWrapper,
      MsProductCardContentWrapper: MsProductCardContentWrapper
    };
    MsProductCard.install = function (Vue) {
      Object.values(MsProductCard_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsProductCard = MsProductCard;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTwoColumnContent/MsTwoColumnContent.vue?vue&type=template&id=d70f07a0&
    var MsTwoColumnContentvue_type_template_id_d70f07a0_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "two-column-content"
      }, [_c('div', {
        staticClass: "two-column-content__content"
      }, [_vm._t("section-header"), _c('div', {
        staticClass: "two-column-content__row-wrapper"
      }, [_vm._t("default")], 2)], 2), _c('div', {
        staticClass: "two-column-content__image-wrapper"
      }, [_c('ms-image', {
        staticClass: "two-column-content__image",
        attrs: {
          "src": _vm.imageUrl,
          "alt": _vm.imageAlt,
          "width": "320",
          "height": "306"
        }
      })], 1)]);
    };
    var MsTwoColumnContentvue_type_template_id_d70f07a0_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTwoColumnContent/MsTwoColumnContent.vue?vue&type=template&id=d70f07a0&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTwoColumnContent/MsTwoColumnContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTwoColumnContentvue_type_script_lang_js_ = {
      name: 'MsTwoColumnContent',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Two Column Content'
      },
      props: {
        /**
         * Sets image src path
         */
        imageUrl: {
          type: String,
          default: null
        },
        /**
         * Sets image alt
         */
        imageAlt: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTwoColumnContent/MsTwoColumnContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTwoColumnContent_MsTwoColumnContentvue_type_script_lang_js_ = MsTwoColumnContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTwoColumnContent/MsTwoColumnContent.vue

    /* normalize component */

    var MsTwoColumnContent_component = normalizeComponent(MsTwoColumnContent_MsTwoColumnContentvue_type_script_lang_js_, MsTwoColumnContentvue_type_template_id_d70f07a0_render, MsTwoColumnContentvue_type_template_id_d70f07a0_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTwoColumnContent = MsTwoColumnContent_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTwoColumnContent/MsTwoColumnContentItem.vue?vue&type=template&id=ed6062ec&
    var MsTwoColumnContentItemvue_type_template_id_ed6062ec_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "two-column-content__column-wrapper"
      }, [_c('div', {
        staticClass: "content-box"
      }, [_c('div', {
        staticClass: "content-box__main text-body-0"
      }, [_c('ms-heading', {
        staticClass: "text-header-p2 mb-1",
        attrs: {
          "heading-tag": "h3"
        }
      }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n      ")]), _vm._t("default")], 2)])]);
    };
    var MsTwoColumnContentItemvue_type_template_id_ed6062ec_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsTwoColumnContent/MsTwoColumnContentItem.vue?vue&type=template&id=ed6062ec&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsTwoColumnContent/MsTwoColumnContentItem.vue?vue&type=script&lang=js&

    /* harmony default export */
    var MsTwoColumnContentItemvue_type_script_lang_js_ = {
      name: 'MsTwoColumnContentItem',
      components: {
        MsHeading: MsHeading
      },
      props: {
        /**
         * Set heading for column title
         */
        heading: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsTwoColumnContent/MsTwoColumnContentItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsTwoColumnContent_MsTwoColumnContentItemvue_type_script_lang_js_ = MsTwoColumnContentItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsTwoColumnContent/MsTwoColumnContentItem.vue

    /* normalize component */

    var MsTwoColumnContentItem_component = normalizeComponent(MsTwoColumnContent_MsTwoColumnContentItemvue_type_script_lang_js_, MsTwoColumnContentItemvue_type_template_id_ed6062ec_render, MsTwoColumnContentItemvue_type_template_id_ed6062ec_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsTwoColumnContentItem = MsTwoColumnContentItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsTwoColumnContent/index.js

    var MsTwoColumnContent_components = {
      MsTwoColumnContent: MsTwoColumnContent,
      MsTwoColumnContentItem: MsTwoColumnContentItem
    };
    MsTwoColumnContent.install = function (Vue) {
      Object.values(MsTwoColumnContent_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsTwoColumnContent = MsTwoColumnContent;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsContentBox/MsContentBox.vue?vue&type=template&id=7d0f21cf&
    var MsContentBoxvue_type_template_id_7d0f21cf_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "content-box",
        class: [_vm.$attrs.class, _vm.$attrs.staticClass, {
          'content-box--shadow': _vm.hasBoxShadow
        }]
      }, [_c('div', {
        staticClass: "content-box__main"
      }, [_vm._t("default")], 2)]);
    };
    var MsContentBoxvue_type_template_id_7d0f21cf_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBox.vue?vue&type=template&id=7d0f21cf&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsContentBox/MsContentBox.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsContentBoxvue_type_script_lang_js_ = {
      name: 'MsContentBox',
      storybook: {
        path: 'Cargo Product Language/Patterns/Perceptual Pattern/Content Box'
      },
      props: {
        /**
         * Set shadow for content box
        */
        hasBoxShadow: {
          type: Boolean,
          default: false
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBox.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsContentBox_MsContentBoxvue_type_script_lang_js_ = MsContentBoxvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBox.vue

    /* normalize component */

    var MsContentBox_component = normalizeComponent(MsContentBox_MsContentBoxvue_type_script_lang_js_, MsContentBoxvue_type_template_id_7d0f21cf_render, MsContentBoxvue_type_template_id_7d0f21cf_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsContentBox = MsContentBox_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsContentBox/MsContentBoxHeading.vue?vue&type=template&id=684ec270&
    var MsContentBoxHeadingvue_type_template_id_684ec270_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "content-box__heading"
      }, [_vm.leadTitle && _vm.leadTitle !== '' ? _c('span', {
        staticClass: "content-box__lead-title text-header-p4 mb-1"
      }, [_vm._v(_vm._s(_vm.leadTitle))]) : _vm._e(), _vm._t("default")], 2);
    };
    var MsContentBoxHeadingvue_type_template_id_684ec270_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBoxHeading.vue?vue&type=template&id=684ec270&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsContentBox/MsContentBoxHeading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsContentBoxHeadingvue_type_script_lang_js_ = {
      name: 'MsContentBoxHeading',
      props: {
        /**
         * Sets lead/step title, eg: Step 1
         */
        leadTitle: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBoxHeading.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsContentBox_MsContentBoxHeadingvue_type_script_lang_js_ = MsContentBoxHeadingvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBoxHeading.vue

    /* normalize component */

    var MsContentBoxHeading_component = normalizeComponent(MsContentBox_MsContentBoxHeadingvue_type_script_lang_js_, MsContentBoxHeadingvue_type_template_id_684ec270_render, MsContentBoxHeadingvue_type_template_id_684ec270_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsContentBoxHeading = MsContentBoxHeading_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsContentBox/MsContentBoxContent.vue?vue&type=template&id=1dfe3b84&
    var MsContentBoxContentvue_type_template_id_1dfe3b84_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "content-box__wrapper"
      }, [_vm.icon ? _c('div', {
        staticClass: "content-box__icon"
      }, [_c('ms-icon', {
        attrs: {
          "icon": _vm.icon
        }
      })], 1) : _vm._e(), _c('div', {
        staticClass: "content-box__content"
      }, [_vm._t("default")], 2)]);
    };
    var MsContentBoxContentvue_type_template_id_1dfe3b84_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBoxContent.vue?vue&type=template&id=1dfe3b84&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsContentBox/MsContentBoxContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsContentBoxContentvue_type_script_lang_js_ = {
      name: 'MsContentBoxContent',
      props: {
        /**
         * Set list icon, eg: ['fal', 'file']
        */
        icon: {
          type: Array,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBoxContent.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsContentBox_MsContentBoxContentvue_type_script_lang_js_ = MsContentBoxContentvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsContentBox/MsContentBoxContent.vue

    /* normalize component */

    var MsContentBoxContent_component = normalizeComponent(MsContentBox_MsContentBoxContentvue_type_script_lang_js_, MsContentBoxContentvue_type_template_id_1dfe3b84_render, MsContentBoxContentvue_type_template_id_1dfe3b84_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsContentBoxContent = MsContentBoxContent_component.exports;
    // CONCATENATED MODULE: ./src/components/MsContentBox/index.js

    var MsContentBox_components = {
      MsContentBox: MsContentBox,
      MsContentBoxHeading: MsContentBoxHeading,
      MsContentBoxContent: MsContentBoxContent
    };
    MsContentBox.install = function (Vue) {
      Object.values(MsContentBox_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsContentBox = MsContentBox;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooterBanner/MsFooterBanner.vue?vue&type=template&id=45f6f3f2&
    var MsFooterBannervue_type_template_id_45f6f3f2_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "footer-banner",
        class: [_vm.$attrs.class, _vm.$attrs.staticClass]
      }, [_c('ms-image', {
        staticClass: "footer-banner__image",
        attrs: {
          "src": _vm.imageUrl,
          "alt": _vm.imageAlt
        }
      })], 1);
    };
    var MsFooterBannervue_type_template_id_45f6f3f2_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsFooterBanner/MsFooterBanner.vue?vue&type=template&id=45f6f3f2&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsFooterBanner/MsFooterBanner.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooterBannervue_type_script_lang_js_ = {
      name: 'MsFooterBanner',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Footer Banner'
      },
      props: {
        /**
         * Sets image url
         */
        imageUrl: {
          type: String,
          default: 'https://assets.cdn-moneysmart.com/assets/cargo/images/pvrku0megguqgie3496y.png'
        },
        /**
         * Sets image alt
         */
        imageAlt: {
          type: String,
          default: 'background image'
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsFooterBanner/MsFooterBanner.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsFooterBanner_MsFooterBannervue_type_script_lang_js_ = MsFooterBannervue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsFooterBanner/MsFooterBanner.vue

    /* normalize component */

    var MsFooterBanner_component = normalizeComponent(MsFooterBanner_MsFooterBannervue_type_script_lang_js_, MsFooterBannervue_type_template_id_45f6f3f2_render, MsFooterBannervue_type_template_id_45f6f3f2_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsFooterBanner = MsFooterBanner_component.exports;
    // CONCATENATED MODULE: ./src/components/MsFooterBanner/index.js

    var MsFooterBanner_components = {
      MsFooterBanner: MsFooterBanner,
      MsImage: MsImage
    };
    MsFooterBanner.install = function (Vue) {
      Object.values(MsFooterBanner_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsFooterBanner = MsFooterBanner;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsVerticalColumn/MsVerticalColumn.vue?vue&type=template&id=a500f270&
    var MsVerticalColumnvue_type_template_id_a500f270_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "vertical-column",
        class: {
          'vertical-column--reversed': _vm.reversed
        }
      }, [_c('div', {
        staticClass: "vertical-column__content"
      }, [_vm._t("section-header"), _c('div', {
        staticClass: "vertical-column__row-wrapper"
      }, [_c('div', {
        staticClass: "vertical-column__column-wrapper"
      }, [_vm._t("default")], 2)])], 2), _c('div', {
        staticClass: "vertical-column__image-wrapper"
      }, [_vm.desktopImageUrl ? _c('ms-image', {
        staticClass: "vertical-column__image vertical-column__image--desktop",
        attrs: {
          "src": _vm.desktopImageUrl,
          "alt": _vm.imageAlt,
          "width": "588",
          "height": "373"
        }
      }) : _vm._e(), _vm.mobileImageUrl ? _c('ms-image', {
        staticClass: "vertical-column__image vertical-column__image--mobile",
        attrs: {
          "src": _vm.mobileImageUrl,
          "alt": _vm.imageAlt,
          "width": "327",
          "height": "208"
        }
      }) : _vm._e()], 1)]);
    };
    var MsVerticalColumnvue_type_template_id_a500f270_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsVerticalColumn/MsVerticalColumn.vue?vue&type=template&id=a500f270&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsVerticalColumn/MsVerticalColumn.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsVerticalColumnvue_type_script_lang_js_ = {
      name: 'MsVerticalColumn',
      storybook: {
        path: 'Cargo Product Language/Patterns/Purpose Pattern/Vertical Column'
      },
      props: {
        /**
         * Reverses the image location for desktop
         */
        reversed: {
          type: Boolean,
          default: false
        },
        /**
         * Sets desktop image src path
         */
        desktopImageUrl: {
          type: String,
          default: null
        },
        /**
         * Sets mobile image src path
         */
        mobileImageUrl: {
          type: String,
          default: null
        },
        /**
         * Sets image alt
         */
        imageAlt: {
          type: String,
          default: 'Vertical Column Image'
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsVerticalColumn/MsVerticalColumn.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsVerticalColumn_MsVerticalColumnvue_type_script_lang_js_ = MsVerticalColumnvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsVerticalColumn/MsVerticalColumn.vue

    /* normalize component */

    var MsVerticalColumn_component = normalizeComponent(MsVerticalColumn_MsVerticalColumnvue_type_script_lang_js_, MsVerticalColumnvue_type_template_id_a500f270_render, MsVerticalColumnvue_type_template_id_a500f270_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsVerticalColumn = MsVerticalColumn_component.exports;
    // CONCATENATED MODULE: ./src/components/MsVerticalColumn/index.js

    var MsVerticalColumn_components = {
      MsVerticalColumn: MsVerticalColumn
    };
    MsVerticalColumn.install = function (Vue) {
      Object.values(MsVerticalColumn_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsVerticalColumn = MsVerticalColumn;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickLinkMenu/MsQuickLinkMenu.vue?vue&type=template&id=eea121de&
    var MsQuickLinkMenuvue_type_template_id_eea121de_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "quick-link-menu"
      }, [_c('div', {
        staticClass: "quick-link-menu__row-wrapper"
      }, [_vm._t("default")], 2)]);
    };
    var MsQuickLinkMenuvue_type_template_id_eea121de_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsQuickLinkMenu/MsQuickLinkMenu.vue?vue&type=template&id=eea121de&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickLinkMenu/MsQuickLinkMenu.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuickLinkMenuvue_type_script_lang_js_ = {
      name: 'MsQuickLinkMenu',
      storybook: {
        path: 'Cargo Product Language/Patterns/Functional Pattern/Quick Link Menu'
      }
    };
    // CONCATENATED MODULE: ./src/components/MsQuickLinkMenu/MsQuickLinkMenu.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuickLinkMenu_MsQuickLinkMenuvue_type_script_lang_js_ = MsQuickLinkMenuvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsQuickLinkMenu/MsQuickLinkMenu.vue

    /* normalize component */

    var MsQuickLinkMenu_component = normalizeComponent(MsQuickLinkMenu_MsQuickLinkMenuvue_type_script_lang_js_, MsQuickLinkMenuvue_type_template_id_eea121de_render, MsQuickLinkMenuvue_type_template_id_eea121de_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsQuickLinkMenu = MsQuickLinkMenu_component.exports;
    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f1803c82-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickLinkMenu/MsQuickLinkMenuItem.vue?vue&type=template&id=7c397c79&
    var MsQuickLinkMenuItemvue_type_template_id_7c397c79_render = function render() {
      var _vm = this,
        _c = _vm._self._c;
      return _c('div', {
        staticClass: "quick-link-menu__column-wrapper",
        class: {
          'quick-link-menu__column-wrapper--no-image': _vm.imageUrl === null
        }
      }, [_c('ms-link', {
        staticClass: "quick-link-menu__link",
        attrs: {
          "href": _vm.quickLink
        }
      }, [_vm.imageUrl !== null ? _c('div', {
        staticClass: "quick-link-menu__image-wrapper"
      }, [_c('ms-image', {
        attrs: {
          "alt": _vm.imageAlt,
          "src": _vm.imageUrl,
          "width": "179",
          "height": "92"
        }
      })], 1) : _vm._e(), _c('div', {
        staticClass: "quick-link-menu__content-wrapper"
      }, [_c('ms-paragraph', {
        staticClass: "quick-link-menu__title text-body-p1",
        attrs: {
          "content": _vm.title
        }
      })], 1)])], 1);
    };
    var MsQuickLinkMenuItemvue_type_template_id_7c397c79_staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/MsQuickLinkMenu/MsQuickLinkMenuItem.vue?vue&type=template&id=7c397c79&

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MsQuickLinkMenu/MsQuickLinkMenuItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuickLinkMenuItemvue_type_script_lang_js_ = {
      name: 'MsQuickLinkMenuItem',
      props: {
        /**
         * Sets image src path
         */
        imageUrl: {
          type: String,
          default: null
        },
        /**
         * Sets image alt
         */
        imageAlt: {
          type: String,
          default: null
        },
        /**
         * Sets title
        */
        title: {
          type: String,
          default: null
        },
        /**
         * Sets quickLink
        */
        quickLink: {
          type: String,
          default: null
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/MsQuickLinkMenu/MsQuickLinkMenuItem.vue?vue&type=script&lang=js&
    /* harmony default export */
    var MsQuickLinkMenu_MsQuickLinkMenuItemvue_type_script_lang_js_ = MsQuickLinkMenuItemvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./src/components/MsQuickLinkMenu/MsQuickLinkMenuItem.vue

    /* normalize component */

    var MsQuickLinkMenuItem_component = normalizeComponent(MsQuickLinkMenu_MsQuickLinkMenuItemvue_type_script_lang_js_, MsQuickLinkMenuItemvue_type_template_id_7c397c79_render, MsQuickLinkMenuItemvue_type_template_id_7c397c79_staticRenderFns, false, null, null, null);

    /* harmony default export */
    var MsQuickLinkMenuItem = MsQuickLinkMenuItem_component.exports;
    // CONCATENATED MODULE: ./src/components/MsQuickLinkMenu/index.js

    var MsQuickLinkMenu_components = {
      MsQuickLinkMenu: MsQuickLinkMenu,
      MsQuickLinkMenuItem: MsQuickLinkMenuItem
    };
    MsQuickLinkMenu.install = function (Vue) {
      Object.values(MsQuickLinkMenu_components).forEach(function (component) {
        Vue.component(component.name, component);
      });
    };
    /* harmony default export */
    var components_MsQuickLinkMenu = MsQuickLinkMenu;
    // CONCATENATED MODULE: ./src/components/index.js

    // EXTERNAL MODULE: ./node_modules/@moneysmart/cargo/dist/cargo.min.css
    var cargo_min = __webpack_require__("6790");

    // CONCATENATED MODULE: ./src/index.js
    // This is the entry point for running the building the prod bundle.
    // These will be included when you `npm run build`

    // Import Cargo CSS to build bundle of cargo-vue.
    // This will be output in `dist/cargo-vue.css`

    var CargoVue = {
      install: function install(Vue) {
        Object.values(components_namespaceObject).forEach(function (Component) {
          Vue.use(Component);
        });
        Vue.directive('ClickOutside', click_outside);
      }
    };
    /* harmony default export */
    var src_0 = CargoVue;

    // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js

    /* harmony default export */
    var entry_lib = __webpack_exports__["default"] = src_0;

    /***/
  },

  /***/"fba5": /***/function (module, exports, __webpack_require__) {
    var assocIndexOf = __webpack_require__("cb5a");

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module.exports = listCacheHas;

    /***/
  }

  /******/
});